(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48834)["lW"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 27484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 19132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,_){ true?module.exports=_(__webpack_require__(27484)):0}(this,(function(e){"use strict";function _(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=_(e),t={name:"ko",weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),ordinal:function(e){return e},formats:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},meridiem:function(e){return e<12?"오전":"오후"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"}};return d.default.locale(t,null,!0),t}));

/***/ }),

/***/ 10285:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return(e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1)}],a:[i,function(e){this.afternoon=u(e,!0)}],S:[/\d/,function(e){this.milliseconds=100*+e}],SS:[n,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else{var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={}}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""))}else i.call(this,e)}}}));

/***/ }),

/***/ 66607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 79212:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)}}}));

/***/ }),

/***/ 56176:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)}}}));

/***/ }),

/***/ 79593:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
  REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
  REACT_MEMO_TYPE = Symbol.for("react.memo"),
  REACT_LAZY_TYPE = Symbol.for("react.lazy"),
  REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"),
  REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
  if ("object" === typeof object && null !== object) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        switch (((object = object.type), object)) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return object;
          default:
            switch (((object = object && object.$$typeof), object)) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
                return object;
              case REACT_CONSUMER_TYPE:
                return object;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
}
__webpack_unused_export__ = REACT_CONSUMER_TYPE;
__webpack_unused_export__ = REACT_CONTEXT_TYPE;
__webpack_unused_export__ = REACT_ELEMENT_TYPE;
__webpack_unused_export__ = REACT_FORWARD_REF_TYPE;
__webpack_unused_export__ = REACT_FRAGMENT_TYPE;
__webpack_unused_export__ = REACT_LAZY_TYPE;
__webpack_unused_export__ = REACT_MEMO_TYPE;
__webpack_unused_export__ = REACT_PORTAL_TYPE;
__webpack_unused_export__ = REACT_PROFILER_TYPE;
__webpack_unused_export__ = REACT_STRICT_MODE_TYPE;
__webpack_unused_export__ = REACT_SUSPENSE_TYPE;
__webpack_unused_export__ = REACT_SUSPENSE_LIST_TYPE;
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_CONSUMER_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
};
__webpack_unused_export__ = function (object) {
  return (
    "object" === typeof object &&
    null !== object &&
    object.$$typeof === REACT_ELEMENT_TYPE
  );
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_LAZY_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_MEMO_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
};
__webpack_unused_export__ = function (object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.iY = function (type) {
  return "string" === typeof type ||
    "function" === typeof type ||
    type === REACT_FRAGMENT_TYPE ||
    type === REACT_PROFILER_TYPE ||
    type === REACT_STRICT_MODE_TYPE ||
    type === REACT_SUSPENSE_TYPE ||
    type === REACT_SUSPENSE_LIST_TYPE ||
    type === REACT_OFFSCREEN_TYPE ||
    ("object" === typeof type &&
      null !== type &&
      (type.$$typeof === REACT_LAZY_TYPE ||
        type.$$typeof === REACT_MEMO_TYPE ||
        type.$$typeof === REACT_CONTEXT_TYPE ||
        type.$$typeof === REACT_CONSUMER_TYPE ||
        type.$$typeof === REACT_FORWARD_REF_TYPE ||
        type.$$typeof === REACT_CLIENT_REFERENCE ||
        void 0 !== type.getModuleId))
    ? !0
    : !1;
};
exports.kM = typeOf;


/***/ }),

/***/ 89961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Fe; },
  "vJ": function() { return /* binding */ We; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ Ue; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/cjs/react-is.production.js
var react_is_production = __webpack_require__(79593);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34406);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is_production/* typeOf */.kM)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.5",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.5"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.5");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.5"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=(0,react.useContext)(Ge),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.5"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,isPropValid,_):!N||isPropValid(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is_production/* isValidElementType */.iY)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=(0,react.useContext)(Ge),l=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.5"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.5",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 4601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_1___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ Lh; },
/* harmony export */   "Av": function() { return /* binding */ gg; },
/* harmony export */   "Ee": function() { return /* binding */ Oh; },
/* harmony export */   "Ix": function() { return /* binding */ Ig; },
/* harmony export */   "Kx": function() { return /* binding */ Ah; },
/* harmony export */   "M1": function() { return /* binding */ Dh; },
/* harmony export */   "MG": function() { return /* binding */ Eh; },
/* harmony export */   "QI": function() { return /* binding */ Ch; },
/* harmony export */   "R1": function() { return /* binding */ Mg; },
/* harmony export */   "Rk": function() { return /* binding */ kh; },
/* harmony export */   "Vb": function() { return /* binding */ gl; },
/* harmony export */   "ZD": function() { return /* binding */ jh; },
/* harmony export */   "bZ": function() { return /* binding */ Dg; },
/* harmony export */   "h_": function() { return /* binding */ Rg; },
/* harmony export */   "oi": function() { return /* binding */ Ph; },
/* harmony export */   "pm": function() { return /* binding */ Qh; },
/* harmony export */   "zx": function() { return /* binding */ ht; }
/* harmony export */ });
/* unused harmony exports ActionSheetContext, ActionSheetItemLabel, ActionSheetTrigger, AreaContainer, Checkbox, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, HelpTextArea, InformationText, InputContainer, RadioButton, SNACKBAR_ANIMATION_DURATION, Snackbar, SnackbarAction, SnackbarContainer, SnackbarContentWrapper, SnackbarDescription, SnackbarTitle, SnackbarViewport, TOAST_ANIMATION_DURATION, Toast, ToastAction, ToastDescription, ToastProvider, ToastTitle, ToastViewport, buttonVariants, textButtonVariants, useActionSheet, useActionSheetContext, useSnackbar */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28316);





const ra = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null), oa = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ra);
  if (!e)
    throw new Error("ActionSheet 컴포넌트는 ActionSheet Provider 내부에서 사용되어야 합니다.");
  return e;
};
function aa(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = aa(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function ia() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = aa(e)) && (r && (r += " "), r += t);
  return r;
}
const Tr = "-", $c = (e) => {
  const t = Bc(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const i = s.split(Tr);
      return i[0] === "" && i.length !== 1 && i.shift(), sa(i, t) || Fc(s);
    },
    getConflictingClassGroupIds: (s, i) => {
      const u = n[s] || [];
      return i && r[s] ? [...u, ...r[s]] : u;
    }
  };
}, sa = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? sa(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Tr);
  return (s = t.validators.find(({
    validator: i
  }) => i(a))) == null ? void 0 : s.classGroupId;
}, po = /^\[(.+)\]$/, Fc = (e) => {
  if (po.test(e)) {
    const t = po.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Bc = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Vc(Object.entries(e.classGroups), n).forEach(([a, s]) => {
    tr(s, r, a, t);
  }), r;
}, tr = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : mo(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Wc(o)) {
        tr(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, s]) => {
      tr(s, mo(t, a), n, r);
    });
  });
}, mo = (e, t) => {
  let n = e;
  return t.split(Tr).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Wc = (e) => e.isThemeGetter, Vc = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([s, i]) => [t + s, i])) : a);
  return [n, o];
}) : e, Uc = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (a, s) => {
    n.set(a, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return o(a, s), s;
    },
    set(a, s) {
      n.has(a) ? n.set(a, s) : o(a, s);
    }
  };
}, ca = "!", zc = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], a = t.length, s = (i) => {
    const u = [];
    let l = 0, f = 0, d;
    for (let g = 0; g < i.length; g++) {
      let y = i[g];
      if (l === 0) {
        if (y === o && (r || i.slice(g, g + a) === t)) {
          u.push(i.slice(f, g)), f = g + a;
          continue;
        }
        if (y === "/") {
          d = g;
          continue;
        }
      }
      y === "[" ? l++ : y === "]" && l--;
    }
    const m = u.length === 0 ? i : i.substring(f), v = m.startsWith(ca), b = v ? m.substring(1) : m, h = d && d > f ? d - f : void 0;
    return {
      modifiers: u,
      hasImportantModifier: v,
      baseClassName: b,
      maybePostfixModifierPosition: h
    };
  };
  return n ? (i) => n({
    className: i,
    parseClassName: s
  }) : s;
}, Hc = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Kc = (e) => ({
  cache: Uc(e.cacheSize),
  parseClassName: zc(e),
  ...$c(e)
}), jc = /\s+/, Gc = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, a = [], s = e.trim().split(jc);
  let i = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const l = s[u], {
      modifiers: f,
      hasImportantModifier: d,
      baseClassName: m,
      maybePostfixModifierPosition: v
    } = n(l);
    let b = !!v, h = r(b ? m.substring(0, v) : m);
    if (!h) {
      if (!b) {
        i = l + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (h = r(m), !h) {
        i = l + (i.length > 0 ? " " + i : i);
        continue;
      }
      b = !1;
    }
    const g = Hc(f).join(":"), y = d ? g + ca : g, E = y + h;
    if (a.includes(E))
      continue;
    a.push(E);
    const x = o(h, b);
    for (let w = 0; w < x.length; ++w) {
      const S = x[w];
      a.push(y + S);
    }
    i = l + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function Yc() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = la(t)) && (r && (r += " "), r += n);
  return r;
}
const la = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = la(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Xc(e, ...t) {
  let n, r, o, a = s;
  function s(u) {
    const l = t.reduce((f, d) => d(f), e());
    return n = Kc(l), r = n.cache.get, o = n.cache.set, a = i, i(u);
  }
  function i(u) {
    const l = r(u);
    if (l)
      return l;
    const f = Gc(u, n);
    return o(u, f), f;
  }
  return function() {
    return a(Yc.apply(null, arguments));
  };
}
const Z = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, ua = /^\[(?:([a-z-]+):)?(.+)\]$/i, qc = /^\d+\/\d+$/, Zc = /* @__PURE__ */ new Set(["px", "full", "screen"]), Qc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Jc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, el = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, tl = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, nl = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, _e = (e) => ft(e) || Zc.has(e) || qc.test(e), Ue = (e) => vt(e, "length", ul), ft = (e) => !!e && !Number.isNaN(Number(e)), Dn = (e) => vt(e, "number", ft), Tt = (e) => !!e && Number.isInteger(Number(e)), rl = (e) => e.endsWith("%") && ft(e.slice(0, -1)), H = (e) => ua.test(e), ze = (e) => Qc.test(e), ol = /* @__PURE__ */ new Set(["length", "size", "percentage"]), al = (e) => vt(e, ol, da), il = (e) => vt(e, "position", da), sl = /* @__PURE__ */ new Set(["image", "url"]), cl = (e) => vt(e, sl, fl), ll = (e) => vt(e, "", dl), Nt = () => !0, vt = (e, t, n) => {
  const r = ua.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, ul = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Jc.test(e) && !el.test(e)
), da = () => !1, dl = (e) => tl.test(e), fl = (e) => nl.test(e), pl = () => {
  const e = Z("colors"), t = Z("spacing"), n = Z("blur"), r = Z("brightness"), o = Z("borderColor"), a = Z("borderRadius"), s = Z("borderSpacing"), i = Z("borderWidth"), u = Z("contrast"), l = Z("grayscale"), f = Z("hueRotate"), d = Z("invert"), m = Z("gap"), v = Z("gradientColorStops"), b = Z("gradientColorStopPositions"), h = Z("inset"), g = Z("margin"), y = Z("opacity"), E = Z("padding"), x = Z("saturate"), w = Z("scale"), S = Z("sepia"), R = Z("skew"), C = Z("space"), T = Z("translate"), M = () => ["auto", "contain", "none"], O = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", H, t], D = () => [H, t], A = () => ["", _e, Ue], P = () => ["auto", ft, H], B = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], k = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], _ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], I = () => ["", "0", H], K = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [ft, H];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Nt],
      spacing: [_e, Ue],
      blur: ["none", "", ze, H],
      brightness: G(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ze, H],
      borderSpacing: D(),
      borderWidth: A(),
      contrast: G(),
      grayscale: I(),
      hueRotate: G(),
      invert: I(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [rl, Ue],
      inset: $(),
      margin: $(),
      opacity: G(),
      padding: D(),
      saturate: G(),
      scale: G(),
      sepia: I(),
      skew: G(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", H]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ze]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": K()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": K()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...B(), H]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Tt, H]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", H]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Tt, H]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Nt]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Tt, H]
        }, H]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": P()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": P()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Nt]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Tt, H]
        }, H]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": P()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": P()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ..._()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ..._(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [..._(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [E]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [E]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [E]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [E]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [E]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [E]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [E]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [E]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [E]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [C]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [C]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", H, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [H, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [H, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [ze]
        }, ze]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [H, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [H, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ze, Ue]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Dn]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Nt]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", H]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ft, Dn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _e, H]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", H]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", H]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...k(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", _e, Ue]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _e, H]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", H]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", H]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...B(), il]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", al]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, cl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...k(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: k()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...k()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_e, H]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [_e, Ue]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: A()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [_e, Ue]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ze, ll]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Nt]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...V(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ze, H]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", H]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", H]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", H]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Tt, H]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", H]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", H]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", H]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [_e, Ue, Dn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, ml = /* @__PURE__ */ Xc(pl);
function F(...e) {
  return ml(ia(e));
}
const fa = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ children: e, className: t, disabled: n, onClick: r, ...o }, a) => {
    const { open: s, onOpenChange: i, contentId: u, triggerId: l } = oa(), f = (d) => {
      n || i(!s), r == null || r(d);
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "button",
      {
        ref: a,
        id: l,
        type: "button",
        disabled: n,
        "aria-expanded": s,
        "aria-controls": u,
        "aria-haspopup": "dialog",
        className: F(
          // 기본 버튼 스타일
          "inline-flex items-center justify-center rounded-lg px-4 py-2",
          "typography-ui-16m text-gray-900",
          "border border-gray-200 bg-white",
          "transition-colors duration-200",
          // 호버/포커스 상태
          "hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          // 비활성화 상태
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white",
          t
        ),
        onClick: f,
        ...o,
        children: e
      }
    );
  }
);
fa.displayName = "ActionSheetTrigger";
const hl = (e = {}) => {
  const { open: t, onOpenChange: n, defaultOpen: r = !1 } = e, o = t !== void 0, [a, s] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(r), i = o ? t : a, u = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (l) => {
      o || s(l), n == null || n(l);
    },
    [o, n]
  );
  return {
    open: i,
    onOpenChange: u,
    isControlled: o
  };
}, gl = ({ children: e, ...t }) => {
  const { open: n, onOpenChange: r } = hl(t), o = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    const i = Math.random().toString(36).substr(2, 9);
    return {
      contentId: `actionsheet-content-${i}`,
      triggerId: `actionsheet-trigger-${i}`
    };
  }, []), a = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(e).some(
    (i) => react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(i) && i.type === fa
  ), s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(
    () => ({
      open: n,
      onOpenChange: r,
      contentId: o.contentId,
      triggerId: a ? o.triggerId : void 0
    }),
    [n, r, o.contentId, o.triggerId, a]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ra.Provider, { value: s, children: e });
};
gl.displayName = "ActionSheet";
function ho(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function vl(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = ho(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : ho(e[o], null);
        }
      };
  };
}
var Nr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(n), a = o.find(wl);
  if (a) {
    const s = a.props.children, i = o.map((u) => u === a ? react__WEBPACK_IMPORTED_MODULE_1__.Children.count(s) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(nr, { ...r, ref: t, children: react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(s) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(s, void 0, i) : null });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(nr, { ...r, ref: t, children: n });
});
Nr.displayName = "Slot";
var nr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(n)) {
    const o = xl(n);
    return react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(n, {
      ...bl(r, n.props),
      // @ts-ignore
      ref: t ? vl(t, o) : o
    });
  }
  return react__WEBPACK_IMPORTED_MODULE_1__.Children.count(n) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : null;
});
nr.displayName = "SlotClone";
var yl = ({ children: e }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: e });
function wl(e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(e) && e.type === yl;
}
function bl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      a(...i), o(...i);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function go(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ot(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = go(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : go(e[o], null);
        }
      };
  };
}
function q(...e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(ot(...e), e);
}
function El(e, t) {
  const n = react__WEBPACK_IMPORTED_MODULE_1__.createContext(t), r = (a) => {
    const { children: s, ...i } = a, u = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(n.Provider, { value: u, children: s });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const s = react__WEBPACK_IMPORTED_MODULE_1__.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function $e(e, t = []) {
  let n = [];
  function r(a, s) {
    const i = react__WEBPACK_IMPORTED_MODULE_1__.createContext(s), u = n.length;
    n = [...n, s];
    const l = (d) => {
      var y;
      const { scope: m, children: v, ...b } = d, h = ((y = m == null ? void 0 : m[e]) == null ? void 0 : y[u]) || i, g = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(h.Provider, { value: g, children: v });
    };
    l.displayName = a + "Provider";
    function f(d, m) {
      var h;
      const v = ((h = m == null ? void 0 : m[e]) == null ? void 0 : h[u]) || i, b = react__WEBPACK_IMPORTED_MODULE_1__.useContext(v);
      if (b)
        return b;
      if (s !== void 0)
        return s;
      throw new Error(`\`${d}\` must be used within \`${a}\``);
    }
    return [l, f];
  }
  const o = () => {
    const a = n.map((s) => react__WEBPACK_IMPORTED_MODULE_1__.createContext(s));
    return function(i) {
      const u = (i == null ? void 0 : i[e]) || a;
      return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: u } }),
        [i, u]
      );
    };
  };
  return o.scopeName = e, [r, Cl(o, ...t)];
}
function Cl(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = r.reduce((i, { useScope: u, scopeName: l }) => {
        const d = u(a)[`__scope${l}`];
        return { ...i, ...d };
      }, {});
      return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function L(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var Ae = globalThis != null && globalThis.document ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : () => {
}, Sl = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_1___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_1___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_1__, 2)))[" useInsertionEffect ".trim().toString()] || Ae;
function yt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, s] = Rl({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, u = i ? e : o;
  {
    const f = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e !== void 0);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const d = f.current;
      d !== i && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = i;
    }, [i, r]);
  }
  const l = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (f) => {
      var d;
      if (i) {
        const m = Tl(f) ? f(e) : f;
        m !== e && ((d = s.current) == null || d.call(s, m));
      } else
        a(f);
    },
    [i, e, a, s]
  );
  return [u, l];
}
function Rl({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = react__WEBPACK_IMPORTED_MODULE_1__.useState(e), o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(n), a = react__WEBPACK_IMPORTED_MODULE_1__.useRef(t);
  return Sl(() => {
    a.current = t;
  }, [t]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    var s;
    o.current !== n && ((s = a.current) == null || s.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function Tl(e) {
  return typeof e == "function";
}
function Nl(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.useRef({ value: e, previous: e });
  return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function pa(e) {
  const [t, n] = react__WEBPACK_IMPORTED_MODULE_1__.useState(void 0);
  return Ae(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const u = a.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          s = l.inlineSize, i = l.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function Al(e, t) {
  return react__WEBPACK_IMPORTED_MODULE_1__.useReducer((n, r) => t[n][r] ?? n, e);
}
var Me = (e) => {
  const { present: t, children: n } = e, r = Pl(t), o = typeof n == "function" ? n({ present: r.isPresent }) : react__WEBPACK_IMPORTED_MODULE_1__.Children.only(n), a = q(r.ref, Ml(o));
  return typeof n == "function" || r.isPresent ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(o, { ref: a }) : null;
};
Me.displayName = "Presence";
function Pl(e) {
  const [t, n] = react__WEBPACK_IMPORTED_MODULE_1__.useState(), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e), a = react__WEBPACK_IMPORTED_MODULE_1__.useRef("none"), s = e ? "mounted" : "unmounted", [i, u] = Al(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const l = Jt(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), Ae(() => {
    const l = r.current, f = o.current;
    if (f !== e) {
      const m = a.current, v = Jt(l);
      e ? u("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(f && m !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Ae(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, d = (v) => {
        const h = Jt(r.current).includes(v.animationName);
        if (v.target === t && h && (u("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, m = (v) => {
        v.target === t && (a.current = Jt(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: react__WEBPACK_IMPORTED_MODULE_1__.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Jt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Ml(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function Dl(e) {
  const t = /* @__PURE__ */ Il(e), n = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(a), u = i.find(_l);
    if (u) {
      const l = u.props.children, f = i.map((d) => d === u ? react__WEBPACK_IMPORTED_MODULE_1__.Children.count(l) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Il(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(o)) {
      const s = Ll(o), i = kl(a, o.props);
      return o.type !== react__WEBPACK_IMPORTED_MODULE_1__.Fragment && (i.ref = r ? ot(r, s) : s), react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(o, i);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.count(o) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ol = Symbol("radix.slottable");
function _l(e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ol;
}
function kl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      a(...i), o(...i);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ll(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $l = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], oe = $l.reduce((e, t) => {
  const n = /* @__PURE__ */ Dl(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function ma(e, t) {
  e && react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(() => e.dispatchEvent(t));
}
var xn = "Checkbox", [Fl, bg] = $e(xn), [Bl, Wl] = Fl(xn), ha = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: s,
      disabled: i,
      value: u = "on",
      onCheckedChange: l,
      form: f,
      ...d
    } = e, [m, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), b = q(t, (w) => v(w)), h = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), g = m ? f || !!m.closest("form") : !0, [y, E] = yt({
      prop: o,
      defaultProp: a ?? !1,
      onChange: l,
      caller: xn
    }), x = react__WEBPACK_IMPORTED_MODULE_1__.useRef(y);
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const w = m == null ? void 0 : m.form;
      if (w) {
        const S = () => E(x.current);
        return w.addEventListener("reset", S), () => w.removeEventListener("reset", S);
      }
    }, [m, E]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Bl, { scope: n, state: y, disabled: i, children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        oe.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": je(y) ? "mixed" : y,
          "aria-required": s,
          "data-state": wa(y),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: u,
          ...d,
          ref: b,
          onKeyDown: L(e.onKeyDown, (w) => {
            w.key === "Enter" && w.preventDefault();
          }),
          onClick: L(e.onClick, (w) => {
            E((S) => je(S) ? !0 : !S), g && (h.current = w.isPropagationStopped(), h.current || w.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        ya,
        {
          control: m,
          bubbles: !h.current,
          name: r,
          value: u,
          checked: y,
          required: s,
          disabled: i,
          form: f,
          style: { transform: "translateX(-100%)" },
          defaultChecked: je(a) ? !1 : a
        }
      )
    ] });
  }
);
ha.displayName = xn;
var ga = "CheckboxIndicator", va = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = Wl(ga, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: r || je(a.state) || a.state === !0, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      oe.span,
      {
        "data-state": wa(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
va.displayName = ga;
var Vl = "CheckboxBubbleInput", ya = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({
    __scopeCheckbox: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    defaultChecked: o,
    ...a
  }, s) => {
    const i = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), u = q(i, s), l = Nl(n), f = pa(t);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const m = i.current;
      if (!m)
        return;
      const v = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        v,
        "checked"
      ).set;
      if (l !== n && h) {
        const g = new Event("click", { bubbles: r });
        m.indeterminate = je(n), h.call(m, je(n) ? !1 : n), m.dispatchEvent(g);
      }
    }, [l, n, r]);
    const d = react__WEBPACK_IMPORTED_MODULE_1__.useRef(je(n) ? !1 : n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      oe.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? d.current,
        ...a,
        tabIndex: -1,
        ref: u,
        style: {
          ...a.style,
          ...f,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
ya.displayName = Vl;
function je(e) {
  return e === "indeterminate";
}
function wa(e) {
  return je(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var Ul = ha, zl = va;
// @__NO_SIDE_EFFECTS__
function vo(e) {
  const t = /* @__PURE__ */ Hl(e), n = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(a), u = i.find(jl);
    if (u) {
      const l = u.props.children, f = i.map((d) => d === u ? react__WEBPACK_IMPORTED_MODULE_1__.Children.count(l) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Hl(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(o)) {
      const s = Yl(o), i = Gl(a, o.props);
      return o.type !== react__WEBPACK_IMPORTED_MODULE_1__.Fragment && (i.ref = r ? ot(r, s) : s), react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(o, i);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.count(o) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Kl = Symbol("radix.slottable");
function jl(e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Kl;
}
function Gl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      a(...i), o(...i);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Yl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ba(e) {
  const t = e + "CollectionProvider", [n, r] = $e(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: y } = h, E = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), x = react__WEBPACK_IMPORTED_MODULE_1__.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { scope: g, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", u = /* @__PURE__ */ vo(i), l = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
    (h, g) => {
      const { scope: y, children: E } = h, x = a(i, y), w = q(g, x.collectionRef);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ref: w, children: E });
    }
  );
  l.displayName = i;
  const f = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ vo(f), v = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
    (h, g) => {
      const { scope: y, children: E, ...x } = h, w = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), S = q(g, w), R = a(f, y);
      return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (R.itemMap.set(w, { ref: w, ...x }), () => void R.itemMap.delete(w))), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(m, { [d]: "", ref: S, children: E });
    }
  );
  v.displayName = f;
  function b(h) {
    const g = a(e + "CollectionConsumer", h);
    return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
      const E = g.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (R, C) => x.indexOf(R.ref.current) - x.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    b,
    r
  ];
}
var Xl = react__WEBPACK_IMPORTED_MODULE_1__.createContext(void 0);
function xa(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Xl);
  return e || t || "ltr";
}
function ne(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    t.current = e;
  }), react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Ea(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var ql = "DismissableLayer", rr = "dismissableLayer.update", Zl = "dismissableLayer.pointerDownOutside", Ql = "dismissableLayer.focusOutside", yo, Ca = react__WEBPACK_IMPORTED_MODULE_1__.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Sa = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...u
    } = e, l = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Ca), [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), m = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState({}), b = q(t, (C) => d(C)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(g), E = f ? h.indexOf(f) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, w = E >= y, S = tu((C) => {
      const T = C.target, M = [...l.branches].some((O) => O.contains(T));
      !w || M || (o == null || o(C), s == null || s(C), C.defaultPrevented || i == null || i());
    }, m), R = nu((C) => {
      const T = C.target;
      [...l.branches].some((O) => O.contains(T)) || (a == null || a(C), s == null || s(C), C.defaultPrevented || i == null || i());
    }, m);
    return Ea((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, m), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      if (f)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (yo = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), wo(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = yo);
        };
    }, [f, m, n, l]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), wo());
    }, [f, l]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(rr, C), () => document.removeEventListener(rr, C);
    }, []), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      oe.div,
      {
        ...u,
        ref: b,
        style: {
          pointerEvents: x ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: L(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: L(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: L(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Sa.displayName = ql;
var Jl = "DismissableLayerBranch", eu = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const n = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Ca), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), o = q(t, r);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { ...e, ref: o });
});
eu.displayName = Jl;
function tu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(() => {
  });
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let u = function() {
          Ra(
            Zl,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function nu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Ra(Ql, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function wo() {
  const e = new CustomEvent(rr);
  document.dispatchEvent(e);
}
function Ra(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? ma(o, a) : o.dispatchEvent(a);
}
var In = 0;
function Ta() {
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? bo()), document.body.insertAdjacentElement("beforeend", e[1] ?? bo()), In++, () => {
      In === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), In--;
    };
  }, []);
}
function bo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var On = "focusScope.autoFocusOnMount", _n = "focusScope.autoFocusOnUnmount", xo = { bubbles: !1, cancelable: !0 }, ru = "FocusScope", Na = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, u] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), l = ne(o), f = ne(a), d = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), m = q(t, (h) => u(h)), v = react__WEBPACK_IMPORTED_MODULE_1__.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (v.paused || !i)
          return;
        const w = x.target;
        i.contains(w) ? d.current = w : He(d.current, { select: !0 });
      }, g = function(x) {
        if (v.paused || !i)
          return;
        const w = x.relatedTarget;
        w !== null && (i.contains(w) || He(d.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && He(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const E = new MutationObserver(y);
      return i && E.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), E.disconnect();
      };
    }
  }, [r, i, v.paused]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (i) {
      Co.add(v);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const y = new CustomEvent(On, xo);
        i.addEventListener(On, l), i.dispatchEvent(y), y.defaultPrevented || (ou(lu(Aa(i)), { select: !0 }), document.activeElement === h && He(i));
      }
      return () => {
        i.removeEventListener(On, l), setTimeout(() => {
          const y = new CustomEvent(_n, xo);
          i.addEventListener(_n, f), i.dispatchEvent(y), y.defaultPrevented || He(h ?? document.body, { select: !0 }), i.removeEventListener(_n, f), Co.remove(v);
        }, 0);
      };
    }
  }, [i, l, f, v]);
  const b = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (h) => {
      if (!n && !r || v.paused)
        return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (g && y) {
        const E = h.currentTarget, [x, w] = au(E);
        x && w ? !h.shiftKey && y === w ? (h.preventDefault(), n && He(x, { select: !0 })) : h.shiftKey && y === x && (h.preventDefault(), n && He(w, { select: !0 })) : y === E && h.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { tabIndex: -1, ...s, ref: m, onKeyDown: b });
});
Na.displayName = ru;
function ou(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (He(r, { select: t }), document.activeElement !== n)
      return;
}
function au(e) {
  const t = Aa(e), n = Eo(t, e), r = Eo(t.reverse(), e);
  return [n, r];
}
function Aa(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Eo(e, t) {
  for (const n of e)
    if (!iu(n, { upTo: t }))
      return n;
}
function iu(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function su(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function He(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && su(e) && t && e.select();
  }
}
var Co = cu();
function cu() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = So(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = So(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function So(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function lu(e) {
  return e.filter((t) => t.tagName !== "A");
}
var uu = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_1___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_1___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_1__, 2)))[" useId ".trim().toString()] || (() => {
}), du = 0;
function Ge(e) {
  const [t, n] = react__WEBPACK_IMPORTED_MODULE_1__.useState(uu());
  return Ae(() => {
    e || n((r) => r ?? String(du++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const fu = ["top", "right", "bottom", "left"], Ye = Math.min, pe = Math.max, fn = Math.round, en = Math.floor, Ne = (e) => ({
  x: e,
  y: e
}), pu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, mu = {
  start: "end",
  end: "start"
};
function or(e, t, n) {
  return pe(e, Ye(t, n));
}
function ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Le(e) {
  return e.split("-")[0];
}
function wt(e) {
  return e.split("-")[1];
}
function Ar(e) {
  return e === "x" ? "y" : "x";
}
function Pr(e) {
  return e === "y" ? "height" : "width";
}
function Xe(e) {
  return ["top", "bottom"].includes(Le(e)) ? "y" : "x";
}
function Mr(e) {
  return Ar(Xe(e));
}
function hu(e, t, n) {
  n === void 0 && (n = !1);
  const r = wt(e), o = Mr(e), a = Pr(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = pn(s)), [s, pn(s)];
}
function gu(e) {
  const t = pn(e);
  return [ar(e), t, ar(t)];
}
function ar(e) {
  return e.replace(/start|end/g, (t) => mu[t]);
}
function vu(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : s;
    default:
      return [];
  }
}
function yu(e, t, n, r) {
  const o = wt(e);
  let a = vu(Le(e), n === "start", r);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map(ar)))), a;
}
function pn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => pu[t]);
}
function wu(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Pa(e) {
  return typeof e != "number" ? wu(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function mn(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Ro(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Xe(t), s = Mr(t), i = Pr(s), u = Le(t), l = a === "y", f = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, m = r[i] / 2 - o[i] / 2;
  let v;
  switch (u) {
    case "top":
      v = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      v = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (wt(t)) {
    case "start":
      v[s] -= m * (n && l ? -1 : 1);
      break;
    case "end":
      v[s] += m * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const bu = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = a.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: d
  } = Ro(l, r, u), m = r, v = {}, b = 0;
  for (let h = 0; h < i.length; h++) {
    const {
      name: g,
      fn: y
    } = i[h], {
      x: E,
      y: x,
      data: w,
      reset: S
    } = await y({
      x: f,
      y: d,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: v,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = E ?? f, d = x ?? d, v = {
      ...v,
      [g]: {
        ...v[g],
        ...w
      }
    }, S && b <= 50 && (b++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (l = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: f,
      y: d
    } = Ro(l, m, u)), h = -1);
  }
  return {
    x: f,
    y: d,
    placement: m,
    strategy: o,
    middlewareData: v
  };
};
async function Lt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: s,
    elements: i,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: m = !1,
    padding: v = 0
  } = ke(t, e), b = Pa(v), g = i[m ? d === "floating" ? "reference" : "floating" : d], y = mn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: u
  })), E = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), w = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = mn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: E,
    offsetParent: x,
    strategy: u
  }) : E);
  return {
    top: (y.top - S.top + b.top) / w.y,
    bottom: (S.bottom - y.bottom + b.bottom) / w.y,
    left: (y.left - S.left + b.left) / w.x,
    right: (S.right - y.right + b.right) / w.x
  };
}
const xu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: u
    } = t, {
      element: l,
      padding: f = 0
    } = ke(e, t) || {};
    if (l == null)
      return {};
    const d = Pa(f), m = {
      x: n,
      y: r
    }, v = Mr(o), b = Pr(v), h = await s.getDimensions(l), g = v === "y", y = g ? "top" : "left", E = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", w = a.reference[b] + a.reference[v] - m[v] - a.floating[b], S = m[v] - a.reference[v], R = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let C = R ? R[x] : 0;
    (!C || !await (s.isElement == null ? void 0 : s.isElement(R))) && (C = i.floating[x] || a.floating[b]);
    const T = w / 2 - S / 2, M = C / 2 - h[b] / 2 - 1, O = Ye(d[y], M), $ = Ye(d[E], M), D = O, A = C - h[b] - $, P = C / 2 - h[b] / 2 + T, B = or(D, P, A), k = !u.arrow && wt(o) != null && P !== B && a.reference[b] / 2 - (P < D ? O : $) - h[b] / 2 < 0, V = k ? P < D ? P - D : P - A : 0;
    return {
      [v]: m[v] + V,
      data: {
        [v]: B,
        centerOffset: P - B - V,
        ...k && {
          alignmentOffset: V
        }
      },
      reset: k
    };
  }
}), Eu = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: u,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: m,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: h = !0,
        ...g
      } = ke(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = Le(o), E = Xe(i), x = Le(i) === i, w = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), S = m || (x || !h ? [pn(i)] : gu(i)), R = b !== "none";
      !m && R && S.push(...yu(i, h, b, w));
      const C = [i, ...S], T = await Lt(t, g), M = [];
      let O = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (f && M.push(T[y]), d) {
        const P = hu(o, s, w);
        M.push(T[P[0]], T[P[1]]);
      }
      if (O = [...O, {
        placement: o,
        overflows: M
      }], !M.every((P) => P <= 0)) {
        var $, D;
        const P = ((($ = a.flip) == null ? void 0 : $.index) || 0) + 1, B = C[P];
        if (B)
          return {
            data: {
              index: P,
              overflows: O
            },
            reset: {
              placement: B
            }
          };
        let k = (D = O.filter((V) => V.overflows[0] <= 0).sort((V, _) => V.overflows[1] - _.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!k)
          switch (v) {
            case "bestFit": {
              var A;
              const V = (A = O.filter((_) => {
                if (R) {
                  const I = Xe(_.placement);
                  return I === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  I === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((I) => I > 0).reduce((I, K) => I + K, 0)]).sort((_, I) => _[1] - I[1])[0]) == null ? void 0 : A[0];
              V && (k = V);
              break;
            }
            case "initialPlacement":
              k = i;
              break;
          }
        if (o !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
function To(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function No(e) {
  return fu.some((t) => e[t] >= 0);
}
const Cu = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ke(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Lt(t, {
            ...o,
            elementContext: "reference"
          }), s = To(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: No(s)
            }
          };
        }
        case "escaped": {
          const a = await Lt(t, {
            ...o,
            altBoundary: !0
          }), s = To(a, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: No(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Su(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Le(n), i = wt(n), u = Xe(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, f = a && u ? -1 : 1, d = ke(t, e);
  let {
    mainAxis: m,
    crossAxis: v,
    alignmentAxis: b
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return i && typeof b == "number" && (v = i === "end" ? b * -1 : b), u ? {
    x: v * f,
    y: m * l
  } : {
    x: m * l,
    y: v * f
  };
}
const Ru = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: s,
        middlewareData: i
      } = t, u = await Su(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: a + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Tu = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: s = !1,
        limiter: i = {
          fn: (g) => {
            let {
              x: y,
              y: E
            } = g;
            return {
              x: y,
              y: E
            };
          }
        },
        ...u
      } = ke(e, t), l = {
        x: n,
        y: r
      }, f = await Lt(t, u), d = Xe(Le(o)), m = Ar(d);
      let v = l[m], b = l[d];
      if (a) {
        const g = m === "y" ? "top" : "left", y = m === "y" ? "bottom" : "right", E = v + f[g], x = v - f[y];
        v = or(E, v, x);
      }
      if (s) {
        const g = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", E = b + f[g], x = b - f[y];
        b = or(E, b, x);
      }
      const h = i.fn({
        ...t,
        [m]: v,
        [d]: b
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [m]: a,
            [d]: s
          }
        }
      };
    }
  };
}, Nu = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = ke(e, t), f = {
        x: n,
        y: r
      }, d = Xe(o), m = Ar(d);
      let v = f[m], b = f[d];
      const h = ke(i, t), g = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (u) {
        const x = m === "y" ? "height" : "width", w = a.reference[m] - a.floating[x] + g.mainAxis, S = a.reference[m] + a.reference[x] - g.mainAxis;
        v < w ? v = w : v > S && (v = S);
      }
      if (l) {
        var y, E;
        const x = m === "y" ? "width" : "height", w = ["top", "left"].includes(Le(o)), S = a.reference[d] - a.floating[x] + (w && ((y = s.offset) == null ? void 0 : y[d]) || 0) + (w ? 0 : g.crossAxis), R = a.reference[d] + a.reference[x] + (w ? 0 : ((E = s.offset) == null ? void 0 : E[d]) || 0) - (w ? g.crossAxis : 0);
        b < S ? b = S : b > R && (b = R);
      }
      return {
        [m]: v,
        [d]: b
      };
    }
  };
}, Au = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: s,
        elements: i
      } = t, {
        apply: u = () => {
        },
        ...l
      } = ke(e, t), f = await Lt(t, l), d = Le(o), m = wt(o), v = Xe(o) === "y", {
        width: b,
        height: h
      } = a.floating;
      let g, y;
      d === "top" || d === "bottom" ? (g = d, y = m === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (y = d, g = m === "end" ? "top" : "bottom");
      const E = h - f.top - f.bottom, x = b - f.left - f.right, w = Ye(h - f[g], E), S = Ye(b - f[y], x), R = !t.middlewareData.shift;
      let C = w, T = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (T = x), (r = t.middlewareData.shift) != null && r.enabled.y && (C = E), R && !m) {
        const O = pe(f.left, 0), $ = pe(f.right, 0), D = pe(f.top, 0), A = pe(f.bottom, 0);
        v ? T = b - 2 * (O !== 0 || $ !== 0 ? O + $ : pe(f.left, f.right)) : C = h - 2 * (D !== 0 || A !== 0 ? D + A : pe(f.top, f.bottom));
      }
      await u({
        ...t,
        availableWidth: T,
        availableHeight: C
      });
      const M = await s.getDimensions(i.floating);
      return b !== M.width || h !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function En() {
  return typeof window < "u";
}
function bt(e) {
  return Ma(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function De(e) {
  var t;
  return (t = (Ma(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ma(e) {
  return En() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function be(e) {
  return En() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function Pe(e) {
  return En() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function Ao(e) {
  return !En() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function Vt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Pu(e) {
  return ["table", "td", "th"].includes(bt(e));
}
function Cn(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Dr(e) {
  const t = Ir(), n = be(e) ? xe(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Mu(e) {
  let t = qe(e);
  for (; Pe(t) && !gt(t); ) {
    if (Dr(t))
      return t;
    if (Cn(t))
      return null;
    t = qe(t);
  }
  return null;
}
function Ir() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function gt(e) {
  return ["html", "body", "#document"].includes(bt(e));
}
function xe(e) {
  return me(e).getComputedStyle(e);
}
function Sn(e) {
  return be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function qe(e) {
  if (bt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ao(e) && e.host || // Fallback.
    De(e)
  );
  return Ao(t) ? t.host : t;
}
function Da(e) {
  const t = qe(e);
  return gt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Pe(t) && Vt(t) ? t : Da(t);
}
function $t(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Da(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = me(o);
  if (a) {
    const i = ir(s);
    return t.concat(s, s.visualViewport || [], Vt(o) ? o : [], i && n ? $t(i) : []);
  }
  return t.concat(o, $t(o, [], n));
}
function ir(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ia(e) {
  const t = xe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Pe(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, i = fn(n) !== a || fn(r) !== s;
  return i && (n = a, r = s), {
    width: n,
    height: r,
    $: i
  };
}
function Or(e) {
  return be(e) ? e : e.contextElement;
}
function pt(e) {
  const t = Or(e);
  if (!Pe(t))
    return Ne(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = Ia(t);
  let s = (a ? fn(n.width) : n.width) / r, i = (a ? fn(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const Du = /* @__PURE__ */ Ne(0);
function Oa(e) {
  const t = me(e);
  return !Ir() || !t.visualViewport ? Du : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Iu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function nt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Or(e);
  let s = Ne(1);
  t && (r ? be(r) && (s = pt(r)) : s = pt(e));
  const i = Iu(a, n, r) ? Oa(a) : Ne(0);
  let u = (o.left + i.x) / s.x, l = (o.top + i.y) / s.y, f = o.width / s.x, d = o.height / s.y;
  if (a) {
    const m = me(a), v = r && be(r) ? me(r) : r;
    let b = m, h = ir(b);
    for (; h && r && v !== b; ) {
      const g = pt(h), y = h.getBoundingClientRect(), E = xe(h), x = y.left + (h.clientLeft + parseFloat(E.paddingLeft)) * g.x, w = y.top + (h.clientTop + parseFloat(E.paddingTop)) * g.y;
      u *= g.x, l *= g.y, f *= g.x, d *= g.y, u += x, l += w, b = me(h), h = ir(b);
    }
  }
  return mn({
    width: f,
    height: d,
    x: u,
    y: l
  });
}
function _r(e, t) {
  const n = Sn(e).scrollLeft;
  return t ? t.left + n : nt(De(e)).left + n;
}
function _a(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    _r(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function Ou(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", s = De(r), i = t ? Cn(t.floating) : !1;
  if (r === s || i && a)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ne(1);
  const f = Ne(0), d = Pe(r);
  if ((d || !d && !a) && ((bt(r) !== "body" || Vt(s)) && (u = Sn(r)), Pe(r))) {
    const v = nt(r);
    l = pt(r), f.x = v.x + r.clientLeft, f.y = v.y + r.clientTop;
  }
  const m = s && !d && !a ? _a(s, u, !0) : Ne(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + f.x + m.x,
    y: n.y * l.y - u.scrollTop * l.y + f.y + m.y
  };
}
function _u(e) {
  return Array.from(e.getClientRects());
}
function ku(e) {
  const t = De(e), n = Sn(e), r = e.ownerDocument.body, o = pe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = pe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + _r(e);
  const i = -n.scrollTop;
  return xe(r).direction === "rtl" && (s += pe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: i
  };
}
function Lu(e, t) {
  const n = me(e), r = De(e), o = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, i = 0, u = 0;
  if (o) {
    a = o.width, s = o.height;
    const l = Ir();
    (!l || l && t === "fixed") && (i = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: i,
    y: u
  };
}
function $u(e, t) {
  const n = nt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = Pe(e) ? pt(e) : Ne(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, u = o * a.x, l = r * a.y;
  return {
    width: s,
    height: i,
    x: u,
    y: l
  };
}
function Po(e, t, n) {
  let r;
  if (t === "viewport")
    r = Lu(e, n);
  else if (t === "document")
    r = ku(De(e));
  else if (be(t))
    r = $u(t, n);
  else {
    const o = Oa(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return mn(r);
}
function ka(e, t) {
  const n = qe(e);
  return n === t || !be(n) || gt(n) ? !1 : xe(n).position === "fixed" || ka(n, t);
}
function Fu(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = $t(e, [], !1).filter((i) => be(i) && bt(i) !== "body"), o = null;
  const a = xe(e).position === "fixed";
  let s = a ? qe(e) : e;
  for (; be(s) && !gt(s); ) {
    const i = xe(s), u = Dr(s);
    !u && i.position === "fixed" && (o = null), (a ? !u && !o : !u && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Vt(s) && !u && ka(e, s)) ? r = r.filter((f) => f !== s) : o = i, s = qe(s);
  }
  return t.set(e, r), r;
}
function Bu(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Cn(t) ? [] : Fu(t, this._c) : [].concat(n), r], i = s[0], u = s.reduce((l, f) => {
    const d = Po(t, f, o);
    return l.top = pe(d.top, l.top), l.right = Ye(d.right, l.right), l.bottom = Ye(d.bottom, l.bottom), l.left = pe(d.left, l.left), l;
  }, Po(t, i, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Wu(e) {
  const {
    width: t,
    height: n
  } = Ia(e);
  return {
    width: t,
    height: n
  };
}
function Vu(e, t, n) {
  const r = Pe(t), o = De(t), a = n === "fixed", s = nt(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = Ne(0);
  if (r || !r && !a)
    if ((bt(t) !== "body" || Vt(o)) && (i = Sn(t)), r) {
      const m = nt(t, !0, a, t);
      u.x = m.x + t.clientLeft, u.y = m.y + t.clientTop;
    } else
      o && (u.x = _r(o));
  const l = o && !r && !a ? _a(o, i) : Ne(0), f = s.left + i.scrollLeft - u.x - l.x, d = s.top + i.scrollTop - u.y - l.y;
  return {
    x: f,
    y: d,
    width: s.width,
    height: s.height
  };
}
function kn(e) {
  return xe(e).position === "static";
}
function Mo(e, t) {
  if (!Pe(e) || xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return De(e) === n && (n = n.ownerDocument.body), n;
}
function La(e, t) {
  const n = me(e);
  if (Cn(e))
    return n;
  if (!Pe(e)) {
    let o = qe(e);
    for (; o && !gt(o); ) {
      if (be(o) && !kn(o))
        return o;
      o = qe(o);
    }
    return n;
  }
  let r = Mo(e, t);
  for (; r && Pu(r) && kn(r); )
    r = Mo(r, t);
  return r && gt(r) && kn(r) && !Dr(r) ? n : r || Mu(e) || n;
}
const Uu = async function(e) {
  const t = this.getOffsetParent || La, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Vu(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function zu(e) {
  return xe(e).direction === "rtl";
}
const Hu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ou,
  getDocumentElement: De,
  getClippingRect: Bu,
  getOffsetParent: La,
  getElementRects: Uu,
  getClientRects: _u,
  getDimensions: Wu,
  getScale: pt,
  isElement: be,
  isRTL: zu
};
function $a(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ku(e, t) {
  let n = null, r;
  const o = De(e);
  function a() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, u) {
    i === void 0 && (i = !1), u === void 0 && (u = 1), a();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: d,
      width: m,
      height: v
    } = l;
    if (i || t(), !m || !v)
      return;
    const b = en(d), h = en(o.clientWidth - (f + m)), g = en(o.clientHeight - (d + v)), y = en(f), x = {
      rootMargin: -b + "px " + -h + "px " + -g + "px " + -y + "px",
      threshold: pe(0, Ye(1, u)) || 1
    };
    let w = !0;
    function S(R) {
      const C = R[0].intersectionRatio;
      if (C !== u) {
        if (!w)
          return s();
        C ? s(!1, C) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !$a(l, e.getBoundingClientRect()) && s(), w = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function ju(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Or(e), f = o || a ? [...l ? $t(l) : [], ...$t(t)] : [];
  f.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const d = l && i ? Ku(l, n) : null;
  let m = -1, v = null;
  s && (v = new ResizeObserver((y) => {
    let [E] = y;
    E && E.target === l && v && (v.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), n();
  }), l && !u && v.observe(l), v.observe(t));
  let b, h = u ? nt(e) : null;
  u && g();
  function g() {
    const y = nt(e);
    h && !$a(h, y) && n(), h = y, b = requestAnimationFrame(g);
  }
  return n(), () => {
    var y;
    f.forEach((E) => {
      o && E.removeEventListener("scroll", n), a && E.removeEventListener("resize", n);
    }), d == null || d(), (y = v) == null || y.disconnect(), v = null, u && cancelAnimationFrame(b);
  };
}
const Gu = Ru, Yu = Tu, Xu = Eu, qu = Au, Zu = Cu, Do = xu, Qu = Nu, Ju = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Hu,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return bu(e, t, {
    ...o,
    platform: a
  });
};
var ln = typeof document < "u" ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_1__.useEffect;
function hn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!hn(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !hn(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Fa(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Io(e, t) {
  const n = Fa(e);
  return Math.round(t * n) / n;
}
function Ln(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e);
  return ln(() => {
    t.current = e;
  }), t;
}
function ed(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: u,
    open: l
  } = e, [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState(r);
  hn(m, r) || v(r);
  const [b, h] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), [g, y] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), E = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((_) => {
    _ !== R.current && (R.current = _, h(_));
  }, []), x = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((_) => {
    _ !== C.current && (C.current = _, y(_));
  }, []), w = a || b, S = s || g, R = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), C = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), T = react__WEBPACK_IMPORTED_MODULE_1__.useRef(f), M = u != null, O = Ln(u), $ = Ln(o), D = Ln(l), A = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
    if (!R.current || !C.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: m
    };
    $.current && (_.platform = $.current), Ju(R.current, C.current, _).then((I) => {
      const K = {
        ...I,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      P.current && !hn(T.current, K) && (T.current = K, react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(() => {
        d(K);
      }));
    });
  }, [m, t, n, $, D]);
  ln(() => {
    l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [l]);
  const P = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
  ln(() => (P.current = !0, () => {
    P.current = !1;
  }), []), ln(() => {
    if (w && (R.current = w), S && (C.current = S), w && S) {
      if (O.current)
        return O.current(w, S, A);
      A();
    }
  }, [w, S, A, O, M]);
  const B = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
    reference: R,
    floating: C,
    setReference: E,
    setFloating: x
  }), [E, x]), k = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
    reference: w,
    floating: S
  }), [w, S]), V = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!k.floating)
      return _;
    const I = Io(k.floating, f.x), K = Io(k.floating, f.y);
    return i ? {
      ..._,
      transform: "translate(" + I + "px, " + K + "px)",
      ...Fa(k.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: K
    };
  }, [n, i, k.floating, f.x, f.y]);
  return react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
    ...f,
    update: A,
    refs: B,
    elements: k,
    floatingStyles: V
  }), [f, A, B, k, V]);
}
const td = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Do({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Do({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, nd = (e, t) => ({
  ...Gu(e),
  options: [e, t]
}), rd = (e, t) => ({
  ...Yu(e),
  options: [e, t]
}), od = (e, t) => ({
  ...Qu(e),
  options: [e, t]
}), ad = (e, t) => ({
  ...Xu(e),
  options: [e, t]
}), id = (e, t) => ({
  ...qu(e),
  options: [e, t]
}), sd = (e, t) => ({
  ...Zu(e),
  options: [e, t]
}), cd = (e, t) => ({
  ...td(e),
  options: [e, t]
});
var ld = "Arrow", Ba = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    oe.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Ba.displayName = ld;
var ud = Ba, kr = "Popper", [Wa, Va] = $e(kr), [dd, Ua] = Wa(kr), za = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(dd, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
za.displayName = kr;
var Ha = "PopperAnchor", Ka = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = Ua(Ha, n), s = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), i = q(t, s);
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { ...o, ref: i });
  }
);
Ka.displayName = Ha;
var Lr = "PopperContent", [fd, pd] = Wa(Lr), ja = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    var le, ve, se, Ie, Oe, Et;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: u = !0,
      collisionBoundary: l = [],
      collisionPadding: f = 0,
      sticky: d = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: b,
      ...h
    } = e, g = Ua(Lr, n), [y, E] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), x = q(t, (Be) => E(Be)), [w, S] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), R = pa(w), C = (R == null ? void 0 : R.width) ?? 0, T = (R == null ? void 0 : R.height) ?? 0, M = r + (a !== "center" ? "-" + a : ""), O = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, $ = Array.isArray(l) ? l : [l], D = $.length > 0, A = {
      padding: O,
      boundary: $.filter(hd),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: D
    }, { refs: P, floatingStyles: B, placement: k, isPositioned: V, middlewareData: _ } = ed({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...Be) => ju(...Be, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        nd({ mainAxis: o + T, alignmentAxis: s }),
        u && rd({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? od() : void 0,
          ...A
        }),
        u && ad({ ...A }),
        id({
          ...A,
          apply: ({ elements: Be, rects: z, availableWidth: Xt, availableHeight: qt }) => {
            const { width: Ct, height: Mn } = z.reference, st = Be.floating.style;
            st.setProperty("--radix-popper-available-width", `${Xt}px`), st.setProperty("--radix-popper-available-height", `${qt}px`), st.setProperty("--radix-popper-anchor-width", `${Ct}px`), st.setProperty("--radix-popper-anchor-height", `${Mn}px`);
          }
        }),
        w && cd({ element: w, padding: i }),
        gd({ arrowWidth: C, arrowHeight: T }),
        m && sd({ strategy: "referenceHidden", ...A })
      ]
    }), [I, K] = Xa(k), G = ne(b);
    Ae(() => {
      V && (G == null || G());
    }, [V, G]);
    const ae = (le = _.arrow) == null ? void 0 : le.x, ie = (ve = _.arrow) == null ? void 0 : ve.y, fe = ((se = _.arrow) == null ? void 0 : se.centerOffset) !== 0, [Fe, ge] = react__WEBPACK_IMPORTED_MODULE_1__.useState();
    return Ae(() => {
      y && ge(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "div",
      {
        ref: P.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...B,
          transform: V ? B.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Fe,
          "--radix-popper-transform-origin": [
            (Ie = _.transformOrigin) == null ? void 0 : Ie.x,
            (Oe = _.transformOrigin) == null ? void 0 : Oe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Et = _.hide) == null ? void 0 : Et.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          fd,
          {
            scope: n,
            placedSide: I,
            onArrowChange: S,
            arrowX: ae,
            arrowY: ie,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              oe.div,
              {
                "data-side": I,
                "data-align": K,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
ja.displayName = Lr;
var Ga = "PopperArrow", md = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Ya = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = pd(Ga, r), s = md[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          ud,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Ya.displayName = Ga;
function hd(e) {
  return e !== null;
}
var gd = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, y, E;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [l, f] = Xa(n), d = { start: "0%", center: "50%", end: "100%" }[f], m = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + i / 2, v = (((E = o.arrow) == null ? void 0 : E.y) ?? 0) + u / 2;
    let b = "", h = "";
    return l === "bottom" ? (b = s ? d : `${m}px`, h = `${-u}px`) : l === "top" ? (b = s ? d : `${m}px`, h = `${r.floating.height + u}px`) : l === "right" ? (b = `${-u}px`, h = s ? d : `${v}px`) : l === "left" && (b = `${r.floating.width + u}px`, h = s ? d : `${v}px`), { data: { x: b, y: h } };
  }
});
function Xa(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var qa = za, vd = Ka, yd = ja, wd = Ya, bd = "Portal", Za = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1);
  Ae(() => a(!0), []);
  const s = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return s ? react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { ...r, ref: t }), s) : null;
});
Za.displayName = bd;
var $n = "rovingFocusGroup.onEntryFocus", xd = { bubbles: !1, cancelable: !0 }, Ut = "RovingFocusGroup", [sr, Qa, Ed] = ba(Ut), [Cd, Ja] = $e(
  Ut,
  [Ed]
), [Sd, Rd] = Cd(Ut), ei = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sr.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sr.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Td, { ...e, ref: t }) }) })
);
ei.displayName = Ut;
var Td = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: u,
    onEntryFocus: l,
    preventScrollOnEntryFocus: f = !1,
    ...d
  } = e, m = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), v = q(t, m), b = xa(a), [h, g] = yt({
    prop: s,
    defaultProp: i ?? null,
    onChange: u,
    caller: Ut
  }), [y, E] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), x = ne(l), w = Qa(n), S = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), [R, C] = react__WEBPACK_IMPORTED_MODULE_1__.useState(0);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const T = m.current;
    if (T)
      return T.addEventListener($n, x), () => T.removeEventListener($n, x);
  }, [x]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    Sd,
    {
      scope: n,
      orientation: r,
      dir: b,
      loop: o,
      currentTabStopId: h,
      onItemFocus: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
        (T) => g(T),
        [g]
      ),
      onItemShiftTab: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => E(!0), []),
      onFocusableItemAdd: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
        () => C((T) => T + 1),
        []
      ),
      onFocusableItemRemove: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
        () => C((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        oe.div,
        {
          tabIndex: y || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: L(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: L(e.onFocus, (T) => {
            const M = !S.current;
            if (T.target === T.currentTarget && M && !y) {
              const O = new CustomEvent($n, xd);
              if (T.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const $ = w().filter((k) => k.focusable), D = $.find((k) => k.active), A = $.find((k) => k.id === h), B = [D, A, ...$].filter(
                  Boolean
                ).map((k) => k.ref.current);
                ri(B, f);
              }
            }
            S.current = !1;
          }),
          onBlur: L(e.onBlur, () => E(!1))
        }
      )
    }
  );
}), ti = "RovingFocusGroupItem", ni = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      children: s,
      ...i
    } = e, u = Ge(), l = a || u, f = Rd(ti, n), d = f.currentTabStopId === l, m = Qa(n), { onFocusableItemAdd: v, onFocusableItemRemove: b, currentTabStopId: h } = f;
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      if (r)
        return v(), () => b();
    }, [r, v, b]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      sr.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          oe.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": f.orientation,
            ...i,
            ref: t,
            onMouseDown: L(e.onMouseDown, (g) => {
              r ? f.onItemFocus(l) : g.preventDefault();
            }),
            onFocus: L(e.onFocus, () => f.onItemFocus(l)),
            onKeyDown: L(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget)
                return;
              const y = Pd(g, f.orientation, f.dir);
              if (y !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey)
                  return;
                g.preventDefault();
                let x = m().filter((w) => w.focusable).map((w) => w.ref.current);
                if (y === "last")
                  x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const w = x.indexOf(g.currentTarget);
                  x = f.loop ? Md(x, w + 1) : x.slice(w + 1);
                }
                setTimeout(() => ri(x));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: d, hasTabStop: h != null }) : s
          }
        )
      }
    );
  }
);
ni.displayName = ti;
var Nd = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ad(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Pd(e, t, n) {
  const r = Ad(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Nd[r];
}
function ri(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function Md(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Dd = ei, Id = ni;
// @__NO_SIDE_EFFECTS__
function Od(e) {
  const t = /* @__PURE__ */ _d(e), n = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(a), u = i.find(Ld);
    if (u) {
      const l = u.props.children, f = i.map((d) => d === u ? react__WEBPACK_IMPORTED_MODULE_1__.Children.count(l) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function _d(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(o)) {
      const s = Fd(o), i = $d(a, o.props);
      return o.type !== react__WEBPACK_IMPORTED_MODULE_1__.Fragment && (i.ref = r ? ot(r, s) : s), react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(o, i);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.count(o) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var kd = Symbol("radix.slottable");
function Ld(e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === kd;
}
function $d(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      a(...i), o(...i);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Fd(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Bd = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, lt = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap(), nn = {}, Fn = 0, oi = function(e) {
  return e && (e.host || oi(e.parentNode));
}, Wd = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = oi(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Vd = function(e, t, n, r) {
  var o = Wd(t, Array.isArray(e) ? e : [e]);
  nn[n] || (nn[n] = /* @__PURE__ */ new WeakMap());
  var a = nn[n], s = [], i = /* @__PURE__ */ new Set(), u = new Set(o), l = function(d) {
    !d || i.has(d) || (i.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var f = function(d) {
    !d || u.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (i.has(m))
        f(m);
      else
        try {
          var v = m.getAttribute(r), b = v !== null && v !== "false", h = (lt.get(m) || 0) + 1, g = (a.get(m) || 0) + 1;
          lt.set(m, h), a.set(m, g), s.push(m), h === 1 && b && tn.set(m, !0), g === 1 && m.setAttribute(n, "true"), b || m.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", m, y);
        }
    });
  };
  return f(t), i.clear(), Fn++, function() {
    s.forEach(function(d) {
      var m = lt.get(d) - 1, v = a.get(d) - 1;
      lt.set(d, m), a.set(d, v), m || (tn.has(d) || d.removeAttribute(r), tn.delete(d)), v || d.removeAttribute(n);
    }), Fn--, Fn || (lt = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakMap(), tn = /* @__PURE__ */ new WeakMap(), nn = {});
  };
}, ai = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || Bd(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Vd(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Re = function() {
  return Re = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Re.apply(this, arguments);
};
function ii(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Ud(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var un = "right-scroll-bar-position", dn = "width-before-scroll-bar", zd = "with-scroll-bars-hidden", Hd = "--removed-body-scroll-bar-size";
function Bn(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Kd(e, t) {
  var n = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var jd = typeof window < "u" ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_1__.useEffect, Oo = /* @__PURE__ */ new WeakMap();
function Gd(e, t) {
  var n = Kd(t || null, function(r) {
    return e.forEach(function(o) {
      return Bn(o, r);
    });
  });
  return jd(function() {
    var r = Oo.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), s = n.current;
      o.forEach(function(i) {
        a.has(i) || Bn(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Bn(i, s);
      });
    }
    Oo.set(n, e);
  }, [e]), n;
}
function Yd(e) {
  return e;
}
function Xd(e, t) {
  t === void 0 && (t = Yd);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, r);
      return n.push(s), function() {
        n = n.filter(function(i) {
          return i !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), s = n;
      }
      var u = function() {
        var f = s;
        s = [], f.forEach(a);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(f) {
          s.push(f), l();
        },
        filter: function(f) {
          return s = s.filter(f), n;
        }
      };
    }
  };
  return o;
}
function qd(e) {
  e === void 0 && (e = {});
  var t = Xd(null);
  return t.options = Re({ async: !0, ssr: !1 }, e), t;
}
var si = function(e) {
  var t = e.sideCar, n = ii(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(r, Re({}, n));
};
si.isSideCarExport = !0;
function Zd(e, t) {
  return e.useMedium(t), si;
}
var ci = qd(), Wn = function() {
}, Rn = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(e, t) {
  var n = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), r = react__WEBPACK_IMPORTED_MODULE_1__.useState({
    onScrollCapture: Wn,
    onWheelCapture: Wn,
    onTouchMoveCapture: Wn
  }), o = r[0], a = r[1], s = e.forwardProps, i = e.children, u = e.className, l = e.removeScrollBar, f = e.enabled, d = e.shards, m = e.sideCar, v = e.noIsolation, b = e.inert, h = e.allowPinchZoom, g = e.as, y = g === void 0 ? "div" : g, E = e.gapMode, x = ii(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = m, S = Gd([n, t]), R = Re(Re({}, x), o);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(
    react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
    null,
    f && react__WEBPACK_IMPORTED_MODULE_1__.createElement(w, { sideCar: ci, removeScrollBar: l, shards: d, noIsolation: v, inert: b, setCallbacks: a, allowPinchZoom: !!h, lockRef: n, gapMode: E }),
    s ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(react__WEBPACK_IMPORTED_MODULE_1__.Children.only(i), Re(Re({}, R), { ref: S })) : react__WEBPACK_IMPORTED_MODULE_1__.createElement(y, Re({}, R, { className: u, ref: S }), i)
  );
});
Rn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Rn.classNames = {
  fullWidth: dn,
  zeroRight: un
};
var _o, Qd = function() {
  if (_o)
    return _o;
  if (true)
    return __webpack_require__.nc;
};
function Jd() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Qd();
  return t && e.setAttribute("nonce", t), e;
}
function ef(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function tf(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var nf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Jd()) && (ef(t, n), tf(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, rf = function() {
  var e = nf();
  return function(t, n) {
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, li = function() {
  var e = rf(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, of = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Vn = function(e) {
  return parseInt(e || "", 10) || 0;
}, af = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Vn(n), Vn(r), Vn(o)];
}, sf = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return of;
  var t = af(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, cf = li(), mt = "data-scroll-locked", lf = function(e, t, n, r) {
  var o = e.left, a = e.top, s = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(zd, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(mt, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(un, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(dn, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(un, " .").concat(un, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(dn, " .").concat(dn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(mt, `] {
    `).concat(Hd, ": ").concat(i, `px;
  }
`);
}, ko = function() {
  var e = parseInt(document.body.getAttribute(mt) || "0", 10);
  return isFinite(e) ? e : 0;
}, uf = function() {
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    return document.body.setAttribute(mt, (ko() + 1).toString()), function() {
      var e = ko() - 1;
      e <= 0 ? document.body.removeAttribute(mt) : document.body.setAttribute(mt, e.toString());
    };
  }, []);
}, df = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  uf();
  var a = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
    return sf(o);
  }, [o]);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(cf, { styles: lf(a, !t, o, n ? "" : "!important") });
}, cr = !1;
if (typeof window < "u")
  try {
    var rn = Object.defineProperty({}, "passive", {
      get: function() {
        return cr = !0, !0;
      }
    });
    window.addEventListener("test", rn, rn), window.removeEventListener("test", rn, rn);
  } catch {
    cr = !1;
  }
var ut = cr ? { passive: !1 } : !1, ff = function(e) {
  return e.tagName === "TEXTAREA";
}, ui = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ff(e) && n[t] === "visible")
  );
}, pf = function(e) {
  return ui(e, "overflowY");
}, mf = function(e) {
  return ui(e, "overflowX");
}, Lo = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = di(e, r);
    if (o) {
      var a = fi(e, r), s = a[1], i = a[2];
      if (s > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, hf = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, gf = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, di = function(e, t) {
  return e === "v" ? pf(t) : mf(t);
}, fi = function(e, t) {
  return e === "v" ? hf(t) : gf(t);
}, vf = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, yf = function(e, t, n, r, o) {
  var a = vf(e, window.getComputedStyle(t).direction), s = a * r, i = n.target, u = t.contains(i), l = !1, f = s > 0, d = 0, m = 0;
  do {
    var v = fi(e, i), b = v[0], h = v[1], g = v[2], y = h - g - a * b;
    (b || y) && di(e, i) && (d += y, m += b), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !u && i !== document.body || // self content
    u && (t.contains(i) || t === i)
  );
  return (f && (o && Math.abs(d) < 1 || !o && s > d) || !f && (o && Math.abs(m) < 1 || !o && -s > m)) && (l = !0), l;
}, on = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $o = function(e) {
  return [e.deltaX, e.deltaY];
}, Fo = function(e) {
  return e && "current" in e ? e.current : e;
}, wf = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, bf = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, xf = 0, dt = [];
function Ef(e) {
  var t = react__WEBPACK_IMPORTED_MODULE_1__.useRef([]), n = react__WEBPACK_IMPORTED_MODULE_1__.useRef([0, 0]), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(), o = react__WEBPACK_IMPORTED_MODULE_1__.useState(xf++)[0], a = react__WEBPACK_IMPORTED_MODULE_1__.useState(li)[0], s = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    s.current = e;
  }, [e]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = Ud([e.lockRef.current], (e.shards || []).map(Fo), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = on(h), E = n.current, x = "deltaX" in h ? h.deltaX : E[0] - y[0], w = "deltaY" in h ? h.deltaY : E[1] - y[1], S, R = h.target, C = Math.abs(x) > Math.abs(w) ? "h" : "v";
    if ("touches" in h && C === "h" && R.type === "range")
      return !1;
    var T = Lo(C, R);
    if (!T)
      return !0;
    if (T ? S = C : (S = C === "v" ? "h" : "v", T = Lo(C, R)), !T)
      return !1;
    if (!r.current && "changedTouches" in h && (x || w) && (r.current = S), !S)
      return !0;
    var M = r.current || S;
    return yf(M, g, h, M === "h" ? x : w, !0);
  }, []), u = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h) {
    var g = h;
    if (!(!dt.length || dt[dt.length - 1] !== a)) {
      var y = "deltaY" in g ? $o(g) : on(g), E = t.current.filter(function(S) {
        return S.name === g.type && (S.target === g.target || g.target === S.shadowParent) && wf(S.delta, y);
      })[0];
      if (E && E.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!E) {
        var x = (s.current.shards || []).map(Fo).filter(Boolean).filter(function(S) {
          return S.contains(g.target);
        }), w = x.length > 0 ? i(g, x[0]) : !s.current.noIsolation;
        w && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h, g, y, E) {
    var x = { name: h, delta: g, target: y, should: E, shadowParent: Cf(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== x;
      });
    }, 1);
  }, []), f = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h) {
    n.current = on(h), r.current = void 0;
  }, []), d = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h) {
    l(h.type, $o(h), h.target, i(h, e.lockRef.current));
  }, []), m = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(h) {
    l(h.type, on(h), h.target, i(h, e.lockRef.current));
  }, []);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
    return dt.push(a), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", u, ut), document.addEventListener("touchmove", u, ut), document.addEventListener("touchstart", f, ut), function() {
      dt = dt.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", u, ut), document.removeEventListener("touchmove", u, ut), document.removeEventListener("touchstart", f, ut);
    };
  }, []);
  var v = e.removeScrollBar, b = e.inert;
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(
    react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
    null,
    b ? react__WEBPACK_IMPORTED_MODULE_1__.createElement(a, { styles: bf(o) }) : null,
    v ? react__WEBPACK_IMPORTED_MODULE_1__.createElement(df, { gapMode: e.gapMode }) : null
  );
}
function Cf(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Sf = Zd(ci, Ef);
var pi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(e, t) {
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Rn, Re({}, e, { ref: t, sideCar: Sf }));
});
pi.classNames = Rn.classNames;
const mi = pi;
var lr = ["Enter", " "], Rf = ["ArrowDown", "PageUp", "Home"], hi = ["ArrowUp", "PageDown", "End"], Tf = [...Rf, ...hi], Nf = {
  ltr: [...lr, "ArrowRight"],
  rtl: [...lr, "ArrowLeft"]
}, Af = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, zt = "Menu", [Ft, Pf, Mf] = ba(zt), [at, gi] = $e(zt, [
  Mf,
  Va,
  Ja
]), Ht = Va(), vi = Ja(), [yi, Qe] = at(zt), [Df, Kt] = at(zt), wi = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: s = !0 } = e, i = Ht(t), [u, l] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), f = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), d = ne(a), m = xa(o);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const v = () => {
      f.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => f.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qa, { ...i, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    yi,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: u,
      onContentChange: l,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        Df,
        {
          scope: t,
          onClose: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: f,
          dir: m,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
wi.displayName = zt;
var If = "MenuAnchor", $r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ht(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vd, { ...o, ...r, ref: t });
  }
);
$r.displayName = If;
var Fr = "MenuPortal", [Of, bi] = at(Fr, {
  forceMount: void 0
}), xi = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Qe(Fr, t);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Of, { scope: t, forceMount: n, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: n || a.open, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Za, { asChild: !0, container: o, children: r }) }) });
};
xi.displayName = Fr;
var he = "MenuContent", [_f, Br] = at(he), Ei = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = bi(he, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Qe(he, e.__scopeMenu), s = Kt(he, e.__scopeMenu);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ft.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: r || a.open, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ft.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(kf, { ...o, ref: t }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lf, { ...o, ref: t }) }) }) });
  }
), kf = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Qe(he, e.__scopeMenu), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), o = q(t, r);
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const a = r.current;
      if (a)
        return ai(a);
    }, []), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Wr,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: L(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Lf = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const n = Qe(he, e.__scopeMenu);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    Wr,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), $f = /* @__PURE__ */ Od("MenuContent.ScrollLock"), Wr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: i,
      onEntryFocus: u,
      onEscapeKeyDown: l,
      onPointerDownOutside: f,
      onFocusOutside: d,
      onInteractOutside: m,
      onDismiss: v,
      disableOutsideScroll: b,
      ...h
    } = e, g = Qe(he, n), y = Kt(he, n), E = Ht(n), x = vi(n), w = Pf(n), [S, R] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), C = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), T = q(t, C, g.onContentChange), M = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), O = react__WEBPACK_IMPORTED_MODULE_1__.useRef(""), $ = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), D = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), A = react__WEBPACK_IMPORTED_MODULE_1__.useRef("right"), P = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), B = b ? mi : react__WEBPACK_IMPORTED_MODULE_1__.Fragment, k = b ? { as: $f, allowPinchZoom: !0 } : void 0, V = (I) => {
      var le, ve;
      const K = O.current + I, G = w().filter((se) => !se.disabled), ae = document.activeElement, ie = (le = G.find((se) => se.ref.current === ae)) == null ? void 0 : le.textValue, fe = G.map((se) => se.textValue), Fe = Xf(fe, K, ie), ge = (ve = G.find((se) => se.textValue === Fe)) == null ? void 0 : ve.ref.current;
      (function se(Ie) {
        O.current = Ie, window.clearTimeout(M.current), Ie !== "" && (M.current = window.setTimeout(() => se(""), 1e3));
      })(K), ge && setTimeout(() => ge.focus());
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => () => window.clearTimeout(M.current), []), Ta();
    const _ = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((I) => {
      var G, ae;
      return A.current === ((G = D.current) == null ? void 0 : G.side) && Zf(I, (ae = D.current) == null ? void 0 : ae.area);
    }, []);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _f,
      {
        scope: n,
        searchRef: O,
        onItemEnter: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
          (I) => {
            _(I) && I.preventDefault();
          },
          [_]
        ),
        onItemLeave: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
          (I) => {
            var K;
            _(I) || ((K = C.current) == null || K.focus(), R(null));
          },
          [_]
        ),
        onTriggerLeave: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
          (I) => {
            _(I) && I.preventDefault();
          },
          [_]
        ),
        pointerGraceTimerRef: $,
        onPointerGraceIntentChange: react__WEBPACK_IMPORTED_MODULE_1__.useCallback((I) => {
          D.current = I;
        }, []),
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(B, { ...k, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          Na,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: L(a, (I) => {
              var K;
              I.preventDefault(), (K = C.current) == null || K.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              Sa,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: l,
                onPointerDownOutside: f,
                onFocusOutside: d,
                onInteractOutside: m,
                onDismiss: v,
                children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
                  Dd,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: L(u, (I) => {
                      y.isUsingKeyboardRef.current || I.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
                      yd,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Bi(g.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...E,
                        ...h,
                        ref: T,
                        style: { outline: "none", ...h.style },
                        onKeyDown: L(h.onKeyDown, (I) => {
                          const G = I.target.closest("[data-radix-menu-content]") === I.currentTarget, ae = I.ctrlKey || I.altKey || I.metaKey, ie = I.key.length === 1;
                          G && (I.key === "Tab" && I.preventDefault(), !ae && ie && V(I.key));
                          const fe = C.current;
                          if (I.target !== fe || !Tf.includes(I.key))
                            return;
                          I.preventDefault();
                          const ge = w().filter((le) => !le.disabled).map((le) => le.ref.current);
                          hi.includes(I.key) && ge.reverse(), Gf(ge);
                        }),
                        onBlur: L(e.onBlur, (I) => {
                          I.currentTarget.contains(I.target) || (window.clearTimeout(M.current), O.current = "");
                        }),
                        onPointerMove: L(
                          e.onPointerMove,
                          Bt((I) => {
                            const K = I.target, G = P.current !== I.clientX;
                            if (I.currentTarget.contains(K) && G) {
                              const ae = I.clientX > P.current ? "right" : "left";
                              A.current = ae, P.current = I.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ei.displayName = he;
var Ff = "MenuGroup", Vr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { role: "group", ...r, ref: t });
  }
);
Vr.displayName = Ff;
var Bf = "MenuLabel", Ci = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oe.div, { ...r, ref: t });
  }
);
Ci.displayName = Bf;
var gn = "MenuItem", Bo = "menu.itemSelect", Tn = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), s = Kt(gn, e.__scopeMenu), i = Br(gn, e.__scopeMenu), u = q(t, a), l = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), f = () => {
      const d = a.current;
      if (!n && d) {
        const m = new CustomEvent(Bo, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Bo, (v) => r == null ? void 0 : r(v), { once: !0 }), ma(d, m), m.defaultPrevented ? l.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Si,
      {
        ...o,
        ref: u,
        disabled: n,
        onClick: L(e.onClick, f),
        onPointerDown: (d) => {
          var m;
          (m = e.onPointerDown) == null || m.call(e, d), l.current = !0;
        },
        onPointerUp: L(e.onPointerUp, (d) => {
          var m;
          l.current || (m = d.currentTarget) == null || m.click();
        }),
        onKeyDown: L(e.onKeyDown, (d) => {
          const m = i.searchRef.current !== "";
          n || m && d.key === " " || lr.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
Tn.displayName = gn;
var Si = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, s = Br(gn, n), i = vi(n), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), l = q(t, u), [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [m, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState("");
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const b = u.current;
      b && v((b.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Ft.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? m,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Id, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          oe.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: l,
            onPointerMove: L(
              e.onPointerMove,
              Bt((b) => {
                r ? s.onItemLeave(b) : (s.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: L(
              e.onPointerLeave,
              Bt((b) => s.onItemLeave(b))
            ),
            onFocus: L(e.onFocus, () => d(!0)),
            onBlur: L(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), Wf = "MenuCheckboxItem", Ri = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mi, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Tn,
      {
        role: "menuitemcheckbox",
        "aria-checked": vn(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Hr(n),
        onSelect: L(
          o.onSelect,
          () => r == null ? void 0 : r(vn(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ri.displayName = Wf;
var Ti = "MenuRadioGroup", [Vf, Uf] = at(
  Ti,
  { value: void 0, onValueChange: () => {
  } }
), Ni = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = ne(r);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Vf, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Vr, { ...o, ref: t }) });
  }
);
Ni.displayName = Ti;
var Ai = "MenuRadioItem", Pi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = Uf(Ai, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mi, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Tn,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": Hr(a),
        onSelect: L(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Pi.displayName = Ai;
var Ur = "MenuItemIndicator", [Mi, zf] = at(
  Ur,
  { checked: !1 }
), Di = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = zf(Ur, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Me,
      {
        present: r || vn(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          oe.span,
          {
            ...o,
            ref: t,
            "data-state": Hr(a.checked)
          }
        )
      }
    );
  }
);
Di.displayName = Ur;
var Hf = "MenuSeparator", Ii = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      oe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Ii.displayName = Hf;
var Kf = "MenuArrow", Oi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ht(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(wd, { ...o, ...r, ref: t });
  }
);
Oi.displayName = Kf;
var zr = "MenuSub", [jf, _i] = at(zr), ki = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Qe(zr, t), s = Ht(t), [i, u] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), [l, f] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), d = ne(o);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (a.open === !1 && d(!1), () => d(!1)), [a.open, d]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qa, { ...s, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    yi,
    {
      scope: t,
      open: r,
      onOpenChange: d,
      content: l,
      onContentChange: f,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        jf,
        {
          scope: t,
          contentId: Ge(),
          triggerId: Ge(),
          trigger: i,
          onTriggerChange: u,
          children: n
        }
      )
    }
  ) });
};
ki.displayName = zr;
var Dt = "MenuSubTrigger", Li = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Qe(Dt, e.__scopeMenu), r = Kt(Dt, e.__scopeMenu), o = _i(Dt, e.__scopeMenu), a = Br(Dt, e.__scopeMenu), s = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: u } = a, l = { __scopeMenu: e.__scopeMenu }, f = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => f, [f]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const d = i.current;
      return () => {
        window.clearTimeout(d), u(null);
      };
    }, [i, u]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)($r, { asChild: !0, ...l, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Si,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Bi(n.open),
        ...e,
        ref: ot(t, o.onTriggerChange),
        onClick: (d) => {
          var m;
          (m = e.onClick) == null || m.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: L(
          e.onPointerMove,
          Bt((d) => {
            a.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: L(
          e.onPointerLeave,
          Bt((d) => {
            var v, b;
            f();
            const m = (v = n.content) == null ? void 0 : v.getBoundingClientRect();
            if (m) {
              const h = (b = n.content) == null ? void 0 : b.dataset.side, g = h === "right", y = g ? -5 : 5, E = m[g ? "left" : "right"], x = m[g ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + y, y: d.clientY },
                  { x: E, y: m.top },
                  { x, y: m.top },
                  { x, y: m.bottom },
                  { x: E, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(d), d.defaultPrevented)
                return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: L(e.onKeyDown, (d) => {
          var v;
          const m = a.searchRef.current !== "";
          e.disabled || m && d.key === " " || Nf[r.dir].includes(d.key) && (n.onOpenChange(!0), (v = n.content) == null || v.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Li.displayName = Dt;
var $i = "MenuSubContent", Fi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = bi(he, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Qe(he, e.__scopeMenu), s = Kt(he, e.__scopeMenu), i = _i($i, e.__scopeMenu), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), l = q(t, u);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ft.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: r || a.open, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ft.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Wr,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = u.current) == null || d.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: L(e.onFocusOutside, (f) => {
          f.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: L(e.onEscapeKeyDown, (f) => {
          s.onClose(), f.preventDefault();
        }),
        onKeyDown: L(e.onKeyDown, (f) => {
          var v;
          const d = f.currentTarget.contains(f.target), m = Af[s.dir].includes(f.key);
          d && m && (a.onOpenChange(!1), (v = i.trigger) == null || v.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
Fi.displayName = $i;
function Bi(e) {
  return e ? "open" : "closed";
}
function vn(e) {
  return e === "indeterminate";
}
function Hr(e) {
  return vn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Gf(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Yf(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function Xf(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = Yf(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((l) => l !== n));
  const u = s.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function qf(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], u = t[s], l = i.x, f = i.y, d = u.x, m = u.y;
    f > r != m > r && n < (d - l) * (r - f) / (m - f) + l && (o = !o);
  }
  return o;
}
function Zf(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return qf(n, t);
}
function Bt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Qf = wi, Jf = $r, ep = xi, tp = Ei, np = Vr, rp = Ci, op = Tn, ap = Ri, ip = Ni, sp = Pi, cp = Di, lp = Ii, up = Oi, dp = (/* unused pure expression or super */ null && (ki)), fp = Li, pp = Fi, Nn = "DropdownMenu", [mp, xg] = $e(
  Nn,
  [gi]
), ce = gi(), [hp, Wi] = mp(Nn), Vi = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: s,
    modal: i = !0
  } = e, u = ce(t), l = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), [f, d] = yt({
    prop: o,
    defaultProp: a ?? !1,
    onChange: s,
    caller: Nn
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    hp,
    {
      scope: t,
      triggerId: Ge(),
      triggerRef: l,
      contentId: Ge(),
      open: f,
      onOpenChange: d,
      onOpenToggle: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => d((m) => !m), [d]),
      modal: i,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Qf, { ...u, open: f, onOpenChange: d, dir: r, modal: i, children: n })
    }
  );
};
Vi.displayName = Nn;
var Ui = "DropdownMenuTrigger", zi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Wi(Ui, n), s = ce(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Jf, { asChild: !0, ...s, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      oe.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: ot(t, a.triggerRef),
        onPointerDown: L(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: L(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
zi.displayName = Ui;
var gp = "DropdownMenuPortal", Hi = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ce(t);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ep, { ...r, ...n });
};
Hi.displayName = gp;
var Ki = "DropdownMenuContent", ji = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Wi(Ki, n), a = ce(n), s = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      tp,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: L(e.onCloseAutoFocus, (i) => {
          var u;
          s.current || (u = o.triggerRef.current) == null || u.focus(), s.current = !1, i.preventDefault();
        }),
        onInteractOutside: L(e.onInteractOutside, (i) => {
          const u = i.detail.originalEvent, l = u.button === 0 && u.ctrlKey === !0, f = u.button === 2 || l;
          (!o.modal || f) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
ji.displayName = Ki;
var vp = "DropdownMenuGroup", Gi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(np, { ...o, ...r, ref: t });
  }
);
Gi.displayName = vp;
var yp = "DropdownMenuLabel", Yi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(rp, { ...o, ...r, ref: t });
  }
);
Yi.displayName = yp;
var wp = "DropdownMenuItem", Xi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(op, { ...o, ...r, ref: t });
  }
);
Xi.displayName = wp;
var bp = "DropdownMenuCheckboxItem", qi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ap, { ...o, ...r, ref: t });
});
qi.displayName = bp;
var xp = "DropdownMenuRadioGroup", Zi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ip, { ...o, ...r, ref: t });
});
Zi.displayName = xp;
var Ep = "DropdownMenuRadioItem", Qi = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sp, { ...o, ...r, ref: t });
});
Qi.displayName = Ep;
var Cp = "DropdownMenuItemIndicator", Ji = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cp, { ...o, ...r, ref: t });
});
Ji.displayName = Cp;
var Sp = "DropdownMenuSeparator", es = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lp, { ...o, ...r, ref: t });
});
es.displayName = Sp;
var Rp = "DropdownMenuArrow", Tp = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(up, { ...o, ...r, ref: t });
  }
);
Tp.displayName = Rp;
var Np = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, s = ce(t), [i, u] = yt({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p(dp, { ...s, open: i, onOpenChange: u, children: n });
}, Ap = "DropdownMenuSubTrigger", ts = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(fp, { ...o, ...r, ref: t });
});
ts.displayName = Ap;
var Pp = "DropdownMenuSubContent", ns = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    pp,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ns.displayName = Pp;
var Mp = Vi, rs = zi, os = Hi, as = ji, Dp = (/* unused pure expression or super */ null && (Gi)), is = Yi, ss = Xi, cs = qi, Ip = (/* unused pure expression or super */ null && (Zi)), ls = Qi, us = Ji, ds = es, Op = (/* unused pure expression or super */ null && (Np)), fs = ts, ps = ns;
const Te = ({ name: e, size: t, color: n, filled: r, onClick: o, rotate: a = 0, className: s }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: t ? `${t}px` : void 0,
      transform: a ? `rotate(${a}deg)` : void 0
    },
    onClick: o,
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "span",
      {
        translate: "no",
        className: F("material-symbols-rounded", s),
        style: {
          fontSize: t ? `${t}px` : void 0,
          color: n,
          overflow: "hidden",
          fontVariationSettings: r ? "'FILL' 1" : "'FILL' 0"
        },
        children: e
      }
    )
  }
), _p = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("g", { id: "CheckItem" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M18.2961 4.5363C18.8284 4.97598 18.9034 5.76387 18.4637 6.29611L8.96375 17.7961C8.7241 18.0862 8.36651 18.2529 7.99023 18.25C7.61395 18.247 7.25903 18.0747 7.02396 17.7809L3.02396 12.7809C2.5927 12.2418 2.6801 11.4552 3.21918 11.0239C3.75825 10.5927 4.54487 10.6801 4.97613 11.2191L8.01561 15.0185L16.5363 4.7039C16.976 4.17166 17.7639 4.09663 18.2961 4.5363Z", fill: "#FD7E14" }))), kp = ({ size: e = 22, className: t, ...n }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_p, { width: e, height: e, className: t, ...n });
// @__NO_SIDE_EFFECTS__
function Ze(e) {
  const t = /* @__PURE__ */ Lp(e), n = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(a), u = i.find(Fp);
    if (u) {
      const l = u.props.children, f = i.map((d) => d === u ? react__WEBPACK_IMPORTED_MODULE_1__.Children.count(l) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(l) ? react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(l, void 0, f) : null });
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Lp(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(o)) {
      const s = Wp(o), i = Bp(a, o.props);
      return o.type !== react__WEBPACK_IMPORTED_MODULE_1__.Fragment && (i.ref = r ? ot(r, s) : s), react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(o, i);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.count(o) > 1 ? react__WEBPACK_IMPORTED_MODULE_1__.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var $p = Symbol("radix.slottable");
function Fp(e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === $p;
}
function Bp(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const u = a(...i);
      return o(...i), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Wp(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Vp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ms = Vp.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Up(e, t) {
  e && react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(() => e.dispatchEvent(t));
}
var zp = "DismissableLayer", ur = "dismissableLayer.update", Hp = "dismissableLayer.pointerDownOutside", Kp = "dismissableLayer.focusOutside", Wo, hs = react__WEBPACK_IMPORTED_MODULE_1__.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Kr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...u
    } = e, l = react__WEBPACK_IMPORTED_MODULE_1__.useContext(hs), [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), m = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState({}), b = q(t, (C) => d(C)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = h.indexOf(g), E = f ? h.indexOf(f) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, w = E >= y, S = Gp((C) => {
      const T = C.target, M = [...l.branches].some((O) => O.contains(T));
      !w || M || (o == null || o(C), s == null || s(C), C.defaultPrevented || i == null || i());
    }, m), R = Yp((C) => {
      const T = C.target;
      [...l.branches].some((O) => O.contains(T)) || (a == null || a(C), s == null || s(C), C.defaultPrevented || i == null || i());
    }, m);
    return Ea((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, m), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      if (f)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Wo = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), Vo(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Wo);
        };
    }, [f, m, n, l]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), Vo());
    }, [f, l]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(ur, C), () => document.removeEventListener(ur, C);
    }, []), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      ms.div,
      {
        ...u,
        ref: b,
        style: {
          pointerEvents: x ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: L(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: L(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: L(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Kr.displayName = zp;
var jp = "DismissableLayerBranch", gs = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const n = react__WEBPACK_IMPORTED_MODULE_1__.useContext(hs), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), o = q(t, r);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ms.div, { ...e, ref: o });
});
gs.displayName = jp;
function Gp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(() => {
  });
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let u = function() {
          vs(
            Hp,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Yp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && vs(Kp, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Vo() {
  const e = new CustomEvent(ur);
  document.dispatchEvent(e);
}
function vs(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Up(o, a) : o.dispatchEvent(a);
}
var Xp = Kr, qp = gs, Zp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Qp = Zp.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Un = "focusScope.autoFocusOnMount", zn = "focusScope.autoFocusOnUnmount", Uo = { bubbles: !1, cancelable: !0 }, Jp = "FocusScope", ys = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, u] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), l = ne(o), f = ne(a), d = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), m = q(t, (h) => u(h)), v = react__WEBPACK_IMPORTED_MODULE_1__.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (v.paused || !i)
          return;
        const w = x.target;
        i.contains(w) ? d.current = w : Ke(d.current, { select: !0 });
      }, g = function(x) {
        if (v.paused || !i)
          return;
        const w = x.relatedTarget;
        w !== null && (i.contains(w) || Ke(d.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Ke(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const E = new MutationObserver(y);
      return i && E.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), E.disconnect();
      };
    }
  }, [r, i, v.paused]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (i) {
      Ho.add(v);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const y = new CustomEvent(Un, Uo);
        i.addEventListener(Un, l), i.dispatchEvent(y), y.defaultPrevented || (em(am(ws(i)), { select: !0 }), document.activeElement === h && Ke(i));
      }
      return () => {
        i.removeEventListener(Un, l), setTimeout(() => {
          const y = new CustomEvent(zn, Uo);
          i.addEventListener(zn, f), i.dispatchEvent(y), y.defaultPrevented || Ke(h ?? document.body, { select: !0 }), i.removeEventListener(zn, f), Ho.remove(v);
        }, 0);
      };
    }
  }, [i, l, f, v]);
  const b = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
    (h) => {
      if (!n && !r || v.paused)
        return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
      if (g && y) {
        const E = h.currentTarget, [x, w] = tm(E);
        x && w ? !h.shiftKey && y === w ? (h.preventDefault(), n && Ke(x, { select: !0 })) : h.shiftKey && y === x && (h.preventDefault(), n && Ke(w, { select: !0 })) : y === E && h.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Qp.div, { tabIndex: -1, ...s, ref: m, onKeyDown: b });
});
ys.displayName = Jp;
function em(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ke(r, { select: t }), document.activeElement !== n)
      return;
}
function tm(e) {
  const t = ws(e), n = zo(t, e), r = zo(t.reverse(), e);
  return [n, r];
}
function ws(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function zo(e, t) {
  for (const n of e)
    if (!nm(n, { upTo: t }))
      return n;
}
function nm(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function rm(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && rm(e) && t && e.select();
  }
}
var Ho = om();
function om() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ko(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ko(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Ko(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function am(e) {
  return e.filter((t) => t.tagName !== "A");
}
var im = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], sm = im.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), cm = "Portal", jr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1);
  Ae(() => a(!0), []);
  const s = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return s ? react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sm.div, { ...r, ref: t }), s) : null;
});
jr.displayName = cm;
var lm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], jt = lm.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), An = "Dialog", [bs, Eg] = $e(An), [um, Ce] = bs(An), xs = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !0
  } = e, i = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), [l, f] = yt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: An
  });
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    um,
    {
      scope: t,
      triggerRef: i,
      contentRef: u,
      contentId: Ge(),
      titleId: Ge(),
      descriptionId: Ge(),
      open: l,
      onOpenChange: f,
      onOpenToggle: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => f((d) => !d), [f]),
      modal: s,
      children: n
    }
  );
};
xs.displayName = An;
var Es = "DialogTrigger", Cs = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ce(Es, n), a = q(t, o.triggerRef);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      jt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Xr(o.open),
        ...r,
        ref: a,
        onClick: L(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Cs.displayName = Es;
var Gr = "DialogPortal", [dm, Ss] = bs(Gr, {
  forceMount: void 0
}), Rs = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = Ce(Gr, t);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(dm, { scope: t, forceMount: n, children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(r, (s) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: n || a.open, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(jr, { asChild: !0, container: o, children: s }) })) });
};
Rs.displayName = Gr;
var yn = "DialogOverlay", Ts = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Ss(yn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ce(yn, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: r || a.open, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pm, { ...o, ref: t }) }) : null;
  }
);
Ts.displayName = yn;
var fm = /* @__PURE__ */ Ze("DialogOverlay.RemoveScroll"), pm = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ce(yn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mi, { as: fm, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        jt.div,
        {
          "data-state": Xr(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), rt = "DialogContent", Ns = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Ss(rt, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ce(rt, e.__scopeDialog);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: r || a.open, children: a.modal ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mm, { ...o, ref: t }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(hm, { ...o, ref: t }) });
  }
);
Ns.displayName = rt;
var mm = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Ce(rt, e.__scopeDialog), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), o = q(t, n.contentRef, r);
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const a = r.current;
      if (a)
        return ai(a);
    }, []), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      As,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: L(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: L(e.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, i = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: L(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), hm = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const n = Ce(rt, e.__scopeDialog), r = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      As,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, i;
          (s = e.onCloseAutoFocus) == null || s.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var u, l;
          (u = e.onInteractOutside) == null || u.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), As = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...s } = e, i = Ce(rt, n), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), l = q(t, u);
    return Ta(), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        ys,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            Kr,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Xr(i.open),
              ...s,
              ref: l,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(gm, { titleId: i.titleId }),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ym, { contentRef: u, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), Yr = "DialogTitle", Ps = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ce(Yr, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(jt.h2, { id: o.titleId, ...r, ref: t });
  }
);
Ps.displayName = Yr;
var Ms = "DialogDescription", Ds = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ce(Ms, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(jt.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Ds.displayName = Ms;
var Is = "DialogClose", Os = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ce(Is, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      jt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: L(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Os.displayName = Is;
function Xr(e) {
  return e ? "open" : "closed";
}
var _s = "DialogTitleWarning", [Cg, ks] = El(_s, {
  contentName: rt,
  titleName: Yr,
  docsSlug: "dialog"
}), gm = ({ titleId: e }) => {
  const t = ks(_s), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, vm = "DialogDescriptionWarning", ym = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ks(vm).contentName}}.`;
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Ls = xs, wm = Cs, $s = Rs, Fs = Ts, Bs = Ns, Ws = Ps, Vs = Ds, bm = Os;
function xm(e) {
  if (!e || typeof document > "u")
    return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const Us = react__WEBPACK_IMPORTED_MODULE_1__.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), xt = () => {
  const e = react__WEBPACK_IMPORTED_MODULE_1__.useContext(Us);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
xm(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Em() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Cm() {
  return qr(/^Mac/);
}
function Sm() {
  return qr(/^iPhone/);
}
function jo() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Rm() {
  return qr(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Cm() && navigator.maxTouchPoints > 1;
}
function zs() {
  return Sm() || Rm();
}
function qr(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Tm = 24, Nm = typeof window < "u" ? react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_1__.useEffect;
function Go(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const Hn = typeof document < "u" && window.visualViewport;
function Yo(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Hs(e) {
  for (Yo(e) && (e = e.parentElement); e && !Yo(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Am = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let an = 0, Kn;
function Pm(e = {}) {
  let { isDisabled: t } = e;
  Nm(() => {
    if (!t)
      return an++, an === 1 && zs() && (Kn = Mm()), () => {
        an--, an === 0 && (Kn == null || Kn());
      };
  }, [
    t
  ]);
}
function Mm() {
  let e, t = 0, n = (d) => {
    e = Hs(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let m = d.changedTouches[0].pageY, v = e.scrollTop, b = e.scrollHeight - e.clientHeight;
    b !== 0 && ((v <= 0 && m > t || v >= b && m < t) && d.preventDefault(), t = m);
  }, o = (d) => {
    let m = d.target;
    dr(m) && m !== document.activeElement && (d.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, a = (d) => {
    let m = d.target;
    dr(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", Hn && (Hn.height < window.innerHeight ? requestAnimationFrame(() => {
        Xo(m);
      }) : Hn.addEventListener("resize", () => Xo(m), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, i = window.pageXOffset, u = window.pageYOffset, l = Go(Dm(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let f = Go(At(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), At(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), At(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), At(document, "focus", a, !0), At(window, "scroll", s));
  return () => {
    l(), f(), window.scrollTo(i, u);
  };
}
function Dm(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function At(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Xo(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = Hs(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + Tm;
      a > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function dr(e) {
  return e instanceof HTMLInputElement && !Am.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Im(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Om(...e) {
  return (t) => e.forEach((n) => Im(n, t));
}
function Ks(...e) {
  return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(Om(...e), e);
}
const js = /* @__PURE__ */ new WeakMap();
function te(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let r = {};
  Object.entries(t).forEach(([o, a]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, a);
      return;
    }
    r[o] = e.style[o], e.style[o] = a;
  }), !n && js.set(e, r);
}
function _m(e, t) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let n = js.get(e);
  n && (e.style[t] = n[t]);
}
const ee = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function sn(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[ee(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[ee(t) ? 5 : 4]) : null);
}
function km(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function jn(e, t) {
  if (!e)
    return () => {
    };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Lm(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Q = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Gs = 0.4, $m = 0.25, Fm = 100, Ys = 8, et = 16, fr = 26, Gn = "vaul-dragging";
function Xs(e) {
  const t = react__WEBPACK_IMPORTED_MODULE_1__.useRef(e);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    t.current = e;
  }), react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Bm({ defaultProp: e, onChange: t }) {
  const n = react__WEBPACK_IMPORTED_MODULE_1__.useState(e), [r] = n, o = react__WEBPACK_IMPORTED_MODULE_1__.useRef(r), a = Xs(t);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function qs({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Bm({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, s = a ? e : r, i = Xs(n), u = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((l) => {
    if (a) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && i(d);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    i
  ]);
  return [
    s,
    u
  ];
}
function Wm({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: a, onSnapPointChange: s, direction: i = "bottom", container: u, snapToSequentialPoint: l }) {
  const [f, d] = qs({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [m, v] = react__WEBPACK_IMPORTED_MODULE_1__.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    function C() {
      v({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", C), () => window.removeEventListener("resize", C);
  }, []);
  const b = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => f === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    f
  ]), h = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    var C;
    return (C = n == null ? void 0 : n.findIndex((T) => T === f)) != null ? C : null;
  }, [
    n,
    f
  ]), g = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === f || !n, y = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    const C = u ? {
      width: u.getBoundingClientRect().width,
      height: u.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var T;
    return (T = n == null ? void 0 : n.map((M) => {
      const O = typeof M == "string";
      let $ = 0;
      if (O && ($ = parseInt(M, 10)), ee(i)) {
        const A = O ? $ : m ? M * C.height : 0;
        return m ? i === "bottom" ? C.height - A : -C.height + A : A;
      }
      const D = O ? $ : m ? M * C.width : 0;
      return m ? i === "right" ? C.width - D : -C.width + D : D;
    })) != null ? T : [];
  }, [
    n,
    m,
    u
  ]), E = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => h !== null ? y == null ? void 0 : y[h] : null, [
    y,
    h
  ]), x = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((C) => {
    var T;
    const M = (T = y == null ? void 0 : y.findIndex((O) => O === C)) != null ? T : null;
    s(M), te(r.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(i) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)`
    }), y && M !== y.length - 1 && a !== void 0 && M !== a && M < a ? te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "0"
    }) : te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(M, 0)]);
  }, [
    r.current,
    n,
    y,
    a,
    o,
    d
  ]);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (f || e) {
      var C;
      const T = (C = n == null ? void 0 : n.findIndex((M) => M === e || M === f)) != null ? C : -1;
      y && T !== -1 && typeof y[T] == "number" && x(y[T]);
    }
  }, [
    f,
    e,
    n,
    y,
    x
  ]);
  function w({ draggedDistance: C, closeDrawer: T, velocity: M, dismissible: O }) {
    if (a === void 0)
      return;
    const $ = i === "bottom" || i === "right" ? (E ?? 0) - C : (E ?? 0) + C, D = h === a - 1, A = h === 0, P = C > 0;
    if (D && te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`
    }), !l && M > 2 && !P) {
      O ? T() : x(y[0]);
      return;
    }
    if (!l && M > 2 && P && y && n) {
      x(y[n.length - 1]);
      return;
    }
    const B = y == null ? void 0 : y.reduce((V, _) => typeof V != "number" || typeof _ != "number" ? V : Math.abs(_ - $) < Math.abs(V - $) ? _ : V), k = ee(i) ? window.innerHeight : window.innerWidth;
    if (M > Gs && Math.abs(C) < k * 0.4) {
      const V = P ? 1 : -1;
      if (V > 0 && b && n) {
        x(y[n.length - 1]);
        return;
      }
      if (A && V < 0 && O && T(), h === null)
        return;
      x(y[h + V]);
      return;
    }
    x(B);
  }
  function S({ draggedDistance: C }) {
    if (E === null)
      return;
    const T = i === "bottom" || i === "right" ? E - C : E + C;
    (i === "bottom" || i === "right") && T < y[y.length - 1] || (i === "top" || i === "left") && T > y[y.length - 1] || te(r.current, {
      transform: ee(i) ? `translate3d(0, ${T}px, 0)` : `translate3d(${T}px, 0, 0)`
    });
  }
  function R(C, T) {
    if (!n || typeof h != "number" || !y || a === void 0)
      return null;
    const M = h === a - 1;
    if (h >= a && T)
      return 0;
    if (M && !T)
      return 1;
    if (!g && !M)
      return null;
    const $ = M ? h + 1 : h - 1, D = M ? y[$] - y[$ - 1] : y[$ + 1] - y[$], A = C / Math.abs(D);
    return M ? 1 - A : A;
  }
  return {
    isLastSnapPoint: b,
    activeSnapPoint: f,
    shouldFade: g,
    getPercentageDragged: R,
    setActiveSnapPoint: d,
    activeSnapPointIndex: h,
    onRelease: w,
    onDrag: S,
    snapPointsOffset: y
  };
}
const Vm = () => () => {
};
function Um() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = xt(), a = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => document.body.style.backgroundColor, []);
  function i() {
    return (window.innerWidth - fr) / window.innerWidth;
  }
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (t && n) {
      a.current && clearTimeout(a.current);
      const u = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!u)
        return;
      Lm(r && !o ? jn(document.body, {
        background: "black"
      }) : Vm, jn(u, {
        transformOrigin: ee(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Q.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Q.EASE.join(",")})`
      }));
      const l = jn(u, {
        borderRadius: `${Ys}px`,
        overflow: "hidden",
        ...ee(e) ? {
          transform: `scale(${i()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${i()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        l(), a.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, Q.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let Pt = null;
function zm({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: a }) {
  const [s, i] = react__WEBPACK_IMPORTED_MODULE_1__.useState(() => typeof window < "u" ? window.location.href : ""), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), l = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
    if (jo() && Pt === null && e && !a) {
      Pt = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-u.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const v = m - window.innerHeight;
        v && u.current >= m && (document.body.style.top = `${-(u.current + v)}px`);
      }), 300);
    }
  }, [
    e
  ]), f = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
    if (jo() && Pt !== null && !a) {
      const d = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Pt), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          i(window.location.href);
          return;
        }
        window.scrollTo(m, d);
      }), Pt = null;
    }
  }, [
    s
  ]);
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    function d() {
      u.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || f();
      };
  }, [
    t,
    f
  ]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && l(), t || window.setTimeout(() => {
      f();
    }, 500)) : f());
  }, [
    e,
    r,
    s,
    t,
    n,
    l,
    f
  ]), {
    restorePositionSetting: f
  };
}
function Zs({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: a, shouldScaleBackground: s = !1, setBackgroundColorOnScale: i = !0, closeThreshold: u = $m, scrollLockTimeout: l = Fm, dismissible: f = !0, handleOnly: d = !1, fadeFromIndex: m = a && a.length - 1, activeSnapPoint: v, setActiveSnapPoint: b, fixed: h, modal: g = !0, onClose: y, nested: E, noBodyStyles: x = !1, direction: w = "bottom", defaultOpen: S = !1, disablePreventScroll: R = !0, snapToSequentialPoint: C = !1, preventScrollRestoration: T = !1, repositionInputs: M = !0, onAnimationEnd: O, container: $, autoFocus: D = !1 }) {
  var A, P;
  const [B = !1, k] = qs({
    defaultProp: S,
    prop: e,
    onChange: (W) => {
      t == null || t(W), !W && !E && Pc(), setTimeout(() => {
        O == null || O(W);
      }, Q.DURATION * 1e3), W && !g && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), W || (document.body.style.pointerEvents = "auto");
    }
  }), [V, _] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [I, K] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [G, ae] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), ie = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), fe = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), Fe = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), ge = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), le = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), ve = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), se = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), Ie = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), Oe = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), Et = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!S), Be = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), z = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), Xt = react__WEBPACK_IMPORTED_MODULE_1__.useRef(((A = z.current) == null ? void 0 : A.getBoundingClientRect().height) || 0), qt = react__WEBPACK_IMPORTED_MODULE_1__.useRef(((P = z.current) == null ? void 0 : P.getBoundingClientRect().width) || 0), Ct = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), Mn = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((W) => {
    a && W === St.length - 1 && (fe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: st, activeSnapPointIndex: ct, setActiveSnapPoint: so, onRelease: Tc, snapPointsOffset: St, onDrag: Nc, shouldFade: co, getPercentageDragged: Ac } = Wm({
    snapPoints: a,
    activeSnapPointProp: v,
    setActiveSnapPointProp: b,
    drawerRef: z,
    fadeFromIndex: m,
    overlayRef: ie,
    onSnapPointChange: Mn,
    direction: w,
    container: $,
    snapToSequentialPoint: C
  });
  Pm({
    isDisabled: !B || I || !g || G || !V || !M || !R
  });
  const { restorePositionSetting: Pc } = zm({
    isOpen: B,
    modal: g,
    nested: E ?? !1,
    hasBeenOpened: V,
    preventScrollRestoration: T,
    noBodyStyles: x
  });
  function Zt() {
    return (window.innerWidth - fr) / window.innerWidth;
  }
  function Mc(W) {
    var Y, X;
    !f && !a || z.current && !z.current.contains(W.target) || (Xt.current = ((Y = z.current) == null ? void 0 : Y.getBoundingClientRect().height) || 0, qt.current = ((X = z.current) == null ? void 0 : X.getBoundingClientRect().width) || 0, K(!0), Fe.current = /* @__PURE__ */ new Date(), zs() && window.addEventListener("touchend", () => ve.current = !1, {
      once: !0
    }), W.target.setPointerCapture(W.pointerId), Ie.current = ee(w) ? W.pageY : W.pageX);
  }
  function lo(W, Y) {
    var X;
    let j = W;
    const J = (X = window.getSelection()) == null ? void 0 : X.toString(), de = z.current ? sn(z.current, w) : null, ue = /* @__PURE__ */ new Date();
    if (j.tagName === "SELECT" || j.hasAttribute("data-vaul-no-drag") || j.closest("[data-vaul-no-drag]"))
      return !1;
    if (w === "right" || w === "left")
      return !0;
    if (fe.current && ue.getTime() - fe.current.getTime() < 500)
      return !1;
    if (de !== null && (w === "bottom" ? de > 0 : de < 0))
      return !0;
    if (J && J.length > 0)
      return !1;
    if (le.current && ue.getTime() - le.current.getTime() < l && de === 0 || Y)
      return le.current = ue, !1;
    for (; j; ) {
      if (j.scrollHeight > j.clientHeight) {
        if (j.scrollTop !== 0)
          return le.current = /* @__PURE__ */ new Date(), !1;
        if (j.getAttribute("role") === "dialog")
          return !0;
      }
      j = j.parentNode;
    }
    return !0;
  }
  function Dc(W) {
    if (z.current && I) {
      const Y = w === "bottom" || w === "right" ? 1 : -1, X = (Ie.current - (ee(w) ? W.pageY : W.pageX)) * Y, j = X > 0, J = a && !f && !j;
      if (J && ct === 0)
        return;
      const de = Math.abs(X), ue = document.querySelector("[data-vaul-drawer-wrapper]"), We = w === "bottom" || w === "top" ? Xt.current : qt.current;
      let ye = de / We;
      const Je = Ac(de, j);
      if (Je !== null && (ye = Je), J && ye >= 1 || !ve.current && !lo(W.target, j))
        return;
      if (z.current.classList.add(Gn), ve.current = !0, te(z.current, {
        transition: "none"
      }), te(ie.current, {
        transition: "none"
      }), a && Nc({
        draggedDistance: X
      }), j && !a) {
        const Se = km(X), Qt = Math.min(Se * -1, 0) * Y;
        te(z.current, {
          transform: ee(w) ? `translate3d(0, ${Qt}px, 0)` : `translate3d(${Qt}px, 0, 0)`
        });
        return;
      }
      const Ve = 1 - ye;
      if ((co || m && ct === m - 1) && (r == null || r(W, ye), te(ie.current, {
        opacity: `${Ve}`,
        transition: "none"
      }, !0)), ue && ie.current && s) {
        const Se = Math.min(Zt() + ye * (1 - Zt()), 1), Qt = 8 - ye * 8, fo = Math.max(0, 14 - ye * 14);
        te(ue, {
          borderRadius: `${Qt}px`,
          transform: ee(w) ? `scale(${Se}) translate3d(0, ${fo}px, 0)` : `scale(${Se}) translate3d(${fo}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const Se = de * Y;
        te(z.current, {
          transform: ee(w) ? `translate3d(0, ${Se}px, 0)` : `translate3d(${Se}px, 0, 0)`
        });
      }
    }
  }
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    window.requestAnimationFrame(() => {
      Et.current = !0;
    });
  }, []), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    var W;
    function Y() {
      if (!z.current || !M)
        return;
      const X = document.activeElement;
      if (dr(X) || Oe.current) {
        var j;
        const J = ((j = window.visualViewport) == null ? void 0 : j.height) || 0, de = window.innerHeight;
        let ue = de - J;
        const We = z.current.getBoundingClientRect().height || 0, ye = We > de * 0.8;
        Ct.current || (Ct.current = We);
        const Je = z.current.getBoundingClientRect().top;
        if (Math.abs(Be.current - ue) > 60 && (Oe.current = !Oe.current), a && a.length > 0 && St && ct) {
          const Ve = St[ct] || 0;
          ue += Ve;
        }
        if (Be.current = ue, We > J || Oe.current) {
          const Ve = z.current.getBoundingClientRect().height;
          let Se = Ve;
          Ve > J && (Se = J - (ye ? Je : fr)), h ? z.current.style.height = `${Ve - Math.max(ue, 0)}px` : z.current.style.height = `${Math.max(Se, J - Je)}px`;
        } else
          Em() || (z.current.style.height = `${Ct.current}px`);
        a && a.length > 0 && !Oe.current ? z.current.style.bottom = "0px" : z.current.style.bottom = `${Math.max(ue, 0)}px`;
      }
    }
    return (W = window.visualViewport) == null || W.addEventListener("resize", Y), () => {
      var X;
      return (X = window.visualViewport) == null ? void 0 : X.removeEventListener("resize", Y);
    };
  }, [
    ct,
    a,
    St
  ]);
  function Rt(W) {
    Ic(), y == null || y(), W || k(!1), setTimeout(() => {
      a && so(a[0]);
    }, Q.DURATION * 1e3);
  }
  function uo() {
    if (!z.current)
      return;
    const W = document.querySelector("[data-vaul-drawer-wrapper]"), Y = sn(z.current, w);
    te(z.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`
    }), te(ie.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "1"
    }), s && Y && Y > 0 && B && te(W, {
      borderRadius: `${Ys}px`,
      overflow: "hidden",
      ...ee(w) ? {
        transform: `scale(${Zt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Zt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Q.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Q.EASE.join(",")})`
    }, !0);
  }
  function Ic() {
    !I || !z.current || (z.current.classList.remove(Gn), ve.current = !1, K(!1), ge.current = /* @__PURE__ */ new Date());
  }
  function Oc(W) {
    if (!I || !z.current)
      return;
    z.current.classList.remove(Gn), ve.current = !1, K(!1), ge.current = /* @__PURE__ */ new Date();
    const Y = sn(z.current, w);
    if (!W || !lo(W.target, !1) || !Y || Number.isNaN(Y) || Fe.current === null)
      return;
    const X = ge.current.getTime() - Fe.current.getTime(), j = Ie.current - (ee(w) ? W.pageY : W.pageX), J = Math.abs(j) / X;
    if (J > 0.05 && (ae(!0), setTimeout(() => {
      ae(!1);
    }, 200)), a) {
      Tc({
        draggedDistance: j * (w === "bottom" || w === "right" ? 1 : -1),
        closeDrawer: Rt,
        velocity: J,
        dismissible: f
      }), o == null || o(W, !0);
      return;
    }
    if (w === "bottom" || w === "right" ? j > 0 : j < 0) {
      uo(), o == null || o(W, !0);
      return;
    }
    if (J > Gs) {
      Rt(), o == null || o(W, !1);
      return;
    }
    var de;
    const ue = Math.min((de = z.current.getBoundingClientRect().height) != null ? de : 0, window.innerHeight);
    var We;
    const ye = Math.min((We = z.current.getBoundingClientRect().width) != null ? We : 0, window.innerWidth), Je = w === "left" || w === "right";
    if (Math.abs(Y) >= (Je ? ye : ue) * u) {
      Rt(), o == null || o(W, !1);
      return;
    }
    o == null || o(W, !0), uo();
  }
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (B && (te(document.documentElement, {
    scrollBehavior: "auto"
  }), fe.current = /* @__PURE__ */ new Date()), () => {
    _m(document.documentElement, "scrollBehavior");
  }), [
    B
  ]);
  function _c(W) {
    const Y = W ? (window.innerWidth - et) / window.innerWidth : 1, X = W ? -et : 0;
    se.current && window.clearTimeout(se.current), te(z.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(w) ? `scale(${Y}) translate3d(0, ${X}px, 0)` : `scale(${Y}) translate3d(${X}px, 0, 0)`
    }), !W && z.current && (se.current = setTimeout(() => {
      const j = sn(z.current, w);
      te(z.current, {
        transition: "none",
        transform: ee(w) ? `translate3d(0, ${j}px, 0)` : `translate3d(${j}px, 0, 0)`
      });
    }, 500));
  }
  function kc(W, Y) {
    if (Y < 0)
      return;
    const X = (window.innerWidth - et) / window.innerWidth, j = X + Y * (1 - X), J = -et + Y * et;
    te(z.current, {
      transform: ee(w) ? `scale(${j}) translate3d(0, ${J}px, 0)` : `scale(${j}) translate3d(${J}px, 0, 0)`,
      transition: "none"
    });
  }
  function Lc(W, Y) {
    const X = ee(w) ? window.innerHeight : window.innerWidth, j = Y ? (X - et) / X : 1, J = Y ? -et : 0;
    Y && te(z.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(w) ? `scale(${j}) translate3d(0, ${J}px, 0)` : `scale(${j}) translate3d(${J}px, 0, 0)`
    });
  }
  return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    g || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    g
  ]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Ls, {
    defaultOpen: S,
    onOpenChange: (W) => {
      !f && !W || (W ? _(!0) : Rt(!0), k(W));
    },
    open: B
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Us.Provider, {
    value: {
      activeSnapPoint: st,
      snapPoints: a,
      setActiveSnapPoint: so,
      drawerRef: z,
      overlayRef: ie,
      onOpenChange: t,
      onPress: Mc,
      onRelease: Oc,
      onDrag: Dc,
      dismissible: f,
      shouldAnimate: Et,
      handleOnly: d,
      isOpen: B,
      isDragging: I,
      shouldFade: co,
      closeDrawer: Rt,
      onNestedDrag: kc,
      onNestedOpenChange: _c,
      onNestedRelease: Lc,
      keyboardIsOpen: Oe,
      modal: g,
      snapPointsOffset: St,
      activeSnapPointIndex: ct,
      direction: w,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: i,
      noBodyStyles: x,
      container: $,
      autoFocus: D
    }
  }, n));
}
const Qs = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: a, isOpen: s, modal: i, shouldAnimate: u } = xt(), l = Ks(t, n), f = r && r.length > 0;
  if (!i)
    return null;
  const d = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((m) => o(m), [
    o
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Fs, {
    onMouseUp: d,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && f ? "true" : "false",
    "data-vaul-snap-points-overlay": s && a ? "true" : "false",
    "data-vaul-animate": u != null && u.current ? "true" : "false",
    ...e
  });
});
Qs.displayName = "Drawer.Overlay";
const Js = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: a, onPress: s, onRelease: i, onDrag: u, keyboardIsOpen: l, snapPointsOffset: f, activeSnapPointIndex: d, modal: m, isOpen: v, direction: b, snapPoints: h, container: g, handleOnly: y, shouldAnimate: E, autoFocus: x } = xt(), [w, S] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), R = Ks(o, a), C = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), T = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), M = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), O = h && h.length > 0;
  Um();
  const $ = (A, P, B = 0) => {
    if (M.current)
      return !0;
    const k = Math.abs(A.y), V = Math.abs(A.x), _ = V > k, I = [
      "bottom",
      "right"
    ].includes(P) ? 1 : -1;
    if (P === "left" || P === "right") {
      if (!(A.x * I < 0) && V >= 0 && V <= B)
        return _;
    } else if (!(A.y * I < 0) && k >= 0 && k <= B)
      return !_;
    return M.current = !0, !0;
  };
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    O && window.requestAnimationFrame(() => {
      S(!0);
    });
  }, []);
  function D(A) {
    C.current = null, M.current = !1, i(A);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Bs, {
    "data-vaul-drawer-direction": b,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": w ? "true" : "false",
    "data-vaul-snap-points": v && O ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    "data-vaul-animate": E != null && E.current ? "true" : "false",
    ...r,
    ref: R,
    style: f && f.length > 0 ? {
      "--snap-point-height": `${f[d ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (A) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, A), C.current = {
        x: A.pageX,
        y: A.pageY
      }, s(A));
    },
    onOpenAutoFocus: (A) => {
      n == null || n(A), x || A.preventDefault();
    },
    onPointerDownOutside: (A) => {
      if (e == null || e(A), !m || A.defaultPrevented) {
        A.preventDefault();
        return;
      }
      l.current && (l.current = !1);
    },
    onFocusOutside: (A) => {
      if (!m) {
        A.preventDefault();
        return;
      }
    },
    onPointerMove: (A) => {
      if (T.current = A, y || (r.onPointerMove == null || r.onPointerMove.call(r, A), !C.current))
        return;
      const P = A.pageY - C.current.y, B = A.pageX - C.current.x, k = A.pointerType === "touch" ? 10 : 2;
      $({
        x: B,
        y: P
      }, b, k) ? u(A) : (Math.abs(B) > k || Math.abs(P) > k) && (C.current = null);
    },
    onPointerUp: (A) => {
      r.onPointerUp == null || r.onPointerUp.call(r, A), C.current = null, M.current = !1, i(A);
    },
    onPointerOut: (A) => {
      r.onPointerOut == null || r.onPointerOut.call(r, A), D(T.current);
    },
    onContextMenu: (A) => {
      r.onContextMenu == null || r.onContextMenu.call(r, A), T.current && D(T.current);
    }
  });
});
Js.displayName = "Drawer.Content";
const Hm = 250, Km = 120, ec = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: a, snapPoints: s, activeSnapPoint: i, setActiveSnapPoint: u, dismissible: l, handleOnly: f, isOpen: d, onPress: m, onDrag: v } = xt(), b = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), h = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
  function g() {
    if (h.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      y();
    }, Km);
  }
  function y() {
    if (a || e || h.current) {
      x();
      return;
    }
    if (x(), !s || s.length === 0) {
      l || o();
      return;
    }
    if (i === s[s.length - 1] && l) {
      o();
      return;
    }
    const S = s.findIndex((C) => C === i);
    if (S === -1)
      return;
    const R = s[S + 1];
    u(R);
  }
  function E() {
    b.current = window.setTimeout(() => {
      h.current = !0;
    }, Hm);
  }
  function x() {
    b.current && window.clearTimeout(b.current), h.current = !1;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    onClick: g,
    onPointerCancel: x,
    onPointerDown: (w) => {
      f && m(w), E();
    },
    onPointerMove: (w) => {
      f && v(w);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
ec.displayName = "Drawer.Handle";
function jm({ onDrag: e, onOpenChange: t, open: n, ...r }) {
  const { onNestedDrag: o, onNestedOpenChange: a, onNestedRelease: s } = xt();
  if (!o)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Zs, {
    nested: !0,
    open: n,
    onClose: () => {
      a(!1);
    },
    onDrag: (i, u) => {
      o(i, u), e == null || e(i, u);
    },
    onOpenChange: (i) => {
      i && a(i), t == null || t(i);
    },
    onRelease: s,
    ...r
  });
}
function Gm(e) {
  const t = xt(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement($s, {
    container: n,
    ...r
  });
}
const Mt = {
  Root: Zs,
  NestedRoot: jm,
  Content: Js,
  Overlay: Qs,
  Trigger: wm,
  Portal: Gm,
  Handle: ec,
  Close: bm,
  Title: Ws,
  Description: Vs
};
function Ym(e) {
  const t = e + "CollectionProvider", [n, r] = $e(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: y } = h, E = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), x = react__WEBPACK_IMPORTED_MODULE_1__.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o, { scope: g, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", u = /* @__PURE__ */ Ze(i), l = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
    (h, g) => {
      const { scope: y, children: E } = h, x = a(i, y), w = q(g, x.collectionRef);
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ref: w, children: E });
    }
  );
  l.displayName = i;
  const f = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ Ze(f), v = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
    (h, g) => {
      const { scope: y, children: E, ...x } = h, w = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), S = q(g, w), R = a(f, y);
      return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (R.itemMap.set(w, { ref: w, ...x }), () => void R.itemMap.delete(w))), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(m, { [d]: "", ref: S, children: E });
    }
  );
  v.displayName = f;
  function b(h) {
    const g = a(e + "CollectionConsumer", h);
    return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
      const E = g.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (R, C) => x.indexOf(R.ref.current) - x.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    b,
    r
  ];
}
var Xm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], it = Xm.reduce((e, t) => {
  const n = /* @__PURE__ */ Ze(`Primitive.${t}`), r = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(u, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function qm(e, t) {
  e && react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(() => e.dispatchEvent(t));
}
var Zm = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Qm = "VisuallyHidden", Zr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    it.span,
    {
      ...e,
      ref: t,
      style: { ...Zm, ...e.style }
    }
  )
);
Zr.displayName = Qm;
var Qr = "ToastProvider", [Jr, Jm, eh] = Ym("Toast"), [tc, Sg] = $e("Toast", [eh]), [th, Pn] = tc(Qr), nc = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: s
  } = e, [i, u] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), [l, f] = react__WEBPACK_IMPORTED_MODULE_1__.useState(0), d = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1), m = react__WEBPACK_IMPORTED_MODULE_1__.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Qr}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Jr.Provider, { scope: t, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    th,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: l,
      viewport: i,
      onViewportChange: u,
      onToastAdd: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => f((v) => v + 1), []),
      onToastRemove: react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => f((v) => v - 1), []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: m,
      children: s
    }
  ) });
};
nc.displayName = Qr;
var rc = "ToastViewport", nh = ["F8"], pr = "toast.viewportPause", mr = "toast.viewportResume", oc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = nh,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, s = Pn(rc, n), i = Jm(n), u = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), l = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), f = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), d = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), m = q(t, d, s.onViewportChange), v = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), b = s.toastCount > 0;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const g = (y) => {
        var x;
        r.length !== 0 && r.every((w) => y[w] || y.code === w) && ((x = d.current) == null || x.focus());
      };
      return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
    }, [r]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const g = u.current, y = d.current;
      if (b && g && y) {
        const E = () => {
          if (!s.isClosePausedRef.current) {
            const R = new CustomEvent(pr);
            y.dispatchEvent(R), s.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (s.isClosePausedRef.current) {
            const R = new CustomEvent(mr);
            y.dispatchEvent(R), s.isClosePausedRef.current = !1;
          }
        }, w = (R) => {
          !g.contains(R.relatedTarget) && x();
        }, S = () => {
          g.contains(document.activeElement) || x();
        };
        return g.addEventListener("focusin", E), g.addEventListener("focusout", w), g.addEventListener("pointermove", E), g.addEventListener("pointerleave", S), window.addEventListener("blur", E), window.addEventListener("focus", x), () => {
          g.removeEventListener("focusin", E), g.removeEventListener("focusout", w), g.removeEventListener("pointermove", E), g.removeEventListener("pointerleave", S), window.removeEventListener("blur", E), window.removeEventListener("focus", x);
        };
      }
    }, [b, s.isClosePausedRef]);
    const h = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
      ({ tabbingDirection: g }) => {
        const E = i().map((x) => {
          const w = x.ref.current, S = [w, ...hh(w)];
          return g === "forwards" ? S : S.reverse();
        });
        return (g === "forwards" ? E.reverse() : E).flat();
      },
      [i]
    );
    return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const g = d.current;
      if (g) {
        const y = (E) => {
          var S, R, C;
          const x = E.altKey || E.ctrlKey || E.metaKey;
          if (E.key === "Tab" && !x) {
            const T = document.activeElement, M = E.shiftKey;
            if (E.target === g && M) {
              (S = l.current) == null || S.focus();
              return;
            }
            const D = h({ tabbingDirection: M ? "backwards" : "forwards" }), A = D.findIndex((P) => P === T);
            Yn(D.slice(A + 1)) ? E.preventDefault() : M ? (R = l.current) == null || R.focus() : (C = f.current) == null || C.focus();
          }
        };
        return g.addEventListener("keydown", y), () => g.removeEventListener("keydown", y);
      }
    }, [i, h]), /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
      qp,
      {
        ref: u,
        role: "region",
        "aria-label": o.replace("{hotkey}", v),
        tabIndex: -1,
        style: { pointerEvents: b ? void 0 : "none" },
        children: [
          b && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            hr,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const g = h({
                  tabbingDirection: "forwards"
                });
                Yn(g);
              }
            }
          ),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Jr.Slot, { scope: n, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(it.ol, { tabIndex: -1, ...a, ref: m }) }),
          b && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            hr,
            {
              ref: f,
              onFocusFromOutsideViewport: () => {
                const g = h({
                  tabbingDirection: "backwards"
                });
                Yn(g);
              }
            }
          )
        ]
      }
    );
  }
);
oc.displayName = rc;
var ac = "ToastFocusProxy", hr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = Pn(ac, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      Zr,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var l;
          const i = s.relatedTarget;
          !((l = a.viewport) != null && l.contains(i)) && r();
        }
      }
    );
  }
);
hr.displayName = ac;
var Gt = "Toast", rh = "toast.swipeStart", oh = "toast.swipeMove", ah = "toast.swipeCancel", ih = "toast.swipeEnd", ic = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...s } = e, [i, u] = yt({
      prop: r,
      defaultProp: o ?? !0,
      onChange: a,
      caller: Gt
    });
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Me, { present: n || i, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      lh,
      {
        open: i,
        ...s,
        ref: t,
        onClose: () => u(!1),
        onPause: ne(e.onPause),
        onResume: ne(e.onResume),
        onSwipeStart: L(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: L(e.onSwipeMove, (l) => {
          const { x: f, y: d } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${f}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: L(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: L(e.onSwipeEnd, (l) => {
          const { x: f, y: d } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${f}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), u(!1);
        })
      }
    ) });
  }
);
ic.displayName = Gt;
var [sh, ch] = tc(Gt, {
  onClose() {
  }
}), lh = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: s,
      onEscapeKeyDown: i,
      onPause: u,
      onResume: l,
      onSwipeStart: f,
      onSwipeMove: d,
      onSwipeCancel: m,
      onSwipeEnd: v,
      ...b
    } = e, h = Pn(Gt, n), [g, y] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null), E = q(t, (P) => y(P)), x = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), w = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null), S = o || h.duration, R = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), C = react__WEBPACK_IMPORTED_MODULE_1__.useRef(S), T = react__WEBPACK_IMPORTED_MODULE_1__.useRef(0), { onToastAdd: M, onToastRemove: O } = h, $ = ne(() => {
      var B;
      (g == null ? void 0 : g.contains(document.activeElement)) && ((B = h.viewport) == null || B.focus()), s();
    }), D = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(
      (P) => {
        !P || P === 1 / 0 || (window.clearTimeout(T.current), R.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout($, P));
      },
      [$]
    );
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      const P = h.viewport;
      if (P) {
        const B = () => {
          D(C.current), l == null || l();
        }, k = () => {
          const V = (/* @__PURE__ */ new Date()).getTime() - R.current;
          C.current = C.current - V, window.clearTimeout(T.current), u == null || u();
        };
        return P.addEventListener(pr, k), P.addEventListener(mr, B), () => {
          P.removeEventListener(pr, k), P.removeEventListener(mr, B);
        };
      }
    }, [h.viewport, S, u, l, D]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      a && !h.isClosePausedRef.current && D(S);
    }, [a, S, h.isClosePausedRef, D]), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (M(), () => O()), [M, O]);
    const A = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => g ? mc(g) : null, [g]);
    return h.viewport ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
      A && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        uh,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: A
        }
      ),
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sh, { scope: n, onClose: $, children: react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Jr.ItemSlot, { scope: n, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          Xp,
          {
            asChild: !0,
            onEscapeKeyDown: L(i, () => {
              h.isFocusedToastEscapeKeyDownRef.current || $(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              it.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...b,
                ref: E,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: L(e.onKeyDown, (P) => {
                  P.key === "Escape" && (i == null || i(P.nativeEvent), P.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, $()));
                }),
                onPointerDown: L(e.onPointerDown, (P) => {
                  P.button === 0 && (x.current = { x: P.clientX, y: P.clientY });
                }),
                onPointerMove: L(e.onPointerMove, (P) => {
                  if (!x.current)
                    return;
                  const B = P.clientX - x.current.x, k = P.clientY - x.current.y, V = !!w.current, _ = ["left", "right"].includes(h.swipeDirection), I = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, K = _ ? I(0, B) : 0, G = _ ? 0 : I(0, k), ae = P.pointerType === "touch" ? 10 : 2, ie = { x: K, y: G }, fe = { originalEvent: P, delta: ie };
                  V ? (w.current = ie, cn(oh, d, fe, {
                    discrete: !1
                  })) : qo(ie, h.swipeDirection, ae) ? (w.current = ie, cn(rh, f, fe, {
                    discrete: !1
                  }), P.target.setPointerCapture(P.pointerId)) : (Math.abs(B) > ae || Math.abs(k) > ae) && (x.current = null);
                }),
                onPointerUp: L(e.onPointerUp, (P) => {
                  const B = w.current, k = P.target;
                  if (k.hasPointerCapture(P.pointerId) && k.releasePointerCapture(P.pointerId), w.current = null, x.current = null, B) {
                    const V = P.currentTarget, _ = { originalEvent: P, delta: B };
                    qo(B, h.swipeDirection, h.swipeThreshold) ? cn(ih, v, _, {
                      discrete: !0
                    }) : cn(
                      ah,
                      m,
                      _,
                      {
                        discrete: !0
                      }
                    ), V.addEventListener("click", (I) => I.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), uh = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Pn(Gt, t), [a, s] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [i, u] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1);
  return ph(() => s(!0)), react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    const l = window.setTimeout(() => u(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), i ? null : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(jr, { asChild: !0, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Zr, { ...r, children: a && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, dh = "ToastTitle", sc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(it.div, { ...r, ref: t });
  }
);
sc.displayName = dh;
var fh = "ToastDescription", cc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(it.div, { ...r, ref: t });
  }
);
cc.displayName = fh;
var lc = "ToastAction", uc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pc, { altText: n, asChild: !0, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(fc, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${lc}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
uc.displayName = lc;
var dc = "ToastClose", fc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = ch(dc, n);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pc, { asChild: !0, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      it.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: L(e.onClick, o.onClose)
      }
    ) });
  }
);
fc.displayName = dc;
var pc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    it.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function mc(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), mh(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...mc(r));
    }
  }), t;
}
function cn(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? qm(o, a) : o.dispatchEvent(a);
}
var qo = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function ph(e = () => {
}) {
  const t = ne(e);
  Ae(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function mh(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function hh(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Yn(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var gh = nc, vh = oc, yh = ic, wh = sc, bh = cc, xh = uc;
const hc = gh, eo = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(yh, { ref: t, ...e }));
eo.displayName = "PrimitiveToastRootToastRoot";
const to = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vh, { ref: t, ...e }));
to.displayName = "PrimitiveToastViewport";
const gc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(xh, { ref: t, ...e }));
gc.displayName = "PrimitiveToastAction";
const no = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(wh, { ref: t, ...e }));
no.displayName = "PrimitiveToastTitle";
const ro = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((e, t) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bh, { ref: t, ...e }));
ro.displayName = "PrimitiveToastDescription";
const vc = ({ children: e, className: t }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: F("flex items-center gap-1", t), children: [
  /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "info", size: 16, color: "#C6CACE", filled: !0 }),
  /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-13r text-gray-400", children: e })
] }), Eh = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({
    title: e,
    description: t,
    children: n,
    informationText: r,
    className: o,
    closeOnOverlayClick: a = !0,
    closeOnEscape: s = !0,
    ...i
  }, u) => {
    const { open: l, onOpenChange: f, contentId: d } = oa(), m = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null), v = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null), [b, h] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!1), g = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle(u, () => v.current, []), (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => (l ? (g.current && (clearTimeout(g.current), g.current = null), h(!0)) : b && (g.current && clearTimeout(g.current), g.current = setTimeout(() => {
      h(!1), g.current = null;
    }, 250)), () => {
      g.current && (clearTimeout(g.current), g.current = null);
    }), [l, b]), (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      if (!s || !l)
        return;
      const x = (w) => {
        w.key === "Escape" && f(!1);
      };
      return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
    }, [s, l, f]), (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      var S;
      if (!l)
        return;
      const x = document.activeElement, w = (S = v.current) == null ? void 0 : S.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      return w && w.length > 0 && w[0].focus(), () => {
        x && x.focus();
      };
    }, [l]);
    const y = (x) => {
      a && x.target === m.current && f(!1);
    };
    if (!b)
      return null;
    const E = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "div",
      {
        ref: m,
        className: F(
          "fixed inset-0 z-[350] flex items-end justify-center bg-black/50 p-4",
          l ? "animate-fade-in" : "animate-fade-out"
        ),
        onClick: y,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
          "div",
          {
            ref: v,
            id: d,
            className: F(
              "flex w-full min-w-[360px] max-w-[480px] flex-col gap-4 rounded-2xl bg-white px-3 py-6",
              l ? "animate-slide-up" : "animate-slide-down",
              o
            ),
            ...i,
            children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col gap-2 px-3", children: [
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", { className: "typography-ui-22sb text-gray-900", children: e }),
                t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", { className: "typography-ui-15r text-gray-600", children: t })
              ] }),
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex flex-col", children: n }),
              r && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "px-3", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vc, { children: r }) })
            ]
          }
        )
      }
    );
    return (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(E, document.body);
  }
);
Eh.displayName = "ActionSheetContent";
const yc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ label: e, description: t, showNew: n = !1, className: r, ...o }, a) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { ref: a, className: F("flex flex-col gap-1", r), ...o, children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-17m text-gray-600", children: e }),
      n && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex h-[18px] w-[18px] items-center justify-center rounded-full bg-red-600", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-12sb !text-white", children: "N" }) })
    ] }),
    t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-13r text-start text-gray-400", children: t })
  ] })
);
yc.displayName = "ActionSheetItemLabel";
const Ch = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ label: e, description: t, showNew: n = !1, selected: r = !1, onPress: o, className: a, onClick: s, ...i }, u) => {
    const l = (f) => {
      o == null || o(), s == null || s(f);
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
      "button",
      {
        ref: u,
        className: F(
          // 기본 스타일
          "flex flex-row items-center justify-center gap-2 rounded-lg px-3 py-4",
          "w-full transition-colors duration-200",
          // 호버/액티브 상태
          "hover:bg-gray-30 active:bg-gray-30",
          // 포커스 상태
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          a
        ),
        onClick: l,
        ...i,
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex-1", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            yc,
            {
              label: e,
              description: t,
              showNew: n,
              className: F(
                // 선택 상태에 따른 텍스트 색상 오버라이드
                r && "[&_span:first-child]:text-gray-900"
              )
            }
          ) }),
          r && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(kp, { className: "flex-shrink-0" })
        ]
      }
    );
  }
);
Ch.displayName = "ActionSheetItem";
const Zo = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Qo = ia, Yt = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Qo(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, s = Object.keys(o).map((l) => {
    const f = n == null ? void 0 : n[l], d = a == null ? void 0 : a[l];
    if (f === null)
      return null;
    const m = Zo(f) || Zo(d);
    return o[l][m];
  }), i = n && Object.entries(n).reduce((l, f) => {
    let [d, m] = f;
    return m === void 0 || (l[d] = m), l;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, f) => {
    let { class: d, className: m, ...v } = f;
    return Object.entries(v).every((b) => {
      let [h, g] = b;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...i
      }[h]) : {
        ...a,
        ...i
      }[h] === g;
    }) ? [
      ...l,
      d,
      m
    ] : l;
  }, []);
  return Qo(e, s, u, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Sh = Yt(
  "inline-flex items-center justify-center whitespace-nowrap font-pretendard transition-colors focus-visible:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      size: {
        s: "typography-ui-13m h-8 gap-1 rounded-[8px] px-2",
        m: "typography-ui-15sb h-10 gap-1 rounded-[8px] px-3",
        l: "typography-ui-17sb h-12 gap-2 rounded-[12px] px-4",
        xl: "typography-ui-17sb h-14 gap-2 rounded-[12px] px-5"
      },
      buttonColor: {
        primary: "",
        red: "",
        gray: "",
        primaryLight: ""
      },
      buttonStyle: {
        contained: "",
        outlined: ""
      }
    },
    defaultVariants: {
      size: "m",
      buttonColor: "primary",
      buttonStyle: "contained"
    },
    compoundVariants: [
      // Primary Contained
      {
        buttonColor: "primary",
        buttonStyle: "contained",
        className: "bg-primary-600 text-white hover:bg-primary-700 active:scale-[0.98] active:bg-primary-800 disabled:bg-gray-100 disabled:text-white"
      },
      // Primary Outlined
      {
        buttonColor: "primary",
        buttonStyle: "outlined",
        className: "border border-primary-500 border-solid bg-white text-primary-700 hover:bg-primary-100 active:scale-[0.98] active:bg-primary-200 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Contained
      {
        buttonColor: "gray",
        buttonStyle: "contained",
        className: "bg-gray-700 text-white hover:bg-gray-800 active:scale-[0.98] active:bg-gray-900 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Outlined
      {
        buttonColor: "gray",
        buttonStyle: "outlined",
        className: "border border-gray-100 border-solid bg-white text-gray-600 hover:bg-gray-30 active:scale-[0.98] active:bg-gray-50 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Red Contained
      {
        buttonColor: "red",
        buttonStyle: "contained",
        className: "bg-red-600 text-white hover:bg-red-700 active:scale-[0.98] active:bg-red-800 disabled:bg-gray-100 disabled:text-white"
      },
      // PrimaryLight Contained
      {
        buttonColor: "primaryLight",
        buttonStyle: "contained",
        className: "bg-primary-100 text-primary-700 hover:bg-primary-200 active:scale-[0.98] active:bg-primary-300 disabled:bg-gray-100 disabled:text-white"
      }
    ]
  }
), ht = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ className: e, size: t, buttonColor: n, buttonStyle: r, asChild: o = !1, ...a }, s) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(o ? Nr : "button", { className: F(Sh({ size: t, buttonColor: n, buttonStyle: r, className: e })), ref: s, ...a })
);
ht.displayName = "Button";
const wc = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ state: e = "enabled", autoStateChange: t = !0, containerClassName: n, className: r, disabled: o, onChange: a, value: s, ...i }, u) => {
    const l = () => o ? "disabled" : s && s.toString().trim() !== "" ? "typed" : e, [f, d] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(l()), m = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null), v = u || m;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      o ? d("disabled") : e !== f && !t && d(e);
    }, [e, o, t, f]), (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      if (!o && t) {
        const S = s && s.toString().trim() !== "";
        S && (f === "enabled" || f === "focus") ? d("typed") : !S && f === "typed" && d("enabled");
      }
    }, [s, o, t, f]);
    const b = (S) => {
      var R;
      o || (t && d(s ? "typed" : "focus"), (R = i.onFocus) == null || R.call(i, S));
    }, h = (S) => {
      var R;
      o || (t && d(s ? "typed" : "enabled"), (R = i.onBlur) == null || R.call(i, S));
    }, g = (S) => {
      o || (t && d(S.target.value ? "typing" : "focus"), a == null || a(S));
    }, y = o, x = F(
      "relative flex w-full rounded-lg px-[16px] py-[13px] min-h-[120px] max-h-[240px] overflow-y-auto",
      (() => y ? "bg-gray-40" : "bg-gray-10 border border-gray-100 border-solid")(),
      n
    ), w = F(
      "typography-ui-17m placeholder:text-gray-300 w-full p-0 resize-none bg-transparent border-none outline-none caret-primary-700",
      {
        "text-gray-200": f === "disabled",
        "placeholder:text-gray-200": f === "disabled",
        "text-gray-300": f === "enabled" || f === "focus",
        "text-gray-700": f === "typing" || f === "typed"
      },
      {
        "cursor-not-allowed": f === "disabled"
      },
      r
    );
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: x, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "relative flex w-full gap-0.5", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "textarea",
      {
        ref: v,
        className: w,
        disabled: o || f === "disabled",
        onChange: g,
        onFocus: b,
        onBlur: h,
        value: s,
        ...i
      }
    ) }) });
  }
);
wc.displayName = "AreaContainer";
function Rh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", s = 0; s < arguments.length; s++) {
        var i = arguments[s];
        i && (a = o(a, r(i)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var s = "";
      for (var i in a)
        t.call(a, i) && a[i] && (s = o(s, i));
      return s;
    }
    function o(a, s) {
      return s ? a ? a + " " + s : a + s : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(bc);
var Th = bc.exports;
const Nh = /* @__PURE__ */ Rh(Th), oo = ({
  state: e = "default",
  text: t,
  characterCount: n,
  maxLength: r = 50,
  showCharacterCounter: o = !1,
  className: a
}) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex w-full items-center justify-between", children: [
  /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    "div",
    {
      className: Nh(
        "typography-ui-13r w-full rounded-md border-none",
        {
          "text-gray-400": e === "default",
          "text-red-700": e === "error"
        },
        a
      ),
      children: t
    }
  ),
  o && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "mt-1 flex justify-end", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { className: "typography-ui-13r text-gray-500", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "text-gray-500", children: n }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { className: "text-gray-400", children: [
      "/",
      r
    ] })
  ] }) })
] }), Ah = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({
    className: e,
    helpTextArea: t,
    maxLength: n,
    showCharacterCount: r = !1,
    state: o = "enabled",
    autoStateChange: a = !0,
    containerClassName: s,
    disabled: i,
    value: u,
    onChange: l,
    ...f
  }, d) => {
    var y;
    const [m, v] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((y = f.defaultValue) == null ? void 0 : y.toString().length) || (u == null ? void 0 : u.toString().length) || 0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      u !== void 0 && v(u.toString().length);
    }, [u]);
    const b = (E) => {
      v(E.target.value.length), l == null || l(E);
    }, h = F("flex w-full flex-col gap-[8px]", s), g = i || o === "disabled" ? "default" : o === "error" ? "error" : "default";
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: h, children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        wc,
        {
          ref: d,
          className: F("min-h-[80px]", e),
          state: o,
          autoStateChange: a,
          disabled: i,
          value: u,
          onChange: b,
          maxLength: n,
          ...f
        }
      ),
      (t || r) && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        oo,
        {
          state: g,
          text: t || "",
          showCharacterCounter: r,
          characterCount: m,
          maxLength: n,
          className: "border-0 p-0"
        }
      ) })
    ] });
  }
);
Ah.displayName = "TextArea";
const tt = {
  wrapper: "relative w-full",
  inputWrapper: "flex items-center w-full h-[50px] px-4 py-[13px] rounded-[8px]",
  input: "typography-ui-17m flex-1 h-full w-full p-0 border-none bg-transparent text-gray-700 placeholder:text-gray-300 outline-none focus:outline-none disabled:cursor-not-allowed disabled:text-gray-200 caret-primary-700 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&]:appearance-none",
  clearButton: "cursor-pointer text-gray-600",
  validationIcon: "cursor-default",
  iconContainer: "flex items-center gap-[4px] pl-[8px]"
}, xc = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({
    className: e,
    value: t,
    onChange: n,
    onValueChange: r,
    showClearButton: o = !0,
    onClear: a,
    children: s,
    validationStatus: i = "none",
    defaultValue: u,
    ...l
  }, f) => {
    const d = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null), m = f || d, [v, b] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!1), h = l.type === "password", g = h && v ? "text" : l.type, y = (D) => {
      let A = D.target.value;
      l.type !== "text" && l.maxLength && A.length > l.maxLength && (A = A.slice(0, l.maxLength), D.target.value = A), r == null || r(A), n == null || n(D);
    }, E = () => {
      var D;
      r == null || r(""), n == null || n({ target: { value: "" } }), a == null || a(), (D = m.current) == null || D.focus();
    }, x = i === "error" || l["aria-invalid"] === !0, w = l.disabled, S = () => x ? "border border-red-600 border-solid bg-red-100" : w ? "bg-gray-40" : "bg-gray-10 border border-gray-100 border-solid", R = F(tt.inputWrapper, S(), e), C = () => i === "success" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "check_circle", size: 20, className: "text-green-500", filled: !0 }) : i === "error" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "error", size: 20, className: "text-red-500", filled: !0 }) : null, M = t !== void 0 ? t : u, { type: O, ...$ } = l;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: F(tt.wrapper, e), children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: R, children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          "input",
          {
            type: g || "text",
            className: tt.input,
            value: M,
            onChange: y,
            ref: m,
            "aria-invalid": x,
            ...$
          }
        ),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: tt.iconContainer, children: [
          h && M && !l.disabled && !l.readOnly && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            "div",
            {
              className: tt.clearButton,
              onClick: () => {
                var D;
                b(!v), (D = m.current) == null || D.focus();
              },
              "aria-label": v ? "비밀번호 숨기기" : "비밀번호 보기",
              children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
                Te,
                {
                  name: v ? "visibility" : "visibility_off",
                  size: 20,
                  className: "text-gray-700",
                  filled: !0
                }
              )
            }
          ),
          o && M && !l.disabled && !l.readOnly && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: tt.clearButton, onClick: E, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "cancel", size: 20, className: "text-gray-200", filled: !0 }) }),
          i !== "none" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: tt.validationIcon, children: C() })
        ] })
      ] }),
      s
    ] });
  }
);
xc.displayName = "InputContainer";
const Ph = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({
    state: e = "enabled",
    helpTextArea: t,
    type: n,
    value: r,
    onChange: o,
    onValueChange: a,
    showClearButton: s = !0,
    onClear: i,
    className: u,
    defaultValue: l,
    isValid: f,
    ...d
  }, m) => {
    const [v, b] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(r);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
      r !== v && b(r);
    }, [r]);
    const h = (w) => {
      a && (d.maxLength && w.length > d.maxLength && (w = w.slice(0, d.maxLength)), a(w), b(w));
    }, g = (w) => {
      o && (d.maxLength && w.target.value.length > d.maxLength && (w.target.value = w.target.value.slice(0, d.maxLength)), o(w), b(w.target.value));
    }, y = () => {
      b(""), a == null || a(""), i == null || i();
    }, E = r !== void 0;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        xc,
        {
          className: u,
          value: E ? r : v,
          defaultValue: E ? void 0 : l,
          onChange: o ? g : void 0,
          onValueChange: a ? h : void 0,
          showClearButton: s,
          onClear: y,
          type: n,
          disabled: e === "disabled" || d.disabled,
          "aria-invalid": e === "error",
          validationStatus: e === "error" ? "error" : f ? "success" : "none",
          ref: m,
          ...d
        }
      ),
      t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        oo,
        {
          state: e === "error" ? "error" : "default",
          text: t,
          showCharacterCounter: !1,
          className: "mt-2 border-0 p-0"
        }
      )
    ] });
  }
);
Ph.displayName = "TextInput";
const ao = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    Ul,
    {
      ref: n,
      className: F(
        "peer h-[22px] w-[22px] rounded-[4px] border-2 border-gray-100 border-solid bg-white ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "!duration-75",
        "data-[state=checked]:border-0 data-[state=checked]:bg-primary-600 data-[state=checked]:text-white",
        "data-[state=indeterminate]:border-0 data-[state=indeterminate]:bg-primary-600 data-[state=indeterminate]:text-white",
        "disabled:cursor-not-allowed",
        "disabled:data-[state=checked]:bg-gray-100 disabled:data-[state=indeterminate]:bg-gray-100",
        "disabled:data-[state=unchecked]:border-gray-100 disabled:data-[state=unchecked]:bg-gray-50",
        e
      ),
      ...t,
      checked: t.checked,
      "data-state": t.checked === "indeterminate" ? "indeterminate" : t.checked ? "checked" : "unchecked",
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        zl,
        {
          className: F("flex items-center justify-center text-current"),
          forceMount: t.checked === "indeterminate" ? !0 : void 0,
          children: t.checked === "indeterminate" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "check_indeterminate_small", size: 22 }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "check", size: 22 })
        }
      )
    }
  )
);
ao.displayName = "Checkbox";
const Mh = Yt("flex items-center", {
  variants: {
    hasDescription: {
      true: "flex-col items-start gap-2",
      false: "gap-2"
    }
  },
  defaultVariants: {
    hasDescription: !1
  }
}), Dh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({ className: e, label: t, description: n, checkboxProps: r, hasDescription: o, ...a }, s) => {
    const i = !!n, u = () => {
      if (r != null && r.onCheckedChange && r.checked !== "indeterminate") {
        const l = r.checked !== !0;
        r.onCheckedChange(l);
      }
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { ref: s, className: F(Mh({ hasDescription: i, className: e })), ...a, children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ao, { ...r }),
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-15m cursor-pointer text-gray-900", onClick: u, children: t })
      ] }),
      n && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "pl-[30px]", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "typography-ui-13r text-gray-400", children: n }) })
    ] });
  }
);
Dh.displayName = "CheckItem";
const io = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({ className: e, checked: t, disabled: n, onClick: r, ...o }, a) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    "button",
    {
      ref: a,
      type: "button",
      className: F(
        "!duration-75 relative h-[22px] w-[22px] rounded-full border-2 border-solid transition-[border-width,border-color,background-color]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        "focus:outline-none",
        t ? n ? "border-[5px] border-gray-100 bg-white" : "border-[5px] border-primary-600 bg-white ring-primary-500" : n ? "border-gray-100 bg-gray-50" : "border-gray-100 bg-white hover:border-primary-500",
        n ? "cursor-not-allowed" : "cursor-pointer",
        e
      ),
      disabled: n,
      onClick: n ? void 0 : r,
      "data-state": t ? "checked" : "unchecked",
      "aria-checked": t,
      role: "radio",
      ...o
    }
  )
);
io.displayName = "RadioButton";
const Ec = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(void 0);
function Ih({ defaultValue: e, value: t, onChange: n, name: r, children: o, className: a }, s) {
  const [i, u] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(e), l = {
    value: t !== void 0 ? t : i,
    onChange: (f) => {
      t === void 0 && u(f), n == null || n(f);
    },
    name: r
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ec.Provider, { value: l, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { ref: s, className: F("flex flex-col gap-3", a), role: "radiogroup", children: o }) });
}
const Oh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Ih);
Oh.displayName = "RadioGroup";
function _h({ value: e, children: t, className: n, disabled: r, description: o }, a) {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Ec);
  if (!s)
    throw new Error("RadioItem must be used within a RadioGroup");
  const i = s.value === e;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        io,
        {
          ref: a,
          checked: i,
          disabled: r,
          onClick: () => !r && s.onChange(e),
          name: s.name,
          value: e,
          "aria-checked": i
        }
      ),
      t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "label",
        {
          className: F(
            "typography-ui-15m cursor-pointer",
            r && "cursor-not-allowed text-gray-300",
            n
          ),
          onClick: () => !r && s.onChange(e),
          children: t
        }
      )
    ] }),
    o && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "pl-[30px]", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: F("typography-ui-13r text-gray-400", r && "text-gray-300"), children: o }) })
  ] });
}
const kh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(_h);
kh.displayName = "RadioItem";
const Rg = Mp, Lh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, helpText: t, children: n, selectedValue: r, ...o }, a) => {
  const s = r || n;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
      rs,
      {
        ref: a,
        className: F(
          "group flex h-[50px] w-full items-center justify-between gap-[4px] rounded-lg bg-gray-10 px-4 py-[13px] transition-colors",
          "typography-ui-17m text-gray-300 focus:outline-none",
          r && "text-gray-700",
          "border-[1px] border-gray-100 border-solid disabled:cursor-not-allowed disabled:bg-gray-40 disabled:text-gray-200",
          e
        ),
        ...o,
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "min-w-0 truncate", children: s }),
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", { className: "text-gray-700", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              Te,
              {
                name: "keyboard_arrow_down",
                className: "h-5 w-5 group-data-[state=closed]:block group-data-[state=open]:hidden"
              }
            ),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              Te,
              {
                name: "keyboard_arrow_up",
                className: "h-5 w-5 group-data-[state=open]:block group-data-[state=closed]:hidden"
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(oo, { state: "default", text: t, showCharacterCounter: !1, className: "border-0 p-0" })
  ] });
});
Lh.displayName = rs.displayName;
const Tg = (/* unused pure expression or super */ null && (Dp)), Ng = (/* unused pure expression or super */ null && (os)), Ag = (/* unused pure expression or super */ null && (Op)), Pg = (/* unused pure expression or super */ null && (Ip)), $h = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
  fs,
  {
    ref: o,
    className: F(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-4 py-3 text-sm outline-none focus:bg-gray-20 data-[state=open]:bg-gray-20 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Te, { name: "chevron_right", className: "ml-auto" })
    ]
  }
));
$h.displayName = fs.displayName;
const Fh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  ps,
  {
    ref: n,
    className: F(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-[--radix-dropdown-menu-content-transform-origin] overflow-hidden rounded-md border bg-white p-1 shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ...t
  }
));
Fh.displayName = ps.displayName;
const Bh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, sideOffset: t = 8, align: n = "center", side: r = "bottom", ...o }, a) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(os, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  as,
  {
    ref: a,
    sideOffset: t,
    align: n,
    side: r,
    avoidCollisions: !0,
    collisionPadding: 8,
    className: F(
      "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] w-[var(--radix-dropdown-menu-trigger-width)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-white px-0 py-2 shadow-md",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...o
  }
) }));
Bh.displayName = as.displayName;
const Wh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  ss,
  {
    ref: r,
    className: F(
      "relative flex cursor-default select-none items-center gap-2 px-4 py-3 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600 hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Wh.displayName = ss.displayName;
const Vh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, children: t, checked: n, ...r }, o) => {
  const a = n === "indeterminate";
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
    cs,
    {
      ref: o,
      className: F(
        "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        "typography-ui-17m text-gray-600",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(us, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          ao,
          {
            className: "h-[18px] w-[18px]",
            checked: a ? "indeterminate" : !0,
            onClick: (s) => {
              s.preventDefault(), s.stopPropagation();
            }
          }
        ) }) }),
        t
      ]
    }
  );
});
Vh.displayName = cs.displayName;
const Uh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
  ls,
  {
    ref: r,
    className: F(
      "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "typography-ui-17m text-gray-600",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(us, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        io,
        {
          checked: !0,
          className: "h-[18px] w-[18px]",
          onClick: (o) => {
            o.preventDefault(), o.stopPropagation();
          }
        }
      ) }) }),
      t
    ]
  }
));
Uh.displayName = ls.displayName;
const zh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  is,
  {
    ref: r,
    className: F("typography-ui-17sb px-4 py-3 text-gray-700", t && "pl-8", e),
    ...n
  }
));
zh.displayName = is.displayName;
const Hh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ds, { ref: n, className: F("-mx-1 my-1 h-px bg-gray-100", e), ...t }));
Hh.displayName = ds.displayName;
const Kh = ({ className: e, ...t }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { className: F("ml-auto text-gray-400 text-xs tracking-widest", e), ...t });
Kh.displayName = "DropdownMenuShortcut";
const jh = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  ({ className: e, checked: t, defaultChecked: n, disabled: r, onChange: o, ...a }, s) => {
    const [i, u] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(n || !1), l = t !== void 0, f = l ? t : i, d = () => {
      r || (l || u(!i), o == null || o(!f));
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      "div",
      {
        ref: s,
        className: F(
          "relative h-[22px] w-[36px] rounded-[24px] p-[3px] transition-colors",
          f ? "bg-primary-600" : "bg-gray-100",
          r && "opacity-50",
          "cursor-pointer",
          e
        ),
        role: "switch",
        "aria-checked": f,
        tabIndex: r ? -1 : 0,
        onClick: d,
        onKeyDown: (m) => {
          (m.key === "Enter" || m.key === " ") && (m.preventDefault(), d());
        },
        ...a,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          "div",
          {
            className: F(
              "h-[16px] w-[16px] rounded-full bg-white shadow-[0px_1px_2px_0px_rgba(0,0,0,0.04)] transition-transform",
              f ? "translate-x-[14px]" : "translate-x-0"
            )
          }
        )
      }
    );
  }
);
jh.displayName = "Toggle";
const Mg = ({
  type: e,
  showInformationText: t = !1,
  title: n,
  description: r,
  informationText: o = "Information Text",
  children: a,
  buttons: s,
  open: i,
  onOpenChange: u,
  className: l
}) => {
  const f = () => {
    if (!s)
      return null;
    if (e === "single") {
      const d = s[0];
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        ht,
        {
          size: "xl",
          buttonColor: d.variant === "primary" ? "primary" : "gray",
          buttonStyle: d.variant === "primary" ? "contained" : "outlined",
          onClick: d.onClick,
          disabled: d.disabled ?? !1,
          className: "w-full",
          children: d.label
        }
      );
    }
    return e === "horizontal" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex gap-[12px]", children: s.map((d, m) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      ht,
      {
        size: "xl",
        buttonColor: d.variant === "primary" ? "primary" : "gray",
        buttonStyle: d.variant === "primary" ? "contained" : "outlined",
        onClick: d.onClick,
        disabled: d.disabled ?? !1,
        className: "flex-1",
        children: d.label
      },
      m
    )) }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex flex-col gap-[12px]", children: s.map((d, m) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      ht,
      {
        size: "xl",
        buttonColor: d.variant === "primary" ? "primary" : "gray",
        buttonStyle: d.variant === "primary" ? "contained" : "outlined",
        onClick: d.onClick,
        className: "w-full",
        disabled: d.disabled ?? !1,
        children: d.label
      },
      m
    )) });
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mt.Root, { open: i, onOpenChange: u, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Mt.Portal, { children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mt.Overlay, { className: "fixed inset-0 z-[9999] bg-dimmed-40" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mt.Title, {}),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
      Mt.Content,
      {
        className: F(
          "fixed right-0 bottom-0 left-0 z-[9999] mx-auto",
          "rounded-t-2xl bg-white",
          "flex flex-col gap-[32px]",
          "w-full min-w-[360px] max-w-[480px]",
          l
        ),
        style: { margin: "0 auto" },
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col gap-[20px] px-[20px] pt-[24px] pb-0", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col gap-[8px] px-[4px]", children: [
              /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", { className: "typography-ui-22sb whitespace-pre-line text-gray-800", children: n }),
              r && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", { className: "typography-ui-15r text-gray-600", children: r })
            ] }),
            a && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "px-[4px]", children: a }),
            t && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "px-[4px]", children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vc, { children: o }) })
          ] }),
          s && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "px-[20px] pb-[24px]", children: f() })
        ]
      }
    )
  ] }) });
}, Dg = ({
  type: e,
  title: t,
  description: n,
  children: r,
  buttons: o,
  open: a,
  className: s,
  onOpenChange: i
}) => {
  const u = () => {
    if (!o)
      return null;
    if (e === "single") {
      const l = o[0];
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        ht,
        {
          size: "xl",
          buttonColor: l.buttonColor,
          buttonStyle: l.buttonStyle,
          onClick: l.onClick || (() => i == null ? void 0 : i(!1)),
          className: "w-full",
          children: l.label
        }
      );
    }
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "flex gap-[8px]", children: o.map((l, f) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      ht,
      {
        size: "xl",
        buttonColor: l.buttonColor,
        buttonStyle: l.buttonStyle,
        onClick: l.onClick || (() => i == null ? void 0 : i(!1)),
        className: "flex-1",
        children: l.label
      },
      f
    )) });
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ls, { open: a, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)($s, { children: [
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fs, { className: "fixed inset-0 z-[9999] bg-dimmed-40" }),
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
      Bs,
      {
        className: F(
          "-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-[9999] transform",
          "rounded-[16px] bg-white shadow-[0px_8px_16px_0px_rgba(0,0,0,0.16)]",
          "flex flex-col gap-[24px] whitespace-pre-wrap p-[24px]",
          "w-full min-w-[296px] max-w-[296px]",
          s
        ),
        children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { className: "flex flex-col gap-[8px]", children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Ws, { className: "typography-ui-20sb break-words text-gray-800", children: t }),
            n && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Vs, { className: "typography-ui-15r break-words text-gray-600", children: n }),
            r && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "px-[4px]", children: r })
          ] }),
          o && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { children: u() })
        ]
      }
    )
  ] }) });
}, Gh = 1, Yh = 3e3, Cc = 300;
let Xn = 0;
const Xh = () => (Xn = (Xn + 1) % Number.MAX_SAFE_INTEGER, Xn.toString()), Sc = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null), qn = /* @__PURE__ */ new Map(), Zn = (e, t) => {
  if (qn.has(e))
    return;
  const n = setTimeout(() => {
    qn.delete(e), t({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Cc);
  qn.set(e, n);
}, qh = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Gh)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, Zh = (e, t) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((o) => {
    const a = Xh(), s = (u) => e({
      type: "UPDATE_TOAST",
      toast: { ...u, id: a }
    }), i = () => {
      e({ type: "DISMISS_TOAST", toastId: a }), Zn(a, e);
    };
    return e({
      type: "ADD_TOAST",
      toast: {
        ...o,
        id: a,
        open: !0,
        duration: o.duration ?? Yh,
        direction: o.direction ?? "top",
        onOpenChange: (u) => {
          u || i();
        }
      }
    }), {
      id: a,
      dismiss: i,
      update: s
    };
  }, []), r = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (o) => {
      e({ type: "DISMISS_TOAST", toastId: o }), o ? Zn(o, e) : t.toasts.forEach((a) => {
        Zn(a.id, e);
      });
    },
    [t.toasts]
  );
  return { toast: n, dismiss: r };
}, Qh = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Sc);
  if (!e)
    throw new Error("useToast must be used within a ToastProvider");
  return e;
}, Jh = hc, gr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(to, { ref: n, className: F("fixed z-[350] flex max-h-screen w-auto", e), ...t })
);
gr.displayName = "ToastViewport";
const eg = Yt(
  F(
    "group pointer-events-auto relative flex items-center justify-center whitespace-pre",
    "rounded-[8px] border bg-white px-[20px] py-[13px] shadow-lg",
    "sm:gap-3 sm:rounded-[8px] sm:px-[20px] sm:py-[13px]",
    "w-max max-w-[320px]",
    // 기본 transition 설정
    "transition-all duration-300 ease-out"
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 px-[20px] py-[13px] text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), vr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ className: e, variant: t, direction: n, style: r, open: o, duration: a = 3e3, ...s }, i) => {
    const [u, l] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState(o);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
      if (o) {
        d(!0);
        const v = setTimeout(() => l(!0), 10);
        return () => clearTimeout(v);
      } else {
        l(!1);
        const v = setTimeout(() => {
          d(!1);
        }, Cc);
        return () => clearTimeout(v);
      }
    }, [o]);
    const m = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
      transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
      transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
      opacity: u ? 1 : 0,
      ...r
    }), [u, n, r]);
    return f ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      eo,
      {
        ref: i,
        className: F(eg({ variant: t, direction: n }), e),
        style: m,
        open: !0,
        duration: a,
        forceMount: !0,
        "data-direction": n,
        ...s
      }
    ) : null;
  }
);
vr.displayName = "ToastRoot";
const tg = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  gc,
  {
    ref: n,
    className: F(
      "inline-flex h-7 shrink-0 items-center justify-center rounded-[8px]",
      "border border-gray-200 bg-transparent px-2",
      "transition-colors hover:bg-gray-50",
      "focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2",
      "disabled:pointer-events-none disabled:opacity-50",
      "sm:h-8 sm:rounded-[8px] sm:px-3 ",
      e
    ),
    ...t
  }
));
tg.displayName = "ToastAction";
const ng = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(no, { ref: n, className: F("leading-none tracking-tight", e), ...t }));
ng.displayName = "ToastTitle";
const yr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  ro,
  {
    ref: n,
    className: F("typography-ui-15r text-center leading-relaxed", e),
    ...t
  }
));
yr.displayName = "ToastDescription";
const rg = ({ children: e }) => {
  const [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(qh, { toasts: [] }), { toast: r, dismiss: o } = Zh(n, t), a = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(
    () => ({
      toasts: t.toasts,
      toast: r,
      dismiss: o
    }),
    [t.toasts, r, o]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Sc.Provider, { value: a, children: e });
}, og = () => {
  const { toasts: e } = Qh(), [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    n(!0);
  }, []);
  const r = e.filter((s) => s.direction === "top"), o = e.filter((s) => s.direction === "bottom");
  if (!t)
    return null;
  const a = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Jh, { children: [
    r.map(function({ id: s, text: i, ...u }) {
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vr, { ...u, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "grid gap-1", children: i && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(yr, { children: i }) }) }, s);
    }),
    r.length > 0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(gr, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    o.map(function({ id: s, text: i, ...u }) {
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(vr, { ...u, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "grid gap-1", children: i && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(yr, { children: i }) }) }, s);
    }),
    o.length > 0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(gr, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(a, document.body) : a;
}, Ig = ({ children: e }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(rg, { children: [
  e,
  /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(og, {})
] }), ag = 1, wr = 6e3, ig = 300;
let Qn = 0;
const sg = () => (Qn = (Qn + 1) % Number.MAX_SAFE_INTEGER, Qn.toString()), Rc = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null), Jn = /* @__PURE__ */ new Map(), er = (e, t) => {
  if (Jn.has(e))
    return;
  const n = setTimeout(() => {
    Jn.delete(e), t({
      type: "REMOVE_SNACKBAR",
      snackbarId: e
    });
  }, wr);
  Jn.set(e, n);
}, cg = (e, t) => {
  switch (t.type) {
    case "ADD_SNACKBAR":
      return {
        ...e,
        snackbars: [t.snackbar, ...e.snackbars].slice(0, ag)
      };
    case "UPDATE_SNACKBAR":
      return {
        ...e,
        snackbars: e.snackbars.map((n) => n.id === t.snackbar.id ? { ...n, ...t.snackbar } : n)
      };
    case "DISMISS_SNACKBAR": {
      const { snackbarId: n } = t;
      return {
        ...e,
        snackbars: e.snackbars.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_SNACKBAR":
      return t.snackbarId === void 0 ? {
        ...e,
        snackbars: []
      } : {
        ...e,
        snackbars: e.snackbars.filter((n) => n.id !== t.snackbarId)
      };
  }
}, lg = (e, t) => {
  const n = _t((o) => {
    const a = sg(), s = (l) => e({
      type: "UPDATE_SNACKBAR",
      snackbar: { ...l, id: a }
    }), i = () => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: a }), er(a, e);
    };
    e({
      type: "ADD_SNACKBAR",
      snackbar: {
        ...o,
        id: a,
        open: !0,
        duration: o.duration ?? wr,
        direction: o.direction ?? "top",
        onOpenChange: (l) => {
          l || i();
        }
      }
    });
    const u = o.duration ?? wr;
    return setTimeout(() => {
      i();
    }, u), {
      id: a,
      dismiss: i,
      update: s
    };
  }, []), r = _t(
    (o) => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: o }), o ? er(o, e) : t.snackbars.forEach((a) => {
        er(a.id, e);
      });
    },
    [t.snackbars]
  );
  return { snackbar: n, dismiss: r };
}, ug = () => {
  const e = bn(Rc);
  if (!e)
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  return e;
}, dg = (/* unused pure expression or super */ null && (hc)), br = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(to, { ref: n, className: F("fixed z-[100] flex max-h-screen w-auto", e), ...t })
);
br.displayName = "SnackbarViewport";
const fg = Yt(
  F(
    "group pointer-events-auto relative flex w-full items-center justify-center gap-2",
    "overflow-hidden rounded-[8px] border bg-white shadow-lg transition-all hover:cursor-auto",
    "min-w-[320px] max-w-full sm:gap-3 sm:rounded-[8px] "
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), xr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, variant: t, direction: n, style: r, open: o, duration: a = 3e3, ...s }, i) => {
  const [u, l] = react__WEBPACK_IMPORTED_MODULE_1__.useState(!1), [f, d] = react__WEBPACK_IMPORTED_MODULE_1__.useState(o);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (o) {
      d(!0);
      const v = setTimeout(() => l(!0), 10);
      return () => clearTimeout(v);
    } else {
      l(!1);
      const v = setTimeout(() => {
        d(!1);
      }, ig);
      return () => clearTimeout(v);
    }
  }, [o]);
  const m = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => ({
    transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
    transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
    opacity: u ? 1 : 0,
    ...r
  }), [u, n, r]);
  return f ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    eo,
    {
      ref: i,
      className: F(fg({ variant: t, direction: n }), "min-w-[320px] max-w-full justify-between", e),
      style: m,
      open: !0,
      duration: a,
      forceMount: !0,
      "data-direction": n,
      ...s
    }
  ) : null;
});
xr.displayName = "SnackbarRoot";
const Er = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ buttonText: e, buttonAction: t, onDismiss: n, ...r }, o) => {
  const a = () => {
    t(), n == null || n();
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    "button",
    {
      ref: o,
      className: F("typography-ui-15sb text-primary-700", "h-full px-[20px] py-[13px]"),
      onClick: a,
      type: "button",
      ...r,
      children: e
    }
  );
});
Er.displayName = "SnackbarAction";
const Cr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  no,
  {
    ref: n,
    className: F("typography-ui-15sb text-white", "whitespace-nowrap", e),
    ...t
  }
));
Cr.displayName = "SnackbarTitle";
const Sr = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
  ro,
  {
    ref: n,
    className: F("typography-ui-15r text-gray-200", "whitespace-nowrap", e),
    ...t
  }
));
Sr.displayName = "SnackbarDescription";
const Jo = ({ children: e }) => /* @__PURE__ */ p("div", { className: "grid py-[13px] pl-[20px]", children: e }), pg = ({ children: e }) => {
  const [t, n] = ta(cg, { snackbars: [] }), { snackbar: r, dismiss: o } = lg(n, t), a = kt(
    () => ({
      snackbars: t.snackbars,
      snackbar: r,
      dismiss: o
    }),
    [t.snackbars, r, o]
  );
  return /* @__PURE__ */ p(Rc.Provider, { value: a, children: e });
}, mg = () => {
  const { snackbars: e, dismiss: t } = ug(), [n, r] = Ee(!1);
  we(() => {
    r(!0);
  }, []);
  const o = e.filter((i) => i.direction === "top"), a = e.filter((i) => i.direction === "bottom");
  if (!n)
    return null;
  const s = /* @__PURE__ */ U(dg, { children: [
    o.map(function({ id: i, title: u, description: l, buttonAction: f, buttonText: d, ...m }) {
      return /* @__PURE__ */ U(xr, { ...m, children: [
        /* @__PURE__ */ U(Jo, { children: [
          u && /* @__PURE__ */ p(Cr, { children: u }),
          l && /* @__PURE__ */ p(Sr, { children: l })
        ] }),
        f && d && /* @__PURE__ */ p(Er, { buttonText: d, buttonAction: f, onDismiss: () => t(i) })
      ] }, i);
    }),
    o.length > 0 && /* @__PURE__ */ p(br, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    a.map(function({ id: i, title: u, description: l, buttonAction: f, buttonText: d, ...m }) {
      return /* @__PURE__ */ U(xr, { ...m, children: [
        /* @__PURE__ */ U(Jo, { children: [
          u && /* @__PURE__ */ p(Cr, { children: u }),
          l && /* @__PURE__ */ p(Sr, { children: l })
        ] }),
        f && d && /* @__PURE__ */ p(Er, { buttonText: d, buttonAction: f, onDismiss: () => t(i) })
      ] }, i);
    }),
    a.length > 0 && /* @__PURE__ */ p(br, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? Rr(s, document.body) : s;
}, Og = ({ children: e }) => /* @__PURE__ */ U(pg, { children: [
  e,
  /* @__PURE__ */ p(mg, {})
] }), hg = Yt(
  "typography-ui-15m inline-flex h-6 cursor-pointer items-center justify-center whitespace-nowrap px-0 leading-[22px] underline-offset-[2px] transition-all duration-200 focus-visible:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 ",
  {
    variants: {
      color: {
        primary: "text-primary-600 hover:text-primary-700 active:text-primary-800",
        red: "text-red-500 hover:text-red-600 active:text-red-700",
        gray: "text-gray-600 hover:text-gray-700 active:text-gray-800"
      },
      state: {
        default: "opacity-100",
        hover: "opacity-80",
        pressed: "opacity-60",
        dimmed: "opacity-40"
      }
    },
    defaultVariants: {
      color: "primary",
      state: "default"
    }
  }
), gg = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
  ({ className: e, color: t, state: n, underline: r = !0, asChild: o = !1, ...a }, s) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    o ? Nr : "button",
    {
      className: F(hg({ color: t, state: n, className: e })),
      ref: s,
      style: { textDecoration: r ? "underline" : "none" },
      ...a
    }
  )
);
gg.displayName = "TextButton";

//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 46438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var t=__webpack_require__(99313),e=__webpack_require__(95978),r=function(){function t(){}return t.isNotNullOrUndefined=function(t){return null!=t},t.isNullOrUndefined=function(t){return null==t},t.requiredNotNullOrUndefined=function(t,e){if(void 0===e&&(e=function(){return"Required value is null or undefined"}),this.isNullOrUndefined(t))throw new Error(e());return t},t.fromMap=function(t){var e={};return t.forEach((function(t,r){e[r]=t})),e},t}(),n=function(){function t(){}return t.mapNotNullOrUndefined=function(t,e){for(var n=Array(),i=0,o=t;i<o.length;i++){var s=e(o[i]);r.isNotNullOrUndefined(s)&&n.push(s)}return n},t.mapOrUndefined=function(t,e){for(var n=Array(),i=0,o=t;i<o.length;i++){var s=e(o[i]);if(r.isNullOrUndefined(s))return;n.push(s)}return n},t.associateTo=function(t,e,r){for(var n=0,i=t;n<i.length;n++){var o=r(i[n]);e.set(o[0],o[1])}return e},t.associate=function(t,e){return this.associateTo(t,new Map,e)},t.associateBy=function(t,e){return this.associate(t,(function(t){return[e(t),t]}))},t.chunked=function(t,e){for(var r=[],n=t.slice();n.length;)r.push(n.splice(0,e));return r},t}(),i={DISABLE:0,ERROR:1,WARN:2,INFO:3,DEBUG:4},o=function(){function t(){}return t.setLogLevel=function(t){void 0===t&&(t=i.INFO),this.logLevel=t},t.initCounter=function(t){this.counters=n.associate(Object.keys(i),(function(e){return[e,t(e)]}))},t._log=function(t,e){var r;switch(t){case"WARN":r="orange";break;case"ERROR":r="red";break;default:r="#AAAAAA"}if(e instanceof Error)s.log(t,r,e.message,e);else try{s.log(t,r,e)}catch(t){}},t.increment=function(e){var r,n;null===(n=null===(r=t.counters)||void 0===r?void 0:r.get(e))||void 0===n||n.increment()},t.logLevel=i.INFO,t.log={error:function(e){t.logLevel>=i.ERROR&&(t._log("ERROR",e),t.increment("ERROR"))},warn:function(e){t.logLevel>=i.WARN&&(t._log("WARN",e),t.increment("WARN"))},info:function(e){t.logLevel>=i.INFO&&(t._log("INFO",e),t.increment("INFO"))},debug:function(e){t.logLevel>=i.DEBUG&&(t._log("DEBUG",e),t.increment("DEBUG"))}},t}(),s=function(){function t(){}return t.log=function(t,e,r,n){try{console.log("%c[".concat(t,"] Hackle: ").concat(r),"color: ".concat(e))}catch(t){}},t}(),u=function(t,e){return u=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])},u(t,e)};function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function r(){this.constructor=t}u(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}var c=function(){return c=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var i in e=arguments[r])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t},c.apply(this,arguments)};function p(t,e,r,n){return new(r||(r=Promise))((function(i,o){function s(t){try{a(n.next(t))}catch(t){o(t)}}function u(t){try{a(n.throw(t))}catch(t){o(t)}}function a(t){var e;t.done?i(t.value):(e=t.value,e instanceof r?e:new r((function(t){t(e)}))).then(s,u)}a((n=n.apply(t,e||[])).next())}))}function f(t,e){var r,n,i,o,s={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:u(0),throw:u(1),return:u(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function u(o){return function(u){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;s;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,n=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(i=s.trys,(i=i.length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){s=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){s.label=o[1];break}if(6===o[0]&&s.label<i[1]){s.label=i[1],i=o;break}if(i&&s.label<i[2]){s.label=i[2],s.ops.push(o);break}i[2]&&s.ops.pop(),s.trys.pop();continue}o=e.call(t,s)}catch(t){o=[6,t],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,u])}}}function l(t,e,r){if(r||2===arguments.length)for(var n,i=0,o=e.length;i<o;i++)!n&&i in e||(n||(n=Array.prototype.slice.call(e,0,i)),n[i]=e[i]);return t.concat(n||Array.prototype.slice.call(e))}var h=o.log,d=function(){function t(){}return t.isEqual=function(t,e){return t.type===e.type&&t.value===e.value},t.isEquals=function(t,e){if(null==e)return!1;var r=Object.keys(t);return r.length===Object.keys(e).length&&r.every((function(r){return t[r]===e[r]}))},t.sanitize=function(t){var e={};if(r.isNullOrUndefined(t))return e;for(var n=0,i=Object.entries(t);n<i.length;n++){var o=i[n],s=o[0],u=o[1];if(this.isValidType(s)){var a=this.sanitizeValue(u);r.isNullOrUndefined(a)?h.debug("Invalid identifier value. The identifier type value be a string of 512 characters or less. [".concat(s,"]")):e[s]=a}else h.debug("Invalid identifier type. The identifier type must be a string of 128 characters or less. [".concat(s,"]"))}return e},t.isValidType=function(t){return!r.isNullOrUndefined(t)&&("string"==typeof t&&t.length>0&&t.length<=this.MAX_IDENTIFIER_TYPE_LENGTH)},t.sanitizeValue=function(t){return"string"==typeof t&&t.length>0&&t.length<=this.MAX_IDENTIFIER_VALUE_LENGTH?t:"number"==typeof t?t.toString():null},t.MAX_IDENTIFIER_TYPE_LENGTH=128,t.MAX_IDENTIFIER_VALUE_LENGTH=512,t}(),v=o.log,y=function(){function t(){}return t.sanitize=function(t){var e={};if(r.isNullOrUndefined(t))return e;for(var n=0,i=Object.entries(t);n<i.length;n++){var o=i[n],s=o[0],u=o[1];if(Object.keys(e).length>=this.MAX_PROPERTIES_COUNT){v.debug("The number of properties cannot exceed 128. Drops excess properties. [".concat(s,", ").concat(u,"]"));break}if(this.isValidKey(s)){var a=this.sanitizeValue(s,u);r.isNullOrUndefined(a)?v.debug("Invalid property value. The property value mus be 'string(..1024)', 'number', 'boolean', or 'array' type. [".concat(u,"]")):e[s]=a}else v.debug("Invalid property key. The property key must be a string of 128 characters or less. [".concat(s,"]"))}return e},t.isValidProperty=function(t,e){return this.isValidKey(t)&&this.isValidValue(e)},t.isValidKey=function(t){return r.isNotNullOrUndefined(t)&&"string"==typeof t&&t.length>0&&t.length<=this.MAX_PROPERTY_KEY_LENGTH},t.sanitizeValue=function(t,e){var r=this;return"string"==typeof t&&t.startsWith(this.SYSTEM_PROPERTY_KEY_PREFIX)?e:this.isValidValue(e)?Array.isArray(e)?e.filter((function(t){return r.isValidElement(t)})):e:null},t.isValidValue=function(t){return!r.isNullOrUndefined(t)&&("string"==typeof t?t.length<=this.MAX_PROPERTY_VALUE_LENGTH:"number"==typeof t?!isNaN(t)&&isFinite(t):"boolean"==typeof t||Array.isArray(t))},t.isValidElement=function(t){return!r.isNullOrUndefined(t)&&("string"==typeof t?t.length>0&&t.length<=this.MAX_PROPERTY_VALUE_LENGTH:"number"==typeof t)},t.truncateStringValue=function(t){return"string"==typeof t&&t.length>this.MAX_PROPERTY_VALUE_LENGTH?t.slice(0,this.MAX_PROPERTY_VALUE_LENGTH):t},t.SYSTEM_PROPERTY_KEY_PREFIX="$",t.MAX_PROPERTIES_COUNT=128,t.MAX_PROPERTY_KEY_LENGTH=128,t.MAX_PROPERTY_VALUE_LENGTH=1024,t}(),m=["nanoseconds","microseconds","milliseconds","seconds","minutes","hours","days"],g=function(){function t(){}return t.nanosToUnit=function(e,r){switch(r){case"nanoseconds":return e;case"microseconds":return e/(t.C1/t.C0);case"milliseconds":return e/(t.C2/t.C0);case"seconds":return e/(t.C3/t.C0);case"minutes":return e/(t.C4/t.C0);case"hours":return e/(t.C5/t.C0);case"days":return e/(t.C6/t.C0)}},t.microsToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C1/t.C0);case"milliseconds":return e/(t.C2/t.C1);case"microseconds":return e;case"seconds":return e/(t.C3/t.C1);case"minutes":return e/(t.C4/t.C1);case"hours":return e/(t.C5/t.C1);case"days":return e/(t.C6/t.C1)}},t.millisToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C2/t.C0);case"microseconds":return e*(t.C2/t.C1);case"milliseconds":return e;case"seconds":return e/(t.C3/t.C2);case"minutes":return e/(t.C4/t.C2);case"hours":return e/(t.C5/t.C2);case"days":return e/(t.C6/t.C2)}},t.secondsToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C3/t.C0);case"microseconds":return e*(t.C3/t.C1);case"milliseconds":return e*(t.C3/t.C2);case"seconds":return e;case"minutes":return e/(t.C4/t.C3);case"hours":return e/(t.C5/t.C3);case"days":return e/(t.C6/t.C3)}},t.minutesToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C4/t.C0);case"microseconds":return e*(t.C4/t.C1);case"milliseconds":return e*(t.C4/t.C2);case"seconds":return e*(t.C4/t.C3);case"minutes":return e;case"hours":return e/(t.C5/t.C4);case"days":return e/(t.C6/t.C4)}},t.hoursToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C5/t.C0);case"microseconds":return e*(t.C5/t.C1);case"milliseconds":return e*(t.C5/t.C2);case"seconds":return e*(t.C5/t.C3);case"minutes":return e*(t.C5/t.C4);case"hours":return e;case"days":return e/(t.C6/t.C5)}},t.daysToUnit=function(e,r){switch(r){case"nanoseconds":return e*(t.C6/t.C0);case"microseconds":return e*(t.C6/t.C1);case"milliseconds":return e*(t.C6/t.C2);case"seconds":return e*(t.C6/t.C3);case"minutes":return e*(t.C6/t.C4);case"hours":return e*(t.C6/t.C5);case"days":return e}},t.C0=1,t.C1=1e3*t.C0,t.C2=1e3*t.C1,t.C3=1e3*t.C2,t.C4=60*t.C3,t.C5=60*t.C4,t.C6=24*t.C5,t.converter={nanoseconds:t.nanosToUnit,microseconds:t.microsToUnit,milliseconds:t.millisToUnit,seconds:t.secondsToUnit,minutes:t.minutesToUnit,hours:t.hoursToUnit,days:t.daysToUnit},t}(),E=function(){function t(){}return t.prototype.tick=function(){return 1e3*Date.now()},t.prototype.currentMillis=function(){return Date.now()},t.instance=new t,t}(),w=function(){function t(){}return t.prototype.get=function(t,e){return e},t}(),T=function(){function t(t){this.parameters=t}return t.prototype.get=function(t,e){var n=this.parameters.get(t);return r.isNullOrUndefined(n)?e:r.isNullOrUndefined(e)||typeof n==typeof e?n:e},t}(),_=o.log;function I(t,e){var r=t.find((function(t){return t===e||t.toLowerCase()===e.toLowerCase()}));return r||_.debug("Unsupported type [".concat(e,"]. Please use the latest version of sdk.")),r}function A(t,e){if(!r.isNullOrUndefined(e)){for(var n=new Array,i=0,o=e;i<o.length;i++){var s=I(t,o[i]);if(r.isNullOrUndefined(s))return;n.push(s)}return n}}var b=function(){function t(t,e){this.value=t,this.reason=e}return t.of=function(e,r){return new t(e,r)},t}(),N=function(){function t(t,e,r){this.inAppMessage=t,this.message=e,this.reason=r}return t.prototype.isShow=function(){return r.isNotNullOrUndefined(this.inAppMessage)&&r.isNotNullOrUndefined(this.message)},t.of=function(e,r,n){return new t(r,n,e)},t}(),O=function(){function t(t,e,r){this.variation=t,this.reason=e,this.config=r}return t.of=function(e,r,n){return void 0===n&&(n=new w),new t(e,r,n)},t.prototype.get=function(t,e){return this.config.get(t,e)},t}(),R=function(){function t(t,e,r){this.isOn=t,this.reason=e,this.config=r}return t.on=function(e,r){return void 0===r&&(r=new w),new t(!0,e,r)},t.off=function(e,r){return void 0===r&&(r=new w),new t(!1,e,r)},t.prototype.get=function(t,e){return this.config.get(t,e)},t}(),x=function(){function t(){}return t.prototype.get=function(t,e){return e},t}(),M=function(){function t(t,e){this.id=t,this.config=e}return t.fromJson=function(e){return new t(e.id,new T(n.associate(e.parameters,(function(t){return[t.key,t.value]}))))},t.prototype.get=function(t,e){switch(typeof e){case"string":case"number":case"boolean":return this.config.get(t,e);default:return e}},t}(),S=function(){function t(){}return t.SDK_NOT_READY="SDK_NOT_READY",t.EXCEPTION="EXCEPTION",t.INVALID_INPUT="INVALID_INPUT",t.UNSUPPORTED_PLATFORM="UNSUPPORTED_PLATFORM",t.TYPE_MISMATCH="TYPE_MISMATCH",t.EXPERIMENT_NOT_FOUND="EXPERIMENT_NOT_FOUND",t.EXPERIMENT_DRAFT="EXPERIMENT_DRAFT",t.EXPERIMENT_PAUSED="EXPERIMENT_PAUSED",t.EXPERIMENT_COMPLETED="EXPERIMENT_COMPLETED",t.OVERRIDDEN="OVERRIDDEN",t.TRAFFIC_NOT_ALLOCATED="TRAFFIC_NOT_ALLOCATED",t.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT="NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT",t.IDENTIFIER_NOT_FOUND="IDENTIFIER_NOT_FOUND",t.VARIATION_DROPPED="VARIATION_DROPPED",t.TRAFFIC_ALLOCATED="TRAFFIC_ALLOCATED",t.TRAFFIC_ALLOCATED_BY_TARGETING="TRAFFIC_ALLOCATED_BY_TARGETING",t.NOT_IN_EXPERIMENT_TARGET="NOT_IN_EXPERIMENT_TARGET",t.FEATURE_FLAG_NOT_FOUND="FEATURE_FLAG_NOT_FOUND",t.FEATURE_FLAG_INACTIVE="FEATURE_FLAG_INACTIVE",t.INDIVIDUAL_TARGET_MATCH="INDIVIDUAL_TARGET_MATCH",t.TARGET_RULE_MATCH="TARGET_RULE_MATCH",t.DEFAULT_RULE="DEFAULT_RULE",t.REMOTE_CONFIG_PARAMETER_NOT_FOUND="REMOTE_CONFIG_PARAMETER_NOT_FOUND",t.IN_APP_MESSAGE_NOT_FOUND="IN_APP_MESSAGE_NOT_FOUND",t.IN_APP_MESSAGE_DRAFT="IN_APP_MESSAGE_DRAFT",t.IN_APP_MESSAGE_PAUSED="IN_APP_MESSAGE_PAUSED",t.IN_APP_MESSAGE_HIDDEN="IN_APP_MESSAGE_HIDDEN",t.IN_APP_MESSAGE_TARGET="IN_APP_MESSAGE_TARGET",t.NOT_IN_IN_APP_MESSAGE_PERIOD="NOT_IN_IN_APP_MESSAGE_PERIOD",t.NOT_IN_IN_APP_MESSAGE_TARGET="NOT_IN_IN_APP_MESSAGE_TARGET",t}(),C=function(){function t(t,e,r,n,i,o,s,u,a,c,p,f,l,h,d,v,y){this.id=t,this.key=e,this.type=r,this.identifierType=n,this.status=i,this.version=o,this.executionVersion=s,this.variations=u,this.userOverrides=a,this.segmentOverrides=c,this.targetAudiences=p,this.splitUrlTargets=f,this.targetRules=l,this.defaultRule=h,this.containerId=d,this.implementationType=v,this.winnerVariationId=y}return t.fromJson=function(e,r){var i=t.experimentStatusOrNull(r.execution.status),o=r.variations.map((function(t){return new U(t.id,t.key,"DROPPED"===t.status,t.parameterConfigurationId)})),s=n.associate(r.execution.userOverrides,(function(t){return[t.userId,t.variationId]})),u=n.mapNotNullOrUndefined(r.execution.segmentOverrides,(function(t){return J.fromJson(t,ct.IDENTIFIER)})),a=n.mapNotNullOrUndefined(r.execution.targetAudiences,(function(t){return G.fromJson(t,ct.PROPERTY)})),c=Gt.fromJson(r.execution.targetUrls),p=t.experimentImplementationTypeOrNull(r.implementationType),f=n.mapNotNullOrUndefined(r.execution.targetRules,(function(t){return J.fromJson(t,ct.PROPERTY)})),l=z.fromJson(r.execution.defaultRule);return i&&p&&l&&new t(r.id,r.key,e,r.identifierType,i,r.version,r.execution.version,o,s,u,a,c,f,l,r.containerId,p,r.winnerVariationId)},t.experimentStatusOrNull=function(t){switch(t){case"READY":return"DRAFT";case"RUNNING":return"RUNNING";case"PAUSED":return"PAUSED";case"STOPPED":return"COMPLETED";default:return void _.debug("Unsupported status [".concat(t,"]"))}},t.experimentImplementationTypeOrNull=function(t){switch(t){case"DEFAULT":return"DEFAULT";case"SPLIT_URL":return"SPLIT_URL";default:return void _.debug("Unsupported implementationType [".concat(t,"]"))}},t.prototype._winnerVariationOrNull=function(){if(this.winnerVariationId)return this._getVariationByIdOrNull(this.winnerVariationId)},t.prototype._getVariationByIdOrNull=function(t){return this.variations.find((function(e){return e.id===t}))},t.prototype._getVariationByKeyOrNull=function(t){return this.variations.find((function(e){return e.key===t}))},t}(),U=function(t,e,r,n){this.id=t,this.key=e,this.isDropped=r,this.parameterConfigurationId=n},P=function(){function t(t,e,r,n){this.id=t,this.seed=e,this.slotSize=r,this.slots=n}return t.fromJson=function(e){return new t(e.id,e.seed,e.slotSize,e.slots.map((function(t){var e=t.startInclusive,r=t.endExclusive,n=t.variationId;return new k(e,r,n)})))},t}(),k=function(){function t(t,e,r){this.startInclusive=t,this.endExclusive=e,this.variationId=r}return t.prototype.contains=function(t){return this.startInclusive<=t&&t<this.endExclusive},t}(),D=function(){function t(t,e){this.id=t,this.key=e}return t.fromJson=function(e){return new t(e.id,e.key)},t}(),L=function(){function t(){}return t.ID="$id",t.USER="$userId",t.DEVICE="$deviceId",t.SESSION="$sessionId",t.HACKLE_DEVICE="$hackleDeviceId",t}(),F=function(t){var e=new V;return e.addIdentifiers(t.identifiers||{}),e.add(L.ID,t.id),e.add(L.DEVICE,t.deviceId),r.isNotNullOrUndefined(t.userId)&&e.add(L.USER,t.userId),e.build()},V=function(){function t(){this.identifiers={}}return t.prototype.addIdentifiers=function(t){for(var e in t)this.add(e,t[e]);return this},t.prototype.add=function(t,e){var r=d.sanitizeValue(e);return d.isValidType(t)&&r?this.identifiers[t]=e:_.warn("Invalid user identifier [type=".concat(t,", value=").concat(e,"]")),this},t.prototype.build=function(){return this.identifiers},t}(),j=function(t){var e,r,n,i={};return i.id=null!==(e=d.sanitizeValue(t.id))&&void 0!==e?e:void 0,i.userId=null!==(r=d.sanitizeValue(t.userId))&&void 0!==r?r:void 0,i.deviceId=null!==(n=d.sanitizeValue(t.deviceId))&&void 0!==n?n:void 0,"object"==typeof t.properties&&(i.properties=y.sanitize(t.properties)),"object"==typeof t.identifiers&&(i.identifiers=d.sanitize(t.identifiers)),function(t){return Boolean(t.id||t.userId||t.deviceId||t.identifiers&&Object.keys(t.identifiers).length>0)}(i)?i:null},G=function(){function t(t){this.conditions=t}return t.fromJson=function(e,r){return new t(n.mapNotNullOrUndefined(e.conditions,(function(t){return H.fromJson(t,r)})))},t.prototype.toJson=function(){return{conditions:this.conditions.map((function(t){return t.toJson()}))}},t}(),H=function(){function t(t,e){this.key=t,this.match=e}return t.fromJson=function(e,r){var n=B.fromJson(e.key);if(n&&r.supports(n.type)){var i=K.fromJson(e.match);return i&&new t(n,i)}},t.prototype.toJson=function(){return{key:this.key.toJson(),match:this.match.toJson()}},t}(),B=function(){function t(t,e){this.type=t,this.name=e}return t.fromJson=function(e){var r=I(ut,e.type);return r&&new t(r,e.name)},t.prototype.toJson=function(){return{type:this.type,name:this.name}},t}(),K=function(){function t(t,e,r,n){this.type=t,this.operator=e,this.valueType=r,this.values=n}return t.fromJson=function(e){var r=I(nt,e.type),n=I(ot,e.operator),i=I(it,e.valueType);return r&&n&&i&&new t(r,n,i,e.values)},t.prototype.toJson=function(){return{operator:this.operator,type:this.type,valueType:this.valueType,values:this.values}},t}(),z=function(){function t(t,e,r){this.type=t,this.variationId=e,this.bucketId=r}return t.fromJson=function(e){var r=I(st,e.type);return r&&new t(r,e.variationId,e.bucketId)},t}(),J=function(){function t(t,e){this.target=t,this.action=e}return t.fromJson=function(e,r){var n=G.fromJson(e.target,r),i=z.fromJson(e.action);return n&&i&&new t(n,i)},t}(),Y=function(){function t(t,e,r,n){this.id=t,this.key=e,this.type=r,this.targets=n}return t.fromJson=function(e){var r=I(at,e.type);return r&&new t(e.id,e.key,r,n.mapNotNullOrUndefined(e.targets,(function(t){return G.fromJson(t,ct.SEGMENT)})))},t}(),q=function(){function t(t,e,r){this.id=t,this.bucketId=e,this.groups=r}return t.fromJson=function(e){return new t(e.id,e.bucketId,e.groups.map((function(t){return X.fromJson(t)})))},t.prototype.getGroupOrNull=function(t){return this.groups.find((function(e){return e.id===t}))},t}(),X=function(){function t(t,e){this.id=t,this.experiments=e}return t.fromJson=function(e){return new t(e.id,e.experiments)},t}(),W=function(){function t(t,e,r,n,i,o){this.id=t,this.key=e,this.type=r,this.identifierType=n,this.targetRules=i,this.defaultValue=o}return t.fromJson=function(e){var r=I(it,e.type),i=n.mapNotNullOrUndefined(e.targetRules,(function(t){return $.fromJson(t,ct.PROPERTY)})),o=Z.fromJson(e.defaultValue);return r&&new t(e.id,e.key,r,e.identifierType,i,o)},t}(),$=function(){function t(t,e,r,n,i){this.key=t,this.name=e,this.target=r,this.bucketId=n,this.value=i}return t.fromJson=function(e,r){var n=G.fromJson(e.target,r);return n&&new t(e.key,e.name,n,e.bucketId,Z.fromJson(e.value))},t}(),Z=function(){function t(t,e){this.id=t,this.rawValue=e}return t.fromJson=function(e){return new t(e.id,e.value)},t}();function Q(t,e){return t-e}var tt=function(){function t(t,e,r){this.coreVersion=t,this.prerelease=e,this.build=r}return t.tryParse=function(e){var r=t.regExp.exec(e);if(r){r[0];var n=r[1],i=r[2],o=void 0===i?"0":i,s=r[3],u=void 0===s?"0":s,a=r[4],c=r[5];return new t(new et(parseInt(n,10),parseInt(o,10),parseInt(u,10)),rt.parse(a),rt.parse(c))}},t.prototype.compareTo=function(t){return this.coreVersion.compareTo(t.coreVersion)||this.prerelease.compareTo(t.prerelease)},t.prototype.isEqualTo=function(t){return 0===this.compareTo(t)},t.prototype.isGreaterThan=function(t){return this.compareTo(t)>0},t.prototype.isGreaterThanOrEqualTo=function(t){return this.compareTo(t)>=0},t.prototype.isLessThan=function(t){return this.compareTo(t)<0},t.prototype.isLessThanOrEqualTo=function(t){return this.compareTo(t)<=0},t.regExp=/^(0|[1-9]\d*)(?:\.(0|[1-9]\d*))?(?:\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/,t}(),et=function(){function t(t,e,r){this.major=t,this.minor=e,this.patch=r}return t.prototype.compareTo=function(t){return Q(this.major,t.major)||Q(this.minor,t.minor)||Q(this.patch,t.patch)},t}(),rt=function(){function t(t){this.identifiers=t}return t.parse=function(e){return e?new t(e.split(".")):t.EMPTY},t.prototype.isEmpty=function(){return 0===this.identifiers.length},t.prototype.isNotEmpty=function(){return!this.isEmpty()},t.prototype.compareTo=function(t){return this.isEmpty()&&t.isEmpty()?0:this.isEmpty()&&t.isNotEmpty()?1:this.isNotEmpty()&&t.isEmpty()?-1:this.compareIdentifiers(t)},t.prototype.compareIdentifiers=function(e){for(var r=Math.min(this.identifiers.length,e.identifiers.length),n=0;n<r;n++){var i=t.compareIdentifiers(this.identifiers[n],e.identifiers[n]);if(0!==i)return i}return Q(this.identifiers.length,e.identifiers.length)},t.compareIdentifiers=function(e,r){return t.numericIdentifierRegExp.test(e)&&t.numericIdentifierRegExp.test(r)?Q(+e,+r):e===r?0:e<r?-1:1},t.EMPTY=new t([]),t.numericIdentifierRegExp=/^(0|[1-9]\d*)$/,t}(),nt=["MATCH","NOT_MATCH"],it=["STRING","NUMBER","BOOLEAN","VERSION","JSON","URL","NULL","UNKNOWN"],ot=["IN","CONTAINS","STARTS_WITH","ENDS_WITH","GT","GTE","LT","LTE"],st=["VARIATION","BUCKET"],ut=["USER_ID","USER_PROPERTY","HACKLE_PROPERTY","SEGMENT","AB_TEST","FEATURE_FLAG","EVENT_PROPERTY","COHORT"],at=["USER_ID","USER_PROPERTY"],ct=function(){function t(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.supportedKeyTypes=t}return t.prototype.supports=function(t){return this.supportedKeyTypes.includes(t)},t.IDENTIFIER=new t("SEGMENT"),t.PROPERTY=new t("SEGMENT","USER_PROPERTY","HACKLE_PROPERTY","AB_TEST","FEATURE_FLAG","EVENT_PROPERTY","COHORT"),t.SEGMENT=new t("USER_ID","USER_PROPERTY","HACKLE_PROPERTY","COHORT"),t}(),pt=["ACTIVE","DRAFT","PAUSE"],ft=["WEB","ANDROID","IOS"],lt=["IMMEDIATE","CUSTOM"],ht=["MODAL"],dt=["IMAGE_TEXT","IMAGE_ONLY","TEXT_ONLY"],vt=["VERTICAL","HORIZONTAL"],yt=["CLICK"],mt=["CLOSE","WEB_LINK","HIDDEN","LINK_AND_CLOSE","LINK_NEW_TAB","LINK_NEW_TAB_AND_CLOSE","LINK_NEW_WINDOW","LINK_NEW_WINDOW_AND_CLOSE"],gt=function(){function t(t,e,r,n,i,o,s){this.id=t,this.key=e,this.status=r,this.period=n,this.eventTrigger=i,this.targetContext=o,this.messageContext=s}return t.fromJson=function(e){var n=I(pt,e.status);if(!r.isNullOrUndefined(n)){var i;switch(I(lt,e.timeUnit)){case"IMMEDIATE":i=new Et;break;case"CUSTOM":if(r.isNullOrUndefined(e.startEpochTimeMillis))return;if(r.isNullOrUndefined(e.endEpochTimeMillis))return;i=new wt(e.startEpochTimeMillis,e.endEpochTimeMillis);break;default:return}var o=Rt.fromJson(e.messageContext);if(!r.isNullOrUndefined(o)){var s=e.eventTriggerRules.map(_t.fromJson),u=It.fromJson(e.eventFrequencyCap);return new t(e.id,e.key,n,i,new Tt(s,u),Nt.fromJson(e.targetContext),o)}}},t.prototype.supports=function(t){return this.messageContext.platformTypes.includes(t)},t}(),Et=function(){function t(){this.type="IMMEDIATE"}return t.prototype.within=function(t){return!0},t}(),wt=function(){function t(t,e){this.startMillisInclusive=t,this.endMillisExclusive=e,this.type="CUSTOM"}return t.prototype.within=function(t){return this.startMillisInclusive<=t&&t<this.endMillisExclusive},t}(),Tt=function(t,e){this.rules=t,this.frequencyCap=e},_t=function(){function t(t,e){this.eventKey=t,this.targets=e}return t.fromJson=function(e){return new t(e.eventKey,n.mapNotNullOrUndefined(e.targets,(function(t){return G.fromJson(t,ct.PROPERTY)})))},t}(),It=function(){function t(t,e){this.identifierCaps=t,this.durationCap=e}return t.fromJson=function(e){return e?new t(e.identifiers.map(At.fromJson),bt.fromJson(e.duration)):null},t}(),At=function(){function t(t,e){this.identifierType=t,this.count=e}return t.fromJson=function(e){return new t(e.identifierType,e.countPerIdentifier)},t}(),bt=function(){function t(t,e){this.durationMillis=t,this.count=e}return t.fromJson=function(e){if(!e)return null;var r=I(m,e.durationUnit.timeUnit);return r?new t(g.converter[r](e.durationUnit.amount,"milliseconds"),e.countPerDuration):null},t}(),Nt=function(){function t(t,e){this.overrides=t,this.targets=e}return t.fromJson=function(e){return new t(e.overrides.map(Ot.fromJson),n.mapNotNullOrUndefined(e.targets,(function(t){return G.fromJson(t,ct.PROPERTY)})))},t}(),Ot=function(){function t(t,e){this.identifierType=t,this.identifiers=e}return t.fromJson=function(e){return new t(e.identifierType,e.identifiers)},t}(),Rt=function(){function t(t,e,r,n){this.defaultLang=t,this.platformTypes=e,this.orientations=r,this.messages=n}return t.fromJson=function(e){var i=A(ft,e.platformTypes);if(!r.isNullOrUndefined(i)){var o=A(vt,e.orientations);if(!r.isNullOrUndefined(o)){var s=n.mapOrUndefined(e.messages,xt.fromJson);if(!r.isNullOrUndefined(s))return new t(e.defaultLang,i,o,s)}}},t}(),xt=function(){function t(t,e,r,n,i,o,s){this.lang=t,this.layout=e,this.images=r,this.text=n,this.buttons=i,this.closeButton=o,this.background=s}return t.fromJson=function(e){var i=Mt.fromJson(e.layout);if(!r.isNullOrUndefined(i)){var o=n.mapOrUndefined(e.images,St.fromJson);if(!r.isNullOrUndefined(o)){var s=n.mapOrUndefined(e.buttons,kt.fromJson);if(!r.isNullOrUndefined(s)){var u=void 0;if(!r.isNotNullOrUndefined(e.closeButton)||(u=kt.fromJson2(e.closeButton),!r.isNullOrUndefined(u)))return new t(e.lang,i,o,e.text?Ct.fromJson(e.text):void 0,s,u,new Lt(e.background.color))}}}},t.prototype.toJson=function(){var t,e,r,n;return{lang:this.lang,layout:{layoutType:this.layout.layoutType,displayType:this.layout.displayType},images:this.images.map((function(t){return t.toJson()})),text:null!==(e=null===(t=this.text)||void 0===t?void 0:t.toJson())&&void 0!==e?e:null,closeButton:null!==(n=null===(r=this.closeButton)||void 0===r?void 0:r.toCloseButtonJson())&&void 0!==n?n:null,buttons:this.buttons.map((function(t){return t.toJson()})),background:{color:this.background.color}}},t}(),Mt=function(){function t(t,e){this.displayType=t,this.layoutType=e}return t.fromJson=function(e){var n=I(dt,e.layoutType),i=I(ht,e.displayType);if(!r.isNullOrUndefined(i)&&!r.isNullOrUndefined(n))return new t(i,n)},t}(),St=function(){function t(t,e,r){this.orientation=t,this.imagePath=e,this.action=r}return t.fromJson=function(e){var n=I(vt,e.orientation);if(!r.isNullOrUndefined(n)){var i=void 0;if(!r.isNotNullOrUndefined(e.action)||(i=Ft.fromJson(e.action),!r.isNullOrUndefined(i)))return new t(n,e.imagePath,i)}},t.prototype.toJson=function(){var t,e;return{orientation:this.orientation,imagePath:this.imagePath,action:null!==(e=null===(t=this.action)||void 0===t?void 0:t.toJson())&&void 0!==e?e:null}},t}(),Ct=function(){function t(t,e){this.title=t,this.body=e}return t.fromJson=function(e){return new t(Ut.fromJson(e.title),Ut.fromJson(e.body))},t.prototype.toJson=function(){return{title:{text:this.title.text,style:{textColor:this.title.style.color}},body:{text:this.body.text,style:{textColor:this.body.style.color}}}},t}(),Ut=function(){function t(t,e){this.text=t,this.style=e}return t.fromJson=function(e){return new t(e.text,new Pt(e.style.textColor))},t}(),Pt=function(t){this.color=t},kt=function(){function t(t,e,r){this.text=t,this.style=e,this.action=r}return t.fromJson=function(e){var n=Ft.fromJson(e.action);if(!r.isNullOrUndefined(n))return new t(e.text,new Dt(e.style.textColor,e.style.bgColor,e.style.borderColor),n)},t.fromJson2=function(e){var n=Ft.fromJson(e.action);if(!r.isNullOrUndefined(n))return new t("✕",new Dt(e.style.color,"#FFFFFF","#FFFFFF"),n)},t.prototype.toJson=function(){return{text:this.text,action:this.action.toJson(),style:{textColor:this.style.textColor,bgColor:this.style.backgroundColor,borderColor:this.style.backgroundColor}}},t.prototype.toCloseButtonJson=function(){return{action:this.action.toJson(),style:{color:this.style.textColor}}},t}(),Dt=function(t,e,r){this.textColor=t,this.backgroundColor=e,this.borderColor=r},Lt=function(t){this.color=t},Ft=function(){function t(t,e,r){this.behavior=t,this.type=e,this.value=r}return t.fromJson=function(e){var n,i=I(yt,e.behavior);if(!r.isNullOrUndefined(i)){var o=I(mt,e.type);if(!r.isNullOrUndefined(o))return new t(i,o,null!==(n=e.value)&&void 0!==n?n:void 0)}},t.prototype.toJson=function(){var t;return{behavior:this.behavior,type:this.type,value:null!==(t=this.value)&&void 0!==t?t:null}},t}(),Vt=function(t){this.id=t};exports.kg=void 0,(exports.kg||(exports.kg={})).MANUAL="MANUAL";var jt=function(){function t(t,e,r){this.needRedirect=t,this.redirectType=e,this.redirectUrl=r}return t.fromDto=function(e){var r;return new t(e.needRedirect,(r=e.properties.type,Object.values(exports.kg).includes(r)?e.properties.type:null),e.properties.value)},t}(),Gt=function(){function t(t,e){this.includeTargets=t,this.excludeTargets=e}return t.fromJson=function(e){if(null!==e)return new t(n.mapNotNullOrUndefined(e.match,(function(t){return G.fromJson(t,ct.PROPERTY)})),n.mapNotNullOrUndefined(e.notMatch,(function(t){return G.fromJson(t,ct.PROPERTY)})))},t}(),Ht=function(){function t(t){this.name=t,this._tags={},this.name=t}return t.prototype.tags=function(t){var e=this;return Object.entries(t).forEach((function(t){var r=t[0],n=t[1];e._tags[r]=n})),this},t.prototype.tag=function(t,e){return this._tags[t]=e,this},t.prototype.register=function(t){return t.registerTimer({name:this.name,tags:this._tags,type:"TIMER"})},t}(),Bt=function(){function t(t){this._clock=t,this.startTime=this._clock.tick()}return t.start=function(e){return void 0===e&&(e=t.defaultClock),new t(e)},t.prototype.stop=function(t){var e=this._clock.tick()-this.startTime;t.record(e,"microseconds")},t.defaultClock=new E,t}();var Kt=function(){function t(t){this.name=t,this._tags={}}return t.prototype.tags=function(t){var e=this;return Object.entries(t).forEach((function(t){var r=t[0],n=t[1];e._tags[r]=n})),this},t.prototype.tag=function(t,e){return this._tags[t]=e,this},t.prototype.register=function(t){return t.registerCounter({name:this.name,tags:this._tags,type:"COUNTER"})},t}();var zt=function(){function t(t,e){this.valueSupplier=e,this.field=t}return Object.defineProperty(t.prototype,"value",{get:function(){return this.valueSupplier()},enumerable:!1,configurable:!0}),t}();function Jt(t,e){return t.name===e.name&&d.isEquals(t.tags,e.tags)}var Yt=function(){function t(t){this.counterValue=0,this.id=t}return t.prototype.count=function(){return this.counterValue},t.prototype.increment=function(t){this.counterValue+=null!=t?t:1},t.prototype.measure=function(){return[new zt("count",this.count.bind(this))]},t}(),qt=function(){function t(t){this.id=t,this.currentCounter=new Yt(t)}return t.prototype.flush=function(){var t=this.currentCounter;return this.currentCounter=new Yt(this.id),t},t.prototype.count=function(){return this.currentCounter.count()},t.prototype.increment=function(t){this.currentCounter.increment(t)},t.prototype.measure=function(){return[new zt("count",this.count.bind(this))]},t}(),Xt=function(){function t(t){this.compareFn=t,this.data=new Map,this.compareFn=t,this.data=new Map}return t.prototype.values=function(){return Array.from(this.data.values())},t.prototype.keys=function(){return Array.from(this.data.keys())},t.prototype.get=function(t){var e=this,r=this.keys().find((function(r){return e.compareFn(r,t)}));return r?this.data.get(r):void 0},t.prototype.has=function(t){return void 0!==this.get(t)},t.prototype.add=function(t,e){var r=e;return r||(r=t),this.data.set(t,r),this},t.prototype.delete=function(t){if(this.has(t)){var e=this.get(t);return this.data.delete(t),e}},t.prototype.forEach=function(t){this.data.forEach(t)},t.prototype.filter=function(e){for(var r=new t(this.compareFn),n=0,i=this.entries();n<i.length;n++){var o=i[n];e(o[0],o[1])&&r.add(o[0],o[1])}return r},t.prototype.entries=function(){return Array.from(this.data.entries())},t}(),Wt=function(){function e(){this.id=t.v4(),this.name="MetricRegistry",this._metrics=new Xt(Jt)}return Object.defineProperty(e.prototype,"metrics",{get:function(){return Array.from(this._metrics.values())},enumerable:!1,configurable:!0}),e.prototype.registerCounter=function(t){return this.registerMetricIfNecessary(t,this.createCounter.bind(this))},e.prototype.registerTimer=function(t){return this.registerMetricIfNecessary(t,this.createTimer.bind(this))},e.prototype.counter=function(t,e){return void 0===e&&(e={}),new Kt(t).tags(e).register(this)},e.prototype.timer=function(t,e){return void 0===e&&(e={}),new Ht(t).tags(e).register(this)},e.prototype.registerMetricIfNecessary=function(t,e){return this.getOrCreateMetric(t,e)},e.prototype.getOrCreateMetric=function(t,e){var r,n=this._metrics.get(t);return n?r=n:(r=e(t),this._metrics.add(t,r)),r},e.prototype.close=function(){},e}(),$t=function(t){function e(e,r){var n=t.call(this)||this;return n.scheduler=e,n.pushIntervalMillis=r,n.publishingJob=null,n}return a(e,t),e.prototype.start=function(){var t=this;null===this.publishingJob&&(this.publishingJob=this.scheduler.schedulePeriodically(this.pushIntervalMillis,this.pushIntervalMillis,(function(){return t.publish(!1)})),o.log.debug("PushMetricRegistry started. Publish metrics every ".concat(this.pushIntervalMillis,"ms.")))},e.prototype.stop=function(){var t;null===(t=this.publishingJob)||void 0===t||t.cancel(),this.publishingJob=null,this.publish(!0),o.log.debug("PushMetricRegistry stopped.")},e.prototype.close=function(){this.stop()},e}(Wt);var Zt=function(){function t(t){this._count=0,this._total=0,this._max=0,this.id=t}return t.prototype.count=function(){return this._count},t.prototype.totalTime=function(t){return g.nanosToUnit(this._total,t)},t.prototype.max=function(t){return g.nanosToUnit(this._max,t)},t.prototype.mean=function(t){return 0===this.count()?0:this.totalTime(t)/this.count()},t.prototype.record=function(t,e){if(!(t<0)){var r=g.converter[e](t,"nanoseconds");this._count=this.count()+1,this._total+=r,this._max=Math.max(r,this._max)}},t.prototype.measure=function(){var t=this;return[new zt("count",this.count.bind(this)),new zt("total",(function(){return t.totalTime("milliseconds")})),new zt("max",(function(){return t.max("milliseconds")})),new zt("mean",(function(){return t.mean("milliseconds")}))]},t}(),Qt=function(){function t(t){this.id=t,this.currentTimer=new Zt(t)}return t.prototype.flush=function(){var t=this.currentTimer;return this.currentTimer=new Zt(this.id),t},t.prototype.count=function(){return this.currentTimer.count()},t.prototype.totalTime=function(t){return this.currentTimer.totalTime(t)},t.prototype.max=function(t){return this.currentTimer.max(t)},t.prototype.record=function(t,e){this.currentTimer.record(t,e)},t.prototype.mean=function(t){return 0===this.count()?0:this.totalTime(t)/this.count()},t.prototype.measure=function(){var t=this;return[new zt("count",this.count.bind(this)),new zt("total",(function(){return t.totalTime("milliseconds")})),new zt("max",(function(){return t.max("milliseconds")})),new zt("mean",(function(){return t.mean("milliseconds")}))]},t}(),te=function(t){function e(e,r){return t.call(this,e,r)||this}return a(e,t),e.prototype.createCounter=function(t){return new qt(t)},e.prototype.createTimer=function(t){return new Qt(t)},e.prototype.publish=function(t){void 0===t&&(t=!1);var e=this.metrics.reduce((function(t,e){return function(t){return void 0!==t.flush&&"function"==typeof t.flush}(e)?t.concat(e.flush()):t}),[]);this.flushMetrics(e,t)},e.prototype.close=function(){t.prototype.close.call(this)},e}($t),ee=function(){function t(t){this.id=t}return t.prototype.count=function(){return 0},t.prototype.increment=function(t){},t.prototype.measure=function(){return[new zt("count",this.count.bind(this))]},t}(),re=function(){function t(t){this._counters=new Xt((function(t,e){return t.id===e.id})),this.id=t,this.noopCounter=new ee(t)}return Object.defineProperty(t.prototype,"counters",{get:function(){return Array.from(this._counters.values())},enumerable:!1,configurable:!0}),t.prototype.add=function(t){this._counters.add(t,t.registerCounter(this.id))},t.prototype.count=function(){return(this.counters[0]||this.noopCounter).count()},t.prototype.increment=function(t){this.counters.forEach((function(e){e.increment(t)}))},t.prototype.measure=function(){return[new zt("count",this.count.bind(this))]},t}();var ne,ie=function(){function t(t){this.id=t}return t.prototype.measure=function(){var t=this;return[new zt("count",this.count.bind(this)),new zt("total",(function(){return t.totalTime("milliseconds")})),new zt("max",(function(){return t.max("milliseconds")})),new zt("mean",(function(){return t.mean("milliseconds")}))]},t.prototype.count=function(){return 0},t.prototype.totalTime=function(t){return 0},t.prototype.max=function(t){return 0},t.prototype.mean=function(t){return 0},t.prototype.record=function(t,e){},t}(),oe=function(){function t(t){this._timers=new Xt((function(t,e){return t.id===e.id})),this.id=t,this.noopTimer=new ie(t)}return Object.defineProperty(t.prototype,"firstTimer",{get:function(){return this.timers[0]||this.noopTimer},enumerable:!1,configurable:!0}),t.prototype.totalTime=function(t){return this.firstTimer.totalTime(t)},t.prototype.max=function(t){return this.firstTimer.max(t)},t.prototype.mean=function(t){return this.firstTimer.mean(t)},t.prototype.record=function(t,e){this.timers.forEach((function(r){r.record(t,e)}))},Object.defineProperty(t.prototype,"timers",{get:function(){return Array.from(this._timers.values())},enumerable:!1,configurable:!0}),t.prototype.add=function(t){this._timers.add(t,t.registerTimer(this.id))},t.prototype.count=function(){return this.firstTimer.count()},t.prototype.measure=function(){var t=this;return[new zt("count",this.count.bind(this)),new zt("total",(function(){return t.totalTime("milliseconds")})),new zt("max",(function(){return t.max("milliseconds")})),new zt("mean",(function(){return t.mean("milliseconds")}))]},t}(),se=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e.registries=new Xt((function(t,e){return t.id===e.id})),e}return a(e,t),e.prototype.createCounter=function(t){var e=new re(t);return this.addRegistry(e),e},e.prototype.createTimer=function(t){var e=new oe(t);return this.addRegistry(e),e},e.prototype.addRegistry=function(t){this.registries.forEach((function(e){return t.add(e)}))},e.prototype.add=function(t){t instanceof e||this.registries.has(t)||(this.registries.add(t),this.metrics.forEach((function(e){(function(t){return void 0!==t.add&&"function"==typeof t.add})(e)&&e.add(t)})))},e.prototype.close=function(){this.registries.forEach((function(t){t.close()}))},e}(Wt),ue=function(){function t(){}return t.counter=function(e,r){return t.globalRegistry.counter(e,r)},t.timer=function(e,r){return t.globalRegistry.timer(e,r)},t.addRegistry=function(e){t.globalRegistry.add(e),o.log.debug("MetricRegistry added ".concat(e.name))},t.globalRegistry=new se,t}(),ae=function(){function t(){}return t.equalsIgnoreCase=function(t,e){return t.toLowerCase()===e.toLowerCase()},t}(),ce=function(){function t(t,e,r,n,i){this.url=t,this.method=e,this.body=r,this.headers=n,this.options=i}return t.builder=function(){return new pe},t.get=function(e){return t.builder().url(e).build()},t.prototype.toBuilder=function(){return new pe(this)},t}(),pe=function(){function t(t){var e,r,n,i,o,s,u;this._url=null!==(e=null==t?void 0:t.url)&&void 0!==e?e:null,this._method=null!==(r=null==t?void 0:t.method)&&void 0!==r?r:"GET",this._body=null!==(n=null==t?void 0:t.body)&&void 0!==n?n:null,this._headers=null!==(o=null===(i=null==t?void 0:t.headers)||void 0===i?void 0:i.toBuilder())&&void 0!==o?o:le.builder(),this._timeoutMillis=null!==(u=null===(s=null==t?void 0:t.options)||void 0===s?void 0:s.timeoutMillis)&&void 0!==u?u:null}return t.prototype.url=function(t){return this._url=t,this},t.prototype.method=function(t){return this._method=t,this},t.prototype.body=function(t){return this._body=t,this},t.prototype.addHeader=function(t,e){return this._headers.add(t,e),this},t.prototype.timeoutMillis=function(t){return this._timeoutMillis=t,this},t.prototype.build=function(){if(null===this._url)throw new Error("url is null");var t={timeoutMillis:this._timeoutMillis};return new ce(this._url,this._method,this._body,this._headers.build(),t)},t}(),fe=function(){function t(t,e,r){this.statusCode=t,this.body=e,this.headers=r}return t.ok=function(e,r){return t.of(200,e,r)},t.of=function(e,r,n){return new t(e,null!=r?r:null,null!=n?n:le.empty())},t.prototype.isSuccessful=function(){return this.statusCode>=200&&this.statusCode<300},t.prototype.isClientError=function(){return this.statusCode>=400&&this.statusCode<500},t.prototype.isNotModified=function(){return 304===this.statusCode},t}(),le=function(){function t(t){this.headers=t}return t.empty=function(){return new t(new Map)},t.builder=function(){return new he(new Map)},t.prototype.get=function(t){for(var e=0,r=Array.from(this.headers.entries());e<r.length;e++){var n=r[e],i=n[0],o=n[1];if(ae.equalsIgnoreCase(i,t))return o}return null},t.prototype.getOrDefault=function(t,e){var r;return null!==(r=this.get(t))&&void 0!==r?r:e},t.prototype.raw=function(){return Array.from(this.headers.entries()).reduce((function(t,e){var r=e[0],n=e[1];return t[r]=n,t}),{})},t.prototype.toBuilder=function(){return new he(this.headers)},t.IF_MODIFIED_SINCE="If-Modified-Since",t.LAST_MODIFIED="Last-Modified",t}(),he=function(){function t(t){this.headers=t}return t.prototype.add=function(t,e){return this.headers.set(t,e),this},t.prototype.build=function(){return new le(this.headers)},t}(),de=function(t){function e(e,r,n,i,o){var s=t.call(this,i,o)||this;return s.url=e,s.transport=r,s.shutdownTransport=n,s.start(),s}return a(e,t),e.prototype.flushMetrics=function(t,e){var r=this;n.chunked(t.filter(this.isDispatchTarget.bind(this)),100).forEach((function(t){r.dispatch(t,e)}))},e.prototype.isDispatchTarget=function(t){return!(!function(t){return"COUNTER"===t.id.type}(t)&&!function(t){return"TIMER"===t.id.type}(t))&&t.count()>0},e.prototype.dispatch=function(t,e){var r=this.createRequest(t);this.execute(r,e).catch((function(t){return o.log.debug("Failed to flushing metrics: ".concat(t))}))},e.prototype.createRequest=function(t){return ce.builder().url(this.url).method("POST").body(JSON.stringify(this.batch(t))).addHeader("Content-Type","application/json").build()},e.prototype.execute=function(t,e){return e?this.shutdownTransport.send(t):this.transport.send(t)},e.prototype.batch=function(t){return{metrics:t.map((function(t){return{name:t.id.name,type:t.id.type,tags:t.id.tags,measurements:r.fromMap(n.associate(t.measure(),(function(t){return[t.field,t.value]})))}}))}},e.prototype.createCounter=function(t){return new qt(t)},e.prototype.createTimer=function(t){return new Qt(t)},e.prototype.close=function(){t.prototype.close.call(this)},e}(te),ve=function(){function t(){}return t.experiment=function(t,e,r){var n=ue.timer("experiment.decision",{key:String(e),variation:r.variation,reason:String(r.reason)});t.stop(n)},t.featureFlag=function(t,e,r){var n=ue.timer("feature.flag.decision",{key:String(e),on:String(r.isOn),reason:String(r.reason)});t.stop(n)},t.remoteConfig=function(t,e,r){var n=ue.timer("remote.config.decision",{key:String(e),reason:String(r.reason)});t.stop(n)},t.inAppMessage=function(t,e,r){var n=ue.timer("iam.decision",{key:String(e),show:String(r.isShow()),reason:String(r.reason)});t.stop(n)},t}(),ye=function(){function t(){}return t.record=function(e,r,n){var i=ue.timer("api.call",{operation:e,success:t.success(n)});r.stop(i)},t.success=function(t){return null===t?"false":String(t.isSuccessful()||t.isNotModified())},t}(),me=function(){function t(){}return t.decide=function(t,e,n,i){if(r.isNullOrUndefined(n))return this.decision(t,e,"NULL",n,i);switch(typeof n){case"string":return this.decision(t,e,"STRING",n,i);case"number":return this.decision(t,e,"NUMBER",n,i);case"boolean":return this.decision(t,e,"BOOLEAN",n,i);default:return this.decision(t,e,"UNKNOWN",n,i)}},t.decision=function(t,e,n,i,o){return r.isNullOrUndefined(e)?b.of(i,S.INVALID_INPUT):t.remoteConfig(e,o,n,i)},t}(),ge=o.log,Ee=function(){function t(t,e,r){this.core=t,this.userManager=e,this.user=r}return t.prototype.get=function(t,e){var r,n=Bt.start();try{r=this.decide(t,e)}catch(n){ge.error("Unexpected exception while deciding remote config parameter[".concat(t,"]. Returning default value. : ").concat(n)),r=b.of(e,S.EXCEPTION)}return ve.remoteConfig(n,t,r),r.value},t.prototype.decide=function(t,e){var r=this.userManager.resolve(this.user);return me.decide(this.core,t,e,r)},t}(),we=function(){function t(){this._properties=new Map,this.MAX_PROPERTIES_COUNT=128,this.MAX_PROPERTY_KEY_LENGTH=128}return t.prototype.contains=function(t){return this._properties.has(t)},t.prototype.remove=function(t){var e=this;return t instanceof Map&&t.forEach((function(t,r){e.remove(r)})),"string"==typeof t&&this._properties.delete(t),this},t.prototype.compute=function(t,e){var r=this._properties.get(t),n=e(r);null!==n?this.add(t,n):(null!==r||this.contains(t))&&this.remove(t)},t.prototype.add=function(t,e,r){if(void 0===r&&(r=!1),r&&this.contains(t))return this;if(this._properties.size>=this.MAX_PROPERTIES_COUNT)return this;if("string"==typeof t&&t.length>this.MAX_PROPERTY_KEY_LENGTH)return this;var n=y.sanitizeValue(t,e);return n?(this._properties.set(t,n),this):this},t.prototype.addProperties=function(t,e){var r=this;return void 0===e&&(e=!1),t.forEach((function(t,n){r.add(n,t,e)})),this},t.prototype.build=function(){return this._properties},t}();!function(t){t.SET="$set",t.SET_ONCE="$setOnce",t.UNSET="$unset",t.INCREMENT="$increment",t.APPEND="$append",t.APPEND_ONCE="$appendOnce",t.PREPEND="$prepend",t.PREPEND_ONCE="$prependOnce",t.REMOVE="$remove",t.CLEAR_ALL="$clearAll"}(ne||(ne={}));var Te=function(){function t(){}return t.prototype.operate=function(t,e){return 0===t.size?e:0===e.size?t:(new we).addProperties(t).addProperties(e).build()},t}(),_e=function(){function t(){}return t.prototype.operate=function(t,e){return 0===t.size?e:0===e.size?t:(new we).addProperties(t).addProperties(e,!0).build()},t}(),Ie=function(){function t(){}return t.prototype.operate=function(t,e){return 0===t.size?new Map:0===e.size?t:(new we).addProperties(t).remove(e).build()},t}(),Ae=function(){function t(){}return t.prototype.operate=function(t,e){var r=this;if(0===e.size)return t;var n=new we;return n.addProperties(t),e.forEach((function(t,e){n.compute(e,(function(e){return r.increment(e,t)}))})),n.build()},t.prototype.increment=function(t,e){return"number"!=typeof e?t:"number"!=typeof t?null==t?e:t:t+e},t}(),be=function(){function t(){}return t.prototype.operate=function(t,e){var r=this;if(0===e.size)return t;var n=new we;return n.addProperties(t),e.forEach((function(t,e){n.compute(e,(function(e){return r.compute(e,t)}))})),n.build()},t.prototype.compute=function(t,e){var r=this.toArray(t),n=this.toArray(e);return this.operateArray(r,n)},t.prototype.toArray=function(t){return null==t?[]:Array.isArray(t)?t:[t]},t.prototype.contains=function(t,e){return t.includes(e)},t.prototype.prepend=function(t,e,r){return void 0===r&&(r=!1),r&&this.contains(e,t)?e:l([t],e,!0)},t.prototype.append=function(t,e,r){return void 0===r&&(r=!1),r&&this.contains(t,e)?t:l(l([],t,!0),[e],!1)},t}(),Ne=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e.prototype.operateArray=function(t,e){var r=this;return e.reduce((function(t,e){return r.append.bind(r)(t,e)}),t)},e}(be),Oe=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e.prototype.operateArray=function(t,e){return e.reduce(this.appendOnce.bind(this),t)},e.prototype.appendOnce=function(t,e){return this.append(t,e,!0)},e}(be),Re=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e.prototype.operateArray=function(t,e){var r=this;return e.reduceRight((function(t,e){return r.prepend.bind(r)(e,t)}),t)},e}(be),xe=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e.prototype.operateArray=function(t,e){var r=this;return e.reduce(this.appendOnce.bind(this),[]).reduceRight((function(t,e){return r.prependOnce.bind(r)(e,t)}),t)},e.prototype.appendOnce=function(t,e){return this.append(t,e,!0)},e.prototype.prependOnce=function(t,e){return this.prepend(t,e,!0)},e}(be),Me=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e.prototype.operateArray=function(t,e){return e.reduce(this.remove.bind(this),t)},e.prototype.remove=function(t,e){return t.filter((function(t){return t!==e}))},e}(be),Se=function(){function t(){}return t.prototype.operate=function(t,e){return new Map},t}(),Ce=function(){function t(){}return t.get=function(t){switch(t){case ne.SET:return new Te;case ne.SET_ONCE:return new _e;case ne.UNSET:return new Ie;case ne.INCREMENT:return new Ae;case ne.APPEND:return new Ne;case ne.APPEND_ONCE:return new Oe;case ne.PREPEND:return new Re;case ne.PREPEND_ONCE:return new xe;case ne.CLEAR_ALL:return new Se;case ne.REMOVE:return new Me}},t}(),Ue=function(){function t(){this.operations=new Map}return t.prototype.set=function(t,e){return this.add(ne.SET,t,e)},t.prototype.setOnce=function(t,e){return this.add(ne.SET_ONCE,t,e)},t.prototype.unset=function(t){return this.add(ne.UNSET,t,"-")},t.prototype.increment=function(t,e){return this.add(ne.INCREMENT,t,e)},t.prototype.append=function(t,e){return this.add(ne.APPEND,t,e)},t.prototype.appendOnce=function(t,e){return this.add(ne.APPEND_ONCE,t,e)},t.prototype.prepend=function(t,e){return this.add(ne.PREPEND,t,e)},t.prototype.prependOnce=function(t,e){return this.add(ne.PREPEND_ONCE,t,e)},t.prototype.remove=function(t,e){return this.add(ne.REMOVE,t,e)},t.prototype.clearAll=function(){return this.add(ne.CLEAR_ALL,"clearAll","-")},t.prototype.build=function(){var t=Array.from(this.operations.entries()).map((function(t){return[t[0],t[1].build()]}));return new Pe(new Map(t))},t.prototype.containsKey=function(t){return Array.from(this.operations.entries()).some((function(e){return e[0],e[1].contains(t)}))},t.prototype.add=function(t,e,r){if(this.containsKey(e))return this;this.operations.has(t)||this.operations.set(t,new we);var n=this.operations.get(t);return null==n||n.add(e,r),this},t}(),Pe=function(){function t(t){this.operations=null!=t?t:new Map}return t.prototype.operate=function(t){var e=t;return this.operations.forEach((function(t,r){e=Ce.get(r).operate(e,t)})),e},t.prototype.toEvent=function(){var t={key:"$properties"};return this.operations.forEach((function(e,n){var i,o;t.properties=c(c({},t.properties),((i={})[n]=c(c({},null===(o=t.properties)||void 0===o?void 0:o[n]),y.sanitize(r.fromMap(e))),i))})),t},t.prototype.toRecord=function(){var t={};return this.operations.forEach((function(e,r){var n={};e.forEach((function(t,e){n[e]=t})),t[r]=n})),t},t}(),ke=function(){function t(){}return t.timeout=function(t,e){return new Promise((function(r,n){setTimeout((function(){return n(new Error("timeout (".concat(e,"ms)")))}),e),t.then(r,n)}))},t}(),De=o.log,Le=function(){function t(t,e,r,n,i){this.core=t,this.synchronizer=e,this.sessionManager=r,this.userManager=n,this.devTools=i,this.initialized=!1,this.initialize=this.initialize.bind(this),this.getSessionId=this.getSessionId.bind(this),this.getUser=this.getUser.bind(this),this.setUser=this.setUser.bind(this),this.setUserId=this.setUserId.bind(this),this.setDeviceId=this.setDeviceId.bind(this),this.setUserProperty=this.setUserProperty.bind(this),this.setUserProperties=this.setUserProperties.bind(this),this.updateUserProperties=this.updateUserProperties.bind(this),this.resetUser=this.resetUser.bind(this),this.variation=this.variation.bind(this),this.variationDetail=this.variationDetail.bind(this),this.isFeatureOn=this.isFeatureOn.bind(this),this.featureFlagDetail=this.featureFlagDetail.bind(this),this.track=this.track.bind(this),this.trackPageView=this.trackPageView.bind(this),this.remoteConfig=this.remoteConfig.bind(this),this.onReady=this.onReady.bind(this),this.onInitialized=this.onInitialized.bind(this),this.showUserExplorer=this.showUserExplorer.bind(this),this.hideUserExplorer=this.hideUserExplorer.bind(this),this.close=this.close.bind(this),this.initialization=this.initialize()}return t.prototype.initialize=function(){return p(this,void 0,void 0,(function(){var t;return f(this,(function(e){switch(e.label){case 0:return e.trys.push([0,2,3,4]),De.debug("HackleClient initializing"),[4,this.synchronizer.sync()];case 1:return e.sent(),De.debug("HackleClient initialized"),[3,4];case 2:throw t=e.sent(),De.error("HackleClient initialize failed: ".concat(t)),t;case 3:return this.initialized=!0,[7];case 4:return[2]}}))}))},t.prototype.getSessionId=function(){return this.sessionManager.sessionId},t.prototype.getUser=function(){return this.userManager.currentUser},t.prototype.setUser=function(t){try{var e=j(t);return e?(this.userManager.setUser(e),this.synchronizer.syncOnly("cohort").catch((function(){}))):(De.warn("invalid user"),Promise.resolve())}catch(t){return De.error("Unexpected exception while set user: ".concat(t)),Promise.resolve()}},t.prototype.setUserId=function(t){try{if(void 0===t)this.userManager.setUserId(void 0);else{var e=d.sanitizeValue(t);if(!e)return De.warn("Invalid userId. [userId=".concat(t,"]")),Promise.resolve();this.userManager.setUserId(e)}return this.synchronizer.syncOnly("cohort").catch((function(){}))}catch(t){return De.error("Unexpected exception while set userId: ".concat(t)),Promise.resolve()}},t.prototype.setDeviceId=function(t){try{var e=d.sanitizeValue(t);return e?(this.userManager.setDeviceId(e),this.synchronizer.syncOnly("cohort").catch((function(t){}))):(De.warn("Invalid deviceId. [deviceId=".concat(t,"]")),Promise.resolve())}catch(t){return De.error("Unexpected exception while set deviceId: ".concat(t)),Promise.resolve()}},t.prototype.setUserProperty=function(t,e){var r=(new Ue).set(t,e).build();return this.updateUserProperties(r)},t.prototype.setUserProperties=function(t){try{var e=y.sanitize(t),r=new Ue;return Object.entries(e).forEach((function(t){var e=t[0],n=t[1];r.set(e,n)})),this.updateUserProperties(r.build())}catch(t){return De.error("Unexpected exception while set userProperties: ".concat(t)),Promise.resolve()}},t.prototype.updateUserProperties=function(t){try{var e=t.toEvent();return this.track(e),this.userManager.updateUserProperties(t),Promise.resolve()}catch(t){return De.error("Unexpected exception while update userProperties: ".concat(t)),Promise.resolve()}},t.prototype.resetUser=function(){try{this.userManager.resetUser();var t=(new Ue).clearAll().build();return this.track(t.toEvent()),this.synchronizer.syncOnly("cohort")}catch(t){return De.error("Unexpected exception while reset user: ".concat(t)),Promise.resolve()}},t.prototype.variation=function(t,e,r){return this.variationDetail(t,e,r).variation},t.prototype.variationDetail=function(t,e,r){var n=r||"A",i=Bt.start(),o=function(r){try{var i=r.userManager.resolve(e);return r.core.experiment(t,i,n)}catch(e){return De.error("Unexpected exception while deciding variation for experiment[".concat(t,"]. Returning default variation[").concat(n,"] : ").concat(e)),O.of(n,S.EXCEPTION)}}(this);return ve.experiment(i,t,o),o},t.prototype.isFeatureOn=function(t,e){return this.featureFlagDetail(t,e).isOn},t.prototype.featureFlagDetail=function(t,e){var r=Bt.start(),n=function(r){try{var n=r.userManager.resolve(e);return r.core.featureFlag(t,n)}catch(e){return De.error("Unexpected exception while deciding feature flag[".concat(t,"]. Returning default value[false] : ").concat(e)),R.off(S.EXCEPTION)}}(this);return ve.featureFlag(r,t,n),n},t.prototype.track=function(t,e){try{De.debug("track event : ".concat(JSON.stringify(t)));var r=this._convertEvent(t),n=this.userManager.resolve(e);this.core.track(r,n)}catch(t){De.error("Unexpected exception while tracking event: ".concat(t))}},t.prototype.trackPageView=function(t){De.debug("tracking page view");var e=this.userManager.resolve();this.core.track({key:"$page_view"},e)},t.prototype.remoteConfig=function(t){return new Ee(this.core,this.userManager,t)},t.prototype.onReady=function(t,e){void 0===e&&(e=3e3),this.onInitialized({timeout:e}).finally((function(){return t()}))},t.prototype.onInitialized=function(t){var e;return p(this,void 0,void 0,(function(){var r;return f(this,(function(n){switch(n.label){case 0:if(this.initialized)return[2,{success:!0}];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,ke.timeout(this.initialization,null!==(e=null==t?void 0:t.timeout)&&void 0!==e?e:3e3)];case 2:return n.sent(),[2,{success:!0}];case 3:return r=n.sent(),De.error("Failed to onInitialized: ".concat(r)),[2,{success:!1}];case 4:return[2]}}))}))},t.prototype._convertEvent=function(t){return"string"==typeof t?{key:t}:t},t.prototype.showUserExplorer=function(){var t;(null===(t=this.devTools)||void 0===t?void 0:t.userExplorer)?(De.debug("UserExplorer opened."),ue.counter("user.explorer.show",{}).increment(),this.devTools.manager.userExplorer(this.devTools.userExplorer)):De.error("UserExplorer is not provided")},t.prototype.hideUserExplorer=function(){this.devTools?this.devTools.manager.close():De.warn("There is no active HackleDevtools.")},t.prototype.close=function(){De.debug("HackleClient closing"),this.core.close(),this.synchronizer.close()},t}(),Fe=o.log,Ve=function(){function t(t,e){this.invocationProcessor=t,this.user=e}return t.prototype.get=function(t,e){var r=typeof e;try{var n={command:"remoteConfig",parameters:{defaultValue:e,key:t,valueType:r,user:this.user}},i=this.invocationProcessor.process(n);if(!i)throw new Error("invoke result data not exists");switch(r){case"number":return Number(i);case"boolean":return Boolean(i);default:return i}}catch(r){return Fe.error("Unexpected exception while deciding remote config parameter[".concat(t,"]. Returning default value. : ").concat(r)),e}},t}(),je=function(){function t(){}return t.prototype.isInvocatorResponse=function(t){return"object"==typeof t&&null!==t&&"success"in t&&"boolean"==typeof t.success&&"message"in t&&"string"==typeof t.message},t.prototype.resolve=function(t){var e=JSON.parse(null!=t?t:"");if(!this.isInvocatorResponse(e))throw new Error("invalid invocator response data");if(!e.success)throw new Error("failed response");return{message:e.message,success:e.success,data:e.data}},t}(),Ge=function(){function t(t){void 0===t&&(t={days:0,isCrossSubdomain:!1,isSecure:!1}),this.options=t}return t.extractDomain=function(t){var e=/[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i,r=t.split("."),n=r[r.length-1];(n.length>4||"com"===n||"org"===n)&&(e=/[a-z0-9][a-z0-9-]*\.[a-z]+$/i);var i=t.match(e);return i?i[0]:""},t.prototype.getItem=function(t){for(var e=t+"=",r=document.cookie.split(";"),n=0;n<r.length;n++){for(var i=r[n];" "==i.charAt(0);)i=i.substring(1,i.length);if(0===i.indexOf(e))return decodeURIComponent(i.substring(e.length,i.length))}return null},t.prototype.getAllItem=function(t){var e=document.cookie.split("; ").map((function(t){return t.split("=")})),r=null==t?void 0:t.keyPrefix;return r?e.filter((function(t){var e=t[0];return t[1],e.startsWith(r)})):e},t.prototype.setItem=function(e,r,n){var i=c(c({},this.options),n),o="",s="",u="",a="";if(i.isCrossSubdomain){var p=t.extractDomain(document.location.hostname);o=p?"; domain=."+p:""}if(i.days){var f=new Date;f.setTime(f.getTime()+24*i.days*60*60*1e3),s="; expires="+f.toUTCString()}i.sameSite&&(a="; SameSite=".concat(i.sameSite)),i.isSecure&&(u+="; secure");var l=e+"="+encodeURIComponent(r)+s+"; path=/"+o+a+u;return document.cookie=l,l},t.prototype.removeItem=function(t,e){this.setItem(t,"",c(c({},e),{days:-1}))},t.prototype.getOptions=function(){return this.options},t.getInstance=function(e){return void 0===e&&(e={days:3650,isCrossSubdomain:!0}),t.storage||(t.storage=new t(e)),t.storage},t}(),He=function(){function t(){}return t.initialize=function(){Ge.getInstance().getItem("_hackle_hid")||Je()},t}();function Be(){var t=Ge.getInstance(),e=t.getItem("_hackle_id");if(e)return e;var r=t.getItem("_hackle_hid");return r||Je()}function Ke(t){Ge.getInstance().setItem("_hackle_id",t)}function ze(){Ge.getInstance().removeItem("_hackle_id")}function Je(){var e=t.v4();return Ge.getInstance().setItem("_hackle_hid",e),e}var Ye=function(){function t(t){this.invocator=t}return t.prototype.createInvocationRequestDto=function(t){return{_hackle:{command:t.command,parameters:t.parameters}}},t.prototype.process=function(t){var e,r=this.createInvocationRequestDto(t);return null!==(e=this.invocator.invoke(r).data)&&void 0!==e?e:null},t}(),qe=o.log;var Xe=function(){function t(t){this.invocationProcessor=t,this.getSessionId=this.getSessionId.bind(this),this.getUser=this.getUser.bind(this),this.setUser=this.setUser.bind(this),this.setUserId=this.setUserId.bind(this),this.setDeviceId=this.setDeviceId.bind(this),this.setUserProperty=this.setUserProperty.bind(this),this.setUserProperties=this.setUserProperties.bind(this),this.updateUserProperties=this.updateUserProperties.bind(this),this.resetUser=this.resetUser.bind(this),this.variation=this.variation.bind(this),this.variationDetail=this.variationDetail.bind(this),this.isFeatureOn=this.isFeatureOn.bind(this),this.featureFlagDetail=this.featureFlagDetail.bind(this),this.track=this.track.bind(this),this.trackPageView=this.trackPageView.bind(this),this.remoteConfig=this.remoteConfig.bind(this),this.onReady=this.onReady.bind(this),this.onInitialized=this.onInitialized.bind(this),this.showUserExplorer=this.showUserExplorer.bind(this),this.hideUserExplorer=this.hideUserExplorer.bind(this),this.close=this.close.bind(this)}return t.prototype.getSessionId=function(){try{var t=this.invocationProcessor.process({command:"getSessionId"});return null!=t?t:Be()}catch(t){return qe.error("Unexpected exception while get sessionId: ".concat(t)),Be()}},t.prototype.getUser=function(){var t;try{var e=this.invocationProcessor.process({command:"getUser"});return null!==(t=j(e))&&void 0!==t?t:this.defaultUser()}catch(t){return qe.error("Unexpected exception while get user: ".concat(t)),this.defaultUser()}},t.prototype.setUser=function(t){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){try{if(!(e=j(t)))return qe.warn("invalid user"),[2];r={command:"setUser",parameters:{user:e}},this.invocationProcessor.process(r)}catch(t){qe.error("Unexpected exception while set user: ".concat(t))}return[2]}))}))},t.prototype.setUserId=function(t){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){try{if(!(e=d.sanitizeValue(t)))return qe.warn("Invalid userId. [userId=".concat(t,"]")),[2];r={command:"setUserId",parameters:{userId:e}},this.invocationProcessor.process(r)}catch(t){qe.error("Unexpected exception while set userId: ".concat(t))}return[2]}))}))},t.prototype.setDeviceId=function(t){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){try{if(!(e=d.sanitizeValue(t)))return qe.warn("Invalid deviceId. [deviceId=".concat(t,"]")),[2];r={command:"setDeviceId",parameters:{deviceId:e}},this.invocationProcessor.process(r)}catch(t){qe.error("Unexpected exception while set deviceId: ".concat(t))}return[2]}))}))},t.prototype.setUserProperty=function(t,e){return p(this,void 0,void 0,(function(){var r;return f(this,(function(n){try{r={command:"setUserProperty",parameters:{key:t,value:e}},this.invocationProcessor.process(r)}catch(t){qe.error("Unexpected exception while set userProperty: ".concat(t))}return[2]}))}))},t.prototype.setUserProperties=function(t){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){try{e=y.sanitize(t),r=new Ue,Object.entries(e).forEach((function(t){var e=t[0],n=t[1];r.set(e,n)})),this.updateUserProperties(r.build())}catch(t){qe.error("Unexpected exception while set userProperties: ".concat(t))}return[2]}))}))},t.prototype.updateUserProperties=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){try{e={command:"updateUserProperties",parameters:{operations:t.toRecord()}},this.invocationProcessor.process(e)}catch(t){qe.error("Unexpected exception while update userProperties: ".concat(t))}return[2]}))}))},t.prototype.resetUser=function(){return p(this,void 0,void 0,(function(){var t;return f(this,(function(e){try{t={command:"resetUser"},this.invocationProcessor.process(t)}catch(t){qe.error("Unexpected exception while reset user: ".concat(t))}return[2]}))}))},t.prototype.variation=function(t,e,r){void 0===r&&(r="A");try{var n={command:"variation",parameters:{experimentKey:t,defaultVariation:r,user:this.convertUser(e)}},i=this.invocationProcessor.process(n);if(!i)throw new Error("invoke result data not exists");return i}catch(e){return qe.error("Unexpected exception while deciding variation for experiment[".concat(t,"]. Returning default variation[").concat(r,"] : ").concat(e)),r}},t.prototype.variationDetail=function(t,e,r){var n;void 0===r&&(r="A");try{var i={command:"variationDetail",parameters:{experimentKey:t,defaultVariation:r,user:this.convertUser(e)}},o=this.invocationProcessor.process(i);if(null===o)throw new Error("invoke result data not exists");return O.of(o.variation,o.reason,new T(new Map(Object.entries(null!==(n=o.config.parameters)&&void 0!==n?n:{}))))}catch(e){return qe.error("Unexpected exception while deciding variation for experiment[".concat(t,"]. Returning default variation[").concat(r,"] : ").concat(e)),O.of(r,S.EXCEPTION)}},t.prototype.isFeatureOn=function(t,e){try{var r={command:"isFeatureOn",parameters:{featureKey:t,user:this.convertUser(e)}},n=this.invocationProcessor.process(r);if(null===n)throw new Error("invoke result data not exists");return Boolean(n)}catch(e){return qe.error("Unexpected exception while deciding feature flag[".concat(t,"]. Returning default value[false] : ").concat(e)),!1}},t.prototype.featureFlagDetail=function(t,e){var r;try{var n={command:"featureFlagDetail",parameters:{featureKey:t,user:this.convertUser(e)}},i=this.invocationProcessor.process(n);if(null===i)throw new Error("invoke result data not exists");return new R(i.isOn,i.reason,new T(new Map(Object.entries(null!==(r=i.config.parameters)&&void 0!==r?r:{}))))}catch(e){return qe.error("Unexpected exception while deciding feature flag[".concat(t,"]. Returning default value[false] : ").concat(e)),R.off(S.EXCEPTION)}},t.prototype.track=function(t,e){try{var r={command:"track",parameters:{event:this.convertEvent(t),user:this.convertUser(e)}};this.invocationProcessor.process(r)}catch(t){qe.error("Unexpected exception while tracking event: ".concat(t))}},t.prototype.trackPageView=function(t){qe.info("Web to app integration feature is not support 'trackPageView' method")},t.prototype.remoteConfig=function(t){return new Ve(this.invocationProcessor,this.convertUser(t))},t.prototype.onReady=function(t,e){t()},t.prototype.showUserExplorer=function(){try{this.invocationProcessor.process({command:"showUserExplorer"})}catch(t){qe.error("Unexpected exception while show userExplorer: ".concat(t))}},t.prototype.hideUserExplorer=function(){qe.info("Web to app integration feature is not support 'hideUserExplorer' method")},t.prototype.onInitialized=function(t){return Promise.resolve({success:!0})},t.prototype.close=function(){qe.info("Web to app integration feature is not support 'close' method")},t.prototype.convertEvent=function(t){return"string"==typeof t?{key:t}:t},t.prototype.convertUser=function(t){var e;return"string"==typeof t?t:t&&null!==(e=j(t))&&void 0!==e?e:void 0},t.prototype.defaultUser=function(){return{deviceId:Be()}},t}(),We="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},$e=function(t){return t&&t.Math==Math&&t},Ze=$e("object"==typeof globalThis&&globalThis)||$e("object"==typeof window&&window)||$e("object"==typeof self&&self)||$e("object"==typeof We&&We)||function(){return this}()||Function("return this")(),Qe={},tr=function(t){try{return!!t()}catch(t){return!0}},er=!tr((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),rr=!tr((function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype")})),nr=rr,ir=Function.prototype.call,or=nr?ir.bind(ir):function(){return ir.apply(ir,arguments)},sr={},ur={}.propertyIsEnumerable,ar=Object.getOwnPropertyDescriptor,cr=ar&&!ur.call({1:2},1);sr.f=cr?function(t){var e=ar(this,t);return!!e&&e.enumerable}:ur;var pr,fr,lr=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},hr=rr,dr=Function.prototype,vr=dr.bind,yr=dr.call,mr=hr&&vr.bind(yr,yr),gr=hr?function(t){return t&&mr(t)}:function(t){return t&&function(){return yr.apply(t,arguments)}},Er=gr,wr=Er({}.toString),Tr=Er("".slice),_r=function(t){return Tr(wr(t),8,-1)},Ir=tr,Ar=_r,br=Object,Nr=gr("".split),Or=Ir((function(){return!br("z").propertyIsEnumerable(0)}))?function(t){return"String"==Ar(t)?Nr(t,""):br(t)}:br,Rr=TypeError,xr=function(t){if(null==t)throw Rr("Can't call method on "+t);return t},Mr=Or,Sr=xr,Cr=function(t){return Mr(Sr(t))},Ur=function(t){return"function"==typeof t},Pr=Ur,kr=function(t){return"object"==typeof t?null!==t:Pr(t)},Dr=Ze,Lr=Ur,Fr=function(t){return Lr(t)?t:void 0},Vr=function(t,e){return arguments.length<2?Fr(Dr[t]):Dr[t]&&Dr[t][e]},jr=gr({}.isPrototypeOf),Gr=Vr("navigator","userAgent")||"",Hr=Ze,Br=Gr,Kr=Hr.process,zr=Hr.Deno,Jr=Kr&&Kr.versions||zr&&zr.version,Yr=Jr&&Jr.v8;Yr&&(fr=(pr=Yr.split("."))[0]>0&&pr[0]<4?1:+(pr[0]+pr[1])),!fr&&Br&&(!(pr=Br.match(/Edge\/(\d+)/))||pr[1]>=74)&&(pr=Br.match(/Chrome\/(\d+)/))&&(fr=+pr[1]);var qr=fr,Xr=qr,Wr=tr,$r=!!Object.getOwnPropertySymbols&&!Wr((function(){var t=Symbol();return!String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&Xr&&Xr<41})),Zr=$r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,Qr=Vr,tn=Ur,en=jr,rn=Object,nn=Zr?function(t){return"symbol"==typeof t}:function(t){var e=Qr("Symbol");return tn(e)&&en(e.prototype,rn(t))},on=String,sn=function(t){try{return on(t)}catch(t){return"Object"}},un=Ur,an=sn,cn=TypeError,pn=function(t){if(un(t))return t;throw cn(an(t)+" is not a function")},fn=pn,ln=function(t,e){var r=t[e];return null==r?void 0:fn(r)},hn=or,dn=Ur,vn=kr,yn=TypeError,mn={exports:{}},gn=Ze,En=Object.defineProperty,wn=function(t,e){try{En(gn,t,{value:e,configurable:!0,writable:!0})}catch(r){gn[t]=e}return e},Tn=wn,_n=Ze["__core-js_shared__"]||Tn("__core-js_shared__",{}),In=_n;(mn.exports=function(t,e){return In[t]||(In[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.24.1",mode:"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE",source:"https://github.com/zloirock/core-js"});var An=xr,bn=Object,Nn=function(t){return bn(An(t))},On=Nn,Rn=gr({}.hasOwnProperty),xn=Object.hasOwn||function(t,e){return Rn(On(t),e)},Mn=gr,Sn=0,Cn=Math.random(),Un=Mn(1..toString),Pn=function(t){return"Symbol("+(void 0===t?"":t)+")_"+Un(++Sn+Cn,36)},kn=Ze,Dn=mn.exports,Ln=xn,Fn=Pn,Vn=$r,jn=Zr,Gn=Dn("wks"),Hn=kn.Symbol,Bn=Hn&&Hn.for,Kn=jn?Hn:Hn&&Hn.withoutSetter||Fn,zn=function(t){if(!Ln(Gn,t)||!Vn&&"string"!=typeof Gn[t]){var e="Symbol."+t;Vn&&Ln(Hn,t)?Gn[t]=Hn[t]:Gn[t]=jn&&Bn?Bn(e):Kn(e)}return Gn[t]},Jn=or,Yn=kr,qn=nn,Xn=ln,Wn=function(t,e){var r,n;if("string"===e&&dn(r=t.toString)&&!vn(n=hn(r,t)))return n;if(dn(r=t.valueOf)&&!vn(n=hn(r,t)))return n;if("string"!==e&&dn(r=t.toString)&&!vn(n=hn(r,t)))return n;throw yn("Can't convert object to primitive value")},$n=TypeError,Zn=zn("toPrimitive"),Qn=function(t,e){if(!Yn(t)||qn(t))return t;var r,n=Xn(t,Zn);if(n){if(void 0===e&&(e="default"),r=Jn(n,t,e),!Yn(r)||qn(r))return r;throw $n("Can't convert object to primitive value")}return void 0===e&&(e="number"),Wn(t,e)},ti=nn,ei=function(t){var e=Qn(t,"string");return ti(e)?e:e+""},ri=kr,ni=Ze.document,ii=ri(ni)&&ri(ni.createElement),oi=function(t){return ii?ni.createElement(t):{}},si=oi,ui=!er&&!tr((function(){return 7!=Object.defineProperty(si("div"),"a",{get:function(){return 7}}).a})),ai=er,ci=or,pi=sr,fi=lr,li=Cr,hi=ei,di=xn,vi=ui,yi=Object.getOwnPropertyDescriptor;Qe.f=ai?yi:function(t,e){if(t=li(t),e=hi(e),vi)try{return yi(t,e)}catch(t){}if(di(t,e))return fi(!ci(pi.f,t,e),t[e])};var mi={},gi=er&&tr((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype})),Ei=kr,wi=String,Ti=TypeError,_i=function(t){if(Ei(t))return t;throw Ti(wi(t)+" is not an object")},Ii=er,Ai=ui,bi=gi,Ni=_i,Oi=ei,Ri=TypeError,xi=Object.defineProperty,Mi=Object.getOwnPropertyDescriptor;mi.f=Ii?bi?function(t,e,r){if(Ni(t),e=Oi(e),Ni(r),"function"==typeof t&&"prototype"===e&&"value"in r&&"writable"in r&&!r.writable){var n=Mi(t,e);n&&n.writable&&(t[e]=r.value,r={configurable:"configurable"in r?r.configurable:n.configurable,enumerable:"enumerable"in r?r.enumerable:n.enumerable,writable:!1})}return xi(t,e,r)}:xi:function(t,e,r){if(Ni(t),e=Oi(e),Ni(r),Ai)try{return xi(t,e,r)}catch(t){}if("get"in r||"set"in r)throw Ri("Accessors not supported");return"value"in r&&(t[e]=r.value),t};var Si=mi,Ci=lr,Ui=er?function(t,e,r){return Si.f(t,e,Ci(1,r))}:function(t,e,r){return t[e]=r,t},Pi={exports:{}},ki=er,Di=xn,Li=Function.prototype,Fi=ki&&Object.getOwnPropertyDescriptor,Vi=Di(Li,"name"),ji={EXISTS:Vi,PROPER:Vi&&"something"===function(){}.name,CONFIGURABLE:Vi&&(!ki||ki&&Fi(Li,"name").configurable)},Gi=Ur,Hi=_n,Bi=gr(Function.toString);Gi(Hi.inspectSource)||(Hi.inspectSource=function(t){return Bi(t)});var Ki,zi,Ji,Yi=Hi.inspectSource,qi=Ur,Xi=Yi,Wi=Ze.WeakMap,$i=qi(Wi)&&/native code/.test(Xi(Wi)),Zi=mn.exports,Qi=Pn,to=Zi("keys"),eo=function(t){return to[t]||(to[t]=Qi(t))},ro={},no=$i,io=Ze,oo=gr,so=kr,uo=Ui,ao=xn,co=_n,po=eo,fo=ro,lo=io.TypeError,ho=io.WeakMap;if(no||co.state){var vo=co.state||(co.state=new ho),yo=oo(vo.get),mo=oo(vo.has),go=oo(vo.set);Ki=function(t,e){if(mo(vo,t))throw new lo("Object already initialized");return e.facade=t,go(vo,t,e),e},zi=function(t){return yo(vo,t)||{}},Ji=function(t){return mo(vo,t)}}else{var Eo=po("state");fo[Eo]=!0,Ki=function(t,e){if(ao(t,Eo))throw new lo("Object already initialized");return e.facade=t,uo(t,Eo,e),e},zi=function(t){return ao(t,Eo)?t[Eo]:{}},Ji=function(t){return ao(t,Eo)}}var wo={set:Ki,get:zi,has:Ji,enforce:function(t){return Ji(t)?zi(t):Ki(t,{})},getterFor:function(t){return function(e){var r;if(!so(e)||(r=zi(e)).type!==t)throw lo("Incompatible receiver, "+t+" required");return r}}},To=tr,_o=Ur,Io=xn,Ao=er,bo=ji.CONFIGURABLE,No=Yi,Oo=wo.enforce,Ro=wo.get,xo=Object.defineProperty,Mo=Ao&&!To((function(){return 8!==xo((function(){}),"length",{value:8}).length})),So=String(String).split("String"),Co=Pi.exports=function(t,e,r){"Symbol("===String(e).slice(0,7)&&(e="["+String(e).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),r&&r.getter&&(e="get "+e),r&&r.setter&&(e="set "+e),(!Io(t,"name")||bo&&t.name!==e)&&(Ao?xo(t,"name",{value:e,configurable:!0}):t.name=e),Mo&&r&&Io(r,"arity")&&t.length!==r.arity&&xo(t,"length",{value:r.arity});try{r&&Io(r,"constructor")&&r.constructor?Ao&&xo(t,"prototype",{writable:!1}):t.prototype&&(t.prototype=void 0)}catch(t){}var n=Oo(t);return Io(n,"source")||(n.source=So.join("string"==typeof e?e:"")),t};Function.prototype.toString=Co((function(){return _o(this)&&Ro(this).source||No(this)}),"toString");var Uo=Ur,Po=mi,ko=Pi.exports,Do=wn,Lo=function(t,e,r,n){n||(n={});var i=n.enumerable,o=void 0!==n.name?n.name:e;if(Uo(r)&&ko(r,o,n),n.global)i?t[e]=r:Do(e,r);else{try{n.unsafe?t[e]&&(i=!0):delete t[e]}catch(t){}i?t[e]=r:Po.f(t,e,{value:r,enumerable:!1,configurable:!n.nonConfigurable,writable:!n.nonWritable})}return t},Fo={},Vo=Math.ceil,jo=Math.floor,Go=Math.trunc||function(t){var e=+t;return(e>0?jo:Vo)(e)},Ho=function(t){var e=+t;return e!=e||0===e?0:Go(e)},Bo=Ho,Ko=Math.max,zo=Math.min,Jo=function(t,e){var r=Bo(t);return r<0?Ko(r+e,0):zo(r,e)},Yo=Ho,qo=Math.min,Xo=function(t){return t>0?qo(Yo(t),9007199254740991):0},Wo=function(t){return Xo(t.length)},$o=Cr,Zo=Jo,Qo=Wo,ts=function(t){return function(e,r,n){var i,o=$o(e),s=Qo(o),u=Zo(n,s);if(t&&r!=r){for(;s>u;)if((i=o[u++])!=i)return!0}else for(;s>u;u++)if((t||u in o)&&o[u]===r)return t||u||0;return!t&&-1}},es={includes:ts(!0),indexOf:ts(!1)},rs=xn,ns=Cr,is=es.indexOf,os=ro,ss=gr([].push),us=function(t,e){var r,n=ns(t),i=0,o=[];for(r in n)!rs(os,r)&&rs(n,r)&&ss(o,r);for(;e.length>i;)rs(n,r=e[i++])&&(~is(o,r)||ss(o,r));return o},as=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],cs=us,ps=as.concat("length","prototype");Fo.f=Object.getOwnPropertyNames||function(t){return cs(t,ps)};var fs={};fs.f=Object.getOwnPropertySymbols;var ls=Vr,hs=Fo,ds=fs,vs=_i,ys=gr([].concat),ms=ls("Reflect","ownKeys")||function(t){var e=hs.f(vs(t)),r=ds.f;return r?ys(e,r(t)):e},gs=xn,Es=ms,ws=Qe,Ts=mi,_s=function(t,e,r){for(var n=Es(e),i=Ts.f,o=ws.f,s=0;s<n.length;s++){var u=n[s];gs(t,u)||r&&gs(r,u)||i(t,u,o(e,u))}},Is=tr,As=Ur,bs=/#|\.prototype\./,Ns=function(t,e){var r=Rs[Os(t)];return r==Ms||r!=xs&&(As(e)?Is(e):!!e)},Os=Ns.normalize=function(t){return String(t).replace(bs,".").toLowerCase()},Rs=Ns.data={},xs=Ns.NATIVE="N",Ms=Ns.POLYFILL="P",Ss=Ns,Cs=Ze,Us=Qe.f,Ps=Ui,ks=Lo,Ds=wn,Ls=_s,Fs=Ss,Vs=function(t,e){var r,n,i,o,s,u=t.target,a=t.global,c=t.stat;if(r=a?Cs:c?Cs[u]||Ds(u,{}):(Cs[u]||{}).prototype)for(n in e){if(o=e[n],i=t.dontCallGetSet?(s=Us(r,n))&&s.value:r[n],!Fs(a?n:u+(c?".":"#")+n,t.forced)&&void 0!==i){if(typeof o==typeof i)continue;Ls(o,i)}(t.sham||i&&i.sham)&&Ps(o,"sham",!0),ks(r,n,o,t)}},js=!tr((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),Gs=xn,Hs=Ur,Bs=Nn,Ks=js,zs=eo("IE_PROTO"),Js=Object,Ys=Js.prototype,qs=Ks?Js.getPrototypeOf:function(t){var e=Bs(t);if(Gs(e,zs))return e[zs];var r=e.constructor;return Hs(r)&&e instanceof r?r.prototype:e instanceof Js?Ys:null},Xs=Ur,Ws=String,$s=TypeError,Zs=gr,Qs=_i,tu=function(t){if("object"==typeof t||Xs(t))return t;throw $s("Can't set "+Ws(t)+" as a prototype")},eu=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,r={};try{(t=Zs(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(r,[]),e=r instanceof Array}catch(t){}return function(r,n){return Qs(r),tu(n),e?t(r,n):r.__proto__=n,r}}():void 0),ru={},nu=us,iu=as,ou=Object.keys||function(t){return nu(t,iu)},su=er,uu=gi,au=mi,cu=_i,pu=Cr,fu=ou;ru.f=su&&!uu?Object.defineProperties:function(t,e){cu(t);for(var r,n=pu(e),i=fu(e),o=i.length,s=0;o>s;)au.f(t,r=i[s++],n[r]);return t};var lu,hu=Vr("document","documentElement"),du=_i,vu=ru,yu=as,mu=ro,gu=hu,Eu=oi,wu=eo("IE_PROTO"),Tu=function(){},_u=function(t){return"<script>"+t+"<\/script>"},Iu=function(t){t.write(_u("")),t.close();var e=t.parentWindow.Object;return t=null,e},Au=function(){try{lu=new ActiveXObject("htmlfile")}catch(t){}var t,e;Au="undefined"!=typeof document?document.domain&&lu?Iu(lu):((e=Eu("iframe")).style.display="none",gu.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(_u("document.F=Object")),t.close(),t.F):Iu(lu);for(var r=yu.length;r--;)delete Au.prototype[yu[r]];return Au()};mu[wu]=!0;var bu=Object.create||function(t,e){var r;return null!==t?(Tu.prototype=du(t),r=new Tu,Tu.prototype=null,r[wu]=t):r=Au(),void 0===e?r:vu.f(r,e)},Nu=Error,Ou=gr("".replace),Ru=String(Nu("zxcasd").stack),xu=/\n\s*at [^:]*:[^\n]*/,Mu=xu.test(Ru),Su=kr,Cu=Ui,Uu=pn,Pu=rr,ku=gr(gr.bind),Du=function(t,e){return Uu(t),void 0===e?t:Pu?ku(t,e):function(){return t.apply(e,arguments)}},Lu={},Fu=Lu,Vu=zn("iterator"),ju=Array.prototype,Gu=function(t){return void 0!==t&&(Fu.Array===t||ju[Vu]===t)},Hu={};Hu[zn("toStringTag")]="z";var Bu="[object z]"===String(Hu),Ku=Bu,zu=Ur,Ju=_r,Yu=zn("toStringTag"),qu=Object,Xu="Arguments"==Ju(function(){return arguments}()),Wu=Ku?Ju:function(t){var e,r,n;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,e){try{return t[e]}catch(t){}}(e=qu(t),Yu))?r:Xu?Ju(e):"Object"==(n=Ju(e))&&zu(e.callee)?"Arguments":n},$u=Wu,Zu=ln,Qu=Lu,ta=zn("iterator"),ea=function(t){if(null!=t)return Zu(t,ta)||Zu(t,"@@iterator")||Qu[$u(t)]},ra=or,na=pn,ia=_i,oa=sn,sa=ea,ua=TypeError,aa=function(t,e){var r=arguments.length<2?sa(t):e;if(na(r))return ia(ra(r,t));throw ua(oa(t)+" is not iterable")},ca=or,pa=_i,fa=ln,la=function(t,e,r){var n,i;pa(t);try{if(!(n=fa(t,"return"))){if("throw"===e)throw r;return r}n=ca(n,t)}catch(t){i=!0,n=t}if("throw"===e)throw r;if(i)throw n;return pa(n),r},ha=Du,da=or,va=_i,ya=sn,ma=Gu,ga=Wo,Ea=jr,wa=aa,Ta=ea,_a=la,Ia=TypeError,Aa=function(t,e){this.stopped=t,this.result=e},ba=Aa.prototype,Na=function(t,e,r){var n,i,o,s,u,a,c,p=r&&r.that,f=!(!r||!r.AS_ENTRIES),l=!(!r||!r.IS_RECORD),h=!(!r||!r.IS_ITERATOR),d=!(!r||!r.INTERRUPTED),v=ha(e,p),y=function(t){return n&&_a(n,"normal",t),new Aa(!0,t)},m=function(t){return f?(va(t),d?v(t[0],t[1],y):v(t[0],t[1])):d?v(t,y):v(t)};if(l)n=t.iterator;else if(h)n=t;else{if(!(i=Ta(t)))throw Ia(ya(t)+" is not iterable");if(ma(i)){for(o=0,s=ga(t);s>o;o++)if((u=m(t[o]))&&Ea(ba,u))return u;return new Aa(!1)}n=wa(t,i)}for(a=l?t.next:n.next;!(c=da(a,n)).done;){try{u=m(c.value)}catch(t){_a(n,"throw",t)}if("object"==typeof u&&u&&Ea(ba,u))return u}return new Aa(!1)},Oa=Wu,Ra=String,xa=function(t){if("Symbol"===Oa(t))throw TypeError("Cannot convert a Symbol value to a string");return Ra(t)},Ma=xa,Sa=lr,Ca=!tr((function(){var t=Error("a");return!("stack"in t)||(Object.defineProperty(t,"stack",Sa(1,7)),7!==t.stack)})),Ua=Vs,Pa=jr,ka=qs,Da=eu,La=_s,Fa=bu,Va=Ui,ja=lr,Ga=function(t,e){if(Mu&&"string"==typeof t&&!Nu.prepareStackTrace)for(;e--;)t=Ou(t,xu,"");return t},Ha=function(t,e){Su(e)&&"cause"in e&&Cu(t,"cause",e.cause)},Ba=Na,Ka=function(t,e){return void 0===t?arguments.length<2?"":e:Ma(t)},za=Ca,Ja=zn("toStringTag"),Ya=Error,qa=[].push,Xa=function(t,e){var r,n=arguments.length>2?arguments[2]:void 0,i=Pa(Wa,this);Da?r=Da(new Ya,i?ka(this):Wa):(r=i?this:Fa(Wa),Va(r,Ja,"Error")),void 0!==e&&Va(r,"message",Ka(e)),za&&Va(r,"stack",Ga(r.stack,1)),Ha(r,n);var o=[];return Ba(t,qa,{that:o}),Va(r,"errors",o),r};Da?Da(Xa,Ya):La(Xa,Ya,{name:!0});var Wa=Xa.prototype=Fa(Ya.prototype,{constructor:ja(1,Xa),message:ja(1,""),name:ja(1,"AggregateError")});Ua({global:!0,constructor:!0,arity:2},{AggregateError:Xa});var $a=zn,Za=bu,Qa=mi.f,tc=$a("unscopables"),ec=Array.prototype;null==ec[tc]&&Qa(ec,tc,{configurable:!0,value:Za(null)});var rc,nc,ic,oc=function(t){ec[tc][t]=!0},sc=tr,uc=Ur,ac=qs,cc=Lo,pc=zn("iterator"),fc=!1;[].keys&&("next"in(ic=[].keys())?(nc=ac(ac(ic)))!==Object.prototype&&(rc=nc):fc=!0);var lc=null==rc||sc((function(){var t={};return rc[pc].call(t)!==t}));lc&&(rc={}),uc(rc[pc])||cc(rc,pc,(function(){return this}));var hc={IteratorPrototype:rc,BUGGY_SAFARI_ITERATORS:fc},dc=mi.f,vc=xn,yc=zn("toStringTag"),mc=function(t,e,r){t&&!r&&(t=t.prototype),t&&!vc(t,yc)&&dc(t,yc,{configurable:!0,value:e})},gc=hc.IteratorPrototype,Ec=bu,wc=lr,Tc=mc,_c=Lu,Ic=function(){return this},Ac=Vs,bc=or,Nc=Ur,Oc=function(t,e,r,n){var i=e+" Iterator";return t.prototype=Ec(gc,{next:wc(+!n,r)}),Tc(t,i,!1),_c[i]=Ic,t},Rc=qs,xc=eu,Mc=mc,Sc=Ui,Cc=Lo,Uc=Lu,Pc=ji.PROPER,kc=ji.CONFIGURABLE,Dc=hc.IteratorPrototype,Lc=hc.BUGGY_SAFARI_ITERATORS,Fc=zn("iterator"),Vc=function(){return this},jc=function(t,e,r,n,i,o,s){Oc(r,e,n);var u,a,c,p=function(t){if(t===i&&v)return v;if(!Lc&&t in h)return h[t];switch(t){case"keys":case"values":case"entries":return function(){return new r(this,t)}}return function(){return new r(this)}},f=e+" Iterator",l=!1,h=t.prototype,d=h[Fc]||h["@@iterator"]||i&&h[i],v=!Lc&&d||p(i),y="Array"==e&&h.entries||d;if(y&&(u=Rc(y.call(new t)))!==Object.prototype&&u.next&&(Rc(u)!==Dc&&(xc?xc(u,Dc):Nc(u[Fc])||Cc(u,Fc,Vc)),Mc(u,f,!0)),Pc&&"values"==i&&d&&"values"!==d.name&&(kc?Sc(h,"name","values"):(l=!0,v=function(){return bc(d,this)})),i)if(a={values:p("values"),keys:o?v:p("keys"),entries:p("entries")},s)for(c in a)(Lc||l||!(c in h))&&Cc(h,c,a[c]);else Ac({target:e,proto:!0,forced:Lc||l},a);return h[Fc]!==v&&Cc(h,Fc,v,{name:i}),Uc[e]=v,a},Gc=Cr,Hc=oc,Bc=Lu,Kc=wo,zc=mi.f,Jc=jc,Yc=er,qc=Kc.set,Xc=Kc.getterFor("Array Iterator"),Wc=Jc(Array,"Array",(function(t,e){qc(this,{type:"Array Iterator",target:Gc(t),index:0,kind:e})}),(function(){var t=Xc(this),e=t.target,r=t.kind,n=t.index++;return!e||n>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:e[n],done:!1}:{value:[n,e[n]],done:!1}}),"values"),$c=Bc.Arguments=Bc.Array;if(Hc("keys"),Hc("values"),Hc("entries"),Yc&&"values"!==$c.name)try{zc($c,"name",{value:"values"})}catch(t){}var Zc=Wu,Qc=Bu?{}.toString:function(){return"[object "+Zc(this)+"]"};Bu||Lo(Object.prototype,"toString",Qc,{unsafe:!0});var tp="process"==_r(Ze.process),ep=Vr,rp=mi,np=er,ip=zn("species"),op=function(t){var e=ep(t),r=rp.f;np&&e&&!e[ip]&&r(e,ip,{configurable:!0,get:function(){return this}})},sp=jr,up=TypeError,ap=function(t,e){if(sp(e,t))return t;throw up("Incorrect invocation")},cp=gr,pp=tr,fp=Ur,lp=Wu,hp=Yi,dp=function(){},vp=[],yp=Vr("Reflect","construct"),mp=/^\s*(?:class|function)\b/,gp=cp(mp.exec),Ep=!mp.exec(dp),wp=function(t){if(!fp(t))return!1;try{return yp(dp,vp,t),!0}catch(t){return!1}},Tp=function(t){if(!fp(t))return!1;switch(lp(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}try{return Ep||!!gp(mp,hp(t))}catch(t){return!0}};Tp.sham=!0;var _p,Ip,Ap,bp,Np=!yp||pp((function(){var t;return wp(wp.call)||!wp(Object)||!wp((function(){t=!0}))||t}))?Tp:wp,Op=Np,Rp=sn,xp=TypeError,Mp=_i,Sp=function(t){if(Op(t))return t;throw xp(Rp(t)+" is not a constructor")},Cp=zn("species"),Up=function(t,e){var r,n=Mp(t).constructor;return void 0===n||null==(r=Mp(n)[Cp])?e:Sp(r)},Pp=rr,kp=Function.prototype,Dp=kp.apply,Lp=kp.call,Fp="object"==typeof Reflect&&Reflect.apply||(Pp?Lp.bind(Dp):function(){return Lp.apply(Dp,arguments)}),Vp=gr([].slice),jp=TypeError,Gp=/(?:ipad|iphone|ipod).*applewebkit/i.test(Gr),Hp=Ze,Bp=Fp,Kp=Du,zp=Ur,Jp=xn,Yp=tr,qp=hu,Xp=Vp,Wp=oi,$p=function(t,e){if(t<e)throw jp("Not enough arguments");return t},Zp=Gp,Qp=tp,tf=Hp.setImmediate,ef=Hp.clearImmediate,rf=Hp.process,nf=Hp.Dispatch,of=Hp.Function,sf=Hp.MessageChannel,uf=Hp.String,af=0,cf={};try{_p=Hp.location}catch(t){}var pf=function(t){if(Jp(cf,t)){var e=cf[t];delete cf[t],e()}},ff=function(t){return function(){pf(t)}},lf=function(t){pf(t.data)},hf=function(t){Hp.postMessage(uf(t),_p.protocol+"//"+_p.host)};tf&&ef||(tf=function(t){$p(arguments.length,1);var e=zp(t)?t:of(t),r=Xp(arguments,1);return cf[++af]=function(){Bp(e,void 0,r)},Ip(af),af},ef=function(t){delete cf[t]},Qp?Ip=function(t){rf.nextTick(ff(t))}:nf&&nf.now?Ip=function(t){nf.now(ff(t))}:sf&&!Zp?(bp=(Ap=new sf).port2,Ap.port1.onmessage=lf,Ip=Kp(bp.postMessage,bp)):Hp.addEventListener&&zp(Hp.postMessage)&&!Hp.importScripts&&_p&&"file:"!==_p.protocol&&!Yp(hf)?(Ip=hf,Hp.addEventListener("message",lf,!1)):Ip="onreadystatechange"in Wp("script")?function(t){qp.appendChild(Wp("script")).onreadystatechange=function(){qp.removeChild(this),pf(t)}}:function(t){setTimeout(ff(t),0)});var df,vf,yf,mf,gf,Ef,wf,Tf,_f={set:tf,clear:ef},If=Ze,Af=/ipad|iphone|ipod/i.test(Gr)&&void 0!==If.Pebble,bf=/web0s(?!.*chrome)/i.test(Gr),Nf=Ze,Of=Du,Rf=Qe.f,xf=_f.set,Mf=Gp,Sf=Af,Cf=bf,Uf=tp,Pf=Nf.MutationObserver||Nf.WebKitMutationObserver,kf=Nf.document,Df=Nf.process,Lf=Nf.Promise,Ff=Rf(Nf,"queueMicrotask"),Vf=Ff&&Ff.value;Vf||(df=function(){var t,e;for(Uf&&(t=Df.domain)&&t.exit();vf;){e=vf.fn,vf=vf.next;try{e()}catch(t){throw vf?mf():yf=void 0,t}}yf=void 0,t&&t.enter()},Mf||Uf||Cf||!Pf||!kf?!Sf&&Lf&&Lf.resolve?((wf=Lf.resolve(void 0)).constructor=Lf,Tf=Of(wf.then,wf),mf=function(){Tf(df)}):Uf?mf=function(){Df.nextTick(df)}:(xf=Of(xf,Nf),mf=function(){xf(df)}):(gf=!0,Ef=kf.createTextNode(""),new Pf(df).observe(Ef,{characterData:!0}),mf=function(){Ef.data=gf=!gf}));var jf=Vf||function(t){var e={fn:t,next:void 0};yf&&(yf.next=e),vf||(vf=e,mf()),yf=e},Gf=Ze,Hf=function(t){try{return{error:!1,value:t()}}catch(t){return{error:!0,value:t}}},Bf=function(){this.head=null,this.tail=null};Bf.prototype={add:function(t){var e={item:t,next:null};this.head?this.tail.next=e:this.head=e,this.tail=e},get:function(){var t=this.head;if(t)return this.head=t.next,this.tail===t&&(this.tail=null),t.item}};var Kf=Bf,zf=Ze.Promise,Jf="object"==typeof Deno&&Deno&&"object"==typeof Deno.version,Yf=!Jf&&!tp&&"object"==typeof window&&"object"==typeof document,qf=Ze,Xf=zf,Wf=Ur,$f=Ss,Zf=Yi,Qf=zn,tl=Yf,el=Jf,rl=qr;Xf&&Xf.prototype;var nl=Qf("species"),il=!1,ol=Wf(qf.PromiseRejectionEvent),sl=$f("Promise",(function(){var t=Zf(Xf),e=t!==String(Xf);if(!e&&66===rl)return!0;if(!rl||rl<51||!/native code/.test(t)){var r=new Xf((function(t){t(1)})),n=function(t){t((function(){}),(function(){}))};if((r.constructor={})[nl]=n,!(il=r.then((function(){}))instanceof n))return!0}return!e&&(tl||el)&&!ol})),ul={CONSTRUCTOR:sl,REJECTION_EVENT:ol,SUBCLASSING:il},al={},cl=pn,pl=function(t){var e,r;this.promise=new t((function(t,n){if(void 0!==e||void 0!==r)throw TypeError("Bad Promise constructor");e=t,r=n})),this.resolve=cl(e),this.reject=cl(r)};al.f=function(t){return new pl(t)};var fl,ll,hl,dl=Vs,vl=tp,yl=Ze,ml=or,gl=Lo,El=eu,wl=mc,Tl=op,_l=pn,Il=Ur,Al=kr,bl=ap,Nl=Up,Ol=_f.set,Rl=jf,xl=function(t,e){var r=Gf.console;r&&r.error&&(1==arguments.length?r.error(t):r.error(t,e))},Ml=Hf,Sl=Kf,Cl=wo,Ul=zf,Pl=al,kl=ul.CONSTRUCTOR,Dl=ul.REJECTION_EVENT,Ll=ul.SUBCLASSING,Fl=Cl.getterFor("Promise"),Vl=Cl.set,jl=Ul&&Ul.prototype,Gl=Ul,Hl=jl,Bl=yl.TypeError,Kl=yl.document,zl=yl.process,Jl=Pl.f,Yl=Jl,ql=!!(Kl&&Kl.createEvent&&yl.dispatchEvent),Xl=function(t){var e;return!(!Al(t)||!Il(e=t.then))&&e},Wl=function(t,e){var r,n,i,o=e.value,s=1==e.state,u=s?t.ok:t.fail,a=t.resolve,c=t.reject,p=t.domain;try{u?(s||(2===e.rejection&&eh(e),e.rejection=1),!0===u?r=o:(p&&p.enter(),r=u(o),p&&(p.exit(),i=!0)),r===t.promise?c(Bl("Promise-chain cycle")):(n=Xl(r))?ml(n,r,a,c):a(r)):c(o)}catch(t){p&&!i&&p.exit(),c(t)}},$l=function(t,e){t.notified||(t.notified=!0,Rl((function(){for(var r,n=t.reactions;r=n.get();)Wl(r,t);t.notified=!1,e&&!t.rejection&&Ql(t)})))},Zl=function(t,e,r){var n,i;ql?((n=Kl.createEvent("Event")).promise=e,n.reason=r,n.initEvent(t,!1,!0),yl.dispatchEvent(n)):n={promise:e,reason:r},!Dl&&(i=yl["on"+t])?i(n):"unhandledrejection"===t&&xl("Unhandled promise rejection",r)},Ql=function(t){ml(Ol,yl,(function(){var e,r=t.facade,n=t.value;if(th(t)&&(e=Ml((function(){vl?zl.emit("unhandledRejection",n,r):Zl("unhandledrejection",r,n)})),t.rejection=vl||th(t)?2:1,e.error))throw e.value}))},th=function(t){return 1!==t.rejection&&!t.parent},eh=function(t){ml(Ol,yl,(function(){var e=t.facade;vl?zl.emit("rejectionHandled",e):Zl("rejectionhandled",e,t.value)}))},rh=function(t,e,r){return function(n){t(e,n,r)}},nh=function(t,e,r){t.done||(t.done=!0,r&&(t=r),t.value=e,t.state=2,$l(t,!0))},ih=function(t,e,r){if(!t.done){t.done=!0,r&&(t=r);try{if(t.facade===e)throw Bl("Promise can't be resolved itself");var n=Xl(e);n?Rl((function(){var r={done:!1};try{ml(n,e,rh(ih,r,t),rh(nh,r,t))}catch(e){nh(r,e,t)}})):(t.value=e,t.state=1,$l(t,!1))}catch(e){nh({done:!1},e,t)}}};if(kl&&(Hl=(Gl=function(t){bl(this,Hl),_l(t),ml(fl,this);var e=Fl(this);try{t(rh(ih,e),rh(nh,e))}catch(t){nh(e,t)}}).prototype,(fl=function(t){Vl(this,{type:"Promise",done:!1,notified:!1,parent:!1,reactions:new Sl,rejection:!1,state:0,value:void 0})}).prototype=gl(Hl,"then",(function(t,e){var r=Fl(this),n=Jl(Nl(this,Gl));return r.parent=!0,n.ok=!Il(t)||t,n.fail=Il(e)&&e,n.domain=vl?zl.domain:void 0,0==r.state?r.reactions.add(n):Rl((function(){Wl(n,r)})),n.promise})),ll=function(){var t=new fl,e=Fl(t);this.promise=t,this.resolve=rh(ih,e),this.reject=rh(nh,e)},Pl.f=Jl=function(t){return t===Gl||undefined===t?new ll(t):Yl(t)},Il(Ul)&&jl!==Object.prototype)){hl=jl.then,Ll||gl(jl,"then",(function(t,e){var r=this;return new Gl((function(t,e){ml(hl,r,t,e)})).then(t,e)}),{unsafe:!0});try{delete jl.constructor}catch(t){}El&&El(jl,Hl)}dl({global:!0,constructor:!0,wrap:!0,forced:kl},{Promise:Gl}),wl(Gl,"Promise",!1),Tl("Promise");var oh=zn("iterator"),sh=!1;try{var uh=0,ah={next:function(){return{done:!!uh++}},return:function(){sh=!0}};ah[oh]=function(){return this},Array.from(ah,(function(){throw 2}))}catch(t){}var ch=function(t,e){if(!e&&!sh)return!1;var r=!1;try{var n={};n[oh]=function(){return{next:function(){return{done:r=!0}}}},t(n)}catch(t){}return r},ph=zf,fh=ul.CONSTRUCTOR||!ch((function(t){ph.all(t).then(void 0,(function(){}))})),lh=or,hh=pn,dh=al,vh=Hf,yh=Na;Vs({target:"Promise",stat:!0,forced:fh},{all:function(t){var e=this,r=dh.f(e),n=r.resolve,i=r.reject,o=vh((function(){var r=hh(e.resolve),o=[],s=0,u=1;yh(t,(function(t){var a=s++,c=!1;u++,lh(r,e,t).then((function(t){c||(c=!0,o[a]=t,--u||n(o))}),i)})),--u||n(o)}));return o.error&&i(o.value),r.promise}});var mh=Vs,gh=ul.CONSTRUCTOR,Eh=zf,wh=Vr,Th=Ur,_h=Lo,Ih=Eh&&Eh.prototype;if(mh({target:"Promise",proto:!0,forced:gh,real:!0},{catch:function(t){return this.then(void 0,t)}}),Th(Eh)){var Ah=wh("Promise").prototype.catch;Ih.catch!==Ah&&_h(Ih,"catch",Ah,{unsafe:!0})}var bh=or,Nh=pn,Oh=al,Rh=Hf,xh=Na;Vs({target:"Promise",stat:!0,forced:fh},{race:function(t){var e=this,r=Oh.f(e),n=r.reject,i=Rh((function(){var i=Nh(e.resolve);xh(t,(function(t){bh(i,e,t).then(r.resolve,n)}))}));return i.error&&n(i.value),r.promise}});var Mh=or,Sh=al;Vs({target:"Promise",stat:!0,forced:ul.CONSTRUCTOR},{reject:function(t){var e=Sh.f(this);return Mh(e.reject,void 0,t),e.promise}});var Ch=_i,Uh=kr,Ph=al,kh=function(t,e){if(Ch(t),Uh(e)&&e.constructor===t)return e;var r=Ph.f(t);return(0,r.resolve)(e),r.promise},Dh=Vs,Lh=ul.CONSTRUCTOR,Fh=kh;Vr("Promise"),Dh({target:"Promise",stat:!0,forced:Lh},{resolve:function(t){return Fh(this,t)}});var Vh=or,jh=pn,Gh=al,Hh=Hf,Bh=Na;Vs({target:"Promise",stat:!0},{allSettled:function(t){var e=this,r=Gh.f(e),n=r.resolve,i=r.reject,o=Hh((function(){var r=jh(e.resolve),i=[],o=0,s=1;Bh(t,(function(t){var u=o++,a=!1;s++,Vh(r,e,t).then((function(t){a||(a=!0,i[u]={status:"fulfilled",value:t},--s||n(i))}),(function(t){a||(a=!0,i[u]={status:"rejected",reason:t},--s||n(i))}))})),--s||n(i)}));return o.error&&i(o.value),r.promise}});var Kh=or,zh=pn,Jh=Vr,Yh=al,qh=Hf,Xh=Na;Vs({target:"Promise",stat:!0},{any:function(t){var e=this,r=Jh("AggregateError"),n=Yh.f(e),i=n.resolve,o=n.reject,s=qh((function(){var n=zh(e.resolve),s=[],u=0,a=1,c=!1;Xh(t,(function(t){var p=u++,f=!1;a++,Kh(n,e,t).then((function(t){f||c||(c=!0,i(t))}),(function(t){f||c||(f=!0,s[p]=t,--a||o(new r(s,"No one promise resolved")))}))})),--a||o(new r(s,"No one promise resolved"))}));return s.error&&o(s.value),n.promise}});var Wh=Vs,$h=zf,Zh=tr,Qh=Vr,td=Ur,ed=Up,rd=kh,nd=Lo,id=$h&&$h.prototype;if(Wh({target:"Promise",proto:!0,real:!0,forced:!!$h&&Zh((function(){id.finally.call({then:function(){}},(function(){}))}))},{finally:function(t){var e=ed(this,Qh("Promise")),r=td(t);return this.then(r?function(r){return rd(e,t()).then((function(){return r}))}:t,r?function(r){return rd(e,t()).then((function(){throw r}))}:t)}}),td($h)){var od=Qh("Promise").prototype.finally;id.finally!==od&&nd(id,"finally",od,{unsafe:!0})}var sd=gr,ud=Ho,ad=xa,cd=xr,pd=sd("".charAt),fd=sd("".charCodeAt),ld=sd("".slice),hd=function(t){return function(e,r){var n,i,o=ad(cd(e)),s=ud(r),u=o.length;return s<0||s>=u?t?"":void 0:(n=fd(o,s))<55296||n>56319||s+1===u||(i=fd(o,s+1))<56320||i>57343?t?pd(o,s):n:t?ld(o,s,s+2):i-56320+(n-55296<<10)+65536}},dd={codeAt:hd(!1),charAt:hd(!0)}.charAt,vd=xa,yd=wo,md=jc,gd=yd.set,Ed=yd.getterFor("String Iterator");md(String,"String",(function(t){gd(this,{type:"String Iterator",string:vd(t),index:0})}),(function(){var t,e=Ed(this),r=e.string,n=e.index;return n>=r.length?{value:void 0,done:!0}:(t=dd(r,n),e.index+=t.length,{value:t,done:!1})}));var wd=Ze,Td=(wd.Promise,oi("span").classList),_d=Td&&Td.constructor&&Td.constructor.prototype,Id=_d===Object.prototype?void 0:_d,Ad=Ze,bd={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},Nd=Id,Od=Wc,Rd=Ui,xd=zn,Md=xd("iterator"),Sd=xd("toStringTag"),Cd=Od.values,Ud=function(t,e){if(t){if(t[Md]!==Cd)try{Rd(t,Md,Cd)}catch(e){t[Md]=Cd}if(t[Sd]||Rd(t,Sd,e),bd[e])for(var r in Od)if(t[r]!==Od[r])try{Rd(t,r,Od[r])}catch(e){t[r]=Od[r]}}};for(var Pd in bd)Ud(Ad[Pd]&&Ad[Pd].prototype,Pd);Ud(Nd,"DOMTokenList");var kd=al,Dd=Hf;Vs({target:"Promise",stat:!0,forced:!0},{try:function(t){var e=kd.f(this),r=Dd(t);return(r.error?e.reject:e.resolve)(r.value),e.promise}});var Ld=_i,Fd=la,Vd=ei,jd=mi,Gd=lr,Hd=function(t,e,r){var n=Vd(e);n in t?jd.f(t,n,Gd(0,r)):t[n]=r},Bd=Du,Kd=or,zd=Nn,Jd=function(t,e,r,n){try{return n?e(Ld(r)[0],r[1]):e(r)}catch(e){Fd(t,"throw",e)}},Yd=Gu,qd=Np,Xd=Wo,Wd=Hd,$d=aa,Zd=ea,Qd=Array,tv=function(t){var e=zd(t),r=qd(this),n=arguments.length,i=n>1?arguments[1]:void 0,o=void 0!==i;o&&(i=Bd(i,n>2?arguments[2]:void 0));var s,u,a,c,p,f,l=Zd(e),h=0;if(!l||this===Qd&&Yd(l))for(s=Xd(e),u=r?new this(s):Qd(s);s>h;h++)f=o?i(e[h],h):e[h],Wd(u,h,f);else for(p=(c=$d(e,l)).next,u=r?new this:[];!(a=Kd(p,c)).done;h++)f=o?Jd(c,i,[a.value,h],!0):a.value,Wd(u,h,f);return u.length=h,u};Vs({target:"Array",stat:!0,forced:!ch((function(t){Array.from(t)}))},{from:tv});var ev=_r,rv=Array.isArray||function(t){return"Array"==ev(t)};Vs({target:"Array",stat:!0},{isArray:rv});var nv=Np,iv=Hd,ov=Array;Vs({target:"Array",stat:!0,forced:tr((function(){function t(){}return!(ov.of.call(t)instanceof t)}))},{of:function(){for(var t=0,e=arguments.length,r=new(nv(this)?this:ov)(e);e>t;)iv(r,t,arguments[t++]);return r.length=e,r}});var sv=Nn,uv=Wo,av=Ho,cv=oc;Vs({target:"Array",proto:!0},{at:function(t){var e=sv(this),r=uv(e),n=av(t),i=n>=0?n:r+n;return i<0||i>=r?void 0:e[i]}}),cv("at");var pv=TypeError,fv=function(t){if(t>9007199254740991)throw pv("Maximum allowed index exceeded");return t},lv=rv,hv=Np,dv=kr,vv=zn("species"),yv=Array,mv=function(t){var e;return lv(t)&&(e=t.constructor,(hv(e)&&(e===yv||lv(e.prototype))||dv(e)&&null===(e=e[vv]))&&(e=void 0)),void 0===e?yv:e},gv=function(t,e){return new(mv(t))(0===e?0:e)},Ev=tr,wv=qr,Tv=zn("species"),_v=function(t){return wv>=51||!Ev((function(){var e=[];return(e.constructor={})[Tv]=function(){return{foo:1}},1!==e[t](Boolean).foo}))},Iv=Vs,Av=tr,bv=rv,Nv=kr,Ov=Nn,Rv=Wo,xv=fv,Mv=Hd,Sv=gv,Cv=_v,Uv=qr,Pv=zn("isConcatSpreadable"),kv=Uv>=51||!Av((function(){var t=[];return t[Pv]=!1,t.concat()[0]!==t})),Dv=Cv("concat"),Lv=function(t){if(!Nv(t))return!1;var e=t[Pv];return void 0!==e?!!e:bv(t)};Iv({target:"Array",proto:!0,arity:1,forced:!kv||!Dv},{concat:function(t){var e,r,n,i,o,s=Ov(this),u=Sv(s,0),a=0;for(e=-1,n=arguments.length;e<n;e++)if(Lv(o=-1===e?s:arguments[e]))for(i=Rv(o),xv(a+i),r=0;r<i;r++,a++)r in o&&Mv(u,a,o[r]);else xv(a+1),Mv(u,a++,o);return u.length=a,u}});var Fv=sn,Vv=TypeError,jv=function(t,e){if(!delete t[e])throw Vv("Cannot delete property "+Fv(e)+" of "+Fv(t))},Gv=Nn,Hv=Jo,Bv=Wo,Kv=jv,zv=Math.min,Jv=[].copyWithin||function(t,e){var r=Gv(this),n=Bv(r),i=Hv(t,n),o=Hv(e,n),s=arguments.length>2?arguments[2]:void 0,u=zv((void 0===s?n:Hv(s,n))-o,n-i),a=1;for(o<i&&i<o+u&&(a=-1,o+=u-1,i+=u-1);u-- >0;)o in r?r[i]=r[o]:Kv(r,i),i+=a,o+=a;return r},Yv=oc;Vs({target:"Array",proto:!0},{copyWithin:Jv}),Yv("copyWithin");var qv=Du,Xv=Or,Wv=Nn,$v=Wo,Zv=gv,Qv=gr([].push),ty=function(t){var e=1==t,r=2==t,n=3==t,i=4==t,o=6==t,s=7==t,u=5==t||o;return function(a,c,p,f){for(var l,h,d=Wv(a),v=Xv(d),y=qv(c,p),m=$v(v),g=0,E=f||Zv,w=e?E(a,m):r||s?E(a,0):void 0;m>g;g++)if((u||g in v)&&(h=y(l=v[g],g,d),t))if(e)w[g]=h;else if(h)switch(t){case 3:return!0;case 5:return l;case 6:return g;case 2:Qv(w,l)}else switch(t){case 4:return!1;case 7:Qv(w,l)}return o?-1:n||i?i:w}},ey={forEach:ty(0),map:ty(1),filter:ty(2),some:ty(3),every:ty(4),find:ty(5),findIndex:ty(6),filterReject:ty(7)},ry=tr,ny=function(t,e){var r=[][t];return!!r&&ry((function(){r.call(null,e||function(){return 1},1)}))},iy=ey.every;Vs({target:"Array",proto:!0,forced:!ny("every")},{every:function(t){return iy(this,t,arguments.length>1?arguments[1]:void 0)}});var oy=Nn,sy=Jo,uy=Wo,ay=oc;Vs({target:"Array",proto:!0},{fill:function(t){for(var e=oy(this),r=uy(e),n=arguments.length,i=sy(n>1?arguments[1]:void 0,r),o=n>2?arguments[2]:void 0,s=void 0===o?r:sy(o,r);s>i;)e[i++]=t;return e}}),ay("fill");var cy=ey.filter;Vs({target:"Array",proto:!0,forced:!_v("filter")},{filter:function(t){return cy(this,t,arguments.length>1?arguments[1]:void 0)}});var py=Vs,fy=ey.find,ly=oc,hy=!0;"find"in[]&&Array(1).find((function(){hy=!1})),py({target:"Array",proto:!0,forced:hy},{find:function(t){return fy(this,t,arguments.length>1?arguments[1]:void 0)}}),ly("find");var dy=Vs,vy=ey.findIndex,yy=oc,my=!0;"findIndex"in[]&&Array(1).findIndex((function(){my=!1})),dy({target:"Array",proto:!0,forced:my},{findIndex:function(t){return vy(this,t,arguments.length>1?arguments[1]:void 0)}}),yy("findIndex");var gy=Du,Ey=Or,wy=Nn,Ty=Wo,_y=function(t){var e=1==t;return function(r,n,i){for(var o,s=wy(r),u=Ey(s),a=gy(n,i),c=Ty(u);c-- >0;)if(a(o=u[c],c,s))switch(t){case 0:return o;case 1:return c}return e?-1:void 0}},Iy={findLast:_y(0),findLastIndex:_y(1)},Ay=Iy.findLast,by=oc;Vs({target:"Array",proto:!0},{findLast:function(t){return Ay(this,t,arguments.length>1?arguments[1]:void 0)}}),by("findLast");var Ny=Iy.findLastIndex,Oy=oc;Vs({target:"Array",proto:!0},{findLastIndex:function(t){return Ny(this,t,arguments.length>1?arguments[1]:void 0)}}),Oy("findLastIndex");var Ry=rv,xy=Wo,My=fv,Sy=Du,Cy=function(t,e,r,n,i,o,s,u){for(var a,c,p=i,f=0,l=!!s&&Sy(s,u);f<n;)f in r&&(a=l?l(r[f],f,e):r[f],o>0&&Ry(a)?(c=xy(a),p=Cy(t,e,a,c,p,o-1)-1):(My(p+1),t[p]=a),p++),f++;return p},Uy=Cy,Py=Uy,ky=Nn,Dy=Wo,Ly=Ho,Fy=gv;Vs({target:"Array",proto:!0},{flat:function(){var t=arguments.length?arguments[0]:void 0,e=ky(this),r=Dy(e),n=Fy(e,0);return n.length=Py(n,e,e,r,0,void 0===t?1:Ly(t)),n}});var Vy=Uy,jy=pn,Gy=Nn,Hy=Wo,By=gv;Vs({target:"Array",proto:!0},{flatMap:function(t){var e,r=Gy(this),n=Hy(r);return jy(t),(e=By(r,0)).length=Vy(e,r,r,n,0,1,t,arguments.length>1?arguments[1]:void 0),e}});var Ky=ey.forEach,zy=ny("forEach")?[].forEach:function(t){return Ky(this,t,arguments.length>1?arguments[1]:void 0)};Vs({target:"Array",proto:!0,forced:[].forEach!=zy},{forEach:zy});var Jy=es.includes,Yy=oc;Vs({target:"Array",proto:!0,forced:tr((function(){return!Array(1).includes()}))},{includes:function(t){return Jy(this,t,arguments.length>1?arguments[1]:void 0)}}),Yy("includes");var qy=Vs,Xy=es.indexOf,Wy=ny,$y=gr([].indexOf),Zy=!!$y&&1/$y([1],1,-0)<0,Qy=Wy("indexOf");qy({target:"Array",proto:!0,forced:Zy||!Qy},{indexOf:function(t){var e=arguments.length>1?arguments[1]:void 0;return Zy?$y(this,t,e)||0:Xy(this,t,e)}});var tm=Vs,em=Or,rm=Cr,nm=ny,im=gr([].join),om=em!=Object,sm=nm("join",",");tm({target:"Array",proto:!0,forced:om||!sm},{join:function(t){return im(rm(this),void 0===t?",":t)}});var um=Fp,am=Cr,cm=Ho,pm=Wo,fm=ny,lm=Math.min,hm=[].lastIndexOf,dm=!!hm&&1/[1].lastIndexOf(1,-0)<0,vm=fm("lastIndexOf"),ym=dm||!vm?function(t){if(dm)return um(hm,this,arguments)||0;var e=am(this),r=pm(e),n=r-1;for(arguments.length>1&&(n=lm(n,cm(arguments[1]))),n<0&&(n=r+n);n>=0;n--)if(n in e&&e[n]===t)return n||0;return-1}:hm;Vs({target:"Array",proto:!0,forced:ym!==[].lastIndexOf},{lastIndexOf:ym});var mm=ey.map;Vs({target:"Array",proto:!0,forced:!_v("map")},{map:function(t){return mm(this,t,arguments.length>1?arguments[1]:void 0)}});var gm=Vs,Em=Nn,wm=Wo,Tm=fv,_m=tr((function(){return 4294967297!==[].push.call({length:4294967296},1)})),Im=!function(){try{Object.defineProperty([],"length",{writable:!1}).push()}catch(t){return t instanceof TypeError}}();gm({target:"Array",proto:!0,arity:1,forced:_m||Im},{push:function(t){var e=Em(this),r=wm(e),n=arguments.length;Tm(r+n);for(var i=0;i<n;i++)e[r]=arguments[i],r++;return e.length=r,r}});var Am=pn,bm=Nn,Nm=Or,Om=Wo,Rm=TypeError,xm=function(t){return function(e,r,n,i){Am(r);var o=bm(e),s=Nm(o),u=Om(o),a=t?u-1:0,c=t?-1:1;if(n<2)for(;;){if(a in s){i=s[a],a+=c;break}if(a+=c,t?a<0:u<=a)throw Rm("Reduce of empty array with no initial value")}for(;t?a>=0:u>a;a+=c)a in s&&(i=r(i,s[a],a,o));return i}},Mm={left:xm(!1),right:xm(!0)},Sm=Mm.left,Cm=qr,Um=tp;Vs({target:"Array",proto:!0,forced:!ny("reduce")||!Um&&Cm>79&&Cm<83},{reduce:function(t){var e=arguments.length;return Sm(this,t,e,e>1?arguments[1]:void 0)}});var Pm=Mm.right,km=qr,Dm=tp;Vs({target:"Array",proto:!0,forced:!ny("reduceRight")||!Dm&&km>79&&km<83},{reduceRight:function(t){return Pm(this,t,arguments.length,arguments.length>1?arguments[1]:void 0)}});var Lm=Vs,Fm=rv,Vm=gr([].reverse),jm=[1,2];Lm({target:"Array",proto:!0,forced:String(jm)===String(jm.reverse())},{reverse:function(){return Fm(this)&&(this.length=this.length),Vm(this)}});var Gm=Vs,Hm=rv,Bm=Np,Km=kr,zm=Jo,Jm=Wo,Ym=Cr,qm=Hd,Xm=zn,Wm=Vp,$m=_v("slice"),Zm=Xm("species"),Qm=Array,tg=Math.max;Gm({target:"Array",proto:!0,forced:!$m},{slice:function(t,e){var r,n,i,o=Ym(this),s=Jm(o),u=zm(t,s),a=zm(void 0===e?s:e,s);if(Hm(o)&&(r=o.constructor,(Bm(r)&&(r===Qm||Hm(r.prototype))||Km(r)&&null===(r=r[Zm]))&&(r=void 0),r===Qm||void 0===r))return Wm(o,u,a);for(n=new(void 0===r?Qm:r)(tg(a-u,0)),i=0;u<a;u++,i++)u in o&&qm(n,i,o[u]);return n.length=i,n}});var eg=ey.some;Vs({target:"Array",proto:!0,forced:!ny("some")},{some:function(t){return eg(this,t,arguments.length>1?arguments[1]:void 0)}});var rg=Jo,ng=Wo,ig=Hd,og=Array,sg=Math.max,ug=function(t,e,r){for(var n=ng(t),i=rg(e,n),o=rg(void 0===r?n:r,n),s=og(sg(o-i,0)),u=0;i<o;i++,u++)ig(s,u,t[i]);return s.length=u,s},ag=ug,cg=Math.floor,pg=function(t,e){var r=t.length,n=cg(r/2);return r<8?fg(t,e):lg(t,pg(ag(t,0,n),e),pg(ag(t,n),e),e)},fg=function(t,e){for(var r,n,i=t.length,o=1;o<i;){for(n=o,r=t[o];n&&e(t[n-1],r)>0;)t[n]=t[--n];n!==o++&&(t[n]=r)}return t},lg=function(t,e,r,n){for(var i=e.length,o=r.length,s=0,u=0;s<i||u<o;)t[s+u]=s<i&&u<o?n(e[s],r[u])<=0?e[s++]:r[u++]:s<i?e[s++]:r[u++];return t},hg=pg,dg=Gr.match(/firefox\/(\d+)/i),vg=!!dg&&+dg[1],yg=/MSIE|Trident/.test(Gr),mg=Gr.match(/AppleWebKit\/(\d+)\./),gg=!!mg&&+mg[1],Eg=Vs,wg=gr,Tg=pn,_g=Nn,Ig=Wo,Ag=jv,bg=xa,Ng=tr,Og=hg,Rg=ny,xg=vg,Mg=yg,Sg=qr,Cg=gg,Ug=[],Pg=wg(Ug.sort),kg=wg(Ug.push),Dg=Ng((function(){Ug.sort(void 0)})),Lg=Ng((function(){Ug.sort(null)})),Fg=Rg("sort"),Vg=!Ng((function(){if(Sg)return Sg<70;if(!(xg&&xg>3)){if(Mg)return!0;if(Cg)return Cg<603;var t,e,r,n,i="";for(t=65;t<76;t++){switch(e=String.fromCharCode(t),t){case 66:case 69:case 70:case 72:r=3;break;case 68:case 71:r=4;break;default:r=2}for(n=0;n<47;n++)Ug.push({k:e+n,v:r})}for(Ug.sort((function(t,e){return e.v-t.v})),n=0;n<Ug.length;n++)e=Ug[n].k.charAt(0),i.charAt(i.length-1)!==e&&(i+=e);return"DGBEFHACIJK"!==i}}));Eg({target:"Array",proto:!0,forced:Dg||!Lg||!Fg||!Vg},{sort:function(t){void 0!==t&&Tg(t);var e=_g(this);if(Vg)return void 0===t?Pg(e):Pg(e,t);var r,n,i=[],o=Ig(e);for(n=0;n<o;n++)n in e&&kg(i,e[n]);for(Og(i,function(t){return function(e,r){return void 0===r?-1:void 0===e?1:void 0!==t?+t(e,r)||0:bg(e)>bg(r)?1:-1}}(t)),r=i.length,n=0;n<r;)e[n]=i[n++];for(;n<o;)Ag(e,n++);return e}}),op("Array");var jg=Vs,Gg=Nn,Hg=Jo,Bg=Ho,Kg=Wo,zg=fv,Jg=gv,Yg=Hd,qg=jv,Xg=_v("splice"),Wg=Math.max,$g=Math.min;jg({target:"Array",proto:!0,forced:!Xg},{splice:function(t,e){var r,n,i,o,s,u,a=Gg(this),c=Kg(a),p=Hg(t,c),f=arguments.length;for(0===f?r=n=0:1===f?(r=0,n=c-p):(r=f-2,n=$g(Wg(Bg(e),0),c-p)),zg(c+r-n),i=Jg(a,n),o=0;o<n;o++)(s=p+o)in a&&Yg(i,o,a[s]);if(i.length=n,r<n){for(o=p;o<c-n;o++)u=o+r,(s=o+n)in a?a[u]=a[s]:qg(a,u);for(o=c;o>c-n+r;o--)qg(a,o-1)}else if(r>n)for(o=c-n;o>p;o--)u=o+r-1,(s=o+n-1)in a?a[u]=a[s]:qg(a,u);for(o=0;o<r;o++)a[o+p]=arguments[o+2];return a.length=c-n+r,i}}),oc("flat"),oc("flatMap");var Zg=Vs,Qg=Nn,tE=Wo,eE=jv,rE=fv,nE=1!==[].unshift(0),iE=!function(){try{Object.defineProperty([],"length",{writable:!1}).unshift()}catch(t){return t instanceof TypeError}}();Zg({target:"Array",proto:!0,arity:1,forced:nE||iE},{unshift:function(t){var e=Qg(this),r=tE(e),n=arguments.length;if(n){rE(r+n);for(var i=r;i--;){var o=i+n;i in e?e[o]=e[i]:eE(e,o)}for(var s=0;s<n;s++)e[s]=arguments[s]}return e.length=r+n}});wd.Array;var oE={exports:{}},sE={},uE=_r,aE=Cr,cE=Fo.f,pE=ug,fE="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];sE.f=function(t){return fE&&"Window"==uE(t)?function(t){try{return cE(t)}catch(t){return pE(fE)}}(t):cE(aE(t))};var lE=tr((function(){if("function"==typeof ArrayBuffer){var t=new ArrayBuffer(8);Object.isExtensible(t)&&Object.defineProperty(t,"a",{value:8})}})),hE=tr,dE=kr,vE=_r,yE=lE,mE=Object.isExtensible,gE=hE((function(){mE(1)}))||yE?function(t){return!!dE(t)&&((!yE||"ArrayBuffer"!=vE(t))&&(!mE||mE(t)))}:mE,EE=!tr((function(){return Object.isExtensible(Object.preventExtensions({}))})),wE=Vs,TE=gr,_E=ro,IE=kr,AE=xn,bE=mi.f,NE=Fo,OE=sE,RE=gE,xE=EE,ME=!1,SE=Pn("meta"),CE=0,UE=function(t){bE(t,SE,{value:{objectID:"O"+CE++,weakData:{}}})},PE=oE.exports={enable:function(){PE.enable=function(){},ME=!0;var t=NE.f,e=TE([].splice),r={};r[SE]=1,t(r).length&&(NE.f=function(r){for(var n=t(r),i=0,o=n.length;i<o;i++)if(n[i]===SE){e(n,i,1);break}return n},wE({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:OE.f}))},fastKey:function(t,e){if(!IE(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!AE(t,SE)){if(!RE(t))return"F";if(!e)return"E";UE(t)}return t[SE].objectID},getWeakData:function(t,e){if(!AE(t,SE)){if(!RE(t))return!0;if(!e)return!1;UE(t)}return t[SE].weakData},onFreeze:function(t){return xE&&ME&&RE(t)&&!AE(t,SE)&&UE(t),t}};_E[SE]=!0;var kE=Ur,DE=kr,LE=eu,FE=Vs,VE=Ze,jE=gr,GE=Ss,HE=Lo,BE=oE.exports,KE=Na,zE=ap,JE=Ur,YE=kr,qE=tr,XE=ch,WE=mc,$E=function(t,e,r){var n,i;return LE&&kE(n=e.constructor)&&n!==r&&DE(i=n.prototype)&&i!==r.prototype&&LE(t,i),t},ZE=Lo,QE=function(t,e,r){for(var n in e)ZE(t,n,e[n],r);return t},tw=mi.f,ew=bu,rw=QE,nw=Du,iw=ap,ow=Na,sw=jc,uw=op,aw=er,cw=oE.exports.fastKey,pw=wo.set,fw=wo.getterFor,lw={getConstructor:function(t,e,r,n){var i=t((function(t,i){iw(t,o),pw(t,{type:e,index:ew(null),first:void 0,last:void 0,size:0}),aw||(t.size=0),null!=i&&ow(i,t[n],{that:t,AS_ENTRIES:r})})),o=i.prototype,s=fw(e),u=function(t,e,r){var n,i,o=s(t),u=a(t,e);return u?u.value=r:(o.last=u={index:i=cw(e,!0),key:e,value:r,previous:n=o.last,next:void 0,removed:!1},o.first||(o.first=u),n&&(n.next=u),aw?o.size++:t.size++,"F"!==i&&(o.index[i]=u)),t},a=function(t,e){var r,n=s(t),i=cw(e);if("F"!==i)return n.index[i];for(r=n.first;r;r=r.next)if(r.key==e)return r};return rw(o,{clear:function(){for(var t=s(this),e=t.index,r=t.first;r;)r.removed=!0,r.previous&&(r.previous=r.previous.next=void 0),delete e[r.index],r=r.next;t.first=t.last=void 0,aw?t.size=0:this.size=0},delete:function(t){var e=this,r=s(e),n=a(e,t);if(n){var i=n.next,o=n.previous;delete r.index[n.index],n.removed=!0,o&&(o.next=i),i&&(i.previous=o),r.first==n&&(r.first=i),r.last==n&&(r.last=o),aw?r.size--:e.size--}return!!n},forEach:function(t){for(var e,r=s(this),n=nw(t,arguments.length>1?arguments[1]:void 0);e=e?e.next:r.first;)for(n(e.value,e.key,this);e&&e.removed;)e=e.previous},has:function(t){return!!a(this,t)}}),rw(o,r?{get:function(t){var e=a(this,t);return e&&e.value},set:function(t,e){return u(this,0===t?0:t,e)}}:{add:function(t){return u(this,t=0===t?0:t,t)}}),aw&&tw(o,"size",{get:function(){return s(this).size}}),i},setStrong:function(t,e,r){var n=e+" Iterator",i=fw(e),o=fw(n);sw(t,e,(function(t,e){pw(this,{type:n,target:t,state:i(t),kind:e,last:void 0})}),(function(){for(var t=o(this),e=t.kind,r=t.last;r&&r.removed;)r=r.previous;return t.target&&(t.last=r=r?r.next:t.state.first)?"keys"==e?{value:r.key,done:!1}:"values"==e?{value:r.value,done:!1}:{value:[r.key,r.value],done:!1}:(t.target=void 0,{value:void 0,done:!0})}),r?"entries":"values",!r,!0),uw(e)}};(function(t,e,r){var n=-1!==t.indexOf("Map"),i=-1!==t.indexOf("Weak"),o=n?"set":"add",s=VE[t],u=s&&s.prototype,a=s,c={},p=function(t){var e=jE(u[t]);HE(u,t,"add"==t?function(t){return e(this,0===t?0:t),this}:"delete"==t?function(t){return!(i&&!YE(t))&&e(this,0===t?0:t)}:"get"==t?function(t){return i&&!YE(t)?void 0:e(this,0===t?0:t)}:"has"==t?function(t){return!(i&&!YE(t))&&e(this,0===t?0:t)}:function(t,r){return e(this,0===t?0:t,r),this})};if(GE(t,!JE(s)||!(i||u.forEach&&!qE((function(){(new s).entries().next()})))))a=r.getConstructor(e,t,n,o),BE.enable();else if(GE(t,!0)){var f=new a,l=f[o](i?{}:-0,1)!=f,h=qE((function(){f.has(1)})),d=XE((function(t){new s(t)})),v=!i&&qE((function(){for(var t=new s,e=5;e--;)t[o](e,e);return!t.has(-0)}));d||((a=e((function(t,e){zE(t,u);var r=$E(new s,t,a);return null!=e&&KE(e,r[o],{that:r,AS_ENTRIES:n}),r}))).prototype=u,u.constructor=a),(h||v)&&(p("delete"),p("has"),n&&p("get")),(v||l)&&p(o),i&&u.clear&&delete u.clear}c[t]=a,FE({global:!0,constructor:!0,forced:a!=s},c),WE(a,t),i||r.setStrong(a,t,n)})("Map",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),lw);var hw=Wo,dw=function(t,e){for(var r=0,n=hw(e),i=new t(n);n>r;)i[r]=e[r++];return i},vw=Du,yw=Or,mw=Nn,gw=ei,Ew=Wo,ww=bu,Tw=dw,_w=Array,Iw=gr([].push),Aw=function(t,e,r,n){for(var i,o,s,u=mw(t),a=yw(u),c=vw(e,r),p=ww(null),f=Ew(a),l=0;f>l;l++)s=a[l],(o=gw(c(s,l,u)))in p?Iw(p[o],s):p[o]=[s];if(n&&(i=n(u))!==_w)for(o in p)p[o]=Tw(i,p[o]);return p},bw=Aw,Nw=oc;Vs({target:"Array",proto:!0},{group:function(t){var e=arguments.length>1?arguments[1]:void 0;return bw(this,t,e)}}),Nw("group");var Ow=Aw,Rw=oc;Vs({target:"Array",proto:!0,forced:!ny("groupBy")},{groupBy:function(t){var e=arguments.length>1?arguments[1]:void 0;return Ow(this,t,e)}}),Rw("groupBy");var xw=Du,Mw=gr,Sw=Or,Cw=Nn,Uw=Wo,Pw=Vr("Map"),kw=Pw.prototype,Dw=Mw(kw.get),Lw=Mw(kw.has),Fw=Mw(kw.set),Vw=Mw([].push),jw=function(t){for(var e,r,n=Cw(this),i=Sw(n),o=xw(t,arguments.length>1?arguments[1]:void 0),s=new Pw,u=Uw(i),a=0;u>a;a++)e=o(r=i[a],a,n),Lw(s,e)?Vw(Dw(s,e),r):Fw(s,e,[r]);return s},Gw=oc,Hw=jw;Vs({target:"Array",proto:!0,name:"groupToMap",forced:!ny("groupByToMap")},{groupByToMap:Hw}),Gw("groupByToMap");var Bw=oc;Vs({target:"Array",proto:!0},{groupToMap:jw}),Bw("groupToMap");var Kw=Wo,zw=function(t,e){for(var r=Kw(t),n=new e(r),i=0;i<r;i++)n[i]=t[r-i-1];return n},Jw=Cr,Yw=oc,qw=Array;Vs({target:"Array",proto:!0},{toReversed:function(){return zw(Jw(this),qw)}}),Yw("toReversed");var Xw=Ze,Ww=function(t){return Xw[t].prototype},$w=Vs,Zw=pn,Qw=Cr,tT=dw,eT=oc,rT=Array,nT=gr(Ww("Array").sort);$w({target:"Array",proto:!0},{toSorted:function(t){void 0!==t&&Zw(t);var e=Qw(this),r=tT(rT,e);return nT(r,t)}}),eT("toSorted");var iT=Vs,oT=oc,sT=fv,uT=Wo,aT=Jo,cT=Cr,pT=Ho,fT=Array,lT=Math.max,hT=Math.min;iT({target:"Array",proto:!0},{toSpliced:function(t,e){var r,n,i,o,s=cT(this),u=uT(s),a=aT(t,u),c=arguments.length,p=0;for(0===c?r=n=0:1===c?(r=0,n=u-a):(r=c-2,n=hT(lT(pT(e),0),u-a)),i=sT(u+r-n),o=fT(i);p<a;p++)o[p]=s[p];for(;p<a+r;p++)o[p]=arguments[p-a+2];for(;p<i;p++)o[p]=s[p+n-r];return o}}),oT("toSpliced");var dT=Wo,vT=Ho,yT=RangeError,mT=function(t,e,r,n){var i=dT(t),o=vT(r),s=o<0?i+o:o;if(s>=i||s<0)throw yT("Incorrect index");for(var u=new e(i),a=0;a<i;a++)u[a]=a===s?n:t[a];return u},gT=Cr,ET=Array;Vs({target:"Array",proto:!0},{with:function(t,e){return mT(gT(this),ET,t,e)}});var wT,TT,_T=Ze,IT=_n,AT=Ur,bT=qs,NT=Lo,OT=zn("asyncIterator"),RT=_T.AsyncIterator,xT=IT.AsyncIteratorPrototype;if(xT)wT=xT;else if(AT(RT))wT=RT.prototype;else if(IT.USE_FUNCTION_CONSTRUCTOR||_T.USE_FUNCTION_CONSTRUCTOR)try{TT=bT(bT(bT(Function("return async function*(){}()")()))),bT(TT)===Object.prototype&&(wT=TT)}catch(t){}wT||(wT={}),AT(wT[OT])||NT(wT,OT,(function(){return this}));var MT=or,ST=_i,CT=bu,UT=ln,PT=QE,kT=wo,DT=wT,LT=Vr("Promise"),FT=kT.set,VT=kT.getterFor("AsyncFromSyncIterator"),jT=function(t,e,r){var n=t.done;LT.resolve(t.value).then((function(t){e({done:n,value:t})}),r)},GT=function(t){FT(this,{type:"AsyncFromSyncIterator",iterator:ST(t),next:t.next})};GT.prototype=PT(CT(DT),{next:function(){var t=VT(this);return new LT((function(e,r){var n=ST(MT(t.next,t.iterator));jT(n,e,r)}))},return:function(){var t=VT(this).iterator;return new LT((function(e,r){var n=UT(t,"return");if(void 0===n)return e({done:!0,value:void 0});var i=ST(MT(n,t));jT(i,e,r)}))}});var HT=GT,BT=or,KT=HT,zT=_i,JT=aa,YT=ln,qT=zn("asyncIterator"),XT=pn,WT=_i,$T=or,ZT=Vr,QT=ln,t_=or,e_=pn,r_=_i,n_=fv,i_=Vr,o_=function(t){return{iterator:t,next:XT(WT(t).next)}},s_=function(t,e,r,n){try{var i=QT(t,"return");if(i)return ZT("Promise").resolve($T(i,t)).then((function(){e(r)}),(function(t){n(t)}))}catch(t){return n(t)}e(r)},u_=function(t){var e=0==t,r=1==t,n=2==t,i=3==t;return function(t,o,s){var u=o_(t),a=i_("Promise"),c=u.iterator,p=u.next,f=0,l=void 0!==o;return!l&&e||e_(o),new a((function(t,u){var h=function(t){s_(c,u,t,u)},d=function(){try{if(e&&l)try{n_(f)}catch(t){h(t)}a.resolve(r_(t_(p,c))).then((function(p){try{if(r_(p).done)e?(s.length=f,t(s)):t(!i&&(n||void 0));else{var v=p.value;try{l?a.resolve(e?o(v,f):o(v)).then((function(o){if(r)d();else if(n)o?d():s_(c,t,!1,u);else if(e)try{s[f++]=o,d()}catch(t){h(t)}else o?s_(c,t,i||v,u):d()}),h):(s[f++]=v,d())}catch(t){h(t)}}}catch(t){u(t)}}),u)}catch(t){u(t)}};d()}))}},a_={toArray:u_(0),forEach:u_(1),every:u_(2),some:u_(3),find:u_(4)},c_=Du,p_=Nn,f_=Np,l_=function(t,e){var r=arguments.length<2?YT(t,qT):e;return r?zT(BT(r,t)):new KT(JT(t))},h_=aa,d_=ea,v_=ln,y_=Ww,m_=Vr,g_=HT,E_=a_.toArray,w_=zn("asyncIterator"),T_=y_("Array").values;Vs({target:"Array",stat:!0,forced:!0},{fromAsync:function(t){var e=this,r=arguments.length,n=r>1?arguments[1]:void 0,i=r>2?arguments[2]:void 0;return new(m_("Promise"))((function(r){var o=p_(t);void 0!==n&&(n=c_(n,i));var s=v_(o,w_),u=s?void 0:d_(o)||T_,a=f_(e)?new e:[],c=s?l_(o,s):new g_(h_(o,u));r(E_(c,n,a))}))}});var __=ey.filterReject,I_=oc;Vs({target:"Array",proto:!0,forced:!0},{filterOut:function(t){return __(this,t,arguments.length>1?arguments[1]:void 0)}}),I_("filterOut");var A_=ey.filterReject,b_=oc;Vs({target:"Array",proto:!0,forced:!0},{filterReject:function(t){return A_(this,t,arguments.length>1?arguments[1]:void 0)}}),b_("filterReject");var N_=Vs,O_=rv,R_=Object.isFrozen,x_=function(t,e){if(!R_||!O_(t)||!R_(t))return!1;for(var r,n=0,i=t.length;n<i;)if(!("string"==typeof(r=t[n++])||e&&void 0===r))return!1;return 0!==i};N_({target:"Array",stat:!0,sham:!0,forced:!0},{isTemplateObject:function(t){if(!x_(t,!0))return!1;var e=t.raw;return e.length===t.length&&x_(e,!1)}});var M_=Pi.exports,S_=mi,C_=function(t,e,r){return r.get&&M_(r.get,e,{getter:!0}),r.set&&M_(r.set,e,{setter:!0}),S_.f(t,e,r)},U_=oc,P_=Nn,k_=Wo;er&&(C_(Array.prototype,"lastItem",{configurable:!0,get:function(){var t=P_(this),e=k_(t);return 0==e?void 0:t[e-1]},set:function(t){var e=P_(this),r=k_(e);return e[0==r?0:r-1]=t}}),U_("lastItem"));var D_=oc,L_=Nn,F_=Wo;er&&(C_(Array.prototype,"lastIndex",{configurable:!0,get:function(){var t=L_(this),e=F_(t);return 0==e?0:e-1}}),D_("lastIndex"));var V_=gr,j_=pn,G_=Wo,H_=Nn,B_=gv,K_=Vr("Map"),z_=K_.prototype,J_=V_(z_.forEach),Y_=V_(z_.has),q_=V_(z_.set),X_=V_([].push),W_=oc;Vs({target:"Array",proto:!0,forced:!0},{uniqueBy:function(t){var e,r,n,i=H_(this),o=G_(i),s=B_(i,0),u=new K_,a=null!=t?j_(t):function(t){return t};for(e=0;e<o;e++)n=a(r=i[e]),Y_(u,n)||q_(u,n,r);return J_(u,(function(t){X_(s,t)})),s}}),W_("uniqueBy");var $_,Z_=function(){function e(e,r,n){void 0===n&&(n=t.v4()),this.timestamp=e,this.user=r,this.insertId=n}return e.exposure=function(t,e,r,n){return new Q_(n,t,e.experiment,e.variationId,e.variationKey,e.reason,r)},e.track=function(t,e,r,n){return new tI(n,r,t,e)},e.remoteConfig=function(t,e,r,n){return new eI(n,t,e.parameter,e.valueId,e.reason,r)},e.isExposureEvent=function(t){return void 0!==t.experiment},e.isTrackEvent=function(t){return void 0!==t.eventType},e.isRemoteConfigEvent=function(t){return void 0!==t.parameter},e.isExposureEventDto=function(t){return"experimentId"in t&&void 0!==t.experimentId},e.isTrackEventDto=function(t){return"eventTypeId"in t&&void 0!==t.eventTypeId},e.isRemoteConfigEventDto=function(t){return"parameterId"in t&&void 0!==t.parameterId},e.prototype.toDto=function(){return{insertId:this.insertId,timestamp:this.timestamp,userId:this.user.identifiers[L.ID],identifiers:this.user.identifiers,userProperties:y.sanitize(this.user.properties),hackleProperties:y.sanitize(this.user.hackleProperties)}},e}(),Q_=function(t){function e(e,r,n,i,o,s,u,a){var c=t.call(this,e,r,a)||this;return c.experiment=n,c.variationId=i,c.variationKey=o,c.decisionReason=s,c.properties=u,c}return a(e,t),e.prototype.copyWithUser=function(t){return new e(this.timestamp,t,this.experiment,this.variationId,this.variationKey,this.decisionReason,this.properties,this.insertId)},e.prototype.toDto=function(){return c(c({},t.prototype.toDto.call(this)),{experimentId:this.experiment.id,experimentKey:this.experiment.key,experimentType:this.experiment.type,experimentVersion:this.experiment.version,variationId:this.variationId,variationKey:this.variationKey,decisionReason:this.decisionReason.toString(),properties:this.properties})},e}(Z_),tI=function(t){function e(e,r,n,i,o){var s=t.call(this,e,r,o)||this;return s.eventType=n,s.event=i,s}return a(e,t),e.prototype.copyWithUser=function(t){return new e(this.timestamp,t,this.eventType,this.event,this.insertId)},e.prototype.toDto=function(){return c(c({},t.prototype.toDto.call(this)),{eventTypeId:this.eventType.id,eventTypeKey:this.eventType.key,value:this.event.value||0,properties:y.sanitize(this.event.properties)})},e}(Z_),eI=function(t){function e(e,r,n,i,o,s,u){var a=t.call(this,e,r,u)||this;return a.parameter=n,a.valueId=i,a.decisionReason=o,a.properties=s,a}return a(e,t),e.prototype.copyWithUser=function(t){return new e(this.timestamp,t,this.parameter,this.valueId,this.decisionReason,this.properties,this.insertId)},e.prototype.toDto=function(){return c(c({},t.prototype.toDto.call(this)),{parameterId:this.parameter.id,parameterKey:this.parameter.key,parameterType:this.parameter.type,valueId:this.valueId,decisionReason:this.decisionReason.toString(),properties:y.sanitize(this.properties)})},e}(Z_),rI=function(){function t(t,e){this.userManager=t,this.core=e}return t.isSessionEvent=function(e){return!!Z_.isTrackEvent(e)&&(e.event.key===t.SESSION_START_EVENT_NAME||e.event.key===t.SESSION_END_EVENT_NAME)},t.prototype.onSessionStarted=function(e,r,n){this.track(t.SESSION_START_EVENT_NAME,e,r,n)},t.prototype.onSessionEnded=function(e,r,n){this.track(t.SESSION_END_EVENT_NAME,e,r,n)},t.prototype.track=function(t,e,r,n){var i={key:t},o=this.userManager.toHackleUser(r),s=this.decorateSession(o,e);this.core.track(i,s,n)},t.prototype.decorateSession=function(t,e){var r=(new V).add(L.SESSION,e).addIdentifiers(t.identifiers).build();return c(c({},t),{identifiers:r})},t.SESSION_START_EVENT_NAME="$session_start",t.SESSION_END_EVENT_NAME="$session_end",t}(),nI=function(){function t(t,e,r,n){this.delegate=t,this.exposureEventDedupDeterminer=e,this.sessionManager=r,this.userManager=n}return t.prototype.process=function(t){if(rI.isSessionEvent(t)||this.sessionManager.startNewSessionIfNeeded(this.userManager.currentUser,t.timestamp),!this.exposureEventDedupDeterminer.isDedupTarget(t)){var e=function(t,e){var r;return null===e.currentSessionId||t.user.identifiers[L.SESSION]?t:t.copyWithUser(c(c({},t.user),{identifiers:c(c({},t.user.identifiers),(r={},r[L.SESSION]=e.sessionId,r))}))}(t,this.sessionManager);this.delegate.process(e)}},t.prototype.flush=function(t){this.delegate.flush(t)},t.prototype.close=function(){this.delegate.close()},t}(),iI=function(){function t(t){this.cache=new Map,this.exposureEventDedupIntervalMillis=t}return t.prototype.isDedupTarget=function(t){var e;if(-1===this.exposureEventDedupIntervalMillis)return!1;if(!Z_.isExposureEvent(t))return!1;d.isEquals(t.user.identifiers,null===(e=this.currentUser)||void 0===e?void 0:e.identifiers)||(this.currentUser=t.user,this.cache=new Map);var r=[t.experiment.id,t.variationId,t.variationKey,t.decisionReason].join("-"),n=(new Date).getTime(),i=this.cache.get(r);return void 0!==i&&n-i<=this.exposureEventDedupIntervalMillis||(this.cache.set(r,n),!1)},t}(),oI=function(){function t(){}return t.toEvent=function(e){var r;return{key:t.EVENT_KEY,properties:{level:t.LEVEL_ERROR,type:e.name,message:null!==(r=e.message)&&void 0!==r?r:"",$stacktrace:t._stacktrace(e)}}},t._stacktrace=function(e){return r.isNullOrUndefined(e.stack)?"":e.stack.split("\n").slice(0,t.STACK_TRACK_LIMIT).join("\n")},t.EVENT_KEY="$trace",t.LEVEL_ERROR="error",t.STACK_TRACK_LIMIT=30,t}(),sI=function(){function t(){}return t.prototype.evaluate=function(t,e){if(!this.supports(t))throw new Error("Unsupported EvaluatorRequest ".concat(t.toString()));if(e.contains(t)){var r=e.stack.map((function(t){return t.toString()})).join(" - ");throw new Error("Circular evaluation has occurred [".concat(r," - ").concat(t.toString(),"]"))}e.addRequest(t);try{return this.evaluateInternal(t,e)}finally{e.removeRequest(t)}},t}(),uI=function(){function t(t,e,r,n,i,o){this.reason=t,this.targetEvaluations=e,this.experiment=r,this.variationId=n,this.variationKey=i,this.config=o}return t.prototype.with=function(e){return new t(e,this.targetEvaluations,this.experiment,this.variationId,this.variationKey,this.config)},t.of=function(e,r,n,i){var o=this.config(e.workspace,n);return new t(i,r.targetEvaluations,e.experiment,n.id,n.key,o)},t.ofDefault=function(e,n,i){var o=e.experiment._getVariationByKeyOrNull(e.defaultVariationKey);return r.isNotNullOrUndefined(o)?this.of(e,n,o,i):new t(i,n.targetEvaluations,e.experiment,void 0,e.defaultVariationKey,void 0)},t.config=function(t,e){if(!r.isNullOrUndefined(e.parameterConfigurationId))return r.requiredNotNullOrUndefined(t.getParameterConfigurationOrNull(e.parameterConfigurationId),(function(){return"ParameterConfiguration[".concat(e.parameterConfigurationId,"]")}))},t}(),aI=function(t){function e(e){var r=t.call(this)||this;return r.evaluationFlowFactory=e,r}return a(e,t),e.prototype.supports=function(t){return void 0!==t.experiment},e.prototype.evaluateInternal=function(t,e){var r;return null!==(r=this.evaluationFlowFactory.getExperimentFlow(t.experiment.type).evaluate(t,e))&&void 0!==r?r:uI.ofDefault(t,e,S.TRAFFIC_NOT_ALLOCATED)},e}(sI),cI=function(){function t(t,e,r,n,i,o){this.reason=t,this.targetEvaluations=e,this.parameter=r,this.valueId=n,this.value=i,this.properties=o}return t.of=function(e,r,n,i,o,s){return s.returnValue=y.truncateStringValue(i),new t(o,r.targetEvaluations,e.parameter,n,i,s)},t.ofDefault=function(t,e,r,n){return this.of(t,e,void 0,t.defaultValue,r,n)},t}(),pI=function(t){function e(e){var r=t.call(this)||this;return r.targetRuleDeterminer=e,r}return a(e,t),e.prototype.supports=function(t){return void 0!==t.parameter},e.prototype.evaluateInternal=function(t,e){var n={};if(n.requestValueType=t.requiredType,n.requestDefaultValue=y.truncateStringValue(t.defaultValue),r.isNullOrUndefined(t.user.identifiers[t.parameter.identifierType]))return cI.ofDefault(t,e,S.IDENTIFIER_NOT_FOUND,n);var i=this.targetRuleDeterminer.determineTargetRuleOrNull(t,e);return r.isNotNullOrUndefined(i)?(n.targetRuleKey=i.key,n.targetRuleName=i.name,this.evaluation(t,e,i.value,S.TARGET_RULE_MATCH,n)):this.evaluation(t,e,t.parameter.defaultValue,S.DEFAULT_RULE,n)},e.prototype.evaluation=function(t,e,r,n,i){return"UNKNOWN"===t.requiredType||"NULL"!==t.requiredType&&typeof t.defaultValue!=typeof r.rawValue?cI.ofDefault(t,e,S.TYPE_MISMATCH,i):cI.of(t,e,r.id,r.rawValue,n,i)},e}(sI),fI=function(){function t(t,e){this.type=t,this.id=e}return t.prototype.isEquals=function(t){return this.type===t.type&&this.id===t.id},t}(),lI=function(){function t(){this._stack=[],this._targetEvaluations=[]}return t.create=function(){return new t},Object.defineProperty(t.prototype,"stack",{get:function(){return Array.from(this._stack)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"targetEvaluations",{get:function(){return Array.from(this._targetEvaluations)},enumerable:!1,configurable:!0}),t.prototype.contains=function(t){return this._stack.some((function(e){return e.key.isEquals(t.key)}))},t.prototype.addRequest=function(t){this._stack.push(t)},t.prototype.removeRequest=function(t){var e=this._stack.indexOf(t,0);e>-1&&this._stack.splice(e,1)},t.prototype.get=function(t){return this._targetEvaluations.find((function(e){return e instanceof uI&&e.experiment.id===t.id}))},t.prototype.addEvaluation=function(t){this._targetEvaluations.push(t)},t}(),hI=function(){function t(t,e,r,n){this.key=new fI("EXPERIMENT",r.id),this.workspace=t,this.user=e,this.experiment=r,this.defaultVariationKey=n}return t.of=function(e,r,n,i){return new t(e,r,n,i)},t.by=function(e,r){return new t(e.workspace,e.user,r,"A")},t.prototype.toString=function(){return"EvaluatorRequest(type=".concat(this.experiment.type,", key=").concat(this.experiment.key,")")},t}(),dI=function(){function t(t,e,r,n,i){this.key=new fI("REMOTE_CONFIG",r.id),this.workspace=t,this.user=e,this.parameter=r,this.requiredType=n,this.defaultValue=i}return t.of=function(e,r,n,i,o){return new t(e,r,n,i,o)},t.prototype.toString=function(){return"EvaluatorRequest(type=".concat(this.key.type,", key=").concat(this.parameter.key,")")},t}(),vI=function(){function t(){}return t.asString=function(t){switch(typeof t){case"string":return t;case"number":return t.toString();default:return}},t.asNumber=function(t){switch(typeof t){case"number":return this.asActualNumber(t);case"string":return this.asActualNumber(Number(t));default:return}},t.asActualNumber=function(t){return!isNaN(t)&&isFinite(t)?t:void 0},t}(),yI=function(){function t(t){this.storages=t}return t.prototype.getVariation=function(t,e){if(0!==this.storages.length)for(var r=0,n=this.storages;r<n.length;r++){var i=n[r].getVariation(t,e);if(void 0!==i)return i}},t}(),mI=function(){function t(t){this.listStorage=t}return t.prototype.getVariation=function(t,e){var r=this.get(t);if(r)return t._getVariationByIdOrNull(r)},t.prototype.get=function(t){var e=this.listStorage.getItem(t.id.toString());return vI.asNumber(e)},t.prototype.getAll=function(){var t=new Map;return this.listStorage.entries().forEach((function(e){var n=e[0],i=e[1],o=vI.asNumber(n),s=vI.asNumber(i);r.isNullOrUndefined(o)||o<0||r.isNullOrUndefined(s)||o<0||t.set(o,s)})),t},t.prototype.set=function(t,e){this.listStorage.setItem(t.id.toString(),e.toString())},t.prototype.remove=function(t){this.listStorage.removeItem(t.id.toString())},t.prototype.clear=function(){this.listStorage.clear()},t}(),gI=function(){function t(){this.evaluators=new Array}return t.prototype.add=function(t){this.evaluators.push(t)},t.prototype.evaluate=function(t,e){var n=this.evaluators.find((function(e){return e.supports(t)}));if(r.isNullOrUndefined(n))throw new Error("Unsupported EvaluatorRequest [".concat(t.toString(),"]"));return n.evaluate(t,e)},t}(),EI=function(){function t(t){this.conditionMatcherFactory=t}return t.prototype.matches=function(t,e,r){var n=this;return r.conditions.every((function(r){return n._matches(t,e,r)}))},t.prototype.anyMatches=function(t,e,r){var n=this;return!r.length||r.some((function(r){return n.matches(t,e,r)}))},t.prototype._matches=function(t,e,r){return this.conditionMatcherFactory.getMatcher(r.key.type).matches(t,e,r)},t}(),wI=function(){function t(){}return t.prototype.decorate=function(t){return t},t}(),TI=function(){function t(){}return t.prototype.decorate=function(t){return"string"==typeof t?decodeURI(t):t},t}(),_I=function(){function t(t,e){this.valueMatcherFactory=t,this.operatorMatcherFactory=e}return t.prototype.matches=function(t,e,r){void 0===r&&(r=new wI);var n=this.valueMatcherFactory.getMatcher(e.valueType),i=this.operatorMatcherFactory.getMatcher(e.operator),o=this.userValueMatches(t,e,n,i,r);return this.typeMatches(e.type,o)},t.prototype.userValueMatches=function(t,e,r,n,i){return Array.isArray(t)?this.arrayMatches(t,e,r,n,i):this.singleMatches(t,e,r,n,i)},t.prototype.singleMatches=function(t,e,r,n,i){return e.values.some((function(e){return r.matches(n,i.decorate(t),i.decorate(e))}))},t.prototype.arrayMatches=function(t,e,r,n,i){var o=this;return t.some((function(t){return o.singleMatches(t,e,r,n,i)}))},t.prototype.typeMatches=function(t,e){switch(t){case"MATCH":return e;case"NOT_MATCH":return!e}},t}(),II=function(){function t(){}return t.tryParse=function(t){try{return new URL(t)}catch(t){return}},t.removePathnameTrailingSlash=function(e){var r=e instanceof URL?e:t.tryParse(e);if(!r)return String(e);if(r.pathname.endsWith("/")){r.pathname=r.pathname.replace(/\/+$/,"")}return r.href},t}(),AI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return t===e},t.prototype.numberMatches=function(t,e){return t===e},t.prototype.stringMatches=function(t,e){return t===e},t.prototype.versionMatches=function(t,e){return t.isEqualTo(e)},t.prototype.urlMatches=function(t,e){return decodeURI(II.removePathnameTrailingSlash(t))===decodeURI(II.removePathnameTrailingSlash(e))},t}(),bI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return!1},t.prototype.stringMatches=function(t,e){return t.includes(e)},t.prototype.versionMatches=function(t,e){return!1},t.prototype.urlMatches=function(t,e){return decodeURI(t.href).includes(e)},t}(),NI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return!1},t.prototype.stringMatches=function(t,e){return t.startsWith(e)},t.prototype.versionMatches=function(t,e){return!1},t.prototype.urlMatches=function(t,e){return decodeURI(t.href).startsWith(e)},t}(),OI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return!1},t.prototype.stringMatches=function(t,e){return t.endsWith(e)},t.prototype.versionMatches=function(t,e){return!1},t.prototype.urlMatches=function(t,e){return!1},t}(),RI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return t>e},t.prototype.stringMatches=function(t,e){return t>e},t.prototype.versionMatches=function(t,e){return t.isGreaterThan(e)},t.prototype.urlMatches=function(t,e){return!1},t}(),xI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return t>=e},t.prototype.stringMatches=function(t,e){return t>=e},t.prototype.versionMatches=function(t,e){return t.isGreaterThanOrEqualTo(e)},t.prototype.urlMatches=function(t,e){return!1},t}(),MI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return t<e},t.prototype.stringMatches=function(t,e){return t<e},t.prototype.versionMatches=function(t,e){return t.isLessThan(e)},t.prototype.urlMatches=function(t,e){return!1},t}(),SI=function(){function t(){}return t.prototype.booleanMatches=function(t,e){return!1},t.prototype.numberMatches=function(t,e){return t<=e},t.prototype.stringMatches=function(t,e){return t<=e},t.prototype.versionMatches=function(t,e){return t.isLessThanOrEqualTo(e)},t.prototype.urlMatches=function(t,e){return!1},t}(),CI=function(){function t(){}return t.prototype.getMatcher=function(e){switch(e){case"IN":return t.IN_MATCHER;case"CONTAINS":return t.CONTAINS_MATCHER;case"STARTS_WITH":return t.STARTS_WITH_MATCHER;case"ENDS_WITH":return t.ENDS_WITH_MATCHER;case"GT":return t.GT_MATCHER;case"GTE":return t.GTE_MATCHER;case"LT":return t.LT_MATCHER;case"LTE":return t.LTE_MATCHER}},t.IN_MATCHER=new AI,t.CONTAINS_MATCHER=new bI,t.STARTS_WITH_MATCHER=new NI,t.ENDS_WITH_MATCHER=new OI,t.GT_MATCHER=new RI,t.GTE_MATCHER=new xI,t.LT_MATCHER=new MI,t.LTE_MATCHER=new SI,t}(),UI=function(){function t(){}return t.prototype.matches=function(t,e,n){var i=vI.asString(e),o=vI.asString(n);return!r.isNullOrUndefined(i)&&!r.isNullOrUndefined(o)&&t.stringMatches(i,o)},t}(),PI=function(){function t(){}return t.prototype.matches=function(t,e,n){var i=vI.asNumber(e),o=vI.asNumber(n);return!r.isNullOrUndefined(i)&&!r.isNullOrUndefined(o)&&t.numberMatches(i,o)},t}(),kI=function(){function t(){}return t.prototype.matches=function(t,e,r){return"boolean"==typeof e&&"boolean"==typeof r&&t.booleanMatches(e,r)},t}(),DI=function(){function t(){}return t.prototype.matches=function(t,e,r){var n=tt.tryParse(e),i=tt.tryParse(r);return!(!n||!i)&&t.versionMatches(n,i)},t}(),LI=function(){function t(){}return t.prototype.matches=function(t,e,n){var i=II.tryParse(e),o=vI.asString(n);return!r.isNullOrUndefined(i)&&!r.isNullOrUndefined(o)&&t.urlMatches(i,o)},t}(),FI=function(){function t(){}return t.prototype.matches=function(t,e,r){return!1},t}(),VI=function(){function t(){}return t.prototype.getMatcher=function(e){switch(e){case"STRING":case"JSON":return t.STRING_MATCHER;case"NUMBER":return t.NUMBER_MATCHER;case"BOOLEAN":return t.BOOLEAN_MATCHER;case"VERSION":return t.VERSION_MATCHER;case"URL":return t.URL_MATCHER;case"NULL":case"UNKNOWN":return t.NULL_MATCHER}},t.STRING_MATCHER=new UI,t.NUMBER_MATCHER=new PI,t.BOOLEAN_MATCHER=new kI,t.VERSION_MATCHER=new DI,t.URL_MATCHER=new LI,t.NULL_MATCHER=new FI,t}(),jI=function(){function t(t,e){this.URL_HACKLE_PROPERTY_KEY_NAMES=["pagePath","host","url","queryParameter"],this.userValueResolver=t,this.valueOperatorMatcher=e}return t.prototype.matches=function(t,e,n){var i=this.userValueResolver.resolveOrNull(t.user,n.key);if(r.isNullOrUndefined(i))return!1;var o=this.valueDecorator(n.key);return this.valueOperatorMatcher.matches(i,n.match,o)},t.prototype.valueDecorator=function(t){return"HACKLE_PROPERTY"===t.type&&this.URL_HACKLE_PROPERTY_KEY_NAMES.includes(t.name)?new TI:new wI},t}(),GI=function(){function t(){}return t.prototype.resolveOrNull=function(t,e){switch(e.type){case"USER_ID":return t.identifiers[e.name];case"USER_PROPERTY":return t.properties[e.name];case"HACKLE_PROPERTY":return t.hackleProperties[e.name];case"SEGMENT":case"AB_TEST":case"FEATURE_FLAG":case"EVENT_PROPERTY":case"COHORT":throw new Error("Unsupported TargetKeyType [".concat(e.type,"]"))}},t}(),HI=function(){function t(t){this.segmentMatcher=t}return t.prototype.matches=function(t,e,r){var n=this;if("SEGMENT"!=r.key.type)throw new Error("Unsupported TargetKeyType [".concat(r.key.type,"]"));var i=r.match.values.some((function(r){return n._matches(t,e,r)}));switch(r.match.type){case"MATCH":return i;case"NOT_MATCH":return!i}},t.prototype._matches=function(t,e,r){if("string"!=typeof r)throw new Error("SegmentKey[".concat(r,"]"));var n=t.workspace.getSegmentOrNull(r);if(!n)throw new Error("Segment[".concat(r,"]"));return this.segmentMatcher.matches(t,e,n)},t}(),BI=function(){function t(t){this.userConditionMatcher=t}return t.prototype.matches=function(t,e,r){var n=this;return r.targets.some((function(r){return n._matches(t,e,r)}))},t.prototype._matches=function(t,e,r){var n=this;return r.conditions.every((function(r){return n.userConditionMatcher.matches(t,e,r)}))},t}(),KI=function(){function t(t,e){this.abTestMatcher=t,this.featureFlagMatcher=e}return t.prototype.matches=function(t,e,r){switch(r.key.type){case"AB_TEST":return this.abTestMatcher.matches(t,e,r);case"FEATURE_FLAG":return this.featureFlagMatcher.matches(t,e,r);case"USER_ID":case"USER_PROPERTY":case"HACKLE_PROPERTY":case"EVENT_PROPERTY":case"SEGMENT":case"COHORT":throw new Error("Unsupported TargetKeyType [".concat(r.key.type,"]"))}},t}(),zI=function(){function t(t,e){this.evaluator=t,this.valueOperatorMatcher=e}return t.prototype.matches=function(t,e,n){var i,o=r.requiredNotNullOrUndefined(vI.asNumber(n.key.name),(function(){return"Invalid key [".concat(n.key.type,", ").concat(n.key.name,"]")})),s=this.experiment(t,o);if(r.isNullOrUndefined(s))return!1;var u=null!==(i=e.get(s))&&void 0!==i?i:this.evaluate(t,e,s);return this.evaluationMatches(u,n)},t.prototype.evaluate=function(t,e,r){var n=hI.by(t,r),i=this.evaluator.evaluate(n,e),o=this.resolve(t,i);return e.addEvaluation(o),o},t}(),JI=function(t){function e(e,r){return t.call(this,e,r)||this}return a(e,t),e.prototype.experiment=function(t,e){return t.workspace.getExperimentOrNull(e)},e.prototype.resolve=function(t,e){return t instanceof hI&&e.reason===S.TRAFFIC_ALLOCATED?e.with(S.TRAFFIC_ALLOCATED_BY_TARGETING):e},e.prototype.evaluationMatches=function(t,r){return!!e.AB_TEST_MATCHED_REASONS.includes(t.reason)&&this.valueOperatorMatcher.matches(t.variationKey,r.match)},e.AB_TEST_MATCHED_REASONS=[S.OVERRIDDEN,S.TRAFFIC_ALLOCATED,S.EXPERIMENT_COMPLETED,S.TRAFFIC_ALLOCATED_BY_TARGETING],e}(zI),YI=function(t){function e(e,r){return t.call(this,e,r)||this}return a(e,t),e.prototype.experiment=function(t,e){return t.workspace.getFeatureFlagOrNull(e)},e.prototype.resolve=function(t,e){return e},e.prototype.evaluationMatches=function(t,e){var r="A"!==t.variationKey;return this.valueOperatorMatcher.matches(r,e.match)},e}(zI),qI=function(){function t(t,e){this.eventValueResolver=t,this.valueOperatorMatcher=e}return t.prototype.matches=function(t,e,n){if(!this.isEventEvaluatorRequest(t))return!1;var i=this.eventValueResolver.resolveOrNull(t.event,n.key);return!r.isNullOrUndefined(i)&&this.valueOperatorMatcher.matches(i,n.match)},t.prototype.isEventEvaluatorRequest=function(t){return void 0!==t.event},t}(),XI=function(){function t(){}return t.prototype.resolveOrNull=function(t,e){var r;switch(e.type){case"EVENT_PROPERTY":return null===(r=this.properties(t))||void 0===r?void 0:r[e.name];case"USER_ID":case"USER_PROPERTY":case"HACKLE_PROPERTY":case"SEGMENT":case"AB_TEST":case"FEATURE_FLAG":case"COHORT":throw new Error("Unsupported TargetKeyType [".concat(e.type,"]"))}},t.prototype.properties=function(t){return Z_.isTrackEvent(t)?t.event.properties:Z_.isExposureEvent(t)||Z_.isRemoteConfigEvent(t)?t.properties:void 0},t}(),WI=function(){function t(t){this.valueOperatorMatcher=t}return t.prototype.matches=function(t,e,r){var n=this;if("COHORT"!==r.key.type)throw new Error("Unsupported TargetKeyType [".concat(r.key.type,"]"));return!!t.user.cohorts&&t.user.cohorts.some((function(t){return n.valueOperatorMatcher.matches(t.id,r.match)}))},t}(),$I=function(){function t(t){var e=new _I(new VI,new CI);this.userConditionMatcher=new jI(new GI,e),this.eventConditionMatcher=new qI(new XI,e),this.segmentConditionMatcher=new HI(new BI(this.userConditionMatcher)),this.experimentConditionMatcher=new KI(new JI(t,e),new YI(t,e)),this.cohortConditionMatcher=new WI(e)}return t.prototype.getMatcher=function(t){switch(t){case"USER_ID":case"USER_PROPERTY":case"HACKLE_PROPERTY":return this.userConditionMatcher;case"EVENT_PROPERTY":return this.eventConditionMatcher;case"SEGMENT":return this.segmentConditionMatcher;case"AB_TEST":case"FEATURE_FLAG":return this.experimentConditionMatcher;case"COHORT":return this.cohortConditionMatcher}},t}(),ZI=function(){function t(t){this.bucketer=t}return t.prototype.resolveOrNull=function(t,e,r){switch(r.type){case"VARIATION":return this.resolveVariation(t,r);case"BUCKET":return this.resolveBucket(t,r)}},t.prototype.resolveVariation=function(t,e){return t.experiment._getVariationByIdOrNull(e.variationId)},t.prototype.resolveBucket=function(t,e){var r=t.workspace.getBucketOrNull(e.bucketId),n=t.user.identifiers[t.experiment.identifierType];if(n){var i=this.bucketer.bucketing(r,n);if(i)return t.experiment._getVariationByIdOrNull(i.variationId)}},t}(),QI={murmurhash3_x86_32:function(t,e,r,n){void 0===n&&(n=t.length);for(var i,o=3432918353,s=461845907,u=-4&n,a=e,c=0;c<u;c+=4)i=255&t.charCodeAt(c)|(255&t.charCodeAt(c+1))<<8|(255&t.charCodeAt(c+2))<<16|(255&t.charCodeAt(c+3))<<24,i=(131071&(i=this.mul32(i,o)))<<15|i>>>17,a=5*(a=(524287&(a^=i=this.mul32(i,s)))<<13|a>>>19)+3864292196|0;switch(i=0,n%4){case 3:i=(255&t.charCodeAt(u+2))<<16;case 2:i|=(255&t.charCodeAt(u+1))<<8;case 1:i|=255&t.charCodeAt(u),i=(131071&(i=this.mul32(i,o)))<<15|i>>>17,a^=i=this.mul32(i,s)}return a^=n,a^=a>>>16,a=this.mul32(a,2246822507),a^=a>>>13,a=this.mul32(a,3266489909),a^=a>>>16},mul32:function(t,e){var r=65535&e;return((e-r)*t|0)+(r*t|0)|0}},tA=function(){function t(){}return t.prototype.bucketing=function(t,e){var r=this.calculateSlotNumber(t.seed,t.slotSize,e);return t.slots.find((function(t){return t.contains(r)}))},t.prototype.calculateSlotNumber=function(t,e,r){var n=QI.murmurhash3_x86_32(r,t);return Math.abs(n)%Math.abs(e)},t}(),eA=function(){function t(t,e){this.flowEvaluator=t,this.nextFlow=e}return t.prototype.evaluate=function(t,e){return this.flowEvaluator&&this.nextFlow?this.flowEvaluator.evaluate(t,e,this.nextFlow):void 0},t.end=function(){return new t(void 0,void 0)},t.decision=function(e,r){return new t(e,r)},t.of=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];for(var r=this.end(),n=0,i=t.reverse();n<i.length;n++){var o=i[n];r=this.decision(o,r)}return r},t}(),rA=function(){function t(t){this.overrideResolver=t}return t.prototype.evaluate=function(t,e,r){var n=this.overrideResolver.resolveOrNull(t,e);if(!n)return r.evaluate(t,e);switch(t.experiment.type){case"AB_TEST":return uI.of(t,e,n,S.OVERRIDDEN);case"FEATURE_FLAG":return uI.of(t,e,n,S.INDIVIDUAL_TARGET_MATCH)}},t}(),nA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return"DRAFT"===t.experiment.status?uI.ofDefault(t,e,S.EXPERIMENT_DRAFT):r.evaluate(t,e)},t}(),iA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){if("PAUSED"!==t.experiment.status)return r.evaluate(t,e);switch(t.experiment.type){case"AB_TEST":return uI.ofDefault(t,e,S.EXPERIMENT_PAUSED);case"FEATURE_FLAG":return uI.ofDefault(t,e,S.FEATURE_FLAG_INACTIVE)}},t}(),oA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){if("COMPLETED"===t.experiment.status){var n=t.experiment._winnerVariationOrNull();if(!n)throw new Error("winner variation [".concat(t.experiment.id,"]"));return uI.of(t,e,n,S.EXPERIMENT_COMPLETED)}return r.evaluate(t,e)},t}(),sA=function(){function t(t){this.experimentTargetDeterminer=t}return t.prototype.evaluate=function(t,e,r){if("AB_TEST"!==t.experiment.type)throw new Error("experiment type must be AB_TEST [".concat(t.experiment.id,"]"));return this.experimentTargetDeterminer.isUserInExperimentTarget(t,e)?r.evaluate(t,e):uI.ofDefault(t,e,S.NOT_IN_EXPERIMENT_TARGET)},t}(),uA=function(){function t(t){this.actionResolver=t}return t.prototype.evaluate=function(t,e,r){if("RUNNING"!==t.experiment.status)throw new Error("experiment status must be RUNNING [".concat(t.experiment.id,"]"));if("AB_TEST"!==t.experiment.type)throw new Error("experiment type must be AB_TEST [".concat(t.experiment.id,"]"));var n=this.actionResolver.resolveOrNull(t,e,t.experiment.defaultRule);return n?n.isDropped?uI.ofDefault(t,e,S.VARIATION_DROPPED):uI.of(t,e,n,S.TRAFFIC_ALLOCATED):uI.ofDefault(t,e,S.TRAFFIC_NOT_ALLOCATED)},t}(),aA=function(){function t(t,e){this.targetRuleDeterminer=t,this.actionResolver=e}return t.prototype.evaluate=function(t,e,r){if("RUNNING"!==t.experiment.status)throw new Error("experiment status must be RUNNING [".concat(t.experiment.id,"]"));if("FEATURE_FLAG"!==t.experiment.type)throw new Error("experiment type must be FEATURE_FLAG [".concat(t.experiment.id,"]"));if(!t.user.identifiers[t.experiment.identifierType])return r.evaluate(t,e);var n=this.targetRuleDeterminer.determineTargetRuleOrNull(t,e);if(!n)return r.evaluate(t,e);var i=this.actionResolver.resolveOrNull(t,e,n.action);if(!i)throw new Error("FeatureFlag must decide the Variation [".concat(t.experiment.id,"]"));return uI.of(t,e,i,S.TARGET_RULE_MATCH)},t}(),cA=function(){function t(t){this.actionResolver=t}return t.prototype.evaluate=function(t,e,r){if("RUNNING"!==t.experiment.status)throw new Error("experiment status must be RUNNING [".concat(t.experiment.id,"]"));if("FEATURE_FLAG"!==t.experiment.type)throw new Error("experiment type must be FEATURE_FLAG [".concat(t.experiment.id,"]"));if(!t.user.identifiers[t.experiment.identifierType])return uI.ofDefault(t,e,S.DEFAULT_RULE);var n=this.actionResolver.resolveOrNull(t,e,t.experiment.defaultRule);if(!n)throw new Error("FeatureFlag must decide the Variation [".concat(t.experiment.id,"]"));return uI.of(t,e,n,S.DEFAULT_RULE)},t}(),pA=function(){function t(t){this.containerResolver=t}return t.prototype.evaluate=function(t,e,r){var n=t.experiment.containerId;if(!n)return r.evaluate(t,e);var i=t.workspace.getContainerOrNull(n);if(!i)throw new Error("container[".concat(n,"]"));return this.containerResolver.isUserInContainerGroup(t,e,i)?r.evaluate(t,e):uI.ofDefault(t,e,S.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT)},t}(),fA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return t.user.identifiers[t.experiment.identifierType]?r.evaluate(t,e):uI.ofDefault(t,e,S.IDENTIFIER_NOT_FOUND)},t}(),lA=function(){function t(t){this.targetMatcher=t}return t.prototype.isUserInExperimentTarget=function(t,e){var r=this;return 0===t.experiment.targetAudiences.length||t.experiment.targetAudiences.some((function(n){return r.targetMatcher.matches(t,e,n)}))},t}(),hA=function(){function t(t){this.targetMatcher=t}return t.prototype.determineTargetRuleOrNull=function(t,e){var r=this;return t.experiment.targetRules.find((function(n){return r.targetMatcher.matches(t,e,n.target)}))},t}(),dA=function(){function t(t,e,r){this.manualOverrideStorage=t,this.targetMatcher=e,this.actionResolver=r}return t.prototype.resolveOrNull=function(t,e){var r,n;return null!==(n=null!==(r=this.resolveManualOverride(t))&&void 0!==r?r:this._resolveUserOverride(t))&&void 0!==n?n:this._resolveSegmentOverride(t,e)},t.prototype.resolveManualOverride=function(t){return this.manualOverrideStorage.getVariation(t.experiment,t.user)},t.prototype._resolveUserOverride=function(t){var e=t.experiment,r=t.user.identifiers[e.identifierType];if(r){var n=e.userOverrides.get(r);if(n)return e._getVariationByIdOrNull(n)}},t.prototype._resolveSegmentOverride=function(t,e){var r=this,n=t.experiment.segmentOverrides.find((function(n){return r.targetMatcher.matches(t,e,n.target)}));if(n)return this.actionResolver.resolveOrNull(t,e,n.action)},t}(),vA=function(){function t(t){this.bucketer=t}return t.prototype.isUserInContainerGroup=function(t,e,n){var i=t.user.identifiers[t.experiment.identifierType];if(r.isNullOrUndefined(i))return!1;var o=t.workspace.getBucketOrNull(n.bucketId);if(r.isNullOrUndefined(o))throw new Error("Bucket[".concat(n.bucketId,"]"));var s=this.bucketer.bucketing(o,i);if(r.isNullOrUndefined(s))return!1;var u=n.getGroupOrNull(s.variationId);if(r.isNullOrUndefined(u))throw new Error("ContainerGroup[".concat(s.variationId,"]"));return u.experiments.includes(t.experiment.id)},t}(),yA=function(){function t(t,e,r,n){this.reason=t,this.targetEvaluations=e,this.inAppMessage=r,this.message=n}return t.of=function(e,r,n,i){return new t(n,r.targetEvaluations,e.inAppMessage,i)},t}(),mA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return t.inAppMessage.supports("WEB")?r.evaluate(t,e):yA.of(t,e,S.UNSUPPORTED_PLATFORM)},t}(),gA=function(){function t(t,e){this.userOverrideMatcher=t,this.inAppMessageResolver=e}return t.prototype.evaluate=function(t,e,r){if(this.userOverrideMatcher.matches(t,e)){var n=this.inAppMessageResolver.resolve(t,e);return yA.of(t,e,S.OVERRIDDEN,n)}return r.evaluate(t,e)},t}(),EA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return"DRAFT"===t.inAppMessage.status?yA.of(t,e,S.IN_APP_MESSAGE_DRAFT):r.evaluate(t,e)},t}(),wA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return"PAUSE"===t.inAppMessage.status?yA.of(t,e,S.IN_APP_MESSAGE_PAUSED):r.evaluate(t,e)},t}(),TA=function(){function t(){}return t.prototype.evaluate=function(t,e,r){return t.inAppMessage.period.within(t.timestamp)?r.evaluate(t,e):yA.of(t,e,S.NOT_IN_IN_APP_MESSAGE_PERIOD)},t}(),_A=function(){function t(t){this.hiddenMatcher=t}return t.prototype.evaluate=function(t,e,r){return this.hiddenMatcher.matches(t,e)?yA.of(t,e,S.IN_APP_MESSAGE_HIDDEN):r.evaluate(t,e)},t}(),IA=function(){function t(t,e){this.targetMatcher=t,this.inAppMessageResolver=e}return t.prototype.evaluate=function(t,e,r){if(this.targetMatcher.matches(t,e)){var n=this.inAppMessageResolver.resolve(t,e);return yA.of(t,e,S.IN_APP_MESSAGE_TARGET,n)}return yA.of(t,e,S.NOT_IN_IN_APP_MESSAGE_TARGET)},t}(),AA=function(){function t(){}return t.prototype.resolve=function(t,e){var n=t.inAppMessage,i=n.messageContext.defaultLang,o=n.messageContext.messages.find((function(t){return t.lang===i}));if(r.isNullOrUndefined(o))throw new Error("InAppMessage must be decided [".concat(n.id,"]"));return o},t}(),bA=function(){function t(){}return t.prototype.matches=function(t,e){var r=this;return t.inAppMessage.targetContext.overrides.some((function(e){return r.isUserOverridden(t,e)}))},t.prototype.isUserOverridden=function(t,e){var n=t.user.identifiers[e.identifierType];return!r.isNullOrUndefined(n)&&e.identifiers.includes(n)},t}(),NA=function(){function t(t){this.targetMatcher=t}return t.prototype.matches=function(t,e){var r=this,n=t.inAppMessage.targetContext.targets;return 0===n.length||n.some((function(n){return r.targetMatcher.matches(t,e,n)}))},t}(),OA=function(){function t(t){this.storage=t}return t.prototype.matches=function(t,e){return this.storage.exist(t.inAppMessage,t.timestamp)},t}(),RA=function(){function t(t,e){this.targetMatcher=t,this.bucketer=e}return t.prototype.determineTargetRuleOrNull=function(t,e){var r=this;return t.parameter.targetRules.find((function(n){return r.matches(t,e,n)}))},t.prototype.matches=function(t,e,n){if(!this.targetMatcher.matches(t,e,n.target))return!1;var i=t.user.identifiers[t.parameter.identifierType];if(r.isNullOrUndefined(i))return!1;var o=t.workspace.getBucketOrNull(n.bucketId);if(r.isNullOrUndefined(o))throw new Error("bucket[".concat(n.bucketId,"]"));return r.isNotNullOrUndefined(this.bucketer.bucketing(o,i))},t}(),xA=function(){function t(){}return t.get=function(t){return r.requiredNotNullOrUndefined(this.getOrNull(t),(function(){return"Instance not registered [".concat(t,"]")}))},t.getOrNull=function(e){return t.instances.get(e)},t.register=function(e,r){return t.instances.set(e,r),r},t.instances=new Map,t}(),MA=function(){function t(t,e,r){var n=new tA,i=xA.register("targetMatcher",new EI(new $I(t))),o=new ZI(n),s=new dA(e,i,o),u=new vA(n);this.abTestFlow=eA.of(new rA(s),new fA,new pA(u),new sA(new lA(i)),new nA,new iA,new oA,new uA(o)),this.featureFlagFlow=eA.of(new nA,new iA,new oA,new rA(s),new fA,new aA(new hA(i),o),new cA(o));var a=new AA;this.inAppMessageFlow=eA.of(new mA,new gA(new bA,a),new EA,new wA,new TA,new _A(new OA(r)),new IA(new NA(i),a)),this.remoteConfigParameterTargetRuleDeterminer=new RA(i,n)}return t.prototype.getExperimentFlow=function(t){switch(t){case"AB_TEST":return this.abTestFlow;case"FEATURE_FLAG":return this.featureFlagFlow}},t.prototype.getInAppMessageFlow=function(){return this.inAppMessageFlow},t}(),SA=function(){function t(t){this.clock=t}return t.prototype.create=function(e,r){var n=this,i=this.clock.currentMillis(),o=new Array,s=this.createEvent(e,r,i,{});return o.push(s),r.targetEvaluations.forEach((function(r){var s,u=((s={})[t.ROOT_TYPE]=e.key.type,s[t.ROOT_ID]=e.key.id,s),a=n.createEvent(e,r,i,u);o.push(a)})),o},t.prototype.createEvent=function(e,r,n,i){var o;if(r instanceof uI)return i[t.CONFIG_ID_PROPERTY_KEY]=null===(o=r.config)||void 0===o?void 0:o.id,i[t.EXPERIMENT_VERSION_KEY]=r.experiment.version,i[t.EXECUTION_VERSION_KEY]=r.experiment.executionVersion,Z_.exposure(e.user,r,i,n);if(r instanceof cI)return Z_.remoteConfig(e.user,r,c(c({},i),r.properties),n);throw new Error("Unsupported Evaluation [".concat(typeof r,"]"))},t.ROOT_TYPE="$targetingRootType",t.ROOT_ID="$targetingRootId",t.CONFIG_ID_PROPERTY_KEY="$parameterConfigurationId",t.EXPERIMENT_VERSION_KEY="$experiment_version",t.EXECUTION_VERSION_KEY="$execution_version",t}(),CA=function(t){function e(e){var r=t.call(this)||this;return r.evaluationFlowFactory=e,r}return a(e,t),e.prototype.supports=function(t){return void 0!==t.inAppMessage},e.prototype.evaluateInternal=function(t,e){var r;return null!==(r=this.evaluationFlowFactory.getInAppMessageFlow().evaluate(t,e))&&void 0!==r?r:yA.of(t,e,S.NOT_IN_IN_APP_MESSAGE_TARGET)},e}(sI),UA=function(){function t(t,e,r,n){this.key=new fI("IN_APP_MESSAGE",r.key),this.workspace=t,this.user=e,this.inAppMessage=r,this.timestamp=n}return t.of=function(e,r,n,i){return new t(e,r,n,i)},t.prototype.toString=function(){return"EvaluatorRequest(type=".concat(this.key.type,", key=").concat(this.inAppMessage.key,")")},t}(),PA=o.log,kA=function(){function t(t,e,r,n,i,o,s,u){this.experimentEvaluator=t,this.remoteConfigEvaluator=e,this.inAppMessageEvaluator=r,this.workspaceFetcher=n,this.eventFactory=i,this.eventProcessor=o,this.errorDedupDeterminer=s,this.clock=u}return t.create=function(e,r,n,i){var o=new gI,s=new yI(n),u=new MA(o,s,i),a=new aI(u),c=new pI(u.remoteConfigParameterTargetRuleDeterminer),p=new CA(u);return o.add(a),o.add(c),new t(a,c,p,e,new SA(E.instance),r,new DA,E.instance)},t.prototype.experiment=function(t,e,r){var n=this;if(!t)return PA.error("experimentKey must not be empty"),O.of(r,S.INVALID_INPUT);var i=this.workspaceFetcher.get();if(!i)return PA.warn("SDK not ready."),O.of(r,S.SDK_NOT_READY);var o=i.getExperimentOrNull(t);if(!o)return PA.warn("Experiment does not exist."),O.of(r,S.EXPERIMENT_NOT_FOUND);var s=hI.of(i,e,o,r),u=this.experimentInternal(s),a=u[0],c=u[1];return this.eventFactory.create(s,a).forEach((function(t){return n.eventProcessor.process(t)})),c},t.prototype.experiments=function(t){var e=this,r=new Xt((function(t,e){return t.id===e.id})),n=this.workspaceFetcher.get();return n?(n.getExperiments().forEach((function(i){var o=hI.of(n,t,i,"A"),s=e.experimentInternal(o);s[0];var u=s[1];r.add(i,u)})),r):r},t.prototype.experimentInternal=function(t){var e,r=this.experimentEvaluator.evaluate(t,lI.create()),n=null!==(e=r.config)&&void 0!==e?e:new w;return[r,O.of(r.variationKey,r.reason,n)]},t.prototype.featureFlag=function(t,e){var r=this;if(!t)return PA.error("featureKey must not be empty"),R.off(S.INVALID_INPUT);var n=this.workspaceFetcher.get();if(!n)return PA.warn("SDK not ready."),R.off(S.SDK_NOT_READY);var i=n.getFeatureFlagOrNull(t);if(!i)return PA.warn("FeatureFlag does not exist."),R.off(S.FEATURE_FLAG_NOT_FOUND);var o=hI.of(n,e,i,"A"),s=this.featureFlagInternal(o),u=s[0],a=s[1];return this.eventFactory.create(o,u).forEach((function(t){return r.eventProcessor.process(t)})),a},t.prototype.featureFlags=function(t){var e=this,r=new Xt((function(t,e){return t.id===e.id})),n=this.workspaceFetcher.get();return n?(n.getFeatureFlags().forEach((function(i){var o=hI.of(n,t,i,"A"),s=e.featureFlagInternal(o);s[0];var u=s[1];r.add(i,u)})),r):r},t.prototype.featureFlagInternal=function(t){var e,r=this.experimentEvaluator.evaluate(t,lI.create()),n=null!==(e=r.config)&&void 0!==e?e:new w;return[r,"A"===r.variationKey?R.off(r.reason,n):R.on(r.reason,n)]},t.prototype.inAppMessage=function(t,e){var r=this.workspaceFetcher.get();if(!r)return PA.warn("SDK not ready."),N.of(S.SDK_NOT_READY);var n=r.getInAppMessageOrNull(t);if(!n)return PA.warn("In app message does not exist."),N.of(S.IN_APP_MESSAGE_NOT_FOUND);var i=UA.of(r,e,n,this.clock.currentMillis()),o=this.inAppMessageEvaluator.evaluate(i,lI.create());return N.of(o.reason,o.inAppMessage,o.message)},t.prototype.tryInAppMessage=function(t,e){var r,n=Bt.start();try{r=this.inAppMessage(t,e)}catch(e){PA.error("Unexpected error while deciding in app message [".concat(t,"]: ").concat(e)),r=N.of(S.EXCEPTION)}return ve.inAppMessage(n,t,r),r},t.prototype.track=function(t,e,r){var n;if(void 0===r&&(r=(new Date).getTime()),t)if("object"==typeof t)if("object"!=typeof t||t.key&&"string"==typeof t.key){var i=(null===(n=this.workspaceFetcher.get())||void 0===n?void 0:n.getEventTypeOrNull(t.key))||new D(0,t.key);this.eventProcessor.process(Z_.track(i,t,e,r))}else PA.warn("Event key must be not null. or event key must be string type.");else PA.warn("Event must be event type.");else PA.warn("event must not be null.")},t.prototype.trackException=function(t,e){if(!this.errorDedupDeterminer.isDedupTarget(t)){var r=oI.toEvent(t);this.flush(),this.track(r,e),this.flush()}},t.prototype.flush=function(){this.eventProcessor.flush(!1)},t.prototype.remoteConfig=function(t,e,n,i){var o=this,s=this.workspaceFetcher.get();if(r.isNullOrUndefined(s))return PA.warn("SDK not ready."),b.of(i,S.SDK_NOT_READY);var u=s.getRemoteConfigParameterOrNull(t);if(r.isNullOrUndefined(u))return PA.warn("Remote config parameter does not exist."),b.of(i,S.REMOTE_CONFIG_PARAMETER_NOT_FOUND);var a=dI.of(s,e,u,n,i),c=this.remoteConfigEvaluator.evaluate(a,lI.create());return this.eventFactory.create(a,c).forEach((function(t){return o.eventProcessor.process(t)})),b.of(c.value,c.reason)},t.prototype.close=function(){this.eventProcessor.close()},t}(),DA=function(){function t(){}return t.prototype.isDedupTarget=function(t){return!!this._isSameError(t,this.previous)||(this.previous=t,!1)},t.prototype._isSameError=function(t,e){return!r.isNullOrUndefined(e)&&(t.name===e.name&&t.message===e.message&&t.stack===e.stack)},t}(),LA=function(){function t(){this._installed=[],this._installations={onerror:VA,onunhandledrejection:jA}}return t.prototype.install=function(t,e){this._install("onerror",t,e),this._install("onunhandledrejection",t,e)},t.prototype._install=function(t,e,r){t in this._installed||((0,this._installations[t])(e,r),this._installed.push(t))},t}(),FA=null;function VA(t,e){FA=window.onerror,window.onerror=function(n,i,o,s,u){r.isNotNullOrUndefined(u)&&t.trackException(u,e.resolve()),FA&&FA.apply(this,arguments)}}function jA(t,e){$_=window.onunhandledrejection,window.onunhandledrejection=function(r){var n;try{"reason"in r?n=r.reason:"detail"in r&&"reason"in r.detail&&(n=r.detail.reason)}catch(t){}n instanceof Error&&t.trackException(n,e.resolve()),$_&&$_.apply(this,arguments)}}var GA=function(){function t(t,e,r){this.storage=t,this.storageKey=e,this.maxSize=r}return t.prototype.read=function(){return p(this,void 0,void 0,(function(){var t;return f(this,(function(e){return(t=this.storage.getItem(this.storageKey))?[2,JSON.parse(t)]:[2,[]]}))}))},t.prototype.save=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){return 0===t.length?[2,this.clear()]:(e=JSON.stringify(t.slice(-this.maxSize)),this.storage.setItem(this.storageKey,e),[2])}))}))},t.prototype.add=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:return[4,this.read()];case 1:return e=r.sent(),[4,this.save(e.concat(t).slice(-this.maxSize))];case 2:return r.sent(),[2]}}))}))},t.prototype.delete=function(t){return p(this,void 0,void 0,(function(){var e,r,n=this;return f(this,(function(i){switch(i.label){case 0:return[4,this.read()];case 1:return e=i.sent(),r=e.filter((function(e){return!n.isDeleteTarget(e,t)})),[4,this.save(r)];case 2:return i.sent(),[2]}}))}))},t.prototype.isDeleteTarget=function(t,e){return e.some((function(e){return e.insertId===t.insertId}))},t.prototype.clear=function(){return p(this,void 0,void 0,(function(){return f(this,(function(t){return this.storage.removeItem(this.storageKey),[2]}))}))},t}(),HA=function(t,e){return null!==t&&(t.userId===e.userId&&t.deviceId===e.deviceId)},BA=function(){function t(t){this.cohorts=t}return t.builder=function(){return new KA},t.empty=function(){return t.builder().build()},t.from=function(e){return new t(e)},t.fromDto=function(e){for(var r=t.builder(),n=0,i=e.cohorts;n<i.length;n++){var o=i[n];r.put({identifier:o.identifier,cohorts:o.cohorts.map((function(t){return new Vt(t)}))})}return r.build()},Object.defineProperty(t.prototype,"rawCohorts",{get:function(){return this.cohorts.values().flatMap((function(t){return t.cohorts}))},enumerable:!1,configurable:!0}),t.prototype.get=function(t){return this.cohorts.get(t)},t.prototype.filterBy=function(e){var r=F(e),n=this.asComparable().filter((function(t,e){return r[t.type]===t.value}));return t.from(n)},t.prototype.asArray=function(){return this.cohorts.values()},t.prototype.asComparable=function(){return this.cohorts},t.prototype.toBuilder=function(){return new KA(this)},t}(),KA=function(){function t(t){this.cohorts=new Xt(d.isEqual),t&&this.putAll(t)}return t.prototype.put=function(t){return this.cohorts.add(t.identifier,t),this},t.prototype.putAll=function(t){var e=this;return t.asArray().forEach((function(t){return e.put(t)})),this},t.prototype.build=function(){return new BA(this.cohorts)},t}(),zA="model",JA="name",YA="type",qA="vendor",XA="version",WA="mobile",$A="tablet",ZA=function(){function t(){}return t.parse=function(e){return{browser:t.getBrowser(e),cpu:t.getCPU(e),device:t.getDevice(e),engine:t.getEngine(e),os:t.getOS(e)}},t.getBrowser=function(e){var r={name:void 0,version:void 0,major:void 0};return t.mapper.rgx.call(r,e,t.regexes.browser),r.major=t.util.major(r.version),r},t.getCPU=function(e){var r={architecture:void 0};return t.mapper.rgx.call(r,e,t.regexes.cpu),r},t.getDevice=function(e){var r={model:void 0,type:void 0,vendor:void 0};return t.mapper.rgx.call(r,e,t.regexes.device),r},t.getEngine=function(e){var r={name:void 0,version:void 0};return t.mapper.rgx.call(r,e,t.regexes.os),r},t.getOS=function(e){var r={name:void 0,version:void 0};return t.mapper.rgx.call(r,e,t.regexes.os),r},t.util={extend:function(t,e){var r={};for(var n in t)e[n]&&e[n].length%2==0?r[n]=e[n].concat(t[n]):r[n]=t[n];return r},has:function(t,e){return"string"==typeof t&&-1!==e.toLowerCase().indexOf(t.toLowerCase())},lowerize:function(t){return t.toLowerCase()},major:function(t){return"string"==typeof t?t.replace(/[^\d\.]/g,"").split(".")[0]:void 0},trim:function(t){return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}},t.mapper={rgx:function(t,e){for(var r,n,i,o,s,u,a=0;a<e.length&&!s;){var c=e[a],p=e[a+1];for(r=n=0;r<c.length&&!s;)if(s=c[r++].exec(t))for(i=0;i<p.length;i++)u=s[++n],"object"==typeof(o=p[i])&&o.length>0?2==o.length?"function"==typeof o[1]?this[o[0]]=o[1].call(this,u):this[o[0]]=o[1]:3==o.length?"function"!=typeof o[1]||o[1].exec&&o[1].test?this[o[0]]=u?u.replace(o[1],o[2]):void 0:this[o[0]]=u?o[1].call(this,u,o[2]):void 0:4==o.length&&(this[o[0]]=u?o[3].call(this,u.replace(o[1],o[2])):void 0):this[o]=u||void 0;a+=2}},str:function(e,r){for(var n in r)if("object"==typeof r[n]&&r[n].length>0){for(var i=0;i<r[n].length;i++)if(t.util.has(r[n][i],e))return"?"===n?void 0:n}else if(t.util.has(r[n],e))return"?"===n?void 0:n;return e}},t.maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}},t.regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[JA,XA],[/(opios)[\/\s]+([\w\.]+)/i],[[JA,"Opera Mini"],XA],[/\s(opr)\/([\w\.]+)/i],[[JA,"Opera"],XA],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[JA,XA],[/(konqueror)\/([\w\.]+)/i],[[JA,"Konqueror"],XA],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[JA,"IE"],XA],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[JA,"Edge"],XA],[/(yabrowser)\/([\w\.]+)/i],[[JA,"Yandex"],XA],[/(Avast)\/([\w\.]+)/i],[[JA,"Avast Secure Browser"],XA],[/(AVG)\/([\w\.]+)/i],[[JA,"AVG Secure Browser"],XA],[/(puffin)\/([\w\.]+)/i],[[JA,"Puffin"],XA],[/(focus)\/([\w\.]+)/i],[[JA,"Firefox Focus"],XA],[/(opt)\/([\w\.]+)/i],[[JA,"Opera Touch"],XA],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[JA,"UCBrowser"],XA],[/(comodo_dragon)\/([\w\.]+)/i],[[JA,/_/g," "],XA],[/(windowswechat qbcore)\/([\w\.]+)/i],[[JA,"WeChat(Win) Desktop"],XA],[/(micromessenger)\/([\w\.]+)/i],[[JA,"WeChat"],XA],[/(brave)\/([\w\.]+)/i],[[JA,"Brave"],XA],[/(whale)\/([\w\.]+)/i],[[JA,"Whale"],XA],[/(qqbrowserlite)\/([\w\.]+)/i],[JA,XA],[/(QQ)\/([\d\.]+)/i],[JA,XA],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[JA,XA],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[JA,XA],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[JA,XA],[/(MetaSr)[\/\s]?([\w\.]+)/i],[JA],[/(LBBROWSER)/i],[JA],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[XA,[JA,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[XA,[JA,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[JA,XA],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[XA,[JA,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[JA,/(.+)/,"$1 WebView"],XA],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[JA,/(.+(?:g|us))(.+)/,"$1 $2"],XA],[/((?:android.+)crmo|crios)\/([\w\.]+)/i,/android.+(chrome)\/([\w\.]+)\s+(?:mobile\s?safari)/i],[[JA,"Chrome Mobile"],XA],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[XA,[JA,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[JA,"Sailfish Browser"],XA],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[JA,XA],[/(dolfin)\/([\w\.]+)/i],[[JA,"Dolphin"],XA],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[JA,"360 Browser"]],[/(coast)\/([\w\.]+)/i],[[JA,"Opera Coast"],XA],[/fxios\/([\w\.-]+)/i],[XA,[JA,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[XA,[JA,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[XA,JA],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[JA,"GSA"],XA],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[JA,[XA,t.mapper.str,t.maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[JA,XA],[/(navigator|netscape)\/([\w\.-]+)/i],[[JA,"Netscape"],XA],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[JA,XA]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[["architecture","amd64"]],[/(ia32(?=;))/i],[["architecture",t.util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[["architecture","ia32"]],[/windows\s(ce|mobile);\sppc;/i],[["architecture","arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[["architecture",/ower/,"",t.util.lowerize]],[/(sun4\w)[;\)]/i],[["architecture","sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[["architecture",t.util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[zA,qA,[YA,$A]],[/applecoremedia\/[\w\.]+ \((ipad)/],[zA,[qA,"Apple"],[YA,$A]],[/(apple\s{0,1}tv)/i],[[zA,"Apple TV"],[qA,"Apple"],[YA,"smarttv"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[qA,zA,[YA,$A]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[zA,[qA,"Amazon"],[YA,$A]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[zA,t.mapper.str,t.maps.device.amazon.model],[qA,"Amazon"],[YA,WA]],[/android.+aft([bms])\sbuild/i],[zA,[qA,"Amazon"],[YA,"smarttv"]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[zA,qA,[YA,WA]],[/\((ip[honed|\s\w*]+);/i],[zA,[qA,"Apple"],[YA,WA]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[qA,zA,[YA,WA]],[/\(bb10;\s(\w+)/i],[zA,[qA,"BlackBerry"],[YA,WA]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[zA,[qA,"Asus"],[YA,$A]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[qA,"Sony"],[zA,"Xperia Tablet"],[YA,$A]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[zA,[qA,"Sony"],[YA,WA]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[qA,zA,[YA,"console"]],[/android.+;\s(shield)\sbuild/i],[zA,[qA,"Nvidia"],[YA,"console"]],[/(playstation\s[34portablevi]+)/i],[zA,[qA,"Sony"],[YA,"console"]],[/(sprint\s(\w+))/i],[[qA,t.mapper.str,t.maps.device.sprint.vendor],[zA,t.mapper.str,t.maps.device.sprint.model],[YA,WA]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[qA,[zA,/_/g," "],[YA,WA]],[/(nexus\s9)/i],[zA,[qA,"HTC"],[YA,$A]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i],[zA,[qA,"Huawei"],[YA,WA]],[/android.+(bah2?-a?[lw]\d{2})/i],[zA,[qA,"Huawei"],[YA,$A]],[/(microsoft);\s(lumia[\s\w]+)/i],[qA,zA,[YA,WA]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[zA,[qA,"Microsoft"],[YA,"console"]],[/(kin\.[onetw]{3})/i],[[zA,/\./g," "],[qA,"Microsoft"],[YA,WA]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[zA,[qA,"Motorola"],[YA,WA]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[zA,[qA,"Motorola"],[YA,$A]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[qA,t.util.trim],[zA,t.util.trim],[YA,"smarttv"]],[/hbbtv.+maple;(\d+)/i],[[zA,/^/,"SmartTV"],[qA,"Samsung"],[YA,"smarttv"]],[/\(dtv[\);].+(aquos)/i],[zA,[qA,"Sharp"],[YA,"smarttv"]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[qA,"Samsung"],zA,[YA,$A]],[/smart-tv.+(samsung)/i],[qA,[YA,"smarttv"],zA],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[qA,"Samsung"],zA,[YA,WA]],[/sie-(\w*)/i],[zA,[qA,"Siemens"],[YA,WA]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[qA,"Nokia"],zA,[YA,WA]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[zA,[qA,"Acer"],[YA,$A]],[/android.+([vl]k\-?\d{3})\s+build/i],[zA,[qA,"LG"],[YA,$A]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[qA,"LG"],zA,[YA,$A]],[/(lg) netcast\.tv/i],[qA,zA,[YA,"smarttv"]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[zA,[qA,"LG"],[YA,WA]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[qA,zA,[YA,$A]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[zA,[qA,"Lenovo"],[YA,$A]],[/(lenovo)[_\s-]?([\w-]+)/i],[qA,zA,[YA,WA]],[/linux;.+((jolla));/i],[qA,zA,[YA,WA]],[/((pebble))app\/[\d\.]+\s/i],[qA,zA,[YA,"wearable"]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[qA,zA,[YA,WA]],[/crkey/i],[[zA,"Chromecast"],[qA,"Google"],[YA,"smarttv"]],[/android.+;\s(glass)\s\d/i],[zA,[qA,"Google"],[YA,"wearable"]],[/android.+;\s(pixel c)[\s)]/i],[zA,[qA,"Google"],[YA,$A]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[zA,[qA,"Google"],[YA,WA]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[zA,/_/g," "],[qA,"Xiaomi"],[YA,WA]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[zA,/_/g," "],[qA,"Xiaomi"],[YA,$A]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[zA,[qA,"Meizu"],[YA,WA]],[/(mz)-([\w-]{2,})/i],[[qA,"Meizu"],zA,[YA,WA]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[zA,[qA,"OnePlus"],[YA,WA]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[zA,[qA,"RCA"],[YA,$A]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[zA,[qA,"Dell"],[YA,$A]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[zA,[qA,"Verizon"],[YA,$A]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[qA,"Barnes & Noble"],zA,[YA,$A]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[zA,[qA,"NuVision"],[YA,$A]],[/android.+;\s(k88)\sbuild/i],[zA,[qA,"ZTE"],[YA,$A]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[zA,[qA,"Swiss"],[YA,WA]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[zA,[qA,"Swiss"],[YA,$A]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[zA,[qA,"Zeki"],[YA,$A]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[qA,"Dragon Touch"],zA,[YA,$A]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[zA,[qA,"Insignia"],[YA,$A]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[zA,[qA,"NextBook"],[YA,$A]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[qA,"Voice"],zA,[YA,WA]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[qA,"LvTel"],zA,[YA,WA]],[/android.+;\s(PH-1)\s/i],[zA,[qA,"Essential"],[YA,WA]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[zA,[qA,"Envizen"],[YA,$A]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[qA,zA,[YA,$A]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[zA,[qA,"MachSpeed"],[YA,$A]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[qA,zA,[YA,$A]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[zA,[qA,"Rotor"],[YA,$A]],[/android.+(KS(.+))\s+build/i],[zA,[qA,"Amazon"],[YA,$A]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[qA,zA,[YA,$A]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[YA,t.util.lowerize],qA,zA],[/[\s\/\(](smart-?tv)[;\)]/i],[[YA,"smarttv"]],[/(android[\w\.\s\-]{0,9});.+build/i],[zA,[qA,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[XA,[JA,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[XA,[JA,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[JA,XA],[/rv\:([\w\.]{1,9}).+(gecko)/i],[XA,JA]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[JA,XA],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[[JA,t.mapper.str,t.maps.os.windows],[XA,t.mapper.str,t.maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[JA,"Windows"],[XA,t.mapper.str,t.maps.os.windows.version]],[/\((bb)(10);/i],[[JA,"BlackBerry"],XA],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[JA,XA],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[JA,"Symbian"],XA],[/\((series40);/i],[JA],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[JA,"Firefox OS"],XA],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[[JA,"Linux"],XA],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[JA,"Chromium OS"],XA],[/(sunos)\s?([\w\.\d]*)/i],[[JA,"Solaris"],XA],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[[JA,"Linux"],XA],[/(iphone)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i],[[JA,"iPhone"],[XA,/_/g,"."]],[/(ipad)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i],[[JA,"iPad"],[XA,/_/g,"."]],[/(haiku)\s(\w+)/i],[JA,XA],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[XA,/_/g,"."],[JA,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[JA,"Mac"],[XA,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[JA,XA]]},t}(),QA=function(){function t(){}return t.generate=function(t){var e,r,n,i,o,s,u;if(void 0===t){var a={hostname:"",pathname:"",host:"",search:"",protocol:""};u={navigator:{userAgent:"",vendor:"",languages:[]},document:{location:a,title:""},location:a,screen:{width:"",height:""}}}else u=t;var c=ZA.parse(u.navigator.userAgent),p=c.browser,f=c.os,l=c.device,h=(u.location.protocol||"").replace(":",""),d=u.screen,v=(null===(e=u.navigator.languages)||void 0===e?void 0:e[0])||"",y=v.split("-")[0],m=(null!==(r=l.type)&&void 0!==r?r:"pc").replace(/\b(mobile|smarttv)\b/g,(function(t,e){return"mobile"===e?"phone":"smarttv"===e?"tv":t})),g=f.name||"",E="",w="";try{g=null!==(i=null===(n=g.match(/\b(Mac|Windows|Linux|Android|iOS)\b/))||void 0===n?void 0:n[0])&&void 0!==i?i:g,E=null!==(s=null===(o=d.orientation.type.match(/\b(landscape|portrait)\b/))||void 0===o?void 0:o[0])&&void 0!==s?s:"",w=Intl.DateTimeFormat().resolvedOptions().timeZone||""}catch(t){}return{platform:"Web",browserName:p.name||"",browserMajorVersion:p.major||"",browserVersion:p.version||"",osName:g,osVersion:f.version||"",deviceModel:l.model||"",deviceType:m,deviceVendor:l.vendor||"",deviceBrand:l.vendor||"",locale:v,language:y,orientation:E,userAgent:u.navigator.userAgent||"",pagePath:u.location.pathname||"",pageTitle:u.document.title||"",host:u.location.host||"",url:u.location.href||"",protocol:h,referrer:u.document.referrer||"",queryParameter:u.location.search||"",screenWidth:d.width||"",screenHeight:d.height||"",timeZone:w}},t}(),tb=function(){function t(t,e,r,n,i,o){this.hackleDeviceId=t,this.storage=e,this.cohortFetcher=r,this.clock=n,this.userListeners=[],this.defaultUser={id:this.hackleDeviceId,deviceId:this.hackleDeviceId},this.context=this.initContext(i,o),this.storage.saveUser(this.context.user)}return t.prototype.initContext=function(t,e){var r,n=null!==(r=null!=e?e:t)&&void 0!==r?r:this.defaultUser;return rb.of(nb(n,this.hackleDeviceId),BA.empty())},t.prototype.addListener=function(t){this.userListeners.push(t)},Object.defineProperty(t.prototype,"currentUser",{get:function(){return this.context.user},enumerable:!1,configurable:!0}),t.prototype.resolve=function(t){var e=this.resolveContext(t);return this.hackleUser(e)},t.prototype.resolveContext=function(t){return void 0===t?this.context:"string"==typeof t?this.updateUser({id:t}):this.updateUser(t)},t.prototype.toHackleUser=function(t){var e=this.context.with(t);return this.hackleUser(e)},t.prototype.hackleUser=function(t){var e=(new V).addIdentifiers(t.user.identifiers||{}).add(L.ID,t.user.id||this.hackleDeviceId).add(L.DEVICE,t.user.deviceId||this.hackleDeviceId).add(L.HACKLE_DEVICE,this.hackleDeviceId);return r.isNotNullOrUndefined(t.user.userId)&&e.add(L.USER,t.user.userId),{identifiers:e.build(),properties:t.user.properties||{},hackleProperties:this.hackleProperties(),cohorts:t.cohorts.rawCohorts}},t.prototype.hackleProperties=function(){var t;return"undefined"!=typeof window&&(t=QA.generate(window)),t||{}},t.prototype.setUser=function(t){return this.updateUser(t).user},t.prototype.setUserId=function(t){var e=c(c({},this.context.user),{userId:t});return this.setUser(e)},t.prototype.setDeviceId=function(t){var e=c(c({},this.context.user),{deviceId:t});return this.setUser(e)},t.prototype.updateUserProperties=function(t){return this.operateProperties(t).user},t.prototype.resetUser=function(){var t=this;return this.updateContext((function(){return t.defaultUser})).user},t.prototype.changeUser=function(t,e,r){this.userListeners.forEach((function(n){n.onUserUpdated(t,e,r)}))},t.prototype.saveUser=function(t){this.storage.saveUser(t)},t.prototype.updateContext=function(t){var e=this.context.user,r=t(e),n=this.context.with(r);return this.context=n,HA(e,r)||(this.changeUser(e,r,this.clock.currentMillis()),this.saveUser(r)),n},t.prototype.updateUser=function(t){var e=this;return this.updateContext((function(r){return n=r,i=nb(t,e.hackleDeviceId),HA(n,i)?c(c({},i),{properties:c(c({},n.properties),i.properties)}):i;var n,i}))},t.prototype.operateProperties=function(t){return this.updateContext((function(e){var n,i=null!==(n=e.properties)&&void 0!==n?n:{},o=t.operate(new Map(Object.entries(i)));return c(c({},e),{properties:r.fromMap(o)})}))},t.prototype.sync=function(){return p(this,void 0,void 0,(function(){var t,e;return f(this,(function(r){switch(r.label){case 0:return r.trys.push([0,2,,3]),[4,this.cohortFetcher.fetch(this.currentUser)];case 1:return t=r.sent(),this.context=this.context.update(t),[3,3];case 2:return e=r.sent(),o.log.error("Failed to sync cohorts: ".concat(e)),[3,3];case 3:return[2]}}))}))},t.prototype.close=function(){return p(this,void 0,void 0,(function(){return f(this,(function(t){return[2]}))}))},t}(),eb=function(){function t(t){this.storage=t}return t.prototype.getUser=function(){var t=this.deviceId||void 0,e=this.userId||void 0;return void 0!==t||void 0!==e?{deviceId:t,userId:e}:null},t.prototype.saveUser=function(t){this.setDeviceId(t.deviceId||null),this.setUserId(t.userId||null)},Object.defineProperty(t.prototype,"deviceId",{get:function(){return this.storage.getItem("_hackle_did")},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"userId",{get:function(){return this.storage.getItem("_hackle_uid")},enumerable:!1,configurable:!0}),t.prototype.setDeviceId=function(t){this.setId("_hackle_did",t)},t.prototype.setUserId=function(t){this.setId("_hackle_uid",t)},t.prototype.setId=function(t,e){r.isNotNullOrUndefined(e)?this.storage.setItem(t,e):this.storage.removeItem(t)},t}(),rb=function(){function t(t,e){this.user=t,this.cohorts=e}return t.of=function(e,r){return new t(e,r.filterBy(e))},t.prototype.with=function(e){return t.of(e,this.cohorts.filterBy(e))},t.prototype.update=function(e){var r=e.filterBy(this.user),n=this.cohorts.toBuilder().putAll(r).build();return t.of(this.user,n)},t}(),nb=function(t,e){return c(c({},t),{id:t.id||e,deviceId:t.deviceId||e})},ib=function(){function e(t,e){this.sessionTimeoutMillis=t,this.storage=e,this.sessionListeners=[],this._currentSessionId=null,this._lastEventTime=null,this.loadSession(),this.loadLastEventTime()}return Object.defineProperty(e.prototype,"currentSessionId",{get:function(){return this._currentSessionId},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"sessionId",{get:function(){var t;return null!==(t=this._currentSessionId)&&void 0!==t?t:e.EMPTY_SESSION_ID},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"lastEventTime",{get:function(){return this._lastEventTime},enumerable:!1,configurable:!0}),e.prototype.addListener=function(t){this.sessionListeners.push(t)},e.prototype.startNewSession=function(t,e,r){return t&&this.endSession(t),this.newSession(e,r)},e.prototype.startNewSessionIfNeeded=function(t,e){var r=this._lastEventTime;return null===r?this.startNewSession(t,t,e):null!==this._currentSessionId&&e-r<this.sessionTimeoutMillis?(this.updateLastEventTime(e),this._currentSessionId):this.startNewSession(t,t,e)},e.prototype.updateLastEventTime=function(t){this._lastEventTime=t,this.storage.setItem("_hackle_last_event_ts","".concat(t))},e.prototype.endSession=function(t){var e=this._currentSessionId,r=this._lastEventTime;null!==e&&null!==r&&this.sessionListeners.forEach((function(n){return n.onSessionEnded(e,t,r)}))},e.prototype.newSession=function(e,r){var n=function(e){return"".concat(e,".").concat(t.v4().slice(0,8))}(r);return this.saveSession(n),this.updateLastEventTime(r),this.sessionListeners.forEach((function(t){t.onSessionStarted(n,e,r)})),n},e.prototype.saveSession=function(t){this._currentSessionId=t,this.storage.setItem("_hackle_session_id",t)},e.prototype.loadSession=function(){this._currentSessionId=this.storage.getItem("_hackle_session_id")},e.prototype.loadLastEventTime=function(){var t=this.storage.getItem("_hackle_last_event_ts");if(null!==t){var e=Number.parseFloat(t);e>0&&(this._lastEventTime=e)}},e.prototype.onUserUpdated=function(t,e,r){this.endSession(t),this.newSession(e,r)},e.EMPTY_SESSION_ID="0.ffffffff",e}(),ob=function(){function t(){this.storage=window.localStorage}return t.prototype.getItem=function(t){var e,r;return null!==(r=null===(e=this.storage)||void 0===e?void 0:e.getItem(t))&&void 0!==r?r:null},t.prototype.removeItem=function(t){var e;null===(e=this.storage)||void 0===e||e.removeItem(t)},t.prototype.setItem=function(t,e){var r;null===(r=this.storage)||void 0===r||r.setItem(t,e)},t.prototype.clear=function(){var t;null===(t=this.storage)||void 0===t||t.clear()},t}(),sb=function(){function t(t,e){this.delegate=t,this.transform=e}return t.postfix=function(e,r){return new t(e,(function(t){return"".concat(t).concat(r)}))},t.prefix=function(e,r){return new t(e,(function(t){return"".concat(r).concat(t)}))},t.prototype.getItem=function(t){return this.delegate.getItem(this.transform(t))},t.prototype.removeItem=function(t){this.delegate.removeItem(this.transform(t))},t.prototype.setItem=function(t,e){this.delegate.setItem(this.transform(t),e)},t}(),ub=function(){function t(t,e,r){void 0===r&&(r=4096);var n=this;this.delegate=t,this.listKey=e,this.encodedListCharLen=6,this.resolveMaxLength=function(t){var e=t-n.encodedListCharLen;return e<0?0:e},this.maxLength=this.resolveMaxLength(r)}return t.prototype.isEqualItem=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},t.prototype.getRemainListSize=function(){try{return this.maxLength-JSON.stringify(this.getList()).length}catch(t){return 0}},t.prototype.isAddableItem=function(t){try{return this.getRemainListSize()>JSON.stringify(t).length}catch(t){return!1}},t.prototype.getVictimIndex=function(t){var e=this.getRemainListSize();try{var r=JSON.stringify(t),n=this.getList(),i=0;return n.findIndex((function(t){return(i+=JSON.stringify(t).length)+e>=r.length}))}catch(t){return-1}},t.prototype.getList=function(){try{var t=this.delegate.getItem(this.listKey);if(!t)return[];var e=JSON.parse(t);return Array.isArray(e)?e:[]}catch(t){return[]}},t.prototype.entries=function(){return this.getList().flatMap(Object.entries)},t.prototype.setItem=function(t,e){var r;try{this.removeItem(t);var n=this.getList(),i=((r={})[t]=e,r);if(!this.isAddableItem(i)){var o=this.getVictimIndex(i);if(o<0)return;n=n.slice(o+1)}var s=JSON.stringify(n.concat(i));this.delegate.setItem(this.listKey,s)}catch(t){}},t.prototype.getItem=function(t){var e=this,r=this.getList().find((function(r){return e.isEqualItem(r,t)}));if(r&&r[t])return r[t]},t.prototype.removeItem=function(t){var e=this,r=this.getList();try{var n=r.filter((function(r){return!e.isEqualItem(r,t)})),i=JSON.stringify(n);this.delegate.setItem(this.listKey,i)}catch(t){}},t.prototype.clear=function(){this.delegate.removeItem(this.listKey)},t}(),ab=function(){function t(t,e,r,n){this.core=t,this.userManager=e,this.abOverrideStorage=r,this.ffOverrideStorage=n}return t.prototype.currentUser=function(){return this.userManager.resolve()},t.prototype.getAbTestDecisions=function(){return this.core.experiments(this.currentUser()).entries()},t.prototype.getAbTestOverrides=function(){return this.abOverrideStorage.getAll()},t.prototype.setAbTestOverride=function(t,e){this.abOverrideStorage.set(t,e),this.increment("AB_TEST","set")},t.prototype.resetAbTestOverride=function(t){this.abOverrideStorage.remove(t),this.increment("AB_TEST","reset")},t.prototype.resetAllAbTestOverride=function(){this.abOverrideStorage.clear(),this.increment("AB_TEST","reset.all")},t.prototype.getFeatureFlagDecisions=function(){return this.core.featureFlags(this.currentUser()).entries()},t.prototype.getFeatureFlagOverrides=function(){return this.ffOverrideStorage.getAll()},t.prototype.setFeatureFlagOverride=function(t,e){this.ffOverrideStorage.set(t,e),this.increment("FEATURE_FLAG","set")},t.prototype.resetFeatureFlagOverride=function(t){this.ffOverrideStorage.remove(t),this.increment("FEATURE_FLAG","reset")},t.prototype.resetAllFeatureFlagOverride=function(){this.ffOverrideStorage.clear(),this.increment("FEATURE_FLAG","reset.all")},t.prototype.increment=function(t,e){ue.counter("experiment.manual.override",{"experiment.type":t,operation:e}).increment()},t}(),cb=function(){function t(){}return t.serverFetch=function(t,e){return"".concat(t,"/api/v2/workspaces/").concat(e,"/config")},t.clientFetch=function(t,e){return"".concat(t,"/api/v2/workspaces/").concat(e,"/config")},t.userCohorts=function(t){return"".concat(t,"/api/v1/cohorts")},t.serverDispatch=function(t){return"".concat(t,"/api/v2/events")},t.clientDispatch=function(t){return"".concat(t,"/api/v2/w/events")},t.beaconDispatch=function(t,e){return"".concat(t,"/api/v2/w/").concat(e,"/events")},t.inAppMessageRenderer=function(t,e){return"".concat(t,"/sdk/iam-renderer/").concat(e,"/iam-renderer.js")},t.monitoring=function(t){return"".concat(t,"/metrics")},t}(),pb=function(){function t(t){this.storage=t}return t.prototype.exist=function(t,e){var n=this.key(t),i=this.storage.getItem(n);if(r.isNullOrUndefined(i))return!1;var o=Number.parseInt(i,10);return Number.isNaN(o)?(this.storage.removeItem(n),!1):e<=o||(this.storage.removeItem(n),!1)},t.prototype.put=function(t,e){this.storage.setItem(this.key(t),"".concat(e))},t.prototype.key=function(t){return"".concat(t.key)},t}(),fb=function(){function t(t){this.handlers=t}return t.prototype.get=function(t){return this.handlers.find((function(e){return e.supports(t)}))},t}(),lb=function(){function t(){}return t.prototype.handle=function(t,e){t.close()},t.prototype.supports=function(t){return"CLOSE"===t.type},t}(),hb=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"WEB_LINK"===t.type},t}(),db=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){t.close();try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"LINK_AND_CLOSE"===t.type},t}(),vb=function(){function t(t,e){this.storage=t,this.clock=e}return t.prototype.handle=function(e,r){var n=this.clock.currentMillis()+t.HIDE_EXPIRATION;this.storage.put(e.context.inAppMessage,n),e.close()},t.prototype.supports=function(t){return"HIDDEN"===t.type},t.HIDE_EXPIRATION=864e5,t}(),yb=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"LINK_NEW_WINDOW"===t.type},t}(),mb=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){t.close();try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"LINK_NEW_WINDOW_AND_CLOSE"===t.type},t}(),gb=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"LINK_NEW_TAB"===t.type},t}(),Eb=function(){function t(t){this.urlHandler=t}return t.prototype.handle=function(t,e){t.close();try{if(!e.value)return;this.urlHandler.open(new URL(e.value))}catch(t){o.log.error("Invalid url: ".concat(e.value))}},t.prototype.supports=function(t){return"LINK_NEW_TAB_AND_CLOSE"===t.type},t}(),wb=function(){function t(t){this.core=t}return t.prototype.track=function(t,e,r){var n=this.createTrackEvent(e,t);this.core.track(n,t.user,r)},t.prototype.createTrackEvent=function(t,e){var r,n,i,o;switch(t.type){case"IMPRESSION":return{key:"$in_app_impression",properties:c({in_app_message_id:e.inAppMessage.id,in_app_message_key:e.inAppMessage.key,title_text:null===(n=null===(r=e.message.text)||void 0===r?void 0:r.title)||void 0===n?void 0:n.text,body_text:null===(o=null===(i=e.message.text)||void 0===i?void 0:i.body)||void 0===o?void 0:o.text,button_text:e.message.buttons.map((function(t){return t.text})),image_url:e.message.images.map((function(t){return t.imagePath}))},e.properties)};case"CLOSE":return{key:"$in_app_close",properties:{in_app_message_id:e.inAppMessage.id,in_app_message_key:e.inAppMessage.key}};case"ACTION":var s=t;return{key:"$in_app_action",properties:{in_app_message_id:e.inAppMessage.id,in_app_message_key:e.inAppMessage.key,action_type:s.action.type,action_area:s.area,action_value:s.action.value,button_text:s.text}}}},t}(),Tb=function(){function t(t,e,r){this.messageViewFactory=t,this.eventHandler=e,this.interactionHandlerFactory=r,this.currentMessageView=null,this.opening=!1}return t.prototype.present=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:if(this.currentMessageView)return[2];if(this.opening)return[2];this.opening=!0,e=null,r.label=1;case 1:return r.trys.push([1,3,4,5]),e=this.messageViewFactory.create(t,this),this.currentMessageView=e,[4,e.open()];case 2:return r.sent(),[3,5];case 3:return r.sent(),null==e||e.close(),[3,5];case 4:return this.opening=!1,[7];case 5:return[2]}}))}))},t}(),_b=function(){function t(t,e,r){var n=this;this.userEventEmitter=t,this.determiner=e,this.presenter=r,this.onEvent=function(t){var e=n.determiner.determineOrNull(t);e&&n.presenter.present(e)},this.initialize()}return t.prototype.initialize=function(){this.userEventEmitter.on("event",this.onEvent)},t.prototype.destroy=function(){this.userEventEmitter.off("event",this.onEvent)},t}(),Ib=function(t,e,r,n){this.inAppMessage=t,this.message=e,this.user=r,this.properties=n},Ab=function(){function t(t,e,r){this.workspaceFetcher=t,this.eventMatcher=e,this.core=r}return t.prototype.determineOrNull=function(t){var e=this.workspaceFetcher.get();if(e)for(var r=0,n=e.getInAppMessages();r<n.length;r++){var i=n[r];if(this.eventMatcher.matches(e,i,t)){var o=this.context(i,t);if(!o)continue;return o}}},t.prototype.context=function(t,e){var r=this.core.tryInAppMessage(t.key,e.user);if(r.inAppMessage&&r.message)return new Ib(r.inAppMessage,r.message,e.user,y.sanitize({decision_reason:r.reason}))},t}(),bb=function(){function t(e,r,n){var i=this;this.scriptLoader=e,this.context=r,this.ui=n,this.container=null,this.renderer=null,this.handleInAppMessageInteraction=function(e){if(e instanceof CustomEvent&&e.type===t.HACKLE_IAM_INTERACTION_EVENT_TYPE){var r=e.detail;i.handleInteraction(r)}}}return t.prototype.open=function(){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){switch(n.label){case 0:return n.trys.push([0,3,,4]),window.addEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE,this.handleInAppMessageInteraction),[4,this.scriptLoader.load()];case 1:return n.sent(),(e=this.addContainer()).style.display="none",e.classList.add("".concat(t.CONTAINER_CLASS_NAME,"--loading")),r=window.HackleInAppMessageRenderer,this.renderer=new r.HackleInAppMessageRenderer(e),[4,this.renderer.render({messageId:this.context.inAppMessage.id,message:this.context.message.toJson()})];case 2:return n.sent(),e.classList.remove("".concat(t.CONTAINER_CLASS_NAME,"--loading")),e.style.display="block",this.handleEvent({type:"IMPRESSION"}),[3,4];case 3:return n.sent(),this.close(),[3,4];case 4:return[2]}}))}))},t.prototype.close=function(){var e;this.handleEvent({type:"CLOSE"}),window.removeEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE,this.handleInAppMessageInteraction),null===(e=this.renderer)||void 0===e||e.destroy(),this.renderer=null,this.removeContainer(),this.ui.currentMessageView=null},t.prototype.addContainer=function(){if(!this.container){var e=document.createElement("div");e.classList.add(t.CONTAINER_CLASS_NAME),this.container=e}return this.container.parentNode||document.body.appendChild(this.container),this.container},t.prototype.removeContainer=function(){var t;this.container&&(null===(t=this.container.parentNode)||void 0===t||t.removeChild(this.container),this.container=null)},t.prototype.handleInteraction=function(t){var e=this.ui.interactionHandlerFactory.get(t);e&&e.handle(this,t)},t.prototype.handleEvent=function(t){this.ui.eventHandler.handle(this,t)},t.HACKLE_IAM_INTERACTION_EVENT_TYPE="hackle-iam-interaction",t.CONTAINER_CLASS_NAME="hackle-iam",t}(),Nb=function(){function t(t){this.scriptLoader=t}return t.prototype.create=function(t,e){return new bb(this.scriptLoader,t,e)},t}(),Ob=function(){function t(t){this.scriptUrl=t}return t.prototype.load=function(){return p(this,void 0,void 0,(function(){var t;return f(this,(function(e){switch(e.label){case 0:return window.HackleInAppMessageRenderer?[2]:(t=this.createScript(),document.head.appendChild(t),[4,this.waitForLoad(t)]);case 1:return[2,e.sent()]}}))}))},t.prototype.createScript=function(){var t=document.createElement("script");return t.type="text/javascript",t.async=!0,t.src=this.scriptUrl,t},t.prototype.waitForLoad=function(t){return new Promise((function(e,r){var n=function(){o(),e(t)},i=function(t){o(),r(t.message)},o=function(){t.removeEventListener("error",i),t.removeEventListener("load",n)};t.addEventListener("load",n),t.addEventListener("error",i)}))},t}(),Rb=function(){function t(t){this.targetMatcher=t}return t.prototype.isTriggerTarget=function(t,e,r){var n=this;return e.eventTrigger.rules.some((function(i){return n.ruleMatches(t,r,e,i)}))},t.prototype.ruleMatches=function(t,e,r,n){if(e.event.key!==n.eventKey)return!1;var i=xb.of(t,e,r);return this.targetMatcher.anyMatches(i,lI.create(),n.targets)},t}(),xb=function(){function t(t,e,r,n){this.key=t,this.workspace=e,this.user=r,this.event=n}return t.of=function(e,r,n){return new t(new fI("IN_APP_MESSAGE",n.key),e,r.user,r)},t}(),Mb=function(){function t(t){this.storage=t}return t.prototype.isTriggerTarget=function(t,e,r){if(!e.eventTrigger.frequencyCap)return!0;var n=this.createMatchContexts(e.eventTrigger.frequencyCap);if(0===n.length)return!0;for(var i=0,o=this.storage.get(e);i<o.length;i++)for(var s=o[i],u=0,a=n;u<a.length;u++){if(a[u].matches(r,s))return!1}return!0},t.prototype.createMatchContexts=function(t){for(var e=[],r=0,n=t.identifierCaps;r<n.length;r++){var i=n[r];e.push(new Sb(new Cb(i)))}return t.durationCap&&e.push(new Sb(new Ub(t.durationCap))),e},t}(),Sb=function(){function t(t){this.matchCount=0,this.predicate=t}return t.prototype.matches=function(t,e){return this.predicate.matches(t,e)&&(this.matchCount+=1),this.matchCount>=this.predicate.thresholdCount},t}(),Cb=function(){function t(t){this.identifierCap=t}return Object.defineProperty(t.prototype,"thresholdCount",{get:function(){return this.identifierCap.count},enumerable:!1,configurable:!0}),t.prototype.matches=function(t,e){var n=t.user.identifiers[this.identifierCap.identifierType];if(r.isNullOrUndefined(n))return!1;var i=e.identifiers[this.identifierCap.identifierType];return!r.isNullOrUndefined(i)&&n===i},t}(),Ub=function(){function t(t){this.durationCap=t}return Object.defineProperty(t.prototype,"thresholdCount",{get:function(){return this.durationCap.count},enumerable:!1,configurable:!0}),t.prototype.matches=function(t,e){return t.timestamp-e.timestamp<=this.durationCap.durationMillis},t}(),Pb=function(){function t(t){this.storage=t}return t.prototype.get=function(t){var e=this.storage.getItem(t.id.toString());return r.isNullOrUndefined(e)?[]:JSON.parse(e)},t.prototype.set=function(t,e){this.storage.setItem(t.id.toString(),JSON.stringify(e))},t}(),kb=function(){function t(t){this.processors=t}return t.prototype.get=function(t){return this.processors.find((function(e){return e.supports(t)}))},t}(),Db=function(){function t(t){this.impressionStorage=t}return t.prototype.process=function(t,e,r){this.saveImpression(t.context.inAppMessage,t.context.user,r)},t.prototype.saveImpression=function(e,r,n){var i=this.impressionStorage.get(e),o={identifiers:r.identifiers,timestamp:n};i.push(o),i.length>t.IMPRESSION_MAX_SIZE&&i.splice(0,i.length-t.IMPRESSION_MAX_SIZE),this.impressionStorage.set(e,i)},t.prototype.supports=function(t){return"IMPRESSION"===t.type},t.IMPRESSION_MAX_SIZE=100,t}(),Lb=function(){function t(){}return t.prototype.process=function(t,e,r){},t.prototype.supports=function(t){return"CLOSE"===t.type},t}(),Fb=function(){function t(t){this.actionHandlerFactory=t}return t.prototype.process=function(t,e,r){var n=this.actionHandlerFactory.get(e.action);n&&n.handle(t,e.action)},t.prototype.supports=function(t){return"ACTION"===t.type},t}(),Vb=function(){function t(t,e,r){this.clock=t,this.eventTracker=e,this.eventProcessorFactory=r}return t.prototype.handle=function(t,e){var r=this.clock.currentMillis();this.eventTracker.track(t.context,e,r);var n=this.eventProcessorFactory.get(e);n&&n.process(t,e,r)},t}(),jb=function(){function t(t,e){this.ruleDeterminer=t,this.frequencyCapDeterminer=e}return t.prototype.matches=function(t,e,r){return!!Z_.isTrackEvent(r)&&(!!this.ruleDeterminer.isTriggerTarget(t,e,r)&&this.frequencyCapDeterminer.isTriggerTarget(t,e,r))},t}(),Gb=function(){function t(t){this.handlers=t}return t.prototype.get=function(t){return this.handlers.find((function(e){return e.supports(t)}))},t}(),Hb=function(){function t(){}return t.prototype.handle=function(t,e){t.close()},t.prototype.supports=function(t){return"CLOSE"===t.type},t}(),Bb=function(){function t(t){this.eventHandler=t}return t.prototype.handle=function(t,e){var r=Ft.fromJson(e.action);if(r){var n={type:"ACTION",action:r,area:e.area,text:e.text};this.eventHandler.handle(t,n)}},t.prototype.supports=function(t){return"ACTION"===t.type},t}(),Kb=function(){function t(){}return t.prototype.open=function(t){window.location.href=t.href},t}(),zb=function(){function t(){}return t.prototype.open=function(t){window.open(t.href,"Hackle","resizable:true")},t}(),Jb=function(){function t(){}return t.prototype.open=function(t){window.open(t.href)},t}(),Yb=function(){function t(){}return t.prototype.open=function(t){window.location.replace(t)},t}(),qb={utm_campaign:void 0,utm_content:void 0,utm_id:void 0,utm_medium:void 0,utm_source:void 0,utm_term:void 0,gclid:void 0,fbclid:void 0},Xb={current:void 0,referrer:void 0},Wb=function(t,e){return Object.keys(qb).every((function(r){return t[r]===e[r]}))},$b=function(t,e,r){return null===t||(!Wb(e,qb)||r.current!==r.referrer)&&!Wb(t,e)},Zb=function(){function t(t,e,r,n){this.storage=t,this.parser=e,this.core=r,this.userManager=n}return t.prototype.startNewCampaign=function(t,e,r){for(var n=c(c({},qb),e),i=new Ue,o=0,s=Object.entries(n);o<s.length;o++){var u=s[o],a=u[0],p=u[1];p?i.set(a,p):i.unset(a)}var f=i.build(),l=f.toEvent(),h=this.userManager.toHackleUser(t);this.core.track(l,h,r),this.userManager.updateUserProperties(f)},t.prototype.startNewCampaignIfNeeded=function(t,e){var r=this.storage.get(),n=this.parser.parse(),i=this.parser.parseDomain();$b(r,n,i)&&(this.storage.set(n),this.startNewCampaign(t,n,e))},t.prototype.onSessionEnded=function(t,e,r){},t.prototype.onSessionStarted=function(t,e,r){this.startNewCampaignIfNeeded(e,r)},t}(),Qb=function(){function t(t){this.storage=t}return t.prototype.get=function(){var t=this.storage.getItem("_hackle_mkt");return t?JSON.parse(t):null},t.prototype.set=function(t){this.storage.setItem("_hackle_mkt",JSON.stringify(t))},t}(),tN=function(){function t(t){this.search=t}return t.prototype.getQueryParam=function(t){return this.getQueryParams((function(){return!0}))[t]||""},t.prototype.getQueryParams=function(t){for(var e={},r=0,n=this.search.substring(1).split("&");r<n.length;r++){var i=n[r].split("="),o=i[0],s=i[1];t&&!t(o,s)||(e[o]=decodeURIComponent(s))}return e},t.getQueryParams=function(){return"undefined"==typeof window?{}:new t(window.location.search).getQueryParams()},t}(),eN=function(){function t(){}return t.extractDomain=function(t){var e=this.DOMAIN_MATCH_REGEX,r=t.split("."),n=r[r.length-1];(n.length>4||"com"===n||"org"===n)&&(e=this.SIMPLE_DOMAIN_MATCH_REGEX);var i=t.match(e);return i?i[0]:t},t.DOMAIN_MATCH_REGEX=/[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i,t.SIMPLE_DOMAIN_MATCH_REGEX=/[a-z0-9][a-z0-9-]*\.[a-z]+$/i,t}(),rN=function(){function t(){}return t.prototype.parse=function(){var t=tN.getQueryParams();return{utm_campaign:t[nN],utm_content:t[iN],utm_id:t[oN],utm_medium:t[sN],utm_source:t[uN],utm_term:t[aN],gclid:t[cN],fbclid:t[pN]}},t.prototype.parseDomain=function(){if("undefined"==typeof window)return Xb;return{current:eN.extractDomain(window.document.location.hostname),referrer:function(){var t=window.document.referrer;if(t){var e=new URL(t).hostname;return eN.extractDomain(e)}}()}},t}(),nN="utm_campaign",iN="utm_content",oN="utm_id",sN="utm_medium",uN="utm_source",aN="utm_term",cN="gclid",pN="fbclid",fN=function(){function t(t,e){var r=this;this.userEventEmitter=t,this.determiner=e,this.onEvent=function(t){var e=r.determiner.determineTargetExposureOrNull(t);e&&r.send(e)},this.initialize()}return t.prototype.initialize=function(){this.userEventEmitter.on("event",this.onEvent)},t.prototype.send=function(t){var e=t.experiment.key,r=t.variationKey,n="HACKLE-EXPERIMENT_".concat(e,"_V").concat(t.experiment.version,"-").concat(r);try{window.gtag("event","experience_impression",{exp_variant_string:n})}catch(t){o.log.error("Unexpected exception while sending an event to Google Analytics with gtag: ".concat(t))}},t}(),lN=function(){function t(t){this.workspaceFetcher=t}return t.prototype.determineTargetExposureOrNull=function(t){var e=this.workspaceFetcher.get();return e&&e.getAttributes().integration_ga_experiment&&Z_.isExposureEvent(t)?"RUNNING"!==t.experiment.status||t.decisionReason!==S.TRAFFIC_ALLOCATED?null:t:null},t}(),hN={user:void 0,debug:!1,log_disabled:!1,auto_track_page_view:!0,pollingIntervalMillis:-1,exposureEventDedupIntervalMillis:6e4,sessionTimeoutMillis:18e5,autoOpenDevTool:!1,sdkUrl:"https://client-sdk.hackle.io",eventUrl:"https://event.hackle.io",monitoringUrl:"https://monitoring.hackle.io",cdnUrl:"https://static.hackle.io",sameSiteCookie:"LAX",secureCookie:!1,SDK_NAME_HEADER:"javascript-sdk_browser",SDK_VERSION_HEADER:"11.25.2",IAM_RENDERER_VERSION_HEADER:"0.0.3"},dN=function(){function t(){}return t.config=function(t){return c(c({},hN),t)},t.logging=function(t){o.initCounter((function(t){return ue.counter("log",{level:t})})),o.setLogLevel(i.INFO),t.log_disabled?o.setLogLevel(i.DISABLE):t.debug&&o.setLogLevel(i.DEBUG)},t.sdk=function(t,e){return o.log.debug("SDK key: ".concat(t)),t||o.log.error("invalid sdk key: '".concat(t,"' (expected: not null, not undefined and not empty string)")),{key:t,name:e.SDK_NAME_HEADER,version:e.SDK_VERSION_HEADER}},t.isBeaconSupported=function(){var t=!1;return"undefined"!=typeof window&&(t=window&&window.navigator&&!!window.navigator.sendBeacon&&!0)&&o.log.debug("support sendBeacon API"),t},t.pollingIntervalMillis=function(t){return void 0===t.pollingIntervalMillis||"number"!=typeof t.pollingIntervalMillis||t.pollingIntervalMillis<=0?-1:Math.max(t.pollingIntervalMillis,3e4)},t.dedupIntervalMillis=function(t){return void 0===t.exposureEventDedupIntervalMillis||"number"!=typeof t.exposureEventDedupIntervalMillis?6e4:t.exposureEventDedupIntervalMillis<1e3||t.exposureEventDedupIntervalMillis>36e5?(o.log.warn("Exposure event dedup interval is outside allowed range[1_000ms..3_600_000ms]. Setting to default value[1m]."),6e4):t.exposureEventDedupIntervalMillis},t}(),vN=function(){function t(){this.synchronizations=[]}return t.prototype.add=function(t,e){this.synchronizations.push({type:t,synchronizer:e})},t.prototype.sync=function(){return p(this,void 0,void 0,(function(){var t=this;return f(this,(function(e){switch(e.label){case 0:return[4,Promise.all(this.synchronizations.map((function(e){return t.safe(e.synchronizer.sync())})))];case 1:return e.sent(),[2]}}))}))},t.prototype.syncOnly=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:if(!(e=this.synchronizations.find((function(e){return e.type===t}))))throw new Error("Unsupported SynchronizerType [".concat(t,"]"));return[4,e.synchronizer.sync()];case 1:return r.sent(),[2]}}))}))},t.prototype.close=function(){return p(this,void 0,void 0,(function(){var t=this;return f(this,(function(e){switch(e.label){case 0:return[4,Promise.all(this.synchronizations.map((function(e){return t.safe(e.synchronizer.close())})))];case 1:return e.sent(),[2]}}))}))},t.prototype.safe=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:return r.trys.push([0,2,,3]),[4,t];case 1:return r.sent(),[3,3];case 2:return e=r.sent(),o.log.error("Failed to sync: ".concat(e)),[3,3];case 3:return[2]}}))}))},t}(),yN=function(){function t(t,e,r){this.delegate=t,this.scheduler=e,this.intervalMillis=r,this.pollingJob=null}return t.prototype.sync=function(){return p(this,void 0,void 0,(function(){var t;return f(this,(function(e){switch(e.label){case 0:return e.trys.push([0,2,,3]),[4,this.delegate.sync()];case 1:return e.sent(),[3,3];case 2:return t=e.sent(),o.log.error("Failed to sync: ".concat(t)),[3,3];case 3:return[2]}}))}))},t.prototype.syncOnly=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:return r.trys.push([0,2,,3]),[4,this.delegate.syncOnly(t)];case 1:return r.sent(),[3,3];case 2:return e=r.sent(),o.log.error("Failed to sync: ".concat(e)),[3,3];case 3:return[2]}}))}))},t.prototype.start=function(){var t=this;-1!==this.intervalMillis&&null===this.pollingJob&&(this.pollingJob=this.scheduler.schedulePeriodically(this.intervalMillis,this.intervalMillis,(function(){return t.sync()})))},t.prototype.stop=function(){var t;-1!==this.intervalMillis&&(null===(t=this.pollingJob)||void 0===t||t.cancel(),this.pollingJob=null)},t.prototype.close=function(){return p(this,void 0,void 0,(function(){return f(this,(function(t){switch(t.label){case 0:return this.stop(),[4,this.delegate.close()];case 1:return t.sent(),[2]}}))}))},t}(),mN=function(){function t(){}return t.prototype.schedule=function(t,e){var r=new gN(t,e);return r.start(),r},t.prototype.schedulePeriodically=function(t,e,r){var n=new EN(t,e,r);return n.start(),n},t}(),gN=function(){function t(t,e){this.delayMillis=t,this.task=e,this.timeout=null}return t.prototype.start=function(){var t=this;this.timeout=setTimeout((function(){return t.task()}),this.delayMillis)},t.prototype.cancel=function(){this.timeout&&(clearTimeout(this.timeout),this.timeout=null)},t}(),EN=function(){function t(t,e,r){this.delayMillis=t,this.intervalMillis=e,this.task=r,this.timeout=null}return t.prototype.start=function(){var t=this;this.timeout=setTimeout((function(){return t.run()}),this.delayMillis)},t.prototype.run=function(){var t=this;this.task(),this.timeout=setTimeout((function(){return t.run()}),this.intervalMillis)},t.prototype.cancel=function(){this.timeout&&(clearTimeout(this.timeout),this.timeout=null)},t}(),wN=function(){function t(t,e,r,i,o,s,u,a,c,p,f){this.experiments=n.associateBy(t,(function(t){return t.key})),this.splitUrlExperiments=n.associateBy(e,(function(t){return t.key})),this.featureFlags=n.associateBy(r,(function(t){return t.key})),this.buckets=n.associateBy(i,(function(t){return t.id})),this.eventTypes=n.associateBy(o,(function(t){return t.key})),this.segments=n.associateBy(s,(function(t){return t.key})),this.containers=n.associateBy(u,(function(t){return t.id})),this.parameterConfigurations=n.associateBy(a,(function(t){return t.id})),this.remoteConfigParameters=n.associateBy(c,(function(t){return t.key})),this.inAppMessages=n.associateBy(p,(function(t){return t.key})),this.attributes=f}return t.prototype.getExperiments=function(){return Array.from(this.experiments.values())},t.prototype.getSplitUrlExperiments=function(){return Array.from(this.splitUrlExperiments.values())},t.prototype.getFeatureFlags=function(){return Array.from(this.featureFlags.values())},t.prototype.getInAppMessages=function(){return Array.from(this.inAppMessages.values())},t.prototype.getExperimentOrNull=function(t){return this.experiments.get(t)},t.prototype.getFeatureFlagOrNull=function(t){return this.featureFlags.get(t)},t.prototype.getBucketOrNull=function(t){return this.buckets.get(t)},t.prototype.getEventTypeOrNull=function(t){return this.eventTypes.get(t)},t.prototype.getSegmentOrNull=function(t){return this.segments.get(t)},t.prototype.getContainerOrNull=function(t){return this.containers.get(t)},t.prototype.getParameterConfigurationOrNull=function(t){return this.parameterConfigurations.get(t)},t.prototype.getRemoteConfigParameterOrNull=function(t){return this.remoteConfigParameters.get(t)},t.prototype.getInAppMessageOrNull=function(t){return this.inAppMessages.get(t)},t.prototype.getAttributes=function(){return this.attributes},t.from=function(e){return new t(n.mapNotNullOrUndefined(e.experiments,(function(t){return C.fromJson("AB_TEST",t)})),n.mapNotNullOrUndefined(e.experiments,(function(t){return C.fromJson("AB_TEST",t)})).filter((function(t){return"SPLIT_URL"===t.implementationType})),n.mapNotNullOrUndefined(e.featureFlags,(function(t){return C.fromJson("FEATURE_FLAG",t)})),e.buckets.map(P.fromJson),e.events.map(D.fromJson),n.mapNotNullOrUndefined(e.segments,Y.fromJson),e.containers.map(q.fromJson),e.parameterConfigurations.map(M.fromJson),n.mapNotNullOrUndefined(e.remoteConfigParameters,W.fromJson),n.mapNotNullOrUndefined(e.inAppMessages,gt.fromJson),e.workspace.attributes)},t}(),TN=function(){function t(t,e){this.url=t,this.transport=e,this.lastModified=null}return t.prototype.fetchIfModified=function(){return p(this,void 0,void 0,(function(){var t,e;return f(this,(function(r){switch(r.label){case 0:return t=this.createRequest(),[4,this.execute(t)];case 1:return e=r.sent(),[2,this.handleResponse(e)]}}))}))},t.prototype.createRequest=function(){var t=ce.builder().url(this.url).method("GET");return null!==this.lastModified&&t.addHeader(le.IF_MODIFIED_SINCE,this.lastModified),t.build()},t.prototype.execute=function(t){return p(this,void 0,void 0,(function(){var e,r,n;return f(this,(function(i){switch(i.label){case 0:e=Bt.start(),i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.transport.send(t)];case 2:return r=i.sent(),ye.record("get.workspace",e,r),[2,r];case 3:throw n=i.sent(),ye.record("get.workspace",e,null),n;case 4:return[2]}}))}))},t.prototype.handleResponse=function(t){if(t.isNotModified())return null;if(!t.isSuccessful())throw new Error("Http status code: ".concat(t.statusCode));if(null===t.body)throw new Error("Response body is empty");this.lastModified=t.headers.get(le.LAST_MODIFIED);var e=JSON.parse(t.body);return wN.from(e)},t}(),_N=function(){function t(t,e){this.url=t,this.transport=e}return t.prototype.fetch=function(t){return p(this,void 0,void 0,(function(){var e,r;return f(this,(function(n){switch(n.label){case 0:return e=this.createRequest(t),[4,this.execute(e)];case 1:return r=n.sent(),[2,this.handleResponse(r)]}}))}))},t.prototype.createRequest=function(t){var r={identifiers:F(t)},n=e.Base64.encodeURL(JSON.stringify(r));return ce.builder().url(this.url).method("GET").addHeader("X-HACKLE-USER",n).build()},t.prototype.execute=function(t){return p(this,void 0,void 0,(function(){var e,r,n;return f(this,(function(i){switch(i.label){case 0:e=Bt.start(),i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.transport.send(t)];case 2:return r=i.sent(),ye.record("get.cohorts",e,r),[2,r];case 3:throw n=i.sent(),ye.record("get.cohorts",e,null),n;case 4:return[2]}}))}))},t.prototype.handleResponse=function(t){if(!t.isSuccessful())throw new Error("Http status code: ".concat(t.statusCode));if(null===t.body)throw new Error("Response body is null");var e=JSON.parse(t.body);return BA.fromDto(e)},t}(),IN=function(){function t(t){this.httpWorkspaceFetcher=t,this.workspace=null}return t.prototype.get=function(){return this.workspace},t.prototype.sync=function(){return p(this,void 0,void 0,(function(){var t,e;return f(this,(function(r){switch(r.label){case 0:return r.trys.push([0,2,,3]),[4,this.httpWorkspaceFetcher.fetchIfModified()];case 1:return(t=r.sent())&&(this.workspace=t),[3,3];case 2:return e=r.sent(),o.log.error("Failed to fetch workspace: ".concat(e)),[3,3];case 3:return[2]}}))}))},t.prototype.close=function(){return p(this,void 0,void 0,(function(){return f(this,(function(t){return[2]}))}))},t}(),AN=function(){function t(t,e,r){this.transport=t,this.shutdownTransport=e,this.retryManager=r}return t.prototype.dispatch=function(t,e){var r=t.map((function(t){return t.toDto()}));return e?this.shutdownDispatch(r):this.normalDispatch(r)},t.prototype.shutdownDispatch=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:return[4,this.retryManager.add(t)];case 1:return r.sent(),[4,this.shutdownTransport.send(t)];case 2:return(e=r.sent()).isSuccessful()||e.isClientError()?[4,this.retryManager.delete(t)]:[3,4];case 3:r.sent(),r.label=4;case 4:return[2]}}))}))},t.prototype.normalDispatch=function(t){return p(this,void 0,void 0,(function(){var e;return f(this,(function(r){switch(r.label){case 0:return[4,this.transport.send(t)];case 1:return(e=r.sent()).isSuccessful()||e.isClientError()?[2]:[4,this.retryManager.add(t)];case 2:return r.sent(),[2]}}))}))},t}();var bN=function(){function t(t,e){this.url=t,this.transport=e}return t.prototype.send=function(t){var e=this.createRequest(t);return this.execute(e)},t.prototype.createRequest=function(t){var e=function(t){var e=new Array,r=new Array,n=new Array;return t.forEach((function(t){t instanceof Z_?Z_.isExposureEvent(t)?e.push(t.toDto()):Z_.isTrackEvent(t)?r.push(t.toDto()):Z_.isRemoteConfigEvent(t)&&n.push(t.toDto()):Z_.isExposureEventDto(t)?e.push(t):Z_.isTrackEventDto(t)?r.push(t):Z_.isRemoteConfigEventDto(t)&&n.push(t)})),{exposureEvents:e,trackEvents:r,remoteConfigEvents:n}}(t);return ce.builder().url(this.url).method("POST").addHeader("Content-Type","application/json").body(JSON.stringify(e)).build()},t.prototype.execute=function(t){return p(this,void 0,void 0,(function(){var e,r,n;return f(this,(function(i){switch(i.label){case 0:e=Bt.start(),i.label=1;case 1:return i.trys.push([1,3,,4]),[4,this.transport.send(t)];case 2:return r=i.sent(),ye.record("post.events",e,r),[2,r];case 3:throw n=i.sent(),ye.record("post.events",e,null),n;case 4:return[2]}}))}))},t}(),NN=function(){function t(t,e){this.repository=t,this.transport=e}return t.prototype.add=function(t){return this.repository.add(t)},t.prototype.delete=function(t){return this.repository.delete(t)},t.prototype.flush=function(){return p(this,void 0,void 0,(function(){var t,e;return f(this,(function(r){switch(r.label){case 0:return[4,this.repository.read()];case 1:return 0===(t=r.sent()).length?[2]:[4,this.transport.send(t)];case 2:return(e=r.sent()).isSuccessful()||e.isClientError()?[4,this.delete(t)]:[3,4];case 3:r.sent(),r.label=4;case 4:return[2]}}))}))},t}(),ON=function(t){function e(e,r,n,i){var o=t.call(this)||this;return o.eventDispatcher=e,o.eventDispatchMaxSize=r,o.flushScheduler=n,o.flushIntervalMillis=i,o.queue=[],o.flushingJob=null,o}return a(e,t),e.prototype.process=function(t){this.enqueue(t),this.emit("event",t)},e.prototype.enqueue=function(t){0===this.queue.length&&this.scheduleFlush(),this.queue.push(t),this.queue.length>=this.eventDispatchMaxSize&&this.flush()},e.prototype.scheduleFlush=function(){var t,e=this;null===(t=this.flushingJob)||void 0===t||t.cancel(),this.flushingJob=this.flushScheduler.schedule(this.flushIntervalMillis,(function(){return e.flush()}))},e.prototype.flush=function(t){var e;void 0===t&&(t=!1),null===(e=this.flushingJob)||void 0===e||e.cancel(),0!==this.queue.length&&(this.eventDispatcher.dispatch(this.queue,t).catch((function(t){return o.log.warn("Failed to dispatch events: ".concat(t))})),this.queue=[])},e.prototype.close=function(){this.flush(!0)},e}(function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return a(e,t),e}(function(){function t(){this.listeners={}}return t.prototype.on=function(t,e){this.listeners[t]=(this.listeners[t]||[]).concat(e)},t.prototype.off=function(t,e){this.listeners[t]=(this.listeners[t]||[]).filter((function(t){return t!==e}))},t.prototype.emit=function(t,e){(this.listeners[t]||[]).forEach((function(t){t(e)}))},t}())),RN=function(){function t(t,e,r){this.sdk=t,this.clock=e,this.delegate=r}return t.prototype.send=function(t){var e=t.toBuilder().addHeader("X-HACKLE-SDK-KEY",this.sdk.key).addHeader("X-HACKLE-SDK-NAME",this.sdk.name).addHeader("X-HACKLE-SDK-VERSION",this.sdk.version).addHeader("X-HACKLE-SDK-TIME",this.clock.currentMillis().toString()).build();return this.delegate.send(e)},t}(),xN=function(){function t(){}return t.intercept=function(t,e){return e instanceof RN?e:new RN(t,E.instance,e)},t}(),MN=function(){function t(){}return t.create=function(){return new t},t.prototype.send=function(t){return new Promise((function(e,r){var n=new XMLHttpRequest;t.options.timeoutMillis&&(n.timeout=t.options.timeoutMillis),n.open(t.method,t.url),n.onreadystatechange=function(){if(n.readyState===n.DONE)if(0!==n.status){var t=function(t){return new fe(t.status,t.responseText,function(t){var e=le.builder(),r=t.getAllResponseHeaders();if(!r)return e.build();for(var n=0,i=r.split("\r\n");n<i.length;n++){var o=i[n],s=o.indexOf(": ");if(s>0){var u=o.slice(0,s),a=o.slice(s+2);e.add(u,a)}}return e.build()}(t))}(n);e(t)}else r(new Error("Request Error"))},function(t,e){var r=e.headers.raw();for(var n in r)r.hasOwnProperty(n)&&t.setRequestHeader(n,r[n])}(n,t),n.send(t.body)}))},t}();var SN,CN=function(){function t(){}return t.create=function(){return new t},t.prototype.send=function(t){var e=this;return new Promise((function(r,n){var i=!1;if("undefined"!=typeof window&&(i=window&&window.navigator&&!!window.navigator.sendBeacon&&!0),!i)throw new Error("BeaconTransport not supported.");var o=e.createBody(t);if(!window.navigator.sendBeacon(t.url,o))throw Error("Failed to sendBeacon");r(fe.ok())}))},t.prototype.createBody=function(t){var e=new URLSearchParams,r=t.headers.get("X-HACKLE-SDK-KEY");return r&&e.append("sdkKey",r),e.append("sdkName",t.headers.getOrDefault("X-HACKLE-SDK-NAME","unknown")),e.append("sdkVersion",t.headers.getOrDefault("X-HACKLE-SDK-VERSION","unknown")),t.body&&e.append("data",t.body),e},t}(),UN=function(){function t(t){this.invocationResponseResolver=t}return t.prototype.invoke=function(t){var e=window.prompt(JSON.stringify(t));return this.invocationResponseResolver.resolve(e)},t}(),PN=function(){function t(t){this.invocationResponseResolver=t}return t.prototype.invoke=function(t){var e;if(!(null===(e=window._hackleApp)||void 0===e?void 0:e.invoke))throw new Error("window._hackleApp.invoke is not implemented");var r=window._hackleApp.invoke(JSON.stringify(t));return this.invocationResponseResolver.resolve(r)},t}();!function(t){t.prompt="prompt",t.function="function"}(SN||(SN={}));var kN=function(){function t(){}return t.prototype.getInvocator=function(t,e){return t===SN.prompt?new UN(e):t===SN.function?new PN(e):null},t}(),DN=function(){function t(t,e,r){var n=this;this.userEventEmitter=t,this.determiner=e,this.redirector=r,this.onEvent=function(t){var e=n.determiner.determineOrNull(t);e&&n.redirector.redirect(e)},this.initialize()}return t.prototype.initialize=function(){this.userEventEmitter.on("event",this.onEvent)},t.prototype.destroy=function(){this.userEventEmitter.off("event",this.onEvent)},t}(),LN=function(t,e,r){this.workspace=t,this.experiment=e,this.decision=r},FN=function(){function t(t,e,r,n){this.workspaceFetcher=t,this.splitUrlMatcher=e,this.splitUrlRedirectedCookieStorage=r,this.core=n}return t.prototype.determineOrNull=function(t){if(!Z_.isTrackEvent(t))return null;if("$page_view"!==t.event.key)return null;if(this.splitUrlRedirectedCookieStorage.alreadyRedirected())return this.splitUrlRedirectedCookieStorage.clear(),null;var e=this.workspaceFetcher.get();if(!e)return null;for(var r=0,n=e.getSplitUrlExperiments();r<n.length;r++){var i=n[r];if(this.splitUrlMatcher.matches(e,i,t)){var o=this.core.experiment(i.key,t.user,"A");return new LN(e,i,o)}}return null},t}(),VN=function(){function t(t){this.targetMatcher=t}return t.prototype.matches=function(t,e,r){if("SPLIT_URL"!==e.implementationType)return!1;if(!e.splitUrlTargets)return!1;var n=e.splitUrlTargets,i=jN.of(t,r);return!(n.excludeTargets.length>0&&this.targetMatcher.anyMatches(i,lI.create(),n.excludeTargets))&&(n.includeTargets.length>0&&this.targetMatcher.anyMatches(i,lI.create(),n.includeTargets))},t}(),jN=function(){function t(t,e,r){this.key=t,this.user=e,this.workspace=r}return t.of=function(e,r){return new t(new fI("SPLIT_URL",r.insertId),r.user,e)},t}(),GN=function(){function t(t,e,r){this.urlResolver=t,this.urlHandler=e,this.splitUrlRedirectedCookieStorage=r}return t.prototype.redirect=function(t){var e=this.urlResolver.resolveOrNull(t);e&&(this.splitUrlRedirectedCookieStorage.setRedirected(!0),this.urlHandler.open(e))},t}(),HN=function(){function t(){}return t.prototype.resolveOrNull=function(e){try{var r=JSON.parse(e.decision.get(t.SPLIT_URL_CONFIG_KEY,"")),n=jt.fromDto(r);return n.needRedirect?this.resolveByRedirectType(n.redirectType,n.redirectUrl):null}catch(t){return null}},t.prototype.resolveByRedirectType=function(t,e){return e&&t===exports.kg.MANUAL?this.resolveManualRedirectUrl(e):null},t.prototype.resolveManualRedirectUrl=function(t){var e;return null!==(e=II.tryParse(t))&&void 0!==e?e:null},t.SPLIT_URL_CONFIG_KEY="redirectUrl",t}(),BN=function(){function t(t,e,r){this.storage=t,this.cookieKey=e,this.cookieStorageOptions=r}return t.prototype.alreadyRedirected=function(){try{var t=this.storage.getItem(this.cookieKey);return!r.isNullOrUndefined(t)&&Boolean(JSON.parse(t))}catch(t){return!1}},t.prototype.clear=function(){this.storage.removeItem(this.cookieKey)},t.prototype.setRedirected=function(t){this.storage.setItem(this.cookieKey,String(t),this.cookieStorageOptions)},t}(),KN=o.log,zN=null;function JN(t,e){var r,n,i,o,s,u,a=dN.config(e);dN.logging(a);try{if((u=window)&&"_hackleApp"in u&&null!==u._hackleApp&&"object"==typeof u._hackleApp&&"getAppSdkKey"in u._hackleApp&&"function"==typeof u._hackleApp.getAppSdkKey&&"getInvocationType"in u._hackleApp&&"function"==typeof u._hackleApp.getInvocationType&&t===window._hackleApp.getAppSdkKey()){var c=(i=window._hackleApp.getInvocationType(),o=new kN,null===(s=o.getInvocator(i,new je))?(qe.error("Failed to get invocator with invocationType:".concat(i)),null):new Xe(new Ye(s)));if(c)return c}}catch(t){KN.error("Unexpected exception while check WebApp client: ".concat(t))}var p=dN.sdk(t,a);if(zN)return KN.debug("use already exists hackleClient"),zN;He.initialize();var f=new ob,l=Ge.getInstance({days:3650,isCrossSubdomain:!0,sameSite:a.sameSiteCookie,isSecure:a.secureCookie}),h=dN.isBeaconSupported(),d=xN.intercept(p,MN.create()),v=xN.intercept(p,CN.create()),y=d;h&&(y=v);var m=new vN,g=new yN(m,new mN,dN.pollingIntervalMillis(a)),w=new TN(cb.clientFetch(a.sdkUrl,p.key),d),T=new IN(w);m.add("workspace",T);var _=new _N(cb.userCohorts(a.sdkUrl),d),I=new eb(sb.postfix(l,"_".concat(t))),A=I.getUser(),b=a.user||null,N=new tb(Be(),I,_,E.instance,A,b);m.add("cohort",N);var O=new ib(a.sessionTimeoutMillis,sb.postfix(l,"_".concat(t.slice(8))));N.addListener(O);var R=new GA(f,"".concat("hackle-repository-storage","_").concat(t),100),x=new bN(cb.clientDispatch(a.eventUrl),d),M=x;h&&(M=new bN(cb.beaconDispatch(a.eventUrl,p.key),v));var S=new NN(R,x),C=new AN(x,M,S),U=new iI(dN.dedupIntervalMillis(a)),P=new ON(C,100,new mN,500),k=new nI(P,U,O,N),D=new mI(new ub(l,"".concat("hackle-manual-override_ab","_").concat(t.slice(0,8)))),L=new mI(new ub(l,"".concat("hackle-manual-override_ff","_").concat(t.slice(0,8)))),F=new pb(sb.prefix(f,"".concat("hackle-iam-hide","_").concat(t.slice(0,8),"_"))),V=new Pb(sb.prefix(f,"".concat("hackle-iam-impression","_").concat(t.slice(0,8),"_"))),j=kA.create(T,k,[D,L],F),G=new Zb(new Qb(sb.postfix(l,"_".concat(t.slice(0,8)))),new rN,j,N),H=new rI(N,j);O.addListener(G),O.addListener(H);var B=new wb(j),K=new fb([new lb,new hb(new Kb),new db(new Kb),new vb(F,E.instance),new yb(new zb),new mb(new zb),new gb(new Jb),new Eb(new Jb)]),z=new kb([new Db(V),new Fb(K),new Lb]),J=new Vb(E.instance,B,z),Y=new Gb([new Hb,new Bb(J)]),q=new Ob(cb.inAppMessageRenderer(a.cdnUrl,a.IAM_RENDERER_VERSION_HEADER)),X=new Tb(new Nb(q),J,Y),W=new jb(new Rb(xA.get("targetMatcher")),new Mb(V)),$=new Ab(T,W,j);new _b(P,$,X);var Z=new lN(T);new fN(P,Z);var Q=new VN(xA.get("targetMatcher")),tt=new BN(l,"hackle-split-url-redirected",{days:.0006944444444444445}),et=new FN(T,Q,tt,j),rt=new GN(new HN,new Yb,tt);new DN(P,et,rt);var nt=new ab(j,N,D,L),it=(null===(r=a.devTool)||void 0===r?void 0:r.userExplorer)&&"function"==typeof(null===(n=a.devTool)||void 0===n?void 0:n.userExplorer),ot=a.devTool&&it?{manager:a.devTool,userExplorer:nt}:void 0,st=new de(cb.monitoring(a.monitoringUrl),d,y,new mN,6e4);ue.addRegistry(st),g.start();var ut=new Le(j,g,O,N,ot);zN=ut;var at,ct,pt,ft=function(){S.flush().catch((function(t){return KN.warn("Failed to flush retry events: ".concat(t))}))};return window.addEventListener("onpagehide"in window?"pagehide":"unload",(function(){ze(),O.updateLastEventTime((new Date).getTime()),ut.close(),ue.globalRegistry.close()})),window.addEventListener("pageshow",ft),document.addEventListener("visibilitychange",(function(){document.hidden||ft()})),a.autoOpenDevTool&&(a.devTool?ut.showUserExplorer():KN.error("DevTool is not provided")),at=Date.now(),ct=N.currentUser,pt=O.currentSessionId,(HA(A,ct)?O.startNewSessionIfNeeded(ct,at):O.startNewSession(A,ct,at))===pt&&G.startNewCampaignIfNeeded(ct,at),ut.onReady((function(){(new LA).install(j,N),function(t,e){if(!e.auto_track_page_view)return;function r(t){if("function"==typeof window.Event)return new Event(t);var e={bubbles:!1,cancelable:!1,detail:void 0},r=document.createEvent("CustomEvent");return r.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),r}t.trackPageView();try{history.pushState=(n=history.pushState,function(){try{var t=n.apply(this,arguments);return window.dispatchEvent(r("locationchange")),t}catch(t){if(t instanceof Error)KN.error(t);else try{KN.error(t)}catch(t){}}}),history.replaceState=function(t){return function(){try{var e=t.apply(this,arguments);return window.dispatchEvent(r("locationchange")),e}catch(t){if(t instanceof Error)KN.error(t);else try{KN.error(t)}catch(t){}}}}(history.replaceState),window.addEventListener("popstate",(function(){try{window.dispatchEvent(r("locationchange"))}catch(t){if(t instanceof Error)KN.error(t);else try{KN.error(t)}catch(t){}}})),window.addEventListener("locationchange",(function(){try{t.trackPageView()}catch(t){if(t instanceof Error)KN.error(t);else try{KN.error(t)}catch(t){}}}))}catch(t){if(t instanceof Error)KN.error(t);else try{KN.error(t)}catch(t){}}var n}(ut,a)})),ut}var YN={createInstance:JN,getUserId:Be,setUserId:Ke,removeUserId:ze,Logger:o};__webpack_unused_export__=P,__webpack_unused_export__=Vt,__webpack_unused_export__=q,__webpack_unused_export__=X,__webpack_unused_export__=et,__webpack_unused_export__=O,__webpack_unused_export__=S,__webpack_unused_export__=x,__webpack_unused_export__=w,__webpack_unused_export__=D,__webpack_unused_export__=C,__webpack_unused_export__=R,__webpack_unused_export__=["BUTTON","IMAGE","X_BUTTON"],__webpack_unused_export__=mt,__webpack_unused_export__=yt,__webpack_unused_export__=ht,__webpack_unused_export__=dt,__webpack_unused_export__=vt,__webpack_unused_export__=ft,__webpack_unused_export__=pt,__webpack_unused_export__=lt,__webpack_unused_export__=L,__webpack_unused_export__=V,__webpack_unused_export__=gt,__webpack_unused_export__=Ft,__webpack_unused_export__=Lt,__webpack_unused_export__=kt,__webpack_unused_export__=Dt,__webpack_unused_export__=Rt,__webpack_unused_export__=Mt,__webpack_unused_export__=xt,__webpack_unused_export__=N,__webpack_unused_export__=bt,__webpack_unused_export__=It,__webpack_unused_export__=Tt,__webpack_unused_export__=_t,__webpack_unused_export__=At,__webpack_unused_export__=St,__webpack_unused_export__=Et,__webpack_unused_export__=wt,__webpack_unused_export__=Nt,__webpack_unused_export__=Ct,__webpack_unused_export__=Ut,__webpack_unused_export__=Pt,__webpack_unused_export__=Ot,__webpack_unused_export__=o,__webpack_unused_export__=ot,__webpack_unused_export__=nt,__webpack_unused_export__=it,__webpack_unused_export__=rt,__webpack_unused_export__=M,__webpack_unused_export__=Pe,__webpack_unused_export__=Ue,__webpack_unused_export__=b,__webpack_unused_export__=W,__webpack_unused_export__=Z,__webpack_unused_export__=$,__webpack_unused_export__=at,__webpack_unused_export__=Y,__webpack_unused_export__=k,__webpack_unused_export__=jt,__webpack_unused_export__=Gt,__webpack_unused_export__=st,__webpack_unused_export__=ut,__webpack_unused_export__=G,__webpack_unused_export__=z,__webpack_unused_export__=H,__webpack_unused_export__=B,__webpack_unused_export__=K,__webpack_unused_export__=J,__webpack_unused_export__=ct,__webpack_unused_export__=U,__webpack_unused_export__=tt,exports.Fs=JN,__webpack_unused_export__=YN,__webpack_unused_export__=Be,__webpack_unused_export__=ze,__webpack_unused_export__=F,__webpack_unused_export__=j,__webpack_unused_export__=Ke;
//# sourceMappingURL=index.browser.min.js.map


/***/ }),

/***/ 99313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NIL": function() { return /* reexport */ nil; },
  "parse": function() { return /* reexport */ esm_browser_parse; },
  "stringify": function() { return /* reexport */ esm_browser_stringify; },
  "v1": function() { return /* reexport */ esm_browser_v1; },
  "v3": function() { return /* reexport */ esm_browser_v3; },
  "v4": function() { return /* reexport */ esm_browser_v4; },
  "v5": function() { return /* reexport */ esm_browser_v5; },
  "validate": function() { return /* reexport */ esm_browser_validate; },
  "version": function() { return /* reexport */ esm_browser_version; }
});

;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/v1.js

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || rng)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || esm_browser_stringify(b);
}

/* harmony default export */ var esm_browser_v1 = (v1);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/parse.js


function parse(uuid) {
  if (!esm_browser_validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ var esm_browser_parse = (parse);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/v35.js



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = esm_browser_parse(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return esm_browser_stringify(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/md5.js
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ var esm_browser_md5 = (md5);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/v3.js


var v3 = v35('v3', 0x30, esm_browser_md5);
/* harmony default export */ var esm_browser_v3 = (v3);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/sha1.js
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ var esm_browser_sha1 = (sha1);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/v5.js


var v5 = v35('v5', 0x50, esm_browser_sha1);
/* harmony default export */ var esm_browser_v5 = (v5);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/nil.js
/* harmony default export */ var nil = ('00000000-0000-0000-0000-000000000000');
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/version.js


function version(uuid) {
  if (!esm_browser_validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* harmony default export */ var esm_browser_version = (version);
;// CONCATENATED MODULE: ../../node_modules/@hackler/javascript-sdk/node_modules/uuid/dist/esm-browser/index.js










/***/ }),

/***/ 21445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var airbridge_loader_1 = __webpack_require__(64693);
var flat_keys_1 = __webpack_require__(56587);
var throwOnServerSide = function () {
    throw Error('Airbridge can not be runned on server side');
};
var AirbridgeMock = {
    init: throwOnServerSide,
    get isSDKEnabled() {
        return window.airbridge.isSDKEnabled;
    },
    startTracking: throwOnServerSide,
    stopTracking: throwOnServerSide,
    fetchResource: throwOnServerSide,
    openBanner: throwOnServerSide,
    setBanner: throwOnServerSide,
    setDownloads: throwOnServerSide,
    setDeeplinks: throwOnServerSide,
    openDeeplink: throwOnServerSide,
    sendWeb: throwOnServerSide,
    createTouchpoint: throwOnServerSide,
    setUserID: throwOnServerSide,
    clearUserID: throwOnServerSide,
    setUserEmail: throwOnServerSide,
    clearUserEmail: throwOnServerSide,
    setUserPhone: throwOnServerSide,
    clearUserPhone: throwOnServerSide,
    setUserAttribute: throwOnServerSide,
    removeUserAttribute: throwOnServerSide,
    clearUserAttributes: throwOnServerSide,
    setUserAlias: throwOnServerSide,
    removeUserAlias: throwOnServerSide,
    clearUserAlias: throwOnServerSide,
    clearUser: throwOnServerSide,
    setUserId: throwOnServerSide,
    setUserAttributes: throwOnServerSide,
    setDeviceAlias: throwOnServerSide,
    removeDeviceAlias: throwOnServerSide,
    clearDeviceAlias: throwOnServerSide,
    createTrackingLink: throwOnServerSide,
    events: {
        send: throwOnServerSide,
        signIn: throwOnServerSide,
        signUp: throwOnServerSide,
        signOut: throwOnServerSide,
        purchased: throwOnServerSide,
        addedToCart: throwOnServerSide,
        productDetailsViewEvent: throwOnServerSide,
        homeViewEvent: throwOnServerSide,
        productListViewEvent: throwOnServerSide,
        searchResultViewEvent: throwOnServerSide,
        wait: throwOnServerSide,
    },
};
var prepare = function () {
    (0, airbridge_loader_1.default)();
    var flatKeys = (0, flat_keys_1.FlatKeys)(AirbridgeMock);
    var _loop_1 = function (flatKey) {
        var method = flatKey.pop();
        if (!method || method === 'isSDKEnabled') {
            return "continue";
        }
        var mockObject = flatKey.reduce(function (object, member) { return object[member]; }, AirbridgeMock);
        mockObject[method] = function () {
            var object = flatKey.reduce(function (object, member) { return object[member]; }, window.airbridge);
            object[method].apply(object, arguments);
        };
    };
    for (var _i = 0, flatKeys_1 = flatKeys; _i < flatKeys_1.length; _i++) {
        var flatKey = flatKeys_1[_i];
        _loop_1(flatKey);
    }
};
if (typeof window !== 'undefined') {
    prepare();
}
var airbridge = AirbridgeMock;
exports.Z = airbridge;


/***/ }),

/***/ 64693:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// @ts-ignore
var load_airbridge = function () { return (function (a_, i_, r_, _b, _r, _i, _d, _g, _e) { if (!a_[_b]) {
    var n = function () { var c = i_.createElement(r_); c.onerror = function () { g.queue.filter(function (a) { return 0 <= _d.indexOf(a[0]); }).forEach(function (a) { a = a[1]; a = a[a.length - 1]; "function" === typeof a && a("error occur when load airbridge"); }); }; c.async = 1; c.src = _r; "complete" === i_.readyState ? i_.head.appendChild(c) : a_.addEventListener("load", function h() { a_.removeEventListener("load", h); i_.head.appendChild(c); }); }, g = { queue: [], get isSDKEnabled() { return !1; } };
    _i.concat(_d).forEach(function (c) { var a = c.split("."), h = a.pop(); a.reduce(function (p, q) { return p[q] = p[q] || {}; }, g)[h] = function () { g.queue.push([c, arguments]); }; });
    a_[_b] = g;
    0 < _g ? (_b = new (a_.XDomainRequest || a_.XMLHttpRequest), _i = function () { }, _b.open("GET", _r), _b.timeout = _g, _b.onload = function () { n(); }, _b.onerror = _i, _b.onprogress = _i, _b.ontimeout = _i, _b.send()) : n();
} })(window, document, "script", "airbridge", "//static.airbridge.io/sdk/latest/airbridge.min.js", "init startTracking stopTracking fetchResource openBanner setBanner setDownload setDownloads openDeeplink setDeeplinks sendWeb setUserAgent setMobileAppData setUserID clearUserID setUserEmail clearUserEmail setUserPhone clearUserPhone setUserAttribute removeUserAttribute clearUserAttributes setUserAlias removeUserAlias clearUserAlias clearUser setUserId setUserAttributes addUserAlias setDeviceAlias removeDeviceAlias clearDeviceAlias setDeviceIFV setDeviceIFA setDeviceGAID events.send events.signIn events.signUp events.signOut events.purchased events.addedToCart events.productDetailsViewEvent events.homeViewEvent events.productListViewEvent events.searchResultViewEvent".split(" "), ["events.wait", "createTouchpoint"], 0); };
exports["default"] = load_airbridge;


/***/ }),

/***/ 56587:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlatKeys = void 0;
var FlatKeys = function (object) {
    var result = [];
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = object[key];
        if (typeof value === 'object' && value !== null && value.constructor === Object) {
            var flatKeys = FlatKeys(value);
            for (var _b = 0, flatKeys_1 = flatKeys; _b < flatKeys_1.length; _b++) {
                var flatKey = flatKeys_1[_b];
                result.push(__spreadArray([key], flatKey, true));
            }
        }
        else {
            result.push([key]);
        }
    }
    return result;
};
exports.FlatKeys = FlatKeys;


/***/ }),

/***/ 95766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(95766)
const ieee754 = __webpack_require__(62333)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(73887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 43459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 73887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43459);
} else {}


/***/ }),

/***/ 62333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 95978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48834)["lW"];
//
// THIS FILE IS AUTOMATICALLY GENERATED! DO NOT EDIT BY HAND!
//
;
(function (global, factory) {
     true
        ? module.exports = factory()
        : 0;
}((typeof self !== 'undefined' ? self
    : typeof window !== 'undefined' ? window
        : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g
            : this), function () {
    'use strict';
    /**
     *  base64.ts
     *
     *  Licensed under the BSD 3-Clause License.
     *    http://opensource.org/licenses/BSD-3-Clause
     *
     *  References:
     *    http://en.wikipedia.org/wiki/Base64
     *
     * @author Dan Kogai (https://github.com/dankogai)
     */
    var version = '3.7.7';
    /**
     * @deprecated use lowercase `version`.
     */
    var VERSION = version;
    var _hasBuffer = typeof Buffer === 'function';
    var _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
    var _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
    var b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var b64chs = Array.prototype.slice.call(b64ch);
    var b64tab = (function (a) {
        var tab = {};
        a.forEach(function (c, i) { return tab[c] = i; });
        return tab;
    })(b64chs);
    var b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
    var _fromCC = String.fromCharCode.bind(String);
    var _U8Afrom = typeof Uint8Array.from === 'function'
        ? Uint8Array.from.bind(Uint8Array)
        : function (it) { return new Uint8Array(Array.prototype.slice.call(it, 0)); };
    var _mkUriSafe = function (src) { return src
        .replace(/=/g, '').replace(/[+\/]/g, function (m0) { return m0 == '+' ? '-' : '_'; }); };
    var _tidyB64 = function (s) { return s.replace(/[^A-Za-z0-9\+\/]/g, ''); };
    /**
     * polyfill version of `btoa`
     */
    var btoaPolyfill = function (bin) {
        // console.log('polyfilled');
        var u32, c0, c1, c2, asc = '';
        var pad = bin.length % 3;
        for (var i = 0; i < bin.length;) {
            if ((c0 = bin.charCodeAt(i++)) > 255 ||
                (c1 = bin.charCodeAt(i++)) > 255 ||
                (c2 = bin.charCodeAt(i++)) > 255)
                throw new TypeError('invalid character found');
            u32 = (c0 << 16) | (c1 << 8) | c2;
            asc += b64chs[u32 >> 18 & 63]
                + b64chs[u32 >> 12 & 63]
                + b64chs[u32 >> 6 & 63]
                + b64chs[u32 & 63];
        }
        return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
    };
    /**
     * does what `window.btoa` of web browsers do.
     * @param {String} bin binary string
     * @returns {string} Base64-encoded string
     */
    var _btoa = typeof btoa === 'function' ? function (bin) { return btoa(bin); }
        : _hasBuffer ? function (bin) { return Buffer.from(bin, 'binary').toString('base64'); }
            : btoaPolyfill;
    var _fromUint8Array = _hasBuffer
        ? function (u8a) { return Buffer.from(u8a).toString('base64'); }
        : function (u8a) {
            // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
            var maxargs = 0x1000;
            var strs = [];
            for (var i = 0, l = u8a.length; i < l; i += maxargs) {
                strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
            }
            return _btoa(strs.join(''));
        };
    /**
     * converts a Uint8Array to a Base64 string.
     * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
     * @returns {string} Base64 string
     */
    var fromUint8Array = function (u8a, urlsafe) {
        if (urlsafe === void 0) { urlsafe = false; }
        return urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
    };
    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
    // const utob = (src: string) => unescape(encodeURIComponent(src));
    // reverting good old fationed regexp
    var cb_utob = function (c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                    + _fromCC(0x80 | (cc & 0x3f)))
                    : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                        + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                        + _fromCC(0x80 | (cc & 0x3f)));
        }
        else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
                + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
                + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                + _fromCC(0x80 | (cc & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    /**
     * @deprecated should have been internal use only.
     * @param {string} src UTF-8 string
     * @returns {string} UTF-16 string
     */
    var utob = function (u) { return u.replace(re_utob, cb_utob); };
    //
    var _encode = _hasBuffer
        ? function (s) { return Buffer.from(s, 'utf8').toString('base64'); }
        : _TE
            ? function (s) { return _fromUint8Array(_TE.encode(s)); }
            : function (s) { return _btoa(utob(s)); };
    /**
     * converts a UTF-8-encoded string to a Base64 string.
     * @param {boolean} [urlsafe] if `true` make the result URL-safe
     * @returns {string} Base64 string
     */
    var encode = function (src, urlsafe) {
        if (urlsafe === void 0) { urlsafe = false; }
        return urlsafe
            ? _mkUriSafe(_encode(src))
            : _encode(src);
    };
    /**
     * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
     * @returns {string} Base64 string
     */
    var encodeURI = function (src) { return encode(src, true); };
    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
    // const btou = (src: string) => decodeURIComponent(escape(src));
    // reverting good old fationed regexp
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function (cccc) {
        switch (cccc.length) {
            case 4:
                var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                    | ((0x3f & cccc.charCodeAt(1)) << 12)
                    | ((0x3f & cccc.charCodeAt(2)) << 6)
                    | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
                return (_fromCC((offset >>> 10) + 0xD800)
                    + _fromCC((offset & 0x3FF) + 0xDC00));
            case 3:
                return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    | (0x3f & cccc.charCodeAt(2)));
            default:
                return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                    | (0x3f & cccc.charCodeAt(1)));
        }
    };
    /**
     * @deprecated should have been internal use only.
     * @param {string} src UTF-16 string
     * @returns {string} UTF-8 string
     */
    var btou = function (b) { return b.replace(re_btou, cb_btou); };
    /**
     * polyfill version of `atob`
     */
    var atobPolyfill = function (asc) {
        // console.log('polyfilled');
        asc = asc.replace(/\s+/g, '');
        if (!b64re.test(asc))
            throw new TypeError('malformed base64.');
        asc += '=='.slice(2 - (asc.length & 3));
        var u24, bin = '', r1, r2;
        for (var i = 0; i < asc.length;) {
            u24 = b64tab[asc.charAt(i++)] << 18
                | b64tab[asc.charAt(i++)] << 12
                | (r1 = b64tab[asc.charAt(i++)]) << 6
                | (r2 = b64tab[asc.charAt(i++)]);
            bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
                : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                    : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
        }
        return bin;
    };
    /**
     * does what `window.atob` of web browsers do.
     * @param {String} asc Base64-encoded string
     * @returns {string} binary string
     */
    var _atob = typeof atob === 'function' ? function (asc) { return atob(_tidyB64(asc)); }
        : _hasBuffer ? function (asc) { return Buffer.from(asc, 'base64').toString('binary'); }
            : atobPolyfill;
    //
    var _toUint8Array = _hasBuffer
        ? function (a) { return _U8Afrom(Buffer.from(a, 'base64')); }
        : function (a) { return _U8Afrom(_atob(a).split('').map(function (c) { return c.charCodeAt(0); })); };
    /**
     * converts a Base64 string to a Uint8Array.
     */
    var toUint8Array = function (a) { return _toUint8Array(_unURI(a)); };
    //
    var _decode = _hasBuffer
        ? function (a) { return Buffer.from(a, 'base64').toString('utf8'); }
        : _TD
            ? function (a) { return _TD.decode(_toUint8Array(a)); }
            : function (a) { return btou(_atob(a)); };
    var _unURI = function (a) { return _tidyB64(a.replace(/[-_]/g, function (m0) { return m0 == '-' ? '+' : '/'; })); };
    /**
     * converts a Base64 string to a UTF-8 string.
     * @param {String} src Base64 string.  Both normal and URL-safe are supported
     * @returns {string} UTF-8 string
     */
    var decode = function (src) { return _decode(_unURI(src)); };
    /**
     * check if a value is a valid Base64 string
     * @param {String} src a value to check
      */
    var isValid = function (src) {
        if (typeof src !== 'string')
            return false;
        var s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
        return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
    };
    //
    var _noEnum = function (v) {
        return {
            value: v, enumerable: false, writable: true, configurable: true
        };
    };
    /**
     * extend String.prototype with relevant methods
     */
    var extendString = function () {
        var _add = function (name, body) { return Object.defineProperty(String.prototype, name, _noEnum(body)); };
        _add('fromBase64', function () { return decode(this); });
        _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
        _add('toBase64URI', function () { return encode(this, true); });
        _add('toBase64URL', function () { return encode(this, true); });
        _add('toUint8Array', function () { return toUint8Array(this); });
    };
    /**
     * extend Uint8Array.prototype with relevant methods
     */
    var extendUint8Array = function () {
        var _add = function (name, body) { return Object.defineProperty(Uint8Array.prototype, name, _noEnum(body)); };
        _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
        _add('toBase64URI', function () { return fromUint8Array(this, true); });
        _add('toBase64URL', function () { return fromUint8Array(this, true); });
    };
    /**
     * extend Builtin prototypes with relevant methods
     */
    var extendBuiltins = function () {
        extendString();
        extendUint8Array();
    };
    var gBase64 = {
        version: version,
        VERSION: VERSION,
        atob: _atob,
        atobPolyfill: atobPolyfill,
        btoa: _btoa,
        btoaPolyfill: btoaPolyfill,
        fromBase64: decode,
        toBase64: encode,
        encode: encode,
        encodeURI: encodeURI,
        encodeURL: encodeURI,
        utob: utob,
        btou: btou,
        decode: decode,
        isValid: isValid,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array,
        extendString: extendString,
        extendUint8Array: extendUint8Array,
        extendBuiltins: extendBuiltins
    };
    //
    // export Base64 to the namespace
    //
    // ES5 is yet to have Object.assign() that may make transpilers unhappy.
    // gBase64.Base64 = Object.assign({}, gBase64);
    gBase64.Base64 = {};
    Object.keys(gBase64).forEach(function (k) { return gBase64.Base64[k] = gBase64[k]; });
    return gBase64;
}));


/***/ }),

/***/ 39515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 89612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(52118),
    hashDelete = __webpack_require__(96909),
    hashGet = __webpack_require__(98138),
    hashHas = __webpack_require__(4174),
    hashSet = __webpack_require__(7942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 80235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3945),
    listCacheDelete = __webpack_require__(21846),
    listCacheGet = __webpack_require__(88028),
    listCacheHas = __webpack_require__(72344),
    listCacheSet = __webpack_require__(94769);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 10326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 96738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(92411),
    mapCacheDelete = __webpack_require__(36417),
    mapCacheGet = __webpack_require__(86928),
    mapCacheHas = __webpack_require__(79493),
    mapCacheSet = __webpack_require__(24150);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 52760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 45386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738),
    setCacheAdd = __webpack_require__(52842),
    setCacheHas = __webpack_require__(52482);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 86571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    stackClear = __webpack_require__(15243),
    stackDelete = __webpack_require__(72858),
    stackGet = __webpack_require__(4417),
    stackHas = __webpack_require__(8605),
    stackSet = __webpack_require__(71418);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 50857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 79162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 93215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 67552:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 1634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(36473),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isIndex = __webpack_require__(39045),
    isTypedArray = __webpack_require__(77598);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 50343:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 65067:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 81207:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 87064:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 50217:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 45981:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 60091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 22218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 13940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(83043);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 13324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 1897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 53366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    getRawTag = __webpack_require__(62107),
    objectToString = __webpack_require__(37157);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 15183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 88746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(51952),
    isObjectLike = __webpack_require__(15125);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 51952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    equalArrays = __webpack_require__(74871),
    equalByTag = __webpack_require__(11491),
    equalObjects = __webpack_require__(17416),
    getTag = __webpack_require__(70940),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isTypedArray = __webpack_require__(77598);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isMasked = __webpack_require__(47394),
    isObject = __webpack_require__(29259),
    toSource = __webpack_require__(87035);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 35522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isLength = __webpack_require__(61158),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 86411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(16001),
    nativeKeys = __webpack_require__(54248);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 6435:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 82857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(60091),
    castPath = __webpack_require__(17297),
    isIndex = __webpack_require__(39045),
    isObject = __webpack_require__(29259),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 39872:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 36473:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 1054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    arrayMap = __webpack_require__(50343),
    isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 47826:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 59950:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 17297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isKey = __webpack_require__(21401),
    stringToPath = __webpack_require__(54452),
    toString = __webpack_require__(66188);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 23895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(39872);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 24019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 83126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(23895),
    hasUnicode = __webpack_require__(33880),
    stringToArray = __webpack_require__(8435),
    toString = __webpack_require__(66188);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 34311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(81207),
    deburr = __webpack_require__(97329),
    words = __webpack_require__(11618);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 61655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(6435);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 83043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 74871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(45386),
    arraySome = __webpack_require__(87064),
    cacheHas = __webpack_require__(59950);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 11491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    Uint8Array = __webpack_require__(79162),
    eq = __webpack_require__(41225),
    equalArrays = __webpack_require__(74871),
    mapToArray = __webpack_require__(75179),
    setToArray = __webpack_require__(16909);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 17416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(13483);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 51242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 13483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1897),
    getSymbols = __webpack_require__(80633),
    keys = __webpack_require__(90249);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 27937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(98304);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 38761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(6840),
    getValue = __webpack_require__(98109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 62107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 80633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(67552),
    stubArray = __webpack_require__(30981);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 70940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(39515),
    Map = __webpack_require__(10326),
    Promise = __webpack_require__(52760),
    Set = __webpack_require__(2143),
    WeakMap = __webpack_require__(93215),
    baseGetTag = __webpack_require__(53366),
    toSource = __webpack_require__(87035);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 98109:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 33880:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 83559:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 52118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 96909:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 98138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 4174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 39045:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 21401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 98304:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(24019);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 16001:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 3945:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 21846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 88028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 72344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 94769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 92411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(89612),
    ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 36417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 86928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 79493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 24150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 75179:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 77777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(30733);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 99191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 54248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(60241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(51242);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 37157:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 60241:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 37772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(51242);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 52842:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 52482:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 16909:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 15243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 72858:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 4417:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 8605:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 71418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326),
    MapCache = __webpack_require__(96738);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 8435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(50217),
    hasUnicode = __webpack_require__(33880),
    unicodeToArray = __webpack_require__(63344);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 54452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(77777);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 33812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 87035:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 63344:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 75304:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 96009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capitalize = __webpack_require__(82108),
    createCompounder = __webpack_require__(34311);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ 82108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(66188),
    upperFirst = __webpack_require__(23779);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 97329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(61655),
    toString = __webpack_require__(66188);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 41225:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 72579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(13324);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(15183),
    isObjectLike = __webpack_require__(15125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 86152:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 67878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isLength = __webpack_require__(61158);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 73226:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772),
    stubFalse = __webpack_require__(79207);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 18149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(88746);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 61049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObject = __webpack_require__(29259);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 61158:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 29259:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 15125:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 4795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 77598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(35522),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 90249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeys = __webpack_require__(86411),
    isArrayLike = __webpack_require__(67878);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 30733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 16765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(82857);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 30981:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 79207:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 66188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(1054);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 23779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(83126);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 11618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(45981),
    hasUnicodeWord = __webpack_require__(83559),
    toString = __webpack_require__(66188),
    unicodeWords = __webpack_require__(75304);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 55351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PB": function() { return /* binding */ NextSeo; },
/* harmony export */   "lX": function() { return /* binding */ DefaultSeo; }
/* harmony export */ });
/* unused harmony exports ArticleJsonLd, BrandJsonLd, BreadcrumbJsonLd, CarouselJsonLd, CollectionPageJsonLd, CorporateContactJsonLd, CourseJsonLd, DatasetJsonLd, EventJsonLd, FAQPageJsonLd, HowToJsonLd, ImageJsonLd, JobPostingJsonLd, LocalBusinessJsonLd, LogoJsonLd, NewsArticleJsonLd, OrganizationJsonLd, ProductJsonLd, ProfilePageJsonLd, QAPageJsonLd, RecipeJsonLd, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd, SoftwareAppJsonLd, VideoGameJsonLd, VideoJsonLd, WebPageJsonLd */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded$x = ["keyOverride"];
var defaults = {
  templateTitle: '',
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
  if (media === void 0) {
    media = [];
  }
  var _ref = _temp === void 0 ? {} : _temp,
    defaultWidth = _ref.defaultWidth,
    defaultHeight = _ref.defaultHeight;
  return media.reduce(function (tags, medium, index) {
    tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:" + mediaType + ":0" + index,
      property: "og:" + mediaType,
      content: medium.url
    }));
    if (medium.alt) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":alt0" + index,
        property: "og:" + mediaType + ":alt",
        content: medium.alt
      }));
    }
    if (medium.secureUrl) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":secure_url0" + index,
        property: "og:" + mediaType + ":secure_url",
        content: medium.secureUrl.toString()
      }));
    }
    if (medium.type) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":type0" + index,
        property: "og:" + mediaType + ":type",
        content: medium.type.toString()
      }));
    }
    if (medium.width) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: medium.width.toString()
      }));
    } else if (defaultWidth) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: defaultWidth.toString()
      }));
    }
    if (medium.height) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: medium.height.toString()
      }));
    } else if (defaultHeight) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: defaultHeight.toString()
      }));
    }
    return tags;
  }, []);
};
var buildTags = function buildTags(config) {
  var _config$openGraph, _config$openGraph3, _config$additionalLin;
  var tagsToRender = [];
  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }
  var updatedTitle = '';
  if (config.title) {
    updatedTitle = config.title;
    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, function () {
        return updatedTitle;
      });
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }
  if (updatedTitle) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
      key: "title"
    }, updatedTitle));
  }
  var noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
  var nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
  var robotsParams = '';
  if (config.robotsProps) {
    var _config$robotsProps = config.robotsProps,
      nosnippet = _config$robotsProps.nosnippet,
      maxSnippet = _config$robotsProps.maxSnippet,
      maxImagePreview = _config$robotsProps.maxImagePreview,
      maxVideoPreview = _config$robotsProps.maxVideoPreview,
      noarchive = _config$robotsProps.noarchive,
      noimageindex = _config$robotsProps.noimageindex,
      notranslate = _config$robotsProps.notranslate,
      unavailableAfter = _config$robotsProps.unavailableAfter;
    robotsParams = "" + (nosnippet ? ',nosnippet' : '') + (maxSnippet ? ",max-snippet:" + maxSnippet : '') + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : '') + (noarchive ? ',noarchive' : '') + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : '') + (noimageindex ? ',noimageindex' : '') + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : '') + (notranslate ? ',notranslate' : '');
  }
  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }
    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: (noindex ? 'noindex' : 'index') + "," + (nofollow ? 'nofollow' : 'follow') + robotsParams
    }));
  } else {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: "index,follow" + robotsParams
    }));
  }
  if (config.description) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "description",
      name: "description",
      content: config.description
    }));
  }
  if (config.themeColor) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "theme-color",
      name: "theme-color",
      content: config.themeColor
    }));
  }
  if (config.mobileAlternate) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "alternate",
      key: "mobileAlternate",
      media: config.mobileAlternate.media,
      href: config.mobileAlternate.href
    }));
  }
  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach(function (languageAlternate) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
        rel: "alternate",
        key: "languageAlternate-" + languageAlternate.hrefLang,
        hrefLang: languageAlternate.hrefLang,
        href: languageAlternate.href
      }));
    });
  }
  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:card",
        name: "twitter:card",
        content: config.twitter.cardType
      }));
    }
    if (config.twitter.site) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:site",
        name: "twitter:site",
        content: config.twitter.site
      }));
    }
    if (config.twitter.handle) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:creator",
        name: "twitter:creator",
        content: config.twitter.handle
      }));
    }
  }
  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "fb:app_id",
        property: "fb:app_id",
        content: config.facebook.appId
      }));
    }
  }
  if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
    var _config$openGraph2;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:title",
      property: "og:title",
      content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
    }));
  }
  if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
    var _config$openGraph4;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:description",
      property: "og:description",
      content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
    }));
  }
  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: config.openGraph.url || config.canonical
      }));
    }
    if (config.openGraph.type) {
      var type = config.openGraph.type.toLowerCase();
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: type
      }));
      if (type === 'profile' && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:first_name",
            property: "profile:first_name",
            content: config.openGraph.profile.firstName
          }));
        }
        if (config.openGraph.profile.lastName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:last_name",
            property: "profile:last_name",
            content: config.openGraph.profile.lastName
          }));
        }
        if (config.openGraph.profile.username) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:username",
            property: "profile:username",
            content: config.openGraph.profile.username
          }));
        }
        if (config.openGraph.profile.gender) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:gender",
            property: "profile:gender",
            content: config.openGraph.profile.gender
          }));
        }
      } else if (type === 'book' && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:author:0" + index,
              property: "book:author",
              content: author
            }));
          });
        }
        if (config.openGraph.book.isbn) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:isbn",
            property: "book:isbn",
            content: config.openGraph.book.isbn
          }));
        }
        if (config.openGraph.book.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:release_date",
            property: "book:release_date",
            content: config.openGraph.book.releaseDate
          }));
        }
        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:tag:0" + index,
              property: "book:tag",
              content: tag
            }));
          });
        }
      } else if (type === 'article' && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:published_time",
            property: "article:published_time",
            content: config.openGraph.article.publishedTime
          }));
        }
        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:modified_time",
            property: "article:modified_time",
            content: config.openGraph.article.modifiedTime
          }));
        }
        if (config.openGraph.article.expirationTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:expiration_time",
            property: "article:expiration_time",
            content: config.openGraph.article.expirationTime
          }));
        }
        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:author:0" + index,
              property: "article:author",
              content: author
            }));
          });
        }
        if (config.openGraph.article.section) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:section",
            property: "article:section",
            content: config.openGraph.article.section
          }));
        }
        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:tag:0" + index,
              property: "article:tag",
              content: tag
            }));
          });
        }
      } else if ((type === 'video.movie' || type === 'video.episode' || type === 'video.tv_show' || type === 'video.other') && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach(function (actor, index) {
            if (actor.profile) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:0" + index,
                property: "video:actor",
                content: actor.profile
              }));
            }
            if (actor.role) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:role:0" + index,
                property: "video:actor:role",
                content: actor.role
              }));
            }
          });
        }
        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach(function (director, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:director:0" + index,
              property: "video:director",
              content: director
            }));
          });
        }
        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach(function (writer, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:writer:0" + index,
              property: "video:writer",
              content: writer
            }));
          });
        }
        if (config.openGraph.video.duration) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:duration",
            property: "video:duration",
            content: config.openGraph.video.duration.toString()
          }));
        }
        if (config.openGraph.video.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:release_date",
            property: "video:release_date",
            content: config.openGraph.video.releaseDate
          }));
        }
        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:tag:0" + index,
              property: "video:tag",
              content: tag
            }));
          });
        }
        if (config.openGraph.video.series) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:series",
            property: "video:series",
            content: config.openGraph.video.series
          }));
        }
      }
    }
    // images
    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }
    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }
    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('image', config.openGraph.images, {
        defaultWidth: defaults.defaultOpenGraphImageWidth,
        defaultHeight: defaults.defaultOpenGraphImageHeight
      }));
    }
    // videos
    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }
    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }
    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('video', config.openGraph.videos, {
        defaultWidth: defaults.defaultOpenGraphVideoWidth,
        defaultHeight: defaults.defaultOpenGraphVideoHeight
      }));
    }
    // audio
    if (config.openGraph.audio) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('audio', config.openGraph.audio));
    }
    if (config.openGraph.locale) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:locale",
        property: "og:locale",
        content: config.openGraph.locale
      }));
    }
    if (config.openGraph.siteName || config.openGraph.site_name) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:site_name",
        property: "og:site_name",
        content: config.openGraph.siteName || config.openGraph.site_name
      }));
    }
  }
  if (config.canonical) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "canonical",
      href: config.canonical,
      key: "canonical"
    }));
  }
  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach(function (_ref2) {
      var _ref3, _ref4;
      var keyOverride = _ref2.keyOverride,
        tag = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", _extends({
        key: "meta:" + ((_ref3 = (_ref4 = keyOverride != null ? keyOverride : tag.name) != null ? _ref4 : tag.property) != null ? _ref3 : tag.httpEquiv)
      }, tag)));
    });
  }
  if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
    config.additionalLinkTags.forEach(function (tag) {
      var _tag$keyOverride;
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", _extends({
        key: "link" + ((_tag$keyOverride = tag.keyOverride) != null ? _tag$keyOverride : tag.href) + tag.rel
      }, tag)));
    });
  }
  return tagsToRender;
};

var WithHead = function WithHead(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, buildTags(props));
};

var DefaultSeo = function DefaultSeo(_ref) {
  var title = _ref.title,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    themeColor = _ref.themeColor,
    _ref$dangerouslySetAl = _ref.dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoIndex = _ref$dangerouslySetAl === void 0 ? false : _ref$dangerouslySetAl,
    _ref$dangerouslySetAl2 = _ref.dangerouslySetAllPagesToNoFollow,
    dangerouslySetAllPagesToNoFollow = _ref$dangerouslySetAl2 === void 0 ? false : _ref$dangerouslySetAl2,
    description = _ref.description,
    canonical = _ref.canonical,
    facebook = _ref.facebook,
    openGraph = _ref.openGraph,
    additionalMetaTags = _ref.additionalMetaTags,
    twitter = _ref.twitter,
    defaultOpenGraphImageWidth = _ref.defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight = _ref.defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth = _ref.defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight = _ref.defaultOpenGraphVideoHeight,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    robotsProps = _ref.robotsProps;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    themeColor: themeColor,
    dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags,
    robotsProps: robotsProps
  });
};

var NextSeo = function NextSeo(_ref) {
  var title = _ref.title,
    themeColor = _ref.themeColor,
    _ref$noindex = _ref.noindex,
    noindex = _ref$noindex === void 0 ? false : _ref$noindex,
    nofollow = _ref.nofollow,
    robotsProps = _ref.robotsProps,
    description = _ref.description,
    canonical = _ref.canonical,
    openGraph = _ref.openGraph,
    facebook = _ref.facebook,
    twitter = _ref.twitter,
    additionalMetaTags = _ref.additionalMetaTags,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, useAppDir ? buildTags({
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }));
};

var toJson = function toJson(type, jsonld) {
  var data = jsonld;
  if (Array.isArray(data) && data.length === 1) {
    data = _extends({}, jsonld[0]);
  }
  var jsonLdObject = Array.isArray(data) ? data.map(function (item) {
    return formatObjectForSchema(type, item);
  }) : formatObjectForSchema(type, data);
  return {
    __html: JSON.stringify(jsonLdObject, safeJsonLdReplacer)
  };
};
var formatObjectForSchema = function formatObjectForSchema(type, jsonld) {
  var _jsonld$id = jsonld.id,
    id = _jsonld$id === void 0 ? undefined : _jsonld$id;
  var updated = _extends({}, id ? {
    '@id': jsonld.id
  } : {}, jsonld);
  delete updated.id;
  return _extends({
    '@context': 'https://schema.org',
    '@type': type
  }, updated);
};
var ESCAPE_ENTITIES = Object.freeze({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join('') + "]", 'g');
var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
  return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
var safeJsonLdReplacer = function () {
  // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
  // Solution from https://stackoverflow.com/a/5499821/864313
  return function (_, value) {
    switch (typeof value) {
      case 'object':
        // Omit null values.
        if (value === null) {
          return undefined;
        }
        return value;
      // JSON.stringify will recursively call replacer.
      case 'number':
      case 'boolean':
      case 'bigint':
        return value;
      // These values are not risky.
      case 'string':
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
      default:
        {
          // JSON.stringify will remove this element.
          return undefined;
        }
    }
  };
}();

var _excluded$w = (/* unused pure expression or super */ null && (["type", "keyOverride", "scriptKey", "scriptId", "dataArray", "useAppDir"]));
function JsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Thing' : _ref$type,
    keyOverride = _ref.keyOverride,
    scriptKey = _ref.scriptKey,
    _ref$scriptId = _ref.scriptId,
    scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId,
    dataArray = _ref.dataArray,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var JsonLdScript = function JsonLdScript() {
    return /*#__PURE__*/React.createElement("script", {
      type: "application/ld+json",
      id: scriptId,
      "data-testid": scriptId,
      dangerouslySetInnerHTML: toJson(type, dataArray === undefined ? _extends({}, rest) : dataArray),
      key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : '')
    });
  };
  if (useAppDir) {
    return /*#__PURE__*/React.createElement(JsonLdScript, null);
  }
  return /*#__PURE__*/React.createElement(Head, null, JsonLdScript());
}

/**
 * Generate author information
 * @param author
 * @returns
 */
function generateAuthorInfo(author) {
  if (typeof author === 'string') {
    return {
      '@type': 'Person',
      name: author
    };
  } else if (!!author.name) {
    var _author$type;
    return {
      '@type': (_author$type = author == null ? void 0 : author.type) != null ? _author$type : 'Person',
      name: author.name,
      url: author == null ? void 0 : author.url
    };
  }
  return;
}
function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map(function (item) {
      return generateAuthorInfo(item);
    }).filter(function (item) {
      return !!item;
    });
  } else if (author) {
    return generateAuthorInfo(author);
  }
  return;
}

function setImage(image) {
  if (image) {
    return {
      '@type': 'ImageObject',
      url: image
    };
  }
  return undefined;
}

function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return undefined;
  }
  return {
    '@type': 'Organization',
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

function setReviewRating(rating) {
  if (rating) {
    return _extends({}, rating, {
      '@type': 'Rating'
    });
  }
  return undefined;
}

var _excluded$v = (/* unused pure expression or super */ null && (["reviewRating", "author", "publisher"]));
function setReviews(reviews) {
  function mapReview(_ref) {
    var reviewRating = _ref.reviewRating,
      author = _ref.author,
      publisher = _ref.publisher,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
    return _extends({}, rest, {
      '@type': 'Review'
    }, author && {
      author: setAuthor(author)
    }, reviewRating && {
      reviewRating: setReviewRating(reviewRating)
    }, publisher && {
      publisher: setPublisher(publisher.name)
    });
  }
  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }
  return undefined;
}

function setNutrition(calories) {
  if (calories) {
    return {
      '@type': 'NutritionInformation',
      calories: calories + " calories"
    };
  }
  return undefined;
}

function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      '@type': 'AggregateRating',
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue
    };
  }
  return undefined;
}

function setClip(clips) {
  function mapClip(clip) {
    return _extends({}, clip, {
      '@type': 'Clip'
    });
  }
  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }
  return undefined;
}

function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/WatchAction',
      userInteractionCount: watchCount
    };
  }
  return undefined;
}

function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication) {
    return _extends({}, publication, {
      '@type': 'BroadcastEvent'
    });
  }
  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }
    return mapBroadcastEvent(publication);
  }
  return undefined;
}

var _excluded$u = (/* unused pure expression or super */ null && (["thumbnailUrls", "hasPart", "watchCount", "publication"]));
function setVideo(video, setContext) {
  if (setContext === void 0) {
    setContext = false;
  }
  function mapVideo(_ref, context) {
    var thumbnailUrls = _ref.thumbnailUrls,
      hasPart = _ref.hasPart,
      watchCount = _ref.watchCount,
      publication = _ref.publication,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
    return _extends({}, rest, {
      '@type': 'VideoObject'
    }, context && {
      '@context': 'https://schema.org'
    }, {
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    });
  }
  if (video) {
    return mapVideo(video, setContext);
  }
  return undefined;
}

function setInstruction(instruction) {
  if (instruction) {
    return _extends({}, instruction, {
      '@type': 'HowToStep'
    });
  }
  return undefined;
}

var _excluded$t = (/* unused pure expression or super */ null && (["type", "keyOverride", "ofType", "data"])),
  _excluded2$1 = (/* unused pure expression or super */ null && (["authorName", "images", "yields", "category", "calories", "aggregateRating", "video", "ingredients", "instructions", "cuisine"]));
function CarouselJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Carousel' : _ref$type,
    keyOverride = _ref.keyOverride,
    ofType = _ref.ofType,
    data = _ref.data,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  function generateList(data, ofType) {
    switch (ofType) {
      case 'default':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            url: item.url
          };
        });
      case 'course':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Course',
              url: item.url,
              name: item.courseName,
              description: item.description,
              provider: {
                '@type': 'Organization',
                name: item.providerName,
                sameAs: item.providerUrl
              }
            }
          };
        });
      case 'movie':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Movie',
              name: item.name,
              url: item.url,
              image: item.image,
              dateCreated: item.dateCreated,
              director: item.director ? Array.isArray(item.director) ? item.director.map(function (director) {
                return {
                  '@type': 'Person',
                  name: director.name
                };
              }) : {
                '@type': 'Person',
                name: item.director.name
              } : undefined,
              review: setReviews(item.review)
            }
          };
        });
      case 'recipe':
        return data.map(function (_ref2, index) {
          var authorName = _ref2.authorName,
            images = _ref2.images,
            yields = _ref2.yields,
            category = _ref2.category,
            calories = _ref2.calories,
            aggregateRating = _ref2.aggregateRating,
            video = _ref2.video,
            ingredients = _ref2.ingredients,
            instructions = _ref2.instructions,
            cuisine = _ref2.cuisine,
            rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: _extends({
              '@context': 'https://schema.org',
              '@type': 'Recipe'
            }, rest, {
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            })
          };
        });
    }
  }
  var jsonLdData = _extends({
    '@type': 'ItemList',
    itemListElement: generateList(data, ofType)
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, jsonLdData, {
    scriptKey: "Carousel"
  }));
}

var _excluded$s = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "section", "dateCreated", "datePublished", "dateModified", "authorName", "authorType", "publisherName", "publisherLogo", "body", "isAccessibleForFree"]));
function NewsArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'NewsArticle' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    section = _ref.section,
    dateCreated = _ref.dateCreated,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    publisherName = _ref.publisherName,
    publisherLogo = _ref.publisherLogo,
    body = _ref.body,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var data = _extends({}, rest, {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body,
    isAccessibleForFree: isAccessibleForFree
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "NewsArticle"
  }));
}

var _excluded$r = (/* unused pure expression or super */ null && (["type", "keyOverride", "baseSalary", "hiringOrganization", "applicantLocationRequirements", "experienceRequirements", "jobLocation"]));
function JobPostingJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'JobPosting' : _ref$type,
    keyOverride = _ref.keyOverride,
    baseSalary = _ref.baseSalary,
    hiringOrganization = _ref.hiringOrganization,
    applicantLocationRequirements = _ref.applicantLocationRequirements,
    experienceRequirements = _ref.experienceRequirements,
    jobLocation = _ref.jobLocation,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  function setBaseSalary(baseSalary) {
    if (baseSalary) {
      return {
        '@type': 'MonetaryAmount',
        currency: baseSalary.currency,
        value: _extends({
          '@type': 'QuantitativeValue',
          unitText: baseSalary.unitText
        }, Array.isArray(baseSalary.value) ? {
          minValue: baseSalary.value[0],
          maxValue: baseSalary.value[1]
        } : {
          value: baseSalary.value
        })
      };
    }
    return undefined;
  }
  function setHiringOrganization(org) {
    return {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }
  function setJobLocation(location) {
    if (location) {
      return {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }
    return undefined;
  }
  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        '@type': 'Country',
        name: requirements
      };
    }
    return undefined;
  }
  function setOccupationalExperienceRequirements(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'OccupationalExperienceRequirements',
        monthsOfExperience: requirements.minimumMonthsOfExperience
      };
    }
    return undefined;
  }
  function setEducationalOccupationalCredential(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'EducationalOccupationalCredential',
        credentialCategory: requirements.credentialCategory
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements),
    experienceRequirements: setOccupationalExperienceRequirements(experienceRequirements == null ? void 0 : experienceRequirements.occupational),
    educationRequirements: setEducationalOccupationalCredential(experienceRequirements == null ? void 0 : experienceRequirements.educational),
    experienceInPlaceOfEducation: experienceRequirements == null ? void 0 : experienceRequirements.experienceInPlaceOfEducation
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "JobPosting"
  }));
}

function setAddress(address) {
  if (!address) return undefined;
  if (!Array.isArray(address)) return toPostalAddress(address);
  // If array of one address, replace with single address
  if (address.length === 1) return toPostalAddress(address[0]);
  // If array, return mapped array of PostalAddresses
  return address.map(toPostalAddress);
}
function toPostalAddress(address) {
  if (typeof address === 'string') return address;
  return _extends({
    '@type': 'PostalAddress'
  }, address);
}

function setGeo(geo) {
  if (geo) {
    return _extends({}, geo, {
      '@type': 'GeoCoordinates'
    });
  }
  return undefined;
}

function setAction(action) {
  if (action) {
    return {
      '@type': action.actionType,
      name: action.actionName,
      target: action.target
    };
  }
  return undefined;
}

function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }
  return undefined;
}

function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }
    return undefined;
  }
  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return _extends({}, itemOffered, {
        '@type': 'Service'
      });
    }
    return undefined;
  }
  if (offer) {
    return _extends({}, offer, {
      '@type': 'Offer',
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    });
  }
  return undefined;
}

function setOpeningHours(openingHours) {
  if (openingHours) {
    return _extends({}, openingHours, {
      '@type': 'OpeningHoursSpecification'
    });
  }
  return undefined;
}

var _excluded$q = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "geo", "rating", "review", "action", "areaServed", "makesOffer", "openingHours", "images"]));
function LocalBusinessJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'LocalBusiness' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    geo = _ref.geo,
    rating = _ref.rating,
    review = _ref.review,
    action = _ref.action,
    areaServed = _ref.areaServed,
    makesOffer = _ref.makesOffer,
    openingHours = _ref.openingHours,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var data = _extends({}, rest, {
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "LocalBusiness"
  }));
}

var _excluded$p = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"])),
  _excluded2 = (/* unused pure expression or super */ null && (["upvoteCount"]));
function QAPageJsonLd(_ref) {
  var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'QAPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var data = _extends({}, rest, {
    mainEntity: _extends({}, mainEntity, {
      '@type': 'Question',
      author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
    }, mainEntity.acceptedAnswer && {
      acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
        '@type': 'Answer',
        author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
      })
    }, mainEntity.suggestedAnswer && {
      suggestedAnswer: mainEntity.suggestedAnswer.map(function (_ref2) {
        var _rest$author;
        var upvoteCount = _ref2.upvoteCount,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        return _extends({}, rest, {
          '@type': 'Answer',
          upvoteCount: upvoteCount || 0,
          author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
        });
      })
    })
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "QAPage"
  }));
}

function setItemListElements(items) {
  if (items && items.length) {
    return items.map(function (item) {
      return {
        '@type': 'ListItem',
        position: item.position,
        item: {
          '@id': item.item,
          name: item.name
        }
      };
    });
  }
  return undefined;
}

var _excluded$o = (/* unused pure expression or super */ null && (["type", "keyOverride", "breadcrumb"]));
function ProfilePageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'ProfilePage' : _ref$type,
    keyOverride = _ref.keyOverride,
    breadcrumb = _ref.breadcrumb,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var data = _extends({}, rest, {
    breadcrumb: Array.isArray(breadcrumb) ? {
      '@type': 'BreadcrumbList',
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "ProfilePage"
  }));
}

var _excluded$n = (/* unused pure expression or super */ null && (["type", "keyOverride", "potentialActions"]));
function SiteLinksSearchBoxJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'WebSite' : _ref$type,
    keyOverride = _ref.keyOverride,
    potentialActions = _ref.potentialActions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  function setPotentialAction(action) {
    if (action) {
      var target = action.target,
        queryInput = action.queryInput;
      return {
        '@type': 'SearchAction',
        target: target + "={" + queryInput + "}",
        'query-input': "required name=" + queryInput
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    potentialAction: potentialActions.map(setPotentialAction)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "jsonld-siteLinksSearchBox"
  }));
}

var _excluded$m = (/* unused pure expression or super */ null && (["type", "keyOverride", "authorName", "images", "yields", "category", "cuisine", "calories", "aggregateRating", "video", "ingredients", "instructions"]));
function RecipeJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Recipe' : _ref$type,
    keyOverride = _ref.keyOverride,
    authorName = _ref.authorName,
    images = _ref.images,
    yields = _ref.yields,
    category = _ref.category,
    cuisine = _ref.cuisine,
    calories = _ref.calories,
    aggregateRating = _ref.aggregateRating,
    video = _ref.video,
    ingredients = _ref.ingredients,
    instructions = _ref.instructions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var data = _extends({}, rest, {
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions ? instructions.map(setInstruction) : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "recipe"
  }));
}

function setLocation(location) {
  if (!location) {
    return undefined;
  }
  if (typeof location === 'string') {
    return location;
  }
  if ('url' in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}
function setVirtualLocation(location) {
  return _extends({}, location, {
    '@type': 'VirtualLocation'
  });
}
function setPlace(location) {
  return _extends({}, location, {
    address: setAddress(location.address),
    '@type': 'Place'
  });
}

var _excluded$l = (/* unused pure expression or super */ null && (["type"]));
function setPerformer(performer) {
  if (performer) {
    var type = performer.type,
      restPerformer = _objectWithoutPropertiesLoose(performer, _excluded$l);
    return _extends({}, restPerformer, {
      '@type': type || 'PerformingGroup'
    });
  }
  return undefined;
}

var _excluded$k = (/* unused pure expression or super */ null && (["seller"]));
function setOffers(offers) {
  function mapOffer(_ref) {
    var seller = _ref.seller,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
    return _extends({}, rest, {
      '@type': 'Offer'
    }, seller && {
      seller: {
        '@type': 'Organization',
        name: seller.name
      }
    });
  }
  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }
  return undefined;
}

function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }
  return undefined;
}

var _excluded$j = (/* unused pure expression or super */ null && (["type"]));
function setOrganizer(organizer) {
  if (organizer) {
    var type = organizer.type,
      restOrganizer = _objectWithoutPropertiesLoose(organizer, _excluded$j);
    return _extends({}, restOrganizer, {
      '@type': type || 'Person'
    });
  }
  return undefined;
}

var _excluded$i = (/* unused pure expression or super */ null && (["type", "keyOverride", "location", "images", "offers", "aggregateOffer", "performers", "organizer", "eventStatus", "eventAttendanceMode"]));
function EventJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Event' : _ref$type,
    keyOverride = _ref.keyOverride,
    location = _ref.location,
    images = _ref.images,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    performers = _ref.performers,
    organizer = _ref.organizer,
    eventStatus = _ref.eventStatus,
    eventAttendanceMode = _ref.eventAttendanceMode,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var data = _extends({}, rest, {
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: eventStatus ? "https://schema.org/" + eventStatus : undefined,
    eventAttendanceMode: eventAttendanceMode ? "https://schema.org/" + eventAttendanceMode : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Event"
  }));
}

function setContactPoint(contactPoint) {
  if (contactPoint) {
    return _extends({}, contactPoint, {
      '@type': 'ContactPoint'
    });
  }
  return undefined;
}

var _excluded$h = (/* unused pure expression or super */ null && (["type", "keyOverride", "contactPoint"]));
function CorporateContactJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var data = _extends({}, rest, {
    contactPoint: contactPoint.map(setContactPoint)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CorporateContact"
  }));
}

function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return _extends({}, creativeWork, {
      '@type': 'CreativeWork'
    });
  }
  return undefined;
}

var _excluded$g = (/* unused pure expression or super */ null && (["type", "keyOverride", "hasPart"]));
function CollectionPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CollectionPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    hasPart = _ref.hasPart,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var data = _extends({}, rest, {
    hasPart: hasPart.map(setCreativeWork)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CollectionPage"
  }));
}

function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      '@type': 'Organization',
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }
  return undefined;
}

function setBrand(brand) {
  if (brand) {
    return {
      '@type': 'Brand',
      name: brand
    };
  }
  return undefined;
}

var _excluded$f = (/* unused pure expression or super */ null && (["type", "keyOverride", "images", "brand", "reviews", "aggregateRating", "manufacturerLogo", "manufacturerName", "offers", "aggregateOffer", "productName"]));
function ProductJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Product' : _ref$type,
    keyOverride = _ref.keyOverride,
    images = _ref.images,
    brand = _ref.brand,
    reviews = _ref.reviews,
    aggregateRating = _ref.aggregateRating,
    manufacturerLogo = _ref.manufacturerLogo,
    manufacturerName = _ref.manufacturerName,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    productName = _ref.productName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var data = _extends({}, rest, {
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({
      manufacturerLogo: manufacturerLogo,
      manufacturerName: manufacturerName
    }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Product"
  }));
}

var _excluded$e = (/* unused pure expression or super */ null && (["type", "keyOverride", "priceCurrency", "price", "aggregateRating", "review"]));
function SoftwareAppJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'SoftwareApplication' : _ref$type,
    keyOverride = _ref.keyOverride,
    priceCurrency = _ref.priceCurrency,
    price = _ref.price,
    aggregateRating = _ref.aggregateRating,
    review = _ref.review,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var data = _extends({}, rest, {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "SoftwareApp"
  }));
}

var _excluded$d = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function VideoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Video' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var data = setVideo(rest, true);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Video"
  }));
}

function setProducer(producer) {
  if (producer) {
    return {
      '@type': 'Organization',
      sameAs: producer.url,
      name: producer.name
    };
  }
  return undefined;
}

function setProvider(provider) {
  if (provider) {
    return {
      '@type': provider.type || 'Organization',
      name: provider.name,
      sameAs: provider.url
    };
  }
  return undefined;
}

var _excluded$c = (/* unused pure expression or super */ null && (["type", "keyOverride", "aggregateRating", "trailer", "reviews", "image", "authorName", "provider", "producerName", "producerUrl", "offers", "operatingSystemName", "platformName", "translatorName", "languageName", "genreName", "publisherName"]));
function VideoGameJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'VideoGame' : _ref$type,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    trailer = _ref.trailer,
    reviews = _ref.reviews,
    image = _ref.image,
    authorName = _ref.authorName,
    provider = _ref.provider,
    producerName = _ref.producerName,
    producerUrl = _ref.producerUrl,
    offers = _ref.offers,
    operatingSystemName = _ref.operatingSystemName,
    platformName = _ref.platformName,
    translatorName = _ref.translatorName,
    languageName = _ref.languageName,
    genreName = _ref.genreName,
    publisherName = _ref.publisherName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var data = _extends({}, rest, {
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({
      name: producerName,
      url: producerUrl
    }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "VideoGame"
  }));
}

function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map(function (contactPoint) {
      return _extends({
        '@type': 'ContactPoint'
      }, contactPoint);
    });
  }
  return undefined;
}

var _excluded$b = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "contactPoints", "contactPoint"]));
function OrganizationJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    contactPoints = _ref.contactPoints,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var data = _extends({}, rest, {
    address: setAddress(address),
    contactPoint: setContactPoints(contactPoint || contactPoints)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "organization"
  }));
}

function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map(function (question) {
      return {
        '@type': 'Question',
        name: question.questionName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.acceptedAnswerText
        }
      };
    });
  }
  return undefined;
}

var _excluded$a = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"]));
function FAQPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'FAQPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var data = _extends({}, rest, {
    mainEntity: setQuestions(mainEntity)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "faq-page"
  }));
}

var _excluded$9 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function LogoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "Logo"
  }));
}

var _excluded$8 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function DatasetJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Dataset' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "dataset"
  }));
}

var _excluded$7 = (/* unused pure expression or super */ null && (["type", "keyOverride", "courseName", "provider"]));
function CourseJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Course' : _ref$type,
    keyOverride = _ref.keyOverride,
    courseName = _ref.courseName,
    provider = _ref.provider,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var data = _extends({
    name: courseName
  }, rest, {
    provider: setProvider(provider)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "course"
  }));
}

var _excluded$6 = (/* unused pure expression or super */ null && (["type", "keyOverride", "itemListElements"]));
function BreadCrumbJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'BreadcrumbList' : _ref$type,
    keyOverride = _ref.keyOverride,
    itemListElements = _ref.itemListElements,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var data = _extends({}, rest, {
    itemListElement: setItemListElements(itemListElements)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "breadcrumb"
  }));
}

var _excluded$5 = (/* unused pure expression or super */ null && (["type", "id", "keyOverride", "aggregateRating"]));
function BrandJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Brand' : _ref$type,
    id = _ref.id,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var data = _extends({
    aggregateRating: setAggregateRating(aggregateRating),
    '@id': id
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "brand"
  }));
}

var _excluded$4 = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "datePublished", "dateModified", "authorName", "publisherName", "publisherLogo", "description", "isAccessibleForFree"]));
function ArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Article' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    _ref$publisherName = _ref.publisherName,
    publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName,
    _ref$publisherLogo = _ref.publisherLogo,
    publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo,
    description = _ref.description,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var data = _extends({
    datePublished: datePublished,
    description: description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    isAccessibleForFree: isAccessibleForFree
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "article"
  }));
}

function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return _extends({
      '@type': (reviewedBy == null ? void 0 : reviewedBy.type) || 'Organization'
    }, reviewedBy);
  }
  return undefined;
}

var _excluded$3 = (/* unused pure expression or super */ null && (["keyOverride", "reviewedBy"]));
function WebPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    reviewedBy = _ref.reviewedBy,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var data = _extends({}, rest, {
    reviewedBy: setReviewedBy(reviewedBy)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    keyOverride: keyOverride
  }, data, {
    type: "WebPage",
    scriptKey: "WebPage"
  }));
}

var _excluded$2 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function SocialProfileJsonLd(_ref) {
  var type = _ref.type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "social"
  }));
}

function setCost(cost) {
  if (cost) {
    return _extends({}, cost, {
      '@type': 'MonetaryAmount'
    });
  }
  return undefined;
}

function setSupply(supply) {
  if (supply) {
    return supply.map(function (supplyItem) {
      return {
        '@type': 'HowToSupply',
        name: supplyItem
      };
    });
  }
  return undefined;
}

function setTool(tool) {
  if (tool) {
    return tool.map(function (toolItem) {
      return {
        '@type': 'HowToTool',
        name: toolItem
      };
    });
  }
  return undefined;
}

function setStep(step) {
  if (step) {
    return step.map(function (stepElement) {
      var itemListElement = stepElement.itemListElement,
        image = stepElement.image;
      var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function (_ref) {
        var type = _ref.type,
          text = _ref.text;
        return {
          '@type': type,
          text: text
        };
      });
      return _extends({}, stepElement, {
        '@type': 'HowToStep',
        itemListElement: currentListElements,
        image: setImage(image)
      });
    });
  }
  return undefined;
}

var _excluded$1 = (/* unused pure expression or super */ null && (["type", "keyOverride", "image", "estimatedCost", "supply", "tool", "step"]));
function howToJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'HowTo' : _ref$type,
    keyOverride = _ref.keyOverride,
    image = _ref.image,
    estimatedCost = _ref.estimatedCost,
    supply = _ref.supply,
    tool = _ref.tool,
    step = _ref.step,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var data = _extends({}, rest, {
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "howTo"
  }));
}

var _excluded = (/* unused pure expression or super */ null && (["keyOverride", "images"]));
function ImageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({}, rest, {
    type: "ImageObject",
    keyOverride: keyOverride,
    dataArray: images,
    scriptKey: "image"
  }));
}




/***/ }),

/***/ 12041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88381)


/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(22987);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21218);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_report__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80162);






var initialState = {
    error: undefined
};
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.resetErrorBoundary = function() {
            _this.setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState));
            if (_this.props.onReset) _this.props.onReset();
        };
        _this.state = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState);
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .errorReport */ .Y)("at GlobalErrorBoundary ".concat(error.message), {
            errorInfo: errorInfo
        }, error);
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, renderFallback = _props.renderFallback;
        var error = this.state.error;
        if (error) {
            return renderFallback({
                error: error,
                reset: this.resetErrorBoundary
            });
        }
        return children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        return {
            error: error
        };
    };
    return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBoundary);


/***/ }),

/***/ 17986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


/**
 *
 * @param name string
 * @param size number (optional)
 * @param color number (optional)
 * @param filled number (optional)
 * @param rotate number (optional)
 * @param onClick () => void (optional)
 * @default
 * size 24px
 * color theme.color.gray900
 * filled false
 *
 * @example
 * <MaterialIcon name={'thumb_down'} size={32} filled />
 *
 */ var MaterialIcon = function(param) {
    var name = param.name, size = param.size, color = param.color, filled = param.filled, onClick = param.onClick, _rotate = param.rotate, rotate = _rotate === void 0 ? 0 : _rotate, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        width: size,
        rotate: rotate,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Icon, {
            className: "material-symbols-rounded ".concat(className),
            size: size,
            color: color,
            filled: filled,
            translate: "no",
            children: name
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialIcon);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a0e54b90-0"
})(_templateObject(), function(props) {
    return props.width && "width: ".concat(props.width, "px;");
}, function(props) {
    return props.rotate && "rotate: ".concat(props.rotate, "deg;");
});
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-a0e54b90-1"
})(_templateObject1(), function(props) {
    return props.size && "font-size: ".concat(props.size, "px;");
}, function(props) {
    return props.color && "color: ".concat(props.color, ";");
}, function(props) {
    return props.filled && "font-variation-settings: 'FILL' ".concat(props.filled ? 1 : 0, ";");
});


/***/ }),

/***/ 47641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "aA": function() { return /* binding */ FloatingActionButton; },
/* harmony export */   "qY": function() { return /* binding */ DefaultButtonStyled; }
/* harmony export */ });
/* unused harmony export LabelButton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background-color: ",
        ";\n  padding: 14px 12px;\n  border-radius: 8px;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  width: 100%;\n  padding: 10px 16px;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 10;\n  position: fixed;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var DefaultButtonStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-3be3430-0"
})(_templateObject());
var LabelButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-3be3430-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var PrimaryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(DefaultButtonStyled).withConfig({
    componentId: "sc-3be3430-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary500;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var FloatingActionButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(DefaultButtonStyled).withConfig({
    componentId: "sc-3be3430-3"
})(_templateObject3());


/***/ }),

/***/ 23155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var WarningCircle = function(param) {
    var _width = param.width, width = _width === void 0 ? 56 : _width, _height = param.height, height = _height === void 0 ? 56 : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
                fill: "#FCC419"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31 15.5C31 13.8432 29.6568 12.5 28 12.5C26.3432 12.5 25 13.8432 25 15.5V28.5C25 30.1568 26.3432 31.5 28 31.5C29.6568 31.5 31 30.1568 31 28.5V15.5ZM28 43.5C30.2091 43.5 32 41.7092 32 39.5C32 37.2909 30.2091 35.5 28 35.5C25.7909 35.5 24 37.2909 24 39.5C24 41.7092 25.7909 43.5 28 43.5Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WarningCircle);


/***/ }),

/***/ 39192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_WarningCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23155);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 96px 0 136px 0;\n\n  & > svg {\n    margin-bottom: 32px;\n  }\n  & > h1 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 10px;\n  }\n\n  & > p {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 24px;\n  }\n\n  & > button {\n    border-radius: 8px;\n    width: fit-content;\n    padding: 10px 20px;\n    ",
        ";\n    color: ",
        ";\n    border: none;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var RootErrorFallback = function(props) {
    var reset = props.reset;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_WarningCircle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                children: "에러가 발생했어요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    "일시적인 오류로 인해 페이지 접근을 할 수 없어요.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "잠시 후 다시 접속해 보세요."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                onClick: reset,
                children: "홈 화면으로 이동"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RootErrorFallback);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f30a6f4d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});


/***/ }),

/***/ 83651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var InnerMobileWebLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1950), __webpack_require__.e(7141)]).then(__webpack_require__.bind(__webpack_require__, 47141));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47141)
            ];
        }
    },
    ssr: true
});
var InnerWebLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9040), __webpack_require__.e(1950), __webpack_require__.e(7804)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: true
});
var InnerWebViewLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9805).then(__webpack_require__.bind(__webpack_require__, 29805));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29805)
            ];
        }
    },
    ssr: true
});
var DefaultLayout = function(param) {
    var children = param.children, client = param.client, userAgent = param.userAgent;
    if (client.isWebView) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerWebViewLayout, {
            children: children
        });
    }
    if (client.isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerMobileWebLayout, {
            client: client,
            userAgent: userAgent,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerWebLayout, {
        client: client,
        userAgent: userAgent,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 26326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ login_modal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/icon/BrandDoctornow.tsx



var BrandDoctorNowIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.gray700 */.Z.color.gray700 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.25214 1.5H8.59874C12.1886 1.5 15.0987 4.41015 15.0987 8C15.0987 11.5899 12.1886 14.5 8.59874 14.5H5.25214C4.0424 14.5 3.0617 13.5193 3.0617 12.3096V11.511C2.72126 11.2629 2.5 10.8611 2.5 10.4076C2.5 9.65422 3.11077 9.04345 3.8642 9.04345C4.61762 9.04345 5.2284 9.65422 5.2284 10.4076C5.2284 10.8959 4.97194 11.3242 4.58639 11.5652V12.3096C4.58639 12.6772 4.88446 12.9753 5.25214 12.9753H8.59874C11.3465 12.9753 13.574 10.7478 13.574 8C13.574 5.25221 11.3465 3.02469 8.59874 3.02469H5.25214C4.88446 3.02469 4.58639 3.32276 4.58639 3.69044V4.43516C4.97194 4.6762 5.2284 5.10452 5.2284 5.59273C5.2284 6.34615 4.61762 6.95693 3.8642 6.95693C3.11077 6.95693 2.5 6.34615 2.5 5.59273C2.5 5.13926 2.72126 4.73747 3.0617 4.48942V3.69044C3.0617 2.48069 4.0424 1.5 5.25214 1.5ZM9.88244 6.95649H10.5244C11.0562 6.95649 11.4873 7.38762 11.4873 7.91945C11.4873 8.45128 11.0562 8.88241 10.5244 8.88241H9.8824V9.52439C9.8824 10.0562 9.45127 10.4874 8.91944 10.4874C8.38761 10.4874 7.95648 10.0562 7.95648 9.52439V8.88245H7.31455C6.78272 8.88245 6.35158 8.45132 6.35158 7.91949C6.35158 7.38766 6.78272 6.95652 7.31455 6.95652H7.95652V6.31455C7.95652 5.78272 8.38765 5.35159 8.91948 5.35159C9.45131 5.35159 9.88244 5.78272 9.88244 6.31455V6.95649Z",
            fill: color
        })
    });
};
/* harmony default export */ var BrandDoctornow = (BrandDoctorNowIcon);

;// CONCATENATED MODULE: ./src/components/atom/icon/CloseIcon.tsx


var CloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3117_516)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.573744 0.00980614C0.425622 0.0377741 0.303741 0.105013 0.19448 0.219029C0.107107 0.310203 0.0523231 0.406305 0.0206047 0.524033C0.00564793 0.57954 0.00401593 0.596929 0.00401593 0.700795C0.00401593 0.805217 0.00560953 0.821985 0.0210399 0.879995C0.0413471 0.956347 0.0887007 1.05504 0.134646 1.11679C0.153981 1.14278 1.60367 2.59763 3.58635 4.58079L7.00471 8L3.58635 11.4192C1.60367 13.4024 0.153981 14.8572 0.134646 14.8832C0.0887007 14.9449 0.0413471 15.0436 0.0210399 15.12C0.00560953 15.178 0.00401593 15.1948 0.00401593 15.2992C0.00401593 15.4031 0.00564793 15.4204 0.0206047 15.476C0.0856223 15.7173 0.28207 15.9143 0.522006 15.9788C0.579766 15.9944 0.596042 15.9959 0.700752 15.9959C0.805174 15.9959 0.821942 15.9943 0.879952 15.9789C0.956304 15.9586 1.055 15.9112 1.11675 15.8653C1.14274 15.846 2.59759 14.3963 4.58075 12.4136L7.99995 8.99523L11.4192 12.4136C13.4023 14.3963 14.8572 15.846 14.8832 15.8653C14.9449 15.9112 15.0436 15.9586 15.12 15.9789C15.178 15.9943 15.1947 15.9959 15.2992 15.9959C15.4039 15.9959 15.4201 15.9944 15.4779 15.9788C15.6756 15.9257 15.8529 15.7752 15.94 15.5867C15.9634 15.536 15.9936 15.4298 15.9936 15.398C15.9936 15.3881 15.9964 15.3782 16 15.376C16.0037 15.3737 16.0064 15.3385 16.0064 15.292C16.0064 15.2403 16.0041 15.2134 16 15.216C15.9962 15.2183 15.9936 15.2121 15.9936 15.2012C15.9936 15.1909 15.9864 15.154 15.9777 15.1192C15.9589 15.0442 15.9123 14.9464 15.8653 14.8832C15.8459 14.8572 14.3962 13.4024 12.4136 11.4192L8.99519 8L12.4136 4.58079C14.3962 2.59763 15.8459 1.14278 15.8653 1.11679C15.9123 1.05361 15.9589 0.955739 15.9777 0.880776C15.9864 0.846004 15.9936 0.809454 15.9936 0.799553C15.9936 0.789653 15.9964 0.779771 16 0.777595C16.0037 0.775297 16.0064 0.740072 16.0064 0.69364C16.0064 0.641934 16.0041 0.615041 16 0.617595C15.9962 0.619886 15.9936 0.613665 15.9936 0.602792C15.9936 0.56612 15.9613 0.457621 15.9332 0.399905C15.8437 0.215899 15.6719 0.0734605 15.4759 0.0206477C15.4204 0.00569094 15.403 0.00405894 15.2992 0.00405894C15.1947 0.00405894 15.178 0.00565254 15.12 0.0210829C15.0436 0.0413901 14.9449 0.0887437 14.8832 0.134689C14.8572 0.154024 13.4023 1.60371 11.4192 3.58639L7.99995 7.00476L4.58075 3.58639C2.59759 1.60371 1.14274 0.154024 1.11675 0.134689C1.05426 0.0881869 0.955792 0.0411597 0.879952 0.0215949C0.798499 0.000577338 0.652406 -0.00504826 0.573744 0.00980614ZM0.00244153 0.700795C0.00244793 0.746555 0.00347193 0.764436 0.00470073 0.740526C0.00593593 0.716622 0.00592953 0.679182 0.00468153 0.657326C0.00343993 0.635477 0.00242873 0.655035 0.00244153 0.700795ZM0.00244153 15.2992C0.00244793 15.345 0.00347193 15.3628 0.00470073 15.3389C0.00593593 15.315 0.00592953 15.2776 0.00468153 15.2557C0.00343993 15.2339 0.00242873 15.2534 0.00244153 15.2992Z",
                    fill: "#3D4551"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3117_516",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_CloseIcon = (CloseIcon);

;// CONCATENATED MODULE: ./src/components/atom/icon/InfoIcon.tsx


var InfoIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "#8D9297" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_604_7029)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.70589 0.0037226C7.37309 0.0197098 7.16342 0.0379306 6.89629 0.0740906C5.8026 0.222135 4.72092 0.613463 3.76989 1.20518C2.68449 1.88048 1.74865 2.83911 1.1009 3.93917C0.966816 4.16688 0.785171 4.52054 0.682086 4.75461C0.316941 5.58371 0.102438 6.41796 0.0261888 7.30557C0.0042624 7.5608 0.0003776 7.66523 0.0003776 7.99997C0.0003776 8.38046 0.0099008 8.56948 0.0453568 8.89277C0.174086 10.0664 0.572666 11.2152 1.2023 12.2272C1.73973 13.091 2.46096 13.8659 3.29309 14.4736C3.93872 14.9451 4.68953 15.3318 5.45949 15.5894C6.06545 15.7921 6.66422 15.916 7.30269 15.9709C7.55793 15.9928 7.66236 15.9967 7.99709 15.9967C8.37758 15.9967 8.56661 15.9872 8.88989 15.9517C10.0635 15.823 11.2124 15.4243 12.2243 14.7948C13.028 14.2947 13.7537 13.6367 14.3433 12.8736C14.8769 12.1829 15.3055 11.3776 15.5865 10.5376C15.7848 9.94484 15.9081 9.3564 15.9653 8.73014C15.9769 8.60255 15.9906 8.37658 15.9907 8.31234C15.9907 8.27792 15.9935 8.24856 15.9971 8.24637C16.0012 8.24384 16.0035 8.1523 16.0035 7.99281C16.0035 7.82804 16.0013 7.74455 15.9971 7.74717C15.993 7.7497 15.9907 7.72856 15.9907 7.68834C15.9906 7.58311 15.9709 7.30934 15.9488 7.10717C15.8206 5.93509 15.4214 4.78457 14.7919 3.77277C14.2545 2.90911 13.5331 2.13395 12.7011 1.52635C12.0553 1.05476 11.3082 0.669937 10.5347 0.4105C9.87775 0.190167 9.24738 0.0667946 8.51584 0.0153962C8.38819 0.0064298 7.82005 -0.0017558 7.70589 0.0037226ZM7.86909 1.40606C6.50988 1.42624 5.15928 1.88743 4.06109 2.70636C3.55517 3.08363 3.08156 3.55722 2.70344 4.06397C2.28277 4.62772 1.95441 5.26082 1.72918 5.94237C1.54929 6.48676 1.44685 7.03312 1.41121 7.63837C1.39601 7.89653 1.40314 8.30672 1.42778 8.59197C1.51682 9.62289 1.85922 10.6339 2.42153 11.5264C2.76582 12.0728 3.21761 12.5916 3.73149 13.0308C4.75485 13.9053 6.06371 14.4534 7.40509 14.5693C7.78348 14.602 8.2107 14.602 8.58909 14.5693C9.9303 14.4534 11.2395 13.9052 12.2627 13.0308C12.5307 12.8017 12.7988 12.5336 13.0279 12.2656C13.8483 11.3055 14.3823 10.0943 14.5404 8.83517C14.5976 8.37983 14.6065 7.88607 14.5662 7.40797C14.4594 6.14084 13.9512 4.87582 13.1496 3.88157C12.8862 3.55482 12.583 3.24287 12.2627 2.96918C11.2401 2.09531 9.93612 1.54878 8.59229 1.43079C8.38673 1.41274 8.09375 1.40272 7.86909 1.40606ZM7.87661 3.37325C7.7297 3.38743 7.57841 3.43072 7.44213 3.49758C7.08825 3.67116 6.84094 3.99026 6.75782 4.38055C6.73547 4.4855 6.72936 4.69502 6.74542 4.80637C6.80566 5.22436 7.06641 5.58309 7.44349 5.76676C7.79373 5.93736 8.20045 5.93736 8.55069 5.76676C8.92534 5.58427 9.18799 5.22462 9.248 4.81195C9.26093 4.72297 9.26092 4.54692 9.24796 4.45402C9.21193 4.19572 9.09459 3.95371 8.91165 3.76045C8.64792 3.48183 8.25898 3.33634 7.87661 3.37325ZM7.94269 4.50479C7.88873 4.52954 7.86001 4.57318 7.86005 4.63037C7.8601 4.71775 7.92127 4.77314 8.0106 4.76667C8.08347 4.76141 8.13494 4.70459 8.13409 4.63037C8.13384 4.60868 8.12926 4.58355 8.12357 4.57263C8.09908 4.52572 8.04716 4.49305 7.99709 4.49305C7.98125 4.49305 7.95677 4.49833 7.94269 4.50479ZM6.7185 6.74601C6.66122 6.75345 6.57535 6.77588 6.52375 6.79688C6.45254 6.82586 6.41065 6.854 6.3524 6.91197C6.23452 7.0293 6.18269 7.16961 6.17512 7.39197C6.16728 7.62269 6.20749 7.78467 6.30467 7.9138C6.3838 8.01894 6.49859 8.08569 6.66279 8.12203C6.72202 8.13515 6.74735 8.13639 7.00989 8.13904L7.29309 8.1419V9.40533V10.6688L6.75069 10.6688C6.1802 10.6688 6.14445 10.6704 6.04215 10.6988C5.88407 10.7428 5.75792 10.8417 5.69063 10.9745C5.66575 11.0236 5.63789 11.1112 5.62506 11.1808C5.60906 11.2675 5.60912 11.4673 5.62518 11.5552C5.67684 11.8377 5.82404 11.9906 6.10396 12.0526L6.16989 12.0672H7.99709H9.82429L9.89022 12.0526C10.1701 11.9906 10.3173 11.8377 10.369 11.5552C10.3851 11.4673 10.3851 11.2675 10.3691 11.1808C10.3144 10.8844 10.1471 10.7233 9.84723 10.6781C9.79745 10.6706 9.68371 10.6688 9.24349 10.6688L8.70109 10.6688L8.70103 9.04157C8.70095 7.40502 8.69989 7.31995 8.67815 7.21661C8.62194 6.9494 8.44921 6.79147 8.16658 6.74887C8.11253 6.74072 7.99921 6.73936 7.43069 6.74002C7.06109 6.74044 6.7406 6.74314 6.7185 6.74601ZM0 7.99997C0 8.13901 0.0008448 8.19588 0.0018816 8.12637C0.002912 8.05685 0.002912 7.94308 0.0018816 7.87357C0.0008448 7.80405 0 7.86093 0 7.99997Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_604_7029",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_InfoIcon = (InfoIcon);

;// CONCATENATED MODULE: ./src/components/atom/icon/arrow/ArrowsLeft.tsx



var ArrowsLeft = function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.gray500 */.Z.color.gray500 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1960_1454)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.56633 3.37064C4.48406 3.37795 4.3901 3.40444 4.31793 3.44066C4.21943 3.49009 4.2604 3.45008 2.1835 5.52555C0.950966 6.75725 0.15711 7.55524 0.133763 7.58598C0.0855582 7.64946 0.0437534 7.73532 0.021091 7.81741C0.00473901 7.87663 0.00342061 7.89025 0.00342061 7.99981C0.00342061 8.10936 0.00473901 8.12299 0.021091 8.18221C0.0437534 8.26429 0.0855582 8.35015 0.133763 8.41363C0.15711 8.44438 0.950966 9.24237 2.1835 10.4741C4.2604 12.5495 4.21943 12.5095 4.31793 12.5589C4.4339 12.6172 4.57034 12.6411 4.7049 12.6269C4.86567 12.6099 4.9941 12.5511 5.10976 12.4414C5.25974 12.2992 5.33113 12.1341 5.33113 11.9294C5.33113 11.7788 5.29844 11.6674 5.21744 11.5422C5.19488 11.5073 4.88005 11.1888 3.79267 10.1006L2.39687 8.70388L8.896 8.70211C15.1562 8.70041 15.3969 8.69992 15.4431 8.6887C15.5898 8.6531 15.6887 8.59849 15.7915 8.49625C15.8561 8.4321 15.9109 8.35426 15.9422 8.28226C15.9643 8.23133 15.9935 8.12473 15.9935 8.09499C15.9935 8.08487 15.9964 8.07661 15.9999 8.07661C16.0039 8.07661 16.0063 8.04414 16.0062 7.99181C16.0062 7.93469 16.0041 7.91014 15.9999 7.91661C15.9952 7.92393 15.9937 7.92148 15.9936 7.90623C15.9935 7.87484 15.9647 7.76918 15.9422 7.71735C15.9109 7.64535 15.8561 7.56751 15.7915 7.50336C15.6887 7.40112 15.5898 7.34651 15.4431 7.31092C15.3969 7.29969 15.1562 7.2992 8.896 7.2975L2.39687 7.29574L3.79267 5.89897C4.88005 4.81085 5.19488 4.49231 5.21744 4.45741C5.29844 4.33216 5.33113 4.22082 5.33113 4.07021C5.33113 3.86553 5.25974 3.70041 5.10976 3.55819C4.96249 3.41854 4.77096 3.35244 4.56633 3.37064ZM0.00244141 7.99981C0.00244141 8.04733 0.00344621 8.06677 0.00468141 8.04301C0.00591021 8.01924 0.00591021 7.98037 0.00468141 7.95661C0.00344621 7.93284 0.00244141 7.95229 0.00244141 7.99981Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1960_1454",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var arrow_ArrowsLeft = (ArrowsLeft);

;// CONCATENATED MODULE: ./src/components/atom/icon/login/Naver.tsx


var Naver = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.5 2V14H14.5V2H2.5ZM11.8281 11.0625H9.54688L7.4375 7.98438V11.0625H5.17188V4.95312H7.45312L9.5625 8.03125V4.95312H11.8281V11.0625Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var login_Naver = (Naver);

;// CONCATENATED MODULE: ./src/components/atom/icon/login/kakao.tsx


var KakaoLoginIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.17188 2C7.25521 2 6.39062 2.14062 5.57812 2.42188C4.76562 2.70312 4.05729 3.08333 3.45312 3.5625C2.84896 4.04167 2.36979 4.60417 2.01562 5.25C1.67188 5.89583 1.5 6.58333 1.5 7.3125C1.5 7.78125 1.57292 8.23438 1.71875 8.67188C1.86458 9.09896 2.06771 9.50521 2.32812 9.89062C2.59896 10.2656 2.92188 10.6146 3.29688 10.9375C3.67188 11.25 4.08333 11.526 4.53125 11.7656L4.03125 14.375L6.92188 12.5312C7.11979 12.5625 7.32292 12.5885 7.53125 12.6094C7.73958 12.6198 7.95312 12.625 8.17188 12.625C9.08854 12.625 9.95312 12.4896 10.7656 12.2188C11.5781 11.9375 12.2865 11.5573 12.8906 11.0781C13.4948 10.5885 13.9688 10.026 14.3125 9.39062C14.6667 8.74479 14.8438 8.05208 14.8438 7.3125C14.8438 6.58333 14.6667 5.89583 14.3125 5.25C13.9688 4.60417 13.4948 4.04167 12.8906 3.5625C12.2865 3.08333 11.5781 2.70312 10.7656 2.42188C9.95312 2.14062 9.08854 2 8.17188 2Z",
            fill: "#2D2E2F"
        })
    });
};
/* harmony default export */ var kakao = (KakaoLoginIcon);

// EXTERNAL MODULE: ./src/constants/SocialOAuth.ts
var SocialOAuth = __webpack_require__(65442);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/molecules/login-modal/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 400px;\n  padding: 32px;\n  background-color: white;\n\n  & > h1 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 4px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n\n  & > p:nth-of-type(1) {\n    ",
        ";\n    color: ",
        ";\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n\n  & > button {\n    padding: 18px 0;\n    color: ",
        ";\n    svg {\n      margin-right: 8px;\n    }\n  }\n\n  @media screen and (max-width: ",
        ") {\n    padding: 24px;\n    max-width: 312px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  margin-bottom: 4px;\n\n  & > button {\n    padding: 8px;\n    border: none;\n    border-radius: 4px;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    &:active {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  border: none;\n  background: #ffe337;\n  border-radius: 12px;\n  margin-bottom: 8px;\n  margin-top: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #04cf00;\n  margin-top: 0;\n  color: ",
        " !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 12px;\n  margin-top: 0;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n\n  & > div {\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: ",
        ";\n  padding: 17px 0;\n  margin-bottom: 16px;\n  margin-top: 8px;\n  color: ",
        ";\n  border-radius: 12px;\n  width: 100%;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: 8px;\n  padding: 16px 23px 16px 16px;\n  border: none;\n  background-color: ",
        ";\n  ",
        ";\n  color: ",
        ";\n  margin-bottom: 24px;\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 32px;\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  margin-top: 16px;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:active {\n    background-color: ",
        ";\n  }\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




















var LoginType = {
    SNS: "sns",
    EMAIL: "email"
};
var LoginModal = function(param) {
    var _isWritePage = param.isWritePage, isWritePage = _isWritePage === void 0 ? false : _isWritePage, onClick = param.onClick, redirectUrl = param.redirectUrl, trackInfo = param.trackInfo, customTitle = param.customTitle, customMessage = param.customMessage;
    var ref = (0,react.useState)(LoginType.SNS), loginType = ref[0], setLoginType = ref[1];
    var router = (0,next_router.useRouter)();
    var pathName = router.asPath;
    var setPageName = (0,es.useSetRecoilState)(auth/* UrlState */.pp);
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var dynamicLinkOptions = (0,react.useMemo)(function() {
        if (trackInfo) {
            return (0,_object_spread/* default */.Z)({
                campaign: trackInfo.campaign,
                content: trackInfo.content,
                term: trackInfo.buttonText
            }, trackInfo.sub_id && {
                sub_id: trackInfo.sub_id
            }, trackInfo.sub_id_1 && {
                sub_id_1: trackInfo.sub_id_1
            }, trackInfo.sub_id_2 && {
                sub_id_2: trackInfo.sub_id_2
            }, trackInfo.sub_id_3 && {
                sub_id_3: trackInfo.sub_id_3
            });
        }
        if (!common/* isServer */.sk && (0,RNPlugins/* isMobile */.tq)(window.navigator.userAgent)) {
            return {
                campaign: "web_all",
                content: "web_drawer_mdl_all",
                term: "닥터나우 앱 다운로드"
            };
        }
        return {
            campaign: "web_service",
            content: "web_lnb_mdl_service",
            term: "닥터나우 앱 다운로드"
        };
    }, [
        common/* isServer */.sk,
        trackInfo
    ]);
    var title = (0,react.useMemo)(function() {
        if (customTitle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "whitespace-pre-wrap",
                children: customTitle
            });
        }
        if (loginType === LoginType.SNS) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                children: [
                    "로그인 및 회원가입을",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "클릭 한 번으로 시작하세요."
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "이메일로 로그인하기"
        });
    }, [
        loginType,
        customTitle
    ]);
    var onClickLoginType = function(type) {
        setLoginType(type);
    };
    var onClickClose = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: "login_exit_click"
        });
        if (isWritePage) {
            router.back();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var onClickLoginLog = function(eventName) {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: eventName
        });
    };
    (0,react.useEffect)(function() {
        setPageName(redirectUrl || pathName);
    }, [
        pathName,
        setPageName,
        redirectUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: onClickClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_CloseIcon, {})
                })
            }),
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: customMessage || "기존 닥터나우 앱과 동일한 아이디를 사용해요."
            }),
            loginType === LoginType.SNS ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: SocialOAuth/* KAKAO_AUTH_URL */.du,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(KaKao, {
                            onClick: function() {
                                return onClickLoginLog("kakao_login_click");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(kakao, {}),
                                "카카오톡으로 시작하기"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: SocialOAuth/* NAVER_AUTH_URL */.l7,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NaverButton, {
                            onClick: function() {
                                return onClickLoginLog("naver_login_click");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(login_Naver, {}),
                                "네이버로 시작하기"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppDownload, {
                        onClick: function() {
                            onClickLoginLog("app_download_click");
                            airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, dynamicLinkOptions);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandDoctornow, {}),
                            "닥터나우 앱 다운로드"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Preparation, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_InfoIcon, {}),
                            "이메일, 애플 로그인은 앱을 이용해 주세요."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                        children: "로그인"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_InfoIcon, {}),
                            "이메일 계정의 회원가입과 아이디/비밀번호 찾기는 닥터나우 앱을 이용해주세요."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackButton, {
                        type: "button",
                        onClick: function() {
                            return onClickLoginType(LoginType.SNS);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_ArrowsLeft, {}),
                            "이전으로 돌아가기"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var login_modal = (LoginModal);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d91eb45-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, layout/* Tablet */.YD);
var Close = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d91eb45-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var KaKao = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8d91eb45-2"
})(_templateObject2());
var NaverButton = (0,styled_components_browser_esm/* default */.ZP)(KaKao).withConfig({
    componentId: "sc-8d91eb45-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});
var AppDownload = (0,styled_components_browser_esm/* default */.ZP)(KaKao).withConfig({
    componentId: "sc-8d91eb45-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray50;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-8d91eb45-5"
})(_templateObject5());
var LoginButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8d91eb45-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.color.primary500;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary700;
});
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d91eb45-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var Preparation = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8d91eb45-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var BackButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8d91eb45-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.color.gray200;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});


/***/ }),

/***/ 48785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ overlay; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/molecules/overlay/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc880c2b-0"
})(_templateObject(), function(param) {
    var index = param.index;
    return index + 300;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});

// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/molecules/overlay/index.tsx





var Overlay = function(props) {
    var _index = props.index, index = _index === void 0 ? 1 : _index, children = props.children, className = props.className, _backgroundColor = props.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.dimmed40 */.Z.color.dimmed40 : _backgroundColor, onClickOverlay = props.onClickOverlay;
    var handleClickOverlay = function(event) {
        if (event.currentTarget === event.target && onClickOverlay) {
            onClickOverlay();
        } else {
            event.stopPropagation();
        }
    };
    (0,react.useEffect)(function() {
        document.body.style.cssText = "\n      overflow: hidden;\n    ";
        return function() {
            document.body.style.cssText = "";
        };
    }, []);
    if (false) {}
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayContainer, {
        className: className,
        index: index,
        onClick: function(event) {
            return handleClickOverlay(event);
        },
        backgroundColor: backgroundColor,
        children: children
    }), document.querySelector("#modal"));
};
/* harmony default export */ var overlay = (Overlay);


/***/ }),

/***/ 65442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ CLIENT_ID; },
/* harmony export */   "He": function() { return /* binding */ REDIRECT_URI; },
/* harmony export */   "du": function() { return /* binding */ KAKAO_AUTH_URL; },
/* harmony export */   "l7": function() { return /* binding */ NAVER_AUTH_URL; }
/* harmony export */ });
/* unused harmony exports NAVER_CLIENT_ID, NAVER_REDIRECT_URI */
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);

var isPreviewUrl = !_types_common__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? /preview/i.test(window.location.href) : false;
var CLIENT_ID = "6ce33006eb475d857a105e06e6b41059";
var REDIRECT_URI = !isPreviewUrl ? "https://doctornow.co.kr/content/kakao/loginCallback" : "https://preview.doctornow.co.kr/content/kakao/loginCallback";
var KAKAO_AUTH_URL = "https://kauth.kakao.com/oauth/authorize?client_id=".concat(CLIENT_ID, "&redirect_uri=").concat(REDIRECT_URI, "&response_type=code");
var NAVER_CLIENT_ID = "rSZ9rcswtFGwIv6PJnFA";
var NAVER_REDIRECT_URI = !isPreviewUrl ? "https://doctornow.co.kr/content/naver/loginCallback" : "https://preview.doctornow.co.kr/content/naver/loginCallback";
var NAVER_AUTH_URL = "https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=".concat(NAVER_CLIENT_ID, "&redirect_uri=").concat(NAVER_REDIRECT_URI, "&state=doctornownaver");


/***/ }),

/***/ 26214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iq": function() { return /* binding */ TELEMEDICINE_CATEGORY_IDS; },
/* harmony export */   "x5": function() { return /* binding */ TREATMENT_CATEGORIES_IDS; }
/* harmony export */ });
/* unused harmony export DEPARTMENT_CATEGORIES_IDS */
var TELEMEDICINE_CATEGORY_IDS = {
    TREATMENT: {
        COLD: "1",
        HAIRLOSS: "9",
        ACNE: "11",
        ARTIFICIAL_TEARS: "558",
        DIET: "12"
    },
    DEPARTMENT: {
        PEDIATRICS: "2"
    }
};
// 하위 호환성을 위한 별칭
var TREATMENT_CATEGORIES_IDS = {
    Hairloss: TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS,
    Acne: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE,
    Diet: TELEMEDICINE_CATEGORY_IDS.TREATMENT.DIET,
    Cold: TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD,
    ArtificialTears: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS
};
var DEPARTMENT_CATEGORIES_IDS = {
    Pediatrics: TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS
};


/***/ }),

/***/ 95611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ SIX_HOURS_IN_MILLISECONDS; },
/* harmony export */   "IC": function() { return /* binding */ APP_ACNE_TRACKING_PARAMS; },
/* harmony export */   "J$": function() { return /* binding */ NON_BENEFIT_SUBMENUS; },
/* harmony export */   "Lb": function() { return /* binding */ TELEMEDICINE_SUBMENUS; },
/* harmony export */   "Oi": function() { return /* binding */ HOSPITAL_SUBMENUS; },
/* harmony export */   "Up": function() { return /* binding */ QNA_SUBMENUS; },
/* harmony export */   "XA": function() { return /* binding */ APP_PUBLIC_DOWNLOAD_URL; },
/* harmony export */   "aG": function() { return /* binding */ APP_STORE_PAGE_LINK_TRACKING_PARAMS; },
/* harmony export */   "eU": function() { return /* binding */ APP_GENERAL_TRACKING_PARAMS; },
/* harmony export */   "fn": function() { return /* binding */ APP_TRACKING_CHANNEL; },
/* harmony export */   "iI": function() { return /* binding */ APP_HAIRLOSS_TRACKING_PARAMS; },
/* harmony export */   "kT": function() { return /* binding */ APP_DIET_TRACKING_PARAMS; },
/* harmony export */   "ld": function() { return /* binding */ MAGAZINE_SUBMENUS; }
/* harmony export */ });
/* unused harmony export FEATURE_FLAG */
/* harmony import */ var _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7551);
/* harmony import */ var _entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42491);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70138);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74735);
/* harmony import */ var _category__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26214);
/* harmony import */ var _hospital__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61172);







var FEATURE_FLAG;
(function(FEATURE_FLAG) {})(FEATURE_FLAG || (FEATURE_FLAG = {}));
var SIX_HOURS_IN_MILLISECONDS = 1000 * 60 * 60 * 6;
var APP_PUBLIC_DOWNLOAD_URL = "https://abr.ge/@doctornow";
var APP_TRACKING_CHANNEL = "web_organic";
var APP_GENERAL_TRACKING_PARAMS = "og_tag_id=138187085&routing_short_id=d816rm&tracking_template_id=2b94e9766fea0e112f2b11b7410088c4&ad_type=click";
var APP_STORE_PAGE_LINK_TRACKING_PARAMS = "og_tag_id=138187710&routing_short_id=pzm4azo&tracking_template_id=a82e9a369aeb09d88afb5812cf2376b6&ad_type=click";
var APP_HAIRLOSS_TRACKING_PARAMS = "og_tag_id=285640949&routing_short_id=pqq5ys&tracking_template_id=36a9407528e07b0d2568b463fd573f57&ad_type=click";
var APP_ACNE_TRACKING_PARAMS = "og_tag_id=285674496&routing_short_id=8r96pa&tracking_template_id=d9be8b6900b21be591266a35119e7e48&ad_type=click";
var APP_DIET_TRACKING_PARAMS = "og_tag_id=285673148&routing_short_id=g0qaey&tracking_template_id=989bfe4cfb73e9b0a566efdcb6630496&ad_type=click";
var TELEMEDICINE_SUBMENUS = [
    {
        text: "소아청소년과",
        url: (0,_entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__/* .getCategoryPath */ .IX)(_category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS */ .Iq.DEPARTMENT.PEDIATRICS, _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT),
        categoryId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS */ .Iq.DEPARTMENT.PEDIATRICS,
        categoryType: _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT
    },
    {
        text: "감기/독감",
        url: (0,_entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__/* .getCategoryPath */ .IX)(_category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD */ .Iq.TREATMENT.COLD, _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT),
        categoryId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD */ .Iq.TREATMENT.COLD,
        categoryType: _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT
    },
    {
        text: "인공눈물",
        url: (0,_entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__/* .getCategoryPath */ .IX)(_category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS */ .Iq.TREATMENT.ARTIFICIAL_TEARS, _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT),
        categoryId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS */ .Iq.TREATMENT.ARTIFICIAL_TEARS,
        categoryType: _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT
    },
    {
        text: "탈모",
        url: (0,_entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__/* .getCategoryPath */ .IX)(_category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS */ .Iq.TREATMENT.HAIRLOSS, _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT),
        categoryId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS */ .Iq.TREATMENT.HAIRLOSS,
        categoryType: _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT
    },
    {
        text: "여드름",
        url: (0,_entities_telemedicine__WEBPACK_IMPORTED_MODULE_1__/* .getCategoryPath */ .IX)(_category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE */ .Iq.TREATMENT.ACNE, _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT),
        categoryId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE */ .Iq.TREATMENT.ACNE,
        categoryType: _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT
    },
    {
        text: "전체 보기",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.TELEMEDICINE.CATEGORIES.path */ .Z6.TELEMEDICINE.CATEGORIES.path,
        categoryId: "ALL",
        categoryType: null
    }, 
];
var HOSPITAL_SUBMENUS = [
    {
        text: "이비인후과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            keyword: "이비인후과",
            regionCode: 11,
            type: "all"
        })
    },
    {
        text: "피부과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            keyword: "피부과",
            regionCode: 11,
            type: "all"
        })
    },
    {
        text: "내과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            keyword: "내과",
            regionCode: 11,
            type: "all"
        })
    },
    {
        text: "산부인과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            keyword: "산부인과",
            regionCode: 11,
            type: "all"
        })
    },
    {
        text: "가정의학과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            keyword: "가정의학과",
            regionCode: 11,
            type: "all"
        })
    },
    {
        text: "전체 보기",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path
    }, 
];
var NON_BENEFIT_SUBMENUS = [
    {
        text: "탈모 진료비",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            treatmentId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TREATMENT_CATEGORIES_IDS.Hairloss */ .x5.Hairloss,
            regionCode: _hospital__WEBPACK_IMPORTED_MODULE_5__/* .SEOUL_REGION_CODE */ .x
        })
    },
    {
        text: "다이어트 진료비",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            treatmentId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TREATMENT_CATEGORIES_IDS.Diet */ .x5.Diet,
            regionCode: _hospital__WEBPACK_IMPORTED_MODULE_5__/* .SEOUL_REGION_CODE */ .x
        })
    },
    {
        text: "여드름 진료비",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path + (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .addQueryString */ .sC)({
            treatmentId: _category__WEBPACK_IMPORTED_MODULE_4__/* .TREATMENT_CATEGORIES_IDS.Acne */ .x5.Acne,
            regionCode: _hospital__WEBPACK_IMPORTED_MODULE_5__/* .SEOUL_REGION_CODE */ .x
        })
    },
    {
        text: "최저가 약국",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.NON_BENEFIT.MAP.path */ .Z6.NON_BENEFIT.MAP.path
    }, 
];
var MAGAZINE_SUBMENUS = [
    {
        text: "건강 매거진",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path + "/INTERNAL"
    },
    {
        text: "1분 FAQ",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.FAQ.LIST.path */ .Z6.FAQ.LIST.path
    },
    {
        text: "의약품 사전",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.MEDICINE_DICTIONARY.HOME.path */ .Z6.MEDICINE_DICTIONARY.HOME.path
    },
    {
        text: "질환백과",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path */ .Z6.DISEASE_ENCYCLOPEDIA.HOME.path
    }, 
];
var QNA_SUBMENUS = [
    {
        text: "실시간 질문",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path
    },
    {
        text: "질문하기",
        url: _types_common__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.QNA.WRITE.path */ .Z6.QNA.WRITE.path
    }, 
];


/***/ }),

/***/ 5322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kc": function() { return /* binding */ IS_LOCAL; },
/* harmony export */   "UM": function() { return /* binding */ IS_PROD_ZONE; },
/* harmony export */   "dU": function() { return /* binding */ getEnv; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(34406);
var IS_LOCAL = "production" === "development"; // local or not
var _PLATFORM_ENV;
var IS_PROD_ZONE = ((_PLATFORM_ENV = process.env.PLATFORM_ENV) !== null && _PLATFORM_ENV !== void 0 ? _PLATFORM_ENV : "production") === "production"; // production zone or not
var getEnv = function() {
    return IS_PROD_ZONE ? "prod" : "develop";
};


/***/ }),

/***/ 83417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GM": function() { return /* binding */ BFF_ERROR_CODE_TYPES; },
/* harmony export */   "c9": function() { return /* binding */ ERROR_MESSAGE; }
/* harmony export */ });
/* unused harmony export DNA_ERROR_CODE_TYPES */
var BFF_ERROR_CODE_TYPES = {
    Default: "Default",
    SignInFailed: "SignInFailed",
    NoAuthorization: "NoAuthorization",
    canceled: "canceled",
    AlreadyReceivedFaceToFaceDiagnosisBooking: "AlreadyReceivedFaceToFaceDiagnosisBooking",
    MaxCountExceeded: "MaxCountExceeded",
    UnableBooking: "UnableBooking",
    OrderMaxCountExceeded: "OrderMaxCountExceeded",
    DuplicatedRequest: "DuplicatedRequest"
};
var DNA_ERROR_CODE_TYPES = {
    DuplicateOrderException: "DuplicateOrderException",
    TooManySendException: "TooManySendException"
};
var ERROR_MESSAGE = {
    DefaultError: "일시적인 오류가 발생했습니다.",
    NoAuthTokenException: "로그인 후 이용 가능합니다.",
    NoAuthorization: "로그인 후 이용 가능합니다.",
    SimpleSurveyAnswerAddFailed: "최대 500자까지 등록가능합니다.",
    AlreadyReceivedFaceToFaceDiagnosisBooking: "이미 접수된 대면진료 예약이 있어요",
    MaxCountExceeded: "선택하신 시간은 예약이 마감 되었어요. 다른 시간을 선택해 주세요.",
    UnableBooking: "현재 예약 기능을 사용할 수 없어요."
};


/***/ }),

/***/ 93247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ INFLUENZA_DEFAULT_PLACEHOLDER; },
/* harmony export */   "Gg": function() { return /* binding */ FaceToFaceLog; },
/* harmony export */   "yA": function() { return /* binding */ INFLUENZA; }
/* harmony export */ });
var INFLUENZA = "influenza";
var INFLUENZA_DEFAULT_PLACEHOLDER = "[ 독감예방접종 ]";
var FaceToFaceLog;
(function(FaceToFaceLog) {
    FaceToFaceLog["click_category"] = "click_category";
    FaceToFaceLog["click_category_treatment"] = "click_category_treatment";
    FaceToFaceLog["click_popular_keyword"] = "click_popular_keyword";
    FaceToFaceLog["click_search_keyword"] = "click_search_keyword";
    FaceToFaceLog["click_filter_nonF2f"] = "click_filter_nonF2f";
    FaceToFaceLog["click_filter_sunday_operation"] = "click_filter_sunday_operation";
    FaceToFaceLog["click_filter_detail"] = "click_filter_detail";
    FaceToFaceLog["click_filter_sorting"] = "click_filter_sorting";
    FaceToFaceLog["click_filter_operating"] = "click_filter_operating";
    FaceToFaceLog["click_filter_easy_booking"] = "click_filter_easy_booking";
    FaceToFaceLog["click_filter_professional"] = "click_filter_professional";
    FaceToFaceLog["click_filter_night_operation"] = "click_filter_night_operation";
    FaceToFaceLog["click_filter_detail_apply"] = "click_filter_detail_apply";
})(FaceToFaceLog || (FaceToFaceLog = {}));


/***/ }),

/***/ 61172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ SEOUL_REGION_CODE; }
/* harmony export */ });
/* unused harmony export DEFAULT_NEIGHBORHOOD_CATEGORY_KEYWORD */
var SEOUL_REGION_CODE = "11";
var DEFAULT_NEIGHBORHOOD_CATEGORY_KEYWORD = "소아과";


/***/ }),

/***/ 78081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ CommonLoggerEventName; }
/* harmony export */ });
var CommonLoggerEventName;
(function(CommonLoggerEventName) {
    CommonLoggerEventName["PageView"] = "page_view";
})(CommonLoggerEventName || (CommonLoggerEventName = {}));


/***/ }),

/***/ 60643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DeeplinkLoggerEventName; }
/* harmony export */ });
var DeeplinkLoggerEventName;
(function(DeeplinkLoggerEventName) {
    DeeplinkLoggerEventName["ClickCtaButton"] = "click_cta_button";
    DeeplinkLoggerEventName["ImpressionQrFloating"] = "impression_qr_floating";
    DeeplinkLoggerEventName["ClickCtaText"] = "click_cta_text";
})(DeeplinkLoggerEventName || (DeeplinkLoggerEventName = {}));


/***/ }),

/***/ 31591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ zIndex; }
/* harmony export */ });
var zIndex = {
    AppHeader: 260,
    MobileWebHeader: 10000,
    Image: 2,
    Info: 5,
    Toast: 320,
    FloatingActionButton: 10,
    Dropbox: 10,
    BottomSticky: 50,
    TabSticky: 250,
    BreadCrumb: 100,
    PharmacyFilterWrapper: 102,
    PharmacyListBottomSheet: 3,
    PharmacyMapLoadingWrapper: 2
};


/***/ }),

/***/ 92998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eb": function() { return /* reexport */ findClosestAvailableScheduleByDate; },
  "jV": function() { return /* reexport */ formatReviewCount; },
  "Aj": function() { return /* reexport */ hooks_useQuickDiagnosisDoctor; }
});

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrAfter.js
var isSameOrAfter = __webpack_require__(79212);
var isSameOrAfter_default = /*#__PURE__*/__webpack_require__.n(isSameOrAfter);
// EXTERNAL MODULE: ./src/types/doctor.ts
var doctor = __webpack_require__(79051);
;// CONCATENATED MODULE: ./src/entities/doctor/libs/diagnosisSchedule.ts


dayjs_min_default().extend((isSameOrAfter_default()));

var findClosestAvailableScheduleByDate = function(schedules, dateToSelect) {
    if (!(schedules === null || schedules === void 0 ? void 0 : schedules.length)) {
        return null;
    }
    if (dateToSelect) {
        var base = dayjs_min_default()(dateToSelect);
        var matched = schedules.filter(function(schedule) {
            return dayjs_min_default()(schedule.targetDate).isSameOrAfter(base, "day");
        }).find(function(schedule) {
            return schedule.status === doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable;
        });
        if (matched) {
            var hasBookableSlots = matched.schedules.some(function(slot) {
                return slot.bookingStatus === doctor/* BookingScheduleTypeVo.Bookable */.Ts.Bookable;
            });
            if (hasBookableSlots) {
                return matched;
            }
            return null;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = schedules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var schedule = _step.value;
            if (schedule.status === doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable) {
                var hasBookableSlots1 = schedule.schedules.some(function(slot) {
                    return slot.bookingStatus === doctor/* BookingScheduleTypeVo.Bookable */.Ts.Bookable;
                });
                if (hasBookableSlots1) {
                    return schedule;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};

;// CONCATENATED MODULE: ./src/entities/doctor/libs/formatReviewCount.ts
var formatReviewCount = function(count) {
    if (count >= 2000) return "2000+";
    if (count >= 1500) return "1500+";
    if (count >= 1000) return "1000+";
    if (count >= 500) return "500+";
    if (count >= 300) return "300+";
    if (count >= 200) return "200+";
    if (count >= 100) return "100+";
    if (count >= 50) return "50+";
    if (count >= 20) return "20+";
    if (count >= 10) return "10+";
    return String(count);
};

;// CONCATENATED MODULE: ./src/entities/doctor/libs/index.ts



// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/parsers/common/index.ts
var common = __webpack_require__(61169);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/doctor/hooks/doctor.gql.impl.tsx


var NonF2fQuickDiagnosisDoctorDocument = "\n    query NonF2fQuickDiagnosisDoctor($request: NonF2fQuickDiagnosisDoctorRequestInput!, $telemedicineTargetType: TelemedicineTargetType!, $contactType: DiagnosisContactType!) {\n  nonF2fQuickDiagnosisDoctor(request: $request) {\n    doctor {\n      doctorId\n      doctorPublicId\n      diagnosisBookingSchedules(\n        contactType: $contactType\n        telemedicineTargetType: $telemedicineTargetType\n      ) {\n        targetDate\n        schedules {\n          startTimeSlot {\n            value\n          }\n          endTimeSlot {\n            value\n          }\n        }\n      }\n    }\n  }\n}\n    ";
var useNonF2fQuickDiagnosisDoctorQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "NonF2fQuickDiagnosisDoctor",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(NonF2fQuickDiagnosisDoctorDocument, "NonF2fQuickDiagnosisDoctor", variables), options);
};
useNonF2fQuickDiagnosisDoctorQuery.getKey = function(variables) {
    return [
        "NonF2fQuickDiagnosisDoctor",
        variables
    ];
};
useNonF2fQuickDiagnosisDoctorQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(NonF2fQuickDiagnosisDoctorDocument, "NonF2fQuickDiagnosisDoctor", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/doctor/hooks/useQuickDiagnosisDoctor.ts





var useQuickDiagnosisDoctor = function() {
    var getQuickDiagnosisDoctorInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, data, firstSchedule, firstTimeSlot;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            useNonF2fQuickDiagnosisDoctorQuery.fetcher({
                                request: {
                                    medicalCategory: {
                                        type: (0,common/* parseMedicalCategoryCategoryTypeOf */.x3)(variables.medicalCategory.type),
                                        id: variables.medicalCategory.id
                                    },
                                    telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.AlwaysEligible */.H7r.AlwaysEligible
                                },
                                telemedicineTargetType: gql_schema/* TelemedicineTargetType.AlwaysEligible */.vw3.AlwaysEligible,
                                contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                            })()
                        ];
                    case 1:
                        data = _state.sent();
                        firstSchedule = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.nonF2fQuickDiagnosisDoctor) === null || ref === void 0 ? void 0 : ref.doctor.diagnosisBookingSchedules) === null || ref1 === void 0 ? void 0 : ref1[0];
                        firstTimeSlot = firstSchedule === null || firstSchedule === void 0 ? void 0 : (ref2 = firstSchedule.schedules) === null || ref2 === void 0 ? void 0 : ref2[0];
                        return [
                            2,
                            {
                                doctorId: (data === null || data === void 0 ? void 0 : (ref3 = data.nonF2fQuickDiagnosisDoctor) === null || ref3 === void 0 ? void 0 : ref3.doctor.doctorId) || "",
                                doctorPid: (data === null || data === void 0 ? void 0 : (ref4 = data.nonF2fQuickDiagnosisDoctor) === null || ref4 === void 0 ? void 0 : ref4.doctor.doctorPublicId) || "",
                                targetDate: (firstSchedule === null || firstSchedule === void 0 ? void 0 : firstSchedule.targetDate) || "",
                                startTimeSlotValue: (firstTimeSlot === null || firstTimeSlot === void 0 ? void 0 : (ref5 = firstTimeSlot.startTimeSlot) === null || ref5 === void 0 ? void 0 : ref5.value) || -1,
                                endTimeSlotValue: (firstTimeSlot === null || firstTimeSlot === void 0 ? void 0 : (ref6 = firstTimeSlot.endTimeSlot) === null || ref6 === void 0 ? void 0 : ref6.value) || -1
                            }
                        ];
                }
            });
        });
        return function getQuickDiagnosisDoctorInfo(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getQuickDiagnosisDoctorInfo: getQuickDiagnosisDoctorInfo
    };
};
/* harmony default export */ var hooks_useQuickDiagnosisDoctor = (useQuickDiagnosisDoctor);

;// CONCATENATED MODULE: ./src/entities/doctor/hooks/index.ts



;// CONCATENATED MODULE: ./src/entities/doctor/index.ts




/***/ }),

/***/ 7551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m1": function() { return /* reexport */ EMedicalCategoryType; },
  "tC": function() { return /* reexport */ hooks_useNonF2fMedicalCategories; }
});

// UNUSED EXPORTS: MedicalCategoryModel

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
;// CONCATENATED MODULE: ./src/entities/medical-category/model/MedicalCategory.ts

var EMedicalCategoryType;
(function(EMedicalCategoryType) {
    EMedicalCategoryType["TREATMENT"] = "TREATMENT";
    EMedicalCategoryType["DEPARTMENT"] = "DEPARTMENT";
    EMedicalCategoryType["VACCINATION"] = "VACCINATION";
})(EMedicalCategoryType || (EMedicalCategoryType = {}));
var MedicalCategoryModel = function MedicalCategoryModel(param) {
    "use strict";
    var _medicalCategory = param._medicalCategory;
    (0,_class_call_check/* default */.Z)(this, MedicalCategoryModel);
    this.id = _medicalCategory.id;
    this.category = _medicalCategory.category;
    this.name = _medicalCategory.name;
    this.iconUrl = _medicalCategory.iconUrl;
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/medical-category/hooks/medicalCategory.gql.impl.tsx


var NonF2fMedicalCategoriesDocument = "\n    query NonF2fMedicalCategories($size: Int) {\n  nonF2fMedicalCategories(size: $size) {\n    category\n    id\n    name\n    iconUrl\n  }\n}\n    ";
var useNonF2fMedicalCategoriesQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "NonF2fMedicalCategories"
    ] : [
        "NonF2fMedicalCategories",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(NonF2fMedicalCategoriesDocument, "NonF2fMedicalCategories", variables), options);
};
useNonF2fMedicalCategoriesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonF2fMedicalCategories"
    ] : [
        "NonF2fMedicalCategories",
        variables
    ];
};
useNonF2fMedicalCategoriesQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(NonF2fMedicalCategoriesDocument, "NonF2fMedicalCategories", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/medical-category/hooks/useNonF2fMedicalCategories.ts





var parseMedicalCategoryType = function(type) {
    switch(type){
        case gql_schema/* MedicalCategoryType.Treatment */.WkB.Treatment:
            return EMedicalCategoryType.TREATMENT;
        case gql_schema/* MedicalCategoryType.Department */.WkB.Department:
            return EMedicalCategoryType.DEPARTMENT;
        default:
            return EMedicalCategoryType.TREATMENT;
    }
};
var parseMedicalCategories = function(data) {
    var _name, _iconUrl;
    return data.nonF2fMedicalCategories.map(function(medicalCategory) {
        return new MedicalCategoryModel({
            _medicalCategory: {
                id: medicalCategory.id,
                category: parseMedicalCategoryType(medicalCategory.category),
                name: (_name = medicalCategory.name) !== null && _name !== void 0 ? _name : "",
                iconUrl: (_iconUrl = medicalCategory.iconUrl) !== null && _iconUrl !== void 0 ? _iconUrl : ""
            }
        });
    });
};
var DEFAULT_SIZE = 9;
var useNonF2fMedicalCategories = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_SIZE;
    var ref = useNonF2fMedicalCategoriesQuery({
        size: size
    }, {
        select: parseMedicalCategories
    }), medicalCategories = ref.data, isLoading = ref.isLoading, error = ref.error;
    return {
        medicalCategories: medicalCategories !== null && medicalCategories !== void 0 ? medicalCategories : [],
        isLoading: isLoading,
        error: error
    };
};
/* harmony default export */ var hooks_useNonF2fMedicalCategories = (useNonF2fMedicalCategories);
useNonF2fMedicalCategories.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var size;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    size = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : DEFAULT_SIZE;
                    return [
                        4,
                        queryClient.prefetchQuery(useNonF2fMedicalCategoriesQuery.getKey({
                            size: size
                        }), useNonF2fMedicalCategoriesQuery.fetcher({
                            size: size
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/entities/medical-category/hooks/index.ts



;// CONCATENATED MODULE: ./src/entities/medical-category/index.ts




/***/ }),

/***/ 56289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7551);
/* harmony import */ var _hooks_telemedicine_telemedicine_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76122);
/* harmony import */ var _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2426);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59403);





var parseCategoryType = function(categoryType) {
    switch(categoryType){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Treatment */ .WkB.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Vaccination */ .WkB.Vaccination;
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
    }
};
var parseSortType = function(sortType) {
    switch(sortType){
        case _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .EDoctorSortType.DEFAULT */ ._c.DEFAULT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DoctorSortType.Default */ .tt_.Default;
        case _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .EDoctorSortType.DISTANCE */ ._c.DISTANCE:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DoctorSortType.Distance */ .tt_.Distance;
        case _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .EDoctorSortType.REVIEW_COUNT */ ._c.REVIEW_COUNT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DoctorSortType.ReviewCount */ .tt_.ReviewCount;
        case _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .EDoctorSortType.REVIEW_AVERAGE_RATING */ ._c.REVIEW_AVERAGE_RATING:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DoctorSortType.ReviewAverageRating */ .tt_.ReviewAverageRating;
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DoctorSortType.Default */ .tt_.Default;
    }
};
var parseDiagnosisType = function(categoryType) {
    switch(categoryType){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Treatment */ .LE2.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Department */ .LE2.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Vaccination */ .LE2.Vaccination;
        default:
            return undefined;
    }
};
var parseSearchDoctors = function(data) {
    return data === null || data === void 0 ? void 0 : data.pages.flatMap(function(page) {
        return page.searchDoctorsByTimeSlotV2.items.map(function(doctor) {
            var ref;
            var _profileUrl, ref1;
            return new _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .NonF2fDoctor */ .ud(doctor.hospital.hospitalName, doctor.publicId, doctor.doctorName, doctor.medicineType, (_profileUrl = doctor.profileUrl) !== null && _profileUrl !== void 0 ? _profileUrl : null, doctor.readyForVideoCall, (ref1 = (ref = doctor.professionalDepartments[0]) === null || ref === void 0 ? void 0 : ref.professionalDepartmentName) !== null && ref1 !== void 0 ? ref1 : null, new _models_doctor_telemedicine__WEBPACK_IMPORTED_MODULE_2__/* .NonF2fDoctorReviewInfo */ .WS(doctor.reviewMetric.averageRating, doctor.reviewMetric.totalCount), null, null);
        });
    });
};
var SEARCH_DOCTORS_LIMIT = 10;
var useSearchDoctorsInfinity = function(param) {
    var categoryType = param.categoryType, _categoryId = param.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId, targetDate = param.targetDate, startTimeSlotValue = param.startTimeSlotValue, endTimeSlotValue = param.endTimeSlotValue, sortType = param.sortType, _specialistOnly = param.specialistOnly, specialistOnly = _specialistOnly === void 0 ? false : _specialistOnly, highReviewRating = param.highReviewRating, highReviewCount = param.highReviewCount, geoPoint = param.geoPoint, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var parsedSortType = parseSortType(sortType);
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useInfiniteQuery */ .N)(_hooks_telemedicine_telemedicine_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useSearchDoctorsByTimeSlotV2Query.getKey */ .Hx.getKey({
        request: {
            condition: {
                medicalCategory: {
                    category: parseCategoryType(categoryType),
                    id: categoryId
                },
                specialistOnly: specialistOnly,
                highReviewRating: highReviewRating,
                highReviewCount: highReviewCount,
                targetDate: targetDate,
                startTimeSlotValue: startTimeSlotValue,
                endTimeSlotValue: endTimeSlotValue,
                geoPoint: geoPoint ? {
                    latitude: geoPoint.latitude,
                    longitude: geoPoint.longitude
                } : undefined
            },
            page: 1,
            limit: SEARCH_DOCTORS_LIMIT,
            sortType: parsedSortType
        },
        diagnosisType: parseDiagnosisType(categoryType),
        diagnosisTypeId: categoryId
    }), function(param) {
        var pageParam = param.pageParam;
        var requestPage = pageParam !== null && pageParam !== void 0 ? pageParam : 1;
        return _hooks_telemedicine_telemedicine_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useSearchDoctorsByTimeSlotV2Query.fetcher */ .Hx.fetcher({
            request: {
                condition: {
                    medicalCategory: {
                        category: parseCategoryType(categoryType),
                        id: categoryId
                    },
                    specialistOnly: specialistOnly,
                    highReviewRating: highReviewRating,
                    highReviewCount: highReviewCount,
                    targetDate: targetDate,
                    startTimeSlotValue: startTimeSlotValue,
                    endTimeSlotValue: endTimeSlotValue,
                    geoPoint: geoPoint ? {
                        latitude: geoPoint.latitude,
                        longitude: geoPoint.longitude
                    } : undefined
                },
                page: requestPage,
                limit: SEARCH_DOCTORS_LIMIT,
                sortType: parsedSortType
            },
            diagnosisType: parseDiagnosisType(categoryType),
            diagnosisTypeId: categoryId
        })();
    }, {
        enabled: enabled && !!categoryId && !!categoryType && !!targetDate && startTimeSlotValue >= 0 && endTimeSlotValue >= 0,
        getNextPageParam: function(lastPage, pages) {
            if (lastPage.searchDoctorsByTimeSlotV2.items.length === SEARCH_DOCTORS_LIMIT) {
                return pages.length + 1;
            }
            return undefined;
        }
    }), searchDoctors = ref.data, isLoadingSearchDoctors = ref.isLoading, fetchNextPageSearchDoctors = ref.fetchNextPage, tmp = ref.hasNextPage, hasNextPageSearchDoctors = tmp === void 0 ? false : tmp;
    return {
        searchDoctors: parseSearchDoctors(searchDoctors),
        isLoadingSearchDoctors: isLoadingSearchDoctors,
        fetchNextPageSearchDoctors: fetchNextPageSearchDoctors,
        hasNextPageSearchDoctors: hasNextPageSearchDoctors
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchDoctorsInfinity);


/***/ }),

/***/ 42491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IX": function() { return /* reexport */ getCategoryPath; },
  "pH": function() { return /* reexport */ hooks_useGetBookingSchedules; },
  "UO": function() { return /* reexport */ hooks_useTelemedicineRequest; }
});

// UNUSED EXPORTS: useSearchDoctorsInfinity

// EXTERNAL MODULE: ./src/models/diagnosis/index.ts
var diagnosis = __webpack_require__(39591);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/telemedicine/hooks/telemedicine.gql.impl.tsx


var AvailableBookingTimeSlotsDocument = "\n    query AvailableBookingTimeSlots {\n  availableBookingTimeSlots {\n    targetDate\n    status\n    displayName\n    schedules {\n      remainingCount\n      bookingStatus\n      startTimeSlot {\n        displayTime\n        value\n        fromDisplayTime\n        toDisplayTime\n      }\n      endTimeSlot {\n        displayTime\n        value\n        fromDisplayTime\n        toDisplayTime\n      }\n    }\n  }\n}\n    ";
var useAvailableBookingTimeSlotsQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "AvailableBookingTimeSlots"
    ] : [
        "AvailableBookingTimeSlots",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(AvailableBookingTimeSlotsDocument, "AvailableBookingTimeSlots", variables), options);
};
useAvailableBookingTimeSlotsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "AvailableBookingTimeSlots"
    ] : [
        "AvailableBookingTimeSlots",
        variables
    ];
};
useAvailableBookingTimeSlotsQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(AvailableBookingTimeSlotsDocument, "AvailableBookingTimeSlots", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/telemedicine/hooks/useGetBookingSchedules.ts


var parseNonFaceToFaceBookingSchedule = function(data) {
    var schedules = data.availableBookingTimeSlots.map(function(scheduleInfo) {
        return {
            displayName: scheduleInfo.displayName,
            status: scheduleInfo.status,
            targetDate: scheduleInfo.targetDate,
            schedules: scheduleInfo.schedules.map(function(schedule) {
                return {
                    bookingStatus: schedule.bookingStatus,
                    startTimeSlot: schedule.startTimeSlot,
                    endTimeSlot: schedule.endTimeSlot,
                    remainingCount: schedule.remainingCount
                };
            })
        };
    });
    return new diagnosis/* NonFaceToFaceBookingSchedulesInfo */.rT(schedules);
};
var useGetBookingSchedules = function() {
    var ref = useAvailableBookingTimeSlotsQuery({}, {
        select: parseNonFaceToFaceBookingSchedule
    }), _data = ref.data, data = _data === void 0 ? new diagnosis/* NonFaceToFaceBookingSchedulesInfo */.rT([]) : _data, isBookingSchedulesFetched = ref.isFetched;
    return {
        bookingSchedulesInfo: data,
        isBookingSchedulesFetched: isBookingSchedulesFetched
    };
};
/* harmony default export */ var hooks_useGetBookingSchedules = (useGetBookingSchedules);

// EXTERNAL MODULE: ./src/entities/telemedicine/hooks/useSearchDoctorsInfinity.ts
var useSearchDoctorsInfinity = __webpack_require__(56289);
// EXTERNAL MODULE: ./src/entities/medical-category/index.ts + 4 modules
var medical_category = __webpack_require__(7551);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/entities/telemedicine/hooks/useTelemedicineRequest.ts





var WEB_DIAGNOSIS_DISABLED_CATEGORIES = [
    {
        id: "12",
        category: medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT
    }, 
];
var useTelemedicineRequest = function() {
    var setShowAuthModal = (0,useAuthModal/* default */.Z)(true, false).setShowAuthModal;
    var navigate = (0,useNavigate/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var token = (0,auth/* getAuthToken */.bW)();
    var getIsEnabledWebTelemedicineCategory = function(categoryId) {
        return !WEB_DIAGNOSIS_DISABLED_CATEGORIES.some(function(category) {
            return category.id === categoryId;
        });
    };
    var onClickTelemedicineRequest = function(param) {
        var categoryId = param.categoryId, type = param.type, redirectUrl = param.redirectUrl;
        if (!token) {
            setShowAuthModal(true, redirectUrl, "3초만에 로그인하고\n비대면 진료 시작해보세요", "앱 설치할 필요 없이 바로 진료받을 수 있어요.");
            return;
        }
        var isEnabledWebTelemedicineCategory = getIsEnabledWebTelemedicineCategory(categoryId);
        if (isEnabledWebTelemedicineCategory) {
            navigate.navigateToTelemedicineRequestScreen({
                categoryId: categoryId,
                type: type
            });
            return;
        }
        router.push(redirectUrl);
    };
    return {
        onClickTelemedicineRequest: onClickTelemedicineRequest
    };
};
/* harmony default export */ var hooks_useTelemedicineRequest = (useTelemedicineRequest);

;// CONCATENATED MODULE: ./src/entities/telemedicine/hooks/index.ts





// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/entities/telemedicine/lib/getCategoryPath.ts


var DIET_TREATMENT_ID = "12";
var MEDICINE_UNIT_ID = 185;
var DEFAULT_REGION_CODE = 11;
var getCategoryPath = function(categoryId, categoryType) {
    if (categoryType === medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT && categoryId === DIET_TREATMENT_ID) {
        return "".concat(common/* ROUTES.NON_BENEFIT.HOME.path */.Z6.NON_BENEFIT.HOME.path, "?treatmentId=").concat(categoryId, "&treatmentMedicineUnitId=").concat(MEDICINE_UNIT_ID, "&regionCode=").concat(DEFAULT_REGION_CODE);
    }
    return "".concat(common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path, "?categoryId=").concat(categoryId, "&type=").concat(categoryType);
};

;// CONCATENATED MODULE: ./src/entities/telemedicine/lib/index.ts


;// CONCATENATED MODULE: ./src/entities/telemedicine/index.ts




/***/ }),

/***/ 76122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hx": function() { return /* binding */ useSearchDoctorsByTimeSlotV2Query; },
/* harmony export */   "lE": function() { return /* binding */ useGetDiagnosisCategoriesV2Query; },
/* harmony export */   "ze": function() { return /* binding */ useSearchDoctorsByUserQuery; }
/* harmony export */ });
/* unused harmony exports SearchDoctorsByUserDocument, SearchDoctorsByTimeSlotDocument, useSearchDoctorsByTimeSlotQuery, SearchDoctorsByTimeSlotV2Document, GetDiagnosisCategoriesV2Document */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var SearchDoctorsByUserDocument = "\n    query SearchDoctorsByUser($request: DoctorSearchByUserRequestInput!) {\n  searchDoctorsByUser(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospitalName\n      id\n      publicId\n      isAffiliated\n      medicineType\n      name\n      profileUrl\n      medicineType\n      professionalDepartment {\n        name\n      }\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n      bookingInfo {\n        bookingAvailability\n        isBookable\n        todayBookable\n        todayCutoffTime\n        todayKickoffTime\n        todaySchedule\n        tomorrowBookable\n        tomorrowCutoffTime\n        tomorrowKickoffTime\n        tomorrowSchedule\n      }\n    }\n  }\n}\n    ";
var useSearchDoctorsByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables), options);
};
useSearchDoctorsByUserQuery.getKey = function(variables) {
    return [
        "SearchDoctorsByUser",
        variables
    ];
};
useSearchDoctorsByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables, options);
};
var SearchDoctorsByTimeSlotDocument = "\n    query SearchDoctorsByTimeSlot($request: TimeSlotBasedDoctorSearchMutationRequestInput!) {\n  searchDoctorsByTimeSlot(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospitalName\n      id\n      publicId\n      isAffiliated\n      medicineType\n      name\n      profileUrl\n      medicineType\n      professionalDepartment {\n        name\n      }\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n    }\n  }\n}\n    ";
var useSearchDoctorsByTimeSlotQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByTimeSlot",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByTimeSlotDocument, "SearchDoctorsByTimeSlot", variables), options);
};
useSearchDoctorsByTimeSlotQuery.getKey = function(variables) {
    return [
        "SearchDoctorsByTimeSlot",
        variables
    ];
};
useSearchDoctorsByTimeSlotQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByTimeSlotDocument, "SearchDoctorsByTimeSlot", variables, options);
};
var SearchDoctorsByTimeSlotV2Document = "\n    query SearchDoctorsByTimeSlotV2($request: TimeSlotBasedDoctorSearchMutationRequestInput!, $diagnosisType: DiagnosisType, $diagnosisTypeId: ID) {\n  searchDoctorsByTimeSlotV2(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospital {\n        hospitalName\n      }\n      id\n      publicId\n      isAffiliated\n      medicineType\n      doctorName\n      profileUrl\n      medicineType\n      professionalDepartments {\n        professionalDepartmentName\n      }\n      readyForVideoCall\n      reviewMetric(diagnosisType: $diagnosisType, diagnosisTypeId: $diagnosisTypeId) {\n        averageRating\n        totalCount\n      }\n    }\n  }\n}\n    ";
var useSearchDoctorsByTimeSlotV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByTimeSlotV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByTimeSlotV2Document, "SearchDoctorsByTimeSlotV2", variables), options);
};
useSearchDoctorsByTimeSlotV2Query.getKey = function(variables) {
    return [
        "SearchDoctorsByTimeSlotV2",
        variables
    ];
};
useSearchDoctorsByTimeSlotV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByTimeSlotV2Document, "SearchDoctorsByTimeSlotV2", variables, options);
};
var GetDiagnosisCategoriesV2Document = "\n    query GetDiagnosisCategoriesV2($contactType: DiagnosisContactType!) {\n  getDiagnosisCategoriesV2(contactType: $contactType) {\n    popularDepartmentCategories {\n      id\n      name\n    }\n    departmentCategories {\n      id\n      name\n      iconUrl\n      description\n    }\n    popularTreatmentCategories {\n      id\n      name\n    }\n    treatmentCategories {\n      id\n      name\n      iconUrl\n      items {\n        id\n        name\n      }\n    }\n  }\n}\n    ";
var useGetDiagnosisCategoriesV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDiagnosisCategoriesV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables), options);
};
useGetDiagnosisCategoriesV2Query.getKey = function(variables) {
    return [
        "GetDiagnosisCategoriesV2",
        variables
    ];
};
useGetDiagnosisCategoriesV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables, options);
};


/***/ }),

/***/ 71213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_molecules_login_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26326);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98266);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4415);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74701);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10712);









var useAuthModal = function() {
    var canOverlayClick = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, isWritePage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showAuthModal = ref[0], setShowAuthModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), redirectUrl = ref1[0], setRedirectUrl = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), customTitle = ref2[0], setCustomTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), customMessage = ref3[0], setCustomMessage = ref3[1];
    var ref4 = (0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), showModal = ref4.showModal, closeModal = ref4.closeModal;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        campaign: "",
        content: "",
        buttonText: ""
    }), trackInfo = ref5[0], setTrackInfo = ref5[1];
    var isRouteBackPath = router.pathname.includes("/content/qna/write");
    var onClickCancel = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_5__/* .clearReturnUrl */ .z9)();
        setShowAuthModal(false);
        setRedirectUrl(undefined);
        setCustomTitle(undefined);
        setCustomMessage(undefined);
        closeModal();
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .isWebView */ .vp)() && isRouteBackPath) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .historyBack */ .$i)();
        }
    }, [
        closeModal,
        isRouteBackPath
    ]);
    var onClickLogin = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_LOGIN */ .nn.MOVE_TO_LOGIN);
            (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_5__/* .clearReturnUrl */ .z9)();
            setShowAuthModal(false);
            setRedirectUrl(undefined);
            setCustomTitle(undefined);
            setCustomMessage(undefined);
            closeModal();
        }
    };
    var handleShowAuthModal = function(show, url, customTitle, customMessage) {
        setShowAuthModal(show);
        if (url) {
            setRedirectUrl(url);
        }
        if (customTitle) {
            setCustomTitle(customTitle);
        }
        if (customMessage) {
            setCustomMessage(customMessage);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showAuthModal) {
            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
                eventName: "sns_login",
                pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router)
            });
            if (!(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_8__/* .isWebView */ .vp)()) {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_6__/* .MODAL_TYPE.BASIC */ .f.BASIC,
                    props: {
                        body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_login_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isWritePage: isWritePage,
                            onClick: onClickCancel,
                            redirectUrl: redirectUrl,
                            customTitle: customTitle,
                            customMessage: customMessage
                        }),
                        onClickOverlay: canOverlayClick ? onClickCancel : undefined
                    }
                });
            } else {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_6__/* .MODAL_TYPE.ALERT */ .f.ALERT,
                    props: {
                        title: customTitle || "로그인이 필요해요",
                        message: customMessage || "서비스 이용을 위해 로그인해 주세요.",
                        buttons: [
                            {
                                label: "닫기",
                                onClick: function() {
                                    return onClickCancel();
                                }
                            },
                            {
                                type: _types_modal__WEBPACK_IMPORTED_MODULE_6__/* .MODAL_BUTTON_TYPE.PRIMARY */ .J.PRIMARY,
                                label: "로그인",
                                onClick: function() {
                                    return onClickLogin();
                                }
                            }, 
                        ]
                    }
                });
            }
        }
    }, [
        showAuthModal,
        redirectUrl,
        customTitle,
        customMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    return {
        setShowAuthModal: handleShowAuthModal,
        setTrackInfo: setTrackInfo,
        trackInfo: trackInfo
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModal);


/***/ }),

/***/ 27728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useIsMounted = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsMounted(true);
        return function() {
            setIsMounted(false);
        };
    }, []);
    return isMounted;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMounted);


/***/ }),

/***/ 8202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_logs_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78081);
/* harmony import */ var _utils_firebase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59334);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_report__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80162);






var useLogger = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var pageViewLog = function(userAgent, payloadParams) {
        var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
        var envParameters = _utils_firebase__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserServiceEnvironmentProperty */ .Z.getUserServiceEnvironmentProperty(userAgent);
        /* DD는 페이지뷰 자동 수집이라 GA만 수집*/ (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .mobileLogger */ .Pp)({
            logger: {
                eventName: _constants_logs_common__WEBPACK_IMPORTED_MODULE_1__/* .CommonLoggerEventName.PageView */ .q.PageView,
                pageName: pageName,
                payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router.query, payloadParams, envParameters)
            }
        });
    };
    var log = function(params, options) {
        var ref = options || {
            googleAnalytics: true,
            datadogRum: true
        }, _googleAnalytics = ref.googleAnalytics, googleAnalytics = _googleAnalytics === void 0 ? true : _googleAnalytics, _datadogRum = ref.datadogRum, datadogRum = _datadogRum === void 0 ? true : _datadogRum;
        var eventName = params.eventName, payload = params.payload;
        var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
        if (googleAnalytics) {
            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .mobileLogger */ .Pp)({
                logger: {
                    eventName: eventName,
                    pageName: pageName,
                    payload: payload ? typeof payload === "function" ? payload() : payload : undefined
                }
            });
        }
        if (datadogRum) {
            // DataDog에는 원래 eventName 그대로 전송
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_4__/* .addActionForRum */ .xr)(eventName, payload ? typeof payload === "function" ? payload() : payload : undefined);
        }
    };
    return {
        log: log,
        pageView: pageViewLog
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogger);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                })
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 85180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useNavigate; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/types/navigate.ts
var DoctornowWebViewType;
(function(DoctornowWebViewType) {
    DoctornowWebViewType["SafeAreaView"] = "SafeAreaView";
    DoctornowWebViewType["BottomSafeAreaView"] = "BottomSafeAreaView";
    DoctornowWebViewType["KeyboardAvoidingView"] = "KeyboardAvoidingView";
})(DoctornowWebViewType || (DoctornowWebViewType = {}));

// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/hooks/useNavigator.ts
var useNavigator = __webpack_require__(35613);
;// CONCATENATED MODULE: ./src/hooks/useNavigate.ts







/**
 * webview wrapper options
 * safeAreaView / bottomSafeAreaView / keyboardAvoidingView
 * @param webViewType DoctornowWebViewType
 * @default DoctornowWebViewType.BottomSafeAreaView
 *
 * webview options
 * @param scrollEnabled boolean
 * @default true
 *
 * @param bounces boolean
 * @default true
 *
 * @param keyboardDisplayRequiresUserAction boolean
 * @default true
 *
 * @param hideKeyboardAccessoryView boolean
 * @default false
 *
 * bottomSheet options
 * @param hasTelemedicineBottomSheet boolean
 * @default false
 */ var useNavigate = function() {
    var navigator = (0,useNavigator/* default */.Z)();
    var navigateToBack = function() {
        return navigator.back();
    };
    var navigateToDietInjection = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.DOCTOR.FACE_TO_FACE_PREFERENCE_STEP.path */.Z6.DOCTOR.FACE_TO_FACE_PREFERENCE_STEP.path
        });
    };
    var navigateToFindPharmacy = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.PHARMACIES.PHARMACIES_FIND.pathName */.Z6.PHARMACIES.PHARMACIES_FIND.pathName
        });
    };
    var navigateToEmergencyContraceptive = function(param) {
        var categoryId = param.categoryId, type = param.type;
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.F2F_LIST.appScreenName */.Z6.DOCTOR.F2F_LIST.appScreenName,
            params: {
                categoryId: categoryId,
                type: type
            }
        });
    };
    var navigateToQnaDetail = function(_param) {
        var questionPid = _param.questionPid, params = (0,_object_without_properties/* default */.Z)(_param, [
            "questionPid"
        ]);
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            params: params
        });
    };
    var navigateToNps = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.QNA.NPS.path */.Z6.QNA.NPS.path
        });
    };
    var navigateToHospitalSearch = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path,
            params: params
        });
    };
    var navigateToMagazineTagList = function(param) {
        var tagName = param.tagName;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MAGAZINE.TAG.path */.Z6.MAGAZINE.TAG.path, "?tag=").concat(tagName)
        });
    };
    var navigateToHospitalDetail = function(_param) {
        var hospitalPid = _param.hospitalPid, props = (0,_object_without_properties/* default */.Z)(_param, [
            "hospitalPid"
        ]);
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path, "/").concat(hospitalPid),
            params: (0,_object_spread/* default */.Z)({
                webViewType: DoctornowWebViewType.KeyboardAvoidingView
            }, props)
        });
    };
    var navigateToMagazineHome = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.MAGAZINE.HOME.path */.Z6.MAGAZINE.HOME.path
        });
    };
    var navigateToMagazineDetail = function(param) {
        var magazinePid = param.magazinePid;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid)
        });
    };
    var navigateToQnaDetailWithJumpToQnaTab = function(_param) {
        var questionPid = _param.questionPid, params = (0,_object_without_properties/* default */.Z)(_param, [
            "questionPid"
        ]);
        return navigator.jumpToScreen({
            tabName: "QuickAnswerTab",
            url: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            params: params
        });
    };
    var navigateHomeWithJumpToHomeTab = function(params) {
        return navigator.jumpToAppScreen({
            tabName: "HomeTab",
            screenName: common/* ROUTES.HOME.appScreenName */.Z6.HOME.appScreenName,
            params: params
        });
    };
    var navigateToTreatmentRequest = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.TREATMENT_REQUEST.TREATMENT_REQUEST.appScreenName */.Z6.TREATMENT_REQUEST.TREATMENT_REQUEST.appScreenName,
            params: params
        });
    };
    var navigateCategorySelectWithJumpToHomeTab = function() {
        return navigator.jumpToAppScreen({
            tabName: "HomeTab",
            screenName: common/* ROUTES.DIAGNOSIS.CATEGORY_SELECT.appScreenName */.Z6.DIAGNOSIS.CATEGORY_SELECT.appScreenName
        });
    };
    var navigateToCategorySelect = function() {
        return navigator.navigateAppScreen({
            screenName: "CategorySelectScreen"
        });
    };
    var navigateToFamilyRegister = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.FAMILY.REGISTER.path */.Z6.FAMILY.REGISTER.path,
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                webViewType: DoctornowWebViewType.KeyboardAvoidingView,
                keyboardDisplayRequiresUserAction: false,
                hideKeyboardAccessoryView: true
            })
        });
    };
    var navigateToMedicineDictionaryDetail = function(param) {
        var medicineDictionaryPid = param.medicineDictionaryPid, keyword = param.keyword;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(medicineDictionaryPid, "/").concat(encodeURIComponent(keyword))
        });
    };
    var navigateToDiseaseEncyclopediaDetail = function(param) {
        var diseaseEncyclopediaPid = param.diseaseEncyclopediaPid, keyword = param.keyword;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path */.Z6.DISEASE_ENCYCLOPEDIA.DETAIL.path, "/").concat(diseaseEncyclopediaPid, "/").concat(encodeURIComponent(keyword))
        });
    };
    var navigateToMagazineAuthorDetail = function(param) {
        var authorPublicId = param.authorPublicId;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.AUTHOR.DETAIL.path */.Z6.AUTHOR.DETAIL.path, "/").concat(authorPublicId)
        });
    };
    var navigateToQnaTagList = function(param) {
        var questionTagId = param.questionTagId, tagName = param.tagName;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.QNA.TAG.path */.Z6.QNA.TAG.path, "/").concat(questionTagId, "?tagName=").concat(tagName)
        });
    };
    var navigateToQnaList = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path,
            params: params
        });
    };
    var navigateToHomeSearchResult = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.SEARCH */.Z6.SEARCH(params === null || params === void 0 ? void 0 : params.keyword, params === null || params === void 0 ? void 0 : params.tab).SEARCH_RESULT.path,
            params: params
        });
    };
    var navigateToQnaWrite = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path
        });
    };
    var navigateToPureWebViewAppScreen = function(params) {
        var _headerTitle;
        return navigator.pushAppScreen({
            screenName: "PureWebViewScreen",
            params: {
                uri: params.uri,
                headerTitle: (_headerTitle = params.headerTitle) !== null && _headerTitle !== void 0 ? _headerTitle : ""
            }
        });
    };
    var navigateToExternalBrowser = function(param) {
        var url = param.url;
        return navigator.openExternalBrowser({
            url: url
        });
    };
    var navigateMedicineDictionaryDetail = function(param) {
        var url = param.url;
        return navigator.pushScreen({
            url: url
        });
    };
    var navigatePharmacyReviewAppScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PHARMACIES.PHARMACIES_REVIEW.appScreenName */.Z6.PHARMACIES.PHARMACIES_REVIEW.appScreenName,
            params: {
                pharmacyPid: params.pharmacyPid,
                longitude: params.longitude,
                latitude: params.latitude
            }
        });
    };
    var navigateToNonBenefitTreatmentMedicineDetail = function(param) {
        var treatmentMedicineId = param.treatmentMedicineId;
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.NON_BENEFIT.TREATMENT_MEDICINE_DETAIL.path */.Z6.NON_BENEFIT.TREATMENT_MEDICINE_DETAIL.path, "/").concat(treatmentMedicineId)
        });
    };
    var navigateToKakaoPayWebViewScreen = function(param) {
        var url = param.url, transactionId = param.transactionId;
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.KAKAOPAY.HOME.appScreenName */.Z6.KAKAOPAY.HOME.appScreenName,
            params: {
                url: url,
                transactionId: transactionId
            }
        });
    };
    var navigateToDoctorDetail = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.DETAIL.appScreenName */.Z6.DOCTOR.DETAIL.appScreenName,
            params: params
        });
    };
    var navigateToHospitalEventPage = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.HOSPITAL.EVENT.path */.Z6.HOSPITAL.EVENT.path,
            params: params
        });
    };
    var navigateToPharmacyDetail = function(_param) {
        var pharmacyId = _param.pharmacyId, params = (0,_object_without_properties/* default */.Z)(_param, [
            "pharmacyId"
        ]);
        return navigator.pushScreen({
            url: "".concat(common/* ROUTES.PHARMACIES.PHARMACIES_DETAIL.path */.Z6.PHARMACIES.PHARMACIES_DETAIL.path, "/").concat(pharmacyId),
            params: params
        });
    };
    var navigateToDoctorListAppScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.LIST.appScreenName */.Z6.DOCTOR.LIST.appScreenName,
            params: params
        });
    };
    var navigateToDiagnosisCategorySelectAppScreen = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DIAGNOSIS.CATEGORY_SELECT.appScreenName */.Z6.DIAGNOSIS.CATEGORY_SELECT.appScreenName
        });
    };
    var navigateToPrescriptionSendImageCheckAppScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PHARMACIES.PRESCRIPTION_SEND_IMAGE_CHECK.appScreenName */.Z6.PHARMACIES.PRESCRIPTION_SEND_IMAGE_CHECK.appScreenName,
            params: params
        });
    };
    var navigateToPointHistory = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.POINT_MARKET.HISTORY.appScreenName */.Z6.POINT_MARKET.HISTORY.appScreenName
        });
    };
    var navigateToPointMarketList = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.POINT_MARKET.LIST.appScreenName */.Z6.POINT_MARKET.LIST.appScreenName
        });
    };
    var navigateToMyInvitationCodeScreen = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.MY_INVITATION_CODE.appScreenName */.Z6.MY_INVITATION_CODE.appScreenName
        });
    };
    var navigateToPointMarketCertificationScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.POINT_MARKET.CERTIFICATION.appScreenName */.Z6.POINT_MARKET.CERTIFICATION.appScreenName,
            params: params
        });
    };
    var navigateToPrescriptionSendFaxInputWebViewScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PRESCRIPTION.FAX_INPUT.appScreenName */.Z6.PRESCRIPTION.FAX_INPUT.appScreenName,
            params: params
        });
    };
    var navigateToPrescriptionReselectReasonWebViewScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PRESCRIPTION.RESELECT_REASON.appScreenName */.Z6.PRESCRIPTION.RESELECT_REASON.appScreenName,
            params: params
        });
    };
    var navigateToSearchRequestDetailInfo = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.SEARCH */.Z6.SEARCH().REQUEST_DETAIL_INFO.path,
            params: params
        });
    };
    var navigateToPrescriptionFailWebViewScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PRESCRIPTION.FAIL.appScreenName */.Z6.PRESCRIPTION.FAIL.appScreenName,
            params: params
        });
    };
    var navigateToPrescriptionSendFaxCheckWebViewScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PRESCRIPTION.FAX_CHECK.appScreenName */.Z6.PRESCRIPTION.FAX_CHECK.appScreenName,
            params: params
        });
    };
    var navigateToAdditionalOrder = function(params) {
        return navigator.pushScreen({
            url: common/* ROUTES.ADDITIONAL_ORDER.path */.Z6.ADDITIONAL_ORDER.path,
            params: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                mainTagTypes: JSON.stringify(params.mainTagTypes),
                medicineRequestInfos: JSON.stringify(params.medicineRequestInfos)
            })
        });
    };
    var navigateToSelectedScreenWithResetNavigation = function(params) {
        return (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.RESET_NAVIGATION_TO_SELECTED_SCREEN */.nn.RESET_NAVIGATION_TO_SELECTED_SCREEN, {
            screenName: params.screenName
        });
    };
    var navigateToPaymentScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.PAYMENT.appScreenName */.Z6.PAYMENT.appScreenName,
            params: params
        });
    };
    var navigateToSplashAppScreen = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.COMMON.SPLASH.appScreenName */.Z6.COMMON.SPLASH.appScreenName
        });
    };
    var navigateToUpdateAppScreen = function() {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.COMMON.UPDATE.appScreenName */.Z6.COMMON.UPDATE.appScreenName
        });
    };
    var navigateToF2FDoctorListAppScreen = function(params) {
        return navigator.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.F2F_LIST.appScreenName */.Z6.DOCTOR.F2F_LIST.appScreenName,
            params: params
        });
    };
    var navigateToRegisterCardScreen = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.CARD.REGISTER.path */.Z6.CARD.REGISTER.path
        });
    };
    var navigateToKakaoPayScreen = function(param) {
        var url = param.url, transactionId = param.transactionId;
        return navigator.pushScreen({
            url: url,
            params: {
                transactionId: transactionId
            }
        });
    };
    var navigateToTelemedicineRequestScreen = function(param) {
        var categoryId = param.categoryId, type = param.type;
        return navigator.pushScreen({
            url: common/* ROUTES.TELEMEDICINE.REQUEST.path */.Z6.TELEMEDICINE.REQUEST.path,
            params: {
                categoryId: categoryId,
                type: type
            }
        });
    };
    var navigateToTelemedicineCategoriesScreen = function() {
        return navigator.pushScreen({
            url: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path
        });
    };
    var navigateToSearchHomeScreen = function(param) {
        var keyword = param.keyword, tab = param.tab;
        navigator.pushScreen({
            url: common/* ROUTES.SEARCH */.Z6.SEARCH().HOME.path,
            params: {
                keyword: keyword,
                tab: tab
            }
        });
    };
    return {
        navigateToBack: navigateToBack,
        navigateToSplashAppScreen: navigateToSplashAppScreen,
        navigateToUpdateAppScreen: navigateToUpdateAppScreen,
        navigateToFindPharmacy: navigateToFindPharmacy,
        navigateToEmergencyContraceptive: navigateToEmergencyContraceptive,
        navigateToQnaDetail: navigateToQnaDetail,
        navigateToNps: navigateToNps,
        navigateToHospitalSearch: navigateToHospitalSearch,
        navigateToMagazineTagList: navigateToMagazineTagList,
        navigateToHospitalDetail: navigateToHospitalDetail,
        navigateToMagazineHome: navigateToMagazineHome,
        navigateToMagazineDetail: navigateToMagazineDetail,
        navigateToQnaDetailWithJumpToQnaTab: navigateToQnaDetailWithJumpToQnaTab,
        navigateHomeWithJumpToHomeTab: navigateHomeWithJumpToHomeTab,
        navigateToTreatmentRequest: navigateToTreatmentRequest,
        navigateCategorySelectWithJumpToHomeTab: navigateCategorySelectWithJumpToHomeTab,
        navigateToCategorySelect: navigateToCategorySelect,
        navigateToFamilyRegister: navigateToFamilyRegister,
        navigateToDietInjection: navigateToDietInjection,
        navigateToMedicineDictionaryDetail: navigateToMedicineDictionaryDetail,
        navigateToMagazineAuthorDetail: navigateToMagazineAuthorDetail,
        navigateToDiseaseEncyclopediaDetail: navigateToDiseaseEncyclopediaDetail,
        navigateToQnaTagList: navigateToQnaTagList,
        navigateToQnaList: navigateToQnaList,
        navigateToHomeSearchResult: navigateToHomeSearchResult,
        navigateToQnaWrite: navigateToQnaWrite,
        navigateToPureWebViewAppScreen: navigateToPureWebViewAppScreen,
        navigateMedicineDictionaryDetail: navigateMedicineDictionaryDetail,
        navigatePharmacyReviewAppScreen: navigatePharmacyReviewAppScreen,
        navigateToExternalBrowser: navigateToExternalBrowser,
        navigateToNonBenefitTreatmentMedicineDetail: navigateToNonBenefitTreatmentMedicineDetail,
        navigateToKakaoPayWebViewScreen: navigateToKakaoPayWebViewScreen,
        navigateToDoctorDetail: navigateToDoctorDetail,
        navigateToHospitalEventPage: navigateToHospitalEventPage,
        navigateToPharmacyDetail: navigateToPharmacyDetail,
        navigateToDoctorListAppScreen: navigateToDoctorListAppScreen,
        navigateToDiagnosisCategorySelectAppScreen: navigateToDiagnosisCategorySelectAppScreen,
        navigateToPrescriptionSendImageCheckAppScreen: navigateToPrescriptionSendImageCheckAppScreen,
        navigateToPointHistory: navigateToPointHistory,
        navigateToPointMarketList: navigateToPointMarketList,
        navigateToMyInvitationCodeScreen: navigateToMyInvitationCodeScreen,
        navigateToPointMarketCertificationScreen: navigateToPointMarketCertificationScreen,
        navigateToPrescriptionSendFaxInputWebViewScreen: navigateToPrescriptionSendFaxInputWebViewScreen,
        navigateToPrescriptionReselectReasonWebViewScreen: navigateToPrescriptionReselectReasonWebViewScreen,
        navigateToSearchRequestDetailInfo: navigateToSearchRequestDetailInfo,
        navigateToPrescriptionFailWebViewScreen: navigateToPrescriptionFailWebViewScreen,
        navigateToPrescriptionSendFaxCheckWebViewScreen: navigateToPrescriptionSendFaxCheckWebViewScreen,
        navigateToAdditionalOrder: navigateToAdditionalOrder,
        navigateToSelectedScreenWithResetNavigation: navigateToSelectedScreenWithResetNavigation,
        navigateToPaymentScreen: navigateToPaymentScreen,
        navigateToF2FDoctorListAppScreen: navigateToF2FDoctorListAppScreen,
        navigateToRegisterCardScreen: navigateToRegisterCardScreen,
        navigateToKakaoPayScreen: navigateToKakaoPayScreen,
        navigateToTelemedicineRequestScreen: navigateToTelemedicineRequestScreen,
        navigateToTelemedicineCategoriesScreen: navigateToTelemedicineCategoriesScreen,
        navigateToSearchHomeScreen: navigateToSearchHomeScreen
    };
};
/* harmony default export */ var hooks_useNavigate = (useNavigate);


/***/ }),

/***/ 35613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74735);






var NavigatorType;
(function(NavigatorType) {
    NavigatorType["PushScreen"] = "PUSH_SCREEN";
    NavigatorType["ReplaceScreen"] = "REPLACE_SCREEN";
    NavigatorType["PopToTop"] = "POP_TO_TOP";
    NavigatorType["Back"] = "BACK";
    NavigatorType["JumpTo"] = "JUMP_TO";
    NavigatorType["Navigate"] = "NAVIGATE";
})(NavigatorType || (NavigatorType = {}));
var useNavigator = function() {
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), push = _ref.push, replace = _ref.replace, routerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "push",
        "replace"
    ]);
    var query = routerProps.query;
    var pushScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.PushScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var popToTopScreen = function(url, options) {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "?routeType=".concat(NavigatorType.PopToTop));
        }
        if (!url) {
            return;
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push(url);
    };
    var jumpToScreen = function(param, options) {
        var tabName = param.tabName, params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                tabName: tabName,
                routeType: NavigatorType.JumpTo,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var replaceScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.ReplaceScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var navigateScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.Navigate,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var back = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", (0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)({
                routeType: NavigatorType.Back
            }));
        }
        return window.history.back();
    };
    var pushAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var jumpToAppScreen = function(param) {
        var tabName = param.tabName, screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */ .nn.MOVE_TO_TAB_HOME, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tabName: tabName,
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var replaceAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var navigateAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.NAVIGATE_TO_PAGE */ .nn.NAVIGATE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var openExternalBrowser = function(param) {
        var url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */ .nn.OPEN_EXTERNAL_BROWSER, {
                url: url
            });
        }
        return window.open(url);
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, routerProps), {
        query: query,
        push: push,
        pushScreen: pushScreen,
        popToTopScreen: popToTopScreen,
        jumpToScreen: jumpToScreen,
        replace: replace,
        replaceScreen: replaceScreen,
        navigateScreen: navigateScreen,
        pushAppScreen: pushAppScreen,
        jumpToAppScreen: jumpToAppScreen,
        replaceAppScreen: replaceAppScreen,
        navigateAppScreen: navigateAppScreen,
        back: back,
        openExternalBrowser: openExternalBrowser
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useNavigator);


/***/ }),

/***/ 18044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sw": function() { return /* binding */ CardPayCompany; },
  "UO": function() { return /* binding */ DoctorMedicineType; },
  "G$": function() { return /* binding */ InviterInfoModel; },
  "IX": function() { return /* binding */ UserAddressType; },
  "Ph": function() { return /* binding */ UserAddressesInfo; },
  "_u": function() { return /* binding */ UserPaymentsInfo; },
  "h6": function() { return /* binding */ UserProfileRelationType; },
  "kl": function() { return /* binding */ UserProfiles; },
  "c5": function() { return /* binding */ UserTelemedicineEligibleGroupType; },
  "tz": function() { return /* binding */ treatmentRequestAgreements; }
});

// UNUSED EXPORTS: UserProfile

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/assets/card-company/bc.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgBc = function SvgBc(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-15.151-2.368a1.544 1.544 0 0 0-1.03-.19c.655-.698 1.011-1.457 1.011-2.224.001-.07-.002-.141-.01-.211-.035-.477-.255-.833-.594-.955-.34-.121-.966-.063-1.959.951l-.595.667c-.166.201-.792 1.149-.907 2.137a12.494 12.494 0 0 0 .363 4.84c.05.167.21.593.594.748.41.167.798-.033 1.141-.211l.092-.045.355-.159.343-.151.42-.185c.31-.107.6-.265.859-.468.366-.313.635-.724.773-1.186.076-.26.125-.529.146-.8a3.762 3.762 0 0 0-.041-1.076c-.195-.87-.628-1.286-.961-1.482Zm-3.182 1.254.019.22a.112.112 0 0 0 .19.09c.373-.313.937-.593 1.392-.436.356.123.598.49.725 1.09.258 1.263-.607 1.871-1.146 2.118l-.019.008-.69.333a.109.109 0 0 1-.083 0c-.043-.021-.055-.05-.084-.125a14.596 14.596 0 0 1-.454-5.257.906.906 0 0 1 .167-.408l.58-.618.065-.071c.314-.307.61-.46.77-.393.134.056.167.268.167.436.029.903-.478 1.832-1.537 2.822a.224.224 0 0 0-.062.191ZM18.093 7.53c.092.027.41.167.603.833.062.273-.226.195-.226.195a4.022 4.022 0 0 0-2.124-.26c-.953.144-1.742.603-2.223 1.298a3.156 3.156 0 0 0-.45 2.485c.443 2.126 2.227 3.21 4.547 2.764.904-.179 1.627-.562 2.102-1.111.015-.018.087-.097.156-.097.097 0 .155.04.194.176.073.24.114.488.121.738a1 1 0 0 1-.333.783 5.484 5.484 0 0 1-2.455 1.153c-1.686.353-3.261.11-4.447-.688a4.469 4.469 0 0 1-1.889-3.007 4.596 4.596 0 0 1 .825-3.57 4.9 4.9 0 0 1 3.068-1.858 5.301 5.301 0 0 1 2.531.166Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var bc = (SvgBc);
;// CONCATENATED MODULE: ./src/assets/card-company/citi.svg
var citi_path, _path2;
function citi_extends() { return citi_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, citi_extends.apply(null, arguments); }

var SvgCiti = function SvgCiti(props) {
  return /*#__PURE__*/react.createElement("svg", citi_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), citi_path || (citi_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.338 13.4a7.798 7.798 0 0 0-2.753-2.5 7.486 7.486 0 0 0-3.555-.9 7.487 7.487 0 0 0-3.555.9 7.798 7.798 0 0 0-2.753 2.5l-.074.11h1.826l.02-.022a6.23 6.23 0 0 1 2.065-1.504 6.036 6.036 0 0 1 4.943 0c.78.35 1.482.861 2.064 1.504l.02.022h1.826l-.074-.11Z",
    fill: "#E60012"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m10.923 20.484-.034.036c-.562.592-1.21.906-1.878.906-1.396 0-2.41-1.086-2.41-2.582 0-1.497 1.014-2.587 2.41-2.587.668 0 1.316.314 1.878.907l.034.036.897-1.124-.023-.031c-.747-.915-1.643-1.359-2.744-1.359-1.1 0-2.116.385-2.848 1.074-.792.753-1.21 1.815-1.21 3.074 0 1.26.418 2.321 1.21 3.074.727.698 1.737 1.082 2.848 1.082 1.111 0 1.997-.445 2.744-1.36l.023-.03-.897-1.116ZM14.313 14.82h-1.585v8.027h1.585V14.82ZM20.527 21.1a2.234 2.234 0 0 1-1.166.403c-.518 0-.744-.281-.744-.905v-4.26h1.616v-1.511h-1.621v-2.498l-1.554.863v1.635h-1.342v1.511h1.342v4.531c0 1.234.706 2.078 1.758 2.1a2.42 2.42 0 0 0 1.408-.368l.015-.012.382-1.547-.094.058ZM23.426 14.82H21.84v8.027h1.586V14.82ZM26.864 13.823a.754.754 0 0 1-.12.408.715.715 0 0 1-.317.27.686.686 0 0 1-.773-.16.76.76 0 0 1-.153-.8.73.73 0 0 1 .262-.33.69.69 0 0 1 .394-.123.67.67 0 0 1 .504.211.723.723 0 0 1 .203.524Zm.136 0a.897.897 0 0 0-.142-.487.852.852 0 0 0-.378-.323.817.817 0 0 0-.921.19.905.905 0 0 0-.183.954.87.87 0 0 0 .312.393c.139.096.302.147.47.147a.8.8 0 0 0 .6-.252.861.861 0 0 0 .242-.622Zm-.458-.207a.29.29 0 0 0-.087-.215.269.269 0 0 0-.214-.072h-.404v.953h.156v-.368h.177l.18.368h.185l-.189-.386a.258.258 0 0 0 .147-.103.276.276 0 0 0 .049-.177Zm-.158 0c0 .095-.064.134-.148.134h-.243v-.268h.243a.124.124 0 0 1 .104.032.134.134 0 0 1 .044.102Z",
    fill: "#004187"
  })));
};
/* harmony default export */ var citi = (SvgCiti);
;// CONCATENATED MODULE: ./src/assets/card-company/etc.svg
var etc_path, etc_path2, _path3;
function etc_extends() { return etc_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, etc_extends.apply(null, arguments); }

var SvgEtc = function SvgEtc(props) {
  return /*#__PURE__*/react.createElement("svg", etc_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), etc_path || (etc_path = /*#__PURE__*/react.createElement("path", {
    opacity: 0.46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.636 16c0-.904-.732-1.636-1.636-1.636h-1.091v-1.091a1.636 1.636 0 0 0-3.273 0V16a1.637 1.637 0 0 0 1.637 1.636H19c.904 0 1.636-.732 1.636-1.636Z",
    fill: "#fff"
  })), etc_path2 || (etc_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.91 16c0 .904.732 1.636 1.636 1.636h1.09v1.091a1.636 1.636 0 0 0 3.273 0V16a1.637 1.637 0 0 0-1.636-1.636h-2.727c-.904 0-1.637.732-1.637 1.636Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.727 5.09H10.04a3.722 3.722 0 0 0-3.722 3.723v1.357a2.318 2.318 0 1 0 2.59-.092V8.813c.001-.625.508-1.131 1.133-1.131h5.686a8.454 8.454 0 1 1 0 16.909H10.04a1.131 1.131 0 0 1-1.13-1.131v-1.266a2.318 2.318 0 1 0-2.59-.092v1.358a3.722 3.722 0 0 0 3.72 3.722h5.687c6.1 0 11.046-4.945 11.046-11.046 0-6.1-4.945-11.045-11.046-11.045Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var etc = (SvgEtc);
;// CONCATENATED MODULE: ./src/assets/card-company/hana.svg
var hana_path, hana_path2;
function hana_extends() { return hana_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, hana_extends.apply(null, arguments); }

var SvgHana = function SvgHana(props) {
  return /*#__PURE__*/react.createElement("svg", hana_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hana_path || (hana_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.636 18.063a3.723 3.723 0 0 0-.261-.892 4.342 4.342 0 0 0-1.764-2.05 3.943 3.943 0 0 0-4.1.025 3.588 3.588 0 0 0-1.595 2.066 4.418 4.418 0 0 0 .277 3.445c.189.323.479.576.825.718a1.185 1.185 0 0 0 1.066-.082 1.132 1.132 0 0 0 .4-1.194 3.075 3.075 0 0 1 .041-1.667c.062-.176.162-.337.293-.471.082-.08.178-.146.282-.195.218-.11.465-.15.707-.113a1.343 1.343 0 0 1 .943.77c.168.39.255.81.257 1.235a18.542 18.542 0 0 1-.82 5.52c-.047.185-.098.365-.15.544-.05.18-.112.318 0 .456.043.055.1.098.165.123.276.113.512-.056.681-.24a9.806 9.806 0 0 0 2.246-3.927c.18-.539.323-1.088.43-1.646a7.176 7.176 0 0 0 .083-2.44M27.373 9.548a.472.472 0 0 0-.513-.45c-.264.037-.52.119-.758.24-4.753 1.805-10.11 2.148-15.118 1.425-.856-.123-1.723-.292-2.563-.43-.513-.082-1.072-.205-1.615-.246a1.937 1.937 0 0 0-1.415.271 1.486 1.486 0 0 0-.18 1.769 3.968 3.968 0 0 0 1.538 1.487c.59.42 1.29.659 2.015.687a85.82 85.82 0 0 0 5.726-.554c3.245-.42 6.665-.82 9.69-2.076 1.012-.4 1.965-.934 2.834-1.59.154-.117.38-.312.38-.512",
    fill: "#fff"
  })), hana_path2 || (hana_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13.742 7.919a1.871 1.871 0 0 0 3.737 0 1.027 1.027 0 0 0-.097-.446c-.159-.344-.344-.513-.323-.913 0-.548-.682-.559-1.061-.559a2.732 2.732 0 0 0-1.225.247 1.877 1.877 0 0 0-1.026 1.63v.04",
    fill: "#fff"
  })));
};
/* harmony default export */ var hana = (SvgHana);
;// CONCATENATED MODULE: ./src/assets/card-company/hyundai.svg
var hyundai_path;
function hyundai_extends() { return hyundai_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, hyundai_extends.apply(null, arguments); }

var SvgHyundai = function SvgHyundai(props) {
  return /*#__PURE__*/react.createElement("svg", hyundai_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hyundai_path || (hyundai_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.041 12A2.043 2.043 0 0 0 3 14.041v5.461h.68v-5.46a1.36 1.36 0 0 1 1.361-1.362h22.012a1.361 1.361 0 0 1 1.36 1.361v5.461h.681v-5.46A2.043 2.043 0 0 0 27.053 12H5.041Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var hyundai = (SvgHyundai);
;// CONCATENATED MODULE: ./src/assets/card-company/jeju.svg
var jeju_path, _g;
function jeju_extends() { return jeju_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, jeju_extends.apply(null, arguments); }

var SvgJeju = function SvgJeju(props) {
  return /*#__PURE__*/react.createElement("svg", jeju_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "jeju_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, jeju_path || (jeju_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.743 24.477c-1.103-.109-2.421-.456-3.571-1.453-1.058-.91-1.712-2.165-2.03-3.271-.325-1.13-.462-2.45.075-2.344.166.03.452.757.762 1.284.32.545.581.848.824 1.033.112.084.489-.754 1.038-1.232.319-.266.664-.355.726.432.065.962-.108 2.108.175 2.108.258 0 .853-.197 2.154-.308.492-.042.772.051.304.707-.233.33-.544.793-1.283 1.325 1.107 1.037 2.433.91 2.459 1.351.014.254-.48.395-1.13.395-.16 0-.329-.01-.503-.028m3.725-9.315c-1.014-.211-1.221-1.131-1.221-1.131-.084-.325-.103-.735-.035-1.258.137-1.092.432-1.603.767-2.451.452-1.137-.645-1.802-.466-2.219.248-.565 1.03.154 1.907.207.753.04 1.206.005 1.79.084.779.101 1.712.366 2.126.853.38.446-.203.988-.898.65-.51-.25-1.152-.098-.776.434.452.505.67.52 1.134.64 1.274.337 1.3 1.56.436 2.188-.978.719-1.976.42-2.371-.987-.2-.704-.695-1.06-1.205-.86-.504.198-.205 1.123.18 1.98.665 1.7-.68 1.88-1.196 1.88-.082 0-.142-.004-.172-.008m-.731 9.634c-.009-.225.32-.282.32-.282 2.959-.584 2.094-2.524 1.048-3.513-.441-.415-4.558-3.97-4.558-3.97-3.925-3.381-3.61-6.018-3.61-6.018.193-3.248 3.031-4.054 5.183-3.866.252.022.393.172.345.386-.044.229-.379.244-.379.244-.684.04-1.296.108-1.761.424-1.732 1.166-1.225 3.15 1.087 5.357.292.276.6.571.92.87 0 0 .46.408 1.387 1.286 1.779 1.637 2.75 2.52 2.75 2.52 3.135 2.61 2.062 4.996.867 5.823-.915.634-1.925.93-3.253 1.003l-.034.001c-.12 0-.304-.074-.311-.265M15.544 6.01c-5.514.25-9.783 4.926-9.534 10.442.25 5.516 4.926 9.786 10.441 9.538 5.514-.25 9.787-4.924 9.539-10.44C25.748 10.183 21.322 6 16.003 6c-.151 0-.305.004-.458.01",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#jeju_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6 6h20v20H6V6Z",
    fill: "#fff"
  }))));
};
/* harmony default export */ var jeju = (SvgJeju);
;// CONCATENATED MODULE: ./src/assets/card-company/kakaoBank.svg
var kakaoBank_path;
function kakaoBank_extends() { return kakaoBank_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kakaoBank_extends.apply(null, arguments); }

var SvgKakaoBank = function SvgKakaoBank(props) {
  return /*#__PURE__*/react.createElement("svg", kakaoBank_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kakaoBank_path || (kakaoBank_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.548 21.006h-1.842V10.992h1.842v10.014ZM21.363 16A6.024 6.024 0 0 0 24 10.992C24 7.682 21.38 5 18.147 5H8.34A.342.342 0 0 0 8 5.347v21.305c0 .192.15.348.339.348h9.808C21.38 27 24 24.317 24 21.007a6.022 6.022 0 0 0-2.637-5.008Z",
    fill: "#1C1C1C"
  })));
};
/* harmony default export */ var kakaoBank = (SvgKakaoBank);
;// CONCATENATED MODULE: ./src/assets/card-company/kakaoPay.svg
var kakaoPay_path, kakaoPay_path2;
function kakaoPay_extends() { return kakaoPay_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kakaoPay_extends.apply(null, arguments); }

var SvgKakaoPay = function SvgKakaoPay(props) {
  return /*#__PURE__*/react.createElement("svg", kakaoPay_extends({
    width: 52,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kakaoPay_path || (kakaoPay_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.928 8C3.548 8 0 10.823 0 14.262c0 2.245 1.484 4.2 3.692 5.322l-.76 2.787c-.036.072 0 .181.073.253a.274.274 0 0 0 .144.073c.037 0 .109-.036.145-.036l3.222-2.172c.47.072.941.108 1.448.108 4.38 0 7.927-2.823 7.927-6.262C15.891 10.823 12.344 8 7.928 8Z",
    fill: "#1C1C1C"
  })), kakaoPay_path2 || (kakaoPay_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M22.588 19.475v4.054h-2.896V8.58h2.027l.362.941c.616-.615 1.557-1.267 3.041-1.267 2.824 0 4.163 2.1 4.163 5.539 0 3.584-2.063 5.864-5.032 5.864-.579.036-1.013 0-1.665-.18Zm0-8.47v6.443c.145.036.543.072.941.072 2.064 0 2.86-1.448 2.86-3.728 0-1.991-.543-3.186-2.172-3.186-.579 0-1.158.181-1.629.399ZM35.547 12.815h1.63v-.362c0-1.195-.688-1.738-1.847-1.738-.905 0-2.027.253-2.968.724l-.797-1.919c1.014-.724 2.607-1.194 4.018-1.194 2.752 0 4.272 1.448 4.272 4.235v6.842h-2.027l-.29-.905c-1.158.832-2.244 1.194-3.185 1.194-2.1 0-3.294-1.267-3.294-3.402 0-2.28 1.556-3.475 4.488-3.475Zm1.63 3.8v-1.99h-1.34c-1.484 0-2.245.542-2.245 1.592 0 .797.399 1.195 1.267 1.195.833.036 1.847-.362 2.317-.797ZM48.615 18.28c-1.013 2.68-2.208 4.634-3.982 5.72l-1.773-1.629c1.013-.905 1.773-1.774 2.389-2.932L41.412 8.977l2.86-.76 2.46 8.47 2.426-8.506 2.824.796-3.367 9.304Z",
    fill: "#1C1C1C"
  })));
};
/* harmony default export */ var kakaoPay = (SvgKakaoPay);
;// CONCATENATED MODULE: ./src/assets/card-company/kookmin.svg
var kookmin_path;
function kookmin_extends() { return kookmin_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kookmin_extends.apply(null, arguments); }

var SvgKookmin = function SvgKookmin(props) {
  return /*#__PURE__*/react.createElement("svg", kookmin_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kookmin_path || (kookmin_path = /*#__PURE__*/react.createElement("path", {
    d: "m28.582 16.236-.226-.137c-.768-.744-1.838-1.066-3.263-.987-1.188.072-2.13.53-2.85.962v-.033c.008-.38.036-.758.083-1.135.05-.383.078-.768.085-1.154a2.606 2.606 0 0 0-.18-1.048.205.205 0 0 0-.08-.096.213.213 0 0 0-.123-.032c-.384.008-1.13.264-1.316.42l-.099.21c0 .412-.099 1.567-.194 1.707l-.05.137a20.252 20.252 0 0 0-.016 4.342c.017.123.263.312.454.379.19.067.86-.095 1.237-.234l.141-.02a.22.22 0 0 0 .144-.084.208.208 0 0 0 .04-.158l.007-.358c.273-1.075 1.374-2.354 2.674-2.548.737-.112 1.318.07 1.776.55.062.087.197.859-.283 1.747-.362.659-1.082 1.21-2.032 1.558-.9.331-1.89.466-3.11.424l-1.15-.752c-.967-.66-2.17-1.484-3.263-1.886-.19-.07-.535-.348-.74-.514l-.113-.09c-.63-.491-1.827-1.266-2.79-1.888l-.518-.338v-.106c.027-.029.63-.38.63-.38.848-.482 1.237-.718 1.32-.84-.016.02.114-.065.114-.065l2.096-1.152c2.012-1.076 4.293-2.296 5.492-3.5l.058-.185.026-.163c.078-.222.085-.462.018-.687a.228.228 0 0 0-.163-.155c-.934-.09-2.141.454-3.24 1.454a2.89 2.89 0 0 1-.676.454l-.168.09c-1.21.67-3.938 2.314-5.372 3.203.136-1.807.379-3.605.728-5.384l-.04-.212-.14-.275-.112-.19-.033-.009a.902.902 0 0 0-.688-.04l-.283.1-.379.138a.21.21 0 0 0-.158.137c-.682 1.602-1.25 4.24-1.377 6.345a32.984 32.984 0 0 0-3.251-1.74l-.019-.01-.075-.016c-.22-.029-.492-.187-.753-.34l-.518-.326-.787-.497c.008 0-.208-.046-.208-.046-.34.057-.99.484-1.186.773a.214.214 0 0 0-.035.125.67.67 0 0 0 .035.18l.035.157.037.095c.379.378 1.336 1.009 2.276 1.5l1.089.561 1.664.889c0 .007.282.218.282.218l.197.11.034.02L6.27 17.38l-1.587 1.026c-.297.16-.604.303-.918.429-.302.1-.557.304-.716.574l-.043.09.044.059.12.089.166.104.174.117.166.025c.283.01.696-.144 1.472-.474.707-.308 2.648-1.441 3.475-1.924l.353-.206c.142.011.307-.108.45-.214.233-.17.484-.316.748-.437 0 0 .132-.07.248-.137v.093c.037 2.46.184 4.247.46 5.625v.026l.027.055c.141.195.29.777.424 1.291l.315 1.026a.7.7 0 0 0 .09.098c.18.117.727.322 1.095.275l.09-.011.058-.125c.03-.155.044-.312.043-.47 0-.188-.015-.396-.033-.648l-.024-.371c-.116-1.71-.226-4.192-.226-5.84v-.138c.298.184 1.613.988 1.613.988 2.235 1.408 5.61 3.537 7.65 4.1a.308.308 0 0 0 .296-.065l.315-.197.057-.023c.119-.054.198-.246.21-.455 1.72-.082 4.12-.727 5.402-2.294.46-.568.714-1.268.72-1.99 0-.521-.149-.973-.423-1.22",
    fill: "#F8B500"
  })));
};
/* harmony default export */ var kookmin = (SvgKookmin);
;// CONCATENATED MODULE: ./src/assets/card-company/lotte.svg
var lotte_path;
function lotte_extends() { return lotte_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, lotte_extends.apply(null, arguments); }

var SvgLotte = function SvgLotte(props) {
  return /*#__PURE__*/react.createElement("svg", lotte_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lotte_path || (lotte_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.992 25.988a.993.993 0 1 1 .04 0h-.04M13.595 7.714a1.815 1.815 0 0 0-1.36.524c-.754.754-1.155 2.311-1.121 4.385.047 2.556.68 7.566 2.665 10.15.291.381.64.716 1.033.992.393.294.869.456 1.36.462.177 0 .355-.015.53-.047 1.156-.279 2.604-1.564 3.671-3.27a.898.898 0 0 1 1.23-.279.87.87 0 0 1 .388.558.883.883 0 0 1-.109.68c-1.36 2.161-3.154 3.67-4.8 4.078h-.04c-.292.054-.588.081-.884.082a4.078 4.078 0 0 1-2.339-.755 6.357 6.357 0 0 1-1.461-1.36c-2.835-3.63-3.026-10.442-3.04-11.21 0-1.808.232-4.27 1.646-5.677a3.548 3.548 0 0 1 2.577-1.026h.21a3.548 3.548 0 0 1 2.577 1.026c1.414 1.408 1.68 3.869 1.645 5.677a18.226 18.226 0 0 1-2.338 8.838.884.884 0 0 1-1.21.306.89.89 0 0 1-.313-1.217 15.33 15.33 0 0 0 2.087-7.995c.034-2.04-.367-3.63-1.122-4.385a1.801 1.801 0 0 0-1.36-.523l-.122-.014Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var lotte = (SvgLotte);
;// CONCATENATED MODULE: ./src/assets/card-company/nh.svg
var nh_path, nh_path2;
function nh_extends() { return nh_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, nh_extends.apply(null, arguments); }

var SvgNh = function SvgNh(props) {
  return /*#__PURE__*/react.createElement("svg", nh_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), nh_path || (nh_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.387 5 16 7.18 11.62 5 16 13.249 20.387 5Z",
    fill: "#fff"
  })), nh_path2 || (nh_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m21.92 11.373-.068-.055 3.13-1.3V5.681l-5.42 2.277s-2.946 5.518-3.01 5.643a4.587 4.587 0 0 1 2.969 1.588 4.493 4.493 0 0 1-.369 6.198 4.599 4.599 0 0 1-3.137 1.232 4.6 4.6 0 0 1-3.137-1.232 4.493 4.493 0 0 1-.368-6.197 4.587 4.587 0 0 1 2.97-1.588l-3.006-5.644-5.446-2.277v4.353l3.126 1.3-.069.054a8.89 8.89 0 0 0-2.808 4.53 8.816 8.816 0 0 0 .299 5.306 8.92 8.92 0 0 0 3.3 4.193 9.067 9.067 0 0 0 5.127 1.586c1.832 0 3.62-.554 5.126-1.586a8.92 8.92 0 0 0 3.301-4.193 8.816 8.816 0 0 0 .3-5.306 8.89 8.89 0 0 0-2.81-4.53v-.015Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var nh = (SvgNh);
;// CONCATENATED MODULE: ./src/assets/card-company/postoffice.svg
var postoffice_path, postoffice_path2, postoffice_path3;
function postoffice_extends() { return postoffice_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, postoffice_extends.apply(null, arguments); }

var SvgPostoffice = function SvgPostoffice(props) {
  return /*#__PURE__*/react.createElement("svg", postoffice_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), postoffice_path || (postoffice_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.044 15.96c-.044.023-.044.065 0 .092l3.703 2.547 1.06-5.194-4.763 2.556ZM25.957 13.4h-.936a.385.385 0 0 0-.168.046l-4.694 2.518a.048.048 0 0 0-.021.018.05.05 0 0 0 .021.073l3.642 2.495c.049.029.104.046.16.05h.94c.047 0 .054-.024 0-.05l-3.715-2.544 4.774-2.56c.052-.026.048-.045-.003-.045Z",
    fill: "#fff"
  })), postoffice_path2 || (postoffice_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M23.954 13.4h-6.527l-1.06 5.191h6.523c.051 0 .055-.022 0-.049l-3.71-2.544 4.767-2.56c.058-.018.054-.037.007-.037Z",
    fill: "#fff"
  })), postoffice_path3 || (postoffice_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M27.96 13.4h-.936a.354.354 0 0 0-.167.046l-4.695 2.518c-.043 0-.043.064 0 .091l3.642 2.495c.05.029.104.046.16.05h.94c.047 0 .055-.024 0-.05l-3.718-2.544 4.77-2.56c.059-.026.055-.045.004-.045ZM23.662 10H8.308a1.52 1.52 0 0 0-1.018.326c-.292.23-.497.558-.58.93a.973.973 0 0 0 .035.53c.06.17.167.317.307.425l5.517 3.791 11.1-5.96c.04-.023.04-.042-.007-.042ZM21.226 21.95l-8.653-5.948-7.065 3.791a1.472 1.472 0 0 0-.46.397 1.541 1.541 0 0 0-.269.555C4.637 21.439 5.005 22 5.872 22h15.354c.036.003.044-.023 0-.05Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var postoffice = (SvgPostoffice);
;// CONCATENATED MODULE: ./src/assets/card-company/samsung.svg
var samsung_path;
function samsung_extends() { return samsung_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, samsung_extends.apply(null, arguments); }

var SvgSamsung = function SvgSamsung(props) {
  return /*#__PURE__*/react.createElement("svg", samsung_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), samsung_path || (samsung_path = /*#__PURE__*/react.createElement("path", {
    d: "m26.487 17.255-.064-3.634h1.133v4.58h-1.628L24.8 14.444h-.023l.063 3.759h-1.13V13.62h1.699l1.05 3.635h.028ZM5.909 14.049l-.624 4.206H4.048l.846-4.63H6.93l.842 4.626H6.543l-.61-4.2-.024-.002ZM11.246 17.16l.564-3.54h1.862l.1 4.63h-1.146l-.029-4.161h-.025l-.762 4.162h-1.161l-.764-4.162H9.86l-.03 4.162H8.687l.1-4.628h1.864l.566 3.538h.029ZM2.123 16.943c.036.112.039.23.01.344a.396.396 0 0 1-.446.31.412.412 0 0 1-.457-.36v-.507H0v.357c0 1.032.804 1.344 1.662 1.344.829 0 1.509-.286 1.618-1.058a2.29 2.29 0 0 0-.006-.758c-.193-.971-1.928-1.26-2.057-1.802a.606.606 0 0 1-.006-.242.378.378 0 0 1 .418-.311.392.392 0 0 1 .423.355.408.408 0 0 1 0 .065v.286H3.2v-.327c0-1.006-.894-1.166-1.542-1.166-.812 0-1.477.274-1.6 1.027a1.64 1.64 0 0 0 .006.63c.198.94 1.823 1.214 2.06 1.813ZM16.992 16.935c.035.11.038.227.009.338a.392.392 0 0 1-.441.309.407.407 0 0 1-.457-.354v-.506H14.89v.354c0 1.023.795 1.331 1.646 1.331.818 0 1.492-.282 1.6-1.048.04-.249.038-.503-.006-.75-.19-.962-1.909-1.247-2.036-1.784a.59.59 0 0 1-.005-.24.373.373 0 0 1 .413-.308.385.385 0 0 1 .42.351.325.325 0 0 1 0 .064v.283h1.131v-.323c0-.997-.886-1.154-1.527-1.154-.804 0-1.463.269-1.583 1.016a1.6 1.6 0 0 0 .011.618c.196.938 1.805 1.21 2.038 1.803ZM20.831 17.555a.41.41 0 0 0 .44-.335.939.939 0 0 0 .01-.176v-3.427h1.158v3.32c0 .085-.008.259-.012.305-.08.864-.754 1.142-1.596 1.142-.841 0-1.515-.28-1.596-1.142 0-.043-.013-.219-.01-.305v-3.319h1.157v3.429a.894.894 0 0 0 .01.175.412.412 0 0 0 .44.333ZM30.37 17.506a.428.428 0 0 0 .466-.338.914.914 0 0 0 .011-.176v-.67h-.467v-.672H32v1.24c0 .103-.006.205-.017.306-.075.843-.797 1.143-1.608 1.143s-1.532-.3-1.608-1.143a2.83 2.83 0 0 1-.017-.305v-1.945c0-.084.01-.227.02-.305.102-.865.793-1.143 1.605-1.143.811 0 1.52.274 1.605 1.143.008.101.012.204.01.305v.154h-1.153v-.26a.948.948 0 0 0-.015-.176.416.416 0 0 0-.457-.336.424.424 0 0 0-.457.336 1.06 1.06 0 0 0-.018.219v2.116c-.002.059.001.118.01.176a.429.429 0 0 0 .47.331Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var samsung = (SvgSamsung);
;// CONCATENATED MODULE: ./src/assets/card-company/shinhan.svg
var shinhan_g;
function shinhan_extends() { return shinhan_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, shinhan_extends.apply(null, arguments); }

var SvgShinhan = function SvgShinhan(props) {
  return /*#__PURE__*/react.createElement("svg", shinhan_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), shinhan_g || (shinhan_g = /*#__PURE__*/react.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M4.435 18.986a.792.792 0 0 1-.079.378c-.046.088-.103.17-.17.245l-.57.639a.551.551 0 0 1-.274.157 1.52 1.52 0 0 1-.323.034H1.387c-.044 0-.12-.005-.228-.013a.537.537 0 0 1-.277-.095l-.837-.56a.064.064 0 0 1-.042-.08c.003-.01.009-.02.017-.028l.482-.623a.078.078 0 0 1 .099-.025l.723.48c.05.03.106.05.165.055.054.008.11.012.165.013H2.7a.504.504 0 0 0 .14-.022.327.327 0 0 0 .134-.069l.33-.389a.314.314 0 0 0 .067-.154c.011-.061.017-.124.017-.186v-.525a.463.463 0 0 0-.089-.286.554.554 0 0 0-.3-.178l-1.907-.522a1.602 1.602 0 0 1-.71-.4.921.921 0 0 1-.293-.685v-.737a.843.843 0 0 1 .076-.381.811.811 0 0 1 .178-.24l.655-.682a.666.666 0 0 1 .278-.153c.105-.026.212-.038.32-.038h1.32c.077 0 .153.004.23.013.099.005.195.038.277.095l.962.63c.05.029.058.064.025.109l-.466.614a.066.066 0 0 1-.053.033.105.105 0 0 1-.046-.008L3 14.862a.585.585 0 0 0-.275-.066h-.953a.372.372 0 0 0-.248.09l-.308.325a.222.222 0 0 0-.07.144 1.5 1.5 0 0 0-.013.188v.406a.39.39 0 0 0 .15.32.82.82 0 0 0 .315.162l1.909.522c.258.06.494.193.68.382a.901.901 0 0 1 .248.64l.001 1.011ZM5.482 13.667a.073.073 0 0 1 .083-.083h.905a.073.073 0 0 1 .082.083v2.093c.127-.09.271-.152.423-.183a2.18 2.18 0 0 1 .474-.058h.89c.081 0 .162.009.241.025.064.01.124.034.179.067l.655.49c.07.044.12.111.145.19.02.076.03.154.03.233v3.75a.073.073 0 0 1-.083.083h-.905a.073.073 0 0 1-.082-.083v-3.533a.172.172 0 0 0-.075-.165l-.267-.165a.268.268 0 0 0-.15-.033h-.919c-.106 0-.213.015-.315.046a.56.56 0 0 0-.24.136v3.71a.072.072 0 0 1-.083.082h-.905a.073.073 0 0 1-.082-.083v-6.602ZM10.71 13.916a.074.074 0 0 1 .083-.082h.904a.074.074 0 0 1 .083.063v.933a.073.073 0 0 1-.083.082h-.904a.073.073 0 0 1-.082-.083v-.913Zm1.07 6.356a.073.073 0 0 1-.084.083h-.903a.072.072 0 0 1-.054-.014.073.073 0 0 1-.029-.07v-4.588a.073.073 0 0 1 .083-.083h.905a.073.073 0 0 1 .082.083v4.59ZM15.949 16.832a.206.206 0 0 0-.058-.178l-.298-.221a.228.228 0 0 0-.142-.05h-.99a.215.215 0 0 0-.124.033l-.282.198a.227.227 0 0 0-.05.055.208.208 0 0 0-.025.112v3.492a.073.073 0 0 1-.083.082h-.907a.073.073 0 0 1-.073-.035.073.073 0 0 1-.01-.048v-3.767c0-.078.013-.155.038-.228a.354.354 0 0 1 .128-.178l.664-.49a.37.37 0 0 1 .178-.074c.073-.012.146-.018.22-.017h1.684c.126-.01.251.02.357.089l.671.489c.06.044.106.106.129.178a.693.693 0 0 1 .037.232v3.768a.073.073 0 0 1-.083.082h-.903a.073.073 0 0 1-.082-.083l.004-3.44ZM18.053 13.667a.073.073 0 0 1 .062-.083h.926a.073.073 0 0 1 .083.083v2.093c.126-.09.27-.15.422-.18.155-.038.313-.057.473-.06h.89c.082.001.162.01.241.026.065.01.127.033.183.067l.656.49c.069.044.12.111.145.19.02.076.03.154.03.232v3.751a.074.074 0 0 1-.085.083h-.907a.073.073 0 0 1-.082-.083V16.74a.173.173 0 0 0-.075-.165l-.267-.165a.267.267 0 0 0-.15-.033h-.918c-.107 0-.213.015-.316.046a.557.557 0 0 0-.24.137v3.71a.073.073 0 0 1-.083.082h-.905a.073.073 0 0 1-.083-.083v-6.603ZM23.54 16.422a.074.074 0 0 1-.083-.083v-.697a.074.074 0 0 1 .084-.083h2.38a.687.687 0 0 1 .241.038.551.551 0 0 1 .175.103l.63.506a.309.309 0 0 1 .112.178c.015.08.022.16.021.24v2.806c0 .074-.01.148-.025.22a.47.47 0 0 1-.165.244l-.467.432a.366.366 0 0 1-.203.103c-.098.01-.196.014-.295.013h-1.767c-.073 0-.145-.006-.217-.017a.387.387 0 0 1-.178-.074l-.58-.44a.584.584 0 0 1-.248-.482v-1.113a.515.515 0 0 1 .208-.442l.653-.547a.45.45 0 0 1 .161-.09.716.716 0 0 1 .188-.02h1.211a.886.886 0 0 1 .386.082c.11.049.209.116.294.199v-.666c0-.03-.005-.06-.016-.09a.21.21 0 0 0-.075-.082l-.232-.18a.268.268 0 0 0-.182-.058H23.54Zm.456 2.796a.153.153 0 0 0 .04.124l.259.206c.041.021.088.03.134.025h1.35a.26.26 0 0 0 .204-.078.25.25 0 0 0 .07-.17v-.92a.325.325 0 0 0-.19-.3.289.289 0 0 0-.12-.024h-1.315a.779.779 0 0 0-.089 0 .148.148 0 0 0-.067.029l-.216.165a.178.178 0 0 0-.058.14l-.002.803ZM31.008 16.832a.205.205 0 0 0-.06-.178l-.288-.223a.225.225 0 0 0-.142-.052h-.997a.22.22 0 0 0-.124.033l-.282.199a.203.203 0 0 0-.05.054.213.213 0 0 0-.025.113v3.493a.073.073 0 0 1-.083.082h-.905a.073.073 0 0 1-.082-.083v-3.765c0-.078.013-.155.037-.229a.358.358 0 0 1 .129-.178l.663-.49a.377.377 0 0 1 .179-.074 1.27 1.27 0 0 1 .22-.017h1.684c.126-.01.251.021.357.09l.673.488c.06.045.105.107.128.178a.702.702 0 0 1 .038.232v3.768a.074.074 0 0 1-.083.083h-.905a.073.073 0 0 1-.083-.083v-3.44ZM1.477 11.2l-.208.362a.232.232 0 0 0 .085.316l1.554.898c.111.064.253.026.317-.085l.208-.36a.232.232 0 0 0-.085-.317l-1.554-.898a.232.232 0 0 0-.317.085Z"
  }))));
};
/* harmony default export */ var shinhan = (SvgShinhan);
;// CONCATENATED MODULE: ./src/assets/card-company/soohyup.svg
var soohyup_path, soohyup_path2;
function soohyup_extends() { return soohyup_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, soohyup_extends.apply(null, arguments); }

var SvgSoohyup = function SvgSoohyup(props) {
  return /*#__PURE__*/react.createElement("svg", soohyup_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), soohyup_path || (soohyup_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.976 15.512c2.429 1.561 2.664 2.959 2.142 4.111-.216.481-.672.9-.672.9s2.061-.994 2.713-2.448c.73-1.624-.06-3.343-2.27-4.833-1.83-1.234-1.069-2.4-1.069-2.4s.604-1.537 2.857-1.537c2.304 0 2.474 1.55 2.474 1.55l.9-1.784c.126-.28-1.467-1.07-3.756-1.071-2.255 0-4.334.906-5.144 2.712-.99 2.205.266 3.799 1.825 4.8Z",
    fill: "#fff"
  })), soohyup_path2 || (soohyup_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.793 18.011c.317-.887 2.121-5.346-.984-5.347-2.119 0-4.516 1.663-4.516 1.663l2.104-4.896s.582-1.174-.764-1.175h-2.17s.805.318.094 1.903l-3.138 7.146s-1.781 3.865-5.364 3.864c-4.715 0-4.35-4.792-4.35-4.792L5 20.14s1.524 2.897 5.252 2.897c2.255 0 3.685-.95 4.38-1.7 0 0-.674 1.567 1.112 1.567h1.833s-.516-.36-.478-.816c.039-.457.652-1.898 1.067-2.653.415-.755 2.471-4.416 4.867-4.646 2.16-.207-1.095 6.578-1.095 6.578s-.629 1.469 1.004 1.512c1.633.043 1.934.042 1.934.042s-.615-.46-.311-1.296c.303-.837.912-2.726 1.228-3.614Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var soohyup = (SvgSoohyup);
;// CONCATENATED MODULE: ./src/assets/card-company/woorri.svg
var _circle, woorri_g, _defs;
function woorri_extends() { return woorri_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, woorri_extends.apply(null, arguments); }

var SvgWoorri = function SvgWoorri(props) {
  return /*#__PURE__*/react.createElement("svg", woorri_extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "woorri_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "#007BC7"
  }))), woorri_g || (woorri_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#woorri_svg__a)"
  }, /*#__PURE__*/react.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "#007BC7"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 16,
    cy: 22,
    r: 14,
    fill: "url(#woorri_svg__b)"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 16,
    cy: 22,
    r: 9,
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 16,
    cy: 43,
    r: 25,
    fill: "#007BC7"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "woorri_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -13.2222 13.2222 0 16 21.222)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.828,
    stopColor: "#00C8FF"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  })))));
};
/* harmony default export */ var woorri = (SvgWoorri);
;// CONCATENATED MODULE: ./src/assets/cards/bcCard.svg
var _rect, bcCard_path;
function bcCard_extends() { return bcCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, bcCard_extends.apply(null, arguments); }

var SvgBcCard = function SvgBcCard(props) {
  return /*#__PURE__*/react.createElement("svg", bcCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E83E44"
  })), bcCard_path || (bcCard_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM8.394 10.342a1.081 1.081 0 0 0-.72-.133c.458-.488.707-1.02.707-1.556 0-.05-.002-.1-.007-.148-.024-.334-.178-.583-.416-.668-.238-.086-.676-.045-1.371.665l-.416.467c-.117.14-.555.804-.636 1.496a8.746 8.746 0 0 0 .254 3.388c.035.117.147.415.417.524.286.116.558-.024.798-.148l.064-.032.249-.11.24-.107.294-.13c.217-.074.42-.185.601-.327a1.75 1.75 0 0 0 .541-.83c.054-.182.088-.37.103-.56a2.634 2.634 0 0 0-.03-.753c-.136-.61-.439-.9-.672-1.038Zm-2.227.878.013.154a.078.078 0 0 0 .133.063c.261-.219.656-.415.975-.305.25.086.418.343.507.763.18.884-.425 1.31-.802 1.482l-.013.006-.484.233a.075.075 0 0 1-.057 0c-.03-.015-.039-.034-.06-.087a10.217 10.217 0 0 1-.317-3.68.634.634 0 0 1 .117-.286l.406-.432.045-.05c.22-.215.428-.322.54-.275.093.04.116.187.116.305.02.632-.334 1.283-1.076 1.975a.156.156 0 0 0-.043.134Zm7.298-5.15c.064.02.287.117.422.584.043.19-.158.136-.158.136a2.815 2.815 0 0 0-1.487-.182c-.667.1-1.22.422-1.556.908a2.208 2.208 0 0 0-.315 1.74c.31 1.488 1.559 2.247 3.183 1.934.633-.124 1.139-.393 1.471-.777.011-.013.061-.068.11-.068.068 0 .108.028.135.124.052.167.08.341.085.516a.697.697 0 0 1-.233.548 3.839 3.839 0 0 1-1.719.807c-1.18.247-2.282.077-3.113-.481a3.129 3.129 0 0 1-1.322-2.105 3.217 3.217 0 0 1 .578-2.499 3.43 3.43 0 0 1 2.147-1.301 3.71 3.71 0 0 1 1.772.117Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var bcCard = (SvgBcCard);
;// CONCATENATED MODULE: ./src/assets/cards/citiCard.svg
var citiCard_rect, citiCard_path, citiCard_path2;
function citiCard_extends() { return citiCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, citiCard_extends.apply(null, arguments); }

var SvgCitiCard = function SvgCitiCard(props) {
  return /*#__PURE__*/react.createElement("svg", citiCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), citiCard_rect || (citiCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#ECECEC"
  })), citiCard_path || (citiCard_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.564 9.472a5.67 5.67 0 0 0-2.002-1.817A5.443 5.443 0 0 0 13.978 7c-.9 0-1.787.225-2.585.655A5.67 5.67 0 0 0 9.39 9.472l-.054.08h1.328l.015-.016a4.53 4.53 0 0 1 1.501-1.093 4.389 4.389 0 0 1 3.594 0 4.53 4.53 0 0 1 1.501 1.093l.014.016h1.328l-.054-.08Z",
    fill: "#E60012"
  })), citiCard_path2 || (citiCard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m8.81 14.623-.024.026c-.409.43-.88.66-1.366.66-1.015 0-1.753-.79-1.753-1.879 0-1.088.738-1.88 1.753-1.88.485 0 .957.228 1.366.66l.024.025.653-.817-.017-.023c-.543-.665-1.195-.988-1.995-.988s-1.539.28-2.072.781c-.575.548-.879 1.32-.879 2.235 0 .916.304 1.688.88 2.236.529.507 1.263.786 2.07.786.809 0 1.453-.324 1.996-.988l.017-.022-.653-.812ZM11.275 10.505h-1.152v5.836h1.152v-5.836ZM15.793 15.07a1.624 1.624 0 0 1-.847.294c-.377 0-.542-.204-.542-.658v-3.097h1.175v-1.1h-1.178V8.694l-1.13.628v1.189h-.976v1.099h.976v3.294c0 .897.513 1.51 1.278 1.527a1.76 1.76 0 0 0 1.024-.268l.011-.009.278-1.124-.069.042ZM17.901 10.505h-1.153v5.836h1.153v-5.836ZM20.4 9.78c0 .105-.03.208-.086.296a.519.519 0 0 1-.231.197.498.498 0 0 1-.562-.116.541.541 0 0 1-.11-.582.53.53 0 0 1 .19-.24.502.502 0 0 1 .286-.09.489.489 0 0 1 .366.154.525.525 0 0 1 .148.38Zm.1 0a.653.653 0 0 0-.103-.354.619.619 0 0 0-.276-.235.594.594 0 0 0-.67.138.658.658 0 0 0-.133.694.632.632 0 0 0 .227.285c.101.07.22.107.342.107a.582.582 0 0 0 .437-.183.627.627 0 0 0 .176-.452Zm-.334-.15a.21.21 0 0 0-.063-.157.195.195 0 0 0-.155-.053h-.294v.693h.113v-.267h.13l.13.267h.135l-.138-.28a.188.188 0 0 0 .107-.075.2.2 0 0 0 .035-.129Zm-.114 0c0 .068-.047.097-.108.097h-.177v-.195h.177a.091.091 0 0 1 .076.023.098.098 0 0 1 .032.074Z",
    fill: "#004187"
  })));
};
/* harmony default export */ var citiCard = (SvgCitiCard);
;// CONCATENATED MODULE: ./src/assets/cards/defaultCard.svg
var defaultCard_rect, defaultCard_path, defaultCard_path2, defaultCard_path3;
function defaultCard_extends() { return defaultCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, defaultCard_extends.apply(null, arguments); }

var SvgDefaultCard = function SvgDefaultCard(props) {
  return /*#__PURE__*/react.createElement("svg", defaultCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), defaultCard_rect || (defaultCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3D4551"
  })), defaultCard_path || (defaultCard_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 12a1 1 0 0 0-1-1H11a1 1 0 1 0 0 2h.5v.5a1 1 0 1 0 2 0V12Z",
    fill: "#fff"
  })), defaultCard_path2 || (defaultCard_path2 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 12a1 1 0 0 0 1 1H14a1 1 0 1 0 0-2h-.5v-.5a1 1 0 1 0-2 0V12Z",
    fill: "#fff"
  })), defaultCard_path3 || (defaultCard_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.23 5H8.616A2.362 2.362 0 0 0 6.25 7.359V8.2a1.5 1.5 0 1 0 1.647.096V7.36c0-.396.322-.717.719-.717h3.614c2.968 0 5.373 2.399 5.373 5.358 0 2.96-2.405 5.358-5.373 5.358H8.616a.718.718 0 0 1-.72-.717v-.938a1.5 1.5 0 1 0-1.647.097v.841A2.362 2.362 0 0 0 8.617 19h3.614c3.877 0 7.02-3.134 7.02-7s-3.143-7-7.02-7Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var defaultCard = (SvgDefaultCard);
;// CONCATENATED MODULE: ./src/assets/cards/hanaCard.svg
var hanaCard_rect, hanaCard_path, hanaCard_path2;
function hanaCard_extends() { return hanaCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, hanaCard_extends.apply(null, arguments); }

var SvgHanaCard = function SvgHanaCard(props) {
  return /*#__PURE__*/react.createElement("svg", hanaCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hanaCard_rect || (hanaCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#008E90"
  })), hanaCard_path || (hanaCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.302 13.58a2.909 2.909 0 0 0-1.356-1.971 2.641 2.641 0 0 0-2.748.018A2.404 2.404 0 0 0 9.13 13.01a2.96 2.96 0 0 0 .186 2.308c.126.216.32.385.553.48a.794.794 0 0 0 .714-.054.76.76 0 0 0 .268-.8 2.06 2.06 0 0 1 .027-1.116.858.858 0 0 1 .196-.316.713.713 0 0 1 .189-.13.783.783 0 0 1 .474-.076.9.9 0 0 1 .631.515c.112.261.17.543.172.827a12.42 12.42 0 0 1-.55 3.698c-.03.124-.065.244-.099.364s-.075.213 0 .306a.259.259 0 0 0 .11.083c.185.075.343-.038.457-.162a6.569 6.569 0 0 0 1.504-2.63c.12-.36.216-.73.288-1.102.112-.538.13-1.091.055-1.635M19.484 7.877a.316.316 0 0 0-.343-.302c-.177.025-.349.08-.508.161-3.183 1.209-6.772 1.439-10.127.955-.573-.083-1.154-.196-1.717-.289-.343-.055-.717-.137-1.081-.165a1.298 1.298 0 0 0-.948.182.996.996 0 0 0-.12 1.185c.245.42.602.764 1.03.996a2.49 2.49 0 0 0 1.35.46 57.536 57.536 0 0 0 3.835-.37c2.174-.282 4.464-.55 6.49-1.392a8.064 8.064 0 0 0 1.899-1.064c.103-.079.254-.21.254-.343",
    fill: "#fff"
  })), hanaCard_path2 || (hanaCard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10.354 6.785a1.253 1.253 0 0 0 2.503 0 .687.687 0 0 0-.065-.299c-.106-.23-.23-.343-.216-.61 0-.368-.457-.375-.711-.375a1.83 1.83 0 0 0-.82.165 1.257 1.257 0 0 0-.688 1.092v.027",
    fill: "#fff"
  })));
};
/* harmony default export */ var hanaCard = (SvgHanaCard);
;// CONCATENATED MODULE: ./src/assets/cards/hyundaiCard.svg
var hyundaiCard_rect, hyundaiCard_path;
function hyundaiCard_extends() { return hyundaiCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, hyundaiCard_extends.apply(null, arguments); }

var SvgHyundaiCard = function SvgHyundaiCard(props) {
  return /*#__PURE__*/react.createElement("svg", hyundaiCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hyundaiCard_rect || (hyundaiCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#000"
  })), hyundaiCard_path || (hyundaiCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.408 9.5c-.373 0-.731.144-.995.399s-.413.6-.413.962V14.5h.47v-3.64c0-.24.098-.47.274-.64a.956.956 0 0 1 .664-.267h15.184c.249 0 .488.096.664.266.176.17.275.4.275.642V14.5H21v-3.64c0-.36-.149-.706-.413-.961a1.435 1.435 0 0 0-.995-.399H4.408Z",
    fill: "#fff",
    stroke: "#fff"
  })));
};
/* harmony default export */ var hyundaiCard = (SvgHyundaiCard);
;// CONCATENATED MODULE: ./src/assets/cards/jejuCard.svg
var jejuCard_rect, jejuCard_path;
function jejuCard_extends() { return jejuCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, jejuCard_extends.apply(null, arguments); }

var SvgJejuCard = function SvgJejuCard(props) {
  return /*#__PURE__*/react.createElement("svg", jejuCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jejuCard_rect || (jejuCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#1A44F5"
  })), jejuCard_path || (jejuCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.42 17.934c-.772-.076-1.695-.32-2.5-1.017-.74-.637-1.198-1.515-1.42-2.29-.228-.792-.324-1.714.052-1.641.116.021.317.53.533.9.225.38.407.593.577.722.078.059.342-.527.727-.862.223-.186.465-.248.508.302.046.674-.076 1.476.122 1.476.181 0 .598-.138 1.508-.216.344-.029.54.036.213.495-.163.23-.38.555-.898.927.774.726 1.703.638 1.72.946.011.178-.335.277-.79.277-.112 0-.23-.007-.352-.02m2.607-6.52c-.709-.148-.854-.792-.854-.792-.059-.227-.072-.514-.025-.88.096-.765.303-1.123.537-1.716.317-.796-.45-1.262-.326-1.553.174-.396.721.107 1.335.144.527.029.844.004 1.253.059.545.071 1.198.256 1.488.597.266.313-.142.692-.628.455-.358-.175-.807-.068-.544.304.317.354.469.364.795.448.89.236.91 1.091.304 1.532-.684.503-1.383.294-1.66-.691-.14-.493-.485-.743-.843-.602-.352.138-.143.786.126 1.386.466 1.19-.476 1.315-.837 1.315a1.09 1.09 0 0 1-.12-.005m-.512 6.744c-.006-.158.224-.198.224-.198 2.071-.408 1.465-1.767.733-2.459-.308-.29-3.19-2.778-3.19-2.778C7.535 10.356 7.755 8.51 7.755 8.51c.136-2.274 2.123-2.838 3.63-2.706.175.015.274.12.24.27-.03.16-.264.17-.264.17-.48.029-.908.076-1.234.297-1.212.817-.857 2.205.761 3.75.205.194.42.4.644.609 0 0 .322.286.971.9a418.231 418.231 0 0 0 1.926 1.764c2.194 1.827 1.442 3.498.606 4.077-.64.443-1.348.65-2.277.701l-.023.002c-.085 0-.213-.052-.219-.186m-.835-13.15a7.001 7.001 0 0 0 .635 13.986 7 7 0 1 0-.635-13.986",
    fill: "#fff"
  })));
};
/* harmony default export */ var jejuCard = (SvgJejuCard);
;// CONCATENATED MODULE: ./src/assets/cards/kakaoBankCard.svg
var kakaoBankCard_rect, kakaoBankCard_path;
function kakaoBankCard_extends() { return kakaoBankCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kakaoBankCard_extends.apply(null, arguments); }

var SvgKakaoBankCard = function SvgKakaoBankCard(props) {
  return /*#__PURE__*/react.createElement("svg", kakaoBankCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kakaoBankCard_rect || (kakaoBankCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFE300"
  })), kakaoBankCard_path || (kakaoBankCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.86 15.3h-1.21V8.7h1.21v6.6Zm3.16-3.3a3.975 3.975 0 0 0 1.73-3.3c0-2.182-1.72-3.95-3.84-3.95H7.471a.225.225 0 0 0-.222.229V19.02c0 .127.099.23.222.23h6.437c2.121 0 3.841-1.768 3.841-3.95 0-1.38-.688-2.595-1.73-3.3Z",
    fill: "#1C1C1C"
  })));
};
/* harmony default export */ var kakaoBankCard = (SvgKakaoBankCard);
;// CONCATENATED MODULE: ./src/assets/cards/kakaoPayMoney.svg
var kakaoPayMoney_rect, kakaoPayMoney_path;
function kakaoPayMoney_extends() { return kakaoPayMoney_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kakaoPayMoney_extends.apply(null, arguments); }

var SvgKakaoPayMoney = function SvgKakaoPayMoney(props) {
  return /*#__PURE__*/react.createElement("svg", kakaoPayMoney_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kakaoPayMoney_rect || (kakaoPayMoney_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFE300"
  })), kakaoPayMoney_path || (kakaoPayMoney_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.982 5C7.71 5 4.25 7.786 4.25 11.179c0 2.214 1.448 4.142 3.601 5.25l-.741 2.75c-.035.071 0 .178.07.25a.267.267 0 0 0 .142.071c.035 0 .106-.036.141-.036l3.142-2.143c.46.072.918.108 1.413.108 4.272 0 7.732-2.786 7.732-6.179 0-3.464-3.46-6.25-7.768-6.25Z",
    fill: "#1C1C1C"
  })));
};
/* harmony default export */ var kakaoPayMoney = (SvgKakaoPayMoney);
;// CONCATENATED MODULE: ./src/assets/cards/kookminCard.svg
var kookminCard_rect, kookminCard_path;
function kookminCard_extends() { return kookminCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, kookminCard_extends.apply(null, arguments); }

var SvgKookminCard = function SvgKookminCard(props) {
  return /*#__PURE__*/react.createElement("svg", kookminCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), kookminCard_rect || (kookminCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#7C7366"
  })), kookminCard_path || (kookminCard_path = /*#__PURE__*/react.createElement("path", {
    d: "m19.255 12.296-.13-.079c-.443-.425-1.06-.61-1.883-.565-.685.041-1.229.303-1.644.551v-.019c.005-.217.02-.434.048-.65.028-.219.045-.44.05-.66a1.482 1.482 0 0 0-.104-.6.117.117 0 0 0-.047-.055.124.124 0 0 0-.07-.019c-.223.005-.653.151-.76.24l-.057.12c0 .236-.057.898-.112.978l-.03.079c-.092.826-.095 1.66-.008 2.486.01.071.151.179.261.217.11.039.497-.054.714-.133l.082-.012a.128.128 0 0 0 .083-.048.12.12 0 0 0 .023-.09l.004-.206c.157-.615.793-1.348 1.543-1.459.425-.064.76.04 1.024.315.036.05.114.492-.163 1-.209.378-.625.694-1.173.893-.518.19-1.09.267-1.794.242l-.663-.43c-.558-.378-1.252-.85-1.883-1.08-.11-.04-.309-.2-.427-.294l-.065-.052c-.363-.281-1.054-.725-1.61-1.082l-.299-.193v-.06c.016-.017.364-.219.364-.219.49-.275.714-.41.762-.48-.01.01.065-.037.065-.037l1.21-.66c1.16-.616 2.477-1.315 3.168-2.005l.034-.106.014-.093a.63.63 0 0 0 .011-.394.125.125 0 0 0-.034-.056.132.132 0 0 0-.06-.032c-.539-.052-1.235.26-1.87.833a1.667 1.667 0 0 1-.389.26l-.097.051c-.698.383-2.272 1.325-3.1 1.834.079-1.034.219-2.064.42-3.083l-.022-.121-.082-.158-.064-.109-.019-.005a.523.523 0 0 0-.397-.023l-.163.058-.219.079a.122.122 0 0 0-.057.027.115.115 0 0 0-.034.051c-.393.918-.721 2.428-.795 3.634-.605-.367-1.231-.7-1.876-.997l-.01-.006-.043-.008c-.128-.017-.284-.107-.435-.196l-.299-.186-.454-.285c.005 0-.12-.026-.12-.026-.196.032-.57.277-.684.442a.122.122 0 0 0-.02.072c.001.035.008.07.02.104l.02.09.021.054c.22.216.771.577 1.314.859l.628.321.96.51c0 .003.163.124.163.124l.113.063.02.012-1.746 1.127-.916.587a5.354 5.354 0 0 1-.529.246.752.752 0 0 0-.414.329l-.024.05.025.035.07.05.095.06.1.068.097.014c.163.006.4-.083.849-.272.407-.176 1.527-.825 2.004-1.101l.204-.118c.082.006.177-.063.26-.123.135-.097.28-.18.431-.25 0 0 .077-.04.144-.079v.054c.02 1.408.106 2.431.265 3.22v.016l.015.031c.082.112.168.445.245.74l.182.587c0 .008.052.056.052.056.104.067.42.184.631.158l.053-.007.033-.071c.017-.089.025-.18.024-.27 0-.107-.008-.226-.018-.37l-.014-.213c-.067-.98-.13-2.4-.13-3.345v-.079c.171.106.93.566.93.566 1.29.807 3.237 2.026 4.414 2.349a.178.178 0 0 0 .17-.038l.182-.112.033-.014c.069-.03.114-.14.122-.26.992-.047 2.376-.417 3.116-1.314.266-.325.412-.726.416-1.14 0-.298-.087-.557-.245-.699",
    fill: "#F8B500"
  })));
};
/* harmony default export */ var kookminCard = (SvgKookminCard);
;// CONCATENATED MODULE: ./src/assets/cards/lotteCard.svg
var lotteCard_rect, lotteCard_path;
function lotteCard_extends() { return lotteCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, lotteCard_extends.apply(null, arguments); }

var SvgLotteCard = function SvgLotteCard(props) {
  return /*#__PURE__*/react.createElement("svg", lotteCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lotteCard_rect || (lotteCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E60012"
  })), lotteCard_path || (lotteCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.512 19.606a.762.762 0 1 1 .031 0h-.031ZM11.28 5.567a1.394 1.394 0 0 0-1.044.402c-.58.58-.888 1.776-.862 3.369.037 1.964.522 5.813 2.047 7.798.224.293.492.55.794.762.302.226.668.35 1.045.355.136 0 .273-.012.407-.036.888-.214 2-1.202 2.82-2.513a.69.69 0 0 1 .946-.214.667.667 0 0 1 .297.428.679.679 0 0 1-.083.523c-1.045 1.66-2.423 2.82-3.687 3.134h-.032a3.818 3.818 0 0 1-.679.062 3.134 3.134 0 0 1-1.796-.58 4.884 4.884 0 0 1-1.123-1.044C8.152 15.223 8.006 9.99 7.995 9.4c0-1.389.178-3.28 1.264-4.36a2.727 2.727 0 0 1 1.98-.79h.161a2.727 2.727 0 0 1 1.98.79c1.086 1.08 1.29 2.971 1.264 4.36a14.003 14.003 0 0 1-1.797 6.79.678.678 0 0 1-.93.235.684.684 0 0 1-.24-.935 11.778 11.778 0 0 0 1.604-6.142c.026-1.567-.282-2.789-.862-3.369a1.384 1.384 0 0 0-1.045-.402l-.094-.01Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var lotteCard = (SvgLotteCard);
;// CONCATENATED MODULE: ./src/assets/cards/nonghyupCard.svg
var nonghyupCard_rect, nonghyupCard_path, nonghyupCard_path2;
function nonghyupCard_extends() { return nonghyupCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, nonghyupCard_extends.apply(null, arguments); }

var SvgNonghyupCard = function SvgNonghyupCard(props) {
  return /*#__PURE__*/react.createElement("svg", nonghyupCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), nonghyupCard_rect || (nonghyupCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FDB913"
  })), nonghyupCard_path || (nonghyupCard_path = /*#__PURE__*/react.createElement("path", {
    d: "m14.923 5-2.925 1.453L9.078 5l2.92 5.5L14.923 5Z",
    fill: "#fff"
  })), nonghyupCard_path2 || (nonghyupCard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m15.945 9.249-.046-.037 2.086-.867V5.454l-3.612 1.518s-1.964 3.679-2.007 3.762c.772.09 1.48.47 1.98 1.059a2.996 2.996 0 0 1-.246 4.132 3.066 3.066 0 0 1-2.092.821 3.066 3.066 0 0 1-2.091-.821 2.996 2.996 0 0 1-.246-4.132c.5-.59 1.208-.968 1.98-1.059L9.648 6.972 6.017 5.454v2.902l2.084.866-.046.037a5.927 5.927 0 0 0-1.872 3.02 5.877 5.877 0 0 0 .199 3.537 5.946 5.946 0 0 0 2.2 2.795A6.045 6.045 0 0 0 12 19.67a6.044 6.044 0 0 0 3.418-1.058 5.946 5.946 0 0 0 2.2-2.795 5.877 5.877 0 0 0 .2-3.537 5.927 5.927 0 0 0-1.873-3.02v-.01Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var nonghyupCard = (SvgNonghyupCard);
;// CONCATENATED MODULE: ./src/assets/cards/postOfficeCard.svg
var postOfficeCard_rect, postOfficeCard_path, postOfficeCard_path2, postOfficeCard_path3;
function postOfficeCard_extends() { return postOfficeCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, postOfficeCard_extends.apply(null, arguments); }

var SvgPostOfficeCard = function SvgPostOfficeCard(props) {
  return /*#__PURE__*/react.createElement("svg", postOfficeCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), postOfficeCard_rect || (postOfficeCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E72410"
  })), postOfficeCard_path || (postOfficeCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.022 11.977c-.03.015-.03.043 0 .06l2.47 1.7.707-3.464-3.177 1.704ZM18.637 10.27h-.624a.256.256 0 0 0-.112.03l-3.13 1.68a.031.031 0 0 0-.015.011.034.034 0 0 0 .014.049l2.43 1.664c.032.02.069.03.106.033h.627c.032 0 .036-.015 0-.033l-2.478-1.697L18.64 10.3c.034-.018.031-.03-.003-.03Z",
    fill: "#fff"
  })), postOfficeCard_path2 || (postOfficeCard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M17.3 10.27h-4.352l-.707 3.462h4.35c.035 0 .037-.015 0-.033l-2.475-1.697 3.18-1.707c.039-.013.037-.025.005-.025Z",
    fill: "#fff"
  })), postOfficeCard_path3 || (postOfficeCard_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M19.974 10.27h-.624a.235.235 0 0 0-.112.03l-3.131 1.68c-.03 0-.03.042 0 .06l2.429 1.664c.032.02.07.03.107.033h.626c.032 0 .037-.015 0-.033l-2.48-1.697 3.182-1.707c.04-.018.037-.03.003-.03ZM17.108 8.002H6.867a1.014 1.014 0 0 0-.68.217 1.09 1.09 0 0 0-.387.62.649.649 0 0 0 .024.354c.04.113.112.211.205.283l3.68 2.529 7.403-3.975c.027-.016.027-.028-.004-.028ZM15.482 15.972l-5.77-3.968-4.713 2.53a.982.982 0 0 0-.307.264c-.084.109-.145.235-.179.37-.095.463.15.837.729.837h10.24c.025.003.03-.015 0-.033Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var postOfficeCard = (SvgPostOfficeCard);
;// CONCATENATED MODULE: ./src/assets/cards/samsungCard.svg
var samsungCard_rect, samsungCard_path;
function samsungCard_extends() { return samsungCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, samsungCard_extends.apply(null, arguments); }

var SvgSamsungCard = function SvgSamsungCard(props) {
  return /*#__PURE__*/react.createElement("svg", samsungCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), samsungCard_rect || (samsungCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#1328A1"
  })), samsungCard_path || (samsungCard_path = /*#__PURE__*/react.createElement("path", {
    d: "m18.554 12.814-.04-2.272h.708v2.863h-1.017l-.705-2.348h-.014l.04 2.348h-.707v-2.863h1.062l.656 2.272h.017ZM5.694 10.81l-.39 2.628H4.53l.53-2.893h1.27l.527 2.891H6.09l-.381-2.625-.015-.001ZM9.029 12.755l.352-2.213h1.164l.063 2.894h-.716l-.019-2.601h-.016l-.476 2.601h-.725l-.478-2.601h-.016l-.018 2.601H7.43l.062-2.892h1.165l.354 2.211h.018ZM3.327 12.619c.022.07.024.144.006.215a.247.247 0 0 1-.279.194.258.258 0 0 1-.285-.225v-.318H2v.224c0 .645.503.84 1.039.84.518 0 .943-.18 1.01-.662a1.431 1.431 0 0 0-.003-.473c-.12-.607-1.205-.788-1.285-1.127a.379.379 0 0 1-.004-.151.237.237 0 0 1 .261-.194.245.245 0 0 1 .265.262v.179H4v-.204c0-.629-.559-.729-.963-.729-.508 0-.924.171-1.001.642-.024.13-.023.264.004.393.123.588 1.14.76 1.287 1.134ZM12.62 12.614a.382.382 0 0 1 .006.211.245.245 0 0 1-.276.193.255.255 0 0 1-.286-.218.01.01 0 0 1 0-.003v-.316h-.758v.221c0 .639.497.832 1.029.832.511 0 .932-.176 1-.655a1.41 1.41 0 0 0-.004-.47c-.119-.6-1.193-.778-1.272-1.114a.369.369 0 0 1-.004-.15.233.233 0 0 1 .259-.193.243.243 0 0 1 .262.22.206.206 0 0 1 0 .04v.177h.707v-.202c0-.623-.554-.721-.955-.721-.502 0-.914.168-.989.635a1 1 0 0 0 .007.386c.122.587 1.128.756 1.274 1.127ZM15.02 13.002a.257.257 0 0 0 .275-.21.582.582 0 0 0 .007-.11V10.54h.724v2.075c0 .053-.005.162-.008.19-.05.54-.471.715-.997.715s-.948-.176-.998-.715c0-.026-.008-.136-.006-.19v-2.074h.723v2.143a.574.574 0 0 0 .007.11.257.257 0 0 0 .274.207ZM20.982 12.97a.267.267 0 0 0 .29-.21.56.56 0 0 0 .008-.11v-.42h-.293v-.42H22v.776c0 .064-.003.127-.01.19-.048.528-.499.715-1.006.715s-.957-.187-1.005-.714a1.735 1.735 0 0 1-.01-.19V11.37c0-.053.006-.143.012-.191.064-.54.496-.714 1.003-.714.507 0 .95.17 1.004.714.005.063.007.127.006.19v.097h-.721v-.163a.6.6 0 0 0-.009-.11.26.26 0 0 0-.286-.21.265.265 0 0 0-.285.21.657.657 0 0 0-.012.137v1.323c-.001.037.001.073.006.11a.268.268 0 0 0 .295.207Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var samsungCard = (SvgSamsungCard);
;// CONCATENATED MODULE: ./src/assets/cards/shinhanCard.svg
var shinhanCard_rect, shinhanCard_path;
function shinhanCard_extends() { return shinhanCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, shinhanCard_extends.apply(null, arguments); }

var SvgShinhanCard = function SvgShinhanCard(props) {
  return /*#__PURE__*/react.createElement("svg", shinhanCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), shinhanCard_rect || (shinhanCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0046FF"
  })), shinhanCard_path || (shinhanCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.765 13.48a.493.493 0 0 1-.049.235.762.762 0 0 1-.106.152l-.356.399a.343.343 0 0 1-.17.098.937.937 0 0 1-.202.02H2.865c-.028 0-.075-.002-.143-.007a.334.334 0 0 1-.172-.06l-.522-.348a.04.04 0 0 1-.027-.03.04.04 0 0 1 .012-.037l.3-.39a.048.048 0 0 1 .062-.015l.45.3c.032.018.067.03.103.034a.864.864 0 0 0 .103.008h.652c.03 0 .06-.005.088-.014a.204.204 0 0 0 .084-.043l.205-.242a.197.197 0 0 0 .042-.096.704.704 0 0 0 .01-.117v-.326a.288.288 0 0 0-.055-.179.345.345 0 0 0-.187-.111l-1.189-.326a1 1 0 0 1-.443-.249.573.573 0 0 1-.182-.427v-.46a.525.525 0 0 1 .047-.237.506.506 0 0 1 .11-.15l.41-.425a.416.416 0 0 1 .173-.095.804.804 0 0 1 .2-.024h.822c.048 0 .096.003.143.008a.335.335 0 0 1 .173.06l.6.393c.031.017.036.04.016.067l-.291.383a.042.042 0 0 1-.033.02.065.065 0 0 1-.029-.005l-.527-.336a.363.363 0 0 0-.172-.041h-.594a.232.232 0 0 0-.155.057l-.192.202a.138.138 0 0 0-.043.09.935.935 0 0 0-.008.116v.253a.243.243 0 0 0 .093.2.51.51 0 0 0 .197.101l1.19.325a.88.88 0 0 1 .424.239c.102.107.157.25.154.398l.001.631ZM5.418 10.163a.045.045 0 0 1 .052-.052h.564a.046.046 0 0 1 .051.052v1.305a.692.692 0 0 1 .264-.114c.097-.023.196-.035.295-.036h.555c.05 0 .101.005.15.015.04.007.078.021.112.042l.408.305a.22.22 0 0 1 .09.119.551.551 0 0 1 .02.145v2.338a.046.046 0 0 1-.052.052h-.564a.045.045 0 0 1-.051-.052V12.08a.107.107 0 0 0-.048-.103l-.166-.103a.166.166 0 0 0-.093-.02h-.573a.674.674 0 0 0-.197.028.348.348 0 0 0-.15.085v2.312a.045.045 0 0 1-.051.052H5.47a.045.045 0 0 1-.051-.052l-.001-4.116ZM8.678 10.318a.046.046 0 0 1 .051-.051h.564a.046.046 0 0 1 .052.052v.569a.045.045 0 0 1-.052.051h-.564a.045.045 0 0 1-.051-.052v-.569Zm.666 3.963a.045.045 0 0 1-.051.051h-.564a.046.046 0 0 1-.033-.008.046.046 0 0 1-.018-.043V11.42a.046.046 0 0 1 .052-.052h.563a.046.046 0 0 1 .052.052v2.861ZM11.944 12.136a.128.128 0 0 0-.036-.11l-.186-.139a.142.142 0 0 0-.089-.03h-.617a.134.134 0 0 0-.077.02l-.176.123a.14.14 0 0 0-.031.034.13.13 0 0 0-.016.07v2.177a.046.046 0 0 1-.038.052h-.579a.044.044 0 0 1-.034-.009.043.043 0 0 1-.012-.013.043.043 0 0 1-.006-.017v-2.362c0-.048.008-.096.024-.142a.22.22 0 0 1 .08-.111l.414-.305a.232.232 0 0 1 .11-.047.79.79 0 0 1 .137-.01h1.05a.357.357 0 0 1 .223.055l.419.305a.221.221 0 0 1 .08.111.43.43 0 0 1 .023.145v2.35a.046.046 0 0 1-.038.05h-.577a.045.045 0 0 1-.05-.051l.002-2.146ZM13.256 10.163v-.018a.047.047 0 0 1 .037-.034h.579a.046.046 0 0 1 .051.052v1.305a.69.69 0 0 1 .263-.113c.097-.023.196-.035.295-.036h.556c.05 0 .1.005.15.015.04.007.079.02.114.042l.409.305c.043.028.075.07.09.119a.563.563 0 0 1 .018.145v2.338a.046.046 0 0 1-.04.052H15.2a.046.046 0 0 1-.05-.039c-.002-.004-.002-.008 0-.013V12.08a.107.107 0 0 0-.048-.103l-.166-.103a.167.167 0 0 0-.093-.02h-.573a.676.676 0 0 0-.197.028.348.348 0 0 0-.15.085v2.313a.045.045 0 0 1-.051.051h-.565a.046.046 0 0 1-.051-.051v-4.117ZM16.676 11.88a.046.046 0 0 1-.051-.052v-.434a.046.046 0 0 1 .052-.051h1.484a.425.425 0 0 1 .15.023c.04.015.078.036.11.064l.393.316c.035.028.06.067.07.111.009.05.013.1.012.15v1.749a.667.667 0 0 1-.015.137.293.293 0 0 1-.103.152l-.291.27a.228.228 0 0 1-.127.064 1.71 1.71 0 0 1-.184.008h-1.101a.885.885 0 0 1-.136-.01.241.241 0 0 1-.11-.047l-.363-.274a.364.364 0 0 1-.154-.3v-.695a.32.32 0 0 1 .13-.275l.407-.341a.28.28 0 0 1 .1-.056.45.45 0 0 1 .117-.013h.756a.553.553 0 0 1 .24.052c.068.03.13.071.184.123v-.415a.16.16 0 0 0-.01-.055.13.13 0 0 0-.047-.052l-.145-.112a.167.167 0 0 0-.113-.036h-1.255Zm.285 1.744a.095.095 0 0 0 .026.077l.16.129a.15.15 0 0 0 .084.015h.842a.164.164 0 0 0 .127-.049.156.156 0 0 0 .044-.106v-.573a.203.203 0 0 0-.118-.187.18.18 0 0 0-.076-.015h-.82a.514.514 0 0 0-.055 0 .093.093 0 0 0-.042.018l-.135.103a.111.111 0 0 0-.036.087l-.001.5ZM21.332 12.136a.129.129 0 0 0-.036-.11l-.18-.14a.14.14 0 0 0-.089-.032h-.622a.137.137 0 0 0-.077.02l-.175.124a.128.128 0 0 0-.032.034.132.132 0 0 0-.015.07v2.178a.046.046 0 0 1-.052.052h-.564a.045.045 0 0 1-.052-.052v-2.348c0-.049.008-.097.024-.142a.222.222 0 0 1 .08-.111l.414-.305a.235.235 0 0 1 .11-.047.79.79 0 0 1 .138-.01h1.05a.353.353 0 0 1 .223.055l.419.305a.222.222 0 0 1 .08.11.441.441 0 0 1 .023.145v2.35a.046.046 0 0 1-.038.051h-.578a.046.046 0 0 1-.051-.038v-2.159ZM2.92 8.625l-.129.225a.145.145 0 0 0 .053.198l.97.56c.068.04.157.015.197-.054l.13-.225a.145.145 0 0 0-.053-.197l-.97-.56a.145.145 0 0 0-.197.053Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var shinhanCard = (SvgShinhanCard);
;// CONCATENATED MODULE: ./src/assets/cards/soohyupCard.svg
var soohyupCard_rect, soohyupCard_path, soohyupCard_path2;
function soohyupCard_extends() { return soohyupCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, soohyupCard_extends.apply(null, arguments); }

var SvgSoohyupCard = function SvgSoohyupCard(props) {
  return /*#__PURE__*/react.createElement("svg", soohyupCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), soohyupCard_rect || (soohyupCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0069B4"
  })), soohyupCard_path || (soohyupCard_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.623 12.118c1.574 1.012 1.727 1.918 1.388 2.665-.14.312-.435.583-.435.583s1.335-.644 1.758-1.586c.473-1.053-.039-2.167-1.47-3.133-1.187-.8-.694-1.555-.694-1.555s.391-.996 1.851-.996c1.494 0 1.604 1.004 1.604 1.004l.583-1.156c.082-.182-.95-.694-2.434-.694-1.461 0-2.809.587-3.334 1.758-.642 1.429.173 2.462 1.183 3.11Z",
    fill: "#fff"
  })), soohyupCard_path2 || (soohyupCard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.226 13.738c.205-.575 1.375-3.465-.637-3.465-1.374 0-2.928 1.077-2.928 1.077l1.364-3.173s.377-.76-.495-.76h-1.406s.521.205.06 1.232l-2.033 4.632s-1.155 2.504-3.477 2.504c-3.056 0-2.819-3.106-2.819-3.106L4.75 15.118s.988 1.877 3.404 1.878c1.461 0 2.388-.616 2.838-1.102 0 0-.436 1.015.721 1.015h1.188s-.334-.233-.31-.529c.026-.296.423-1.23.692-1.719.269-.489 1.601-2.862 3.154-3.011 1.4-.134-.71 4.263-.71 4.263s-.407.952.651.98c1.059.028 1.253.027 1.253.027s-.398-.298-.201-.84.591-1.766.796-2.342Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var soohyupCard = (SvgSoohyupCard);
;// CONCATENATED MODULE: ./src/assets/cards/woorriCard.svg
var woorriCard_rect, woorriCard_circle, woorriCard_g, woorriCard_defs;
function woorriCard_extends() { return woorriCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, woorriCard_extends.apply(null, arguments); }

var SvgWoorriCard = function SvgWoorriCard(props) {
  return /*#__PURE__*/react.createElement("svg", woorriCard_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), woorriCard_rect || (woorriCard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#004B9D"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "woorriCard_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, woorriCard_circle || (woorriCard_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#007BC7"
  }))), woorriCard_g || (woorriCard_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#woorriCard_svg__a)"
  }, /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#007BC7"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 12,
    cy: 15.5,
    rx: 9.8,
    ry: 9.1,
    fill: "url(#woorriCard_svg__b)"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 16.2,
    r: 6.3,
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 30.9,
    r: 17.5,
    fill: "#007BC7"
  }))), woorriCard_defs || (woorriCard_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "woorriCard_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -8.59444 9.25556 0 12 14.994)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.828,
    stopColor: "#00C8FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#007BC7"
  })))));
};
/* harmony default export */ var woorriCard = (SvgWoorriCard);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/constants/card/index.tsx


































var DEFAULT_CARD_ICON = {
    label: "",
    icon: etc,
    bgColor: "#3D4551",
    textColor: theme/* default.color.white */.Z.color.white,
    match: []
};
var CARD_ICON_V2 = [
    {
        label: "KB국민카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(kookmin, {}),
        bgColor: "#7C7366",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "KB",
            "국민"
        ]
    },
    {
        label: "씨티카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(citi, {}),
        bgColor: "#ECECEC",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "씨티"
        ]
    },
    {
        label: "삼성카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(samsung, {}),
        bgColor: "#1328A1",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "삼성"
        ]
    },
    {
        label: "현대카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hyundai, {}),
        bgColor: theme/* default.color.black */.Z.color.black,
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "현대"
        ]
    },
    {
        label: "NH카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(nh, {}),
        bgColor: "#FDB913",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "NH"
        ]
    },
    {
        label: "KEB하나카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hana, {}),
        bgColor: "#008E90",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "하나"
        ]
    },
    {
        label: "우리카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(woorri, {}),
        bgColor: "#004B9D",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "우리"
        ]
    },
    {
        label: "신한카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(shinhan, {}),
        bgColor: "#0046FF",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "신한"
        ]
    },
    {
        label: "BC카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bc, {}),
        bgColor: "#E83E44",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "BC",
            "비씨"
        ]
    },
    {
        label: "수협은행카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(soohyup, {}),
        bgColor: "#0069B4",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "수협"
        ]
    },
    {
        label: "우체국카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(postoffice, {}),
        bgColor: "#E72410",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "우체국"
        ]
    },
    {
        label: "롯데카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(lotte, {}),
        bgColor: "#E60012",
        textColor: theme/* default.color.white */.Z.color.white,
        match: [
            "롯데"
        ]
    },
    {
        label: "제주카드",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jeju, {}),
        bgColor: "#1A44F5",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "제주"
        ]
    },
    {
        label: "카카오페이머니",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoPay, {}),
        bgColor: "#FFE300",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "카카오페이머니"
        ]
    },
    {
        label: "카카오뱅크",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoBank, {}),
        bgColor: "#FFE300",
        textColor: theme/* default.color.gray900 */.Z.color.gray900,
        match: [
            "카카오뱅크체크",
            "카카오뱅크mini",
            "카카오뱅크"
        ]
    },
    DEFAULT_CARD_ICON, 
];
var CARD_ICON = [
    {
        cardIcon: kookminCard,
        match: [
            "KB",
            "국민"
        ]
    },
    {
        cardIcon: citiCard,
        match: [
            "씨티"
        ]
    },
    {
        cardIcon: samsungCard,
        match: [
            "삼성"
        ]
    },
    {
        cardIcon: hyundaiCard,
        match: [
            "현대"
        ]
    },
    {
        cardIcon: nonghyupCard,
        match: [
            "NH"
        ]
    },
    {
        cardIcon: hanaCard,
        match: [
            "하나"
        ]
    },
    {
        cardIcon: woorriCard,
        match: [
            "우리"
        ]
    },
    {
        cardIcon: shinhanCard,
        match: [
            "신한"
        ]
    },
    {
        cardIcon: bcCard,
        match: [
            "BC",
            "비씨"
        ]
    },
    {
        cardIcon: soohyupCard,
        match: [
            "수협"
        ]
    },
    {
        cardIcon: postOfficeCard,
        match: [
            "우체국"
        ]
    },
    {
        cardIcon: lotteCard,
        match: [
            "롯데"
        ]
    },
    {
        cardIcon: jejuCard,
        match: [
            "제주"
        ]
    },
    {
        cardIcon: kakaoPayMoney,
        match: [
            "카카오페이머니"
        ]
    },
    {
        cardIcon: kakaoBankCard,
        match: [
            "카카오뱅크체크",
            "카카오뱅크mini",
            "카카오뱅크"
        ]
    },
    {
        cardIcon: defaultCard,
        match: []
    }, 
];
var getCardIcon = function(cardName) {
    var matchingCardIcon = CARD_ICON.find(function(cardIcon) {
        return cardIcon.match.find(function(it) {
            return it === cardName;
        }) || cardIcon.match.find(function(it) {
            return it === cardName.substring(0, 2);
        });
    });
    var ref;
    return (ref = matchingCardIcon === null || matchingCardIcon === void 0 ? void 0 : matchingCardIcon.cardIcon) !== null && ref !== void 0 ? ref : DefaultCard;
};

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/diagnosis.ts
var diagnosis = __webpack_require__(20138);
;// CONCATENATED MODULE: ./src/models/common/index.ts









var DoctorMedicineType;
(function(DoctorMedicineType) {
    DoctorMedicineType["Dentist"] = "DENTIST";
    DoctorMedicineType["Doctor"] = "DOCTOR";
    DoctorMedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
    DoctorMedicineType["Unknown"] = "UNKNOWN";
})(DoctorMedicineType || (DoctorMedicineType = {}));
var getUserAddressTypeTitle = function(addressType) {
    switch(addressType){
        case gql_schema/* AddressType.Home */.DLH.Home:
            return "집";
        case gql_schema/* AddressType.Company */.DLH.Company:
            return "회사";
        case gql_schema/* AddressType.Others */.DLH.Others:
            return "기타";
        default:
            return "기타";
    }
};
var UserAddressType;
(function(UserAddressType) {
    UserAddressType["Home"] = "HOME";
    UserAddressType["Company"] = "COMPANY";
    UserAddressType["Others"] = "OTHERS";
})(UserAddressType || (UserAddressType = {}));
var getUserAddressType = function(addressType) {
    switch(addressType){
        case gql_schema/* AddressType.Home */.DLH.Home:
            return UserAddressType.Home;
        case gql_schema/* AddressType.Company */.DLH.Company:
            return UserAddressType.Company;
        case gql_schema/* AddressType.Others */.DLH.Others:
            return UserAddressType.Others;
        default:
            return UserAddressType.Others;
    }
};
var getFullAddress = function(address) {
    var fullAddress = (address.roadAddress || address.oldAddress) + ", ".concat(address.detailAddress);
    if (address.deliveryComment) {
        fullAddress += " (".concat(address.deliveryComment, ")");
    }
    return fullAddress;
};
var UserAddressesInfo = /*#__PURE__*/ function() {
    "use strict";
    function UserAddressesInfo(_addresses) {
        (0,_class_call_check/* default */.Z)(this, UserAddressesInfo);
        this._addresses = _addresses;
        this.MAX_ADDRESS_COUNT = 5;
        this.ADDRESS_HIGHORITY = {
            home: 0,
            company: 1,
            others: 2
        };
    }
    var _proto = UserAddressesInfo.prototype;
    _proto.findAddress = function findAddress(addressId) {
        return this.addresses.find(function(address) {
            return address.userAddressId === addressId;
        }) || null;
    };
    _proto.hasAddresses = function hasAddresses() {
        return this.addresses.length > 0;
    };
    _proto.hasAddressFromAddressType = function hasAddressFromAddressType(addressType) {
        return this.addresses.some(function(address) {
            return address.addressType === addressType;
        });
    };
    _proto.findHomeAddress = function findHomeAddress() {
        return this.addresses.find(function(address) {
            return address.addressType === UserAddressType.Home;
        }) || null;
    };
    _proto.findCompanyAddress = function findCompanyAddress() {
        return this.addresses.find(function(address) {
            return address.addressType === UserAddressType.Company;
        }) || null;
    };
    _proto.getOtherAddresses = function getOtherAddresses() {
        return this.addresses.filter(function(address) {
            return address.addressType === UserAddressType.Others;
        });
    };
    (0,_create_class/* default */.Z)(UserAddressesInfo, [
        {
            key: "addresses",
            get: function get() {
                return this._addresses.map(function(userAddress) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userAddress), {
                        addressTypeTitle: getUserAddressTypeTitle(userAddress.addressType),
                        addressType: getUserAddressType(userAddress.addressType),
                        fullAddress: getFullAddress(userAddress)
                    });
                });
            }
        },
        {
            key: "isRegisterable",
            get: function get() {
                return this._addresses.length < this.MAX_ADDRESS_COUNT;
            }
        },
        {
            key: "sortedAddresses",
            get: function get() {
                var _this = this;
                var newAddresses = (0,_to_consumable_array/* default */.Z)(this.addresses);
                var ref;
                return (ref = newAddresses.sort(function(prev, curr) {
                    return _this.ADDRESS_HIGHORITY[prev.addressType] - _this.ADDRESS_HIGHORITY[curr.addressType];
                })) !== null && ref !== void 0 ? ref : [];
            }
        }
    ]);
    return UserAddressesInfo;
}();
var UserTelemedicineEligibleGroupType;
(function(UserTelemedicineEligibleGroupType) {
    UserTelemedicineEligibleGroupType["BACKWOODS_RESIDENT"] = "BACKWOODS_RESIDENT";
    UserTelemedicineEligibleGroupType["MEDICAL_VULNERABLE_AREA_RESIDENT"] = "MEDICAL_VULNERABLE_AREA_RESIDENT";
    UserTelemedicineEligibleGroupType["LONG_TERM_CARE_CLASSIFIER"] = "LONG_TERM_CARE_CLASSIFIER";
    UserTelemedicineEligibleGroupType["REGISTERED_DISABLED"] = "REGISTERED_DISABLED";
    UserTelemedicineEligibleGroupType["INFECTIOUS_DISEASE_CASE"] = "INFECTIOUS_DISEASE_CASE";
    UserTelemedicineEligibleGroupType["UNDER_18_CHILD"] = "UNDER_18_CHILD";
    UserTelemedicineEligibleGroupType["VISITED_PATIENT"] = "VISITED_PATIENT";
    UserTelemedicineEligibleGroupType["OTHERS"] = "OTHERS";
})(UserTelemedicineEligibleGroupType || (UserTelemedicineEligibleGroupType = {}));
var UserProfileRelationType;
(function(UserProfileRelationType) {
    UserProfileRelationType["Children"] = "CHILDREN";
    UserProfileRelationType["Me"] = "ME";
    UserProfileRelationType["Parents"] = "PARENTS";
    UserProfileRelationType["Spouse"] = "SPOUSE";
})(UserProfileRelationType || (UserProfileRelationType = {}));
var UserProfile = /*#__PURE__*/ function() {
    "use strict";
    function UserProfile(_profile) {
        (0,_class_call_check/* default */.Z)(this, UserProfile);
        this._profile = _profile;
    }
    (0,_create_class/* default */.Z)(UserProfile, [
        {
            key: "displayedBirthDate",
            get: function get() {
                return dayjs_min_default()(this._profile.birthDate).format("YYMMDD");
            }
        },
        {
            key: "birthDate",
            get: function get() {
                return this._profile.birthDate;
            }
        },
        {
            key: "targetId",
            get: function get() {
                return this._profile.targetId;
            }
        },
        {
            key: "age",
            get: function get() {
                return this._profile.age;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._profile.name;
            }
        },
        {
            key: "phone",
            get: function get() {
                return this._profile.phone;
            }
        },
        {
            key: "isSsnChanged",
            get: function get() {
                return this._profile.isSsnChanged;
            }
        },
        {
            key: "followingResidentFirstNumber",
            get: function get() {
                return this._profile.followingResidentFirstNumber;
            }
        },
        {
            key: "relation",
            get: function get() {
                switch(this._profile.relation){
                    case gql_schema/* UserProfileRelation.Children */.C5j.Children:
                        return UserProfileRelationType.Children;
                    case gql_schema/* UserProfileRelation.Me */.C5j.Me:
                        return UserProfileRelationType.Me;
                    case gql_schema/* UserProfileRelation.Parents */.C5j.Parents:
                        return UserProfileRelationType.Parents;
                    case gql_schema/* UserProfileRelation.Spouse */.C5j.Spouse:
                        return UserProfileRelationType.Spouse;
                    default:
                        return UserProfileRelationType.Me;
                }
            }
        },
        {
            key: "telemedicineTargetType",
            get: function get() {
                return this._profile.telemedicineTargetType;
            }
        },
        {
            key: "telemedicineEligibleGroupType",
            get: function get() {
                return this._profile.telemedicineEligibleGroupType;
            }
        },
        {
            key: "userTelemedicineEligibleGroupType",
            get: function get() {
                switch(this._profile.telemedicineEligibleGroupType){
                    case gql_schema/* TelemedicineEligibleGroupType.BackwoodsResident */.tPC.BackwoodsResident:
                        return UserTelemedicineEligibleGroupType.BACKWOODS_RESIDENT;
                    case gql_schema/* TelemedicineEligibleGroupType.InfectiousDiseaseCase */.tPC.InfectiousDiseaseCase:
                        return UserTelemedicineEligibleGroupType.INFECTIOUS_DISEASE_CASE;
                    case gql_schema/* TelemedicineEligibleGroupType.LongTermCareClassifier */.tPC.LongTermCareClassifier:
                        return UserTelemedicineEligibleGroupType.LONG_TERM_CARE_CLASSIFIER;
                    case gql_schema/* TelemedicineEligibleGroupType.RegisteredDisabled */.tPC.RegisteredDisabled:
                        return UserTelemedicineEligibleGroupType.REGISTERED_DISABLED;
                    case gql_schema/* TelemedicineEligibleGroupType.MedicalVulnerableAreaResident */.tPC.MedicalVulnerableAreaResident:
                        return UserTelemedicineEligibleGroupType.MEDICAL_VULNERABLE_AREA_RESIDENT;
                    case gql_schema/* TelemedicineEligibleGroupType.Under_18Child */.tPC.Under_18Child:
                        return UserTelemedicineEligibleGroupType.UNDER_18_CHILD;
                    case gql_schema/* TelemedicineEligibleGroupType.VisitedPatient */.tPC.VisitedPatient:
                        return UserTelemedicineEligibleGroupType.VISITED_PATIENT;
                    case gql_schema/* TelemedicineEligibleGroupType.Others */.tPC.Others:
                        return UserTelemedicineEligibleGroupType.OTHERS;
                    default:
                        return null;
                }
            }
        },
        {
            key: "eligibilityTags",
            get: function get() {
                return this._profile.eligibilityTags;
            }
        },
        {
            key: "relationDisplayName",
            get: function get() {
                switch(this.relation){
                    case UserProfileRelationType.Me:
                        return "본인";
                    case UserProfileRelationType.Parents:
                        return "부모님";
                    case UserProfileRelationType.Spouse:
                        return "배우자";
                    case UserProfileRelationType.Children:
                        return "자녀";
                    default:
                        return "";
                }
            }
        },
        {
            key: "isVisibleChildSection",
            get: function get() {
                return this._profile.isVisibleChildSection;
            }
        }
    ]);
    return UserProfile;
}();
var UserProfiles = /*#__PURE__*/ function() {
    "use strict";
    function UserProfiles(_profiles) {
        (0,_class_call_check/* default */.Z)(this, UserProfiles);
        this._profiles = _profiles;
    }
    var _proto = UserProfiles.prototype;
    _proto.hasUserProfiles = function hasUserProfiles() {
        return this._profiles.length > 0;
    };
    _proto.getUserProfileByTargetId = function getUserProfileByTargetId(targetId) {
        if (!targetId) {
            return this.profiles[0];
        }
        return this.profiles.find(function(profile) {
            return profile.targetId === targetId;
        }) || null;
    };
    (0,_create_class/* default */.Z)(UserProfiles, [
        {
            key: "profiles",
            get: function get() {
                return this._profiles.map(function(profile) {
                    return new UserProfile(profile);
                });
            }
        }
    ]);
    return UserProfiles;
}();
var INSTALLMENT_SELECT_LIST = [
    {
        installmentMonth: 0,
        text: "일시불"
    },
    {
        installmentMonth: 2,
        text: "2개월"
    },
    {
        installmentMonth: 3,
        text: "3개월"
    },
    {
        installmentMonth: 4,
        text: "4개월"
    },
    {
        installmentMonth: 5,
        text: "5개월"
    },
    {
        installmentMonth: 6,
        text: "6개월"
    },
    {
        installmentMonth: 7,
        text: "7개월"
    },
    {
        installmentMonth: 8,
        text: "8개월"
    },
    {
        installmentMonth: 9,
        text: "9개월"
    },
    {
        installmentMonth: 10,
        text: "10개월"
    },
    {
        installmentMonth: 11,
        text: "11개월"
    },
    {
        installmentMonth: 12,
        text: "12개월"
    }, 
];
var CardPayCompany;
(function(CardPayCompany) {
    CardPayCompany["Inisis"] = "INISIS";
    CardPayCompany["Kakaopay"] = "KAKAOPAY";
    CardPayCompany["Payple"] = "PAYPLE";
    CardPayCompany["TossPg"] = "TOSS_PG";
    CardPayCompany["Unknown"] = "UNKNOWN";
})(CardPayCompany || (CardPayCompany = {}));
var UserPaymentsInfo = /*#__PURE__*/ function() {
    "use strict";
    function UserPaymentsInfo(_userPayments) {
        (0,_class_call_check/* default */.Z)(this, UserPaymentsInfo);
        this._userPayments = _userPayments;
        this.getDisplayedCardCompany = function(cardName) {
            var matchingIcon = CARD_ICON_V2.find(function(card) {
                return card.match.find(function(it) {
                    return it === cardName;
                }) || card.match.find(function(it) {
                    return it === cardName.substring(0, 2);
                });
            });
            if (!matchingIcon) {
                var icon = DEFAULT_CARD_ICON.icon, bgColor = DEFAULT_CARD_ICON.bgColor, textColor = DEFAULT_CARD_ICON.textColor;
                return {
                    icon: icon,
                    cardName: cardName,
                    bgColor: bgColor,
                    textColor: textColor
                };
            }
            var icon1 = matchingIcon.icon, label = matchingIcon.label, bgColor1 = matchingIcon.bgColor, textColor1 = matchingIcon.textColor;
            return {
                icon: icon1,
                cardName: label,
                bgColor: bgColor1,
                textColor: textColor1
            };
        };
    }
    var _proto = UserPaymentsInfo.prototype;
    _proto.displayCardNumber = function displayCardNumber(cardNumber) {
        var regexPattern = /(.{4})(?=.)/g;
        var replacement = "$1-";
        return cardNumber.replace(regexPattern, replacement);
    };
    _proto.getCardIcon = function getCardIcon(cardName) {
        var matchingCardIcon = CARD_ICON.find(function(cardIcon) {
            return cardIcon.match.find(function(it) {
                return it === cardName;
            }) || cardIcon.match.find(function(it) {
                return it === cardName.substring(0, 2);
            });
        });
        return (matchingCardIcon === null || matchingCardIcon === void 0 ? void 0 : matchingCardIcon.cardIcon) || CARD_ICON[CARD_ICON.length - 1].cardIcon;
    };
    _proto.findSelectedInstallment = function findSelectedInstallment(installmentMonth) {
        if (installmentMonth === undefined) return null;
        return this.installments.find(function(installment) {
            return installment.installmentMonth === installmentMonth;
        }) || null;
    };
    _proto.findDefaultPayment = function findDefaultPayment() {
        return this.payments.find(function(payment) {
            return payment.isDefault;
        }) || null;
    };
    _proto.getCanInstallmentByTreatmentRequest = function getCanInstallmentByTreatmentRequest(treatmentRequest) {
        var ref;
        var enableInstallmentTreatmentRequest = treatmentRequest.isOrientalNonF2FTreatmentRequest() || treatmentRequest.isDietF2FTreatmentRequest();
        var ref1;
        return enableInstallmentTreatmentRequest ? (ref1 = (ref = this.payments.find(function(payment) {
            return payment.id === treatmentRequest.form.paymentId;
        })) === null || ref === void 0 ? void 0 : ref.canInstallment) !== null && ref1 !== void 0 ? ref1 : false : false;
    };
    _proto.getValidationInstallmentByTreatmentRequest = function getValidationInstallmentByTreatmentRequest(treatmentRequest) {
        if (!this.getCanInstallmentByTreatmentRequest(treatmentRequest)) {
            return true;
        }
        return treatmentRequest.form.installmentMonth !== undefined;
    };
    (0,_create_class/* default */.Z)(UserPaymentsInfo, [
        {
            key: "payments",
            get: function get() {
                var _this = this;
                return this._userPayments.filter(function(payment) {
                    return payment.payCompany !== CardPayCompany.Unknown;
                }).map(function(payment) {
                    return {
                        canInstallment: payment.canInstallment,
                        cardName: payment.cardName,
                        cardNumber: payment.cardNumber,
                        displayedCardNumber: _this.displayCardNumber(payment.cardNumber),
                        id: payment.id,
                        isApproved: payment.isApproved,
                        isDefault: payment.isDefault,
                        payCompany: payment.payCompany,
                        displayedCardCompany: _this.getDisplayedCardCompany(payment.cardName),
                        CardIcon: _this.getCardIcon(payment.cardName)
                    };
                });
            }
        },
        {
            key: "nonKakaopayPayments",
            get: function get() {
                return this.payments.filter(function(payment) {
                    return payment.payCompany !== CardPayCompany.Kakaopay;
                });
            }
        },
        {
            key: "kakaopayPayments",
            get: function get() {
                return this.payments.filter(function(payment) {
                    return payment.payCompany === CardPayCompany.Kakaopay;
                });
            }
        },
        {
            key: "installments",
            get: function get() {
                return INSTALLMENT_SELECT_LIST;
            }
        },
        {
            key: "hasKakaoPayments",
            get: function get() {
                return this.kakaopayPayments.length > 0;
            }
        },
        {
            key: "hasNonKakaoPayments",
            get: function get() {
                return this.nonKakaopayPayments.length > 0;
            }
        }
    ]);
    return UserPaymentsInfo;
}();
var treatmentRequestAgreements = [
    {
        required: true,
        text: "개인정보 수집 및 이용 동의",
        selected: false,
        outLink: "https://company.doctornow.co.kr/board_diagnosis/?action=readpost&post_id=3494&bbspaged=1",
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "건강정보 수집 및 이용 동의",
        selected: false,
        outLink: "https://company.doctornow.co.kr/board_diagnosis/?action=readpost&post_id=3495&bbspaged=1",
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.F2F */.d.F2F,
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "제3자 제공 동의",
        selected: false,
        outLink: "https://company.doctornow.co.kr/board_diagnosis/?action=readpost&post_id=3496&bbspaged=1",
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "중요 안내사항에 대한 동의",
        selected: false,
        outLink: "https://company.doctornow.co.kr/board/?action=readpost&post_id=1521",
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.F2F */.d.F2F,
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "동일 성분 대체 조제 동의",
        selected: false,
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.F2F */.d.F2F,
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "진료비 자동 결제 동의",
        selected: false,
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.F2F */.d.F2F,
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    },
    {
        required: true,
        text: "약제비 미결제 시 자동 결제 동의",
        selected: false,
        contactTypeList: [
            diagnosis/* EDiagnosisContactType.F2F */.d.F2F,
            diagnosis/* EDiagnosisContactType.NonF2F */.d.NonF2F
        ]
    }, 
];
var InviterInfoModel = /*#__PURE__*/ function() {
    "use strict";
    function InviterInfoModel(invitationCode, canReceiveReward, inviterRewardAmount, inviteeRewardAmount, inviterReceivableTotalPoints) {
        (0,_class_call_check/* default */.Z)(this, InviterInfoModel);
        this.invitationCode = invitationCode;
        this.inviterRewardAmount = inviterRewardAmount;
        this.inviteeRewardAmount = inviteeRewardAmount;
        this.maxInvitationCount = Math.floor(inviterReceivableTotalPoints / inviterRewardAmount);
        this.canReceiveReward = canReceiveReward;
        this.inviterReceivableTotalPoints = inviterReceivableTotalPoints;
    }
    var _proto = InviterInfoModel.prototype;
    _proto.getData = function getData() {
        return {
            invitationCode: this.invitationCode,
            canReceiveReward: this.canReceiveReward,
            inviterRewardAmount: this.inviterRewardAmount,
            inviteeRewardAmount: this.inviteeRewardAmount,
            inviterReceivableTotalPoints: this.inviterReceivableTotalPoints,
            maxInvitationCount: this.maxInvitationCount
        };
    };
    InviterInfoModel.of = function of(response) {
        return new InviterInfoModel(response.code, response.inviterReceivedPoints < response.inviterReceivableTotalPoints, response.inviterRewardAmount, response.inviteeRewardAmount, response.inviterReceivableTotalPoints);
    };
    InviterInfoModel.initialOf = function initialOf(invitationCode) {
        return new InviterInfoModel(invitationCode, false, 0, 0, 0);
    };
    return InviterInfoModel;
}();


/***/ }),

/***/ 39591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ SsnInputStatus; },
/* harmony export */   "F1": function() { return /* binding */ EDiagnosisPriceType; },
/* harmony export */   "FT": function() { return /* binding */ TreatmentRequestInflowType; },
/* harmony export */   "NV": function() { return /* binding */ DiagnosisCompleteStep; },
/* harmony export */   "P2": function() { return /* binding */ DiagnosisCategoryType; },
/* harmony export */   "Qc": function() { return /* binding */ ScheduleStatus; },
/* harmony export */   "Zq": function() { return /* binding */ DiagnosisRequestCallType; },
/* harmony export */   "cR": function() { return /* binding */ EDiagnosisStep; },
/* harmony export */   "fL": function() { return /* binding */ DoctorDiagnosisFormType; },
/* harmony export */   "pA": function() { return /* binding */ HospitalDeliveryCategoryType; },
/* harmony export */   "qL": function() { return /* binding */ TreatmentRequest; },
/* harmony export */   "rT": function() { return /* binding */ NonFaceToFaceBookingSchedulesInfo; },
/* harmony export */   "v_": function() { return /* binding */ TreatmentRequestDoctor; }
/* harmony export */ });
/* unused harmony exports TelemedicineGroupCode, BookingTimeScheduleStatus */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27805);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18044);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72271);
/* harmony import */ var _types_diagnosis__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20138);
/* harmony import */ var _utils_validate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64002);
/* harmony import */ var _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2426);














var DiagnosisCompleteStep;
(function(DiagnosisCompleteStep) {
    DiagnosisCompleteStep["Find"] = "find";
    DiagnosisCompleteStep["Complete"] = "complete";
})(DiagnosisCompleteStep || (DiagnosisCompleteStep = {}));
var EDiagnosisPriceType;
(function(EDiagnosisPriceType) {
    EDiagnosisPriceType["DiagnosisOnly"] = "DIAGNOSIS_ONLY";
    EDiagnosisPriceType["WithDispensation"] = "WITH_DISPENSATION";
})(EDiagnosisPriceType || (EDiagnosisPriceType = {}));
var DiagnosisCategoryType;
(function(DiagnosisCategoryType) {
    DiagnosisCategoryType["Treatment"] = "symptom";
    DiagnosisCategoryType["Department"] = "subject";
    DiagnosisCategoryType["Vaccination"] = "vaccination";
})(DiagnosisCategoryType || (DiagnosisCategoryType = {}));
var TreatmentRequestInflowType;
(function(TreatmentRequestInflowType) {
    TreatmentRequestInflowType["GENERAL"] = "GENERAL";
    TreatmentRequestInflowType["QUICK"] = "QUICK";
    TreatmentRequestInflowType["WEB_GENERAL"] = "WEB_GENERAL";
    TreatmentRequestInflowType["WEB_QUICK"] = "WEB_QUICK";
})(TreatmentRequestInflowType || (TreatmentRequestInflowType = {}));
var EDiagnosisStep;
(function(EDiagnosisStep) {
    EDiagnosisStep["Diagnosis"] = "diagnosis";
    EDiagnosisStep["Payment"] = "payment";
    EDiagnosisStep["Doctor"] = "doctor";
    EDiagnosisStep["DoctorFilter"] = "doctor-filter";
    EDiagnosisStep["CertificationGuide"] = "user-verification-guide";
})(EDiagnosisStep || (EDiagnosisStep = {}));
var DiagnosisRequestCallType;
(function(DiagnosisRequestCallType) {
    DiagnosisRequestCallType["Video"] = "VIDEO";
    DiagnosisRequestCallType["Audio"] = "AUDIO";
})(DiagnosisRequestCallType || (DiagnosisRequestCallType = {}));
var TelemedicineGroupCode;
(function(TelemedicineGroupCode) {
    TelemedicineGroupCode["BACKWOODS_RESIDENT"] = "BACKWOODS_RESIDENT";
    TelemedicineGroupCode["MEDICAL_VULNERABLE_AREA_RESIDENT"] = "MEDICAL_VULNERABLE_AREA_RESIDENT";
    TelemedicineGroupCode["LONG_TERM_CARE_CLASSIFIER"] = "LONG_TERM_CARE_CLASSIFIER";
    TelemedicineGroupCode["REGISTERED_DISABLED"] = "REGISTERED_DISABLED";
    TelemedicineGroupCode["INFECTIOUS_DISEASE_CASE"] = "INFECTIOUS_DISEASE_CASE";
    TelemedicineGroupCode["UNDER_18_CHILD"] = "UNDER_18_CHILD";
    TelemedicineGroupCode["VISITED_PATIENT"] = "VISITED_PATIENT";
    TelemedicineGroupCode["OTHERS"] = "OTHERS";
})(TelemedicineGroupCode || (TelemedicineGroupCode = {}));
var DoctorDiagnosisFormType;
(function(DoctorDiagnosisFormType) {
    DoctorDiagnosisFormType["General"] = "GENERAL";
    DoctorDiagnosisFormType["InHospitalDelivery"] = "IN_HOSPITAL_DELIVERY";
})(DoctorDiagnosisFormType || (DoctorDiagnosisFormType = {}));
var HospitalDeliveryCategoryType;
(function(HospitalDeliveryCategoryType) {
    HospitalDeliveryCategoryType["PICKUP"] = "PICKUP";
    HospitalDeliveryCategoryType["POST"] = "POST";
    HospitalDeliveryCategoryType["QUICK"] = "QUICK";
})(HospitalDeliveryCategoryType || (HospitalDeliveryCategoryType = {}));
var SsnInputStatus;
(function(SsnInputStatus) {
    SsnInputStatus["Unfinished"] = "UNFINISHED";
    SsnInputStatus["Completed"] = "COMPLETE";
    SsnInputStatus["Errored"] = "ERRORED";
})(SsnInputStatus || (SsnInputStatus = {}));
var _obj;
var DELIVERY_CATEGORY_TITLE_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, HospitalDeliveryCategoryType.PICKUP, "방문해서 받을게요"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, HospitalDeliveryCategoryType.POST, "택배로 받을게요"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, HospitalDeliveryCategoryType.QUICK, "퀵으로 받을게요"), _obj);
var HOSPITAL_DELIVERY_CATEGORIES = Object.values(HospitalDeliveryCategoryType).map(function(hospitalDeliveryCategoryType) {
    return {
        title: DELIVERY_CATEGORY_TITLE_MAP["".concat(hospitalDeliveryCategoryType)],
        inHospitalDeliveryCategoryType: hospitalDeliveryCategoryType
    };
});
var DIET_CATEGORY_ID = "12";
var TreatmentRequest = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentRequest(form) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, TreatmentRequest);
        this.form = form;
        this.ETC_TREATMENT_MEDICINE_ID = null;
    }
    var _proto = TreatmentRequest.prototype;
    _proto.isInHospitalDelivery = function isInHospitalDelivery() {
        return this.form.diagnosisFormType === DoctorDiagnosisFormType.InHospitalDelivery;
    };
    _proto.isQuickMatchRequest = function isQuickMatchRequest() {
        return this.form.inflowType === TreatmentRequestInflowType.QUICK;
    };
    _proto.isWebQuickScheduleRequest = function isWebQuickScheduleRequest() {
        return this.form.inflowType === TreatmentRequestInflowType.WEB_QUICK;
    };
    _proto.hasScheduleModeSelected = function hasScheduleModeSelected() {
        return this.form.inflowType === TreatmentRequestInflowType.WEB_QUICK || this.form.inflowType === TreatmentRequestInflowType.WEB_GENERAL;
    };
    _proto.shouldShowAsapRequest = function shouldShowAsapRequest() {
        return this.isNonF2FTreatmentRequest() && !this.isQuickMatchRequest();
    };
    _proto.isOrientalTreatmentRequest = function isOrientalTreatmentRequest() {
        return this.form.medicineType === _models_common__WEBPACK_IMPORTED_MODULE_1__/* .DoctorMedicineType.OrientalDoctor */ .UO.OrientalDoctor;
    };
    _proto.isF2FTreatmentRequest = function isF2FTreatmentRequest() {
        return this.form.contactType === _types_diagnosis__WEBPACK_IMPORTED_MODULE_3__/* .EDiagnosisContactType.F2F */ .d.F2F;
    };
    _proto.isDietF2FTreatmentRequest = function isDietF2FTreatmentRequest() {
        return this.form.categoryType === DiagnosisCategoryType.Treatment && this.form.categoryId === DIET_CATEGORY_ID && this.isF2FTreatmentRequest();
    };
    _proto.isDietNonF2FTreatmentRequest = function isDietNonF2FTreatmentRequest() {
        return this.form.categoryType === DiagnosisCategoryType.Treatment && this.form.categoryId === DIET_CATEGORY_ID && this.isNonF2FTreatmentRequest();
    };
    _proto.isNonF2FTreatmentRequest = function isNonF2FTreatmentRequest() {
        return this.form.contactType === _types_diagnosis__WEBPACK_IMPORTED_MODULE_3__/* .EDiagnosisContactType.NonF2F */ .d.NonF2F;
    };
    _proto.isOrientalNonF2FTreatmentRequest = function isOrientalNonF2FTreatmentRequest() {
        return this.isOrientalTreatmentRequest() && this.isNonF2FTreatmentRequest();
    };
    _proto.isCategorySelected = function isCategorySelected() {
        return !!this.form.categoryId && !!this.form.categoryType;
    };
    _proto.hasVideoCallRequest = function hasVideoCallRequest() {
        return this.form.hasVideoRequestCallType;
    };
    _proto.getCategory = function getCategory() {
        var isCategorySelected = this.isCategorySelected();
        if (!isCategorySelected) {
            return null;
        }
        return {
            categoryId: this.form.categoryId,
            categoryType: this.form.categoryType
        };
    };
    _proto.updateSymptom = function updateSymptom(symptom) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            symptomInfo: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.symptomInfo), {
                symptom: symptom
            })
        });
        return this.form;
    };
    _proto.updatePatientSsn = function updatePatientSsn(patientSsn) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            patient: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.patient), {
                patientSsn: patientSsn
            })
        });
        return this.form;
    };
    _proto.resetPatientSsn = function resetPatientSsn() {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            patient: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.patient), {
                patientSsn: ""
            })
        });
        return this.form;
    };
    _proto.selectCard = function selectCard(paymentId) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            paymentId: paymentId
        });
        return this.form;
    };
    _proto.updateInstallment = function updateInstallment(installmentMonth) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            installmentMonth: installmentMonth
        });
        return this.form;
    };
    _proto.initializeTreatmentRequestFromDoctor = function initializeTreatmentRequestFromDoctor(doctor) {
        this.form = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            doctorId: doctor.doctorId,
            medicineType: doctor.medicineType,
            hasVideoRequestCallType: this.isNonF2FTreatmentRequest() ? doctor.readyForVideoCall : false,
            requestForVideoCall: this.isNonF2FTreatmentRequest() && doctor.readyForVideoCall ? undefined : DiagnosisRequestCallType.Audio
        }), doctor.diagnosisFormType === DoctorDiagnosisFormType.InHospitalDelivery ? {
            diagnosisFormType: DoctorDiagnosisFormType.InHospitalDelivery,
            delivery: {
                addressId: "",
                inHospitalDeliveryCategoryType: undefined
            },
            isVisitBrand: undefined
        } : {
            diagnosisFormType: DoctorDiagnosisFormType.General
        });
    };
    _proto.updateTreatmentMedicineId = function updateTreatmentMedicineId(treatmentMedicineId) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            treatmentMedicineId: treatmentMedicineId
        });
    };
    _proto.selectBookingTargetDate = function selectBookingTargetDate(bookingTargetDate) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            bookingTargetDate: bookingTargetDate,
            startTimeSlotValue: -1,
            endTimeSlotValue: -1
        });
    };
    _proto.selectBookingTimeSlot = function selectBookingTimeSlot(startTimeSlotValue, endTimeSlotValue) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            startTimeSlotValue: startTimeSlotValue,
            endTimeSlotValue: endTimeSlotValue
        });
        return this.form;
    };
    _proto.updateDoctorPid = function updateDoctorPid(doctorPublicId) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            doctorPid: doctorPublicId
        });
        return this.form;
    };
    _proto.toggleAsapRequest = function toggleAsapRequest() {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            isAsapRequest: !this.form.isAsapRequest
        });
        return this.form;
    };
    _proto.setScheduleMode = function setScheduleMode(mode) {
        var shouldClearSchedule = mode === TreatmentRequestInflowType.WEB_QUICK;
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            inflowType: mode,
            bookingTargetDate: shouldClearSchedule ? "" : this.form.bookingTargetDate,
            startTimeSlotValue: shouldClearSchedule ? -1 : this.form.startTimeSlotValue,
            endTimeSlotValue: shouldClearSchedule ? -1 : this.form.endTimeSlotValue
        });
        return this.form;
    };
    _proto.toggleQuickScheduleMode = function toggleQuickScheduleMode() {
        var isCurrentlyQuickMode = this.isWebQuickScheduleRequest();
        var newMode = isCurrentlyQuickMode ? TreatmentRequestInflowType.WEB_GENERAL : TreatmentRequestInflowType.WEB_QUICK;
        return this.setScheduleMode(newMode);
    };
    _proto.hasEtcTreatmentMedicine = function hasEtcTreatmentMedicine() {
        return this.form.treatmentMedicineId === this.ETC_TREATMENT_MEDICINE_ID;
    };
    _proto.updateVisitBrand = function updateVisitBrand(isVisitBrand) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            isVisitBrand: isVisitBrand
        });
        return this.form;
    };
    _proto.updateRequestCallType = function updateRequestCallType(requestForVideoCall) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            requestForVideoCall: requestForVideoCall
        });
        return this.form;
    };
    _proto.updateUserProfile = function updateUserProfile(patient) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            patient: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.patient, patient)
        });
    };
    _proto.updateSymptomImages = function updateSymptomImages(attachFiles) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            symptomInfo: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.symptomInfo), {
                attachFiles: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this.form.symptomInfo.attachFiles).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(attachFiles))
            })
        });
        return this.form;
    };
    _proto.removeSymptomImage = function removeSymptomImage(imageIndex) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            symptomInfo: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form.symptomInfo), {
                attachFiles: this.form.symptomInfo.attachFiles.filter(function(_, index) {
                    return imageIndex !== index;
                })
            })
        });
        return this.form;
    };
    _proto.updateInHospitalDeliveryType = function updateInHospitalDeliveryType(form, inHospitalDeliveryCategoryType) {
        if (form.diagnosisFormType === DoctorDiagnosisFormType.General) {
            return form;
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, form), {
            delivery: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, form.delivery), {
                inHospitalDeliveryCategoryType: inHospitalDeliveryCategoryType
            })
        });
    };
    _proto.selectAddress = function selectAddress(form, addressId) {
        if (form.diagnosisFormType === DoctorDiagnosisFormType.General) {
            return form;
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, form), {
            delivery: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, form.delivery), {
                addressId: addressId
            })
        });
    };
    _proto.updatePharmacyId = function updatePharmacyId(pharmacyId) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            pharmacyId: pharmacyId
        });
    };
    _proto.updateDispensationInfo = function updateDispensationInfo(dispensationInfo) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            dispensationInfo: dispensationInfo
        });
    };
    _proto.getForm = function getForm() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form);
    };
    _proto.shouldShowPointUseRequest = function shouldShowPointUseRequest() {
        if (!this.form.treatmentMedicineId) {
            return false;
        }
        return !this.hasEtcTreatmentMedicine();
    };
    _proto.getCurrentSsnStatus = function getCurrentSsnStatus() {
        if (!this.form.patient.patientBirth || this.form.patient.patientBirth.length !== 6 || this.form.patient.patientSsn.length !== 7) {
            return SsnInputStatus.Unfinished;
        }
        if ((0,_utils_validate__WEBPACK_IMPORTED_MODULE_4__/* .validateSsnCheck */ .Zr)(this.form.patient.patientBirth, this.form.patient.patientSsn, this.form.patient.isSsnChanged)) {
            return SsnInputStatus.Completed;
        }
        return SsnInputStatus.Errored;
    };
    _proto.validateSsn = function validateSsn() {
        return this.getCurrentSsnStatus() === SsnInputStatus.Completed;
    };
    _proto.isSelectedTreatmentMedicine = function isSelectedTreatmentMedicine() {
        return this.form.treatmentMedicineId !== undefined;
    };
    _proto.getTreatmentMedicineName = function getTreatmentMedicineName(categoryInfo) {
        var _this = this;
        var ref, ref1;
        if (!categoryInfo || !categoryInfo.hasMedicine()) {
            return "";
        }
        var foundMedicineName = (ref1 = (ref = categoryInfo.medicines) === null || ref === void 0 ? void 0 : ref.find(function(medicine) {
            return medicine.id === _this.form.treatmentMedicineId;
        })) === null || ref1 === void 0 ? void 0 : ref1.medicineName;
        return foundMedicineName ? " / ".concat(foundMedicineName) : "";
    };
    _proto.toggleRequestUsePoint = function toggleRequestUsePoint() {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            requestUsePointForNonBenefitDiagnosis: !this.form.requestUsePointForNonBenefitDiagnosis
        });
        return this.form;
    };
    _proto.updateRequestAgreement = function updateRequestAgreement(isAgreement) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            isAgreement: isAgreement
        });
        return this.form;
    };
    _proto.getSortKey = function getSortKey() {
        var _sortKey;
        return (_sortKey = this.form.sortKey) !== null && _sortKey !== void 0 ? _sortKey : _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__/* .EDoctorSortType.DEFAULT */ ._c.DEFAULT;
    };
    _proto.getSortKeyName = function getSortKeyName() {
        switch(this.getSortKey()){
            case _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__/* .EDoctorSortType.DEFAULT */ ._c.DEFAULT:
                return "기본순";
            case _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__/* .EDoctorSortType.REVIEW_COUNT */ ._c.REVIEW_COUNT:
                return "후기많은순";
            case _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__/* .EDoctorSortType.REVIEW_AVERAGE_RATING */ ._c.REVIEW_AVERAGE_RATING:
                return "별점높은순";
            case _doctor_telemedicine__WEBPACK_IMPORTED_MODULE_5__/* .EDoctorSortType.DISTANCE */ ._c.DISTANCE:
                return "가까운순";
            default:
                return "기본순";
        }
    };
    _proto.updateSortKey = function updateSortKey(sortKey) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            sortKey: sortKey
        });
        return this.form;
    };
    _proto.updateSpecialistOnly = function updateSpecialistOnly(specialistOnly) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            specialistOnly: specialistOnly
        });
        return this.form;
    };
    _proto.getIsSpecialistOnly = function getIsSpecialistOnly() {
        var _specialistOnly;
        return (_specialistOnly = this.form.specialistOnly) !== null && _specialistOnly !== void 0 ? _specialistOnly : false;
    };
    _proto.updateGeoPoint = function updateGeoPoint(geoPoint) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            geoPoint: geoPoint
        });
        return this.form;
    };
    _proto.getGeoPoint = function getGeoPoint() {
        return this.form.geoPoint;
    };
    _proto.updateSelectedDoctorFilters = function updateSelectedDoctorFilters(filters) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            selectedDoctorFilters: filters
        });
        return this.form;
    };
    _proto.getSelectedDoctorFilters = function getSelectedDoctorFilters() {
        var _selectedDoctorFilters;
        return (_selectedDoctorFilters = this.form.selectedDoctorFilters) !== null && _selectedDoctorFilters !== void 0 ? _selectedDoctorFilters : [];
    };
    _proto.selectTreatmentRequestDepartment = function selectTreatmentRequestDepartment(department) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            categoryId: department.id,
            categoryType: DiagnosisCategoryType.Department,
            treatmentMedicineId: undefined
        });
    };
    _proto.selectTreatmentRequestTreatment = function selectTreatmentRequestTreatment(treatment) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            categoryId: treatment.id,
            categoryType: DiagnosisCategoryType.Treatment,
            treatmentMedicineId: undefined
        });
    };
    _proto.validateDiagnosisStepWithoutDetailSymptom = function validateDiagnosisStepWithoutDetailSymptom(categoryInfo) {
        if (this.isInHospitalDelivery() && this.form.isVisitBrand === undefined) {
            return false;
        }
        /* 스케쥴 미선택 케이스 */ if (this.form.startTimeSlotValue < 0 || this.form.endTimeSlotValue < 0) {
            return false;
        }
        if (this.form.requestForVideoCall === undefined) {
            return false;
        }
        /* 주민번호 검증 실패 케이스 */ if (!this.validateSsn()) {
            return false;
        }
        if (!this.isCategorySelected()) {
            return false;
        }
        /* 비급여에서 세부 카테고리를 가졌을 때 아직 약품을 선택하지 않은 케이스 */ return !(!!(categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.hasMedicine()) && !this.isSelectedTreatmentMedicine());
    };
    _proto.validateDiagnosisStepByWebDiagnosis = function validateDiagnosisStepByWebDiagnosis() {
        /* 가장 빠른 시간에 진료받기 모드가 아닐 때만 스케쥴 검증 */ if (!this.isWebQuickScheduleRequest()) {
            if (this.form.startTimeSlotValue < 0 || this.form.endTimeSlotValue < 0) {
                return false;
            }
        }
        /* 주민번호 검증 실패 케이스 */ if (!this.validateSsn()) {
            return false;
        }
        if (!this.isCategorySelected()) {
            return false;
        }
        if (this.form.symptomInfo.symptom.length === 0) {
            return false;
        }
        return true;
    };
    _proto.validateDiagnosisStep = function validateDiagnosisStep(categoryInfo) {
        /* 원내배송일때 이전에 브랜드 이용유무 확인을 하지 않은 케이스 */ if (!this.validateDiagnosisStepWithoutDetailSymptom(categoryInfo)) {
            return false;
        }
        return !!this.form.symptomInfo.symptom;
    };
    _proto.validatePaymentStepBeforeAgreementCheck = function validatePaymentStepBeforeAgreementCheck() {
        if (this.form.diagnosisFormType === DoctorDiagnosisFormType.InHospitalDelivery) {
            if (!this.form.delivery) {
                return false;
            }
            if (!this.form.delivery.inHospitalDeliveryCategoryType) {
                return false;
            }
            if (!this.form.delivery.addressId) {
                return false;
            }
        }
        /* 카드가 선택되어 있는지 체크 */ return !!this.form.paymentId;
    };
    _proto.isDisabledApproveCheckButton = function isDisabledApproveCheckButton() {
        if (!this.validatePaymentStepBeforeAgreementCheck()) {
            return false;
        }
        /* 약관을 제외하고 모든 값이 선택되어 있다면 진료 약관 확인 및 동의 버튼 노출 */ return !this.form.isAgreement;
    };
    _proto.validatePaymentStep = function validatePaymentStep() {
        if (!this.validatePaymentStepBeforeAgreementCheck()) {
            return false;
        }
        /* 약관 승인 체크 */ return this.form.isAgreement;
    };
    _proto.updateDoctorId = function updateDoctorId(doctorId) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            doctorId: doctorId
        });
        return this.form;
    };
    _proto.getDoctorId = function getDoctorId() {
        return this.form.doctorId;
    };
    _proto.updateReceiptLocation = function updateReceiptLocation(receiptLocation) {
        this.form = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.form), {
            receiptLocation: receiptLocation
        });
        return this.form;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TreatmentRequest, [
        {
            key: "videoCallRequestTitle",
            get: function get() {
                if (!this.hasVideoCallRequest()) {
                    return "";
                }
                if (this.form.requestForVideoCall === undefined) {
                    return "진료 방식";
                }
                return this.form.requestForVideoCall === DiagnosisRequestCallType.Video ? "영상 진료" : "음성 진료";
            }
        },
        {
            key: "deliveryCategoryList",
            get: function get() {
                /* 퀵 배송 수단을 숨겨달라는 요청에 의해 임시 필터링 */ return HOSPITAL_DELIVERY_CATEGORIES.filter(function(category) {
                    return category.inHospitalDeliveryCategoryType !== HospitalDeliveryCategoryType.QUICK;
                });
            }
        },
        {
            key: "deliveryTypeText",
            get: function get() {
                if (this.form.diagnosisFormType === DoctorDiagnosisFormType.General) {
                    return "";
                }
                if (!this.form.delivery.inHospitalDeliveryCategoryType) {
                    return "약은 어떻게 받으시겠어요?";
                }
                return DELIVERY_CATEGORY_TITLE_MAP[this.form.delivery.inHospitalDeliveryCategoryType];
            }
        },
        {
            key: "deliveryTypeSelectTitle",
            get: function get() {
                var ref;
                if (this.form.diagnosisFormType === DoctorDiagnosisFormType.General) {
                    return "";
                }
                switch((ref = this.form.delivery) === null || ref === void 0 ? void 0 : ref.inHospitalDeliveryCategoryType){
                    case HospitalDeliveryCategoryType.PICKUP:
                        return "어디서 진료를 받고 있으신가요?";
                    case HospitalDeliveryCategoryType.POST:
                    case HospitalDeliveryCategoryType.QUICK:
                        return "배송지를 입력해주세요.";
                    default:
                        return "";
                }
            }
        }
    ]);
    return TreatmentRequest;
}();
var ScheduleStatus;
(function(ScheduleStatus) {
    ScheduleStatus["BOOKABLE"] = "BOOKABLE";
    ScheduleStatus["FULLY_BOOKED"] = "FULLY_BOOKED";
    ScheduleStatus["HOLIDAY"] = "HOLIDAY";
})(ScheduleStatus || (ScheduleStatus = {}));
var BookingTimeScheduleStatus;
(function(BookingTimeScheduleStatus) {
    BookingTimeScheduleStatus["Bookable"] = "BOOKABLE";
    BookingTimeScheduleStatus["Disabled"] = "DISABLED";
    BookingTimeScheduleStatus["FullyBooked"] = "FULLY_BOOKED";
})(BookingTimeScheduleStatus || (BookingTimeScheduleStatus = {}));
var NonFaceToFaceBookingSchedulesInfo = /*#__PURE__*/ function() {
    "use strict";
    function NonFaceToFaceBookingSchedulesInfo(_schedules) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, NonFaceToFaceBookingSchedulesInfo);
        this._schedules = _schedules;
        this.AT_NOON_TIME_SLOT_VALUE = 72;
        this.DAWN_END_VALUE = 46;
        this.MORNING_START_VALUE = 48;
        this.MORNING_END_VALUE = 70;
        this.AFTERNOON_START_VALUE = 72;
        this.AFTERNOON_END_VALUE = 118;
        this.NIGHT_START_VALUE = 120;
    }
    var _proto = NonFaceToFaceBookingSchedulesInfo.prototype;
    _proto.getScheduleStatus = function getScheduleStatus(status) {
        switch(status){
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .DayScheduleStatus.Bookable */ .NZ.Bookable:
                return ScheduleStatus.BOOKABLE;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .DayScheduleStatus.FullyBooked */ .NZ.FullyBooked:
                return ScheduleStatus.FULLY_BOOKED;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .DayScheduleStatus.Holiday */ .NZ.Holiday:
                return ScheduleStatus.HOLIDAY;
        }
    };
    _proto.getBookingTimeStatus = function getBookingTimeStatus(status) {
        switch(status){
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .BookingScheduleType.Bookable */ .GqI.Bookable:
                return BookingTimeScheduleStatus.Bookable;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .BookingScheduleType.Disabled */ .GqI.Disabled:
                return BookingTimeScheduleStatus.Disabled;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .BookingScheduleType.FullyBooked */ .GqI.FullyBooked:
                return BookingTimeScheduleStatus.FullyBooked;
        }
    };
    _proto.convertSchedule = function convertSchedule(schedule) {
        return {
            bookingStatus: this.getBookingTimeStatus(schedule.bookingStatus),
            isBookable: this.getBookingTimeStatus(schedule.bookingStatus) === BookingTimeScheduleStatus.Bookable,
            startTimeSlot: {
                value: schedule.startTimeSlot.value,
                displayTime: schedule.startTimeSlot.displayTime,
                fromDisplayTime: schedule.startTimeSlot.fromDisplayTime,
                toDisplayTime: schedule.startTimeSlot.toDisplayTime
            },
            endTimeSlot: {
                value: schedule.endTimeSlot.value,
                displayTime: schedule.endTimeSlot.displayTime,
                fromDisplayTime: schedule.endTimeSlot.fromDisplayTime,
                toDisplayTime: schedule.endTimeSlot.toDisplayTime
            },
            remainingCount: schedule.remainingCount,
            isSelected: function(startTimeSlotValue, endTimeSlotValue) {
                return schedule.startTimeSlot.value === startTimeSlotValue && schedule.endTimeSlot.value === endTimeSlotValue;
            }
        };
    };
    _proto.filterSchedulesByTimeRange = function filterSchedulesByTimeRange(schedules, startValue, endValue) {
        var _this = this;
        return schedules.filter(function(schedule) {
            var value = schedule.startTimeSlot.value;
            return endValue !== undefined ? value >= startValue && value <= endValue : value >= startValue;
        }).map(function(schedule) {
            return _this.convertSchedule(schedule);
        });
    };
    _proto.findSelectedDaySchedule = function findSelectedDaySchedule(treatmentRequest) {
        var bookingTargetDate = treatmentRequest.form.bookingTargetDate;
        return this.daySchedules.find(function(schedule) {
            return schedule.targetDate === bookingTargetDate;
        }) || null;
    };
    _proto.findSelectedDayScheduleGroupedByTimePeriod = function findSelectedDayScheduleGroupedByTimePeriod(treatmentRequest) {
        var bookingTargetDate = treatmentRequest.form.bookingTargetDate;
        return this.daySchedulesGroupedByTimePeriod.find(function(schedule) {
            return schedule.targetDate === bookingTargetDate;
        }) || null;
    };
    _proto.findSelectedTimeSlot = function findSelectedTimeSlot(treatmentRequest) {
        var _form = treatmentRequest.form, startTimeSlotValue = _form.startTimeSlotValue, endTimeSlotValue = _form.endTimeSlotValue;
        var selectedDay = this.findSelectedDaySchedule(treatmentRequest);
        if (!selectedDay) {
            return null;
        }
        return selectedDay.morningSchedules.find(function(time) {
            return time.isSelected(startTimeSlotValue, endTimeSlotValue);
        }) || selectedDay.afternoonSchedules.find(function(time) {
            return time.isSelected(startTimeSlotValue, endTimeSlotValue);
        }) || null;
    };
    _proto.getSelectedTimeSlotTitle = function getSelectedTimeSlotTitle(treatmentRequest) {
        var shouldShowQuickModeTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (treatmentRequest.isWebQuickScheduleRequest() && shouldShowQuickModeTitle) {
            return "가장 빠른 시간에 진료받기";
        }
        var selectedDay = this.findSelectedDaySchedule(treatmentRequest);
        var selectedTimeSlot = this.findSelectedTimeSlot(treatmentRequest);
        if (!selectedDay || !selectedTimeSlot) {
            return "진료 날짜";
        }
        return "".concat(dayjs__WEBPACK_IMPORTED_MODULE_0___default()("".concat(selectedDay.targetDate)).format("M월 D일"), " ").concat(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.startTimeSlot.fromDisplayTime, "~").concat(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.endTimeSlot.toDisplayTime);
    };
    _proto.findNearestBookingDay = function findNearestBookingDay() {
        return this.daySchedules.find(function(daySchedule) {
            return daySchedule.isBookableDay;
        }) || null;
    };
    _proto.findNearestBookingDayAndTimeSlot = function findNearestBookingDayAndTimeSlot() {
        var nearestDaySchedule = this.findNearestBookingDay();
        if (!nearestDaySchedule) {
            return {
                targetDate: "",
                startTimeSlotValue: -1,
                endTimeSlotValue: -1
            };
        }
        var bookableMorningTimeSlot = nearestDaySchedule.morningSchedules.find(function(timeSlot) {
            return timeSlot.isBookable;
        });
        var bookableAfternoonTimeSlot = nearestDaySchedule.afternoonSchedules.find(function(timeSlot) {
            return timeSlot.isBookable;
        });
        return {
            targetDate: nearestDaySchedule.targetDate,
            startTimeSlotValue: bookableMorningTimeSlot ? bookableMorningTimeSlot.startTimeSlot.value : bookableAfternoonTimeSlot ? bookableAfternoonTimeSlot.startTimeSlot.value : -1,
            endTimeSlotValue: bookableMorningTimeSlot ? bookableMorningTimeSlot.endTimeSlot.value : bookableAfternoonTimeSlot ? bookableAfternoonTimeSlot.endTimeSlot.value : -1
        };
    };
    _proto.getQuickestAvailableMinutes = function getQuickestAvailableMinutes() {
        var nearestDaySchedule = this.findNearestBookingDay();
        if (!nearestDaySchedule) {
            return null;
        }
        var bookableMorningTimeSlot = nearestDaySchedule.morningSchedules.find(function(timeSlot) {
            return timeSlot.isBookable;
        });
        var bookableAfternoonTimeSlot = nearestDaySchedule.afternoonSchedules.find(function(timeSlot) {
            return timeSlot.isBookable;
        });
        var firstBookableSlot = bookableMorningTimeSlot || bookableAfternoonTimeSlot;
        if (!firstBookableSlot) {
            return null;
        }
        var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
        var targetDateTime = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(nearestDaySchedule.targetDate);
        var endTime = firstBookableSlot.endTimeSlot.displayTime;
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(endTime.split(":").map(Number), 2), hours = ref[0], minutes = ref[1];
        var slotEndDateTime = targetDateTime.hour(hours).minute(minutes).second(0);
        var diffInMinutes = slotEndDateTime.diff(now, "minute");
        return diffInMinutes > 0 ? diffInMinutes : null;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(NonFaceToFaceBookingSchedulesInfo, [
        {
            key: "daySchedules",
            get: function get() {
                var _this = this;
                return this._schedules.map(function(daySchedule) {
                    return {
                        displayName: daySchedule.displayName,
                        status: _this.getScheduleStatus(daySchedule.status),
                        isBookableDay: _this.getScheduleStatus(daySchedule.status) === ScheduleStatus.BOOKABLE,
                        targetDate: daySchedule.targetDate,
                        morningSchedules: daySchedule.schedules.filter(function(schedule) {
                            return schedule.startTimeSlot.value < _this.AT_NOON_TIME_SLOT_VALUE;
                        }).map(function(schedule) {
                            return _this.convertSchedule(schedule);
                        }),
                        afternoonSchedules: daySchedule.schedules.filter(function(schedule) {
                            return schedule.startTimeSlot.value >= _this.AT_NOON_TIME_SLOT_VALUE;
                        }).map(function(schedule) {
                            return _this.convertSchedule(schedule);
                        })
                    };
                });
            }
        },
        {
            key: "daySchedulesGroupedByTimePeriod",
            get: function get() {
                var _this = this;
                return this._schedules.map(function(daySchedule) {
                    return {
                        displayName: daySchedule.displayName,
                        status: _this.getScheduleStatus(daySchedule.status),
                        isBookableDay: _this.getScheduleStatus(daySchedule.status) === ScheduleStatus.BOOKABLE,
                        targetDate: daySchedule.targetDate,
                        dawnSchedules: _this.filterSchedulesByTimeRange(daySchedule.schedules, 0, _this.DAWN_END_VALUE),
                        morningSchedules: _this.filterSchedulesByTimeRange(daySchedule.schedules, _this.MORNING_START_VALUE, _this.MORNING_END_VALUE),
                        afternoonSchedules: _this.filterSchedulesByTimeRange(daySchedule.schedules, _this.AFTERNOON_START_VALUE, _this.AFTERNOON_END_VALUE),
                        nightSchedules: _this.filterSchedulesByTimeRange(daySchedule.schedules, _this.NIGHT_START_VALUE)
                    };
                });
            }
        }
    ]);
    return NonFaceToFaceBookingSchedulesInfo;
}();
var TreatmentRequestDoctor = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentRequestDoctor(_doctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, TreatmentRequestDoctor);
        this._doctor = _doctor;
        this.getDoctorMedicineType = function(medicineType) {
            switch(medicineType){
                case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .MedicineType.Dentist */ .UH9.Dentist:
                    return _models_common__WEBPACK_IMPORTED_MODULE_1__/* .DoctorMedicineType.Dentist */ .UO.Dentist;
                case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .MedicineType.Doctor */ .UH9.Doctor:
                    return _models_common__WEBPACK_IMPORTED_MODULE_1__/* .DoctorMedicineType.Doctor */ .UO.Doctor;
                case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .MedicineType.OrientalDoctor */ .UH9.OrientalDoctor:
                    return _models_common__WEBPACK_IMPORTED_MODULE_1__/* .DoctorMedicineType.OrientalDoctor */ .UO.OrientalDoctor;
                default:
                    return _models_common__WEBPACK_IMPORTED_MODULE_1__/* .DoctorMedicineType.Unknown */ .UO.Unknown;
            }
        };
        this.getDiagnosisFormType = function(diagnosisFormType) {
            switch(diagnosisFormType){
                case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisFormType.General */ .qRY.General:
                    return DoctorDiagnosisFormType.General;
                case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisFormType.InHospitalDelivery */ .qRY.InHospitalDelivery:
                    return DoctorDiagnosisFormType.InHospitalDelivery;
                default:
                    return DoctorDiagnosisFormType.General;
            }
        };
    }
    var _proto = TreatmentRequestDoctor.prototype;
    _proto.findTreatmentByCategoryId = function findTreatmentByCategoryId(categoryId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.treatmentCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var treatmentCategory = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = treatmentCategory.treatments[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var treatment = _step1.value;
                        if (treatment.id === categoryId) {
                            return treatment;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    _proto.getSelectedCategory = function getSelectedCategory(params) {
        if (!params) {
            return undefined;
        }
        var categoryType = params.categoryType, categoryId = params.categoryId;
        if (categoryType === DiagnosisCategoryType.Department) {
            var foundDepartment = this.departments.find(function(department) {
                return department.id === categoryId;
            });
            return foundDepartment ? {
                id: foundDepartment.id,
                type: DiagnosisCategoryType.Department,
                name: foundDepartment.name,
                hasMedicine: function() {
                    return false;
                },
                medicines: []
            } : undefined;
        } else if (categoryType === DiagnosisCategoryType.Treatment) {
            var foundTreatment = this.findTreatmentByCategoryId(categoryId);
            return foundTreatment ? {
                id: foundTreatment.id,
                type: DiagnosisCategoryType.Treatment,
                name: foundTreatment.name,
                hasMedicine: function() {
                    return !!foundTreatment.medicines && foundTreatment.medicines.length > 0;
                },
                medicines: foundTreatment.medicines
            } : undefined;
        } else if (categoryType === DiagnosisCategoryType.Vaccination) {
            var foundVaccination = this.doctorVaccinations.find(function(vaccination) {
                return vaccination.treatmentId === categoryId;
            });
            return foundVaccination ? {
                id: foundVaccination.treatmentId,
                type: DiagnosisCategoryType.Vaccination,
                name: foundVaccination.treatmentName,
                hasMedicine: function() {
                    return false;
                },
                medicines: []
            } : undefined;
        }
        return undefined;
    };
    _proto.getSelectedCategoryName = function getSelectedCategoryName(params) {
        var ref;
        var ref1;
        return (ref1 = (ref = this.getSelectedCategory(params)) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "증상 또는 과목을 선택해주세요";
    };
    _proto.hasDepartments = function hasDepartments() {
        return this.departments.length > 0;
    };
    _proto.hasTreatmentCategories = function hasTreatmentCategories() {
        return this.treatmentCategories.length > 0;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TreatmentRequestDoctor, [
        {
            key: "doctorId",
            get: function get() {
                return this._doctor.doctorId;
            }
        },
        {
            key: "doctorName",
            get: function get() {
                return this._doctor.name;
            }
        },
        {
            key: "readyForVideoCall",
            get: function get() {
                return this._doctor.readyForVideoCall;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.getDoctorMedicineType(this._doctor.medicineType);
            }
        },
        {
            key: "diagnosisFormType",
            get: function get() {
                return this.getDiagnosisFormType(this._doctor.diagnosisFormType);
            }
        },
        {
            key: "departments",
            get: function get() {
                return this._doctor.departments;
            }
        },
        {
            key: "treatmentCategories",
            get: /* 비급여 진료항목중에서 그외 진료 및 처방 추가 */ function get() {
                return this._doctor.treatmentCategories.map(function(treatmentCategory) {
                    return {
                        id: treatmentCategory.id,
                        name: treatmentCategory.name,
                        iconUrl: treatmentCategory.iconUrl,
                        treatments: treatmentCategory.treatments.map(function(treatment) {
                            return {
                                id: treatment.id,
                                name: treatment.name,
                                medicines: treatment.medicines.length > 0 ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(treatment.medicines).concat([
                                    {
                                        id: null,
                                        medicineName: "그 외 진료 및 처방"
                                    }
                                ]) : []
                            };
                        })
                    };
                });
            }
        },
        {
            key: "doctorProfileImage",
            get: function get() {
                return this._doctor.profileImageUrl;
            }
        },
        {
            key: "brandName",
            get: function get() {
                var _brandName;
                return (_brandName = this._doctor.brandName) !== null && _brandName !== void 0 ? _brandName : "";
            }
        },
        {
            key: "doctorVaccinations",
            get: function get() {
                var _doctorVaccinations;
                return (_doctorVaccinations = this._doctor.doctorVaccinations) !== null && _doctorVaccinations !== void 0 ? _doctorVaccinations : [];
            }
        }
    ]);
    return TreatmentRequestDoctor;
}();


/***/ }),

/***/ 2426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ NonF2fBookingSchedule; },
/* harmony export */   "WS": function() { return /* binding */ NonF2fDoctorReviewInfo; },
/* harmony export */   "_c": function() { return /* binding */ EDoctorSortType; },
/* harmony export */   "_t": function() { return /* binding */ EBookingAvailability; },
/* harmony export */   "ud": function() { return /* binding */ NonF2fDoctor; },
/* harmony export */   "xX": function() { return /* binding */ EBookingScheduleType; },
/* harmony export */   "yf": function() { return /* binding */ NonF2fBookingInfo; }
/* harmony export */ });
/* unused harmony export NonF2fDoctorMedicinePricing */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27805);
/* harmony import */ var _entities_doctor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92998);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4611);




var EDoctorSortType;
(function(EDoctorSortType) {
    EDoctorSortType["DEFAULT"] = "DEFAULT";
    EDoctorSortType["DISTANCE"] = "DISTANCE";
    EDoctorSortType["REVIEW_COUNT"] = "REVIEW_COUNT";
    EDoctorSortType["REVIEW_AVERAGE_RATING"] = "REVIEW_AVERAGE_RATING";
})(EDoctorSortType || (EDoctorSortType = {}));
var EBookingAvailability;
(function(EBookingAvailability) {
    EBookingAvailability["NotBookable"] = "NOT_BOOKABLE";
    EBookingAvailability["TodayBookable"] = "TODAY_BOOKABLE";
    EBookingAvailability["TomorrowBookable"] = "TOMORROW_BOOKABLE";
    EBookingAvailability["UpcomingBookable"] = "UPCOMING_BOOKABLE";
    EBookingAvailability["Unknown"] = "UNKNOWN";
})(EBookingAvailability || (EBookingAvailability = {}));
var EBookingScheduleType;
(function(EBookingScheduleType) {
    EBookingScheduleType["Today"] = "TODAY";
    EBookingScheduleType["Tomorrow"] = "TOMORROW";
})(EBookingScheduleType || (EBookingScheduleType = {}));
var NonF2fDoctorReviewInfo = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fDoctorReviewInfo(averageRating, count) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, NonF2fDoctorReviewInfo);
        this.averageRating = averageRating;
        this.count = count;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NonF2fDoctorReviewInfo, [
        {
            key: "reviewCountText",
            get: function get() {
                return "".concat((0,_entities_doctor__WEBPACK_IMPORTED_MODULE_0__/* .formatReviewCount */ .jV)(this.count));
            }
        },
        {
            key: "reviewAverageText",
            get: function get() {
                return "".concat(this.averageRating.toFixed(1));
            }
        },
        {
            key: "isReviewAverageRatingOverZero",
            get: function get() {
                return Number(this.averageRating) > 0;
            }
        }
    ]);
    return NonF2fDoctorReviewInfo;
}();
var NonF2fBookingSchedule = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fBookingSchedule(isBookable, schedule, scheduleType) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, NonF2fBookingSchedule);
        this.isBookable = isBookable;
        this.schedule = schedule;
        this.scheduleType = scheduleType;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NonF2fBookingSchedule, [
        {
            key: "isTodayBookable",
            get: function get() {
                return this.scheduleType === EBookingScheduleType.Today;
            }
        },
        {
            key: "scheduleTypeText",
            get: function get() {
                if (this.scheduleType === EBookingScheduleType.Today) {
                    return "오늘 예약";
                }
                return "내일 예약";
            }
        }
    ]);
    return NonF2fBookingSchedule;
}();
var NonF2fBookingInfo = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fBookingInfo(bookingAvailability, schedules) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, NonF2fBookingInfo);
        this.bookingAvailability = bookingAvailability;
        this.schedules = schedules;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NonF2fBookingInfo, [
        {
            key: "isBookingAvailable",
            get: function get() {
                return this.bookingAvailability !== EBookingAvailability.NotBookable;
            }
        },
        {
            key: "closestSchedule",
            get: function get() {
                return this.schedules.find(function(schedule) {
                    return schedule.isBookable;
                }) || null;
            }
        }
    ]);
    return NonF2fBookingInfo;
}();
var NonF2fDoctorMedicinePricing = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function NonF2fDoctorMedicinePricing(treatmentMedicineName, doctorTreatmentMedicineUnitPricingId, originalPrice, priceOnUsingPoint, unit) {
        _class_call_check(this, NonF2fDoctorMedicinePricing);
        this.treatmentMedicineName = treatmentMedicineName;
        this.doctorTreatmentMedicineUnitPricingId = doctorTreatmentMedicineUnitPricingId;
        this.originalPrice = originalPrice;
        this.priceOnUsingPoint = priceOnUsingPoint;
        this.unit = unit;
    }
    _create_class(NonF2fDoctorMedicinePricing, [
        {
            key: "medicinePriceDisplayPrice",
            get: function get() {
                return formatPriceComma(this.priceOnUsingPoint);
            }
        }
    ]);
    return NonF2fDoctorMedicinePricing;
}()));
var NonF2fDoctor = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fDoctor(hospitalName, doctorPublicId, doctorName, medicineType, _profileUrl, readyForVideoCall, professionalDepartmentName, review, bookingInfo, medicinePricing) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, NonF2fDoctor);
        this.hospitalName = hospitalName;
        this.doctorPublicId = doctorPublicId;
        this.doctorName = doctorName;
        this.medicineType = medicineType;
        this._profileUrl = _profileUrl;
        this.readyForVideoCall = readyForVideoCall;
        this.professionalDepartmentName = professionalDepartmentName;
        this.review = review;
        this.bookingInfo = bookingInfo;
        this.medicinePricing = medicinePricing;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NonF2fDoctor, [
        {
            key: "medicineTypeText",
            get: function get() {
                if (this.medicineType === "oriental_doctor") {
                    return "한의사";
                }
                return "의사";
            }
        },
        {
            key: "doctorNameFullText",
            get: function get() {
                return "".concat(this.doctorName, " ").concat(this.medicineTypeText);
            }
        },
        {
            key: "profileUrl",
            get: function get() {
                if (!this._profileUrl || this._profileUrl.includes("null")) {
                    return null;
                }
                return this._profileUrl;
            }
        }
    ]);
    return NonF2fDoctor;
}();


/***/ }),

/***/ 22987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MyApp; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/logger.mjs
var logger = __webpack_require__(30819);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/removable.mjs
var removable = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/query.mjs






// CLASS
class Query extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || logger/* defaultLogger */._;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = (0,utils/* replaceData */.oE)(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (!Array.isArray(this.options.queryKey)) {
      if (false) {}
    }

    const abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        var _this$cache$config$on, _this$cache$config;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);

        if (false) {}
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on2, _this$cache$config2;

        if (typeof data === 'undefined') {
          if (false) {}

          onError(new Error('undefined'));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, data, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
            return { ...this.revertState
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}


//# sourceMappingURL=query.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryCache.mjs





// CLASS
class QueryCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  find(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => (0,utils/* matchQuery */._x)(filters, query));
  }

  findAll(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => (0,utils/* matchQuery */._x)(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}


//# sourceMappingURL=queryCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var lib_mutation = __webpack_require__(89886);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationCache.mjs





// CLASS
class MutationCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new lib_mutation/* Mutation */.m({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    const pausedMutations = this.mutations.filter(x => x.state.isPaused);
    return notifyManager/* notifyManager.batch */.V.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(utils/* noop */.ZT)), Promise.resolve()));
  }

}


//# sourceMappingURL=mutationCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineManager = __webpack_require__(96474);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs









// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || logger/* defaultLogger */._;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];

    if (false) {}
  }

  mount() {
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  }

  isFetching(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = (0,utils/* functionalUpdate */.SE)(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  removeQueries(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  }

  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}


//# sourceMappingURL=queryClient.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/hydration.mjs
// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options = {}) {
  const mutations = [];
  const queries = [];

  if (options.dehydrateMutations !== false) {
    const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(mutation => {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (options.dehydrateQueries !== false) {
    const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(query => {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations,
    queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  const mutationCache = client.getMutationCache();
  const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const queries = dehydratedState.queries || [];
  mutations.forEach(dehydratedMutation => {
    var _options$defaultOptio;

    mutationCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations),
      mutationKey: dehydratedMutation.mutationKey
    }, dehydratedMutation.state);
  });
  queries.forEach(dehydratedQuery => {
    var _options$defaultOptio2;

    const query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries),
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }, dehydratedQuery.state);
  });
}


//# sourceMappingURL=hydration.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/Hydrate.mjs




function useHydrate(state, options = {}) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const optionsRef = react.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react.useMemo(() => {
    if (state) {
      hydrate(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
const Hydrate = ({
  children,
  options,
  state
}) => {
  useHydrate(state, options);
  return children;
};


//# sourceMappingURL=Hydrate.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs


const ReactQueryDevtools =  true ? function () {
  return null;
} : 0;
const ReactQueryDevtoolsPanel = (/* unused pure expression or super */ null && ( true ? function () {
  return null;
} : 0));


//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/ko.js
var ko = __webpack_require__(19132);
var ko_default = /*#__PURE__*/__webpack_require__.n(ko);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(56176);
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/app.js
var app = __webpack_require__(12041);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(62202);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ../../node_modules/recoil-nexus/build/RecoilNexus.js
var RecoilNexus = __webpack_require__(89430);
// EXTERNAL MODULE: ../../node_modules/sanitize.css/sanitize.css
var sanitize = __webpack_require__(57087);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ../../node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68522);
// EXTERNAL MODULE: ../../libs/ui/dist/style.css
var style = __webpack_require__(98612);
// EXTERNAL MODULE: ./src/components/atom/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(16309);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/common/NaverAnalyticsScript.tsx



var NaverAnalyticsScript = function(param) {
    var userAgent = param.userAgent;
    if ((0,RNPlugins/* isWebViewByUserAgent */.c0)(userAgent)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "//wcs.naver.net/wcslog.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "next-naver-analytics",
                dangerouslySetInnerHTML: {
                    __html: '\n          if(!wcs_add) var wcs_add = {};\n          wcs_add["wa"] = "1cb7f323096f1a0";\n          if(window.wcs) {\n              wcs_do();\n            }\n        '
                }
            })
        ]
    });
};
/* harmony default export */ var common_NaverAnalyticsScript = (NaverAnalyticsScript);

// EXTERNAL MODULE: ./src/components/common/RootErrorFallback.tsx
var RootErrorFallback = __webpack_require__(39192);
// EXTERNAL MODULE: ./src/recoil/atoms/common/modal.ts
var modal = __webpack_require__(11221);
// EXTERNAL MODULE: ./src/types/modal.ts
var types_modal = __webpack_require__(74701);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/molecules/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(48785);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
;// CONCATENATED MODULE: ./src/components/common/modal/alert-modal/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 296px;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 8px 16px 0 rgb(0 0 0 / 8%);\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n\n  ",
        ";\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  button + button {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  border-radius: 8px;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var AlertModal = function(param) {
    var title = param.title, message = param.message, body = param.body, buttons = param.buttons, onClickOverlay = param.onClickOverlay, centered = param.centered;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay/* default */.Z, {
        index: zIndex/* zIndex.MobileWebHeader */.W.MobileWebHeader,
        onClickOverlay: onClickOverlay,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertModalContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertModalContent, {
                    centered: centered,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModalTitle, {
                            children: title
                        }),
                        message && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModalMessage, {
                            centered: centered,
                            children: message
                        }),
                        body && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: body
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModalButtonWrapper, {
                    children: buttons.map(function(button, index) {
                        var type = button.type, label = button.label, labelColor = button.labelColor, onClick = button.onClick;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModalButton, {
                            $type: type || types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            labelColor: labelColor,
                            onClick: onClick,
                            children: label || "취소"
                        }, "alertModalButton-".concat(index));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var alert_modal = (AlertModal);
var AlertModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32c19ee4-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background-color: ".concat(theme.color.white, ";\n  ");
});
var AlertModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32c19ee4-1"
})(_templateObject1(), function(param) {
    var centered = param.centered;
    return centered && "\n    justify-content: center;\n    align-items: center;\n  ";
});
var AlertModalTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-32c19ee4-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray800, ";\n    ");
});
var AlertModalMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32c19ee4-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, ";\n    color: ").concat(theme.color.gray600, ";\n    ");
}, function(param) {
    var centered = param.centered;
    return centered && "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align:center;\n  ";
});
var AlertModalButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32c19ee4-4"
})(_templateObject4());
var DefaultModalButton = (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17SB, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.white, ";\n    border: 1px solid ").concat(theme.color.gray200, ";\n    \n    &:active {\n      background: ").concat(theme.color.gray100, ";\n    };\n  ");
});
var BoldModalButton = (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    color: ".concat(theme.color.white, ";\n    background: ").concat(theme.color.gray700, ";\n    \n    &:active {\n      background: ").concat(theme.color.gray800, ";\n    };\n  ");
});
var PrimaryModalButton = (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    color: ".concat(theme.color.white, ";\n    background: ").concat(theme.color.primary600, ";\n\n    &:active {\n      background: ").concat(theme.color.primary800, ";\n    };\n  ");
});
var DangerModalButton = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    color: ".concat(theme.color.white, ";\n    background: ").concat(theme.color.red500, ";\n\n    &:active {\n      background: ").concat(theme.color.red700, ";\n    };\n  ");
});
var AlertModalButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-32c19ee4-5"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17SB, ";\n    ");
}, function(param) {
    var $type = param.$type;
    switch($type){
        case types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT:
            return DefaultModalButton;
        case types_modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD:
            return BoldModalButton;
        case types_modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY:
            return PrimaryModalButton;
        case types_modal/* MODAL_BUTTON_TYPE.DANGER */.J.DANGER:
            return DangerModalButton;
    }
});

;// CONCATENATED MODULE: ./src/components/common/modal/basic-modal/index.tsx



var BasicModal = function(param) {
    var body = param.body, onClickOverlay = param.onClickOverlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay/* default */.Z, {
        index: 10,
        onClickOverlay: onClickOverlay,
        children: body
    });
};
/* harmony default export */ var basic_modal = (BasicModal);

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
;// CONCATENATED MODULE: ./src/components/common/modal/custom-background-color-modal/index.tsx




var CustomBackgroundColorModal = function(param) {
    var body = param.body, onClickOverlay = param.onClickOverlay, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(overlay/* default */.Z, {
        index: 10,
        onClickOverlay: onClickOverlay,
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "absolute top-8 right-8 text-white",
                type: "button",
                onClick: onClickOverlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "close",
                    color: "white",
                    size: 24
                })
            }),
            body
        ]
    });
};
/* harmony default export */ var custom_background_color_modal = (CustomBackgroundColorModal);

;// CONCATENATED MODULE: ./src/components/common/modal/index.tsx











var Modal = function() {
    var modals = (0,es.useRecoilValue)(modal/* modalState */.e);
    (0,react.useEffect)(function() {
        if (modals.length > 0) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return function() {
            document.body.style.overflow = "unset";
        };
    }, [
        modals
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: modals.map(function(param) {
            var index = param.index, type = param.type, props = param.props;
            switch(type){
                case types_modal/* MODAL_TYPE.ALERT */.f.ALERT:
                    return /*#__PURE__*/ (0,react.createElement)(alert_modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        index: index,
                        key: "alertModal-".concat(index)
                    }));
                case types_modal/* MODAL_TYPE.CUSTOM_BACKGROUND */.f.CUSTOM_BACKGROUND:
                    return /*#__PURE__*/ (0,react.createElement)(custom_background_color_modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        index: index,
                        key: "customBackgroundModal-".concat(index)
                    }));
                case types_modal/* MODAL_TYPE.BASIC */.f.BASIC:
                default:
                    return /*#__PURE__*/ (0,react.createElement)(basic_modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        index: index,
                        key: "customModal-".concat(index)
                    }));
            }
        })
    });
};
/* harmony default export */ var common_modal = (Modal);

// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/hooks/useIsMounted.tsx
var useIsMounted = __webpack_require__(27728);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
;// CONCATENATED MODULE: ./src/styles/globalStyle.ts

function globalStyle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n\n  :root {\n    --safe-area-inset-top: env(safe-area-inset-top);\n    --safe-area-inset-bottom: calc(env(safe-area-inset-bottom) * 0.5);\n  }\n\n  * {\n    font-family: "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;\n    scrollbar-width: none; /* Firefox */\n\n    /* &:hover {\n      transition: all 0.4s ease-out;\n    } */\n    &::-webkit-scrollbar {\n      display: none; /* Chrome, Safari, Opera*/\n    }\n  }\n  /* 앱에서 실행될때 아래 동작을 막기 위해 추가 */\n  * {\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* 버튼 클릭시 나오는 하이라이트 제거 */\n    -webkit-touch-callout: none; /* 링크를 오래 눌렀을때 액션 막기*/\n    -webkit-user-drag: none; /* 이미지, 글자 drag 막기*/\n    -webkit-overflow-scrolling: touch;\n  }\n\n  html {\n    font-size: 16px;\n    font-style: normal;\n    text-decoration: none;\n    text-transform: none;\n  }\n  \n    button, li, a {\n     &:hover {\n       cursor: pointer;\n     }\n     &:focus {\n      outline: none;\n    }\n  }\n\n  a {\n    text-decoration: none;\n    outline: none;\n    color: inherit;\n  }\n\n  input, textarea {\n    resize: none;\n    :focus {\n      outline: none;\n    }\n  }\n\n  &:not(input):not(textarea){\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  p, h1, h2, h3, h4,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video, pre {\n    margin: 0;\n    padding: 0;\n    border: 0;\n  }\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0;\n    border: none;\n    background-color: transparent;\n    font: inherit;\n    color: inherit;\n    cursor: pointer;\n  }\n  \n  ol, ul {\n    list-style: none;\n  }\n\n  nextjs-portal {\n    display: none;\n  }\n'
    ]);
    globalStyle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(globalStyle_templateObject());
/* harmony default export */ var globalStyle = (GlobalStyle);

// EXTERNAL MODULE: ./src/styles/globals.css
var globals = __webpack_require__(20533);
// EXTERNAL MODULE: ./src/styles/materialFont.css
var materialFont = __webpack_require__(56422);
;// CONCATENATED MODULE: ./src/shared/ui/content-mark-down/facebook-pixel/FacebookPixel.tsx

var FacebookPixel = function(param) {
    var pixelId = param.pixelId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
            __html: "!function(f,b,e,v,n,t,s)\n                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n                n.queue=[];t=b.createElement(e);t.async=!0;\n                t.src=v;s=b.getElementsByTagName(e)[0];\n                s.parentNode.insertBefore(t,s)}(window, document,'script',\n                'https://connect.facebook.net/en_US/fbevents.js');\n                fbq('init', '".concat(pixelId, "');\n                fbq('track', 'PageView');")
        }
    });
};
/* harmony default export */ var facebook_pixel_FacebookPixel = (FacebookPixel);

// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/hackle.ts
var hackle = __webpack_require__(59421);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/utils/report.ts + 289 modules
var report = __webpack_require__(80162);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ./src/recoil/atoms/common/toast.ts
var toast = __webpack_require__(15094);
;// CONCATENATED MODULE: ./src/components/atom/icon/ToastIcon.tsx


var ToastIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.712 4.00366C11.402 4.01746 11.1664 4.03786 10.8992 4.07402C9.80553 4.22207 8.72385 4.6134 7.77282 5.20511C6.68742 5.88042 5.75158 6.83904 5.10383 7.9391C4.96975 8.16681 4.7881 8.52047 4.68502 8.75454C4.31987 9.58364 4.10537 10.4179 4.02912 11.3055C4.00736 11.5587 4.0034 11.6656 4.00334 11.9999C4.00327 12.3802 4.01277 12.5688 4.04829 12.8927C4.17702 14.0664 4.5756 15.2151 5.20523 16.2271C5.70539 17.031 6.36308 17.7564 7.12642 18.3461C7.81721 18.8798 8.61874 19.3064 9.46242 19.5894C10.0635 19.791 10.6677 19.916 11.3056 19.9708C11.5609 19.9927 11.6653 19.9966 12 19.9966C12.3805 19.9966 12.5695 19.9871 12.8928 19.9516C14.0664 19.8229 15.2153 19.4243 16.2272 18.7947C16.6163 18.5526 16.9778 18.2806 17.3504 17.9494C17.4621 17.8501 17.8502 17.4619 17.9495 17.3503C18.4615 16.7742 18.8403 16.216 19.168 15.5551C19.6134 14.6564 19.8774 13.7242 19.9682 12.7301C19.9798 12.6025 19.9936 12.3765 19.9936 12.3123C19.9936 12.2779 19.9965 12.2485 20 12.2463C20.0041 12.2438 20.0064 12.1534 20.0064 11.9963C20.0064 11.8366 20.0042 11.7503 20 11.7503C19.9962 11.7503 19.9936 11.7252 19.9936 11.6879C19.9936 11.583 19.9738 11.309 19.9517 11.1071C19.8235 9.93502 19.4243 8.78451 18.7948 7.7727C18.5051 7.30711 18.1701 6.8765 17.7865 6.4767C17.1181 5.78016 16.3994 5.25039 15.5552 4.83196C14.59 4.35354 13.6183 4.09223 12.5188 4.01538C12.3909 4.00645 11.8319 3.99832 11.712 4.00366ZM11.872 5.40599C10.5128 5.42618 9.16221 5.88736 8.06402 6.70629C7.5581 7.08356 7.08449 7.55715 6.70637 8.0639C6.2857 8.62765 5.95734 9.26075 5.73211 9.9423C5.55222 10.4867 5.44978 11.0331 5.41414 11.6383C5.40493 11.7949 5.40493 12.2049 5.41414 12.3615C5.45087 12.9851 5.55821 13.5445 5.7494 14.1087C6.13645 15.2508 6.80743 16.2385 7.73442 17.0307C8.75761 17.9051 10.0669 18.4534 11.408 18.5692C11.7864 18.6019 12.2136 18.6019 12.592 18.5692C13.9333 18.4534 15.2413 17.9056 16.2656 17.0307C16.5331 16.8022 16.8023 16.533 17.0308 16.2655C17.8517 15.3044 18.3852 14.0943 18.5433 12.8351C18.6005 12.3798 18.6094 11.886 18.5691 11.4079C18.4623 10.141 17.9559 8.87986 17.1539 7.88332C16.8907 7.55628 16.587 7.24375 16.2656 6.96911C15.3046 6.14789 14.0901 5.61279 12.832 5.45631C12.5279 5.41848 12.1974 5.40116 11.872 5.40599ZM15.2352 7.94225C15.1375 7.96207 15.0445 8.00044 14.9664 8.0532C14.9113 8.09041 14.8245 8.18031 14.7861 8.2399C14.7679 8.26806 13.9691 9.63462 13.0109 11.2767C12.0528 12.9188 11.2626 14.273 11.2549 14.286L11.241 14.3097L10.1415 13.4302C9.53673 12.9464 9.01848 12.5361 8.98978 12.5184C8.92487 12.4782 8.85334 12.4501 8.77442 12.4337C8.68703 12.4156 8.54175 12.4201 8.45217 12.4437C8.19653 12.511 8.00649 12.7102 7.94135 12.9791C7.93595 13.0013 7.93289 13.0532 7.933 13.1199C7.9332 13.2302 7.94283 13.2891 7.97454 13.3743C8.00454 13.4549 8.05965 13.5414 8.12255 13.6066C8.16806 13.6538 10.542 15.5523 10.6089 15.595C10.8828 15.7699 11.2175 15.8291 11.5429 15.7602C11.8558 15.694 12.1368 15.5065 12.3188 15.2425C12.355 15.19 15.9562 9.02219 15.9969 8.94304C16.053 8.83392 16.0738 8.73681 16.0687 8.60837C16.0553 8.2736 15.8299 8.00943 15.4976 7.93919C15.4354 7.92604 15.3079 7.92753 15.2352 7.94225ZM4.00293 12.0031C4.00293 12.1404 4.00377 12.1956 4.00481 12.1259C4.00585 12.0561 4.00584 11.9438 4.0048 11.8763C4.00377 11.8087 4.00292 11.8658 4.00293 12.0031Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var icon_ToastIcon = (ToastIcon);

// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
;// CONCATENATED MODULE: ./src/components/common/toast/ToastItem.tsx

function ToastItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateY(-100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    ToastItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ToastItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(calc((-100% - 32px) * ",
        "));\n  }\n"
    ]);
    ToastItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ToastItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 24px 48px;\n  border-radius: 12px;\n  background-color: ",
        ";\n  text-align: left;\n  color: ",
        ";\n  animation: ",
        " 0.4s ease-in-out forwards;\n  white-space: pre-wrap;\n\n  svg {\n    margin-right: 8px;\n  }\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n    padding: 16px 24px;\n    white-space: nowrap;\n  }\n"
    ]);
    ToastItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var ToastItem = function(param) {
    var toast = param.toast, index = param.index;
    var ref = (0,react.useState)(false), unmount = ref[0], setUnmount = ref[1];
    var animationEnd = function() {
        var _visibleTime;
        setTimeout(function() {
            setUnmount(true);
        }, (_visibleTime = toast.props.visibleTime) !== null && _visibleTime !== void 0 ? _visibleTime : 2000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToastItemWrapper, {
        index: index + 1,
        unmount: unmount,
        onAnimationEnd: animationEnd,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_ToastIcon, {}),
            " ",
            toast.props.message
        ]
    }, "toast-".concat(toast.id));
};
/* harmony default export */ var toast_ToastItem = (ToastItem);
var TopDown = (0,styled_components_browser_esm/* keyframes */.F4)(ToastItem_templateObject());
var BottomUp = function(index) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(ToastItem_templateObject1(), index + 1);
};
var ToastItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a602f27-0"
})(ToastItem_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.black;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var unmount = param.unmount, index = param.index;
    return unmount ? BottomUp(index) : TopDown;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14SB;
});

;// CONCATENATED MODULE: ./src/components/common/toast/ToastMobileItem.tsx

function ToastMobileItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    ToastMobileItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ToastMobileItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(calc((100% + 32px) * ",
        "));\n  }\n"
    ]);
    ToastMobileItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ToastMobileItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  width: 100%;\n  padding: 14px 16px;\n  margin-top: 16px;\n  border-radius: 8px;\n  text-align: left;\n  animation: ",
        "\n    0.4s ease-in-out forwards;\n  white-space: pre-wrap;\n"
    ]);
    ToastMobileItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ToastMobileItem = function(param) {
    var toast = param.toast, index = param.index;
    var ref = (0,react.useState)(false), unmount = ref[0], setUnmount = ref[1];
    var animationEnd = function() {
        var _visibleTime;
        setTimeout(function() {
            setUnmount(true);
        }, (_visibleTime = toast.props.visibleTime) !== null && _visibleTime !== void 0 ? _visibleTime : 2000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastMobileItem_ToastItemWrapper, {
        index: index + 1,
        unmount: unmount,
        onAnimationEnd: animationEnd,
        children: toast.props.message
    }, "toast-".concat(toast.id));
};
/* harmony default export */ var toast_ToastMobileItem = (ToastMobileItem);
var ToastMobileItem_BottomUp = (0,styled_components_browser_esm/* keyframes */.F4)(ToastMobileItem_templateObject());
var ToastMobileItem_TopDown = function(index) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(ToastMobileItem_templateObject1(), index + 1);
};
var ToastMobileItem_ToastItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91dac987-0"
})(ToastMobileItem_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.gray800, ";\n    ");
}, function(param) {
    var unmount = param.unmount, index = param.index;
    return unmount ? ToastMobileItem_TopDown(index) : ToastMobileItem_BottomUp;
});

;// CONCATENATED MODULE: ./src/components/common/toast/index.tsx

function toast_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 32px;\n  width: fit-content;\n"
    ]);
    toast_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function toast_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: fixed;\n  bottom: 32px;\n  width: calc(100% - 32px);\n  margin: 0 16px;\n"
    ]);
    toast_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Toast = function(param) {
    var userAgent = param.userAgent;
    var toasts = (0,es.useRecoilValue)(toast/* toastState */.J);
    var isMobileView = (0,RNPlugins/* isMobile */.tq)(userAgent);
    if (!isMobileView) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: toasts.map(function(toast, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(toast_ToastItem, {
                    toast: toast,
                    index: index
                }, "toast-".concat(toast.id));
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileWrapper, {
        children: toasts.map(function(toast, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(toast_ToastMobileItem, {
                toast: toast,
                index: index
            }, "toast-".concat(toast.id));
        })
    });
};
/* harmony default export */ var common_toast = (Toast);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24dcf4a6-0"
})(toast_templateObject(), zIndex/* zIndex.Toast */.W.Toast);
var MobileWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-24dcf4a6-1"
})(toast_templateObject1(), zIndex/* zIndex.Toast */.W.Toast);

// EXTERNAL MODULE: ./src/shared/utils/client-detector.ts
var client_detector = __webpack_require__(80206);
// EXTERNAL MODULE: ./src/shared/utils/detect.ts
var detect = __webpack_require__(85386);
;// CONCATENATED MODULE: ./next-seo.config.js
/* harmony default export */ var next_seo_config = ({
    title: "닥터나우 - 비대면 진료 앱 1위 | 탈모\xb7여드름\xb7감기몸살\xb7소아과 처방까지",
    description: "비대면 진료 1위 어플 닥터나우로 언제든 원격진료 가능! 탈모약, 여드름약, 다이어트 주사(위고비, 삭센다 등)의 최저가 약국 찾기부터 일요일 진료 가능한 소아과, 산부인과와 약 처방∙배송 서비스까지 이용해 보세요.",
    additionalMetaTags: [
        {
            name: "publisher",
            content: "닥터나우"
        },
        {
            name: "author",
            content: "닥터나우"
        },
        {
            name: "copyright",
            content: "닥터나우"
        },
        {
            name: "creator",
            content: "닥터나우"
        },
        {
            name: "keywords",
            content: "비대면진료, 비대면진료앱, 비대면진료어플, 원격진료, 약배달, 약배송, 약배달어플, 약배달앱, 약배송어플, 약배송앱, 탈모약, 여드름약, 감기약, 소아과, 위고비, 이소티논, 비대면처방"
        }, 
    ],
    openGraph: {
        type: "website",
        locale: "ko_KR",
        url: "https://doctornow.co.kr/",
        title: "닥터나우 - 비대면 진료 앱 1위 | 탈모\xb7여드름\xb7감기몸살\xb7소아과 처방까지",
        site_name: "doctornow",
        description: "비대면 진료 1위 어플 닥터나우로 언제든 원격진료 가능! 탈모약, 여드름약, 다이어트 주사(위고비, 삭센다 등)의 최저가 약국 찾기부터 일요일 진료 가능한 소아과, 산부인과와 약 처방∙배송 서비스까지 이용해 보세요.",
        images: [
            {
                url: "https://media.doctornow.co.kr/og-main.png",
                width: 600,
                height: 315,
                alt: "닥터나우"
            }, 
        ]
    },
    twitter: {
        handle: "@doctornow",
        site: "@doctornow.co.kr",
        cardType: "summary_large_image"
    }
});

;// CONCATENATED MODULE: ./src/pages/_app.tsx

















































dayjs_min_default().extend((localizedFormat_default()));
dayjs_min_default().extend((customParseFormat_default()));
dayjs_min_default().locale((ko_default()));
var isWebBrowserClient = function(client) {
    return !client.isWebView && !common/* isServer */.sk;
};
var QUERY_STALE_TIME = 2000;
function MyApp(_param) {
    var Component = _param.Component, dehydratedState = _param.pageProps.dehydratedState, pageProps = (0,_object_without_properties/* default */.Z)(_param.pageProps, [
        "dehydratedState"
    ]);
    var route = (0,router.useRouter)();
    var isMounted = (0,useIsMounted/* default */.Z)();
    var ref = (0,react.useState)(), prevPageName = ref[0], setPrevPageName = ref[1];
    var isAirbridgeLink = route.query["airbridge_referrer"];
    var userAgent = pageProps.userAgent, client = pageProps.client;
    var logger = (0,useLogger/* default */.Z)();
    if (isWebBrowserClient(client)) {
        if (detect/* HeadlessDetector.shouldInitializeSDK */.G.shouldInitializeSDK(window)) {
            pixel/* default.setup */.Z.setup(client);
            firebase/* default.initApp */.Z.initApp(userAgent, client);
        }
    }
    var initializeRecoilState = function() {
        dayjs_min_default().extend((isBetween_default()));
    };
    var queryClient = (0,react.useRef)(new QueryClient({
        defaultOptions: {
            queries: {
                retry: 0,
                refetchOnWindowFocus: false,
                useErrorBoundary: false,
                refetchOnReconnect: false,
                staleTime: QUERY_STALE_TIME
            },
            mutations: {
                retry: 0
            }
        }
    })).current;
    var _Layout;
    var Layout = (_Layout = Component.Layout) !== null && _Layout !== void 0 ? _Layout : DefaultLayout/* default */.Z;
    (0,react.useEffect)(function() {
        if (isMounted) {
            var currentPageName = (0,url/* getUrlPathWithoutQueryString */.hA)(route.asPath);
            if (prevPageName !== currentPageName) {
                setPrevPageName(currentPageName);
                logger.pageView(userAgent);
            }
        }
    }, [
        isMounted,
        route,
        prevPageName,
        logger
    ]);
    (0,react.useEffect)(function() {
        (0,report/* initDatadogMonitoring */.n9)();
        hackle/* default.createHackle */.Z.createHackle();
        if (env/* IS_LOCAL */.Kc) console.log("init", pageProps);
    }, [
        client.clientType
    ]);
    (0,react.useEffect)(function() {
        if (isAirbridgeLink) {
            sessionStorage.setItem("airbridgeLink", JSON.stringify((0,_object_spread/* default */.Z)({}, route.query)));
        }
    }, [
        isAirbridgeLink,
        route
    ]);
    var _NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config), {
                canonical: "".concat("https://doctornow.co.kr").concat(route.asPath)
            })),
            !client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_pixel_FacebookPixel, {
                pixelId: (_NEXT_PUBLIC_FACEBOOK_PIXEL_ID = "122280647492122") !== null && _NEXT_PUBLIC_FACEBOOK_PIXEL_ID !== void 0 ? _NEXT_PUBLIC_FACEBOOK_PIXEL_ID : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryClientProvider/* QueryClientProvider */.aH, {
                client: queryClient,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hydrate, {
                        state: dehydratedState,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es.RecoilRoot, {
                            initializeState: initializeRecoilState,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecoilNexus/* default */.ZP, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                                    theme: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme/* default */.Z), {
                                        client: client
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ToastContainer */.Ix, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBoundary/* default */.Z, {
                                            renderFallback: RootErrorFallback/* default */.Z,
                                            onReset: function() {
                                                return route.replace(common/* ROUTES.BOARD.HOME.path */.Z6.BOARD.HOME.path);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(globalStyle, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_toast, {
                                                    userAgent: userAgent
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NaverAnalyticsScript, {
                                                    userAgent: userAgent
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                    userAgent: userAgent,
                                                    client: client,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactQueryDevtools, {
                        initialIsOpen: false
                    })
                ]
            })
        ]
    });
}
MyApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(appContext) {
        var ref, ref1, appProps, ref2, userAgent;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        app["default"].getInitialProps(appContext)
                    ];
                case 1:
                    appProps = _state.sent();
                    return [
                        4,
                        appContext.ctx.req
                    ];
                case 2:
                    userAgent = _state.sent() ? (ref2 = (ref = appContext.ctx.req) === null || ref === void 0 ? void 0 : ref.headers["x-user-agent"]) !== null && ref2 !== void 0 ? ref2 : (ref1 = appContext.ctx.req) === null || ref1 === void 0 ? void 0 : ref1.headers["user-agent"] : navigator.userAgent;
                    appProps.pageProps.userAgent = userAgent;
                    appProps.pageProps.client = (0,client_detector/* getClientInfo */.nQ)(userAgent);
                    return [
                        2,
                        (0,_object_spread/* default */.Z)({}, appProps)
                    ];
            }
        });
    });
    return function(appContext) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 61169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ parseContactTypeOf; },
/* harmony export */   "Kv": function() { return /* binding */ parseFamilyRelationOf; },
/* harmony export */   "LY": function() { return /* binding */ parseRumClientType; },
/* harmony export */   "Zl": function() { return /* binding */ convertToCurrencyCommaString; },
/* harmony export */   "dl": function() { return /* binding */ parseMedicalCategoryTypeOf; },
/* harmony export */   "hk": function() { return /* binding */ parseDeprecatedMedicalCategoryCategoryTypeOf; },
/* harmony export */   "x3": function() { return /* binding */ parseMedicalCategoryCategoryTypeOf; },
/* harmony export */   "yB": function() { return /* binding */ parseDiagnosisFormTypeOf; }
/* harmony export */ });
/* harmony import */ var _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7551);
/* harmony import */ var _models_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18044);
/* harmony import */ var _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39591);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20138);





var parseRumClientType = function(client) {
    if (!client.isMobile) {
        return client.clientType;
    }
    if (client.isIOS) {
        return "".concat(client.clientType, "-iOS");
    }
    return "".concat(client.clientType, "-Android");
};
var parseDiagnosisFormTypeOf = function(diagnosisFormType) {
    switch(diagnosisFormType){
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDiagnosisFormType.General */ .fL.General:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.General */ .qRY.General;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDiagnosisFormType.InHospitalDelivery */ .fL.InHospitalDelivery:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.InHospitalDelivery */ .qRY.InHospitalDelivery;
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.General */ .qRY.General;
    }
};
var parseMedicalCategoryTypeOf = function(type) {
    switch(type){
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Department */ .P2.Department:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Treatment */ .P2.Treatment:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Treatment */ .WkB.Treatment;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Vaccination */ .P2.Vaccination:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Vaccination */ .WkB.Vaccination;
    }
};
var parseMedicalCategoryCategoryTypeOf = function(type) {
    switch(type){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Treatment */ .WkB.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Vaccination */ .WkB.Vaccination;
    }
};
var parseDeprecatedMedicalCategoryCategoryTypeOf = function(type) {
    switch(type){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Department */ .P2.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Treatment */ .P2.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Vaccination */ .P2.Vaccination;
    }
};
var parseFamilyRelationOf = function(relation) {
    switch(relation){
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Children */ .h6.Children:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Children */ .dDP.Children;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Parents */ .h6.Parents:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Parents */ .dDP.Parents;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Me */ .h6.Me:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Me */ .dDP.Me;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Spouse */ .h6.Spouse:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Spouse */ .dDP.Spouse;
    }
};
var parseContactTypeOf = function(contactType) {
    switch(contactType){
        case _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__/* .EDiagnosisContactType.F2F */ .d.F2F:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisContactType.F2F */ .qnl.F2F;
        case _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__/* .EDiagnosisContactType.NonF2F */ .d.NonF2F:
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisContactType.NonF2F */ .qnl.NonF2F;
    }
};
var convertToCurrencyCommaString = function(amount) {
    return amount.toLocaleString("en");
};


/***/ }),

/***/ 4415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J1": function() { return /* binding */ tokenState; },
/* harmony export */   "bW": function() { return /* binding */ getAuthToken; },
/* harmony export */   "pp": function() { return /* binding */ UrlState; },
/* harmony export */   "uB": function() { return /* binding */ setAuthToken; },
/* harmony export */   "z9": function() { return /* binding */ clearReturnUrl; }
/* harmony export */ });
/* unused harmony exports getReturnUrl, setReturnUrl */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80888);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10712);




var tokenState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "tokenState",
    default: null,
    effects: [
        (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_2__/* .isWebView */ .vp)() ? (0,_utils_atom__WEBPACK_IMPORTED_MODULE_3__/* .sessionStorageEffect */ .j)("token") : (0,_utils_atom__WEBPACK_IMPORTED_MODULE_3__/* .localStorageEffect */ .N)("token")
    ]
});
var UrlState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "returnUrl",
    default: "",
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_3__/* .sessionStorageEffect */ .j)("url")
    ]
});
var getAuthToken = function() {
    return (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(tokenState);
};
var setAuthToken = function() {
    var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(tokenState, token);
};
var getReturnUrl = function() {
    return getRecoil(UrlState);
};
var setReturnUrl = function(url) {
    setRecoil(UrlState, url);
};
var clearReturnUrl = function() {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(UrlState, "");
};


/***/ }),

/***/ 11221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ modalState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);

var modalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "modalState",
    default: []
});


/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ toastState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);

var toastState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "toastState",
    default: []
});


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ hooks_useAirbridgeDynamicLink; }
});

// UNUSED EXPORTS: useDebounceWithLoading

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/shared/hooks/useAirbridgeDynamicLink.ts










var AIRBRIDGE_PARAM_PREFIX = "ab_";
var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var formatOptionsForLogging = function(options) {
    return Object.fromEntries(Object.entries(options).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            "".concat(AIRBRIDGE_PARAM_PREFIX).concat(key),
            typeof value === "number" ? value.toString() : value, 
        ];
    }));
};
var useAirbridgeDynamicLink = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "web_organic", initOptions = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var getDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getDynamicLink */.Z.getDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, initOptions, options), linkType);
    };
    var getTrackingParams = function() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getTrackingParams */.Z.getTrackingParams(linkType);
    };
    var createTrackingLinkAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(channel, options) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    airbridge/* default.createTrackingLinkAsync */.Z.createTrackingLinkAsync(channel, options)
                ];
            });
        });
        return function createTrackingLinkAsync(channel, options) {
            return _ref.apply(this, arguments);
        };
    }();
    var logToFirebase = function(eventName, options) {
        var pageName = (0,logger/* getPageName */.j0)(router);
        var sanitizedEventName = sanitizeEventName(eventName);
        var formattedOptions = formatOptionsForLogging((0,_object_spread/* default */.Z)({}, initOptions, options));
        var payload = (0,_object_spread/* default */.Z)({
            page_name: pageName
        }, formattedOptions);
        if (env/* IS_LOCAL */.Kc) {
            console.log("logger >>", (0,_object_spread/* default */.Z)({
                eventName: sanitizedEventName
            }, payload));
            return;
        }
        firebase/* default.logEventOnlyFirebase */.Z.logEventOnlyFirebase(sanitizedEventName, payload);
    };
    var navigateWithTracking = function(eventName, options) {
        var linkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        var customOptions = (0,_object_spread/* default */.Z)({}, initOptions, options);
        logToFirebase(eventName, customOptions);
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, customOptions), linkType);
    };
    return {
        navigateWithTracking: navigateWithTracking,
        getDynamicLink: getDynamicLink,
        getTrackingParams: getTrackingParams,
        logToFirebase: logToFirebase,
        createTrackingLinkAsync: createTrackingLinkAsync
    };
};
/* harmony default export */ var hooks_useAirbridgeDynamicLink = (useAirbridgeDynamicLink);

// EXTERNAL MODULE: ./src/shared/hooks/useDebounceWithLoading.ts
var useDebounceWithLoading = __webpack_require__(78974);
;// CONCATENATED MODULE: ./src/shared/hooks/index.ts





/***/ }),

/***/ 78974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useDebounceWithLoading = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), debounced = ref[0], setDebounced = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(previousValue.current, value)) {
            setIsLoading(true);
            previousValue.current = value;
        }
        var handler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            setDebounced(value);
            setIsLoading(false);
        }, delay, options);
        handler();
        return function() {
            handler.cancel();
        };
    }, [
        value,
        delay,
        options
    ]);
    return {
        debouncedValue: debounced,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounceWithLoading);


/***/ }),

/***/ 9628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ EAirbridgeLinkType; }
});

;// CONCATENATED MODULE: ./src/shared/types/airbridge.ts
var DynamicLinkPosition;
(function(DynamicLinkPosition) {
    DynamicLinkPosition["Drawer"] = "drawer";
    DynamicLinkPosition["Gnb"] = "gnb";
    DynamicLinkPosition["Lnb"] = "lnb";
    DynamicLinkPosition["Footer"] = "footer";
    DynamicLinkPosition["Content"] = "content";
})(DynamicLinkPosition || (DynamicLinkPosition = {}));
var DynamicLinkContentFeature;
(function(DynamicLinkContentFeature) {
    DynamicLinkContentFeature["Button"] = "btn";
    DynamicLinkContentFeature["Modal"] = "mdl";
    DynamicLinkContentFeature["Floating"] = "flt";
    DynamicLinkContentFeature["Banner"] = "bnr";
    DynamicLinkContentFeature["Snippet"] = "snippet";
})(DynamicLinkContentFeature || (DynamicLinkContentFeature = {}));
var DynamicLinkContentPage;
(function(DynamicLinkContentPage) {
    DynamicLinkContentPage["All"] = "all";
    DynamicLinkContentPage["Main"] = "main";
    DynamicLinkContentPage["Service"] = "service";
    DynamicLinkContentPage["List"] = "list";
    DynamicLinkContentPage["Detail"] = "details";
})(DynamicLinkContentPage || (DynamicLinkContentPage = {}));
var EAirbridgeLinkType;
(function(EAirbridgeLinkType) {
    EAirbridgeLinkType[/** 일반 앱 다운로드 링크 (기본값) */ "GENERAL"] = "GENERAL";
    EAirbridgeLinkType[/** 앱스토어 페이지 직접 이동 링크 */ "STORE_PAGE"] = "STORE_PAGE";
    EAirbridgeLinkType[/** 탈모 카테고리 전용 링크 */ "HAIRLOSS"] = "HAIRLOSS";
    EAirbridgeLinkType[/** 여드름 카테고리 전용 링크 */ "ACNE"] = "ACNE";
    EAirbridgeLinkType[/** 다이어트 카테고리 전용 링크 */ "DIET"] = "DIET";
})(EAirbridgeLinkType || (EAirbridgeLinkType = {}));

;// CONCATENATED MODULE: ./src/shared/types/index.ts




/***/ }),

/***/ 80206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nQ": function() { return /* binding */ getClientInfo; }
/* harmony export */ });
/* unused harmony export detectClient */
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9912);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);
/* harmony import */ var _detect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85386);



/**
 * 클라이언트 정보를 감지하는 유틸리티 함수
 * user-web과 RNPlugins에서 공통으로 사용할 수 있도록 추출
 *
 * @param userAgent - 브라우저 User Agent 문자열
 * @returns Client 객체 (플랫폼 정보 포함)
 */ var getClientInfo = function(userAgent) {
    var defaultClient = {
        clientType: _types_app__WEBPACK_IMPORTED_MODULE_0__/* .ClientType.WEB */ .B.WEB,
        isWebView: false,
        isMobile: false,
        isIOS: false,
        isAndroid: false,
        isHeadlessBot: false
    };
    if (typeof userAgent !== "string") {
        return defaultClient;
    }
    if (_detect__WEBPACK_IMPORTED_MODULE_2__/* .HeadlessDetector.isHeadlessUser */ .G.isHeadlessUser(userAgent)) {
        return {
            clientType: _types_app__WEBPACK_IMPORTED_MODULE_0__/* .ClientType.WEB */ .B.WEB,
            isWebView: false,
            isMobile: false,
            isAndroid: false,
            isIOS: false,
            isHeadlessBot: true
        };
    }
    if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebViewByUserAgent */ .c0)(userAgent)) {
        // 웹뷰
        return {
            clientType: _types_app__WEBPACK_IMPORTED_MODULE_0__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW,
            isWebView: true,
            isMobile: true,
            isIOS: !(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isAndroidByUserAgent */ .Ey)(userAgent),
            isAndroid: (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isAndroidByUserAgent */ .Ey)(userAgent),
            isHeadlessBot: false
        };
    }
    if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq)(userAgent)) {
        // 모바일 웹
        return {
            clientType: _types_app__WEBPACK_IMPORTED_MODULE_0__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB,
            isWebView: false,
            isMobile: true,
            isIOS: !(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isAndroidByUserAgent */ .Ey)(userAgent),
            isAndroid: (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isAndroidByUserAgent */ .Ey)(userAgent),
            isHeadlessBot: false
        };
    }
    // 웹
    return {
        clientType: _types_app__WEBPACK_IMPORTED_MODULE_0__/* .ClientType.WEB */ .B.WEB,
        isWebView: false,
        isMobile: false,
        isIOS: false,
        isAndroid: false,
        isHeadlessBot: false
    };
};
/**
 * Legacy alias for backward compatibility
 * @deprecated Use getClientInfo instead
 */ var detectClient = (/* unused pure expression or super */ null && (getClientInfo));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getClientInfo)));


/***/ }),

/***/ 85386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ HeadlessDetector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _utils_report__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80162);


var HeadlessDetector = /*#__PURE__*/ function() {
    "use strict";
    function HeadlessDetector() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, HeadlessDetector);
    }
    HeadlessDetector.isHeadlessUser = function isHeadlessUser(userAgent) {
        return /headless|phantomjs|bot|crawl/.test(userAgent);
    };
    HeadlessDetector.isHeadlessUserAgent = function isHeadlessUserAgent(navigator) {
        var userAgent = navigator.userAgent.toLowerCase();
        return /headless|phantomjs|bot|crawl/.test(userAgent);
    };
    HeadlessDetector.isWebdriverPresent = function isWebdriverPresent(navigator) {
        return !!navigator.webdriver;
    };
    HeadlessDetector.hasInvalidLanguages = function hasInvalidLanguages(navigator) {
        var language = navigator.language;
        var languagesLength = navigator.languages.length;
        return !language || languagesLength === 0;
    };
    /* 창 크기 0이면 헤드리스로 판단해도 되는지 여부를 로깅 후 추가할 계획 */ HeadlessDetector.hasZeroDimensions = function hasZeroDimensions(window) {
        var outerWidth = window.outerWidth;
        var outerHeight = window.outerHeight;
        var innerWidth = window.innerWidth;
        var innerHeight = window.innerHeight;
        return outerWidth === 0 && outerHeight === 0 && innerWidth === 0 && innerHeight === 0;
    };
    HeadlessDetector.shouldInitializeSDK = function shouldInitializeSDK(window) {
        if (!window.navigator) {
            return false;
        }
        if (this.hasZeroDimensions(window) && !this.isLogged) {
            this.isLogged = true;
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_0__/* .infoReport */ .pP)("HeadlessDetector에서 창 크기 0 감지 > 헤드리스가 아닌지 확인 필요", {
                userAgent: window.navigator.userAgent
            });
        }
        if (this.isHeadlessUserAgent(window.navigator)) {
            return false;
        }
        if (this.isWebdriverPresent(window.navigator)) {
            return false;
        }
        if (this.hasInvalidLanguages(window.navigator)) {
            return false;
        }
        return true;
    };
    return HeadlessDetector;
}();
HeadlessDetector.isLogged = false;


/***/ }),

/***/ 64952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ Tablet; },
/* harmony export */   "qF": function() { return /* binding */ Fold; },
/* harmony export */   "tS": function() { return /* binding */ DeskTop; }
/* harmony export */ });
/* unused harmony exports MagazineTablet, PCContentArea */
var DeskTop = "1024px";
var Tablet = "768px";
var MagazineTablet = "1180px";
var Fold = "280px";
var PCContentArea = "1090px";


/***/ }),

/***/ 44376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_opacity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52172);

/**
 * string이 아닌 number로 사용되어야 할듯..
 */ var size = {
    mainContentsArea: "768px",
    tablet: "768px",
    appHeader: {
        height: "60px"
    },
    footerButton: {
        height: "60px"
    },
    stickyButton: {
        height: 108
    },
    mobileWebHeader: {
        height: 60
    },
    headerSearchBar: {
        height: 60
    },
    realtimeAnswerStatusBar: {
        height: 57
    },
    searchFilter: {
        height: 60
    }
};
var color = {
    primary100: "#FFF4E6",
    primary200: "#FFE8CC",
    primary300: "#FFD8A8",
    primary400: "#FFC078",
    primary500: "#FF8D00",
    primary600: "#FD7E14",
    primary700: "#F76707",
    primary800: "#E8590C",
    primary900: "#D9480F",
    blue100: "#E7F5FF",
    blue200: "#D0EBFF",
    blue300: "#A5D8FF",
    blue400: "#74C0FC",
    blue500: "#339AF0",
    blue600: "#228BE6",
    blue700: "#1C7ED6",
    blue800: "#1971C2",
    blue900: "#1864AB",
    green100: "#EBFBEE",
    green200: "#D3F9D8",
    green300: "#B2F2BB",
    green400: "#8CE99A",
    green500: "#51CF66",
    green600: "#40C057",
    green700: "#37B24D",
    green800: "#2F9E44",
    green900: "#2B8A3E",
    yellow100: "#FFF9DB",
    yellow200: "#FFF3BF",
    yellow300: "#FFEC99",
    yellow400: "#FFE066",
    yellow500: "#FCC419",
    yellow600: "#FAB005",
    yellow700: "#F59F00",
    yellow800: "#F08C00",
    yellow900: "#E67700",
    red100: "#FFF5F5",
    red200: "#FFE3E3",
    red300: "#FFC9C9",
    red400: "#FFA8A8",
    red500: "#FF6B6B",
    red600: "#FA5252",
    red700: "#F03E3E",
    red800: "#E03131",
    red900: "#C92A2A",
    gray10: "#FBFCFD",
    gray20: "#F7F9FA",
    gray30: "#F5F6F7",
    gray40: "#F1F3F6",
    gray50: "#EDEFF0",
    gray100: "#DFE1E2",
    gray200: "#C6CACE",
    gray300: "#A9AEB1",
    gray400: "#8D9297",
    gray500: "#71767A",
    gray600: "#565C65",
    gray700: "#3D4551",
    gray800: "#2D2E2F",
    gray900: "#1C1D1F",
    white: "#FFFFFF",
    black: "#000000",
    dimmed20: (0,_utils_opacity__WEBPACK_IMPORTED_MODULE_0__/* .withOpacity */ .C)("#000000", 0.2),
    dimmed40: (0,_utils_opacity__WEBPACK_IMPORTED_MODULE_0__/* .withOpacity */ .C)("#000000", 0.4),
    dimmed80: (0,_utils_opacity__WEBPACK_IMPORTED_MODULE_0__/* .withOpacity */ .C)("#000000", 0.8)
};
var defaultTypography = '\n  font-family: "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;\n  font-style: normal;\n  text-decoration: none;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n';
var typography = {
    UI64B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 64px;\n      line-height: 96px;\n  "),
    UI56B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 56px;\n      line-height: 68px;\n  "),
    // UI Text (B/SB/M/R)
    UI48B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 48px;\n      line-height: 60px;\n    "),
    UI48SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 48px;\n      line-height: 60px;\n    "),
    UI40B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 40px;\n      line-height: 52px;\n    "),
    UI40SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 40px;\n      line-height: 52px;\n    "),
    UI36B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 36px;\n      line-height: 48px;\n    "),
    UI36SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 36px;\n      line-height: 48px;\n    "),
    UI32B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 32px;\n      line-height: 42px;\n    "),
    UI32SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 32px;\n      line-height: 42px;\n    "),
    UI28B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 38px;\n    "),
    UI28SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 28px;\n      line-height: 38px;\n    "),
    UI26B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 26px;\n      line-height: 36px;\n    "),
    UI26SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 26px;\n      line-height: 36px;\n    "),
    UI24B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 32px;\n    "),
    UI24SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 32px;\n    "),
    UI24M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 24px;\n      line-height: 32px;\n    "),
    UI22B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 22px;\n      line-height: 30px;\n    "),
    UI22SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 22px;\n      line-height: 30px;\n    "),
    UI20B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 20px;\n      line-height: 28px;\n    "),
    UI20SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 20px;\n      line-height: 28px;\n    "),
    UI20M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 28px;\n    "),
    UI20R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 20px;\n      line-height: 28px;\n    "),
    UI19B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 19px;\n      line-height: 26px;\n    "),
    UI19SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 19px;\n      line-height: 26px;\n    "),
    UI19M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 19px;\n      line-height: 26px;\n    "),
    UI19R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 19px;\n      line-height: 26px;\n    "),
    UI18B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 26px;\n    "),
    UI18SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 18px;\n      line-height: 26px;\n    "),
    UI18M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 26px;\n    "),
    UI18R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 26px;\n    "),
    UI17B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 17px;\n      line-height: 24px;\n    "),
    UI17SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 17px;\n      line-height: 24px;\n    "),
    UI17M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 17px;\n      line-height: 24px;\n    "),
    UI17R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 17px;\n      line-height: 24px;\n    "),
    UI16B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 24px;\n    "),
    UI16SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n    "),
    UI16M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 24px;\n    "),
    UI16R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n    "),
    UI15B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 15px;\n      line-height: 22px;\n    "),
    UI15SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 15px;\n      line-height: 22px;\n    "),
    UI15M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 15px;\n      line-height: 22px;\n    "),
    UI15R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n    "),
    UI14B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 14px;\n      line-height: 20px;\n    "),
    UI14SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 20px;\n    "),
    UI14M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 20px;\n    "),
    UI14R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n    "),
    UI13B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 13px;\n      line-height: 18px;\n    "),
    UI13SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 13px;\n      line-height: 18px;\n    "),
    UI13M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 18px;\n    "),
    UI13R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 18px;\n    "),
    UI12B: "\n      ".concat(defaultTypography, "\n      font-weight: 700;\n      font-size: 12px;\n      line-height: 18px;\n    "),
    UI12SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 18px;\n    "),
    UI12M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n    "),
    UI12R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n    "),
    UI11SB: "\n      ".concat(defaultTypography, "\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 14px;\n    "),
    // UI Sub (M/R)
    UI11M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 11px;\n      line-height: 14px;\n    "),
    UI11R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 11px;\n      line-height: 14px;\n    "),
    UI10SB: "\n    ".concat(defaultTypography, "\n    font-weight: 600;\n    font-size: 10px;\n    line-height: 12px;\n  "),
    UI10M: "\n    ".concat(defaultTypography, "\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 12px;\n  "),
    UI10R: "\n    ".concat(defaultTypography, "\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 12px;\n  "),
    ARTICLE18M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 32px;\n    "),
    ARTICLE18R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 32px;\n    "),
    ARTICLE16M: "\n      ".concat(defaultTypography, "\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 28px;\n    "),
    ARTICLE16R: "\n      ".concat(defaultTypography, "\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 28px;\n    ")
};
var fontWeight = {
    BOLD: 700,
    SEMI_BOLD: 600,
    MEDIUM: 500,
    REGULAR: 400
};
var shadow = {
    BOX_SHADOW_LARGE: "0px 8px 16px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.04)",
    BUTTON_SHADOW_SMALL: "0px 2px 4px rgba(0, 0, 0, 0.08)",
    DROP_DOWN_SHADOW_SMALL: "0px 4px 8px rgba(0, 0, 0, 0.08)"
};
var breakPoint = {
    SMALL_MOBILE: "400px"
};
var theme = {
    size: size,
    color: color,
    typography: typography,
    fontWeight: fontWeight,
    shadow: shadow,
    breakPoint: breakPoint
};
/* harmony default export */ __webpack_exports__["Z"] = (theme);


/***/ }),

/***/ 9912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ClientType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ClientType;
(function(ClientType) {
    ClientType["MOBILE_WEBVIEW"] = "mobile-webview";
    ClientType["MOBILE_WEB"] = "mobile-web";
    ClientType["WEB"] = "web";
})(ClientType || (ClientType = {}));


/***/ }),

/***/ 72271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Et": function() { return /* binding */ PharmacyReviewSortType; },
/* harmony export */   "A1u": function() { return /* binding */ PharmacyFilterType; },
/* harmony export */   "BBh": function() { return /* binding */ HospitalSortType; },
/* harmony export */   "C5j": function() { return /* binding */ UserProfileRelation; },
/* harmony export */   "CxO": function() { return /* binding */ PharmacyPartnershipType; },
/* harmony export */   "D$u": function() { return /* binding */ GameType; },
/* harmony export */   "DLH": function() { return /* binding */ AddressType; },
/* harmony export */   "ERp": function() { return /* binding */ SortType; },
/* harmony export */   "Fs2": function() { return /* binding */ PrescriptionDispensingType; },
/* harmony export */   "G26": function() { return /* binding */ QuestionAnsweredStatus; },
/* harmony export */   "GcW": function() { return /* binding */ InHospitalDeliveryCategoryType; },
/* harmony export */   "Gh6": function() { return /* binding */ DiseaseEncyclopediaSortType; },
/* harmony export */   "Gjj": function() { return /* binding */ MedicalCategoryIconType; },
/* harmony export */   "GqI": function() { return /* binding */ BookingScheduleType; },
/* harmony export */   "H7r": function() { return /* binding */ TelemedicineEligibleTargetType; },
/* harmony export */   "J42": function() { return /* binding */ DoctorType; },
/* harmony export */   "L2T": function() { return /* binding */ ReviewCommentHolderType; },
/* harmony export */   "LE2": function() { return /* binding */ DiagnosisType; },
/* harmony export */   "LXB": function() { return /* binding */ UserMissionStatus; },
/* harmony export */   "LbY": function() { return /* binding */ PharmacySelectionChangeReasonType; },
/* harmony export */   "MF8": function() { return /* binding */ QuestionAccessibleType; },
/* harmony export */   "NZ": function() { return /* binding */ DayScheduleStatus; },
/* harmony export */   "PWk": function() { return /* binding */ InvitationCodeType; },
/* harmony export */   "Qpf": function() { return /* binding */ GeneralSearchFeatureType; },
/* harmony export */   "RKQ": function() { return /* binding */ AnswerLikeType; },
/* harmony export */   "SUn": function() { return /* binding */ QnaAnswerReviewTagExposureType; },
/* harmony export */   "T4Y": function() { return /* binding */ PharmacyFilterMode; },
/* harmony export */   "THR": function() { return /* binding */ MedicineDictionarySortType; },
/* harmony export */   "TMd": function() { return /* binding */ DoctorCareerType; },
/* harmony export */   "Tqb": function() { return /* binding */ AuthorType; },
/* harmony export */   "UH9": function() { return /* binding */ MedicineType; },
/* harmony export */   "V1V": function() { return /* binding */ DoctorReviewSort; },
/* harmony export */   "VYf": function() { return /* binding */ AiAnswerButtonType; },
/* harmony export */   "WkB": function() { return /* binding */ MedicalCategoryType; },
/* harmony export */   "X4d": function() { return /* binding */ FamilyGender; },
/* harmony export */   "Zw_": function() { return /* binding */ AgreementCategory; },
/* harmony export */   "b07": function() { return /* binding */ PharmacyOperationStatusV2; },
/* harmony export */   "bML": function() { return /* binding */ AnswererType; },
/* harmony export */   "cx": function() { return /* binding */ AiAnswerStatus; },
/* harmony export */   "dDP": function() { return /* binding */ FamilyRelation; },
/* harmony export */   "dnx": function() { return /* binding */ GenderType; },
/* harmony export */   "dqE": function() { return /* binding */ DiagnosisPriceType; },
/* harmony export */   "eAd": function() { return /* binding */ MedicalCategorySortType; },
/* harmony export */   "eKF": function() { return /* binding */ HospitalOperatingStatus; },
/* harmony export */   "f$c": function() { return /* binding */ PharmacySortType; },
/* harmony export */   "f9g": function() { return /* binding */ AdColorTheme; },
/* harmony export */   "fAR": function() { return /* binding */ DiagnosisInflowType; },
/* harmony export */   "frO": function() { return /* binding */ ReviewTargetType; },
/* harmony export */   "hCl": function() { return /* binding */ MissionType; },
/* harmony export */   "hlw": function() { return /* binding */ BookingAvailability; },
/* harmony export */   "icF": function() { return /* binding */ DiagnosisAttachmentType; },
/* harmony export */   "iz1": function() { return /* binding */ GeneralSearchSnippetType; },
/* harmony export */   "jcE": function() { return /* binding */ MagazineContentType; },
/* harmony export */   "jzP": function() { return /* binding */ AttachmentBlindType; },
/* harmony export */   "kG5": function() { return /* binding */ AiAnswerCheckStatus; },
/* harmony export */   "lP_": function() { return /* binding */ ProviderType; },
/* harmony export */   "lyM": function() { return /* binding */ DoctorPartnershipStatus; },
/* harmony export */   "ngx": function() { return /* binding */ ClickActionType; },
/* harmony export */   "nww": function() { return /* binding */ PharmacyParkingType; },
/* harmony export */   "nyr": function() { return /* binding */ QuestionSearchSort; },
/* harmony export */   "pLY": function() { return /* binding */ OrderCancelReasonCategory; },
/* harmony export */   "qEJ": function() { return /* binding */ AgreementType; },
/* harmony export */   "qRY": function() { return /* binding */ DiagnosisFormType; },
/* harmony export */   "qTN": function() { return /* binding */ FreeVaccinationSearchFilterType; },
/* harmony export */   "qnl": function() { return /* binding */ DiagnosisContactType; },
/* harmony export */   "rHE": function() { return /* binding */ PayCompany; },
/* harmony export */   "rdQ": function() { return /* binding */ DiseaseEncyclopediaBottomButtonType; },
/* harmony export */   "t6H": function() { return /* binding */ DayOfWeekType; },
/* harmony export */   "tPC": function() { return /* binding */ TelemedicineEligibleGroupType; },
/* harmony export */   "tt_": function() { return /* binding */ DoctorSortType; },
/* harmony export */   "ulb": function() { return /* binding */ KoreaAddressDongType; },
/* harmony export */   "vw3": function() { return /* binding */ TelemedicineTargetType; },
/* harmony export */   "xVd": function() { return /* binding */ QuestionStatus; },
/* harmony export */   "zhv": function() { return /* binding */ PlatformType; }
/* harmony export */ });
/* unused harmony exports GraphqlError, AccountStatus, AdTargetPlace, AffiliationType, AnemiaStatus, AuthRole, BannerDisplayType, BloodPressureStatus, BloodSugarStatus, BodyStatus, BookingStatus, ButtonOnDiagnosisListAtUserAppActionType, CardType, ChannelType, CombinedEligibilityTagType, CommerceOrderItemStatus, CommerceOrderStatus, ContractType, CoreCategoryType, CounselingCancelReason, CounselingStatus, CounselingType, CounselorType, DeliveryCategoryType, DiagnosisBenefitType, DiagnosisPayStatus, DiagnosisStatus, DiagnosisSummaryStatus, DiseaseEncyclopediaContentType, DoctorBadgeType, DoctorGender, DoctorSearchByUserExperimentTestGroup, DoctorVaccinePriceSource, DoctornowRole, DomainName, DoseRecordPointMissionCode, FaceToFaceDiagnosisStatus, FeedbackReasonCode, FeedbackTarget, Gender, HealthCheckItemType, HealthCheckResultStatus, HealthInsuranceScrapingStatus, HealthInsuranceSimpleAuthType, HealthRecordSource, HealthRecordType, HistoryTakingStatus, HomeBannerActionUrlType, HomeBannerImageUrlType, HomeGreetingMessagePhraseType, HospitalFilterType, HospitalOnBoardingStatus, HospitalPartnershipStatus, HospitalSearchPortalType, HotKeywordSortType, InflowType, LiverFunctionStatus, LoginResponseType, LoginType, LottieOnDiagnosisListAtUserApp, MainFunction, MedicalFacilityTreatmentType, MedicineApprovalType, MedicineBenefitType, MedicineDispensabilityStatus, MedicineStandardType, NonBenefitCategoryMedicalNameType, NonBenefitItemUnitType, NoticeAccountType, NoticeCategoryType, NoticeType, NowPartnershipStatus, OrderCancelReasonType, OrderPaymentStatus, OrderStatus, OrderType, OverallCounselingScheduleStatus, PatientGender, PatientNotificationType, PaymentTotalStatus, PeriodType, PersonalizedNutritionAggregateStatus, PharmacyMatchingHistoryType, PharmacyPartnerShip, PointEventType, PointServiceCodeType, PrizeType, ProfessionalFieldType, QuestionCategoryType, QuestionType, QuizBonusType, QuizMessageType, QuizRewardType, QuizStatus, QuizType, RawMaterialType, ReasonForLeavingInputType, ReasonForLeavingType, RecordedTimeType, ResultType, ReviewHolderType, ReviewImageType, ReviewReceiverType, RoleType, SatisfactionStatus, SellerType, ShipmentStatus, ShippingCompany, SignupPath, SubscriptionStatus, SubscriptionTermType, SubscriptionType, SurveyCategory, TagType, TelemedicineEligibleTime, TicketType, TreatmentSearchType, UserPrizeStatus, UserProfileType, VerificationType */
/* harmony import */ var _types_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47358);




var GraphqlError = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(GqlError) {
    "use strict";
    _inherits(GraphqlError, GqlError);
    var _super = _create_super(GraphqlError);
    function GraphqlError() {
        _class_call_check(this, GraphqlError);
        return _super.apply(this, arguments);
    }
    return GraphqlError;
}(GqlError)));
var AccountStatus;
(function(AccountStatus) {
    AccountStatus["Activated"] = "ACTIVATED";
    AccountStatus["Deleted"] = "DELETED";
    AccountStatus["Inactivated"] = "INACTIVATED";
})(AccountStatus || (AccountStatus = {}));
var AdColorTheme;
(function(AdColorTheme) {
    AdColorTheme["Dark"] = "DARK";
    AdColorTheme["Light"] = "LIGHT";
})(AdColorTheme || (AdColorTheme = {}));
var AdTargetPlace;
(function(AdTargetPlace) {
    AdTargetPlace["DoctorWebSideBigLeft"] = "DOCTOR_WEB_SIDE_BIG_LEFT";
    AdTargetPlace["DoctorWebSideBigRight"] = "DOCTOR_WEB_SIDE_BIG_RIGHT";
    AdTargetPlace["DoctorWebSideSmall"] = "DOCTOR_WEB_SIDE_SMALL";
    AdTargetPlace["PharmacistWebSideBig"] = "PHARMACIST_WEB_SIDE_BIG";
    AdTargetPlace["PharmacistWebSideSmall"] = "PHARMACIST_WEB_SIDE_SMALL";
    AdTargetPlace["UserAppCommunityArticleBottom"] = "USER_APP_COMMUNITY_ARTICLE_BOTTOM";
    AdTargetPlace["UserAppCommunityMain"] = "USER_APP_COMMUNITY_MAIN";
    AdTargetPlace["UserAppDiagnosisHistoryInList"] = "USER_APP_DIAGNOSIS_HISTORY_IN_LIST";
    AdTargetPlace["UserAppDoctorListDepartmentInList"] = "USER_APP_DOCTOR_LIST_DEPARTMENT_IN_LIST";
    AdTargetPlace["UserAppDoctorListDepartmentTop"] = "USER_APP_DOCTOR_LIST_DEPARTMENT_TOP";
    AdTargetPlace["UserAppDoctorListTreatmentInList"] = "USER_APP_DOCTOR_LIST_TREATMENT_IN_LIST";
    AdTargetPlace["UserAppDoctorListTreatmentTop"] = "USER_APP_DOCTOR_LIST_TREATMENT_TOP";
    AdTargetPlace["UserAppEncyclopediaDetailBottom"] = "USER_APP_ENCYCLOPEDIA_DETAIL_BOTTOM";
    AdTargetPlace["UserAppExit"] = "USER_APP_EXIT";
    AdTargetPlace["UserAppHealthDocument"] = "USER_APP_HEALTH_DOCUMENT";
    AdTargetPlace["UserAppHealthMain"] = "USER_APP_HEALTH_MAIN";
    AdTargetPlace["UserAppHomeMain"] = "USER_APP_HOME_MAIN";
    AdTargetPlace["UserAppHospitalSearchDetailBottom"] = "USER_APP_HOSPITAL_SEARCH_DETAIL_BOTTOM";
    AdTargetPlace["UserAppHospitalSearchInList"] = "USER_APP_HOSPITAL_SEARCH_IN_LIST";
    AdTargetPlace["UserAppMagazineArticleBottom"] = "USER_APP_MAGAZINE_ARTICLE_BOTTOM";
    AdTargetPlace["UserAppMagazineArticleContentBanner"] = "USER_APP_MAGAZINE_ARTICLE_CONTENT_BANNER";
    AdTargetPlace["UserAppMagazineFaqBottom"] = "USER_APP_MAGAZINE_FAQ_BOTTOM";
    AdTargetPlace["UserAppMainRolling"] = "USER_APP_MAIN_ROLLING";
    AdTargetPlace["UserAppPointMarketMain"] = "USER_APP_POINT_MARKET_MAIN";
    AdTargetPlace["UserAppPopup"] = "USER_APP_POPUP";
    AdTargetPlace["UserAppQnaMain"] = "USER_APP_QNA_MAIN";
    AdTargetPlace["UserAppQnaQuestionBottom"] = "USER_APP_QNA_QUESTION_BOTTOM";
    AdTargetPlace["UserAppQnaQuestionBottomImage"] = "USER_APP_QNA_QUESTION_BOTTOM_IMAGE";
    AdTargetPlace["UserAppSearchMain"] = "USER_APP_SEARCH_MAIN";
    AdTargetPlace["UserAppSearchMainImage"] = "USER_APP_SEARCH_MAIN_IMAGE";
    AdTargetPlace["UserWebHomeMain"] = "USER_WEB_HOME_MAIN";
    AdTargetPlace["UserWebMagazineArticleContentBanner"] = "USER_WEB_MAGAZINE_ARTICLE_CONTENT_BANNER";
    AdTargetPlace["UserWebMenuBottom"] = "USER_WEB_MENU_BOTTOM";
    AdTargetPlace["UserWebMobileMagazineArticleContentBanner"] = "USER_WEB_MOBILE_MAGAZINE_ARTICLE_CONTENT_BANNER";
    AdTargetPlace["UserWebMobileMenuBottom"] = "USER_WEB_MOBILE_MENU_BOTTOM";
    AdTargetPlace["UserWebMobileNonBenefitPriceBand"] = "USER_WEB_MOBILE_NON_BENEFIT_PRICE_BAND";
    AdTargetPlace["UserWebMobileNonBenefitPriceMiddle"] = "USER_WEB_MOBILE_NON_BENEFIT_PRICE_MIDDLE";
    AdTargetPlace["UserWebMobileQnaQuestionBottom"] = "USER_WEB_MOBILE_QNA_QUESTION_BOTTOM";
    AdTargetPlace["UserWebMobileSearchMain"] = "USER_WEB_MOBILE_SEARCH_MAIN";
    AdTargetPlace["UserWebMobileTopStickyBand"] = "USER_WEB_MOBILE_TOP_STICKY_BAND";
    AdTargetPlace["UserWebNonBenefitPriceMiddle"] = "USER_WEB_NON_BENEFIT_PRICE_MIDDLE";
    AdTargetPlace["UserWebQnaQuestionBottom"] = "USER_WEB_QNA_QUESTION_BOTTOM";
    AdTargetPlace["UserWebSearchMain"] = "USER_WEB_SEARCH_MAIN";
    AdTargetPlace["UserWebSideBigRight"] = "USER_WEB_SIDE_BIG_RIGHT";
    AdTargetPlace["UserWebSideSmallLeft"] = "USER_WEB_SIDE_SMALL_LEFT";
    AdTargetPlace["UserWebSideSmallRight"] = "USER_WEB_SIDE_SMALL_RIGHT";
})(AdTargetPlace || (AdTargetPlace = {}));
var AddressType;
(function(AddressType) {
    AddressType["Company"] = "COMPANY";
    AddressType["Home"] = "HOME";
    AddressType["Others"] = "OTHERS";
})(AddressType || (AddressType = {}));
var AffiliationType;
(function(AffiliationType) {
    AffiliationType["Doctornow"] = "DOCTORNOW";
    AffiliationType["Hospital"] = "HOSPITAL";
    AffiliationType["Pharmacy"] = "PHARMACY";
})(AffiliationType || (AffiliationType = {}));
var AgreementCategory;
(function(AgreementCategory) {
    AgreementCategory["AiSymptomCheckerAgreement"] = "AI_SYMPTOM_CHECKER_AGREEMENT";
    AgreementCategory["DoctorTermsAgreement"] = "DOCTOR_TERMS_AGREEMENT";
    AgreementCategory["F2FTermsAgreement"] = "F2F_TERMS_AGREEMENT";
    AgreementCategory["Family"] = "FAMILY";
    AgreementCategory["HealthInsurance"] = "HEALTH_INSURANCE";
    AgreementCategory["HistoryTakingTermsAgreement"] = "HISTORY_TAKING_TERMS_AGREEMENT";
    AgreementCategory["HospitalTermsAgreement"] = "HOSPITAL_TERMS_AGREEMENT";
    AgreementCategory["HospitalWholesalePartnership"] = "HOSPITAL_WHOLESALE_PARTNERSHIP";
    AgreementCategory["LocationBasedService"] = "LOCATION_BASED_SERVICE";
    AgreementCategory["Marketing"] = "MARKETING";
    AgreementCategory["NowPartnership"] = "NOW_PARTNERSHIP";
    AgreementCategory["PharmacistTermsAgreement"] = "PHARMACIST_TERMS_AGREEMENT";
    AgreementCategory["PharmacyWholesalePartnership"] = "PHARMACY_WHOLESALE_PARTNERSHIP";
    AgreementCategory["PointCouponAgreement"] = "POINT_COUPON_AGREEMENT";
    AgreementCategory["QnaAgreement"] = "QNA_AGREEMENT";
    AgreementCategory["UserPayment"] = "USER_PAYMENT";
    AgreementCategory["UserPaymentInisis"] = "USER_PAYMENT_INISIS";
    AgreementCategory["UserPaymentTossPg"] = "USER_PAYMENT_TOSS_PG";
})(AgreementCategory || (AgreementCategory = {}));
var AgreementType;
(function(AgreementType) {
    AgreementType["AiSymptomCheckerTermsAndConditions"] = "AI_SYMPTOM_CHECKER_TERMS_AND_CONDITIONS";
    AgreementType["CollectHealthInformation"] = "COLLECT_HEALTH_INFORMATION";
    AgreementType["CollectMaskingPersonalInformation"] = "COLLECT_MASKING_PERSONAL_INFORMATION";
    AgreementType["CollectPersonalInformation"] = "COLLECT_PERSONAL_INFORMATION";
    AgreementType["CollectUniqueIdentification"] = "COLLECT_UNIQUE_IDENTIFICATION";
    AgreementType["ConsignmentContract"] = "CONSIGNMENT_CONTRACT";
    AgreementType["ConsignmentContractConsignor"] = "CONSIGNMENT_CONTRACT_CONSIGNOR";
    AgreementType["ConsignmentContractTrusteee"] = "CONSIGNMENT_CONTRACT_TRUSTEEE";
    AgreementType["ElectronicFinancialTransaction"] = "ELECTRONIC_FINANCIAL_TRANSACTION";
    AgreementType["F2FProvidePersonalInformation"] = "F2F_PROVIDE_PERSONAL_INFORMATION";
    AgreementType["F2FSensitiveInformation"] = "F2F_SENSITIVE_INFORMATION";
    AgreementType["FamilyRepresentativeApplication"] = "FAMILY_REPRESENTATIVE_APPLICATION";
    AgreementType["HealthInformation"] = "HEALTH_INFORMATION";
    AgreementType["HealthInformationMarketing"] = "HEALTH_INFORMATION_MARKETING";
    AgreementType["HealthInformationOverseasTransfer"] = "HEALTH_INFORMATION_OVERSEAS_TRANSFER";
    AgreementType["HospitalWholesaleServiceTerms"] = "HOSPITAL_WHOLESALE_SERVICE_TERMS";
    AgreementType["LocationBasedServiceTermsAndConditions"] = "LOCATION_BASED_SERVICE_TERMS_AND_CONDITIONS";
    AgreementType["Marketing"] = "MARKETING";
    AgreementType["MarketingNight"] = "MARKETING_NIGHT";
    AgreementType["NowPartnershipPharmaceuticalManagementTerms"] = "NOW_PARTNERSHIP_PHARMACEUTICAL_MANAGEMENT_TERMS";
    AgreementType["NowPartnershipTermsOfService"] = "NOW_PARTNERSHIP_TERMS_OF_SERVICE";
    AgreementType["PartnershipContract"] = "PARTNERSHIP_CONTRACT";
    AgreementType["PartnershipPharmaceuticalManagementTerms"] = "PARTNERSHIP_PHARMACEUTICAL_MANAGEMENT_TERMS";
    AgreementType["PersonalInformationOverseasTransfer"] = "PERSONAL_INFORMATION_OVERSEAS_TRANSFER";
    AgreementType["PersonalInformationProcessing"] = "PERSONAL_INFORMATION_PROCESSING";
    AgreementType["PharmacyWholesaleServiceTerms"] = "PHARMACY_WHOLESALE_SERVICE_TERMS";
    AgreementType["ProvideHealthInformation"] = "PROVIDE_HEALTH_INFORMATION";
    AgreementType["ProvidePersonalInformation"] = "PROVIDE_PERSONAL_INFORMATION";
    AgreementType["ProvideSensitiveInformation"] = "PROVIDE_SENSITIVE_INFORMATION";
    AgreementType["RegularPayment"] = "REGULAR_PAYMENT";
    AgreementType["SensitiveInformation"] = "SENSITIVE_INFORMATION";
    AgreementType["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
})(AgreementType || (AgreementType = {}));
var AiAnswerButtonType;
(function(AiAnswerButtonType) {
    AiAnswerButtonType["Horizontal"] = "HORIZONTAL";
    AiAnswerButtonType["Vertical"] = "VERTICAL";
})(AiAnswerButtonType || (AiAnswerButtonType = {}));
var AiAnswerCheckStatus;
(function(AiAnswerCheckStatus) {
    AiAnswerCheckStatus["Checked"] = "CHECKED";
    AiAnswerCheckStatus["NoNeedToCheck"] = "NO_NEED_TO_CHECK";
    AiAnswerCheckStatus["Unchecked"] = "UNCHECKED";
})(AiAnswerCheckStatus || (AiAnswerCheckStatus = {}));
var AiAnswerStatus;
(function(AiAnswerStatus) {
    AiAnswerStatus["Accepted"] = "ACCEPTED";
    AiAnswerStatus["Generating"] = "GENERATING";
    AiAnswerStatus["GenerationComplete"] = "GENERATION_COMPLETE";
    AiAnswerStatus["GenerationFailed"] = "GENERATION_FAILED";
    AiAnswerStatus["GenerationRequested"] = "GENERATION_REQUESTED";
    AiAnswerStatus["None"] = "NONE";
    AiAnswerStatus["Rejected"] = "REJECTED";
})(AiAnswerStatus || (AiAnswerStatus = {}));
var AnemiaStatus;
(function(AnemiaStatus) {
    AnemiaStatus["Danger"] = "DANGER";
    AnemiaStatus["Normal"] = "NORMAL";
    AnemiaStatus["Warning"] = "WARNING";
})(AnemiaStatus || (AnemiaStatus = {}));
var AnswerLikeType;
(function(AnswerLikeType) {
    AnswerLikeType["Dislike"] = "DISLIKE";
    AnswerLikeType["Like"] = "LIKE";
})(AnswerLikeType || (AnswerLikeType = {}));
var AnswererType;
(function(AnswererType) {
    AnswererType["Ai"] = "AI";
    AnswererType["Doctor"] = "DOCTOR";
    AnswererType["Nurse"] = "NURSE";
})(AnswererType || (AnswererType = {}));
var AttachmentBlindType;
(function(AttachmentBlindType) {
    AttachmentBlindType["Blinded"] = "BLINDED";
    AttachmentBlindType["Dimmed"] = "DIMMED";
    AttachmentBlindType["None"] = "NONE";
})(AttachmentBlindType || (AttachmentBlindType = {}));
var AuthRole;
(function(AuthRole) {
    AuthRole["Admin"] = "ADMIN";
    AuthRole["Hospital"] = "HOSPITAL";
    AuthRole["User"] = "USER";
})(AuthRole || (AuthRole = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["Ai"] = "AI";
    AuthorType["Doctor"] = "DOCTOR";
    AuthorType["GeneralEditor"] = "GENERAL_EDITOR";
    AuthorType["MedicalProfessionalEditor"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["Nurse"] = "NURSE";
})(AuthorType || (AuthorType = {}));
var BannerDisplayType;
(function(BannerDisplayType) {
    BannerDisplayType["All"] = "ALL";
    BannerDisplayType["App"] = "APP";
    BannerDisplayType["Web"] = "WEB";
})(BannerDisplayType || (BannerDisplayType = {}));
var BloodPressureStatus;
(function(BloodPressureStatus) {
    BloodPressureStatus["Hypertension"] = "HYPERTENSION";
    BloodPressureStatus["Normal"] = "NORMAL";
    BloodPressureStatus["PreHypertension"] = "PRE_HYPERTENSION";
})(BloodPressureStatus || (BloodPressureStatus = {}));
var BloodSugarStatus;
(function(BloodSugarStatus) {
    BloodSugarStatus["Diabetes"] = "DIABETES";
    BloodSugarStatus["DiabetesWarning"] = "DIABETES_WARNING";
    BloodSugarStatus["Normal"] = "NORMAL";
})(BloodSugarStatus || (BloodSugarStatus = {}));
var BodyStatus;
(function(BodyStatus) {
    BodyStatus["LowWeight"] = "LOW_WEIGHT";
    BodyStatus["Normal"] = "NORMAL";
    BodyStatus["Obesity"] = "OBESITY";
    BodyStatus["Overweight"] = "OVERWEIGHT";
})(BodyStatus || (BodyStatus = {}));
var BookingAvailability;
(function(BookingAvailability) {
    BookingAvailability["NotBookable"] = "NOT_BOOKABLE";
    BookingAvailability["TodayBookable"] = "TODAY_BOOKABLE";
    BookingAvailability["TomorrowBookable"] = "TOMORROW_BOOKABLE";
    BookingAvailability["UpcomingBookable"] = "UPCOMING_BOOKABLE";
})(BookingAvailability || (BookingAvailability = {}));
var BookingScheduleType;
(function(BookingScheduleType) {
    BookingScheduleType["Bookable"] = "BOOKABLE";
    BookingScheduleType["Disabled"] = "DISABLED";
    BookingScheduleType["FullyBooked"] = "FULLY_BOOKED";
})(BookingScheduleType || (BookingScheduleType = {}));
var BookingStatus;
(function(BookingStatus) {
    BookingStatus["Canceled"] = "CANCELED";
    BookingStatus["Completed"] = "COMPLETED";
    BookingStatus["Pending"] = "PENDING";
})(BookingStatus || (BookingStatus = {}));
var ButtonOnDiagnosisListAtUserAppActionType;
(function(ButtonOnDiagnosisListAtUserAppActionType) {
    ButtonOnDiagnosisListAtUserAppActionType["GoToWriteDiagnosisReview"] = "GO_TO_WRITE_DIAGNOSIS_REVIEW";
})(ButtonOnDiagnosisListAtUserAppActionType || (ButtonOnDiagnosisListAtUserAppActionType = {}));
var CardType;
(function(CardType) {
    CardType["Bank"] = "BANK";
    CardType["Credit"] = "CREDIT";
    CardType["Debit"] = "DEBIT";
    CardType["Gift"] = "GIFT";
    CardType["KakaopayMoney"] = "KAKAOPAY_MONEY";
    CardType["Unknown"] = "UNKNOWN";
})(CardType || (CardType = {}));
var ChannelType;
(function(ChannelType) {
    ChannelType["PersonalizedNutrition"] = "PERSONALIZED_NUTRITION";
    ChannelType[/** @deprecated 구 추가주문임, 신 추가주문은 PHARMACY_MARKETPLACE 사용 */ "PharmacyAdditionalOrder"] = "PHARMACY_ADDITIONAL_ORDER";
    ChannelType["PharmacyMarketplace"] = "PHARMACY_MARKETPLACE";
})(ChannelType || (ChannelType = {}));
var ClickActionType;
(function(ClickActionType) {
    ClickActionType["Outlink"] = "OUTLINK";
    ClickActionType["PhoneCall"] = "PHONE_CALL";
})(ClickActionType || (ClickActionType = {}));
var CombinedEligibilityTagType;
(function(CombinedEligibilityTagType) {
    CombinedEligibilityTagType["MedicineDeliveryAlways"] = "MEDICINE_DELIVERY_ALWAYS";
    CombinedEligibilityTagType["MedicinePickUpOnly"] = "MEDICINE_PICK_UP_ONLY";
    CombinedEligibilityTagType["TelemedicineAlways"] = "TELEMEDICINE_ALWAYS";
    CombinedEligibilityTagType["TelemedicineNightAndHolidayOnly"] = "TELEMEDICINE_NIGHT_AND_HOLIDAY_ONLY";
})(CombinedEligibilityTagType || (CombinedEligibilityTagType = {}));
var CommerceOrderItemStatus;
(function(CommerceOrderItemStatus) {
    CommerceOrderItemStatus["AwaitingShipment"] = "AWAITING_SHIPMENT";
    CommerceOrderItemStatus["Cancelled"] = "CANCELLED";
    CommerceOrderItemStatus["DeliveryCompleted"] = "DELIVERY_COMPLETED";
    CommerceOrderItemStatus["Paid"] = "PAID";
    CommerceOrderItemStatus["PendingPayment"] = "PENDING_PAYMENT";
    CommerceOrderItemStatus["Shipped"] = "SHIPPED";
})(CommerceOrderItemStatus || (CommerceOrderItemStatus = {}));
var CommerceOrderStatus;
(function(CommerceOrderStatus) {
    CommerceOrderStatus["AwaitingShipment"] = "AWAITING_SHIPMENT";
    CommerceOrderStatus["Cancelled"] = "CANCELLED";
    CommerceOrderStatus["DeliveryCompleted"] = "DELIVERY_COMPLETED";
    CommerceOrderStatus["Paid"] = "PAID";
    CommerceOrderStatus["PendingPayment"] = "PENDING_PAYMENT";
    CommerceOrderStatus["Shipped"] = "SHIPPED";
})(CommerceOrderStatus || (CommerceOrderStatus = {}));
var ContractType;
(function(ContractType) {
    ContractType["All"] = "ALL";
    ContractType["FaceToFace"] = "FACE_TO_FACE";
    ContractType["NonFaceToFace"] = "NON_FACE_TO_FACE";
})(ContractType || (ContractType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var CounselingCancelReason;
(function(CounselingCancelReason) {
    CounselingCancelReason["BookingNotPossible"] = "BOOKING_NOT_POSSIBLE";
    CounselingCancelReason["CallFailed"] = "CALL_FAILED";
    CounselingCancelReason["Other"] = "OTHER";
    CounselingCancelReason["WaitingTimeout"] = "WAITING_TIMEOUT";
})(CounselingCancelReason || (CounselingCancelReason = {}));
var CounselingStatus;
(function(CounselingStatus) {
    CounselingStatus["BookingConfirmed"] = "BOOKING_CONFIRMED";
    CounselingStatus["Cancelled"] = "CANCELLED";
    CounselingStatus["Completed"] = "COMPLETED";
    CounselingStatus["Progress"] = "PROGRESS";
    CounselingStatus["Requested"] = "REQUESTED";
})(CounselingStatus || (CounselingStatus = {}));
var CounselingType;
(function(CounselingType) {
    CounselingType["PersonalizedNutrition"] = "PERSONALIZED_NUTRITION";
})(CounselingType || (CounselingType = {}));
var CounselorType;
(function(CounselorType) {
    CounselorType["PersonalizedNutrition"] = "PERSONALIZED_NUTRITION";
})(CounselorType || (CounselorType = {}));
var DayOfWeekType;
(function(DayOfWeekType) {
    DayOfWeekType["Friday"] = "FRIDAY";
    DayOfWeekType["Holiday"] = "HOLIDAY";
    DayOfWeekType["Monday"] = "MONDAY";
    DayOfWeekType["Saturday"] = "SATURDAY";
    DayOfWeekType["Sunday"] = "SUNDAY";
    DayOfWeekType["Thursday"] = "THURSDAY";
    DayOfWeekType["Tuesday"] = "TUESDAY";
    DayOfWeekType["Wednesday"] = "WEDNESDAY";
})(DayOfWeekType || (DayOfWeekType = {}));
var DayScheduleStatus;
(function(DayScheduleStatus) {
    DayScheduleStatus["Bookable"] = "BOOKABLE";
    DayScheduleStatus["FullyBooked"] = "FULLY_BOOKED";
    DayScheduleStatus["Holiday"] = "HOLIDAY";
})(DayScheduleStatus || (DayScheduleStatus = {}));
var DeliveryCategoryType;
(function(DeliveryCategoryType) {
    DeliveryCategoryType["Dawn"] = "DAWN";
    DeliveryCategoryType["PartnershipPickup"] = "PARTNERSHIP_PICKUP";
    DeliveryCategoryType["Pickup"] = "PICKUP";
    DeliveryCategoryType["Post"] = "POST";
    DeliveryCategoryType["Quick"] = "QUICK";
    DeliveryCategoryType["TodayDelivery"] = "TODAY_DELIVERY";
})(DeliveryCategoryType || (DeliveryCategoryType = {}));
var DiagnosisAttachmentType;
(function(DiagnosisAttachmentType) {
    DiagnosisAttachmentType["Symptom"] = "SYMPTOM";
    DiagnosisAttachmentType["TelemedicineGroupVerification"] = "TELEMEDICINE_GROUP_VERIFICATION";
})(DiagnosisAttachmentType || (DiagnosisAttachmentType = {}));
var DiagnosisBenefitType;
(function(DiagnosisBenefitType) {
    DiagnosisBenefitType["Benefit"] = "BENEFIT";
    DiagnosisBenefitType["BenefitAndNonBenefit"] = "BENEFIT_AND_NON_BENEFIT";
    DiagnosisBenefitType["NonBenefit"] = "NON_BENEFIT";
})(DiagnosisBenefitType || (DiagnosisBenefitType = {}));
var DiagnosisContactType;
(function(DiagnosisContactType) {
    DiagnosisContactType["F2F"] = "F2F";
    DiagnosisContactType["NonF2F"] = "NON_F2F";
})(DiagnosisContactType || (DiagnosisContactType = {}));
var DiagnosisFormType;
(function(DiagnosisFormType) {
    DiagnosisFormType["General"] = "GENERAL";
    DiagnosisFormType["InHospitalDelivery"] = "IN_HOSPITAL_DELIVERY";
})(DiagnosisFormType || (DiagnosisFormType = {}));
var DiagnosisInflowType;
(function(DiagnosisInflowType) {
    DiagnosisInflowType["General"] = "GENERAL";
    DiagnosisInflowType["Quick"] = "QUICK";
    DiagnosisInflowType["WebGeneral"] = "WEB_GENERAL";
    DiagnosisInflowType["WebQuick"] = "WEB_QUICK";
})(DiagnosisInflowType || (DiagnosisInflowType = {}));
var DiagnosisPayStatus;
(function(DiagnosisPayStatus) {
    DiagnosisPayStatus["Cancel"] = "CANCEL";
    DiagnosisPayStatus["Done"] = "DONE";
    DiagnosisPayStatus["Fail"] = "FAIL";
    DiagnosisPayStatus["None"] = "NONE";
    DiagnosisPayStatus["Ready"] = "READY";
})(DiagnosisPayStatus || (DiagnosisPayStatus = {}));
var DiagnosisPriceType;
(function(DiagnosisPriceType) {
    DiagnosisPriceType["DiagnosisOnly"] = "DIAGNOSIS_ONLY";
    DiagnosisPriceType["WithDispensation"] = "WITH_DISPENSATION";
})(DiagnosisPriceType || (DiagnosisPriceType = {}));
var DiagnosisStatus;
(function(DiagnosisStatus) {
    DiagnosisStatus["BookingRequested"] = "BOOKING_REQUESTED";
    DiagnosisStatus["Cancel"] = "CANCEL";
    DiagnosisStatus["Done"] = "DONE";
    DiagnosisStatus["Progress"] = "PROGRESS";
    DiagnosisStatus["Ready"] = "READY";
})(DiagnosisStatus || (DiagnosisStatus = {}));
var DiagnosisSummaryStatus;
(function(DiagnosisSummaryStatus) {
    DiagnosisSummaryStatus["DeliveryComplete"] = "DELIVERY_COMPLETE";
    DiagnosisSummaryStatus["DeliveryCompletePickup"] = "DELIVERY_COMPLETE_PICKUP";
    DiagnosisSummaryStatus["DeliveryDoing"] = "DELIVERY_DOING";
    DiagnosisSummaryStatus["DiagnosisAutoPaymentWaiting"] = "DIAGNOSIS_AUTO_PAYMENT_WAITING";
    DiagnosisSummaryStatus["DiagnosisBookingRequested"] = "DIAGNOSIS_BOOKING_REQUESTED";
    DiagnosisSummaryStatus["DiagnosisCancel"] = "DIAGNOSIS_CANCEL";
    DiagnosisSummaryStatus["DiagnosisDirectPaymentWaiting"] = "DIAGNOSIS_DIRECT_PAYMENT_WAITING";
    DiagnosisSummaryStatus["DiagnosisDoing"] = "DIAGNOSIS_DOING";
    DiagnosisSummaryStatus["DiagnosisNoPrescription"] = "DIAGNOSIS_NO_PRESCRIPTION";
    DiagnosisSummaryStatus["DiagnosisPrescriptionExpired"] = "DIAGNOSIS_PRESCRIPTION_EXPIRED";
    DiagnosisSummaryStatus["DispensationAcceptPrescriptionPickup"] = "DISPENSATION_ACCEPT_PRESCRIPTION_PICKUP";
    DiagnosisSummaryStatus["DispensationCompleteDeliveryAccept"] = "DISPENSATION_COMPLETE_DELIVERY_ACCEPT";
    DiagnosisSummaryStatus["DispensationDirectPaymentWaitingFail"] = "DISPENSATION_DIRECT_PAYMENT_WAITING_FAIL";
    DiagnosisSummaryStatus["DispensationDoing"] = "DISPENSATION_DOING";
    DiagnosisSummaryStatus["DispensationManualPaymentWaiting"] = "DISPENSATION_MANUAL_PAYMENT_WAITING";
    DiagnosisSummaryStatus["DispensationSelectPharmacy"] = "DISPENSATION_SELECT_PHARMACY";
    DiagnosisSummaryStatus["DispensationSelectPharmacyCancelByUser"] = "DISPENSATION_SELECT_PHARMACY_CANCEL_BY_USER";
    DiagnosisSummaryStatus["DispensationSelectPharmacyMatching"] = "DISPENSATION_SELECT_PHARMACY_MATCHING";
    DiagnosisSummaryStatus["DispensationSelectRetryPharmacy"] = "DISPENSATION_SELECT_RETRY_PHARMACY";
    DiagnosisSummaryStatus["F2FDiagnosisBookingConfirmed"] = "F2F_DIAGNOSIS_BOOKING_CONFIRMED";
    DiagnosisSummaryStatus["NonF2FDiagnosisWaiting"] = "NON_F2F_DIAGNOSIS_WAITING";
    DiagnosisSummaryStatus["PartnershipPickupDispensationConfirmed"] = "PARTNERSHIP_PICKUP_DISPENSATION_CONFIRMED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationOnsitePaymentCompleted"] = "PARTNERSHIP_PICKUP_DISPENSATION_ONSITE_PAYMENT_COMPLETED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationPaymentCompleted"] = "PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_COMPLETED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationPaymentFailed"] = "PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_FAILED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationPaymentRequested"] = "PARTNERSHIP_PICKUP_DISPENSATION_PAYMENT_REQUESTED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationPrepared"] = "PARTNERSHIP_PICKUP_DISPENSATION_PREPARED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationRequested"] = "PARTNERSHIP_PICKUP_DISPENSATION_REQUESTED";
    DiagnosisSummaryStatus["PartnershipPickupDispensationReserved"] = "PARTNERSHIP_PICKUP_DISPENSATION_RESERVED";
    DiagnosisSummaryStatus["PharmacyReviewed"] = "PHARMACY_REVIEWED";
})(DiagnosisSummaryStatus || (DiagnosisSummaryStatus = {}));
var DiagnosisType;
(function(DiagnosisType) {
    DiagnosisType["Department"] = "DEPARTMENT";
    DiagnosisType["Treatment"] = "TREATMENT";
    DiagnosisType["Vaccination"] = "VACCINATION";
})(DiagnosisType || (DiagnosisType = {}));
var DiseaseEncyclopediaBottomButtonType;
(function(DiseaseEncyclopediaBottomButtonType) {
    DiseaseEncyclopediaBottomButtonType["DiagnosisReservation"] = "DIAGNOSIS_RESERVATION";
    DiseaseEncyclopediaBottomButtonType["None"] = "NONE";
    DiseaseEncyclopediaBottomButtonType["Qna"] = "QNA";
})(DiseaseEncyclopediaBottomButtonType || (DiseaseEncyclopediaBottomButtonType = {}));
var DiseaseEncyclopediaContentType;
(function(DiseaseEncyclopediaContentType) {
    DiseaseEncyclopediaContentType["Disease"] = "DISEASE";
    DiseaseEncyclopediaContentType["Symptom"] = "SYMPTOM";
})(DiseaseEncyclopediaContentType || (DiseaseEncyclopediaContentType = {}));
var DiseaseEncyclopediaSortType;
(function(DiseaseEncyclopediaSortType) {
    DiseaseEncyclopediaSortType["Name"] = "NAME";
    DiseaseEncyclopediaSortType["Score"] = "SCORE";
})(DiseaseEncyclopediaSortType || (DiseaseEncyclopediaSortType = {}));
var DoctorBadgeType;
(function(DoctorBadgeType) {
    DoctorBadgeType["Over_1000Cases"] = "OVER_1000_CASES";
    DoctorBadgeType["Over_1000LateNightCases"] = "OVER_1000_LATE_NIGHT_CASES";
    DoctorBadgeType["Over_1000RevisitRequests"] = "OVER_1000_REVISIT_REQUESTS";
    DoctorBadgeType["SpecialistInSubject"] = "SPECIALIST_IN_SUBJECT";
})(DoctorBadgeType || (DoctorBadgeType = {}));
var DoctorCareerType;
(function(DoctorCareerType) {
    DoctorCareerType["Completion"] = "COMPLETION";
    DoctorCareerType["Current"] = "CURRENT";
    DoctorCareerType["Graduation"] = "GRADUATION";
    DoctorCareerType["Past"] = "PAST";
})(DoctorCareerType || (DoctorCareerType = {}));
var DoctorGender;
(function(DoctorGender) {
    DoctorGender["Female"] = "FEMALE";
    DoctorGender["Male"] = "MALE";
    DoctorGender["None"] = "NONE";
})(DoctorGender || (DoctorGender = {}));
var DoctorPartnershipStatus;
(function(DoctorPartnershipStatus) {
    DoctorPartnershipStatus["Affiliated"] = "AFFILIATED";
    DoctorPartnershipStatus["Applied"] = "APPLIED";
    DoctorPartnershipStatus["Applying"] = "APPLYING";
    DoctorPartnershipStatus["Approved"] = "APPROVED";
    DoctorPartnershipStatus["Blocked"] = "BLOCKED";
    DoctorPartnershipStatus["NotAffiliated"] = "NOT_AFFILIATED";
    DoctorPartnershipStatus["Rejected"] = "REJECTED";
    DoctorPartnershipStatus["Revoked"] = "REVOKED";
})(DoctorPartnershipStatus || (DoctorPartnershipStatus = {}));
var DoctorReviewSort;
(function(DoctorReviewSort) {
    DoctorReviewSort["HighRating"] = "HIGH_RATING";
    DoctorReviewSort["LowRating"] = "LOW_RATING";
    DoctorReviewSort["Newest"] = "NEWEST";
})(DoctorReviewSort || (DoctorReviewSort = {}));
var DoctorSearchByUserExperimentTestGroup;
(function(DoctorSearchByUserExperimentTestGroup) {
    DoctorSearchByUserExperimentTestGroup["A"] = "A";
    DoctorSearchByUserExperimentTestGroup["B"] = "B";
    DoctorSearchByUserExperimentTestGroup["C"] = "C";
})(DoctorSearchByUserExperimentTestGroup || (DoctorSearchByUserExperimentTestGroup = {}));
var DoctorSortType;
(function(DoctorSortType) {
    DoctorSortType["Alphabetically"] = "ALPHABETICALLY";
    DoctorSortType["Default"] = "DEFAULT";
    DoctorSortType["Distance"] = "DISTANCE";
    DoctorSortType["Medicine"] = "MEDICINE";
    DoctorSortType["NearestBooking"] = "NEAREST_BOOKING";
    DoctorSortType["Price"] = "PRICE";
    DoctorSortType["Random"] = "RANDOM";
    DoctorSortType["Recent"] = "RECENT";
    DoctorSortType["ReviewAverageRating"] = "REVIEW_AVERAGE_RATING";
    DoctorSortType["ReviewCount"] = "REVIEW_COUNT";
})(DoctorSortType || (DoctorSortType = {}));
var DoctorType;
(function(DoctorType) {
    DoctorType["Counselor"] = "COUNSELOR";
    DoctorType["Doctor"] = "DOCTOR";
})(DoctorType || (DoctorType = {}));
var DoctorVaccinePriceSource;
(function(DoctorVaccinePriceSource) {
    DoctorVaccinePriceSource["Hira"] = "HIRA";
    DoctorVaccinePriceSource["Manual"] = "MANUAL";
})(DoctorVaccinePriceSource || (DoctorVaccinePriceSource = {}));
var DoctornowRole;
(function(DoctornowRole) {
    DoctornowRole["Admin"] = "ADMIN";
    DoctornowRole["Doctor"] = "DOCTOR";
    DoctornowRole["Hospital"] = "HOSPITAL";
    DoctornowRole["Pharmacy"] = "PHARMACY";
    DoctornowRole["Unknown"] = "UNKNOWN";
    DoctornowRole["User"] = "USER";
})(DoctornowRole || (DoctornowRole = {}));
var DomainName;
(function(DomainName) {
    DomainName["Commerce"] = "COMMERCE";
    DomainName["Counseling"] = "COUNSELING";
    DomainName["Cs"] = "CS";
    DomainName["Healthcare"] = "HEALTHCARE";
    DomainName["Hospital"] = "HOSPITAL";
    DomainName["NonFaceToFaceDiagnosis"] = "NON_FACE_TO_FACE_DIAGNOSIS";
    DomainName["Payment"] = "PAYMENT";
    DomainName["Pharmacy"] = "PHARMACY";
    DomainName["Qna"] = "QNA";
    DomainName["Settlement"] = "SETTLEMENT";
    DomainName["Subscription"] = "SUBSCRIPTION";
})(DomainName || (DomainName = {}));
var DoseRecordPointMissionCode;
(function(DoseRecordPointMissionCode) {
    DoseRecordPointMissionCode["TodayDoseCompleteMission"] = "TODAY_DOSE_COMPLETE_MISSION";
})(DoseRecordPointMissionCode || (DoseRecordPointMissionCode = {}));
var FaceToFaceDiagnosisStatus;
(function(FaceToFaceDiagnosisStatus) {
    FaceToFaceDiagnosisStatus["Booked"] = "BOOKED";
    FaceToFaceDiagnosisStatus["Cancel"] = "CANCEL";
    FaceToFaceDiagnosisStatus["Done"] = "DONE";
    FaceToFaceDiagnosisStatus["InProgress"] = "IN_PROGRESS";
    FaceToFaceDiagnosisStatus["Ready"] = "READY";
})(FaceToFaceDiagnosisStatus || (FaceToFaceDiagnosisStatus = {}));
var FamilyGender;
(function(FamilyGender) {
    FamilyGender["Female"] = "FEMALE";
    FamilyGender["Male"] = "MALE";
    FamilyGender["None"] = "NONE";
})(FamilyGender || (FamilyGender = {}));
var FamilyRelation;
(function(FamilyRelation) {
    FamilyRelation["Children"] = "CHILDREN";
    FamilyRelation["Me"] = "ME";
    FamilyRelation["Parents"] = "PARENTS";
    FamilyRelation["Spouse"] = "SPOUSE";
})(FamilyRelation || (FamilyRelation = {}));
var FeedbackReasonCode;
(function(FeedbackReasonCode) {
    FeedbackReasonCode["ConcernedAboutCost"] = "CONCERNED_ABOUT_COST";
    FeedbackReasonCode["DirectInput"] = "DIRECT_INPUT";
    FeedbackReasonCode["DoctorInfoLack"] = "DOCTOR_INFO_LACK";
    FeedbackReasonCode["TreatmentNotNecessaryYet"] = "TREATMENT_NOT_NECESSARY_YET";
    FeedbackReasonCode["UnsureFitForChild"] = "UNSURE_FIT_FOR_CHILD";
})(FeedbackReasonCode || (FeedbackReasonCode = {}));
var FeedbackTarget;
(function(FeedbackTarget) {
    FeedbackTarget["ExitPediatricDoctorList"] = "EXIT_PEDIATRIC_DOCTOR_LIST";
})(FeedbackTarget || (FeedbackTarget = {}));
var FreeVaccinationSearchFilterType;
(function(FreeVaccinationSearchFilterType) {
    FreeVaccinationSearchFilterType["Child"] = "CHILD";
    FreeVaccinationSearchFilterType["Pregnant"] = "PREGNANT";
    FreeVaccinationSearchFilterType["Senior"] = "SENIOR";
    FreeVaccinationSearchFilterType["SeongnamCitizen"] = "SEONGNAM_CITIZEN";
})(FreeVaccinationSearchFilterType || (FreeVaccinationSearchFilterType = {}));
var GameType;
(function(GameType) {
    GameType["RandomBox"] = "RANDOM_BOX";
    GameType["Roulette"] = "ROULETTE";
})(GameType || (GameType = {}));
var Gender;
(function(Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["None"] = "NONE";
})(Gender || (Gender = {}));
var GenderType;
(function(GenderType) {
    GenderType["Female"] = "FEMALE";
    GenderType["Male"] = "MALE";
    GenderType["None"] = "NONE";
})(GenderType || (GenderType = {}));
var GeneralSearchFeatureType;
(function(GeneralSearchFeatureType) {
    GeneralSearchFeatureType["DietInjection"] = "DIET_INJECTION";
    GeneralSearchFeatureType["EmergencyContraceptive"] = "EMERGENCY_CONTRACEPTIVE";
    GeneralSearchFeatureType["FindPharmacy"] = "FIND_PHARMACY";
})(GeneralSearchFeatureType || (GeneralSearchFeatureType = {}));
var GeneralSearchSnippetType;
(function(GeneralSearchSnippetType) {
    GeneralSearchSnippetType["DeliveryGuide"] = "DELIVERY_GUIDE";
    GeneralSearchSnippetType["FaceToFaceDiagnosis"] = "FACE_TO_FACE_DIAGNOSIS";
    GeneralSearchSnippetType["FaceToFacePrescription"] = "FACE_TO_FACE_PRESCRIPTION";
    GeneralSearchSnippetType["NonFaceToFaceDiagnosis"] = "NON_FACE_TO_FACE_DIAGNOSIS";
    GeneralSearchSnippetType["NonFaceToFacePrescription"] = "NON_FACE_TO_FACE_PRESCRIPTION";
})(GeneralSearchSnippetType || (GeneralSearchSnippetType = {}));
var HealthCheckItemType;
(function(HealthCheckItemType) {
    HealthCheckItemType["AltSgop"] = "ALT_SGOP";
    HealthCheckItemType["AltSgpt"] = "ALT_SGPT";
    HealthCheckItemType["Bmi"] = "BMI";
    HealthCheckItemType["Creatinine"] = "CREATININE";
    HealthCheckItemType["EyeLeft"] = "EYE_LEFT";
    HealthCheckItemType["EyeRight"] = "EYE_RIGHT";
    HealthCheckItemType["Fbs"] = "FBS";
    HealthCheckItemType["Gfr"] = "GFR";
    HealthCheckItemType["Gpt"] = "GPT";
    HealthCheckItemType["HdlCholesterol"] = "HDL_CHOLESTEROL";
    HealthCheckItemType["Hearing"] = "HEARING";
    HealthCheckItemType["Height"] = "HEIGHT";
    HealthCheckItemType["Hemoglobin"] = "HEMOGLOBIN";
    HealthCheckItemType["LdlCholesterol"] = "LDL_CHOLESTEROL";
    HealthCheckItemType["MaximumBloodPressure"] = "MAXIMUM_BLOOD_PRESSURE";
    HealthCheckItemType["MinimumBloodPressure"] = "MINIMUM_BLOOD_PRESSURE";
    HealthCheckItemType["Proteinuria"] = "PROTEINURIA";
    HealthCheckItemType["TotalCholesterol"] = "TOTAL_CHOLESTEROL";
    HealthCheckItemType["Triglyceride"] = "TRIGLYCERIDE";
    HealthCheckItemType["Waist"] = "WAIST";
    HealthCheckItemType["Weight"] = "WEIGHT";
})(HealthCheckItemType || (HealthCheckItemType = {}));
var HealthCheckResultStatus;
(function(HealthCheckResultStatus) {
    HealthCheckResultStatus["Caution"] = "CAUTION";
    HealthCheckResultStatus["Danger"] = "DANGER";
    HealthCheckResultStatus["Normal"] = "NORMAL";
    HealthCheckResultStatus["Uncertain"] = "UNCERTAIN";
})(HealthCheckResultStatus || (HealthCheckResultStatus = {}));
var HealthInsuranceScrapingStatus;
(function(HealthInsuranceScrapingStatus) {
    HealthInsuranceScrapingStatus["Done"] = "DONE";
    HealthInsuranceScrapingStatus["Fail"] = "FAIL";
    HealthInsuranceScrapingStatus["ScrapingProgress"] = "SCRAPING_PROGRESS";
    HealthInsuranceScrapingStatus["SimpleAuthRequested"] = "SIMPLE_AUTH_REQUESTED";
})(HealthInsuranceScrapingStatus || (HealthInsuranceScrapingStatus = {}));
var HealthInsuranceSimpleAuthType;
(function(HealthInsuranceSimpleAuthType) {
    HealthInsuranceSimpleAuthType["Kakaotalk"] = "KAKAOTALK";
    HealthInsuranceSimpleAuthType["KbMobile"] = "KB_MOBILE";
    HealthInsuranceSimpleAuthType["Naver"] = "NAVER";
    HealthInsuranceSimpleAuthType["Passauth"] = "PASSAUTH";
    HealthInsuranceSimpleAuthType["Payco"] = "PAYCO";
    HealthInsuranceSimpleAuthType["Samsungpass"] = "SAMSUNGPASS";
    HealthInsuranceSimpleAuthType["Shinhan"] = "SHINHAN";
    HealthInsuranceSimpleAuthType["Toss"] = "TOSS";
})(HealthInsuranceSimpleAuthType || (HealthInsuranceSimpleAuthType = {}));
var HealthRecordSource;
(function(HealthRecordSource) {
    HealthRecordSource["HealthCheck"] = "HEALTH_CHECK";
    HealthRecordSource["Record"] = "RECORD";
})(HealthRecordSource || (HealthRecordSource = {}));
var HealthRecordType;
(function(HealthRecordType) {
    HealthRecordType["Anemia"] = "ANEMIA";
    HealthRecordType["BloodPressure"] = "BLOOD_PRESSURE";
    HealthRecordType["BloodSugar"] = "BLOOD_SUGAR";
    HealthRecordType["BodyInfo"] = "BODY_INFO";
    HealthRecordType["LiverFunction"] = "LIVER_FUNCTION";
})(HealthRecordType || (HealthRecordType = {}));
var HistoryTakingStatus;
(function(HistoryTakingStatus) {
    HistoryTakingStatus["RequestCanceled"] = "REQUEST_CANCELED";
    HistoryTakingStatus["Submitted"] = "SUBMITTED";
    HistoryTakingStatus["SubmitRequested"] = "SUBMIT_REQUESTED";
})(HistoryTakingStatus || (HistoryTakingStatus = {}));
var HomeBannerActionUrlType;
(function(HomeBannerActionUrlType) {
    HomeBannerActionUrlType["App"] = "APP";
    HomeBannerActionUrlType["Web"] = "WEB";
})(HomeBannerActionUrlType || (HomeBannerActionUrlType = {}));
var HomeBannerImageUrlType;
(function(HomeBannerImageUrlType) {
    HomeBannerImageUrlType["Mobile"] = "MOBILE";
    HomeBannerImageUrlType["Pc"] = "PC";
})(HomeBannerImageUrlType || (HomeBannerImageUrlType = {}));
var HomeGreetingMessagePhraseType;
(function(HomeGreetingMessagePhraseType) {
    HomeGreetingMessagePhraseType["Highlighted"] = "HIGHLIGHTED";
    HomeGreetingMessagePhraseType["Plain"] = "PLAIN";
})(HomeGreetingMessagePhraseType || (HomeGreetingMessagePhraseType = {}));
var HospitalFilterType;
(function(HospitalFilterType) {
    HospitalFilterType["Bookable"] = "BOOKABLE";
    HospitalFilterType["HasMedicinePrice"] = "HAS_MEDICINE_PRICE";
    HospitalFilterType["NightOperating"] = "NIGHT_OPERATING";
    HospitalFilterType["Operating"] = "OPERATING";
    HospitalFilterType["PrescriptionUnit"] = "PRESCRIPTION_UNIT";
    HospitalFilterType["RegionByDepth"] = "REGION_BY_DEPTH";
    HospitalFilterType["Specialist"] = "SPECIALIST";
})(HospitalFilterType || (HospitalFilterType = {}));
var HospitalOnBoardingStatus;
(function(HospitalOnBoardingStatus) {
    HospitalOnBoardingStatus["BreakTimes"] = "BREAK_TIMES";
    HospitalOnBoardingStatus["Completed"] = "COMPLETED";
    HospitalOnBoardingStatus["DepartmentGroups"] = "DEPARTMENT_GROUPS";
    HospitalOnBoardingStatus["OperationTimes"] = "OPERATION_TIMES";
    HospitalOnBoardingStatus["RegularHolidays"] = "REGULAR_HOLIDAYS";
})(HospitalOnBoardingStatus || (HospitalOnBoardingStatus = {}));
var HospitalOperatingStatus;
(function(HospitalOperatingStatus) {
    HospitalOperatingStatus["Closed"] = "CLOSED";
    HospitalOperatingStatus["DayOff"] = "DAY_OFF";
    HospitalOperatingStatus["Lunch"] = "LUNCH";
    HospitalOperatingStatus["Open"] = "OPEN";
    HospitalOperatingStatus["Unknown"] = "UNKNOWN";
})(HospitalOperatingStatus || (HospitalOperatingStatus = {}));
var HospitalPartnershipStatus;
(function(HospitalPartnershipStatus) {
    HospitalPartnershipStatus["NonPartnership"] = "NON_PARTNERSHIP";
    HospitalPartnershipStatus["Partnership"] = "PARTNERSHIP";
    HospitalPartnershipStatus["Pending"] = "PENDING";
})(HospitalPartnershipStatus || (HospitalPartnershipStatus = {}));
var HospitalSearchPortalType;
(function(HospitalSearchPortalType) {
    HospitalSearchPortalType["Naver"] = "NAVER";
})(HospitalSearchPortalType || (HospitalSearchPortalType = {}));
var HospitalSortType;
(function(HospitalSortType) {
    HospitalSortType["Accuracy"] = "ACCURACY";
    HospitalSortType["Distance"] = "DISTANCE";
    HospitalSortType["NonBenefitPrice"] = "NON_BENEFIT_PRICE";
    HospitalSortType["ReviewAverageRating"] = "REVIEW_AVERAGE_RATING";
    HospitalSortType["ReviewCount"] = "REVIEW_COUNT";
})(HospitalSortType || (HospitalSortType = {}));
var HotKeywordSortType;
(function(HotKeywordSortType) {
    HotKeywordSortType["Recommendation"] = "RECOMMENDATION";
})(HotKeywordSortType || (HotKeywordSortType = {}));
var InHospitalDeliveryCategoryType;
(function(InHospitalDeliveryCategoryType) {
    InHospitalDeliveryCategoryType["Pickup"] = "PICKUP";
    InHospitalDeliveryCategoryType["Post"] = "POST";
    InHospitalDeliveryCategoryType["Quick"] = "QUICK";
})(InHospitalDeliveryCategoryType || (InHospitalDeliveryCategoryType = {}));
var InflowType;
(function(InflowType) {
    InflowType["Default"] = "DEFAULT";
    InflowType["NonBenefit"] = "NON_BENEFIT";
})(InflowType || (InflowType = {}));
var InvitationCodeType;
(function(InvitationCodeType) {
    InvitationCodeType["FriendInvitation"] = "FRIEND_INVITATION";
    InvitationCodeType["None"] = "NONE";
})(InvitationCodeType || (InvitationCodeType = {}));
var KoreaAddressDongType;
(function(KoreaAddressDongType) {
    KoreaAddressDongType["Administration"] = "ADMINISTRATION";
    KoreaAddressDongType["Legal"] = "LEGAL";
})(KoreaAddressDongType || (KoreaAddressDongType = {}));
var LiverFunctionStatus;
(function(LiverFunctionStatus) {
    LiverFunctionStatus["Danger"] = "DANGER";
    LiverFunctionStatus["Normal"] = "NORMAL";
    LiverFunctionStatus["Warning"] = "WARNING";
})(LiverFunctionStatus || (LiverFunctionStatus = {}));
var LoginResponseType;
(function(LoginResponseType) {
    LoginResponseType["NeedSignUp"] = "NEED_SIGN_UP";
    LoginResponseType["SigninFail"] = "SIGNIN_FAIL";
    LoginResponseType["Success"] = "SUCCESS";
})(LoginResponseType || (LoginResponseType = {}));
var LoginType;
(function(LoginType) {
    LoginType["Doctornow"] = "DOCTORNOW";
    LoginType["Oauth"] = "OAUTH";
})(LoginType || (LoginType = {}));
var LottieOnDiagnosisListAtUserApp;
(function(LottieOnDiagnosisListAtUserApp) {
    LottieOnDiagnosisListAtUserApp["InProgress"] = "IN_PROGRESS";
})(LottieOnDiagnosisListAtUserApp || (LottieOnDiagnosisListAtUserApp = {}));
var MagazineContentType;
(function(MagazineContentType) {
    MagazineContentType["Article"] = "ARTICLE";
    MagazineContentType["Faq"] = "FAQ";
})(MagazineContentType || (MagazineContentType = {}));
var MainFunction;
(function(MainFunction) {
    MainFunction["Antioxidation"] = "ANTIOXIDATION";
    MainFunction["BloodCirculation"] = "BLOOD_CIRCULATION";
    MainFunction["BloodPressure"] = "BLOOD_PRESSURE";
    MainFunction["BloodSugar"] = "BLOOD_SUGAR";
    MainFunction["BodyFat"] = "BODY_FAT";
    MainFunction["Bone"] = "BONE";
    MainFunction["BoneJoint"] = "BONE_JOINT";
    MainFunction["Cholesterol"] = "CHOLESTEROL";
    MainFunction["Eye"] = "EYE";
    MainFunction["FatigueImprovement"] = "FATIGUE_IMPROVEMENT";
    MainFunction["Gut"] = "GUT";
    MainFunction["Immunity"] = "IMMUNITY";
    MainFunction["Iron"] = "IRON";
    MainFunction["MaleGenital"] = "MALE_GENITAL";
    MainFunction["Memory"] = "MEMORY";
    MainFunction["Metabolism"] = "METABOLISM";
    MainFunction["Skin"] = "SKIN";
    MainFunction["Sleep"] = "SLEEP";
    MainFunction["Stomach"] = "STOMACH";
    MainFunction["Stress"] = "STRESS";
    MainFunction["Vitality"] = "VITALITY";
})(MainFunction || (MainFunction = {}));
var MedicalCategoryIconType;
(function(MedicalCategoryIconType) {
    MedicalCategoryIconType["Animation"] = "ANIMATION";
    MedicalCategoryIconType["PlainImage"] = "PLAIN_IMAGE";
})(MedicalCategoryIconType || (MedicalCategoryIconType = {}));
var MedicalCategorySortType;
(function(MedicalCategorySortType) {
    MedicalCategorySortType["Alphabet"] = "ALPHABET";
    MedicalCategorySortType["Recommendation"] = "RECOMMENDATION";
})(MedicalCategorySortType || (MedicalCategorySortType = {}));
var MedicalCategoryType;
(function(MedicalCategoryType) {
    MedicalCategoryType["Department"] = "DEPARTMENT";
    MedicalCategoryType["Treatment"] = "TREATMENT";
    MedicalCategoryType["Vaccination"] = "VACCINATION";
})(MedicalCategoryType || (MedicalCategoryType = {}));
var MedicalFacilityTreatmentType;
(function(MedicalFacilityTreatmentType) {
    MedicalFacilityTreatmentType["DentalOutpatientClinic"] = "DentalOutpatientClinic";
    MedicalFacilityTreatmentType["Etc"] = "ETC";
    MedicalFacilityTreatmentType["GeneralHospitalization"] = "GeneralHospitalization";
    MedicalFacilityTreatmentType["GeneralOutpatientClinic"] = "GeneralOutpatientClinic";
    MedicalFacilityTreatmentType["PrescriptionPreparation"] = "PrescriptionPreparation";
})(MedicalFacilityTreatmentType || (MedicalFacilityTreatmentType = {}));
var MedicineApprovalType;
(function(MedicineApprovalType) {
    MedicineApprovalType["General"] = "GENERAL";
    MedicineApprovalType["PrescriptionBased"] = "PRESCRIPTION_BASED";
})(MedicineApprovalType || (MedicineApprovalType = {}));
var MedicineBenefitType;
(function(MedicineBenefitType) {
    MedicineBenefitType["Benefit"] = "BENEFIT";
    MedicineBenefitType["NonBenefit"] = "NON_BENEFIT";
})(MedicineBenefitType || (MedicineBenefitType = {}));
var MedicineDictionarySortType;
(function(MedicineDictionarySortType) {
    MedicineDictionarySortType["Name"] = "NAME";
    MedicineDictionarySortType["Score"] = "SCORE";
})(MedicineDictionarySortType || (MedicineDictionarySortType = {}));
var MedicineDispensabilityStatus;
(function(MedicineDispensabilityStatus) {
    MedicineDispensabilityStatus["CheckRequired"] = "CHECK_REQUIRED";
    MedicineDispensabilityStatus["SoldBefore"] = "SOLD_BEFORE";
    MedicineDispensabilityStatus["StockConfirmed"] = "STOCK_CONFIRMED";
})(MedicineDispensabilityStatus || (MedicineDispensabilityStatus = {}));
var MedicineStandardType;
(function(MedicineStandardType) {
    MedicineStandardType["Box"] = "BOX";
    MedicineStandardType["Capsule"] = "CAPSULE";
    MedicineStandardType["Ea"] = "EA";
    MedicineStandardType["Pen"] = "PEN";
    MedicineStandardType["Tablet"] = "TABLET";
    MedicineStandardType["Tube"] = "TUBE";
})(MedicineStandardType || (MedicineStandardType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var MissionType;
(function(MissionType) {
    MissionType["AdWatch"] = "AD_WATCH";
    MissionType["AttendanceCheck"] = "ATTENDANCE_CHECK";
    MissionType["MagazineRead"] = "MAGAZINE_READ";
    MissionType["PedometerLevel_1"] = "PEDOMETER_LEVEL_1";
    MissionType["PedometerLevel_2"] = "PEDOMETER_LEVEL_2";
    MissionType["PedometerLevel_3"] = "PEDOMETER_LEVEL_3";
    MissionType["PedometerLevel_4"] = "PEDOMETER_LEVEL_4";
    MissionType["PedometerLevel_5"] = "PEDOMETER_LEVEL_5";
    MissionType["QnaRead"] = "QNA_READ";
    MissionType["QuizSolve"] = "QUIZ_SOLVE";
    MissionType["QuizSolve_1"] = "QUIZ_SOLVE_1";
    MissionType["QuizSolve_4"] = "QUIZ_SOLVE_4";
    MissionType["QuizSolve_6"] = "QUIZ_SOLVE_6";
    MissionType["TodayMissionAllComplete"] = "TODAY_MISSION_ALL_COMPLETE";
})(MissionType || (MissionType = {}));
var NonBenefitCategoryMedicalNameType;
(function(NonBenefitCategoryMedicalNameType) {
    NonBenefitCategoryMedicalNameType["Acne"] = "Acne";
    NonBenefitCategoryMedicalNameType["Alopecia"] = "Alopecia";
    NonBenefitCategoryMedicalNameType["Cataract"] = "Cataract";
    NonBenefitCategoryMedicalNameType["Diet"] = "Diet";
    NonBenefitCategoryMedicalNameType["ErectileDysfunction"] = "Erectile_dysfunction";
    NonBenefitCategoryMedicalNameType["Gardasil"] = "Gardasil";
    NonBenefitCategoryMedicalNameType["Influenza"] = "Influenza";
    NonBenefitCategoryMedicalNameType["VisionCorrection"] = "Vision_Correction";
})(NonBenefitCategoryMedicalNameType || (NonBenefitCategoryMedicalNameType = {}));
var NonBenefitItemUnitType;
(function(NonBenefitItemUnitType) {
    NonBenefitItemUnitType["Count"] = "COUNT";
    NonBenefitItemUnitType["Day"] = "DAY";
    NonBenefitItemUnitType["Ea"] = "EA";
    NonBenefitItemUnitType["Month"] = "MONTH";
    NonBenefitItemUnitType["Pen"] = "PEN";
    NonBenefitItemUnitType["Pill"] = "PILL";
    NonBenefitItemUnitType["Po"] = "PO";
    NonBenefitItemUnitType["Tablet"] = "TABLET";
    NonBenefitItemUnitType["Times"] = "TIMES";
    NonBenefitItemUnitType["Week"] = "WEEK";
})(NonBenefitItemUnitType || (NonBenefitItemUnitType = {}));
var NoticeAccountType;
(function(NoticeAccountType) {
    NoticeAccountType["Admin"] = "ADMIN";
    NoticeAccountType["Doctor"] = "DOCTOR";
    NoticeAccountType["Hospital"] = "HOSPITAL";
    NoticeAccountType["Pharmacist"] = "PHARMACIST";
    NoticeAccountType["User"] = "USER";
})(NoticeAccountType || (NoticeAccountType = {}));
var NoticeCategoryType;
(function(NoticeCategoryType) {
    NoticeCategoryType["Notice"] = "NOTICE";
    NoticeCategoryType["Update"] = "UPDATE";
})(NoticeCategoryType || (NoticeCategoryType = {}));
var NoticeType;
(function(NoticeType) {
    NoticeType["Normal"] = "NORMAL";
    NoticeType["Popup"] = "POPUP";
    NoticeType["Rolling"] = "ROLLING";
})(NoticeType || (NoticeType = {}));
var NowPartnershipStatus;
(function(NowPartnershipStatus) {
    NowPartnershipStatus["AcceptedByAdminAndBeforeStarterPackagePurchase"] = "ACCEPTED_BY_ADMIN_AND_BEFORE_STARTER_PACKAGE_PURCHASE";
    NowPartnershipStatus["None"] = "NONE";
    NowPartnershipStatus["NowPartnershipApproved"] = "NOW_PARTNERSHIP_APPROVED";
    NowPartnershipStatus["NowPartnershipRequestedByPharmacy"] = "NOW_PARTNERSHIP_REQUESTED_BY_PHARMACY";
})(NowPartnershipStatus || (NowPartnershipStatus = {}));
var OrderCancelReasonCategory;
(function(OrderCancelReasonCategory) {
    OrderCancelReasonCategory["PharmacyCancel"] = "PHARMACY_CANCEL";
    OrderCancelReasonCategory["UserCancelAtNonPartnership"] = "USER_CANCEL_AT_NON_PARTNERSHIP";
    OrderCancelReasonCategory["UserCancelAtPartnership"] = "USER_CANCEL_AT_PARTNERSHIP";
})(OrderCancelReasonCategory || (OrderCancelReasonCategory = {}));
var OrderCancelReasonType;
(function(OrderCancelReasonType) {
    OrderCancelReasonType["AdditionalOrderProductNoStock"] = "ADDITIONAL_ORDER_PRODUCT_NO_STOCK";
    OrderCancelReasonType["AnotherPharmacySelectionByUser"] = "ANOTHER_PHARMACY_SELECTION_BY_USER";
    OrderCancelReasonType["CustomerService"] = "CUSTOMER_SERVICE";
    OrderCancelReasonType["DistanceTooFar"] = "DISTANCE_TOO_FAR";
    OrderCancelReasonType["HourPassed"] = "HOUR_PASSED";
    OrderCancelReasonType["IllegalNumber"] = "ILLEGAL_NUMBER";
    OrderCancelReasonType["InitByAdmin"] = "INIT_BY_ADMIN";
    OrderCancelReasonType["InitByPharmacist"] = "INIT_BY_PHARMACIST";
    OrderCancelReasonType["InvalidFaxNumber"] = "INVALID_FAX_NUMBER";
    OrderCancelReasonType["MedicineNonSubstitutable"] = "MEDICINE_NON_SUBSTITUTABLE";
    OrderCancelReasonType["NotEligibleForDelivery"] = "NOT_ELIGIBLE_FOR_DELIVERY";
    OrderCancelReasonType["NoAlternativeDispense"] = "NO_ALTERNATIVE_DISPENSE";
    OrderCancelReasonType["NoDrugs"] = "NO_DRUGS";
    OrderCancelReasonType["NoResponse"] = "NO_RESPONSE";
    OrderCancelReasonType["NoStock"] = "NO_STOCK";
    OrderCancelReasonType["Other"] = "OTHER";
    OrderCancelReasonType["PatientRejectedAlternative"] = "PATIENT_REJECTED_ALTERNATIVE";
    OrderCancelReasonType["PaymentOverdue"] = "PAYMENT_OVERDUE";
    OrderCancelReasonType["PharmacistDirect"] = "PHARMACIST_DIRECT";
    OrderCancelReasonType["PharmacyNoAnswer"] = "PHARMACY_NO_ANSWER";
    OrderCancelReasonType["PharmacySkipByUser"] = "PHARMACY_SKIP_BY_USER";
    OrderCancelReasonType["PrescriptionAlreadyUsed"] = "PRESCRIPTION_ALREADY_USED";
    OrderCancelReasonType["PrescriptionChanged"] = "PRESCRIPTION_CHANGED";
    OrderCancelReasonType["PrescriptionRejected"] = "PRESCRIPTION_REJECTED";
    OrderCancelReasonType["PriceTooHigh"] = "PRICE_TOO_HIGH";
    OrderCancelReasonType["Reject"] = "REJECT";
    OrderCancelReasonType["ReturnToPreviousPharmacyByUser"] = "RETURN_TO_PREVIOUS_PHARMACY_BY_USER";
    OrderCancelReasonType["SlowResponse"] = "SLOW_RESPONSE";
    OrderCancelReasonType["TemporaryNoStock"] = "TEMPORARY_NO_STOCK";
    OrderCancelReasonType["UserDirect"] = "USER_DIRECT";
    OrderCancelReasonType["ValidityExpired"] = "VALIDITY_EXPIRED";
})(OrderCancelReasonType || (OrderCancelReasonType = {}));
var OrderPaymentStatus;
(function(OrderPaymentStatus) {
    OrderPaymentStatus["Cancel"] = "CANCEL";
    OrderPaymentStatus["Done"] = "DONE";
    OrderPaymentStatus["Fail"] = "FAIL";
    OrderPaymentStatus["None"] = "NONE";
    OrderPaymentStatus["Ready"] = "READY";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Cancel"] = "CANCEL";
    OrderStatus["Done"] = "DONE";
    OrderStatus["None"] = "NONE";
    OrderStatus["Progress"] = "PROGRESS";
    OrderStatus["Ready"] = "READY";
})(OrderStatus || (OrderStatus = {}));
var OrderType;
(function(OrderType) {
    OrderType["Dawn"] = "DAWN";
    OrderType["Delivery"] = "DELIVERY";
    OrderType["PartnershipPickup"] = "PARTNERSHIP_PICKUP";
    OrderType["Pickup"] = "PICKUP";
    OrderType["Post"] = "POST";
    OrderType["Quick"] = "QUICK";
})(OrderType || (OrderType = {}));
var OverallCounselingScheduleStatus;
(function(OverallCounselingScheduleStatus) {
    OverallCounselingScheduleStatus["Bookable"] = "BOOKABLE";
    OverallCounselingScheduleStatus["FullyBooked"] = "FULLY_BOOKED";
})(OverallCounselingScheduleStatus || (OverallCounselingScheduleStatus = {}));
var PatientGender;
(function(PatientGender) {
    PatientGender["Female"] = "FEMALE";
    PatientGender["Male"] = "MALE";
    PatientGender["None"] = "NONE";
})(PatientGender || (PatientGender = {}));
var PatientNotificationType;
(function(PatientNotificationType) {
    PatientNotificationType["CallUp"] = "CALL_UP";
    PatientNotificationType["HistoryTaking"] = "HISTORY_TAKING";
})(PatientNotificationType || (PatientNotificationType = {}));
var PayCompany;
(function(PayCompany) {
    PayCompany["Inisis"] = "INISIS";
    PayCompany["Kakaopay"] = "KAKAOPAY";
    PayCompany["NaverPay"] = "NAVER_PAY";
    PayCompany["Payple"] = "PAYPLE";
    PayCompany["TossPg"] = "TOSS_PG";
})(PayCompany || (PayCompany = {}));
var PaymentTotalStatus;
(function(PaymentTotalStatus) {
    PaymentTotalStatus["AllCancelled"] = "ALL_CANCELLED";
    PaymentTotalStatus["Paid"] = "PAID";
    PaymentTotalStatus["PartialCancelled"] = "PARTIAL_CANCELLED";
    PaymentTotalStatus["PayFailed"] = "PAY_FAILED";
    PaymentTotalStatus["Pending"] = "PENDING";
})(PaymentTotalStatus || (PaymentTotalStatus = {}));
var PeriodType;
(function(PeriodType) {
    PeriodType["Daily"] = "DAILY";
    PeriodType["Lifetime"] = "LIFETIME";
    PeriodType["Monthly"] = "MONTHLY";
    PeriodType["Weekly"] = "WEEKLY";
})(PeriodType || (PeriodType = {}));
var PersonalizedNutritionAggregateStatus;
(function(PersonalizedNutritionAggregateStatus) {
    PersonalizedNutritionAggregateStatus["BeforeSurvey"] = "BEFORE_SURVEY";
    PersonalizedNutritionAggregateStatus["CounselingBookConfirmed"] = "COUNSELING_BOOK_CONFIRMED";
    PersonalizedNutritionAggregateStatus["CounselingBookRequested"] = "COUNSELING_BOOK_REQUESTED";
    PersonalizedNutritionAggregateStatus["CounselingCancelled"] = "COUNSELING_CANCELLED";
    PersonalizedNutritionAggregateStatus["CounselingCompleted"] = "COUNSELING_COMPLETED";
    PersonalizedNutritionAggregateStatus["CounselingProgress"] = "COUNSELING_PROGRESS";
    PersonalizedNutritionAggregateStatus["SubscriptionCancelled"] = "SUBSCRIPTION_CANCELLED";
    PersonalizedNutritionAggregateStatus["SubscriptionCompleted"] = "SUBSCRIPTION_COMPLETED";
    PersonalizedNutritionAggregateStatus["SubscriptionNoOrderInProgress"] = "SUBSCRIPTION_NO_ORDER_IN_PROGRESS";
    PersonalizedNutritionAggregateStatus["SubscriptionOrderInProgressPayFailed"] = "SUBSCRIPTION_ORDER_IN_PROGRESS_PAY_FAILED";
    PersonalizedNutritionAggregateStatus["SubscriptionProgress"] = "SUBSCRIPTION_PROGRESS";
    PersonalizedNutritionAggregateStatus["SurveyCompleted"] = "SURVEY_COMPLETED";
})(PersonalizedNutritionAggregateStatus || (PersonalizedNutritionAggregateStatus = {}));
var PharmacyFilterMode;
(function(PharmacyFilterMode) {
    PharmacyFilterMode["List"] = "LIST";
    PharmacyFilterMode["Range"] = "RANGE";
    PharmacyFilterMode["Toggle"] = "TOGGLE";
})(PharmacyFilterMode || (PharmacyFilterMode = {}));
var PharmacyFilterType;
(function(PharmacyFilterType) {
    PharmacyFilterType["ConfirmedDispensation"] = "CONFIRMED_DISPENSATION";
    PharmacyFilterType["DispensationProbability"] = "DISPENSATION_PROBABILITY";
    PharmacyFilterType["FavoritePharmacy"] = "FAVORITE_PHARMACY";
    PharmacyFilterType["HandlingMedicine"] = "HANDLING_MEDICINE";
    PharmacyFilterType["HighDispensationProbability"] = "HIGH_DISPENSATION_PROBABILITY";
    PharmacyFilterType["IncludeDiagnosisPrice"] = "INCLUDE_DIAGNOSIS_PRICE";
    PharmacyFilterType["IsOpenAtLateNight"] = "IS_OPEN_AT_LATE_NIGHT";
    PharmacyFilterType["IsOpenEveryDay"] = "IS_OPEN_EVERY_DAY";
    PharmacyFilterType["Now"] = "NOW";
    PharmacyFilterType["Operating"] = "OPERATING";
    PharmacyFilterType["Partnership"] = "PARTNERSHIP";
    PharmacyFilterType["PossibleDispensation"] = "POSSIBLE_DISPENSATION";
    PharmacyFilterType["RequestWithApp"] = "REQUEST_WITH_APP";
    PharmacyFilterType["SameMedicine"] = "SAME_MEDICINE";
    PharmacyFilterType["TreatmentMedicine"] = "TREATMENT_MEDICINE";
})(PharmacyFilterType || (PharmacyFilterType = {}));
var PharmacyMatchingHistoryType;
(function(PharmacyMatchingHistoryType) {
    PharmacyMatchingHistoryType["PharmacyCheckPrescriptions"] = "PHARMACY_CHECK_PRESCRIPTIONS";
    PharmacyMatchingHistoryType["PharmacyIssue"] = "PHARMACY_ISSUE";
    PharmacyMatchingHistoryType["PharmacyNoResponse"] = "PHARMACY_NO_RESPONSE";
    PharmacyMatchingHistoryType["PharmacyPriceSet"] = "PHARMACY_PRICE_SET";
    PharmacyMatchingHistoryType["ReservePharmacy"] = "RESERVE_PHARMACY";
    PharmacyMatchingHistoryType["UserCancelledAfterPriceSet"] = "USER_CANCELLED_AFTER_PRICE_SET";
    PharmacyMatchingHistoryType["UserCancelledBeforePriceSet"] = "USER_CANCELLED_BEFORE_PRICE_SET";
})(PharmacyMatchingHistoryType || (PharmacyMatchingHistoryType = {}));
var PharmacyOperationStatusV2;
(function(PharmacyOperationStatusV2) {
    PharmacyOperationStatusV2["Absent"] = "ABSENT";
    PharmacyOperationStatusV2["BeforeOpen"] = "BEFORE_OPEN";
    PharmacyOperationStatusV2["BreakTime"] = "BREAK_TIME";
    PharmacyOperationStatusV2["Closed"] = "CLOSED";
    PharmacyOperationStatusV2["ClosedSoon"] = "CLOSED_SOON";
    PharmacyOperationStatusV2["DayOff"] = "DAY_OFF";
    PharmacyOperationStatusV2["Open"] = "OPEN";
    PharmacyOperationStatusV2["Unknown"] = "UNKNOWN";
})(PharmacyOperationStatusV2 || (PharmacyOperationStatusV2 = {}));
var PharmacyParkingType;
(function(PharmacyParkingType) {
    PharmacyParkingType["Free"] = "FREE";
    PharmacyParkingType["Paid"] = "PAID";
    PharmacyParkingType["Unavailable"] = "UNAVAILABLE";
})(PharmacyParkingType || (PharmacyParkingType = {}));
var PharmacyPartnerShip;
(function(PharmacyPartnerShip) {
    PharmacyPartnerShip["Nonpartnership"] = "nonpartnership";
    PharmacyPartnerShip["Partnership"] = "partnership";
    PharmacyPartnerShip["Pending"] = "pending";
})(PharmacyPartnerShip || (PharmacyPartnerShip = {}));
var PharmacyPartnershipType;
(function(PharmacyPartnershipType) {
    PharmacyPartnershipType["Nonpartnership"] = "nonpartnership";
    PharmacyPartnershipType["Partnership"] = "partnership";
    PharmacyPartnershipType["Pending"] = "pending";
})(PharmacyPartnershipType || (PharmacyPartnershipType = {}));
var PharmacyReviewSortType;
(function(PharmacyReviewSortType) {
    PharmacyReviewSortType["HighRating"] = "HIGH_RATING";
    PharmacyReviewSortType["Newest"] = "NEWEST";
})(PharmacyReviewSortType || (PharmacyReviewSortType = {}));
var PharmacySelectionChangeReasonType;
(function(PharmacySelectionChangeReasonType) {
    PharmacySelectionChangeReasonType["Other"] = "OTHER";
    PharmacySelectionChangeReasonType["OutOfStock"] = "OUT_OF_STOCK";
    PharmacySelectionChangeReasonType["PharmacyNotResponding"] = "PHARMACY_NOT_RESPONDING";
    PharmacySelectionChangeReasonType["PrescriptionRejected"] = "PRESCRIPTION_REJECTED";
})(PharmacySelectionChangeReasonType || (PharmacySelectionChangeReasonType = {}));
var PharmacySortType;
(function(PharmacySortType) {
    PharmacySortType["DispensationProbability"] = "DISPENSATION_PROBABILITY";
    PharmacySortType["Distance"] = "DISTANCE";
    PharmacySortType["HighRating"] = "HIGH_RATING";
    PharmacySortType["LowPrice"] = "LOW_PRICE";
    PharmacySortType["MostReviews"] = "MOST_REVIEWS";
    PharmacySortType["QuickReceipt"] = "QUICK_RECEIPT";
    PharmacySortType["VisitCount"] = "VISIT_COUNT";
})(PharmacySortType || (PharmacySortType = {}));
var PlatformType;
(function(PlatformType) {
    PlatformType["Android"] = "ANDROID";
    PlatformType["Ios"] = "IOS";
    PlatformType["None"] = "NONE";
    PlatformType["Web"] = "WEB";
})(PlatformType || (PlatformType = {}));
var PointEventType;
(function(PointEventType) {
    PointEventType["Cancel"] = "CANCEL";
    PointEventType["Earn"] = "EARN";
    PointEventType["Expire"] = "EXPIRE";
    PointEventType["Return"] = "RETURN";
    PointEventType["Use"] = "USE";
})(PointEventType || (PointEventType = {}));
var PointServiceCodeType;
(function(PointServiceCodeType) {
    PointServiceCodeType["CommerceOrderPointUse"] = "COMMERCE_ORDER_POINT_USE";
    PointServiceCodeType["CorrectDailyOxQuizAnswer"] = "CORRECT_DAILY_OX_QUIZ_ANSWER";
    PointServiceCodeType["CorrectDailyOxQuizAnswerV2"] = "CORRECT_DAILY_OX_QUIZ_ANSWER_V2";
    PointServiceCodeType["DailyExpiration"] = "DAILY_EXPIRATION";
    PointServiceCodeType["DailyOxQuizBonusRewardPoint"] = "DAILY_OX_QUIZ_BONUS_REWARD_POINT";
    PointServiceCodeType["DoseRecordMission"] = "DOSE_RECORD_MISSION";
    PointServiceCodeType["Event"] = "EVENT";
    PointServiceCodeType["ExchangePoint"] = "EXCHANGE_POINT";
    PointServiceCodeType["FriendInvitation"] = "FRIEND_INVITATION";
    PointServiceCodeType["HealthRecordMission"] = "HEALTH_RECORD_MISSION";
    PointServiceCodeType["NonFaceToFaceDiagnosisNonBenefitDiagnosisUse"] = "NON_FACE_TO_FACE_DIAGNOSIS_NON_BENEFIT_DIAGNOSIS_USE";
    PointServiceCodeType["NonFaceToFaceDiagnosisNonBenefitDiagnosisUseReturn"] = "NON_FACE_TO_FACE_DIAGNOSIS_NON_BENEFIT_DIAGNOSIS_USE_RETURN";
    PointServiceCodeType["NonFaceToFaceDiagnosisReviewEvent"] = "NON_FACE_TO_FACE_DIAGNOSIS_REVIEW_EVENT";
    PointServiceCodeType["OnboardingPoint"] = "ONBOARDING_POINT";
    PointServiceCodeType["OrderPointUse"] = "ORDER_POINT_USE";
    PointServiceCodeType["OrderPointUseReturn"] = "ORDER_POINT_USE_RETURN";
    PointServiceCodeType["PedometerMission"] = "PEDOMETER_MISSION";
    PointServiceCodeType["PersonalizedNutritionPreBooking"] = "PERSONALIZED_NUTRITION_PRE_BOOKING";
    PointServiceCodeType["PersonalizedNutritionReviewEvent"] = "PERSONALIZED_NUTRITION_REVIEW_EVENT";
    PointServiceCodeType["QuestionPointUse"] = "QUESTION_POINT_USE";
    PointServiceCodeType["UserPaymentRegisterTossPgReward"] = "USER_PAYMENT_REGISTER_TOSS_PG_REWARD";
    PointServiceCodeType["WritePharmacyReviewWithReceipt"] = "WRITE_PHARMACY_REVIEW_WITH_RECEIPT";
})(PointServiceCodeType || (PointServiceCodeType = {}));
var PrescriptionDispensingType;
(function(PrescriptionDispensingType) {
    PrescriptionDispensingType["InHospital"] = "IN_HOSPITAL";
    PrescriptionDispensingType["OutHospital"] = "OUT_HOSPITAL";
})(PrescriptionDispensingType || (PrescriptionDispensingType = {}));
var PrizeType;
(function(PrizeType) {
    PrizeType["DoctornowPoint"] = "DOCTORNOW_POINT";
    PrizeType["Gifticon"] = "GIFTICON";
    PrizeType["Manual"] = "MANUAL";
})(PrizeType || (PrizeType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["Department"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var ProviderType;
(function(ProviderType) {
    ProviderType["Apple"] = "APPLE";
    ProviderType["Doctornow"] = "DOCTORNOW";
    ProviderType["Kakao"] = "KAKAO";
    ProviderType["Naver"] = "NAVER";
})(ProviderType || (ProviderType = {}));
var QnaAnswerReviewTagExposureType;
(function(QnaAnswerReviewTagExposureType) {
    QnaAnswerReviewTagExposureType["Always"] = "ALWAYS";
    QnaAnswerReviewTagExposureType["Negative"] = "NEGATIVE";
    QnaAnswerReviewTagExposureType["Positive"] = "POSITIVE";
})(QnaAnswerReviewTagExposureType || (QnaAnswerReviewTagExposureType = {}));
var QuestionAccessibleType;
(function(QuestionAccessibleType) {
    QuestionAccessibleType["All"] = "ALL";
    QuestionAccessibleType["DoctorsAndMe"] = "DOCTORS_AND_ME";
    QuestionAccessibleType["Me"] = "ME";
})(QuestionAccessibleType || (QuestionAccessibleType = {}));
var QuestionAnsweredStatus;
(function(QuestionAnsweredStatus) {
    QuestionAnsweredStatus["Answered"] = "ANSWERED";
    QuestionAnsweredStatus["Answering"] = "ANSWERING";
    QuestionAnsweredStatus["Checking"] = "CHECKING";
})(QuestionAnsweredStatus || (QuestionAnsweredStatus = {}));
var QuestionCategoryType;
(function(QuestionCategoryType) {
    QuestionCategoryType["Department"] = "DEPARTMENT";
    QuestionCategoryType["Life"] = "LIFE";
    QuestionCategoryType["Treatment"] = "TREATMENT";
})(QuestionCategoryType || (QuestionCategoryType = {}));
var QuestionSearchSort;
(function(QuestionSearchSort) {
    QuestionSearchSort["Recent"] = "RECENT";
})(QuestionSearchSort || (QuestionSearchSort = {}));
var QuestionStatus;
(function(QuestionStatus) {
    QuestionStatus["AiAnswered"] = "AI_ANSWERED";
    QuestionStatus["AiAnswerFailed"] = "AI_ANSWER_FAILED";
    QuestionStatus["AiAnswerRequested"] = "AI_ANSWER_REQUESTED";
    QuestionStatus["AwaitingBasicAnswer"] = "AWAITING_BASIC_ANSWER";
    QuestionStatus["AwaitingPremiumAnswer"] = "AWAITING_PREMIUM_ANSWER";
    QuestionStatus["HasBasicAnswer"] = "HAS_BASIC_ANSWER";
    QuestionStatus["PaymentFailed"] = "PAYMENT_FAILED";
    QuestionStatus["PendingPayment"] = "PENDING_PAYMENT";
    QuestionStatus["PremiumAnswered"] = "PREMIUM_ANSWERED";
    QuestionStatus["PremiumAnswering"] = "PREMIUM_ANSWERING";
    QuestionStatus["Refunded"] = "REFUNDED";
})(QuestionStatus || (QuestionStatus = {}));
var QuestionType;
(function(QuestionType) {
    QuestionType["Multi"] = "MULTI";
    QuestionType["Single"] = "SINGLE";
})(QuestionType || (QuestionType = {}));
var QuizBonusType;
(function(QuizBonusType) {
    QuizBonusType["Normal"] = "NORMAL";
    QuizBonusType["WithBonus"] = "WITH_BONUS";
})(QuizBonusType || (QuizBonusType = {}));
var QuizMessageType;
(function(QuizMessageType) {
    QuizMessageType["Highlighted"] = "HIGHLIGHTED";
    QuizMessageType["Plain"] = "PLAIN";
})(QuizMessageType || (QuizMessageType = {}));
var QuizRewardType;
(function(QuizRewardType) {
    QuizRewardType["Point"] = "POINT";
    QuizRewardType["Ticket"] = "TICKET";
})(QuizRewardType || (QuizRewardType = {}));
var QuizStatus;
(function(QuizStatus) {
    QuizStatus["Correct"] = "CORRECT";
    QuizStatus["Expired"] = "EXPIRED";
    QuizStatus["Incorrect"] = "INCORRECT";
    QuizStatus["Pending"] = "PENDING";
    QuizStatus["Solvable"] = "SOLVABLE";
})(QuizStatus || (QuizStatus = {}));
var QuizType;
(function(QuizType) {
    QuizType["Ox"] = "OX";
})(QuizType || (QuizType = {}));
var RawMaterialType;
(function(RawMaterialType) {
    RawMaterialType["FunctionalRawMaterial"] = "FUNCTIONAL_RAW_MATERIAL";
    RawMaterialType["Nutrient"] = "NUTRIENT";
})(RawMaterialType || (RawMaterialType = {}));
var ReasonForLeavingInputType;
(function(ReasonForLeavingInputType) {
    ReasonForLeavingInputType["Select"] = "SELECT";
    ReasonForLeavingInputType["Text"] = "TEXT";
})(ReasonForLeavingInputType || (ReasonForLeavingInputType = {}));
var ReasonForLeavingType;
(function(ReasonForLeavingType) {
    ReasonForLeavingType["Leave"] = "LEAVE";
    ReasonForLeavingType["Signup"] = "SIGNUP";
})(ReasonForLeavingType || (ReasonForLeavingType = {}));
var RecordedTimeType;
(function(RecordedTimeType) {
    RecordedTimeType["BreakfastAfterMeal"] = "BREAKFAST_AFTER_MEAL";
    RecordedTimeType["DinnerAfterMeal"] = "DINNER_AFTER_MEAL";
    RecordedTimeType["EmptyStomach"] = "EMPTY_STOMACH";
    RecordedTimeType["LunchAfterMeal"] = "LUNCH_AFTER_MEAL";
})(RecordedTimeType || (RecordedTimeType = {}));
var ResultType;
(function(ResultType) {
    ResultType["Available"] = "AVAILABLE";
    ResultType["ContainBannedWord"] = "CONTAIN_BANNED_WORD";
    ResultType["Duplication"] = "DUPLICATION";
})(ResultType || (ResultType = {}));
var ReviewCommentHolderType;
(function(ReviewCommentHolderType) {
    ReviewCommentHolderType["Doctor"] = "DOCTOR";
})(ReviewCommentHolderType || (ReviewCommentHolderType = {}));
var ReviewHolderType;
(function(ReviewHolderType) {
    ReviewHolderType["User"] = "USER";
})(ReviewHolderType || (ReviewHolderType = {}));
var ReviewImageType;
(function(ReviewImageType) {
    ReviewImageType["Default"] = "DEFAULT";
    ReviewImageType["Medicine"] = "MEDICINE";
    ReviewImageType["Receipt"] = "RECEIPT";
})(ReviewImageType || (ReviewImageType = {}));
var ReviewReceiverType;
(function(ReviewReceiverType) {
    ReviewReceiverType["Doctor"] = "DOCTOR";
    ReviewReceiverType["Hospital"] = "HOSPITAL";
    ReviewReceiverType["Pharmacy"] = "PHARMACY";
})(ReviewReceiverType || (ReviewReceiverType = {}));
var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["Diagnosis"] = "DIAGNOSIS";
    ReviewTargetType["Order"] = "ORDER";
    ReviewTargetType["QnaAnswer"] = "QNA_ANSWER";
})(ReviewTargetType || (ReviewTargetType = {}));
var RoleType;
(function(RoleType) {
    RoleType["Admin"] = "ADMIN";
    RoleType["Doctor"] = "DOCTOR";
    RoleType["Hospital"] = "HOSPITAL";
    RoleType["Patient"] = "PATIENT";
    RoleType["Pharmacist"] = "PHARMACIST";
    RoleType["Pharmacy"] = "PHARMACY";
    RoleType["Temp"] = "TEMP";
    RoleType["User"] = "USER";
})(RoleType || (RoleType = {}));
var SatisfactionStatus;
(function(SatisfactionStatus) {
    SatisfactionStatus["Dissatisfaction"] = "DISSATISFACTION";
    SatisfactionStatus["Satisfaction"] = "SATISFACTION";
    SatisfactionStatus["Visited"] = "VISITED";
})(SatisfactionStatus || (SatisfactionStatus = {}));
var SellerType;
(function(SellerType) {
    SellerType["Doctornow"] = "DOCTORNOW";
    SellerType["Pharmacy"] = "PHARMACY";
})(SellerType || (SellerType = {}));
var ShipmentStatus;
(function(ShipmentStatus) {
    ShipmentStatus["Canceled"] = "CANCELED";
    ShipmentStatus["Completed"] = "COMPLETED";
    ShipmentStatus["Failed"] = "FAILED";
    ShipmentStatus["Pending"] = "PENDING";
    ShipmentStatus["PickedUp"] = "PICKED_UP";
    ShipmentStatus["Requested"] = "REQUESTED";
})(ShipmentStatus || (ShipmentStatus = {}));
var ShippingCompany;
(function(ShippingCompany) {
    ShippingCompany["Barogo"] = "BAROGO";
    ShippingCompany["BarogoToday"] = "BAROGO_TODAY";
    ShippingCompany["Cj"] = "CJ";
    ShippingCompany["Doobal"] = "DOOBAL";
    ShippingCompany["InsungQuick"] = "INSUNG_QUICK";
    ShippingCompany["KakaoDobo"] = "KAKAO_DOBO";
    ShippingCompany["KakaoQuick"] = "KAKAO_QUICK";
    ShippingCompany["Logen"] = "LOGEN";
    ShippingCompany["Logiall"] = "LOGIALL";
    ShippingCompany["Logispot"] = "LOGISPOT";
    ShippingCompany["Lotte"] = "LOTTE";
    ShippingCompany["ManualQuick"] = "MANUAL_QUICK";
    ShippingCompany["PartnershipPickup"] = "PARTNERSHIP_PICKUP";
    ShippingCompany["Pickup"] = "PICKUP";
    ShippingCompany["PostOffice"] = "POST_OFFICE";
    ShippingCompany["TeamFresh"] = "TEAM_FRESH";
    ShippingCompany["Todaypickup"] = "TODAYPICKUP";
    ShippingCompany["Vroong"] = "VROONG";
    ShippingCompany["VroongDawn"] = "VROONG_DAWN";
    ShippingCompany["Yongma"] = "YONGMA";
})(ShippingCompany || (ShippingCompany = {}));
var SignupPath;
(function(SignupPath) {
    SignupPath["Blog"] = "BLOG";
    SignupPath["Community"] = "COMMUNITY";
    SignupPath["DoctornowHomepage"] = "DOCTORNOW_HOMEPAGE";
    SignupPath["Etc"] = "ETC";
    SignupPath["FriendRecommendation"] = "FRIEND_RECOMMENDATION";
    SignupPath["Hospital"] = "HOSPITAL";
    SignupPath["Instagram"] = "INSTAGRAM";
    SignupPath["MedicalFacilityAdvertisement"] = "MEDICAL_FACILITY_ADVERTISEMENT";
    SignupPath["MedicalFacilityStaffGuide"] = "MEDICAL_FACILITY_STAFF_GUIDE";
    SignupPath["OutdoorAdvertisement"] = "OUTDOOR_ADVERTISEMENT";
    SignupPath["PcMobileAdvertisement"] = "PC_MOBILE_ADVERTISEMENT";
    SignupPath["Pharmacy"] = "PHARMACY";
    SignupPath["PortalSearch"] = "PORTAL_SEARCH";
    SignupPath["Tv"] = "TV";
    SignupPath["Youtube"] = "YOUTUBE";
})(SignupPath || (SignupPath = {}));
var SortType;
(function(SortType) {
    SortType["Asc"] = "ASC";
    SortType["Desc"] = "DESC";
})(SortType || (SortType = {}));
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus["Cancelled"] = "CANCELLED";
    SubscriptionStatus["Completed"] = "COMPLETED";
    SubscriptionStatus["Pending"] = "PENDING";
    SubscriptionStatus["Progress"] = "PROGRESS";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var SubscriptionTermType;
(function(SubscriptionTermType) {
    SubscriptionTermType["Infinite"] = "INFINITE";
    SubscriptionTermType["One"] = "ONE";
})(SubscriptionTermType || (SubscriptionTermType = {}));
var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["PersonalizedNutrition"] = "PERSONALIZED_NUTRITION";
})(SubscriptionType || (SubscriptionType = {}));
var SurveyCategory;
(function(SurveyCategory) {
    SurveyCategory["Food"] = "FOOD";
    SurveyCategory["GeneAnalysis"] = "GENE_ANALYSIS";
    SurveyCategory["Health"] = "HEALTH";
    SurveyCategory["LifeStyle"] = "LIFE_STYLE";
    SurveyCategory["Precaution"] = "PRECAUTION";
})(SurveyCategory || (SurveyCategory = {}));
var TagType;
(function(TagType) {
    TagType["Department"] = "DEPARTMENT";
    TagType["Disease"] = "DISEASE";
    TagType["Free"] = "FREE";
    TagType["Symptom"] = "SYMPTOM";
})(TagType || (TagType = {}));
var TelemedicineEligibleGroupType;
(function(TelemedicineEligibleGroupType) {
    TelemedicineEligibleGroupType["BackwoodsResident"] = "BACKWOODS_RESIDENT";
    TelemedicineEligibleGroupType["InfectiousDiseaseCase"] = "INFECTIOUS_DISEASE_CASE";
    TelemedicineEligibleGroupType["LongTermCareClassifier"] = "LONG_TERM_CARE_CLASSIFIER";
    TelemedicineEligibleGroupType["MedicalVulnerableAreaResident"] = "MEDICAL_VULNERABLE_AREA_RESIDENT";
    TelemedicineEligibleGroupType["Others"] = "OTHERS";
    TelemedicineEligibleGroupType["RegisteredDisabled"] = "REGISTERED_DISABLED";
    TelemedicineEligibleGroupType["Under_18Child"] = "UNDER_18_CHILD";
    TelemedicineEligibleGroupType["VisitedPatient"] = "VISITED_PATIENT";
})(TelemedicineEligibleGroupType || (TelemedicineEligibleGroupType = {}));
var TelemedicineEligibleTargetType;
(function(TelemedicineEligibleTargetType) {
    TelemedicineEligibleTargetType["AlwaysEligible"] = "ALWAYS_ELIGIBLE";
    TelemedicineEligibleTargetType["NightAndHolidayOnly"] = "NIGHT_AND_HOLIDAY_ONLY";
})(TelemedicineEligibleTargetType || (TelemedicineEligibleTargetType = {}));
var TelemedicineEligibleTime;
(function(TelemedicineEligibleTime) {
    TelemedicineEligibleTime["OffHoursOrWeekend"] = "OFF_HOURS_OR_WEEKEND";
    TelemedicineEligibleTime["RegularBusinessHours"] = "REGULAR_BUSINESS_HOURS";
})(TelemedicineEligibleTime || (TelemedicineEligibleTime = {}));
var TelemedicineTargetType;
(function(TelemedicineTargetType) {
    TelemedicineTargetType["AlwaysEligible"] = "ALWAYS_ELIGIBLE";
    TelemedicineTargetType["NightAndHolidayOnly"] = "NIGHT_AND_HOLIDAY_ONLY";
})(TelemedicineTargetType || (TelemedicineTargetType = {}));
var TicketType;
(function(TicketType) {
    TicketType["Basic"] = "BASIC";
})(TicketType || (TicketType = {}));
var TreatmentSearchType;
(function(TreatmentSearchType) {
    TreatmentSearchType["All"] = "ALL";
    TreatmentSearchType["Benefit"] = "BENEFIT";
    TreatmentSearchType["NonBenefit"] = "NON_BENEFIT";
})(TreatmentSearchType || (TreatmentSearchType = {}));
var UserMissionStatus;
(function(UserMissionStatus) {
    UserMissionStatus["Completed"] = "COMPLETED";
    UserMissionStatus["Pending"] = "PENDING";
})(UserMissionStatus || (UserMissionStatus = {}));
var UserPrizeStatus;
(function(UserPrizeStatus) {
    UserPrizeStatus["Drawn"] = "DRAWN";
    UserPrizeStatus["Received"] = "RECEIVED";
})(UserPrizeStatus || (UserPrizeStatus = {}));
var UserProfileRelation;
(function(UserProfileRelation) {
    UserProfileRelation["Children"] = "CHILDREN";
    UserProfileRelation["Me"] = "ME";
    UserProfileRelation["Parents"] = "PARENTS";
    UserProfileRelation["Spouse"] = "SPOUSE";
})(UserProfileRelation || (UserProfileRelation = {}));
var UserProfileType;
(function(UserProfileType) {
    UserProfileType["Family"] = "FAMILY";
    UserProfileType["User"] = "USER";
})(UserProfileType || (UserProfileType = {}));
var VerificationType;
(function(VerificationType) {
    VerificationType["Email"] = "EMAIL";
    VerificationType["Phone"] = "PHONE";
})(VerificationType || (VerificationType = {}));


/***/ }),

/***/ 70138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JR": function() { return /* binding */ DIRECTION; },
/* harmony export */   "NO": function() { return /* binding */ SIZE; },
/* harmony export */   "V_": function() { return /* binding */ BOARD_TYPE; },
/* harmony export */   "Z6": function() { return /* binding */ ROUTES; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "yx": function() { return /* binding */ KAKAOSHARETYPE; }
/* harmony export */ });
/* unused harmony export APP_SCREEN_NAME */
var DIRECTION = {
    TOP: "TOP",
    RIGHT: "RIGHT",
    BOTTOM: "BOTTOM",
    LEFT: "LEFT"
};
var SIZE = {
    LARGE: "large",
    MEDIUM: "medium",
    SMALL: "small"
};
var isServer = "object" === "undefined";
var KAKAOSHARETYPE = {
    QNA: "qna",
    MAGAZINE: "magazine"
};
var BOARD_TYPE = {
    COMMUNITY: "community",
    QNA: "qna",
    MAGAZINE: "magazine",
    DOCTOR_LIST: "doctor_list",
    HOSPITAL_LIST: "hospital_list"
};
// mobile webview
var ROUTES = {
    // 홈
    HOME: {
        pageName: "web_home",
        path: "/",
        appScreenName: "MainScreen"
    },
    // 무엇이든 물어보세요
    QNA: {
        // 무엇이든 물어보세요 홈(/quickAnswer?tab=${tab})
        HOME: {
            pageName: "web_quick_answer",
            path: "/content/qna",
            appScreenName: "QnaMainScreen"
        },
        // 무엇이든 물어보세요 질문 작성
        WRITE: {
            pageName: "web_quick_answer_write",
            path: "/content/qna/write",
            appScreenName: "QnaWriteWebViewScreen"
        },
        // 무엇이든 물어보세요 질문 상세(/quickAnswer/${answerId})
        DETAIL: {
            pageName: "web_quick_answer_detail",
            path: "/content/qna",
            appScreenName: "QnaDetailWebViewScreen"
        },
        // 무엇이든 물어보세요 질문 검색(/quickAnswer/search?keyword=${keyword})
        SEARCH: {
            pageName: "web_search",
            path: "/content/search",
            appScreenName: "CommunicationSearchWebViewScreen"
        },
        // 무엇이든 물어보세요 실시간 질문 페이지(/quickAnswer/category/${categoryId})
        REALTIME: {
            pageName: "web_quick_answer_realtime",
            path: "/content/qna/realtime",
            appScreenName: "QnaListWebViewScreen"
        },
        // 무엇이든 물어보세요 태그 별 리스트 페이지(/quickAnswer/tag/${tagId})
        TAG: {
            pageName: "web_quick_answer_tag_page",
            path: "/content/qna/tag",
            appScreenName: "QnaListByTagWebViewScreen"
        },
        // 무엇이든 물어보세요 핵심 가치 페이지
        SERVICE: {
            pageName: "web_quick_answer_service",
            path: "/content/qna/service",
            appScreenName: "QnaServiceWebViewScreen"
        },
        // 무엇이든 물어보세요 NPS 페이지
        NPS: {
            pageName: "web_quick_answer_nps",
            path: "/content/qna/nps",
            appScreenName: "QnaNpsWebViewScreen"
        },
        // AI 답변 관련 페이지
        AI: {
            pageName: "web_quick_answer_ai_answer",
            path: "/content/qna/ai-answer",
            appScreenName: "QnaAiAnswerWebViewScreen"
        },
        AITITLE: {
            pageName: "web_quick_answer_ai_title",
            path: "/content/qna/ai-title",
            appScreenName: "QnaAiTitleWebViewScreen"
        },
        QNA_PAYMENT: {
            pageName: "web_qna_payment",
            path: function(pid) {
                return "/content/qna/payment/".concat(pid);
            },
            appScreenName: "QnaPaymentWebViewScreen"
        },
        WRITE_ANSWER_REVIEW: {
            pageName: "web_qna_write_answer_review",
            path: function(questionPid, answerPid) {
                return "/content/qna/".concat(questionPid, "/answers/").concat(answerPid, "/reviews/write");
            },
            appScreenName: "QnaAnswerWriteReviewWebViewScreen"
        }
    },
    MAP: {
        // 근처 병원 약국 찾기 화면 (/map?좌표 쿼리 스트링)
        HOME: {
            pageName: "web_map",
            path: "/map",
            appScreenName: ""
        }
    },
    // 건강 매거진
    MAGAZINE: {
        // 건강 매거진 홈
        HOME: {
            pageName: "web_health_tip",
            path: "/content/magazine",
            appScreenName: "MagazineWebViewScreen"
        },
        LIST: {
            pageName: "web_health_tip_list",
            path: "/content/magazine/list",
            appScreenName: "MagazineListWebViewScreen"
        },
        TAG: {
            pageName: "web_health_tip_tag_list",
            path: "/content/magazine/tag",
            appScreenName: "MagazineListByTagWebViewScreen"
        },
        // 건강 매거진 상세
        DETAIL: {
            pageName: "web_health_tip_detail",
            path: "/content/magazine",
            appScreenName: "MagazineDetailWebViewScreen"
        }
    },
    // 건강매거진/FAG 에디터
    AUTHOR: {
        DETAIL: {
            pageName: "web_author_detail",
            path: "/author",
            appScreenName: ""
        }
    },
    // 건강 FAQ
    FAQ: {
        LIST: {
            pageName: "web_faq_content_list",
            path: "/content/faq",
            appScreenName: "FaqListWebViewScreen"
        },
        TAG: {
            pageName: "web_faq_content_tag_list",
            path: "/content/faq/tag",
            appScreenName: "FaqListByTagWebViewScreen"
        },
        DETAIL: {
            pageName: "web_faq_content_detail",
            path: "/content/faq",
            appScreenName: "FaqDetailWebViewScreen"
        }
    },
    // Board
    BOARD: {
        // board 홈
        HOME: {
            pageName: "web_board",
            path: "/content/board",
            appScreenName: "CommunicationMainScreen"
        }
    },
    COMMUNITY: {
        // 커뮤니티 홈
        HOME: {
            pageName: "web_community",
            path: "/content/community",
            appScreenName: ""
        },
        // 커뮤니티 상세
        DETAIL: {
            pageName: "web_community_detail",
            path: "/content/community",
            appScreenName: "CommunityPostDetailWebViewScreen"
        },
        // 커뮤니티 글 리스트
        LIST: {
            pageName: "web_community_list",
            path: "/content/community/list",
            appScreenName: "CommunityPostListWebViewScreen"
        },
        // 커뮤니티 글 작성
        WRITE: {
            pageName: "web_community_write",
            path: "/content/community/write",
            appScreenName: "CommunityPostWriteWebViewScreen"
        },
        // 커뮤니티 프로필 셋팅
        SETTING: {
            pageName: "web_community_setting",
            path: "/content/community/setting",
            appScreenName: "CommunityUserSettingWebViewScreen"
        },
        // 커뮤니티 댓글 상세페이지
        COMMENT: {
            pageName: "web_community_comment",
            path: "/content/community/comment",
            appScreenName: "CommunityCommentDetailWebViewScreen"
        },
        // 커뮤니티 정책 페이지
        POLICY: {
            pageName: "web_community_policy",
            path: "/content/community/policy",
            appScreenName: ""
        }
    },
    COMMON: {
        NPS_COMPLETE: {
            pageName: "web_qna_nps_complete",
            path: "/content/complete?type=QnaNps",
            appScreenName: "QnaCompleteWebViewScreen"
        },
        QNA_WRITE_COMPLETE: {
            pageName: "web_qna_write_complete",
            path: "/content/complete",
            appScreenName: "QnaCompleteWebViewScreen"
        },
        MYPAGE: {
            pageName: "web_mypage",
            path: "/content/mypage",
            appScreenName: "CommunicationMypageWebViewScreen"
        },
        SEARCH: {
            pageName: "web_search",
            path: "/content/search",
            appScreenName: "CommunicationSearchWebViewScreen"
        },
        REPORT: {
            pageName: "web_report",
            path: "/content/report",
            appScreenName: "CommunicationReportWebViewScreen"
        },
        PURE_WEBVIEW: {
            pageName: "web_pure_webview",
            page: "",
            appScreenName: "PureWebViewScreen"
        },
        SPLASH: {
            pageName: "",
            page: "",
            appScreenName: "SplashScreen"
        },
        UPDATE: {
            pageName: "",
            page: "",
            appScreenName: "UpdateScreen"
        }
    },
    BOOKINGS: {
        HOME: {
            pageName: "web_bookings_home",
            path: "/content/bookings",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "web_bookings_detail",
            path: "/content/bookings/",
            appScreenName: ""
        }
    },
    HOSPITAL: {
        HOME: {
            pageName: "web_hospital_list",
            path: "/hospitals",
            appScreenName: "HospitalsWebViewScreen"
        },
        DETAIL: {
            pageName: "web_hospital_detail",
            path: "/hospitals/",
            appScreenName: "HospitalDetailWebViewScreen"
        },
        CATEGORIES: {
            pageName: "web_hospital_categories",
            path: "/hospitals/medical/categories",
            appScreenName: "HospitalMedicalCategoriesWebViewScreen"
        },
        TREATMENTS: {
            pageName: "web_hospital_treatments",
            path: "/hospitals/medical/treatments",
            appScreenName: "HospitalTreatmentsWebViewScreen"
        },
        SEARCH: {
            pageName: "web_hospital_search",
            path: "/hospitals/search",
            appScreenName: "SearchHospitalsWebViewScreen"
        },
        INFLUENZA: {
            pageName: "web_hospital_influenza",
            path: "/hospitals/influenza",
            appScreenName: "InfluenzaHospitalListWebViewScreen"
        },
        EVENT: {
            pageName: "web_hospital_event",
            path: "/hospitals/event",
            appScreenName: "HospitalEventWebViewScreen"
        },
        NEIGHBORHOOD: {
            pageName: "web_hospital_neighborhood",
            path: "/hospitals/neighborhood",
            appScreenName: ""
        }
    },
    WEB_DIAGNOSIS: function(doctorPublicId) {
        return {
            REQUEST: {
                pageName: "web_diagnosis_request",
                path: "/diagnosis/".concat(doctorPublicId, "/request"),
                appScreenName: ""
            },
            REQUEST_USER_INFO: {
                pageName: "web_diagnosis_request_user_info",
                path: "/diagnosis/".concat(doctorPublicId, "/request/userInfo"),
                appScreenName: ""
            },
            SOCIAL_LOGIN: {
                pageName: "web_diagnosis_login",
                path: "/diagnosis/".concat(doctorPublicId, "/request/userLogin"),
                appScreenName: ""
            },
            COMPLETE: {
                pageName: "web_diagnosis_request_completed",
                path: "/diagnosis/".concat(doctorPublicId, "/request/complete"),
                appScreenName: ""
            }
        };
    },
    SEARCH: function(keyword, entryType) {
        return {
            HOME: {
                pageName: "web_search",
                path: "/search".concat(entryType ? "?entryType=".concat(entryType) : ""),
                appScreenName: "SearchWebViewScreen"
            },
            SEARCH_RESULT: {
                pageName: "web_integrate_search_result",
                path: "/search?keyword=".concat(keyword).concat(entryType ? "&entryType=".concat(entryType) : ""),
                appScreenName: "SearchResultWebViewScreen"
            },
            REQUEST_INFO: {
                pageName: "web_search_request_info",
                path: "/search/requestInfo",
                appScreenName: "SearchRequestInfoWebViewScreen"
            },
            REQUEST_DETAIL_INFO: {
                pageName: "web_search_request_detail_info",
                path: "/search/requestDetailInfo",
                appScreenName: "SearchRequestDetailInfoWebViewScreen"
            }
        };
    },
    CRAWLER: {
        HOSPITALS: {
            pageName: "crawler_hospitals",
            path: "/crawler/hospitals",
            appScreenName: ""
        }
    },
    POINT_MARKET: {
        LIST: {
            pageName: "web_point_market_list",
            path: "/pointMarket",
            appScreenName: "PointMarketListWebViewScreen"
        },
        DETAIL: {
            pageName: "web_point_market_detail",
            path: "/pointMarket",
            appScreenName: "PointMarketDetailWebViewScreen"
        },
        HISTORY: {
            pageName: "",
            path: "",
            appScreenName: "PointHistoryScreen"
        },
        CERTIFICATION: {
            pageName: "",
            path: "",
            appScreenName: "CertificationScreen"
        }
    },
    SITEMAP_HOSPITAL: {
        LIST: {
            pageName: "sitemap_hospitals",
            path: "/sitemap/hospital-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_hospital_detail",
            path: "/sitemap/hospital.xml",
            appScreenName: ""
        },
        INFLUENZA_DETAIL: {
            pageName: "sitemap_hospital_influenza_detail",
            path: "/sitemap/influenza.xml",
            appScreenName: ""
        }
    },
    SITEMAP_CONTENT: {
        LIST: {
            pageName: "sitemap_contents",
            path: "/sitemap/content-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_content_detail",
            path: "/sitemap/content.xml",
            appScreenName: ""
        }
    },
    SITEMAP_NON_BENEFIT: {
        LIST: {
            pageName: "sitemap_non_benefits",
            path: "/sitemap/non-benefit-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_non_benefit_detail",
            path: "/sitemap/non-benefit.xml",
            appScreenName: ""
        }
    },
    SITEMAP_TELEMEDICINE: {
        LIST: {
            pageName: "sitemap_telemedicine",
            path: "/sitemap/telemedicine-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_telemedicine_detail",
            path: "/sitemap/telemedicine.xml",
            appScreenName: ""
        }
    },
    SITEMAP_DISEASE_ENCYCLOPEDIA: {
        LIST: {
            pageName: "sitemap_disease_encyclopedia",
            path: "/sitemap/disease-encyclopedia-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_disease_encyclopedia_detail",
            path: "/sitemap/disease-encyclopedia.xml",
            appScreenName: ""
        }
    },
    SITEMAP_MEDICINE_DICTIONARY: {
        LIST: {
            pageName: "sitemap_medicine_dictionary",
            path: "/sitemap/medicine-dictionary-index.xml",
            appScreenName: ""
        },
        DETAIL: {
            pageName: "sitemap_medicine_dictionary_detail",
            path: "/sitemap/medicine-dictionary.xml",
            appScreenName: ""
        }
    },
    PHARMACIES: {
        PHARMACY_CALL: {
            pageName: "pharmacy_call",
            path: "/pharmacies/call",
            appScreenName: "PharmacyCallScreen"
        },
        PRESCRIPTION_SEND_IMAGE_CHECK: {
            pageName: "",
            path: "",
            appScreenName: "PrescriptionSendImageCheckScreen"
        },
        PHARMACIES_PICKUP: {
            pageName: "",
            path: "",
            appScreenName: "PharmaciesPickupWebViewScreen"
        },
        PHARMACIES_DETAIL: {
            pageName: "",
            path: "/pharmacies",
            appScreenName: "PharmacyDetailWebViewScreen"
        },
        PHARMACIES_REVIEW: {
            pageName: "",
            path: "",
            appScreenName: "PharmacyReviewWebViewScreen"
        },
        ONBOARDING_GUIDE: {
            pageName: "",
            path: "/pharmacies/pickupOnboarding",
            appScreenName: "PharmaciesPickupOnboardingWebViewScreen"
        },
        PAYMENT: {
            pageName: "",
            path: "/pharmacies/payment",
            appScreenName: "PharmacyPaymentWebViewScreen"
        },
        PHARMACIES_FIND: {
            pageName: "",
            pathName: "/pharmacies/find",
            appScreenName: "FindPharmacyWebViewScreen"
        }
    },
    DIAGNOSIS: {
        DETAIL: {
            pageName: "",
            path: "",
            appScreenName: "DiagnosisDetailScreen"
        },
        CATEGORY_SELECT: {
            pageName: "",
            path: "",
            appScreenName: "CategorySelectScreen"
        },
        DIAGNOSIS_REQUEST: {
            pageName: "",
            path: "/diagnosis/treatment-request",
            appScreenName: ""
        }
    },
    DOCTOR: {
        LIST: {
            pageName: "",
            path: "",
            appScreenName: "DoctorListScreen"
        },
        BRAND_LIST: {
            pageName: "",
            path: "",
            appScreenName: "BrandDoctorListScreen"
        },
        F2F_LIST: {
            pageName: "",
            path: "",
            appScreenName: "F2FDoctorListScreen"
        },
        DETAIL: {
            pageName: "",
            path: "/doctors",
            appScreenName: "DoctorDetailScreen"
        },
        REVIEWS: function(doctorId) {
            return {
                pageName: "doctor_detail_reviews",
                path: "/doctors/".concat(doctorId, "/reviews"),
                appScreenName: "DoctorDetailReviewsWebViewScreen"
            };
        },
        FACE_TO_FACE_PREFERENCE_STEP: {
            pageName: "",
            path: "/face-to-face/preference-step",
            appScreenName: ""
        }
    },
    NON_BENEFIT: {
        HOME: {
            pageName: "",
            path: "/non-benefit",
            appScreenName: "NonBenefitHomeWebViewScreen"
        },
        MAP: {
            pageName: "",
            path: "/non-benefit/map",
            appScreenName: "NonBenefitMapWebViewScreen"
        },
        TREATMENT_MEDICINE_DETAIL: {
            pageName: "",
            path: "/non-benefit/treatment-medicine/",
            appScreenName: "NonBenefitTreatmentMedicineDetailWebViewScreen"
        }
    },
    MEDICATION: {
        DETAIL: {
            pageName: "",
            path: "/medication",
            appScreenName: "MedicationDetailScreen"
        }
    },
    PRESCRIPTION: {
        FAIL: {
            pageName: "",
            path: "/prescription/send/fail",
            appScreenName: "PrescriptionSendFailWebViewScreen"
        },
        RESELECT_REASON: {
            pageName: "",
            path: "/prescription/send/reselect-reason",
            appScreenName: "PrescriptionSendReselectReasonWebViewScreen"
        },
        FAX_INPUT: {
            pageName: "",
            path: "/prescription/send/fax-input",
            appScreenName: "PrescriptionSendFaxInputWebViewScreen"
        },
        FAX_CHECK: {
            pageName: "",
            path: "/prescription/send/fax-check",
            appScreenName: "PrescriptionSendFaxCheckWebViewScreen"
        }
    },
    CARD: {
        HOME: {
            pageName: "",
            path: "/cards",
            appScreenName: "CardListWebViewScreen"
        },
        REGISTER: {
            pageName: "",
            path: "/cards/register",
            appScreenName: "CardRegisterWebViewScreen"
        }
    },
    FAMILY: {
        HOME: {
            pageName: "",
            path: "/family",
            appScreenName: "FamilyListWebViewScreen"
        },
        REGISTER: {
            pageName: "",
            path: "/family/register",
            appScreenName: "FamilyRegisterWebViewScreen"
        }
    },
    ADDRESS: {
        HOME: {
            pageName: "",
            path: "/addresses",
            appScreenName: "AddressListWebViewScreen"
        },
        REGISTER: {
            pageName: "",
            path: "/addresses/register",
            appScreenName: "AddressRegisterWebViewScreen"
        }
    },
    KAKAOPAY: {
        HOME: {
            pageName: "",
            path: "",
            appScreenName: "KakaoPayWebViewScreen"
        }
    },
    TREATMENT_REQUEST: {
        TREATMENT_REQUEST: {
            pageName: "",
            path: "",
            appScreenName: "TreatmentRequestScreen"
        }
    },
    TELEMEDICINE: {
        DOCTORS: {
            pageName: "",
            path: "/telemedicine/doctors",
            appScreenName: "",
            buildPath: function(type, id) {
                return "/telemedicine/doctors/".concat(type, "/").concat(id);
            }
        },
        CATEGORIES: {
            pageName: "",
            path: "/telemedicine/categories",
            appScreenName: ""
        },
        REQUEST: {
            pageName: "",
            path: "/telemedicine/request",
            appScreenName: ""
        }
    },
    MEDICINE_DICTIONARY: {
        DETAIL: {
            pageName: "",
            path: "/medicine-dictionary",
            appScreenName: ""
        },
        HOME: {
            pageName: "",
            path: "/medicine-dictionary",
            appScreenName: ""
        },
        SEARCH: {
            pageName: "",
            path: "/medicine-dictionary/search",
            appScreenName: ""
        }
    },
    DISEASE_ENCYCLOPEDIA: {
        DETAIL: {
            pageName: "",
            path: "/disease-encyclopedia",
            appScreenName: ""
        },
        HOME: {
            pageName: "",
            path: "/disease-encyclopedia",
            appScreenName: ""
        },
        SEARCH: {
            pageName: "",
            path: "/disease-encyclopedia/search",
            appScreenName: ""
        },
        SELECT_SUBJECT: {
            pageName: "",
            path: "/disease-encyclopedia/select-subject",
            appScreenName: ""
        },
        TOTAL: {
            pageName: "",
            path: "/disease-encyclopedia/total",
            appScreenName: ""
        }
    },
    MY_INVITATION_CODE: {
        pageName: "",
        path: "",
        appScreenName: "MyInvitationCodeScreen"
    },
    ADDITIONAL_ORDER: {
        pageName: "",
        path: "/additional-order",
        appScreenName: ""
    },
    PAYMENT: {
        pageName: "",
        path: "",
        appScreenName: "PaymentScreen"
    }
};
/**
 * @deprecated 위 ROUTES로만 사용
 */ var APP_SCREEN_NAME = {
    // 본인 인증
    CERTIFICATION: "CertificationScreen",
    // 진료 증상 or 과목 선택
    CATEGORY_SELECT: "CategorySelectScreen",
    // 진료 요청(=바로 진료)
    TREATMENT_REQUEST: "TreatmentRequestScreen",
    // 의사 상세
    DOCTOR_DETAIL: "DoctorDetailScreen",
    // 의사 리스트
    DOCTOR_LIST: "DoctorListScreen",
    // 무물보 질문하기
    QNA_WRITE: "QnaWriteWebViewScreen",
    // 무물보 상세
    QNA_DETAIL: "QnaDetailWebViewScreen",
    // 무물보 검색
    QNA_SEARCH: "CommunicationSearchWebViewScreen",
    // 건강꿀팁 상세
    MAGAZINE_DETAIL: "MagazineDetailWebViewScreen",
    // 마이페이지
    MY_PAGE: "MyPageScreen",
    // 무물보 실시간 질문 페이지
    QNA_REALTIME: "QnaListWebViewScreen",
    // 무물보 마이페이지
    QNA_MY_PAGE: "QuickAnswerMypageWebViewScreen",
    // 처방 내역 보기
    DIAGNOSIS_LIST: "DiagnosisListScreen",
    // 커뮤니티 설정
    COMMUNITY_SETTING: "communitySettingScreen",
    // 정보 요청 페이지
    REQUEST_INFO: "SearchRequestInfoWebViewScreen",
    // 정보 상세 요청 페이지
    REQUEST_DETAIL_INFO: "SearchRequestDetailInfoWebViewScreen",
    // 포인트 내역 페이지
    POINT_HISTORY: "PointHistoryScreen",
    // 포인트 마켓 인증 페이지
    POINT_MARKET_CERTIFICATION: "PointMarketCertificationWebViewScreen"
};


/***/ }),

/***/ 45140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ AttachmentBlindType; }
/* harmony export */ });
/* unused harmony export BOARD_POST_TAG_TYPE */
var BOARD_POST_TAG_TYPE = {
    DEFAULT: "DEFAULT",
    RECOMMENDED: "RECOMMENDED",
    POPULAR: "POPULAR"
};
var AttachmentBlindType;
(function(AttachmentBlindType) {
    AttachmentBlindType["Blinded"] = "BLINDED";
    AttachmentBlindType["Dimmed"] = "DIMMED";
    AttachmentBlindType["None"] = "NONE";
})(AttachmentBlindType || (AttachmentBlindType = {}));


/***/ }),

/***/ 20138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ EDiagnosisContactType; }
/* harmony export */ });
var EDiagnosisContactType;
(function(EDiagnosisContactType) {
    EDiagnosisContactType["NonF2F"] = "NON_F2F";
    EDiagnosisContactType["F2F"] = "F2F";
})(EDiagnosisContactType || (EDiagnosisContactType = {}));


/***/ }),

/***/ 79051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CK": function() { return /* binding */ DoctorBookingStatus; },
/* harmony export */   "Ts": function() { return /* binding */ BookingScheduleTypeVo; },
/* harmony export */   "Uc": function() { return /* binding */ BookingScheduleStatus; },
/* harmony export */   "WF": function() { return /* binding */ EBookingAvailabilityVo; },
/* harmony export */   "Wj": function() { return /* binding */ DiagnosisTypeVo; },
/* harmony export */   "eO": function() { return /* binding */ DayOfWeek; },
/* harmony export */   "gO": function() { return /* binding */ CareerType; }
/* harmony export */ });
var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek[DayOfWeek["Mon"] = 1] = "Mon";
    DayOfWeek[DayOfWeek["Tue"] = 2] = "Tue";
    DayOfWeek[DayOfWeek["Wed"] = 3] = "Wed";
    DayOfWeek[DayOfWeek["Thu"] = 4] = "Thu";
    DayOfWeek[DayOfWeek["Fri"] = 5] = "Fri";
    DayOfWeek[DayOfWeek["Sat"] = 6] = "Sat";
    DayOfWeek[DayOfWeek["Sun"] = 7] = "Sun";
    DayOfWeek[DayOfWeek["Hol"] = 8] = "Hol";
})(DayOfWeek || (DayOfWeek = {}));
var CareerType;
(function(CareerType) {
    CareerType["Current"] = "CURRENT";
    CareerType["Past"] = "PAST";
    CareerType["Graduation"] = "GRADUATION";
    CareerType["Completion"] = "COMPLETION";
})(CareerType || (CareerType = {}));
var EBookingAvailabilityVo;
(function(EBookingAvailabilityVo) {
    EBookingAvailabilityVo["TodayBookable"] = "TODAY_BOOKABLE";
    EBookingAvailabilityVo["TomorrowBookable"] = "TOMORROW_BOOKABLE";
    EBookingAvailabilityVo["UpcomingBookable"] = "UPCOMING_BOOKABLE";
    EBookingAvailabilityVo["NotBookable"] = "NOT_BOOKABLE";
    EBookingAvailabilityVo["Unknown"] = "UNKNOWN";
})(EBookingAvailabilityVo || (EBookingAvailabilityVo = {}));
var DiagnosisTypeVo;
(function(DiagnosisTypeVo) {
    DiagnosisTypeVo["Department"] = "DEPARTMENT";
    DiagnosisTypeVo["TREATMENT"] = "TREATMENT";
})(DiagnosisTypeVo || (DiagnosisTypeVo = {}));
var BookingScheduleStatus;
(function(BookingScheduleStatus) {
    BookingScheduleStatus["Bookable"] = "BOOKABLE";
    BookingScheduleStatus["FullyBooked"] = "FULLY_BOOKED";
    BookingScheduleStatus["Holiday"] = "HOLIDAY";
    BookingScheduleStatus["Unknown"] = "UNKNOWN";
})(BookingScheduleStatus || (BookingScheduleStatus = {}));
var BookingScheduleTypeVo;
(function(BookingScheduleTypeVo) {
    BookingScheduleTypeVo["Bookable"] = "BOOKABLE";
    BookingScheduleTypeVo["Disabled"] = "DISABLED";
    BookingScheduleTypeVo["FullyBooked"] = "FULLY_BOOKED";
    BookingScheduleTypeVo["Unknown"] = "UNKNOWN";
})(BookingScheduleTypeVo || (BookingScheduleTypeVo = {}));
var DoctorBookingStatus;
(function(DoctorBookingStatus) {
    DoctorBookingStatus["TodayBookable"] = "TodayBookable";
    DoctorBookingStatus["TomorrowBookable"] = "TomorrowBookable";
    DoctorBookingStatus["BookingUnavailable"] = "BookingUnavailable";
})(DoctorBookingStatus || (DoctorBookingStatus = {}));


/***/ }),

/***/ 47358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ GraphqlError; }
});

// UNUSED EXPORTS: ServerError

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(21218);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(501);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(34067);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(6729);
;// CONCATENATED MODULE: ./src/types/error.ts




var GraphqlError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(GraphqlError, Error1);
    var _super = (0,_create_super/* default */.Z)(GraphqlError);
    function GraphqlError(message, code) {
        (0,_class_call_check/* default */.Z)(this, GraphqlError);
        var _this;
        _this = _super.call(this, message);
        _this.code = code;
        return _this;
    }
    return GraphqlError;
}(_wrapNativeSuper(Error));
var ServerError;
(function(ServerError) {
    ServerError["NotFound"] = "NotFound";
    ServerError["BadRequest"] = "BadRequest";
})(ServerError || (ServerError = {}));


/***/ }),

/***/ 24396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J0": function() { return /* binding */ DiagnosisState; },
/* harmony export */   "LC": function() { return /* binding */ HospitalSearchMode; },
/* harmony export */   "RJ": function() { return /* binding */ ContractType; },
/* harmony export */   "Sy": function() { return /* binding */ HospitalFreeInfluenzaType; },
/* harmony export */   "UG": function() { return /* binding */ HospitalSearchParamsQueries; },
/* harmony export */   "UH": function() { return /* binding */ MedicineType; },
/* harmony export */   "Vq": function() { return /* binding */ HospitalDetailModal; },
/* harmony export */   "c9": function() { return /* binding */ ReviewSortType; },
/* harmony export */   "k_": function() { return /* binding */ HospitalSearchSortType; },
/* harmony export */   "rT": function() { return /* binding */ HospitalInfluenzaFilter; },
/* harmony export */   "x6": function() { return /* binding */ HospitalCommonFilterType; }
/* harmony export */ });
/* unused harmony export DayOfWeek */
var ReviewSortType;
(function(ReviewSortType) {
    ReviewSortType["RECENT"] = "RECENT";
    ReviewSortType["LOW"] = "LOW";
    ReviewSortType["HIGH"] = "HIGH";
})(ReviewSortType || (ReviewSortType = {}));
var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Holiday"] = "HOLIDAY";
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
})(DayOfWeek || (DayOfWeek = {}));
var DiagnosisState;
(function(DiagnosisState) {
    DiagnosisState["On"] = "On";
    DiagnosisState["Off"] = "Off";
    DiagnosisState["Lunch"] = "Lunch";
    DiagnosisState["DayOff"] = "DayOff";
    DiagnosisState["Unknown"] = "Unknown";
})(DiagnosisState || (DiagnosisState = {}));
var ContractType;
(function(ContractType) {
    ContractType["All"] = "ALL";
    ContractType["FaceToFace"] = "FACE_TO_FACE";
    ContractType["NonFaceToFace"] = "NON_FACE_TO_FACE";
})(ContractType || (ContractType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var HospitalSearchSortType;
(function(HospitalSearchSortType) {
    HospitalSearchSortType["ACCURACY"] = "ACCURACY";
    HospitalSearchSortType["DISTANCE"] = "DISTANCE";
    HospitalSearchSortType["REVIEW_AVERAGE_RATING"] = "REVIEW_AVERAGE_RATING";
    HospitalSearchSortType["REVIEW_COUNT"] = "REVIEW_COUNT";
})(HospitalSearchSortType || (HospitalSearchSortType = {}));
var HospitalSearchParamsQueries;
(function(HospitalSearchParamsQueries) {
    HospitalSearchParamsQueries["SortType"] = "sortType";
    HospitalSearchParamsQueries["CommonFilter"] = "commonFilter";
    HospitalSearchParamsQueries["Keyword"] = "keyword";
    HospitalSearchParamsQueries["Mode"] = "mode";
})(HospitalSearchParamsQueries || (HospitalSearchParamsQueries = {}));
var HospitalSearchMode;
(function(HospitalSearchMode) {
    HospitalSearchMode["NEAR"] = "NEAR";
    HospitalSearchMode["SEARCH"] = "SEARCH";
})(HospitalSearchMode || (HospitalSearchMode = {}));
var HospitalFreeInfluenzaType;
(function(HospitalFreeInfluenzaType) {
    HospitalFreeInfluenzaType["Child"] = "Child";
    HospitalFreeInfluenzaType["Pregnant"] = "Pregnant";
    HospitalFreeInfluenzaType["Senior"] = "Senior";
    HospitalFreeInfluenzaType["SeongnamCitizen"] = "SeongnamCitizen";
})(HospitalFreeInfluenzaType || (HospitalFreeInfluenzaType = {}));
var HospitalInfluenzaFilter;
(function(HospitalInfluenzaFilter) {
    HospitalInfluenzaFilter["FreeInfluenza"] = "FreeInfluenza";
})(HospitalInfluenzaFilter || (HospitalInfluenzaFilter = {}));
var HospitalCommonFilterType;
(function(HospitalCommonFilterType) {
    HospitalCommonFilterType["Specialist"] = "specialist";
    HospitalCommonFilterType["Bookable"] = "bookable";
    HospitalCommonFilterType["Operating"] = "operating";
    HospitalCommonFilterType["NightOperation"] = "nightOperation";
    HospitalCommonFilterType["SundayOperation"] = "sundayOperation";
    HospitalCommonFilterType["NonF2f"] = "nonF2f";
})(HospitalCommonFilterType || (HospitalCommonFilterType = {}));
var HospitalDetailModal;
(function(HospitalDetailModal) {
    HospitalDetailModal["Booking"] = "booking";
})(HospitalDetailModal || (HospitalDetailModal = {}));


/***/ }),

/***/ 74701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ MODAL_BUTTON_TYPE; },
/* harmony export */   "f": function() { return /* binding */ MODAL_TYPE; }
/* harmony export */ });
var MODAL_BUTTON_TYPE = {
    DEFAULT: "default",
    BOLD: "bold",
    PRIMARY: "primary",
    DANGER: "danger"
};
var MODAL_TYPE = {
    ALERT: "ALERT",
    BASIC: "BASIC",
    LOGIN: "LOGIN",
    CUSTOM_BACKGROUND: "CUSTOM_BACKGROUND"
};


/***/ }),

/***/ 89776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22970);
/* harmony import */ var airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21445);
/* harmony import */ var _constants_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95611);
/* harmony import */ var _constants_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5322);
/* harmony import */ var _shared_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9628);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9912);
/* harmony import */ var _utils_report__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80162);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88295);













var Airbridge = /*#__PURE__*/ function() {
    "use strict";
    function Airbridge() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, Airbridge);
    }
    Airbridge.initialize = function initialize() {
        try {
            airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .Z.init({
                app: "doctornow",
                webToken: "cce91b6cf16e41d59a34f9a1bddda0c1",
                useProtectedAttributionWindow: true,
                protectedAttributionWindowInMinutes: 30,
                utmParsing: true
            });
        } catch (error) {
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_5__/* .infoReport */ .pP)("Airbridge:initialize > error", {}, (0,_error__WEBPACK_IMPORTED_MODULE_6__/* .getErrorObject */ .T)(error));
        }
    };
    Airbridge.trackEvent = function trackEvent(eventName, eventParams) {
        try {
            switch(eventName){
                case "page_view":
                    airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].events.send */ .Z.events.send(eventName, {
                        customAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, eventParams), {
                            env: (0,_constants_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnv */ .dU)()
                        }),
                        label: String(eventParams === null || eventParams === void 0 ? void 0 : eventParams.page_name)
                    });
                    break;
                case "complete_subscription_payment":
                    airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].events.send */ .Z.events.send(eventName, {
                        customAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, eventParams), {
                            env: (0,_constants_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnv */ .dU)()
                        }),
                        value: Number(eventParams === null || eventParams === void 0 ? void 0 : eventParams.amountToPay)
                    });
                    break;
                default:
                    airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].events.send */ .Z.events.send(eventName, {
                        customAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, eventParams), {
                            env: (0,_constants_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnv */ .dU)()
                        })
                    });
                    break;
            }
        } catch (error) {
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_5__/* .infoReport */ .pP)("Airbridge:trackEvent > error", {
                eventName: eventName,
                eventParams: eventParams
            }, (0,_error__WEBPACK_IMPORTED_MODULE_6__/* .getErrorObject */ .T)(error));
        }
    };
    Airbridge.setUserProperties = function setUserProperties(userProperties) {
        try {
            Object.entries(userProperties).forEach(function(param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setUserAttribute */ .Z.setUserAttribute(key, value);
            });
        } catch (error) {
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_5__/* .infoReport */ .pP)("Airbridge:setUserProperties > error", {
                userProperties: userProperties
            }, (0,_error__WEBPACK_IMPORTED_MODULE_6__/* .getErrorObject */ .T)(error));
        }
    };
    Airbridge.setUserId = function setUserId(userId) {
        try {
            airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setUserID */ .Z.setUserID(userId);
        } catch (error) {
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_5__/* .infoReport */ .pP)("Airbridge:setUserId > error", {
                userId: userId
            }, (0,_error__WEBPACK_IMPORTED_MODULE_6__/* .getErrorObject */ .T)(error));
        }
    };
    Airbridge.setClient = function setClient(client) {
        if (this.os) {
            return;
        }
        if (client.clientType === _types_app__WEBPACK_IMPORTED_MODULE_4__/* .ClientType.WEB */ .B.WEB) {
            this.os = "WEB";
        } else if (client.isIOS) {
            this.os = "IOS";
        } else if (client.isAndroid) {
            this.os = "ANDROID";
        }
        this.setUserProperties({
            os: this.os
        });
    };
    Airbridge.setDeepLink = function setDeepLink(param) {
        var buttonID = param.buttonID, deeplinkUrl = param.deeplinkUrl, ctaParams = param.ctaParams;
        try {
            airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setDeeplinks */ .Z.setDeeplinks({
                buttonID: buttonID,
                deeplinks: {
                    ios: deeplinkUrl,
                    android: deeplinkUrl,
                    desktop: deeplinkUrl
                },
                fallbacks: {
                    ios: "itunes-appstore",
                    android: "google-play"
                },
                ctaParams: ctaParams,
                redirect: true,
                desktopPopUp: true
            });
        } catch (error) {
            (0,_utils_report__WEBPACK_IMPORTED_MODULE_5__/* .infoReport */ .pP)("Airbridge:setDeepLink > error", {}, (0,_error__WEBPACK_IMPORTED_MODULE_6__/* .getErrorObject */ .T)(error));
        }
    };
    Airbridge.buildDynamicLinkParams = function buildDynamicLinkParams(param) {
        var parsedParams = JSON.parse(JSON.stringify(param));
        return this.os ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, parsedParams), {
            ad_group: this.os
        }) : parsedParams;
    };
    Airbridge.getDynamicLink = function getDynamicLink(param) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.GENERAL */ .Q.GENERAL;
        var params = this.buildDynamicLinkParams(param);
        var trackingParams = this.getTrackingParams(linkType);
        var url = "".concat(_constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_PUBLIC_DOWNLOAD_URL */ .XA, "/").concat(_constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_TRACKING_CHANNEL */ .fn, "?").concat(new URLSearchParams(params).toString(), "&").concat(trackingParams);
        return url;
    };
    Airbridge.getTrackingParams = function getTrackingParams() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.GENERAL */ .Q.GENERAL;
        switch(linkType){
            case _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.STORE_PAGE */ .Q.STORE_PAGE:
                return _constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_STORE_PAGE_LINK_TRACKING_PARAMS */ .aG;
            case _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.HAIRLOSS */ .Q.HAIRLOSS:
                return _constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_HAIRLOSS_TRACKING_PARAMS */ .iI;
            case _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.ACNE */ .Q.ACNE:
                return _constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_ACNE_TRACKING_PARAMS */ .IC;
            case _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.DIET */ .Q.DIET:
                return _constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_DIET_TRACKING_PARAMS */ .kT;
            case _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.GENERAL */ .Q.GENERAL:
            default:
                return _constants_common__WEBPACK_IMPORTED_MODULE_1__/* .APP_GENERAL_TRACKING_PARAMS */ .eU;
        }
    };
    Airbridge.setDynamicLink = function setDynamicLink(param) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _shared_types__WEBPACK_IMPORTED_MODULE_3__/* .EAirbridgeLinkType.GENERAL */ .Q.GENERAL;
        var url = this.getDynamicLink(param, linkType);
        window.location.href = url;
    };
    Airbridge.createTrackingLinkAsync = function createTrackingLinkAsync(channel, options) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        airbridge_web_sdk_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].createTrackingLink */ .Z.createTrackingLink(channel, options, function(param) {
                            var shortURL = param.shortURL;
                            resolve(shortURL);
                        }, function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        })();
    };
    return Airbridge;
}();
Airbridge.os = null;
/* harmony default export */ __webpack_exports__["Z"] = (Airbridge);


/***/ }),

/***/ 80888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ localStorageEffect; },
/* harmony export */   "j": function() { return /* binding */ sessionStorageEffect; }
/* harmony export */ });
var localStorageEffect = function(key) {
    return function(param) {
        var setSelf = param.setSelf, onSet = param.onSet;
        if (false) {}
        var savedValue = localStorage.getItem(key);
        if (savedValue !== null && savedValue !== "undefined") {
            setSelf(JSON.parse(savedValue));
        }
        onSet(function(newValue, _, isReset) {
            isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue));
        });
    };
};
var sessionStorageEffect = function(key) {
    return function(param) {
        var setSelf = param.setSelf, onSet = param.onSet;
        if (false) {}
        var savedValue = sessionStorage.getItem(key);
        if (savedValue !== null) {
            setSelf(JSON.parse(savedValue));
        }
        onSet(function(newValue, _, _isReset) {
            var confirm = newValue.length === 0;
            confirm ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, JSON.stringify(newValue));
        });
    };
};


/***/ }),

/***/ 27841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ setupDNSCacheErrorHandling; },
/* harmony export */   "y": function() { return /* binding */ createDNSCacheAdapter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);






// 원본 axios adapter 보존
var originalAdapter = (axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.adapter);
/**
 * DNS 캐싱을 사용하는 커스텀 Axios Adapter 생성
 *
 * 🔥 서버사이드 전용 DNS 캐싱:
 * - cacheable-lookup 기반 고성능 DNS 캐싱 (Node.js 환경에서만)
 * - 클라이언트에서는 원본 adapter 사용 (브라우저 자체 DNS 캐싱)
 *
 * 서버사이드 기능:
 * 1. HTTP 요청 전에 호스트명을 캐싱된 IP로 자동 치환
 * 2. 수동 Round-robin으로 ALB 로드밸런싱 지원
 * 3. Host 헤더 유지로 ALB 라우팅 보장
 * 4. DNS 실패 시 원본 adapter로 fallback
 * 5. TTL 기반 자동 캐시 관리
 *
 * @returns AxiosAdapter DNS 캐싱이 적용된 adapter (서버사이드만)
 */ var createDNSCacheAdapter = function() {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(config) {
            var url, hostname, ipv4Regex, dnsManager, dnsResult, modifiedBaseURL, modifiedConfig, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 클라이언트사이드에서는 DNS 캐싱 비활성화
                        if (!_types_common__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk) {
                            // 브라우저에서는 원본 adapter 사용 (브라우저 자체 DNS 캐싱)
                            return [
                                2,
                                originalAdapter(config)
                            ];
                        }
                        // baseURL이 없으면 원본 adapter 사용
                        if (!config.baseURL) {
                            return [
                                2,
                                originalAdapter(config)
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        url = new URL(config.baseURL);
                        hostname = url.hostname;
                        ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
                        if (ipv4Regex.test(hostname)) {
                            return [
                                2,
                                originalAdapter(config)
                            ];
                        }
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5308).then(__webpack_require__.bind(__webpack_require__, 88423))
                        ];
                    case 2:
                        dnsManager = _state.sent().dnsManager;
                        return [
                            4,
                            dnsManager.resolveWithDetailedInfo(hostname)
                        ];
                    case 3:
                        dnsResult = _state.sent();
                        modifiedBaseURL = config.baseURL.replace(hostname, dnsResult.ip);
                        modifiedConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, config), {
                            baseURL: modifiedBaseURL,
                            headers: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, config.headers), {
                                Host: hostname
                            })
                        });
                        return [
                            2,
                            originalAdapter(modifiedConfig)
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("DNS cache adapter error (server-side):", error);
                        // DNS 실패 시 원본 adapter로 fallback
                        return [
                            2,
                            originalAdapter(config)
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(config) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * DNS 캐싱 에러 핸들링 설정 (서버사이드 전용)
 *
 * 주요 기능:
 * 1. 네트워크 에러 감지 시 다음 IP로 자동 재시도 (서버에서만)
 * 2. DNS failover 로직으로 가용성 향상
 * 3. ALB IP 변경 시 무중단 서비스 보장
 *
 * @param axiosInstance DNS 캐싱을 적용할 axios 인스턴스
 */ var setupDNSCacheErrorHandling = function(axiosInstance) {
    axiosInstance.interceptors.response.use(function(response) {
        return response;
    }, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(error) {
            var config, baseURL, url, hostname, configWithRetry, dnsManager, nextIP, retryBaseURL, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = error.config;
                        // 클라이언트사이드에서는 에러 핸들링 비활성화
                        if (!_types_common__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        if (!(error.code === "ECONNREFUSED" || error.code === "ENOTFOUND" || error.code === "ETIMEDOUT" || error.code === "EHOSTUNREACH")) return [
                            3,
                            5
                        ];
                        baseURL = config.baseURL || config.url;
                        if (!baseURL) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        url = new URL(baseURL);
                        hostname = url.hostname;
                        configWithRetry = config;
                        if (!!configWithRetry.__retryCount) return [
                            3,
                            5
                        ];
                        configWithRetry.__retryCount = 1;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5308).then(__webpack_require__.bind(__webpack_require__, 88423))
                        ];
                    case 2:
                        dnsManager = _state.sent().dnsManager;
                        return [
                            4,
                            dnsManager.getNextIP(hostname)
                        ];
                    case 3:
                        nextIP = _state.sent();
                        retryBaseURL = baseURL.replace(url.hostname, nextIP);
                        return [
                            2,
                            axiosInstance((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, configWithRetry), {
                                baseURL: retryBaseURL
                            }))
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            Promise.reject(error)
                        ];
                    case 5:
                        return [
                            2,
                            Promise.reject(error)
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
};


/***/ }),

/***/ 88295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getErrorObject; },
/* harmony export */   "p": function() { return /* binding */ getBffErrorMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42838);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83417);



var getBffErrorMessage = function(error) {
    var errorData = error;
    if (errorData.code && errorData.code in _constants_errors__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MESSAGE */ .c9) {
        return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errors__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MESSAGE */ .c9, errorData.code);
    }
    if (errorData.message) {
        return errorData.message;
    }
    return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errors__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_MESSAGE */ .c9, "DefaultError");
};
var getErrorObject = function(error) {
    var errorObject = undefined;
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(error, Error)) {
        errorObject = error;
    }
    return errorObject;
};


/***/ }),

/***/ 8391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kk": function() { return /* binding */ RestApi; },
/* harmony export */   "Wj": function() { return /* binding */ removeAuthorization; },
/* harmony export */   "Xy": function() { return /* binding */ preSignedUrlFetch; },
/* harmony export */   "be": function() { return /* binding */ axiosInstance; },
/* harmony export */   "eE": function() { return /* binding */ instance; },
/* harmony export */   "he": function() { return /* binding */ fetch; },
/* harmony export */   "l3": function() { return /* binding */ gqlFetcher; }
/* harmony export */ });
/* unused harmony exports BFF_BASE_URL, preSignedUrlInstance, gqlRestRequest */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22970);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16765);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4415);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70138);
/* harmony import */ var _types_error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47358);
/* harmony import */ var _utils_token__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53612);
/* harmony import */ var _mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10712);












var BFF_BASE_URL = "".concat("https://bff.doctornow.co.kr");
var API_BASE_URL = "".concat("https://api.doctornow.co.kr");
// DNS 최적화 시스템을 서버사이드에서만 초기화
var dnsAdapter = null;
// 서버사이드에서만 DNS 시스템 동기 초기화
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk) {
    try {
        // 동기적으로 DNS adapter 생성
        var createDNSCacheAdapter = (__webpack_require__(27841)/* .createDNSCacheAdapter */ .y);
        dnsAdapter = createDNSCacheAdapter();
        console.log("\uD83D\uDD27 DNS Adapter 동기 로딩 완료:", dnsAdapter ? "성공" : "실패");
    } catch (error) {
        console.error("DNS system initialization failed:", error);
    }
}
var onRequest = function(config) {
    // 서버서사이드에서 실행될 경우 로컬스토리지, 스토어가 없으니 그냥 config 반환
    if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk) {
        return config;
    }
    var token = (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuthToken */ .bW)();
    var controller = new AbortController();
    if (token) {
        if ((0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)()) {
            if (config.headers) {
                config.headers.Authorization = "Bearer ".concat(token);
            }
            return config;
        }
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(token.split("//"), 2), accessToken = ref[0], expirationTime = ref[1];
        //토큰 만료 기간 확인 후 (당일 발급된 토큰)
        if ((0,_utils_token__WEBPACK_IMPORTED_MODULE_5__/* .checkTokenExpiration */ .N)(expirationTime)) {
            // 헤더에 토큰 추가
            if (config.headers) {
                config.headers.Authorization = "Bearer ".concat(accessToken);
            }
        // 토큰 만료 시
        } else {
            (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .setAuthToken */ .uB)();
            if (config.headers) {
                config.headers.Authorization = "";
            }
            // 요청 취소
            controller.abort();
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, config), {
                signal: controller.signal
            });
        }
    }
    return config;
};
var onRequestError = function(requestError) {
    return Promise.reject(requestError);
};
var onResponse = function(response) {
    if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk) {
        return response;
    }
    if ("errors" in response.data) {
        return response;
    }
    if ((0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)()) {
        return response;
    }
    var token = (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuthToken */ .bW)();
    if (token) {
        var accessToken = token.split("//")[0];
        var newToken = (0,_utils_token__WEBPACK_IMPORTED_MODULE_5__/* .setTokenExpiration */ .B)(accessToken);
        (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .setAuthToken */ .uB)(newToken);
    }
    return response;
};
var onResponseError = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(responseError) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            return [
                2,
                Promise.reject(responseError)
            ];
        });
    });
    return function onResponseError(responseError) {
        return _ref.apply(this, arguments);
    };
}();
//restApi instance
var instanceConfig = {
    headers: {
        "content-type": "application/json"
    },
    baseURL: API_BASE_URL
};
// 서버사이드에서만 DNS adapter 사용
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    instanceConfig.adapter = dnsAdapter;
}
var instance = axios__WEBPACK_IMPORTED_MODULE_0___default().create(instanceConfig);
var RestApi = {
    get: function(url, options) {
        return instance.get(url, options);
    },
    post: function(url, param, options) {
        return instance.post(url, param, options);
    },
    put: function(url, param, options) {
        return instance.put(url, param, options);
    },
    delete: function(url, options) {
        return instance.delete(url, options);
    }
};
instance.interceptors.request.use(onRequest, onRequestError);
instance.interceptors.response.use(onResponse, onResponseError);
// 서버사이드에서만 DNS 캐싱 에러 핸들링 설정
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    try {
        var setupDNSCacheErrorHandling = (__webpack_require__(27841)/* .setupDNSCacheErrorHandling */ .R);
        setupDNSCacheErrorHandling(instance);
    } catch (error1) {
        console.error("DNS error handling setup failed for instance:", error1);
    }
}
var axiosInstanceConfig = {
    headers: {
        "content-type": "application/json"
    },
    timeout: 30000
};
// 서버사이드에서만 DNS adapter 사용
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    axiosInstanceConfig.adapter = dnsAdapter;
}
var axiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create(axiosInstanceConfig);
axiosInstance.interceptors.request.use(onRequest, onRequestError);
axiosInstance.interceptors.response.use(onResponse, onResponseError);
// 서버사이드에서만 DNS 캐싱 에러 핸들링 설정
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    try {
        var setupDNSCacheErrorHandling1 = (__webpack_require__(27841)/* .setupDNSCacheErrorHandling */ .R);
        setupDNSCacheErrorHandling1(axiosInstance);
    } catch (error2) {
        console.error("DNS error handling setup failed for axiosInstance:", error2);
    }
}
var removeAuthorization = function() {
    (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .setAuthToken */ .uB)();
    axiosInstance.defaults.headers.common["Authorization"] = "";
};
var preSignedUrlConfig = {
    headers: {
        "Content-Type": "multipart/form-data"
    }
};
// 서버사이드에서만 DNS adapter 사용
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    preSignedUrlConfig.adapter = dnsAdapter;
}
var preSignedUrlInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create(preSignedUrlConfig);
// 서버사이드에서만 DNS 캐싱 에러 핸들링 설정
if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
    try {
        var setupDNSCacheErrorHandling2 = (__webpack_require__(27841)/* .setupDNSCacheErrorHandling */ .R);
        setupDNSCacheErrorHandling2(preSignedUrlInstance);
    } catch (error3) {
        console.error("DNS error handling setup failed for preSignedUrlInstance:", error3);
    }
}
var preSignedUrlFetch = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : API_BASE_URL;
    preSignedUrlInstance.defaults.baseURL = baseURL;
    return preSignedUrlInstance;
};
//graphQL fetch
var fetch = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : API_BASE_URL;
    axiosInstance.defaults.baseURL = baseURL;
    return axiosInstance;
};
var newAbortSignal = function() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 30000;
    var abortController = new AbortController();
    setTimeout(function() {
        return abortController.abort();
    }, time || 0);
    return abortController.signal;
};
var gqlFetcher = function(query, operationName, variables, options) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var response, _errors, ref, message, extensions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(BFF_BASE_URL, "/graphql/").concat(operationName)).post("", {
                            query: query,
                            variables: variables,
                            operationName: operationName
                        }, {
                            headers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                "Content-Type": "application/json"
                            }, options),
                            signal: newAbortSignal()
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _errors = response.data.errors;
                    if (_errors) {
                        ref = _errors[0] || {}, message = ref.message, extensions = ref.extensions;
                        if (extensions && extensions.code) {
                            throw new _types_error__WEBPACK_IMPORTED_MODULE_4__/* .GraphqlError */ .Q(message, extensions.code);
                        }
                        throw new _types_error__WEBPACK_IMPORTED_MODULE_4__/* .GraphqlError */ .Q(message, "Default");
                    }
                    return [
                        2,
                        response.data.data
                    ];
            }
        });
    });
};
/**
 * @author div
 * 현재 bff url을 향해 rest 방식으로 쏘고 있음
 * 내일 안으로 딘이 bff로 수정해주실 예정이고 그 후 삭제 예정
 * (그러나 당장 배너 클릭 로그가 쌓이지 않고 있어 일단은 이렇게 작업해서 배포)
 **/ var gqlRestRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(url, params) {
        var bffRestUrl, headers, token, accessToken, gqlRestConfig, axiosInstance;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bffRestUrl = "".concat("https://bff.doctornow.co.kr", "/api/");
                    if (!bffRestUrl) {
                        return [
                            2
                        ];
                    }
                    headers = {
                        "Content-Type": "application/json"
                    };
                    token = (0,_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuthToken */ .bW)();
                    if (token) {
                        accessToken = token.split("//")[0];
                        lodash_set__WEBPACK_IMPORTED_MODULE_1___default()(headers, "Authorization", "Bearer ".concat(accessToken));
                    }
                    gqlRestConfig = {
                        baseURL: bffRestUrl,
                        headers: headers,
                        timeout: 10000
                    };
                    // 서버사이드에서만 DNS adapter 사용
                    if (_types_common__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk && dnsAdapter) {
                        gqlRestConfig.adapter = dnsAdapter;
                    }
                    axiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create(gqlRestConfig);
                    return [
                        4,
                        axiosInstance.post(url, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function gqlRestRequest(url, params) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 59334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ firebase; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
;// CONCATENATED MODULE: ../../node_modules/@firebase/util/dist/index.esm2017.js
/* provided dependency */ var process = __webpack_require__(34406);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || typeof process.env === 'undefined') {
        return;
    }
    const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const index_esm2017_getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function index_esm2017_isBrowser() {
    return typeof window !== 'undefined' || index_esm2017_isWebWorker();
}
/**
 * Detect Web Worker context
 */
function index_esm2017_isWebWorker() {
    return (typeof WorkerGlobalScope !== 'undefined' &&
        typeof self !== 'undefined' &&
        self instanceof WorkerGlobalScope);
}
function index_esm2017_isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        !!navigator.userAgent &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function index_esm2017_isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function index_esm2017_validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function index_esm2017_areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function index_esm2017_async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/component/dist/esm/index.esm2017.js


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class index_esm2017_ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/logger/dist/esm/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function index_esm2017_setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ../../node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// CONCATENATED MODULE: ../../node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$p = "@firebase/app";
const version$1 = "0.10.8";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');

const name$o = "@firebase/app-compat";

const name$n = "@firebase/analytics-compat";

const name$m = "@firebase/analytics";

const name$l = "@firebase/app-check-compat";

const name$k = "@firebase/app-check";

const name$j = "@firebase/auth";

const name$i = "@firebase/auth-compat";

const name$h = "@firebase/database";

const name$g = "@firebase/database-compat";

const name$f = "@firebase/functions";

const name$e = "@firebase/functions-compat";

const name$d = "@firebase/installations";

const name$c = "@firebase/installations-compat";

const name$b = "@firebase/messaging";

const name$a = "@firebase/messaging-compat";

const name$9 = "@firebase/performance";

const name$8 = "@firebase/performance-compat";

const name$7 = "@firebase/remote-config";

const name$6 = "@firebase/remote-config-compat";

const name$5 = "@firebase/storage";

const name$4 = "@firebase/storage-compat";

const name$3 = "@firebase/firestore";

const name$2 = "@firebase/vertexai-preview";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const version = "10.12.5";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const index_esm2017_DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$p]: 'fire-core',
    [name$o]: 'fire-core-compat',
    [name$m]: 'fire-analytics',
    [name$n]: 'fire-analytics-compat',
    [name$k]: 'fire-app-check',
    [name$l]: 'fire-app-check-compat',
    [name$j]: 'fire-auth',
    [name$i]: 'fire-auth-compat',
    [name$h]: 'fire-rtdb',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    for (const serverApp of _serverApps.values()) {
        _addComponent(serverApp, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function index_esm2017_getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    index_esm2017_getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */
function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */
function _isFirebaseServerApp(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new Component('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseServerAppImpl extends (/* unused pure expression or super */ null && (FirebaseAppImpl)) {
    constructor(options, serverConfig, name, container) {
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined
            ? serverConfig.automaticDataCollectionEnabled
            : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) {
            // Construct the parent FirebaseAppImp object.
            super(options, config, container);
        }
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({ automaticDataCollectionEnabled }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') {
            this._finalizationRegistry = new FinalizationRegistry(() => {
                this.automaticCleanup();
            });
        }
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$p, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) {
            return;
        }
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) {
            this._finalizationRegistry.register(obj, this);
        }
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) {
            return 0;
        }
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        void deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = (/* unused pure expression or super */ null && (version));
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: index_esm2017_DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = index_esm2017_getDefaultAppConfig());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (deepEqual(options, existingApp.options) &&
            deepEqual(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new index_esm2017_ComponentContainer(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if (isBrowser() && !isWebWorker()) {
        // FirebaseServerApp isn't designed to be run in browsers.
        throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */);
    }
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) {
        _serverAppConfig.automaticDataCollectionEnabled = false;
    }
    let appOptions;
    if (_isFirebaseApp(_options)) {
        appOptions = _options.options;
    }
    else {
        appOptions = _options;
    }
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) {
        delete nameObj.releaseOnDeref;
    }
    const hashCode = (s) => {
        return [...s].reduce((hash, c) => (Math.imul(31, hash) + c.charCodeAt(0)) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') {
            throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */, {});
        }
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new ComponentContainer(nameString);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function index_esm2017_getApp(name = index_esm2017_DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === index_esm2017_DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    }
    else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new Component(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function index_esm2017_setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        try {
                            db.createObjectStore(STORE_NAME);
                        }
                        catch (e) {
                            // Safari/iOS browsers throw occasional exceptions on
                            // db.createObjectStore() that may be a bug. Avoid blocking
                            // the rest of the app functionality.
                            console.warn(e);
                        }
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                return;
            }
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = base64urlEncodeWithoutPadding(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!index_esm2017_isIndexedDBAvailable()) {
            return false;
        }
        else {
            return index_esm2017_validateIndexedDBOpenable()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
                return idbHeartbeatObject;
            }
            else {
                return { heartbeats: [] };
            }
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new Component('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$p, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$p, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/installations/dist/esm/index.esm2017.js





const esm_index_esm2017_name = "@firebase/installations";
const index_esm2017_version = "0.6.8";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${index_esm2017_version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const index_esm2017_ERROR_FACTORY = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof FirebaseError &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return index_esm2017_ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let index_esm2017_dbPromise = null;
function index_esm2017_getDbPromise() {
    if (!index_esm2017_dbPromise) {
        index_esm2017_dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return index_esm2017_dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await index_esm2017_getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID can not be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw index_esm2017_ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw index_esm2017_ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (!response.ok) {
        throw await getErrorFromResponse('Delete Installation', response);
    }
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, oldEntry => {
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
            // Delete the unregistered entry without sending a deleteInstallation request.
            return undefined;
        }
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // Can't delete while trying to register.
            throw index_esm2017_ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
        }
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
            if (!navigator.onLine) {
                throw index_esm2017_ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return () => {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
    const installationsImpl = _getProvider(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return index_esm2017_ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = index_esm2017_getProvider(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = index_esm2017_getProvider(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    _registerComponent(new Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    _registerComponent(new Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerInstallations();
registerVersion(esm_index_esm2017_name, index_esm2017_version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
registerVersion(esm_index_esm2017_name, index_esm2017_version, 'esm2017');


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/analytics/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Analytics.
 */
const ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const GA_FID_KEY = 'firebase_id';
const ORIGIN_KEY = 'origin';
const FETCH_TIMEOUT_MILLIS = 60 * 1000;
const DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_logger = new Logger('@firebase/analytics');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */]: 'A Firebase Analytics instance with the appId {$id} ' +
        ' already exists. ' +
        'Only one Firebase Analytics instance can be created for each appId.',
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */]: 'initializeAnalytics() cannot be called again with different options than those ' +
        'it was initially called with. It can be called again with the same options to ' +
        'return the existing instance, or getAnalytics() can be used ' +
        'to get a reference to the already-initialized instance.',
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */]: 'Firebase Analytics has already been initialized.' +
        'settings() must be called before initializing any Analytics instance' +
        'or it will have no effect.',
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */]: 'Firebase Analytics is not supported in this environment. ' +
        'Wrap initialization of analytics in analytics.isSupported() ' +
        'to prevent initialization in unsupported environments. Details: {$errorInfo}',
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */]: 'IndexedDB unavailable or restricted in this environment. ' +
        'Wrap initialization of analytics in analytics.isSupported() ' +
        'to prevent initialization in unsupported environments. Details: {$errorInfo}',
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */]: 'The config fetch request timed out while in an exponential backoff state.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field to' +
        'contain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field to' +
        'contain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const esm_index_esm2017_ERROR_FACTORY = new ErrorFactory('analytics', 'Analytics', index_esm2017_ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Verifies and creates a TrustedScriptURL.
 */
function createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith(GTAG_URL)) {
        const err = esm_index_esm2017_ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */, {
            gtagURL: url
        });
        index_esm2017_logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */
function promiseAllSettled(promises) {
    return Promise.all(promises.map(promise => promise.catch(e => e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */
function createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) {
        trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    }
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy
        ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL)
        : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) {
        dataLayer = window[dataLayerName];
    }
    else {
        window[dataLayerName] = dataLayer;
    }
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */
async function gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) {
            await initializationPromisesMap[correspondingAppId];
        }
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find(config => config.measurementId === measurementId);
            if (foundConfig) {
                await initializationPromisesMap[foundConfig.appId];
            }
        }
    }
    catch (e) {
        index_esm2017_logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */, measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */
async function gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) {
                gaSendToList = [gaSendToList];
            }
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList) {
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find(config => config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) {
                    initializationPromisesToWaitFor.push(initializationPromise);
                }
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) {
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
            initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        }
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */, measurementId, gtagParams || {});
    }
    catch (e) {
        index_esm2017_logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */
function wrapGtag(gtagCore, 
/**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */
initializationPromisesMap, 
/**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */
dynamicConfigPromisesList, 
/**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */
measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */
    async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            }
            else if (command === "config" /* GtagCommand.CONFIG */) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            }
            else if (command === "consent" /* GtagCommand.CONSENT */) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */, consentAction, gtagParams);
            }
            else if (command === "get" /* GtagCommand.GET */) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */, measurementId, fieldName, callback);
            }
            else if (command === "set" /* GtagCommand.SET */) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */, customParams);
            }
            else {
                gtagCore(command, ...args);
            }
        }
        catch (e) {
            index_esm2017_logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */
function wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function (..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] &&
        typeof window[gtagFunctionName] === 'function') {
        // @ts-ignore
        gtagCore = window[gtagFunctionName];
    }
    window[gtagFunctionName] = wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */
function findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)) {
        if (tag.src &&
            tag.src.includes(GTAG_URL) &&
            tag.src.includes(dataLayerName)) {
            return tag;
        }
    }
    return null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */
const LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */
const BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */
class RetryData {
    constructor(throttleMetadata = {}, intervalMillis = BASE_INTERVAL_MILLIS) {
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const defaultRetryData = new RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */
function index_esm2017_getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */
async function fetchDynamicConfig(appFields) {
    var _a;
    const { appId, apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: index_esm2017_getHeaders(apiKey)
    };
    const appUrl = DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = (await response.json());
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) {
                errorMessage = jsonResponse.error.message;
            }
        }
        catch (_ignored) { }
        throw esm_index_esm2017_ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */, {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */
async function fetchDynamicConfigWithRetry(app, 
// retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = defaultRetryData, timeoutMillis) {
    const { appId, apiKey, measurementId } = app.options;
    if (!appId) {
        throw esm_index_esm2017_ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */);
    }
    if (!apiKey) {
        if (measurementId) {
            return {
                measurementId,
                appId
            };
        }
        throw esm_index_esm2017_ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */);
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new AnalyticsAbortSignal();
    setTimeout(async () => {
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : FETCH_TIMEOUT_MILLIS);
    return attemptFetchDynamicConfigWithRetry({ appId, apiKey, measurementId }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */
async function attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis, backoffCount }, signal, retryData = defaultRetryData // for testing
) {
    var _a;
    const { appId, measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await setAbortableTimeout(signal, throttleEndTimeMillis);
    }
    catch (e) {
        if (measurementId) {
            index_esm2017_logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` +
                ` Falling back to the measurement ID ${measurementId}` +
                ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return { appId, measurementId };
        }
        throw e;
    }
    try {
        const response = await fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    }
    catch (e) {
        const error = e;
        if (!isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                index_esm2017_logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` +
                    ` Falling back to the measurement ID ${measurementId}` +
                    ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return { appId, measurementId };
            }
            else {
                throw e;
            }
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503
            ? calculateBackoffMillis(backoffCount, retryData.intervalMillis, LONG_RETRY_FACTOR)
            : calculateBackoffMillis(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        index_esm2017_logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject) => {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(() => {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(esm_index_esm2017_ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */, {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof FirebaseError) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
class AnalyticsAbortSignal {
    constructor() {
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach(listener => listener());
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Event parameters to set on 'gtag' during initialization.
 */
let defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */
async function logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */, eventName, eventParams);
        return;
    }
    else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), { 'send_to': measurementId });
        gtagFunction("event" /* GtagCommand.EVENT */, eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */
async function setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */, { 'screen_name': screenName });
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */
async function setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */, { 'user_id': id });
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */
async function setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties)) {
            // use dot notation for merge behavior in gtag.js
            flatProperties[`user_properties.${key}`] = properties[key];
        }
        gtagFunction("set" /* GtagCommand.SET */, flatProperties);
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */
async function internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject) => {
        gtagFunction("get" /* GtagCommand.GET */, measurementId, 'client_id', (clientId) => {
            if (!clientId) {
                reject(esm_index_esm2017_ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */));
            }
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */
async function setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */
let defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */
function _setConsentDefaultForInit(consentSettings) {
    defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */
function _setDefaultEventParametersForInit(customParams) {
    defaultEventParametersForInit = customParams;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function validateIndexedDB() {
    if (!index_esm2017_isIndexedDBAvailable()) {
        index_esm2017_logger.warn(esm_index_esm2017_ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */, {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    }
    else {
        try {
            await index_esm2017_validateIndexedDBOpenable();
        }
        catch (e) {
            index_esm2017_logger.warn(esm_index_esm2017_ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */, {
                errorInfo: e === null || e === void 0 ? void 0 : e.toString()
            }).message);
            return false;
        }
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */
async function _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise
        .then(config => {
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId &&
            config.measurementId !== app.options.measurementId) {
            index_esm2017_logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` +
                ` does not match the measurement ID fetched from the server (${config.measurementId}).` +
                ` To ensure analytics events are always sent to the correct Analytics property,` +
                ` update the` +
                ` measurement ID field in the local config or remove it from the local config.`);
        }
    })
        .catch(e => index_esm2017_logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = validateIndexedDB().then(envIsValid => {
        if (envIsValid) {
            return installations.getId();
        }
        else {
            return undefined;
        }
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!findGtagScriptOnPage(dataLayerName)) {
        insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    }
    // Detects if there are consent settings that need to be configured.
    if (defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */, 'default', defaultConsentSettingsForInit);
        _setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) {
        configProperties[GA_FID_KEY] = fid;
    }
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */, dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if (defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */, defaultEventParametersForInit);
        _setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Analytics Service class.
 */
class AnalyticsService {
    constructor(app) {
        this.app = app;
    }
    _delete() {
        delete initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */
let initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */
let dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */
const measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */
let dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */
let gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */
let gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */
let wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */
let globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */
function settings(options) {
    if (globalInitDone) {
        throw esm_index_esm2017_ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */);
    }
    if (options.dataLayerName) {
        dataLayerName = options.dataLayerName;
    }
    if (options.gtagName) {
        gtagName = options.gtagName;
    }
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */
function warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if (index_esm2017_isBrowserExtension()) {
        mismatchedEnvMessages.push('This is a browser extension environment.');
    }
    if (!index_esm2017_areCookiesEnabled()) {
        mismatchedEnvMessages.push('Cookies are not available.');
    }
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages
            .map((message, index) => `(${index + 1}) ${message}`)
            .join(' ');
        const err = esm_index_esm2017_ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */, {
            errorInfo: details
        });
        index_esm2017_logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */
function factory(app, installations, options) {
    warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) {
        throw esm_index_esm2017_ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */);
    }
    if (!app.options.apiKey) {
        if (app.options.measurementId) {
            index_esm2017_logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` +
                ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` +
                ` provided in the "measurementId" field in the local Firebase config.`);
        }
        else {
            throw esm_index_esm2017_ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */);
        }
    }
    if (initializationPromisesMap[appId] != null) {
        throw esm_index_esm2017_ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */, {
            id: appId
        });
    }
    if (!globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        getOrCreateDataLayer(dataLayerName);
        const { wrappedGtag, gtagCore } = wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagName);
        wrappedGtagFunction = wrappedGtag;
        gtagCoreFunction = gtagCore;
        globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    initializationPromisesMap[appId] = _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCoreFunction, dataLayerName, options);
    const analyticsInstance = new AnalyticsService(app);
    return analyticsInstance;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
function getAnalytics(app = getApp()) {
    app = getModularInstance(app);
    // Dependencies
    const analyticsProvider = _getProvider(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        return analyticsProvider.getImmediate();
    }
    return initializeAnalytics(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
function initializeAnalytics(app, options = {}) {
    // Dependencies
    const analyticsProvider = index_esm2017_getProvider(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if (deepEqual(options, analyticsProvider.getOptions())) {
            return existingInstance;
        }
        else {
            throw esm_index_esm2017_ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */);
        }
    }
    const analyticsInstance = analyticsProvider.initialize({ options });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */
async function isSupported() {
    if (isBrowserExtension()) {
        return false;
    }
    if (!areCookiesEnabled()) {
        return false;
    }
    if (!isIndexedDBAvailable()) {
        return false;
    }
    try {
        const isDBOpenable = await validateIndexedDBOpenable();
        return isDBOpenable;
    }
    catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */
function setCurrentScreen(analyticsInstance, screenName, options) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setCurrentScreen$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch(e => index_esm2017_logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
async function getGoogleAnalyticsClientId(analyticsInstance) {
    analyticsInstance = getModularInstance(analyticsInstance);
    return internalGetGoogleAnalyticsClientId(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */
function index_esm2017_setUserId(analyticsInstance, id, options) {
    analyticsInstance = index_esm2017_getModularInstance(analyticsInstance);
    setUserId$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch(e => index_esm2017_logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */
function index_esm2017_setUserProperties(analyticsInstance, properties, options) {
    analyticsInstance = index_esm2017_getModularInstance(analyticsInstance);
    setUserProperties$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch(e => index_esm2017_logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */
function setAnalyticsCollectionEnabled(analyticsInstance, enabled) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setAnalyticsCollectionEnabled$1(initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch(e => index_esm2017_logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */
function setDefaultEventParameters(customParams) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) {
        wrappedGtagFunction("set" /* GtagCommand.SET */, customParams);
    }
    else {
        _setDefaultEventParametersForInit(customParams);
    }
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */
function index_esm2017_logEvent(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = index_esm2017_getModularInstance(analyticsInstance);
    logEvent$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch(e => index_esm2017_logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */
function setConsent(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) {
        wrappedGtagFunction("consent" /* GtagCommand.CONSENT */, 'update', consentSettings);
    }
    else {
        _setConsentDefaultForInit(consentSettings);
    }
}

const dist_esm_index_esm2017_name = "@firebase/analytics";
const esm_index_esm2017_version = "0.10.7";

/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
function registerAnalytics() {
    _registerComponent(new Component(ANALYTICS_TYPE, (container, { options: analyticsOptions }) => {
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container
            .getProvider('installations-internal')
            .getImmediate();
        return factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */));
    _registerComponent(new Component('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
    registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(dist_esm_index_esm2017_name, esm_index_esm2017_version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options) => index_esm2017_logEvent(analytics, eventName, eventParams, options)
            };
        }
        catch (e) {
            throw esm_index_esm2017_ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */, {
                reason: e
            });
        }
    }
}
registerAnalytics();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/firebase/analytics/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/firebase/app/dist/esm/index.esm.js



var index_esm_name = "firebase";
var index_esm_version = "10.12.5";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(index_esm_name, index_esm_version, 'app');
//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/report.ts + 289 modules
var report = __webpack_require__(80162);
// EXTERNAL MODULE: ./src/utils/error.ts
var utils_error = __webpack_require__(88295);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/utils/firebase.ts









var SERVICE_PLATFORM;
(function(SERVICE_PLATFORM) {
    SERVICE_PLATFORM["WEB"] = "web";
    SERVICE_PLATFORM["USER_WEB"] = "user_web";
})(SERVICE_PLATFORM || (SERVICE_PLATFORM = {}));
var SERVICE_UA_CATEGORY;
(function(SERVICE_UA_CATEGORY) {
    SERVICE_UA_CATEGORY["DEVICE"] = "device";
    SERVICE_UA_CATEGORY["BROWSER"] = "browser";
})(SERVICE_UA_CATEGORY || (SERVICE_UA_CATEGORY = {}));
var DEVICE_PLATFORM;
(function(DEVICE_PLATFORM) {
    DEVICE_PLATFORM["PC_WEB"] = "pc_web";
    DEVICE_PLATFORM["MOBILE_WEB"] = "mobile_web";
    DEVICE_PLATFORM["WEB_VIEW"] = "web_view";
})(DEVICE_PLATFORM || (DEVICE_PLATFORM = {}));
var Firebase = /*#__PURE__*/ function() {
    "use strict";
    function Firebase() {
        (0,_class_call_check/* default */.Z)(this, Firebase);
    }
    Firebase.hasInitializedApp = function hasInitializedApp() {
        try {
            return getApps().length > 0;
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:hasInitializedApp > error", {}, (0,utils_error/* getErrorObject */.T)(error));
            return false;
        }
    };
    Firebase.hasFullyInitialized = function hasFullyInitialized() {
        try {
            return getApps().length > 0 && this._analytics !== undefined;
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:hasFullyInitialized > error", {}, (0,utils_error/* getErrorObject */.T)(error));
            return false;
        }
    };
    Firebase.initApp = function initApp(userAgent, client) {
        if (this.hasFullyInitialized()) {
            return;
        }
        try {
            var webApp;
            if (this.hasInitializedApp()) {
                var apps = getApps();
                webApp = apps.find(function(app) {
                    return app.name === "doctornow-web";
                });
                if (!webApp) {
                    throw new Error("기존 Firebase 앱을 찾을 수 없습니다");
                }
            } else {
                webApp = initializeApp({
                    apiKey: "AIzaSyC1Te_JUAD_peZJg-8gWAVIowC3Qv9VRBA",
                    authDomain: "doctornow-web.firebaseapp.com",
                    databaseURL: "https://baedalyakgook.firebaseio.com",
                    projectId: "doctornow-web",
                    storageBucket: "doctornow-web.appspot.com",
                    messagingSenderId: "512351040521",
                    appId: "1:512351040521:web:cbcce24e6e7619fd9d74d8",
                    measurementId: "G-8NECV1E3F0"
                }, "doctornow-web");
            }
            var analyticsConfig = {
                config: {
                    send_page_view: false
                }
            };
            airbridge/* default.initialize */.Z.initialize();
            airbridge/* default.setClient */.Z.setClient(client);
            this._analytics = initializeAnalytics(webApp, analyticsConfig);
            var environmentProperties = this.getUserServiceEnvironmentProperty(userAgent);
            this.setUserProperties(environmentProperties);
            this.setDefaultEventParameters(environmentProperties);
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:initApp > error", {}, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.removeListener = function removeListener() {
        if (!this._unsubscribe) return;
        this._unsubscribe();
    };
    Firebase.logEventOnlyFirebase = function logEventOnlyFirebase(eventName, eventParams) {
        try {
            if (!this._analytics) return;
            index_esm2017_logEvent(this._analytics, eventName, eventParams);
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:logEvent > error", {
                error: error,
                eventName: eventName,
                eventParams: eventParams
            }, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.logEvent = function logEvent(eventName, eventParams) {
        try {
            if (!this._analytics) return;
            index_esm2017_logEvent(this._analytics, eventName, eventParams);
            airbridge/* default.trackEvent */.Z.trackEvent(eventName, eventParams);
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:logEvent > error", {
                error: error,
                eventName: eventName,
                eventParams: eventParams
            }, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.setUserProperties = function setUserProperties(properties) {
        try {
            if (!this._analytics) return;
            index_esm2017_setUserProperties(this._analytics, (0,_object_spread/* default */.Z)({}, properties));
            airbridge/* default.setUserProperties */.Z.setUserProperties(properties);
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:setUserProperties > error", {
                properties: properties
            }, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.setUserId = function setUserId(id) {
        try {
            if (!this._analytics) return;
            index_esm2017_setUserId(this._analytics, id);
            airbridge/* default.setUserId */.Z.setUserId(id);
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:setUserId > error", {
                userId: id
            }, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.setDefaultEventParameters = function setDefaultEventParameters1(properties) {
        try {
            if (!this._analytics) return;
            setDefaultEventParameters((0,_object_spread/* default */.Z)({}, properties));
        } catch (error) {
            (0,report/* infoReport */.pP)("Firebase:setDefaultEventParameters > error", {}, (0,utils_error/* getErrorObject */.T)(error));
        }
    };
    Firebase.getMobileWebUserServiceEnvironmentProperty = function getMobileWebUserServiceEnvironmentProperty() {
        return {
            service_platform: SERVICE_PLATFORM.USER_WEB,
            service_ua_category: SERVICE_UA_CATEGORY.BROWSER,
            device_platform: DEVICE_PLATFORM.MOBILE_WEB,
            env: (0,env/* getEnv */.dU)()
        };
    };
    Firebase.getUserServiceEnvironmentProperty = function getUserServiceEnvironmentProperty(userAgent) {
        if ((0,RNPlugins/* isWebViewByUserAgent */.c0)(userAgent)) {
            // 웹뷰
            return {
                service_platform: SERVICE_PLATFORM.USER_WEB,
                service_ua_category: SERVICE_UA_CATEGORY.DEVICE,
                device_platform: DEVICE_PLATFORM.WEB_VIEW,
                env: (0,env/* getEnv */.dU)()
            };
        }
        if ((0,RNPlugins/* isMobileWebByUserAgent */.hn)(userAgent)) {
            // 모바일 웹
            return {
                service_platform: SERVICE_PLATFORM.USER_WEB,
                service_ua_category: SERVICE_UA_CATEGORY.BROWSER,
                device_platform: DEVICE_PLATFORM.MOBILE_WEB,
                env: (0,env/* getEnv */.dU)()
            };
        }
        // 웹
        return {
            service_platform: SERVICE_PLATFORM.WEB,
            service_ua_category: SERVICE_UA_CATEGORY.BROWSER,
            device_platform: DEVICE_PLATFORM.PC_WEB,
            env: (0,env/* getEnv */.dU)()
        };
    };
    return Firebase;
}();
/* harmony default export */ var firebase = (Firebase);


/***/ }),

/***/ 4611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ convertMarkdownToPlainText; },
/* harmony export */   "Ej": function() { return /* binding */ getRatingTitle; },
/* harmony export */   "G9": function() { return /* binding */ getFormattedReviewTotalCount; },
/* harmony export */   "IA": function() { return /* binding */ parseDashTel; },
/* harmony export */   "JH": function() { return /* binding */ isEventLabel; },
/* harmony export */   "LI": function() { return /* binding */ getUserAddressTypeTitle; },
/* harmony export */   "M": function() { return /* binding */ createSearchHospitalLdJson; },
/* harmony export */   "PT": function() { return /* binding */ getDiagnosisStateOfOperatingStatus; },
/* harmony export */   "QN": function() { return /* binding */ getDiagnosisStateText; },
/* harmony export */   "Ux": function() { return /* binding */ getUserAge; },
/* harmony export */   "aD": function() { return /* binding */ getSatisfactionText; },
/* harmony export */   "dM": function() { return /* binding */ formatPriceComma; },
/* harmony export */   "ds": function() { return /* binding */ getReviewScore; },
/* harmony export */   "eB": function() { return /* binding */ refreshedTimeAt; },
/* harmony export */   "eu": function() { return /* binding */ getQndAnswererMedicalStaffType; },
/* harmony export */   "hX": function() { return /* binding */ displayedAt; },
/* harmony export */   "hq": function() { return /* binding */ getCommonFilterQueryString; },
/* harmony export */   "jV": function() { return /* binding */ createMainPageLdJson; },
/* harmony export */   "kE": function() { return /* binding */ isNumeric; },
/* harmony export */   "mo": function() { return /* binding */ getCurrencyFormat; },
/* harmony export */   "ox": function() { return /* binding */ formatKilometerByMeter; },
/* harmony export */   "pC": function() { return /* binding */ getDetailSymptomText; },
/* harmony export */   "pg": function() { return /* binding */ createHospitalLdJson; },
/* harmony export */   "r3": function() { return /* binding */ nonBenefitSeoLdJson; },
/* harmony export */   "tX": function() { return /* binding */ getUserAddressType; },
/* harmony export */   "wE": function() { return /* binding */ absoluteTime; },
/* harmony export */   "xt": function() { return /* binding */ absoluteDate; },
/* harmony export */   "zV": function() { return /* binding */ sortImageBlindTypeFormat; },
/* harmony export */   "zj": function() { return /* binding */ getAnswerDetail; },
/* harmony export */   "zm": function() { return /* binding */ formatShareUrl; }
/* harmony export */ });
/* unused harmony exports formatToKRW, getQnaAnswerStatusLabel, getQnaAnswerStatus, getSortTypeName, getDepartmentReviewFilter, getDoctorReviewFilter, getDayOfTheWeekToTitle, getDayOfTheWeekToColor, formatKilometer, formatKilometerByMeterWithNoDecimal, getBoardPostTagLabel, getMedicineType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87394);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_f2f__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93247);
/* harmony import */ var _models_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18044);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44376);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72271);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70138);
/* harmony import */ var _types_community__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45140);
/* harmony import */ var _types_hospital__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24396);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74735);











var displayedAt = function(date) {
    var milliSeconds = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date));
    var seconds = milliSeconds / 1000;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    if (days >= 7) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY.MM.DD");
    }
    if (hours < 1) {
        return "방금 전";
    } else if (hours < 24) {
        return "".concat(Math.floor(hours), "시간 전");
    } else {
        return "".concat(Math.floor(days), "일 전");
    }
};
var absoluteDate = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY.MM.DD");
};
var absoluteTime = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY-MM-DDThh:mm:ssTZD|PTDHMS");
};
// 1000 -> 1,000
var getCurrencyFormat = function(num) {
    return num === null || num === void 0 ? void 0 : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var formatToKRW = function(amount) {
    return new Intl.NumberFormat("ko-KR").format(amount) + "원";
};
var getUserAge = function(birth) {
    var ref;
    var getYear = function() {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().year();
    };
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getYear() - Number((ref = birth.match(/^(\d{4})-/)) === null || ref === void 0 ? void 0 : ref[1]) + 1;
};
var formatShareUrl = function(url) {
    return "".concat("https://doctornow.co.kr").concat(url);
};
var refreshedTimeAt = function(date) {
    var milliSeconds = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date));
    var seconds = milliSeconds / 1000;
    var minutes = seconds / 60;
    if (minutes < 1) {
        return "방금 전";
    } else if (minutes >= 4) {
        return "4분 전";
    } else {
        return "".concat(Math.floor(minutes), "분 전");
    }
};
var sortImageBlindTypeFormat = function(attachments) {
    /* 리스트, 상세페이지 사진 노출
   * NONE -> DIMMED -> BLINDE 순
   * 질문 리스트에서 이미지 노출 추가되면서 최대한 공개된 사진 위주로 보여주기위해
   * 중간에 DIMMED 까지 정렬함
   */ return attachments.filter(function(x) {
        return x.blindType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AttachmentBlindType.None */ .jzP.None;
    }).concat(attachments.filter(function(x) {
        return x.blindType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AttachmentBlindType.Dimmed */ .jzP.Dimmed;
    })).concat(attachments.filter(function(x) {
        return x.blindType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AttachmentBlindType.Blinded */ .jzP.Blinded;
    }));
};
var getQnaAnswerStatusLabel = function(status) {
    switch(status){
        case QuestionAnsweredStatus.Answered:
            return "답변완료";
        case QuestionAnsweredStatus.Answering:
            return "답변중";
        default:
            return "확인중";
    }
};
var getQnaAnswerStatus = function(status) {
    switch(status){
        case QuestionAnsweredStatus.Checking:
            return "질문 확인 중";
        case QuestionAnsweredStatus.Answering:
            return "답변 작성 중";
        default:
            return "답변완료";
    }
};
var getQndAnswererMedicalStaffType = function(type, name) {
    switch(type){
        case "NURSE":
            return "닥터나우 의료진";
        case "AI":
            return "".concat(name);
        default:
            return "".concat(name, " 선생님");
    }
};
var getSortTypeName = function(sort) {
    switch(sort){
        case ReviewSortType.RECENT:
            return "최신순";
        case ReviewSortType.LOW:
            return "별점 낮은 순";
        case ReviewSortType.HIGH:
            return "별점 높은 순";
    }
};
var isNumeric = function(text) {
    return /^[0-9]+$/.test(text);
};
var getRatingTitle = function(rating) {
    var ratingTitle = {
        5: "매우 만족",
        4: "만족",
        3: "보통",
        2: "불만족",
        1: "매우 불만족"
    };
    return ratingTitle["".concat(rating)];
};
var getDepartmentReviewFilter = function(departmentFilter) {
    return {
        count: departmentFilter.count,
        id: Number(departmentFilter.diagnosisTypeId),
        name: departmentFilter.name
    };
};
var getDoctorReviewFilter = function(doctorFilter) {
    return {
        count: doctorFilter.reviewMetric.totalCount,
        id: Number(doctorFilter.id),
        name: doctorFilter.name
    };
};
var getDiagnosisStateOfOperatingStatus = function(operationgStatus) {
    switch(operationgStatus){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HospitalOperatingStatus.Open */ .eKF.Open:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.On */ .J0.On;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HospitalOperatingStatus.Closed */ .eKF.Closed:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Off */ .J0.Off;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HospitalOperatingStatus.Lunch */ .eKF.Lunch:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Lunch */ .J0.Lunch;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HospitalOperatingStatus.DayOff */ .eKF.DayOff:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.DayOff */ .J0.DayOff;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HospitalOperatingStatus.Unknown */ .eKF.Unknown:
        default:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Unknown */ .J0.Unknown;
    }
};
var getDayOfTheWeekToTitle = function(dayOfWeek) {
    switch(dayOfWeek){
        case DayOfWeekType.Monday:
            return "월";
        case DayOfWeekType.Tuesday:
            return "화";
        case DayOfWeekType.Wednesday:
            return "수";
        case DayOfWeekType.Thursday:
            return "목";
        case DayOfWeekType.Friday:
            return "금";
        case DayOfWeekType.Saturday:
            return "토";
        case DayOfWeekType.Sunday:
            return "일";
        case DayOfWeekType.Holiday:
            return "공휴일";
    }
};
var getDayOfTheWeekToColor = function(dayOfWeek) {
    switch(dayOfWeek){
        case DayOfWeekType.Holiday:
        case DayOfWeekType.Sunday:
            return theme.color.red700;
        case DayOfWeekType.Saturday:
            return theme.color.blue700;
        case DayOfWeekType.Monday:
        case DayOfWeekType.Tuesday:
        case DayOfWeekType.Wednesday:
        case DayOfWeekType.Thursday:
        case DayOfWeekType.Friday:
            return theme.color.gray800;
    }
};
var formatKilometer = function(meter) {
    return meter / 1000;
};
var formatKilometerByMeter = function(meter) {
    if (meter >= 1000) {
        var result = (meter / 1000).toFixed(1);
        return result + "km";
    } else {
        return meter.toFixed(1) + "m";
    }
};
var formatKilometerByMeterWithNoDecimal = function(meter) {
    if (meter >= 1000) {
        var result = Math.floor(meter / 1000);
        return result + "km";
    } else {
        return Math.floor(meter) + "m";
    }
};
var getReviewScore = function(number) {
    var numberLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var score = Math.floor(number * 10) / 10;
    return score.toPrecision(numberLength);
};
var getBoardPostTagLabel = function(type) {
    switch(type){
        case BOARD_POST_TAG_TYPE.RECOMMENDED:
            return "추천";
        case BOARD_POST_TAG_TYPE.POPULAR:
        default:
            return "인기";
    }
};
var getDiagnosisStateText = function(state) {
    switch(state){
        case _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.On */ .J0.On:
            return "진료중";
        case _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Off */ .J0.Off:
            return "진료종료";
        case _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Lunch */ .J0.Lunch:
            return "휴게시간";
        case _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.DayOff */ .J0.DayOff:
            return "휴무";
        case _types_hospital__WEBPACK_IMPORTED_MODULE_7__/* .DiagnosisState.Unknown */ .J0.Unknown:
            return "확인필요";
    }
};
var getUserAddressTypeTitle = function(addressType) {
    switch(addressType){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Home */ .DLH.Home:
            return "집";
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Company */ .DLH.Company:
            return "회사";
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Others */ .DLH.Others:
            return "기타";
        default:
            return "기타";
    }
};
var getUserAddressType = function(addressType) {
    switch(addressType){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Home */ .DLH.Home:
            return _models_common__WEBPACK_IMPORTED_MODULE_2__/* .UserAddressType.Home */ .IX.Home;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Company */ .DLH.Company:
            return _models_common__WEBPACK_IMPORTED_MODULE_2__/* .UserAddressType.Company */ .IX.Company;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_4__/* .AddressType.Others */ .DLH.Others:
            return _models_common__WEBPACK_IMPORTED_MODULE_2__/* .UserAddressType.Others */ .IX.Others;
        default:
            return _models_common__WEBPACK_IMPORTED_MODULE_2__/* .UserAddressType.Others */ .IX.Others;
    }
};
var parseDashTel = function(str) {
    if (typeof str !== "string") return "";
    str = str.replace(/[^0-9]/g, "");
    if (str.indexOf("82") == 0) {
        return str.replace(/(^82)(2|\d{2})(\d+)?(\d{4})$/, "+$1-$2-$3-$4"); // +82
    } else if (str.indexOf("1") == 0) {
        return str.replace(/(^1\d{3})(\d{4})$/, "$1-$2"); // 1588, 1566, 1677, ...
    }
    return str.replace(/(^02|^0501|^0502|^0503|^0504|^0505|^0506|^0507|^0508|^0509|^0\d{2})(\d+)?(\d{4})$/, "$1-$2-$3"); // 02/0501/0502/0503/0504/0505/0506/0507/0508/0509/010/011/031
};
var getFormattedReviewTotalCount = function(totalCount) {
    return "".concat(totalCount);
};
function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
var convertMarkdownToPlainText = function(text) {
    if (!text) return "";
    // Step 1: Remove markdown images
    var processedText = text.replace(/!\[[^\]]*\]\([^)]+\)/g, "");
    // Step 2: Replace markdown links with just the text part
    processedText = processedText.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
    // Step 3: Remove HTML tags and their content
    processedText = processedText.replace(/<[^>]*>/g, "");
    // Step 4: Replace markdown tables
    processedText = processedText.replace(/\|[^|]*\|/g, " ");
    // Step 5: Replace other markdown formatting
    processedText = processedText// Bold: **text** -> text
    .replace(/\*\*([^*]+)\*\*/g, "$1")// Italic: *text* -> text
    .replace(/\*([^*]+)\*/g, "$1")// Headers: ## Header -> Header
    .replace(/^#+\s+(.+)$/gm, "$1")// Inline code: `code` -> code
    .replace(/`([^`]+)`/g, "$1")// Strikethrough: ~~text~~ -> text
    .replace(/~~([^~]+)~~/g, "$1")// Blockquotes: > quote -> quote
    .replace(/^>\s+(.+)$/gm, "$1");
    // Step 6: Clean up whitespace
    processedText = processedText// Replace multiple newlines with a single space
    .replace(/\n+/g, " ")// Replace multiple spaces with a single space
    .replace(/\s+/g, " ")// Trim leading and trailing whitespace
    .trim();
    return processedText;
};
var createHospitalLdJson = function(hospital, reviewData, publicId) {
    var foundHospitalImage = hospital === null || hospital === void 0 ? void 0 : hospital.profileImages.find(function(image) {
        return !image.url.includes("hospital_default");
    });
    var localBusinessJson = {
        "@context": "https://schema.org",
        "@type": "MedicalBusiness"
    };
    if (hospital === null || hospital === void 0 ? void 0 : hospital.name) {
        localBusinessJson.name = "".concat(hospital.name);
    }
    if (foundHospitalImage) {
        localBusinessJson.image = foundHospitalImage.url;
    }
    if (publicId) {
        localBusinessJson.url = "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.DETAIL.path */ .Z6.HOSPITAL.DETAIL.path).concat(publicId);
    }
    if (!!(reviewData === null || reviewData === void 0 ? void 0 : reviewData.averageRating) && !!(reviewData === null || reviewData === void 0 ? void 0 : reviewData.totalCount)) {
        localBusinessJson.aggregateRating = {
            "@type": "AggregateRating",
            ratingValue: "".concat(reviewData.averageRating),
            reviewCount: "".concat(reviewData.totalCount)
        };
    }
    if ((hospital === null || hospital === void 0 ? void 0 : hospital.roadAddress) || (hospital === null || hospital === void 0 ? void 0 : hospital.jibunAddress)) {
        var ref;
        var address = (ref = (hospital === null || hospital === void 0 ? void 0 : hospital.roadAddress) || (hospital === null || hospital === void 0 ? void 0 : hospital.jibunAddress)) !== null && ref !== void 0 ? ref : "";
        var streetAddress = "".concat((hospital === null || hospital === void 0 ? void 0 : hospital.roadAddress) || (hospital === null || hospital === void 0 ? void 0 : hospital.jibunAddress)).concat((hospital === null || hospital === void 0 ? void 0 : hospital.detailAddress) ? " ".concat(hospital.detailAddress) : "");
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(address.split(" "), 2), region = ref1[0], locality = ref1[1];
        localBusinessJson.address = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            "@type": "PostalAddress",
            streetAddress: streetAddress,
            addressCountry: "대한민국"
        }, region && locality ? {
            addressRegion: region,
            addressLocality: locality
        } : {});
    }
    if ((hospital === null || hospital === void 0 ? void 0 : hospital.latitude) && hospital.longitude) {
        localBusinessJson.geo = {
            "@type": "GeoCoordinates",
            latitude: "".concat(hospital.latitude),
            longitude: "".concat(hospital.longitude)
        };
    }
    if (hospital === null || hospital === void 0 ? void 0 : hospital.tel) {
        localBusinessJson.telephone = parseDashTel(hospital.tel);
    }
    if (hospital === null || hospital === void 0 ? void 0 : hospital.duties) {
        var _openTime, _closeTime;
        var validDuties = hospital.duties.filter(function(duty) {
            return !!duty.openTime && !!duty.closeTime && !duty.isClosed;
        }).map(function(duty) {
            return {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: capitalize(duty.dayOfWeek),
                opens: (_openTime = duty.openTime) !== null && _openTime !== void 0 ? _openTime : "",
                closes: (_closeTime = duty.closeTime) !== null && _closeTime !== void 0 ? _closeTime : ""
            };
        });
        if (validDuties.length > 0) {
            localBusinessJson.openingHoursSpecification = validDuties;
        }
    }
    if (hospital === null || hospital === void 0 ? void 0 : hospital.partnershipTemplate) {
        var ref2;
        var departmentList = (ref2 = hospital === null || hospital === void 0 ? void 0 : hospital.departmentGroups) !== null && ref2 !== void 0 ? ref2 : [];
        localBusinessJson.description = "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.regionByDepth.eupMyeonDongName, " ").concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, "에서, ").concat(departmentList.slice(0, 3).map(function(departmentGroup) {
            return departmentGroup.departmentGroupName;
        }).join(", "), " 진료를 바로 예약할 수 있어요. 76,614개 병원이 모인 닥터나우에서 내게 딱 맞는 병원을 찾아보세요!");
        if (departmentList.length > 0) {
            localBusinessJson.department = "".concat(departmentList.map(function(department) {
                return department.departmentGroupName;
            }).join(", "));
        }
    } else {
        var ref3;
        var departmentList1 = (ref3 = hospital === null || hospital === void 0 ? void 0 : hospital.departmentsV2) !== null && ref3 !== void 0 ? ref3 : [];
        localBusinessJson.description = "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.regionByDepth.eupMyeonDongName, " ").concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, "에서, ").concat(departmentList1.slice(0, 3).map(function(department) {
            return department.departmentName;
        }).join(", "), " 진료를 바로 예약할 수 있어요. 76,614개 병원이 모인 닥터나우에서 내게 딱 맞는 병원을 찾아보세요!");
        if (departmentList1.length > 0) {
            localBusinessJson.department = "".concat(departmentList1.map(function(department) {
                return department.departmentName;
            }).join(", "));
        }
    }
    return localBusinessJson;
};
var createSearchHospitalLdJson = function(searchedHospitals, keyword) {
    var ref;
    var hospitals = searchedHospitals.slice(0, 20);
    var ref1;
    var totalCount = (ref1 = (ref = searchedHospitals[0]) === null || ref === void 0 ? void 0 : ref.hospitalTotalCount) !== null && ref1 !== void 0 ? ref1 : 0;
    var title = keyword ? "".concat(keyword, " 인기 병원 TOP10 - 닥터나우") : "인기 병원 TOP10 - 닥터나우";
    var description = keyword ? "인기 병원을 바로 예약할 수 있어요. TOP10을 포함한 ".concat(keyword, " ").concat(totalCount, "개 중 나에게 꼭 맞는 병원을 선택해 보세요!") : "인기 병원을 바로 예약할 수 있어요. TOP10을 포함한 76,614개 중 나에게 꼭 맞는 병원을 선택해 보세요!";
    var canonical = keyword ? "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.SEARCH.path */ .Z6.HOSPITAL.SEARCH.path, "?keyword=").concat(keyword) : "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.SEARCH.path */ .Z6.HOSPITAL.SEARCH.path);
    return [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr"),
            logo: "".concat("https://media.doctornow.co.kr/og-main.png"),
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    email: "contact@doctornow.co.kr",
                    contactType: "customer service"
                }, 
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "".concat("https://doctornow.co.kr"),
            potentialAction: {
                "@type": "SearchAction",
                target: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.SEARCH.path */ .Z6.HOSPITAL.SEARCH.path, "?keyword={keyword}"),
                "query-input": "required name=keyword"
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: title,
            description: description,
            url: canonical,
            itemListElement: hospitals.map(function(hospital, i) {
                return {
                    "@type": "ListItem",
                    position: "".concat(i + 1),
                    name: hospital.hospitalName,
                    url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.DETAIL.path */ .Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId)
                };
            })
        }, 
    ];
};
var nonBenefitSeoLdJson = function(params) {
    var doctors = params.doctors, canonical = params.canonical, faqs = params.faqs;
    var ldJson = [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr"),
            logo: "".concat("https://media.doctornow.co.kr/og-main.png"),
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    email: "contact@doctornow.co.kr",
                    contactType: "customer service"
                }, 
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "".concat("https://doctornow.co.kr"),
            potentialAction: {
                "@type": "SearchAction",
                target: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path, "?treatmentMedicineUnitId={id}"),
                "query-input": "required name=id"
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq) {
                return {
                    "@type": "Question",
                    name: faq.title,
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: convertMarkdownToPlainText(faq.description)
                    }
                };
            })
        }, 
    ];
    if (doctors.length > 0) {
        ldJson.push({
            "@context": "https://schema.org",
            "@type": "ItemList",
            url: canonical,
            itemListElement: doctors.map(function(doctor, i) {
                return {
                    "@type": "ListItem",
                    position: "".concat(i + 1),
                    name: doctor.doctorDisplayName,
                    url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.DOCTOR.DETAIL.path */ .Z6.DOCTOR.DETAIL.path, "/").concat(doctor.doctorId)
                };
            })
        });
    }
    return ldJson;
};
var createMainPageLdJson = function() {
    var submenuItems = [
        {
            name: "우리동네 진료 가격",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path)
        },
        {
            name: "최저가 약국 찾기",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.NON_BENEFIT.MAP.path */ .Z6.NON_BENEFIT.MAP.path)
        },
        {
            name: "지역별 병원 정보",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.NEIGHBORHOOD.path */ .Z6.HOSPITAL.NEIGHBORHOOD.path)
        },
        {
            name: "가까운 병원 찾기",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path)
        },
        {
            name: "실시간 의료상담",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path)
        },
        {
            name: "건강 매거진",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path)
        },
        {
            name: "1분 FAQ",
            url: "".concat("https://doctornow.co.kr").concat(_types_common__WEBPACK_IMPORTED_MODULE_5__/* .ROUTES.FAQ.LIST.path */ .Z6.FAQ.LIST.path)
        },
        {
            name: "회사 소개",
            url: "".concat("https://company.doctornow.co.kr", "/company")
        },
        {
            name: "팀 문화",
            url: "".concat("https://company.doctornow.co.kr", "/culture")
        },
        {
            name: "서비스 소개",
            url: "".concat("https://company.doctornow.co.kr", "/service")
        },
        {
            name: "제휴 안내",
            url: "".concat("https://company.doctornow.co.kr", "/partnership")
        },
        {
            name: "소식 \xb7 공지",
            url: "".concat("https://company.doctornow.co.kr", "/notice")
        },
        {
            name: "채용 공고",
            url: "".concat("https://company.doctornow.co.kr", "/career")
        }, 
    ];
    return [
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            alternateName: "DoctorNow",
            url: "".concat("https://doctornow.co.kr"),
            logo: "".concat("https://media.doctornow.co.kr/og-main.png"),
            foundingDate: "2019",
            foundingLocation: "Seoul, KR",
            sameAs: [
                // 인스타그램
                "https://www.instagram.com/doctornow_official",
                // 카카오톡 채널
                "https://pf.kakao.com/_whSxnK",
                // 유튜브
                "https://www.youtube.com/@doctornow_official",
                // 네이버 블로그
                "https://blog.naver.com/doctornow_official",
                // 쓰레드
                "https://www.threads.com/@doctornow_official",
                // 틱톡
                "https://www.tiktok.com/@doctornow.official",
                // 구글 플레이 스토어
                "https://play.google.com/store/apps/details?id=com.baedalyakgook_user&hl=ko",
                // 애플 앱 스토어
                "https://apps.apple.com/kr/app/%EB%8B%A5%ED%84%B0%EB%82%98%EC%9A%B0-%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD-1%EC%9C%84-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%95%B1/id1513718380", 
            ],
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    contactType: "customer service",
                    email: "contact@doctornow.co.kr",
                    availableLanguage: [
                        "ko"
                    ],
                    areaServed: "KR"
                }, 
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "".concat("https://doctornow.co.kr"),
            name: "닥터나우",
            potentialAction: {
                "@type": "SearchAction",
                target: "".concat("https://doctornow.co.kr", "/search?keyword={query}"),
                "query-input": "required name=query"
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "ItemList",
            url: "".concat("https://doctornow.co.kr"),
            itemListElement: submenuItems.map(function(menuItem, i) {
                return {
                    "@type": "ListItem",
                    position: "".concat(i + 1),
                    name: menuItem.name,
                    url: menuItem.url
                };
            })
        },
        {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "회사소개 \xb7 채용 | 닥터나우",
            url: "".concat("https://company.doctornow.co.kr")
        }, 
    ];
};
var getAnswerDetail = function(answer) {
    var header = answer.header, content = answer.content, footer = answer.footer;
    if (!header && !footer) {
        return content;
    }
    var temp = content;
    if (header) {
        temp = header + "\n\n" + temp;
    }
    if (footer) {
        temp = temp + "\n\n" + footer;
    }
    return temp;
};
var getDetailSymptomText = function(type) {
    if (!type) {
        return undefined;
    }
    switch(type){
        case _constants_f2f__WEBPACK_IMPORTED_MODULE_1__/* .INFLUENZA */ .yA:
            return _constants_f2f__WEBPACK_IMPORTED_MODULE_1__/* .INFLUENZA_DEFAULT_PLACEHOLDER */ .FK;
        default:
            return "".concat(type, " 상담");
    }
};
var isEventLabel = function(category) {
    var EventLabel = "이벤트";
    return category.label === EventLabel;
};
var getCommonFilterQueryString = function(commonFilter) {
    var selectedCommonFilterKeys = Object.entries(commonFilter).reduce(function(acc, cur) {
        var _cur = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(cur, 2), key = _cur[0], value = _cur[1];
        if (value) {
            acc.push(key);
        }
        return acc;
    }, []);
    return (0,_utils_url__WEBPACK_IMPORTED_MODULE_8__/* .stringifyToArray */ .jl)(selectedCommonFilterKeys);
};
var getMedicineType = function(type) {
    switch(type){
        case MedicineType.OrientalDoctor:
            return "한의사";
        case MedicineType.Doctor:
        default:
            return "의사";
    }
};
var formatPriceComma = function(x) {
    var ref;
    return (ref = x === null || x === void 0 ? void 0 : x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) !== null && ref !== void 0 ? ref : "0";
};
var getSatisfactionText = function(score) {
    var satisfactionTexts = [
        "",
        "매우 별로에요",
        "별로에요",
        "그저 그래요",
        "만족해요",
        "매우 만족해요"
    ];
    var ref;
    return (ref = satisfactionTexts["".concat(score)]) !== null && ref !== void 0 ? ref : satisfactionTexts[0];
};


/***/ }),

/***/ 59421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _hackler_javascript_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46438);




var Hackle = /*#__PURE__*/ function() {
    "use strict";
    function Hackle() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Hackle);
    }
    Hackle.createHackle = function createHackle() {
        var hackleClient = _hackler_javascript_sdk__WEBPACK_IMPORTED_MODULE_0__/* .createInstance */ .Fs("SX3QSjTQ2RzGiFcspwMGdJW6LBOw08A6" || 0, {
            debug: false
        });
        this._hackleClient = hackleClient;
        return hackleClient;
    };
    Hackle.variation = function variation(id) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve) {
                                if (!_this._hackleClient) {
                                    return;
                                } else {
                                    _this._hackleClient.onReady(function() {
                                        var ref;
                                        var variation = (ref = _this._hackleClient) === null || ref === void 0 ? void 0 : ref.variation(id);
                                        resolve(variation);
                                    });
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    };
    Hackle.getUser = function getUser() {
        if (!this._hackleClient) return;
        return this._hackleClient.getUser();
    };
    Hackle.setUserId = function setUserId(userId) {
        if (!this._hackleClient) return;
        this._hackleClient.setUserId(userId);
    };
    Hackle.setDeviceId = function setDeviceId(deviceId) {
        if (!this._hackleClient) return;
        this._hackleClient.setDeviceId(deviceId);
    };
    Hackle.setUserProperty = function setUserProperty(key, value) {
        if (!this._hackleClient) return;
        this._hackleClient.setUserProperty(key, value);
    };
    Hackle.resetUser = function resetUser() {
        if (!this._hackleClient) return;
        this._hackleClient.resetUser();
    };
    Hackle.track = function track(event) {
        if (!this._hackleClient) return;
        var user = this.getUser();
        this._hackleClient.track(event, user);
    };
    return Hackle;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Hackle);


/***/ }),

/***/ 78287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pp": function() { return /* binding */ mobileLogger; },
/* harmony export */   "S4": function() { return /* binding */ communityLogger; },
/* harmony export */   "SH": function() { return /* binding */ DomainTypeForLogger; },
/* harmony export */   "Uj": function() { return /* binding */ magazineLogger; },
/* harmony export */   "b9": function() { return /* binding */ getMobileWebPageName; },
/* harmony export */   "cl": function() { return /* binding */ coreLogger; },
/* harmony export */   "j0": function() { return /* binding */ getPageName; },
/* harmony export */   "kg": function() { return /* binding */ logger; },
/* harmony export */   "lp": function() { return /* binding */ faqLogger; },
/* harmony export */   "vS": function() { return /* binding */ faceTofaceLogger; }
/* harmony export */ });
/* unused harmony exports getPageNameForLogging, getPageNameForUrlPathname, getEventNameForLogging, qnaLogger */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87394);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96009);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16765);
/* harmony import */ var lodash_set__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5322);
/* harmony import */ var _constants_logs_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78081);
/* harmony import */ var _utils_pixel_pixel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5863);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59334);
/* harmony import */ var _mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10712);










var DomainTypeForLogger;
(function(DomainTypeForLogger) {
    DomainTypeForLogger["WEB_DIAGNOSIS"] = "web_diagnosis";
    DomainTypeForLogger["COMMUNITY"] = "community";
    DomainTypeForLogger["QNA"] = "qna";
    DomainTypeForLogger["MAGAZINE"] = "magazine";
    DomainTypeForLogger["FACE_TO_FACE"] = "face_to_face";
    DomainTypeForLogger["CORE"] = "core";
    DomainTypeForLogger["FAQ"] = "faq";
})(DomainTypeForLogger || (DomainTypeForLogger = {}));
var logger = function(param) {
    var eventName = param.eventName, pageName = param.pageName, payload = param.payload;
    if (_constants_env__WEBPACK_IMPORTED_MODULE_2__/* .IS_LOCAL */ .Kc) {
        var ref;
        console.log("logger >>", (ref = {
            eventName: eventName,
            pageName: pageName,
            payload: payload
        }) !== null && ref !== void 0 ? ref : "");
    }
    var attributes = {
        page_name: pageName
    };
    if (payload) {
        Object.entries(payload).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            if (typeof value === "number") {
                lodash_set__WEBPACK_IMPORTED_MODULE_1___default()(attributes, key, value.toString());
            } else {
                lodash_set__WEBPACK_IMPORTED_MODULE_1___default()(attributes, key, value);
            }
        });
    }
    _firebase__WEBPACK_IMPORTED_MODULE_5__/* ["default"].logEvent */ .Z.logEvent(eventName, attributes);
};
var PIXEL_EVENT_NAME_LIST = [
    "click_survey_start",
    "click_survey_submit",
    "click_counseling_request",
    "complete_survey_submit",
    "signup", 
];
var evaluatePixelLog = function(props) {
    if ((0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)()) return;
    var _logger = props.logger, eventName = _logger.eventName, pageName = _logger.pageName;
    if (PIXEL_EVENT_NAME_LIST.includes(eventName)) {
        _utils_pixel_pixel__WEBPACK_IMPORTED_MODULE_4__/* ["default"].trackCustom */ .Z.trackCustom(eventName, {
            page_name: pageName
        });
    }
};
/**
 * GA에서 허용하는 형식으로 eventName을 변환하는 함수
 * GA에서는 언더바(_)를 제외한 특수문자를 허용하지 않으므로
 * 영문, 숫자, 언더바는 유지하고 특수문자만 언더바로 대체
 */ var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var mobileLogger = function(propsParams) {
    if (_constants_env__WEBPACK_IMPORTED_MODULE_2__/* .IS_LOCAL */ .Kc) {
        var ref;
        return console.log("logger >>", (ref = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, propsParams)) !== null && ref !== void 0 ? ref : "");
    }
    var sanitizedEventName = sanitizeEventName(propsParams.logger.eventName.slice(0, 40));
    /* GA로그에서 이벤트명은 40자까지 허용 */ var params = {
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, propsParams.logger), {
            eventName: sanitizedEventName
        })
    };
    if (params.logger.eventName === _constants_logs_common__WEBPACK_IMPORTED_MODULE_3__/* .CommonLoggerEventName.PageView */ .q.PageView && !params.logger.pageName.trim()) {
        return;
    }
    evaluatePixelLog(params);
    if ((0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)()) {
        return (0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .sendPostMessageToNative */ .T0)(_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .NATIVE_POST_MESSAGE_TYPE.LOGGER */ .nn.LOGGER, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, params));
    }
    logger((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, params.logger));
};
/**
 *
 * @param url NextRouter
 *
 */ var getPageName = function(url) {
    return getPageNameForUrlPathname(url.pathname);
};
var getMobileWebPageName = function(url) {
    return getPageName(url);
};
var toCamelCase = function(str) {
    return camelCase(str);
};
var camelToSnakeCase = function(str) {
    return str.replace(/[A-Z]/g, function(letter) {
        return "_".concat(letter.toLowerCase());
    });
};
var getPageNameForLogging = function(url) {
    return url.split("/").slice(1).filter(function(path) {
        return !path.includes("[");
    }).map(camelToSnakeCase).join("_");
};
var removeSquareBrackets = function(str) {
    return str.replace(/\[|\]/g, "");
};
var replaceIdPath = function(str) {
    return str.replace(/\[([^\]]*?)([iI][dD])([^\]]*?)\]/g, function(match) {
        if (/[iI][dD]/.test(match)) {
            return "[id]";
        } else {
            return match;
        }
    });
};
var limitMaxLength = function(str, length) {
    return str.length > length ? str.slice(0, length) : str;
};
var removeDashbar = function(str) {
    return str.replace(/-/g, "");
};
var getPageNameForUrlPathname = function(url) {
    var formattedPageName = url.split("/").slice(1).map(replaceIdPath).map(removeSquareBrackets).map(removeDashbar).map(function(path) {
        return limitMaxLength(path, 12);
    }).join("_").slice(0, 40);
    return formattedPageName === "" ? "home" : formattedPageName;
};
var getEventNameForLogging = function(onEventName) {
    return camelToSnakeCase(toCamelCase(onEventName.replace(/^on/g, "")));
};
var coreLogger = function(props) {
    mobileLogger({
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                domain: DomainTypeForLogger.CORE
            }, props.payload)
        })
    });
};
var communityLogger = function(props) {
    mobileLogger({
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                domain: DomainTypeForLogger.COMMUNITY
            }, props.payload)
        })
    });
};
var qnaLogger = function(props) {
    mobileLogger({
        logger: _object_spread_props(_object_spread({}, props), {
            payload: _object_spread({
                domain: DomainTypeForLogger.QNA,
                platform: isWebView() ? "App" : "Web(PC/Mobile)"
            }, props.payload)
        })
    });
};
var magazineLogger = function(props) {
    mobileLogger({
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                domain: DomainTypeForLogger.MAGAZINE,
                platform: (0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)() ? "App" : "Web(PC/Mobile)"
            }, props.payload)
        })
    });
};
var faqLogger = function(props) {
    mobileLogger({
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                domain: DomainTypeForLogger.FAQ,
                platform: (0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)() ? "App" : "Web(PC/Mobile)"
            }, props.payload)
        })
    });
};
var faceTofaceLogger = function(props) {
    mobileLogger({
        logger: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                domain: DomainTypeForLogger.FACE_TO_FACE,
                platform: (0,_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_6__/* .isWebView */ .vp)() ? "App" : "Web(PC/Mobile)"
            }, props.payload)
        })
    });
};


/***/ }),

/***/ 10712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": function() { return /* binding */ historyBack; },
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "Ey": function() { return /* binding */ isAndroidByUserAgent; },
/* harmony export */   "T0": function() { return /* binding */ sendPostMessageToNative; },
/* harmony export */   "c0": function() { return /* binding */ isWebViewByUserAgent; },
/* harmony export */   "hn": function() { return /* binding */ isMobileWebByUserAgent; },
/* harmony export */   "nn": function() { return /* binding */ NATIVE_POST_MESSAGE_TYPE; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "vp": function() { return /* binding */ isWebView; }
/* harmony export */ });
/* unused harmony exports getUserAgent, withClientServerSideProps */
/* harmony import */ var _shared_utils_client_detector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80206);





var NATIVE_POST_MESSAGE_TYPE = {
    // 뒤로가기
    GO_BACK: "GO_BACK",
    // Event Logging
    LOGGER: "LOGGER",
    // 로그인 화면 이동
    MOVE_TO_LOGIN: "MOVE_TO_LOGIN",
    // 특정 유저앱 페이지 이동
    MOVE_TO_PAGE: "MOVE_TO_PAGE",
    // 특정 유저앱 탭/페이지 이동 (jumpto)
    MOVE_TO_TAB_HOME: "MOVE_TO_TAB_HOME",
    // 특정 유저앱 페이지 이동 (replace)
    REPLACE_TO_PAGE: "REPLACE_TO_PAGE",
    // 외부 브라우저 열기
    OPEN_EXTERNAL_BROWSER: "OPEN_EXTERNAL_BROWSER",
    // 전화걸기.
    CALL: "CALL",
    // 앱 redux neverSeeAgainState
    SET_NEVER_SEE_AGAIN: "SET_NEVER_SEE_AGAIN",
    // 앱 버전 요청
    GET_APP_VERSION: "GET_APP_VERSION",
    // 뒤로가기 제어 상태
    SET_PREVENT_BACK: "SET_PREVENT_BACK",
    // 카카오 페이 등록
    REGISTER_KAKAO_PAY: "REGISTER_KAKAO_PAY",
    // 첫번째 페이지 제외 페이지 리셋
    RESET_OVER_FIRST_PAGE: "RESET_OVER_FIRST_PAGE",
    // 채널톡 열기
    OPEN_CHANNEL_TALK: "OPEN_CHANNEL_TALK",
    // 앱 리뷰 열기
    OPEN_APP_REVIEW: "OPEN_APP_REVIEW",
    // 카드 선택 BottomSheet 호출
    SELECT_CARD: "SELECT_CARD",
    // 결제 수단 관리 페이지 이동
    MOVE_TO_PAYMENT_PAGE: "MOVE_TO_PAYMENT_PAGE",
    // 진료 대상군 체크 후 의사 상세페이지 이동
    MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK: "MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK",
    RESET_NAVIGATION_TO_SELECTED_SCREEN: "RESET_NAVIGATION_TO_SELECTED_SCREEN",
    // 본인인증 페이지 이동
    MOVE_CERTIFICATION_SCREEN: "MOVE_CERTIFICATION_SCREEN",
    // 앱에서 커스텀 데이터독 액션 로깅
    ADD_ACTION_FOR_RUM: "ADD_ACTION_FOR_RUM",
    STACK_POP_TO_POP: "STACK_POP_TO_POP",
    OPEN_MISSION_TARGET_LINK: "OPEN_MISSION_TARGET_LINK",
    // 광고 보기,
    VIEW_ADVERTISEMENT: "VIEW_ADVERTISEMENT",
    // 친구 초대
    SHARE_INVITATION_CODE: "SHARE_INVITATION_CODE",
    MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK: "MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK",
    MOVE_TO_CATEGORY_SELECT: "MOVE_TO_CATEGORY_SELECT",
    GO_BACK_AND_SET_PARAMS: "GO_BACK_AND_SET_PARAMS",
    SET_PREVENT_BACK_EVENT: "SET_PREVENT_BACK_EVENT",
    DOCTOR_DETAIL_OPEN_MAP: "DOCTOR_DETAIL_OPEN_MAP",
    DOCTOR_DETAIL_CALL_HOSPITAL: "DOCTOR_DETAIL_CALL_HOSPITAL",
    DOCTOR_DETAIL_REQUEST_TREATMENT: "DOCTOR_DETAIL_REQUEST_TREATMENT",
    NAVIGATE_TO_PHARMACY_FIND_WITH_CURRENT_LOCATION: "NAVIGATE_TO_PHARMACY_FIND_WITH_CURRENT_LOCATION",
    COMPLETE_TREATMENT_REQUEST: "COMPLETE_TREATMENT_REQUEST",
    DOCTOR_DETAIL_REQUEST_TREATMENT_WITH_TARGET_ID: "DOCTOR_DETAIL_REQUEST_TREATMENT_WITH_TARGET_ID",
    REGISTER_PAYMENT_KAKAO_PAY: "REGISTER_PAYMENT_KAKAO_PAY",
    REQUEST_VIDEO_CALL_PERMISSION: "REQUEST_VIDEO_CALL_PERMISSION",
    POP_WITH_REPLACE_AT_PRESCRIPTION_SEND_FAIL_SCREEN: "POP_WITH_REPLACE_AT_PRESCRIPTION_SEND_FAIL_SCREEN",
    INVALIDATE_DIAGNOSIS_DETAIL_CACHE_AT_PRESCRIPTION_RE_SEND_SCREEN: "INVALIDATE_DIAGNOSIS_DETAIL_CACHE_AT_PRESCRIPTION_RE_SEND_SCREEN",
    NAVIGATE_TO_PHARMACY_PICK_UP_WITH_LOCATION: "NAVIGATE_TO_PHARMACY_PICK_UP_WITH_LOCATION",
    DISMISS_KEYBOARD: "DISMISS_KEYBOARD",
    ROUTE_RESET_TO_DIAGNOSIS_DETAIL_AT_PRESCRIPTION_SEND_FAX_INPUT_SCREEN: "ROUTE_RESET_TO_DIAGNOSIS_DETAIL_AT_PRESCRIPTION_SEND_FAX_INPUT_SCREEN",
    NAVIGATE_TO_PRESCRIPTION_SEND_SUCCESS_WEBVIEW_SCREEN_AFTER_ROUTE_RESET: "NAVIGATE_TO_PRESCRIPTION_SEND_SUCCESS_WEBVIEW_SCREEN_AFTER_ROUTE_RESET",
    LOGGING_AT_PRESCRIPTION_SEND_FAX_CHECK_WEBVIEW_SCREEN: "LOGGING_AT_PRESCRIPTION_SEND_FAX_CHECK_WEBVIEW_SCREEN",
    CALL_TO_PHARMACY: "CALL_TO_PHARMACY",
    COMPLETE_DIAGNOSIS_REQUEST: "COMPLETE_DIAGNOSIS_REQUEST",
    MOVE_DIAGNOSIS_LIST_AFTER_REQUEST_COMPLETE: "MOVE_DIAGNOSIS_LIST_AFTER_REQUEST_COMPLETE",
    NAVIGATE_TO_PAGE: "NAVIGATE_TO_PAGE",
    REQUEST_SUCCESS_PHARMACY_REVIEW: "REQUEST_SUCCESS_PHARMACY_REVIEW"
};
var isMobile = function(userAgent) {
    return /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone|RNWebView/i.test(userAgent);
};
// webview
var isWebViewByUserAgent = function(userAgent) {
    return /RNWebView/i.test(userAgent);
};
// mobile web
var isMobileWebByUserAgent = function(userAgent) {
    return /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent) && !/RNWebView/i.test(userAgent);
};
var isWebView = function() {
    return  true && !!(window === null || window === void 0 ? void 0 : window.ReactNativeWebView);
};
var isAndroid = function() {
    var userAgent = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
    return /android/i.test(userAgent);
};
var isAndroidByUserAgent = function(userAgent) {
    return /android/i.test(userAgent);
};
var getUserAgent = function() {
    return navigator === null || navigator === void 0 ? void 0 : navigator.userAgent;
};
var historyBack = function() {
    if (isWebView()) {
        sendPostMessageToNative(NATIVE_POST_MESSAGE_TYPE.GO_BACK);
    } else {
        window.history.back();
    }
};
var sendPostMessageToNative = function(type, payload) {
    try {
        if (!isWebView()) {
            throw new Error("Native Plugin을 확인할 수 없습니다.");
        } else {
            console.log("postMessage: ", {
                type: type,
                payload: payload
            });
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: type,
                payload: payload
            }));
        }
    } catch (error) {
        var e = error;
        console.log("postMessage Error: ", e.message);
    }
};
function withClientServerSideProps(getServerSideFn) {
    return function() {
        var _wrappedGetServerSideProps = _async_to_generator(function(ctx) {
            var ref, ref1, ref2, client;
            return _ts_generator(this, function(_state) {
                client = getClientInfo((ref2 = (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.headers["x-user-agent"]) !== null && ref2 !== void 0 ? ref2 : (ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : ref1.headers["user-agent"]);
                return [
                    2,
                    getServerSideFn(_object_spread_props(_object_spread({}, ctx), {
                        client: client
                    }))
                ];
            });
        });
        function wrappedGetServerSideProps(ctx) {
            return _wrappedGetServerSideProps.apply(this, arguments);
        }
        return wrappedGetServerSideProps;
    }();
}


/***/ }),

/***/ 52172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ withOpacity; }
});

;// CONCATENATED MODULE: ../../node_modules/hex-rgb/index.js
const hexCharacters = 'a-f\\d';
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, 'gi');
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, 'i');

function hexRgb(hex, options = {}) {
	if (typeof hex !== 'string' || nonHexChars.test(hex) || !validHexSize.test(hex)) {
		throw new TypeError('Expected a valid hex string');
	}

	hex = hex.replace(/^#/, '');
	let alphaFromHex = 1;

	if (hex.length === 8) {
		alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
		hex = hex.slice(0, 6);
	}

	if (hex.length === 4) {
		alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
		hex = hex.slice(0, 3);
	}

	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	const number = Number.parseInt(hex, 16);
	const red = number >> 16;
	const green = (number >> 8) & 255;
	const blue = number & 255;
	const alpha = typeof options.alpha === 'number' ? options.alpha : alphaFromHex;

	if (options.format === 'array') {
		return [red, green, blue, alpha];
	}

	if (options.format === 'css') {
		const alphaString = alpha === 1 ? '' : ` / ${Number((alpha * 100).toFixed(2))}%`;
		return `rgb(${red} ${green} ${blue}${alphaString})`;
	}

	return {red, green, blue, alpha};
}

;// CONCATENATED MODULE: ./src/utils/opacity.ts

var withOpacity = function(color, opacity) {
    var ref = hexRgb(color), red = ref.red, green = ref.green, blue = ref.blue;
    var ret = "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(opacity, ")");
    return ret;
};


/***/ }),

/***/ 5863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var _utils_error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88295);
/* harmony import */ var _utils_report__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80162);







var Pixel = /*#__PURE__*/ function() {
    "use strict";
    function Pixel() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Pixel);
        this.fbq = null;
        this.client = null;
    }
    var _proto = Pixel.prototype;
    _proto.isEnableClient = function isEnableClient() {
        return this.client && !this.client.isWebView;
    };
    _proto.setup = function setup(client) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                _this.client = client;
                if (_this.fbq || !window.fbq) {
                    return [
                        2
                    ];
                }
                _this.fbq = window.fbq;
                return [
                    2
                ];
            });
        })();
    };
    _proto.pageView = function pageView() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                if (!_this.isEnableClient()) {
                    return [
                        2
                    ];
                }
                try {
                    if (!_this.fbq) {
                        (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:pageView > fbq is not initialized", {});
                        return [
                            2
                        ];
                    }
                    _this.fbq("track", "PageView");
                } catch (error) {
                    (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:pageView > error", {
                        error: error
                    }, (0,_utils_error__WEBPACK_IMPORTED_MODULE_0__/* .getErrorObject */ .T)(error));
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.trackCustom = function trackCustom(event, data) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                if (!_this.isEnableClient()) {
                    return [
                        2
                    ];
                }
                try {
                    if (!_this.fbq) {
                        (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:trackCustom > fbq is not initialized", {});
                        return [
                            2
                        ];
                    }
                    _this.fbq("trackCustom", event, data);
                } catch (error) {
                    (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:trackCustom > error", {
                        error: error
                    }, (0,_utils_error__WEBPACK_IMPORTED_MODULE_0__/* .getErrorObject */ .T)(error));
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.track = function track(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                if (!_this.isEnableClient()) {
                    return [
                        2
                    ];
                }
                try {
                    if (!_this.fbq) {
                        (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:track > fbq is not initialized", {});
                        return [
                            2
                        ];
                    }
                    _this.fbq.apply(_this, [
                        "track",
                        event
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(args)));
                } catch (error) {
                    (0,_utils_report__WEBPACK_IMPORTED_MODULE_1__/* .infoReport */ .pP)("Pixel:track > error", {
                        error: error
                    }, (0,_utils_error__WEBPACK_IMPORTED_MODULE_0__/* .getErrorObject */ .T)(error));
                }
                return [
                    2
                ];
            });
        })();
    };
    Pixel.getInstance = function getInstance() {
        if (!Pixel.instance) {
            Pixel.instance = new Pixel();
        }
        return Pixel.instance;
    };
    Pixel.setup = function setup(client) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                return [
                    2,
                    Pixel.getInstance().setup(client)
                ];
            });
        })();
    };
    Pixel.pageView = function pageView() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                return [
                    2,
                    Pixel.getInstance().pageView()
                ];
            });
        })();
    };
    Pixel.trackCustom = function trackCustom(event, data) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                return [
                    2,
                    Pixel.getInstance().trackCustom(event, data)
                ];
            });
        })();
    };
    Pixel.track = function track(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var _instance;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                return [
                    2,
                    (_instance = Pixel.getInstance()).track.apply(_instance, [
                        event
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(args)))
                ];
            });
        })();
    };
    return Pixel;
}();
/* harmony default export */ __webpack_exports__["Z"] = (Pixel);


/***/ }),

/***/ 80162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xr": function() { return /* binding */ addActionForRum; },
  "cl": function() { return /* binding */ debugReport; },
  "Y": function() { return /* binding */ errorReport; },
  "pP": function() { return /* binding */ infoReport; },
  "n9": function() { return /* binding */ initDatadogMonitoring; },
  "Gm": function() { return /* binding */ resetUserWithDatadogRum; },
  "i7": function() { return /* binding */ setUserWithDatadogRum; },
  "jg": function() { return /* binding */ warningReport; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/display.js
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
    originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
    debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
    log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
    info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
    warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
    error: originalConsoleMethods.error.bind(globalConsole, PREFIX),
};
var DOCS_ORIGIN = 'https://docs.datadoghq.com';
var DOCS_TROUBLESHOOTING = "".concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting");
var MORE_DETAILS = 'More details:';
//# sourceMappingURL=display.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/monitor.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(e);
            }
        }
    }
}
function displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugMode) {
        display.error.apply(display, __spreadArray(['[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
function polyfills_includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function polyfills_arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function polyfills_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/boot/init.js




function makePublicApi(stub) {
    var publicApi = polyfills_assign({
        version: "5.23.3",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
        display.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
    }
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = getGlobalObject();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/timer.js



function timer_setTimeout(callback, delay) {
    return getZoneJsOriginalValue(getGlobalObject(), 'setTimeout')(monitor(callback), delay);
}
function timer_clearTimeout(timeoutId) {
    getZoneJsOriginalValue(getGlobalObject(), 'clearTimeout')(timeoutId);
}
function timer_setInterval(callback, delay) {
    return getZoneJsOriginalValue(getGlobalObject(), 'setInterval')(monitor(callback), delay);
}
function timer_clearInterval(timeoutId) {
    getZoneJsOriginalValue(getGlobalObject(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = timer_setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            timer_clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function functionUtils_noop() { }
//# sourceMappingURL=functionUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return functionUtils_noop;
}
//# sourceMappingURL=jsonStringify.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js

function shallowClone(object) {
    return polyfills_assign({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/context/customerDataTracker.js





// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * ONE_KIBI_BYTE;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * ONE_KIBI_BYTE;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createCustomerDataTrackerManager(compressionStatus) {
    if (compressionStatus === void 0) { compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */; }
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) { initialBytesCount = 0; }
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
            return;
        }
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */
            ? CUSTOMER_DATA_BYTES_LIMIT
            : CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function (tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */
        createDetachedTracker: function () {
            var tracker = createCustomerDataTracker(function () { return checkCustomerDataLimit(tracker.getBytesCount()); });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */
        getOrCreateTracker: function (type) {
            if (!customerDataTrackers.has(type)) {
                customerDataTrackers.set(type, createCustomerDataTracker(checkCustomerDataLimit));
            }
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function (newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function () { return compressionStatus; },
        stop: function () {
            customerDataTrackers.forEach(function (tracker) { return tracker.stop(); });
            customerDataTrackers.clear();
        },
    };
}
function createCustomerDataTracker(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = throttle(function (context) {
        bytesCountCache = computeBytesCount(jsonStringify(context));
        checkCustomerDataLimit();
    }, BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function () {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function (context) {
            if (isEmptyObject(context)) {
                resetBytesCount();
            }
            else {
                computeBytesCountThrottled(context);
            }
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function () { return bytesCountCache; },
        stop: function () {
            cancelComputeBytesCount();
        },
    };
}
function displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    display.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / ONE_KIBI_BYTE, "KiB threshold. ").concat(MORE_DETAILS, " ").concat(DOCS_TROUBLESHOOTING, "/#customer-data-exceeds-the-recommended-threshold-warning"));
}
//# sourceMappingURL=customerDataTracker.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/mergeInto.js

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var serializedSanitizedData = JSON.stringify(sanitizedData);
    var accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/observable.js
// eslint-disable-next-line no-restricted-syntax
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        this.observers.push(f);
        if (this.observers.length === 1 && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        }
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return new Observable(function (globalObservable) {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
}
//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/context/contextManager.js




function createContextManager(customerDataTracker) {
    var context = {};
    var changeObservable = new Observable();
    var contextManager = {
        getContext: function () { return deepClone(context); },
        setContext: function (newContext) {
            if (getType(newContext) === 'object') {
                context = sanitize(newContext);
                customerDataTracker.updateCustomerData(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = sanitize(property);
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/trackingConsent.js

var TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
function createTrackingConsentState(currentConsent) {
    var observable = new Observable();
    return {
        tryToInit: function (trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        update: function (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function () {
            return currentConsent === TrackingConsent.GRANTED;
        },
        observable: observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/addEventListener.js


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = monitor(function (event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
            return;
        }
        if (once) {
            stop();
        }
        listener(event);
    });
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js


var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
    var storageKey = buildStorageKey(productKey, customerDataType);
    storageListeners.push(addEventListener(configuration, window, "storage" /* DOM_EVENT.STORAGE */, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext(combine(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function buildStorageKey(productKey, customerDataType) {
    return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function removeStorageListeners() {
    storageListeners.map(function (listener) { return listener.stop(); });
}
//# sourceMappingURL=storeContextManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.js
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */

var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && startsWith(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
    var stack = [{ url: url, column: column, line: line }];
    var _a = tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack,
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
//# sourceMappingURL=computeStackTrace.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.js



/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            functionUtils_noop();
        }
    }
    callMonitored(function () {
        var stackTrace = computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
//# sourceMappingURL=handlingStack.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/error/error.js




var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace ? stackTrace.name : undefined;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = computeStackTrace(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
    ExperimentalFeature["TOLERANT_RESOURCE_TIMINGS"] = "tolerant_resource_timings";
    ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
    ExperimentalFeature["UPDATE_VIEW_NAME"] = "update_view_name";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function initFeatureFlags(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) {
        addExperimentalFeatures(enableExperimentalFeatures.filter(function (flag) {
            return objectHasValue(ExperimentalFeature, flag);
        }));
    }
}
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
var PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';
//# sourceMappingURL=intakeSites.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function timeStampToClocks(timeStamp) {
    return { relative: getRelativeTime(timeStamp), timeStamp: timeStamp };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!isNumber(duration)) {
        return duration;
    }
    return round(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function numberUtils_round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return numberUtils_isNumber(value) && value >= 0 && value <= 100;
}
function numberUtils_isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
function getConnectivity() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js

function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return polyfills_arrayFrom(set);
}
function removeItem(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) {
        array.splice(index, 1);
    }
}
//# sourceMappingURL=arrayUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js

var BUFFER_LIMIT = 500;
function boundedBuffer_createBoundedBuffer() {
    var buffer = [];
    var add = function (callback) {
        var length = buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            buffer.splice(0, 1);
        }
    };
    var remove = function (callback) {
        removeItem(buffer, callback);
    };
    var drain = function (arg) {
        buffer.forEach(function (callback) { return callback(arg); });
        buffer.length = 0;
    };
    return {
        add: add,
        remove: remove,
        drain: drain,
    };
}
//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
    usage: 'usage',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js

















var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var preStartTelemetryBuffer = boundedBuffer_createBoundedBuffer();
var onRawTelemetryEventCollected = function (event) {
    preStartTelemetryBuffer.add(function () { return onRawTelemetryEventCollected(event); });
};
function startTelemetry(telemetryService, configuration) {
    var _a;
    var contextProvider;
    var observable = new Observable();
    var alreadySentEvents = new Set();
    var telemetryEnabled = !polyfills_includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && performDraw(configuration.telemetrySampleRate);
    var telemetryEnabledPerType = (_a = {},
        _a[TelemetryType.log] = telemetryEnabled,
        _a[TelemetryType.configuration] = telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate),
        _a[TelemetryType.usage] = telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate),
        _a);
    var runtimeEnvInfo = getRuntimeEnvInfo();
    onRawTelemetryEventCollected = function (rawEvent) {
        var stringifiedEvent = jsonStringify(rawEvent);
        if (telemetryEnabledPerType[rawEvent.type] &&
            alreadySentEvents.size < configuration.maxTelemetryEventsPerPage &&
            !alreadySentEvents.has(stringifiedEvent)) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            sendToExtension('telemetry', event_1);
            alreadySentEvents.add(stringifiedEvent);
        }
    };
    startMonitorErrorCollection(addTelemetryError);
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return combine({
            type: 'telemetry',
            date: timeStampNow(),
            service: telemetryService,
            version: "5.23.3",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: combine(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: getConnectivity(),
            }),
            experimental_features: polyfills_arrayFrom(getExperimentalFeatures()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryEnabled,
    };
}
function getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function startFakeTelemetry() {
    var events = [];
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
// need to be called after telemetry context is provided and observers are registered
function drainPreStartTelemetry() {
    preStartTelemetryBuffer.drain();
}
function resetTelemetry() {
    preStartTelemetryBuffer = createBoundedBuffer();
    onRawTelemetryEventCollected = function (event) {
        preStartTelemetryBuffer.add(function () { return onRawTelemetryEventCollected(event); });
    };
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
    displayIfDebugEnabled(ConsoleApiName.debug, message, context);
    onRawTelemetryEventCollected(polyfills_assign({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e, context) {
    onRawTelemetryEventCollected(polyfills_assign({
        type: TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
    onRawTelemetryEventCollected({
        type: TelemetryType.configuration,
        configuration: configuration,
    });
}
function addTelemetryUsage(usage) {
    onRawTelemetryEventCollected({
        type: TelemetryType.usage,
        usage: usage,
    });
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: NO_ERROR_STACK_PRESENT_MESSAGE,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return startsWith(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/user/user.js



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = polyfills_assign({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = getType(newUser) === 'object';
    if (!isValid) {
        display.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js

function displayAlreadyInitializedError(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) {
        display.error("".concat(sdkName, " is already initialized."));
    }
}
//# sourceMappingURL=displayAlreadyInitializedError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/logger/isAuthorized.js
var _a;

function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && polyfills_includes(sanitizedHandlerType, handlerType));
}
var StatusType = {
    ok: 'ok',
    debug: 'debug',
    info: 'info',
    notice: 'notice',
    warn: 'warn',
    error: 'error',
    critical: 'critical',
    alert: 'alert',
    emerg: 'emerg',
};
var STATUS_PRIORITIES = (_a = {},
    _a[StatusType.ok] = 0,
    _a[StatusType.debug] = 1,
    _a[StatusType.info] = 2,
    _a[StatusType.notice] = 4,
    _a[StatusType.warn] = 5,
    _a[StatusType.error] = 6,
    _a[StatusType.critical] = 7,
    _a[StatusType.alert] = 8,
    _a[StatusType.emerg] = 9,
    _a);
//# sourceMappingURL=isAuthorized.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
// note: it is safe to merge declarations as long as the methods are actually defined on the prototype
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging, no-restricted-syntax
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, customerDataTracker, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = createContextManager(customerDataTracker);
        this.contextManager.setContext(loggerContext);
        if (name) {
            this.contextManager.setContextProperty('logger', { name: name });
        }
    }
    Logger.prototype.logImplementation = function (message, messageContext, status, error, handlingStack) {
        if (status === void 0) { status = StatusType.info; }
        var errorContext;
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
            var rawError = computeRawError({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: ErrorSource.LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */,
                startClocks: clocksNow(),
            });
            errorContext = {
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
                causes: rawError.causes,
            };
        }
        var sanitizedMessageContext = sanitize(messageContext);
        var context = errorContext
            ? combine({ error: errorContext }, sanitizedMessageContext)
            : sanitizedMessageContext;
        this.handleLogStrategy({
            message: sanitize(message),
            context: context,
            status: status,
        }, this, handlingStack);
    };
    Logger.prototype.log = function (message, messageContext, status, error) {
        if (status === void 0) { status = StatusType.info; }
        var handlingStack;
        if (isAuthorized(status, HandlerType.http, this)) {
            handlingStack = createHandlingStack();
        }
        this.logImplementation(message, messageContext, status, error, handlingStack);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.setContext(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.getContext();
    };
    Logger.prototype.setContextProperty = function (key, value) {
        this.contextManager.setContextProperty(key, value);
    };
    Logger.prototype.removeContextProperty = function (key) {
        this.contextManager.removeContextProperty(key);
    };
    Logger.prototype.clearContext = function () {
        this.contextManager.clearContext();
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitored
    ], Logger.prototype, "logImplementation", null);
    return Logger;
}());

/* eslint-disable local-rules/disallow-side-effects */
Logger.prototype.ok = createLoggerMethod(StatusType.ok);
Logger.prototype.debug = createLoggerMethod(StatusType.debug);
Logger.prototype.info = createLoggerMethod(StatusType.info);
Logger.prototype.notice = createLoggerMethod(StatusType.notice);
Logger.prototype.warn = createLoggerMethod(StatusType.warn);
Logger.prototype.error = createLoggerMethod(StatusType.error);
Logger.prototype.critical = createLoggerMethod(StatusType.critical);
Logger.prototype.alert = createLoggerMethod(StatusType.alert);
Logger.prototype.emerg = createLoggerMethod(StatusType.emerg);
function createLoggerMethod(status) {
    return function (message, messageContext, error) {
        var handlingStack;
        if (isAuthorized(status, HandlerType.http, this)) {
            handlingStack = createHandlingStack();
        }
        this.logImplementation(message, messageContext, status, error, handlingStack);
    };
}
//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/eventBridge.js


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getCapabilities: function () {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
        },
        getPrivacyLevel: function () {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event, viewId) {
            var view = viewId ? { id: viewId } : undefined;
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event, view: view }));
        },
    };
}
function bridgeSupports(capability) {
    var bridge = getEventBridge();
    return !!bridge && includes(bridge.getCapabilities(), capability);
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || endsWith(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js





/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall, _a) {
    var _b = _a === void 0 ? {} : _a, computeHandlingStack = _b.computeHandlingStack;
    var original = targetPrototype[method];
    if (typeof original !== 'function') {
        if (startsWith(method, 'on')) {
            original = functionUtils_noop;
        }
        else {
            return { stop: functionUtils_noop };
        }
    }
    var stopped = false;
    var instrumentation = function () {
        if (stopped) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
            return original.apply(this, arguments);
        }
        var parameters = polyfills_arrayFrom(arguments);
        var postCallCallback;
        callMonitored(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function (callback) {
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? createHandlingStack() : undefined,
            },
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var result = original.apply(this, parameters);
        if (postCallCallback) {
            callMonitored(postCallCallback, null, [result]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: function () {
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) {
                targetPrototype[method] = original;
            }
        },
    };
}
function instrumentSetter(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: noop };
    }
    var stoppedInstrumentation = noop;
    var instrumentation = function (target, value) {
        // put hooked setter into event loop to avoid of set latency
        setTimeout(function () {
            if (instrumentation !== stoppedInstrumentation) {
                after(target, value);
            }
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(targetPrototype, property, originalDescriptor);
            }
            instrumentation = stoppedInstrumentation;
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js

function normalizeUrl(url) {
    return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/fetchObservable.js






var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function resetFetchObservable() {
    fetchObservable = undefined;
}
function createFetchObservable() {
    return new Observable(function (observable) {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod(window, 'fetch', function (call) { return beforeSend(call, observable); }, {
            computeHandlingStack: true,
        }).stop;
        return stop;
    });
}
function beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall, handlingStack = _a.handlingStack;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) {
        methodFromParams = input.method;
    }
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    var url = input instanceof Request ? input.url : normalizeUrl(String(input));
    var startClocks = clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
        handlingStack: handlingStack,
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function (responsePromise) { return afterSend(observable, responsePromise, context); });
}
function afterSend(observable, responsePromise, startContext) {
    var context = startContext;
    function reportFetch(partialContext) {
        context.state = 'resolve';
        polyfills_assign(context, partialContext);
        observable.notify(context);
    }
    responsePromise.then(monitor(function (response) {
        reportFetch({
            response: response,
            responseType: response.type,
            status: response.status,
            isAborted: false,
        });
    }), monitor(function (error) {
        var _a, _b;
        reportFetch({
            status: 0,
            isAborted: ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || (error instanceof DOMException && error.code === DOMException.ABORT_ERR),
            error: error,
        });
    }));
}
//# sourceMappingURL=fetchObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) {
                return match[2];
            }
        }
        else {
            break;
        }
    }
}
function findCommaSeparatedValues(rawString) {
    var result = new Map();
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            result.set(match[1], match[2]);
        }
        else {
            break;
        }
    }
    return result;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
function isIE() {
    return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
    return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
    return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
    return browserCache !== null && browserCache !== void 0 ? browserCache : (browserCache = detectBrowser());
}
// Exported only for tests
function detectBrowser(browserWindow) {
    var _a;
    if (browserWindow === void 0) { browserWindow = window; }
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
        return 1 /* Browser.CHROMIUM */;
    }
    if (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 ||
        (/safari/i.test(userAgent) && !/chrome|android/i.test(userAgent))) {
        return 2 /* Browser.SAFARI */;
    }
    if (browserWindow.document.documentMode) {
        return 0 /* Browser.IE */;
    }
    return 3 /* Browser.OTHER */;
}
//# sourceMappingURL=browserDetection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/cookie.js



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    var partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
    if (!initCookieParsed) {
        initCookieParsed = findCommaSeparatedValues(document.cookie);
    }
    return initCookieParsed.get(name);
}
function resetInitCookies() {
    initCookieParsed = undefined;
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(generateUUID());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var EXPIRED = '1';
function getExpiredSessionState() {
    return {
        isExpired: EXPIRED,
    };
}
function isSessionInNotStartedState(session) {
    return isEmptyObject(session);
}
function isSessionStarted(session) {
    return !isSessionInNotStartedState(session);
}
function isSessionInExpiredState(session) {
    return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return ((sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) &&
        (sessionState.expire === undefined || dateNow() < Number(sessionState.expire)));
}
function expandSessionState(session) {
    session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
function toSessionString(session) {
    return objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = getInitCookie(SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = getInitCookie(OLD_SESSION_COOKIE_NAME);
        var oldRumType = getInitCookie(OLD_RUM_COOKIE_NAME);
        var oldLogsType = getInitCookie(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (isSessionStarted(session)) {
            expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js






function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return areCookiesAuthorized(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: isChromium(),
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        expireSession: function () { return expireSessionCookie(cookieOptions); },
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        setCookie(SESSION_STORE_KEY, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
    };
}
function expireSessionCookie(options) {
    setCookie(SESSION_STORE_KEY, toSessionString(getExpiredSessionState()), SESSION_TIME_OUT_DELAY, options);
}
function retrieveSessionCookie() {
    var sessionString = getCookie(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure =
        !!initConfiguration.useSecureSessionCookie ||
            !!initConfiguration.usePartitionedCrossSiteSessionCookie ||
            !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite =
        !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = generateUUID();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        expireSession: expireSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function expireSessionFromLocalStorage() {
    persistInLocalStorage(getExpiredSessionState());
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js




var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, persistSession = sessionStoreStrategy.persistSession, expireSession = sessionStoreStrategy.expireSession;
    var persistWithLock = function (session) { return persistSession(polyfills_assign({}, session, { lock: currentLock })); };
    var retrieveStore = function () {
        var session = sessionStoreStrategy.retrieveSession();
        var lock = session.lock;
        if (session.lock) {
            delete session.lock;
        }
        return {
            session: session,
            lock: lock,
        };
    };
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = generateUUID();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (isSessionInExpiredState(processedSession)) {
            expireSession();
        }
        else {
            expandSessionState(processedSession);
            isLockEnabled ? persistWithLock(processedSession) : persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
    next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    timer_setTimeout(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js










/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new Observable();
    var expireObservable = new Observable();
    var sessionStateUpdateObservable = new Observable();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : initLocalStorageStrategy();
    var expireSession = sessionStoreStrategy.expireSession;
    var watchSessionTimeoutId = timer_setInterval(watchSession, STORAGE_POLL_DELAY);
    var sessionCache;
    startSession();
    var _a = throttle(function () {
        processSessionStoreOperations({
            process: function (sessionState) {
                if (isSessionInNotStartedState(sessionState)) {
                    return;
                }
                var synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isSessionStarted(sessionState) && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }, STORAGE_POLL_DELAY), throttledExpandOrRenewSession = _a.throttled, cancelExpandOrRenewSession = _a.cancel;
    function expandSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (isSessionInExpiredState(sessionState) ? getExpiredSessionState() : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (isSessionInExpiredState(sessionState)) {
            sessionState = getExpiredSessionState();
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionStateUpdateObservable.notify({ previousState: sessionCache, newState: sessionState });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        processSessionStoreOperations({
            process: function (sessionState) {
                if (isSessionInNotStartedState(sessionState)) {
                    return getExpiredSessionState();
                }
            },
            after: function (sessionState) {
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if (isSessionInNotStartedState(sessionState)) {
            return false;
        }
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (isTracked && !sessionState.id) {
            sessionState.id = generateUUID();
            sessionState.created = String(dateNow());
        }
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = getExpiredSessionState();
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        processSessionStoreOperations({
            process: function (sessionState) { return polyfills_assign({}, sessionState, partialSessionState); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStateUpdateObservable,
        restartSession: startSession,
        expire: function () {
            cancelExpandOrRenewSession();
            expireSession();
            synchronizeSession(getExpiredSessionState());
        },
        stop: function () {
            timer_clearInterval(watchSessionTimeoutId);
        },
        updateSessionState: updateSessionState,
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js




function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function (api, payload) {
            var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        trackType: trackType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        var normalizedProxyUrl_1 = normalizeUrl(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    if (typeof proxy === 'function') {
        return function (parameters) { return proxy({ path: path, parameters: parameters }); };
    }
    var host = buildEndpointHost(trackType, initConfiguration);
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(trackType, initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US1 : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (trackType === 'logs' && initConfiguration.usePciIntake && site === INTAKE_SITE_US1) {
        return PCI_INTAKE_HOST_US1;
    }
    if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
    }
    if (site === INTAKE_SITE_FED_STAGING) {
        return "http-intake.logs.".concat(site);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("5.23.3"), "api:".concat(api)].concat(configurationTags);
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.23.3")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat(generateUUID()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (trackType === 'rum') {
        parameters.push("batch_time=".concat(timeStampNow()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. ").concat(MORE_DETAILS, " ").concat(DOCS_ORIGIN, "/getting_started/tagging/#defining-tags"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var site = initConfiguration.site || INTAKE_SITE_US1;
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = computeIntakeUrlPrefixes(endpointBuilders, site);
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return polyfills_assign({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: site,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = polyfills_assign({}, initConfiguration, {
        site: INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return polyfills_assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
function computeIntakeUrlPrefixes(endpointBuilders, site) {
    var intakeUrlPrefixes = objectValues(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    if (site === INTAKE_SITE_US1) {
        intakeUrlPrefixes.push("https://".concat(PCI_INTAKE_HOST_US1, "/"));
    }
    return intakeUrlPrefixes;
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js










var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
var TraceContextInjection = {
    ALL: 'all',
    SAMPLED: 'sampled',
};
function isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== 'string') {
        display.error("".concat(tagName, " must be defined as a string"));
        return false;
    }
    return true;
}
function isDatadogSite(site) {
    if (site && typeof site === 'string' && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        display.error("Site should be a valid Datadog site. ".concat(MORE_DETAILS, " ").concat(DOCS_ORIGIN, "/getting_started/site/."));
        return false;
    }
    return true;
}
function isSampleRate(sampleRate, name) {
    if (sampleRate !== undefined && !isPercentage(sampleRate)) {
        display.error("".concat(name, " Sample Rate should be a number between 0 and 100"));
        return false;
    }
    return true;
}
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (!isDatadogSite(initConfiguration.site) ||
        !isSampleRate(initConfiguration.sessionSampleRate, 'Session') ||
        !isSampleRate(initConfiguration.telemetrySampleRate, 'Telemetry') ||
        !isSampleRate(initConfiguration.telemetryConfigurationSampleRate, 'Telemetry Configuration') ||
        !isSampleRate(initConfiguration.telemetryUsageSampleRate, 'Telemetry Usage') ||
        !isString(initConfiguration.version, 'Version') ||
        !isString(initConfiguration.env, 'Env') ||
        !isString(initConfiguration.service, 'Service')) {
        return;
    }
    if (initConfiguration.trackingConsent !== undefined &&
        !objectHasValue(TrackingConsent, initConfiguration.trackingConsent)) {
        display.error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return polyfills_assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: selectSessionStoreStrategyType(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: initConfiguration.service || undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : TrackingConsent.GRANTED,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * ONE_SECOND),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * ONE_KIBI_BYTE,
    }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
    };
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    var observables = [];
    if (polyfills_includes(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    return new Observable(function (observable) {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
}
function createCspViolationReportObservable(configuration) {
    return new Observable(function (observable) {
        var stop = addEventListener(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function buildRawReportFromReport(report) {
    var type = report.type, body = report.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalReport: report,
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
        originalReport: event,
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * ONE_KIBI_BYTE;
function validateAndBuildLogsConfiguration(initConfiguration) {
    if (initConfiguration.usePciIntake === true && initConfiguration.site && initConfiguration.site !== 'datadoghq.com') {
        display.warn('PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.');
    }
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, objectValues(ConsoleApiName), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, objectValues(RawReportType), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !polyfills_includes(forwardConsoleLogs, ConsoleApiName.error)) {
        forwardConsoleLogs.push(ConsoleApiName.error);
    }
    return polyfills_assign({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
        sendLogsAfterSessionExpiration: !!initConfiguration.sendLogsAfterSessionExpiration,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return polyfills_includes(allowedValues, api); })))) {
        display.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : removeDuplicates(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = serializeConfiguration(configuration);
    return polyfills_assign({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
        use_pci_intake: configuration.usePciIntake,
        send_logs_after_session_expiration: configuration.sendLogsAfterSessionExpiration,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/boot/preStartLogs.js


function createPreStartStrategy(getCommonContext, trackingConsentState, doStartLogs) {
    var bufferApiCalls = boundedBuffer_createBoundedBuffer();
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) {
            return;
        }
        trackingConsentStateSubscription.unsubscribe();
        var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
        bufferApiCalls.drain(startLogsResult);
    }
    return {
        init: function (initConfiguration) {
            if (!initConfiguration) {
                display.error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            initFeatureFlags(initConfiguration.enableExperimentalFeatures);
            if (canUseEventBridge()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                displayAlreadyInitializedError('DD_LOGS', initConfiguration);
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            cachedConfiguration = configuration;
            // Instrumuent fetch to track network requests
            // This is needed in case the consent is not granted and some cutsomer
            // library (Apollo Client) is storing uninstrumented fetch to be used later
            // The subscrption is needed so that the instrumentation process is completed
            initFetchObservable().subscribe(functionUtils_noop);
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartLogs();
        },
        get initConfiguration() {
            return cachedInitConfiguration;
        },
        getInternalContext: functionUtils_noop,
        handleLog: function (message, statusType, handlingStack, context, date) {
            if (context === void 0) { context = getCommonContext(); }
            if (date === void 0) { date = timeStampNow(); }
            bufferApiCalls.add(function (startLogsResult) {
                return startLogsResult.handleLog(message, statusType, handlingStack, context, date);
            });
        },
    };
}
function overrideInitConfigurationForBridge(initConfiguration) {
    return polyfills_assign({}, initConfiguration, { clientToken: 'empty' });
}
//# sourceMappingURL=preStartLogs.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js




var LOGS_STORAGE_KEY = 'logs';
function makeLogsPublicApi(startLogsImpl) {
    var customerDataTrackerManager = createCustomerDataTrackerManager();
    var globalContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
    var userContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
    var trackingConsentState = createTrackingConsentState();
    function getCommonContext() {
        return buildCommonContext(globalContextManager, userContextManager);
    }
    var strategy = createPreStartStrategy(getCommonContext, trackingConsentState, function (initConfiguration, configuration) {
        if (initConfiguration.storeContextsAcrossPages) {
            storeContextManager(configuration, globalContextManager, LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            storeContextManager(configuration, userContextManager, LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */);
        }
        var startLogsResult = startLogsImpl(initConfiguration, configuration, getCommonContext, trackingConsentState);
        strategy = createPostStartStrategy(initConfiguration, startLogsResult);
        return startLogsResult;
    });
    var customLoggers = {};
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return strategy.handleLog.apply(strategy, params);
    }, customerDataTrackerManager.createDetachedTracker());
    return makePublicApi({
        logger: mainLogger,
        init: monitor(function (initConfiguration) { return strategy.init(initConfiguration); }),
        setTrackingConsent: monitor(function (trackingConsent) {
            trackingConsentState.update(trackingConsent);
            addTelemetryUsage({ feature: 'set-tracking-consent', tracking_consent: trackingConsent });
        }),
        getGlobalContext: monitor(function () { return globalContextManager.getContext(); }),
        setGlobalContext: monitor(function (context) { return globalContextManager.setContext(context); }),
        setGlobalContextProperty: monitor(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        removeGlobalContextProperty: monitor(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: monitor(function () { return globalContextManager.clearContext(); }),
        createLogger: monitor(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return strategy.handleLog.apply(strategy, params);
            }, customerDataTrackerManager.createDetachedTracker(), sanitize(name), conf.handler, conf.level, sanitize(conf.context));
            return customLoggers[name];
        }),
        getLogger: monitor(function (name) { return customLoggers[name]; }),
        getInitConfiguration: monitor(function () { return deepClone(strategy.initConfiguration); }),
        getInternalContext: monitor(function (startTime) { return strategy.getInternalContext(startTime); }),
        setUser: monitor(function (newUser) {
            if (checkUser(newUser)) {
                userContextManager.setContext(sanitizeUser(newUser));
            }
        }),
        getUser: monitor(function () { return userContextManager.getContext(); }),
        setUserProperty: monitor(function (key, property) {
            var _a;
            var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: monitor(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: monitor(function () { return userContextManager.clearContext(); }),
    });
}
function createPostStartStrategy(initConfiguration, startLogsResult) {
    return polyfills_assign({
        init: function (initConfiguration) {
            displayAlreadyInitializedError('DD_LOGS', initConfiguration);
        },
        initConfiguration: initConfiguration,
    }, startLogsResult);
}
//# sourceMappingURL=logsPublicApi.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js



var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable(configuration) {
    return new Observable(function (observable) {
        var stopListeners = addEventListeners(configuration, window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */], function (event) {
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = addEventListener(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
            observable.notify({ reason: PageExitReason.UNLOADING });
        }).stop;
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function isPageExitReason(reason) {
    return polyfills_includes(objectValues(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/valueHistory.js



var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
function createValueHistory(_a) {
    var expireDelay = _a.expireDelay, maxEntries = _a.maxEntries;
    var entries = [];
    var clearOldValuesInterval = timer_setInterval(function () { return clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    function clearOldValues() {
        var oldTimeThreshold = relativeNow() - expireDelay;
        while (entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold) {
            entries.pop();
        }
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    function add(value, startTime) {
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                removeItem(entries, entry);
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (maxEntries && entries.length >= maxEntries) {
            entries.pop();
        }
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */
    function find(startTime, options) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (options === void 0) { options = { returnInactive: false }; }
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.startTime <= startTime) {
                if (options.returnInactive || startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    function closeActive(endTime) {
        var latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    function findAll(startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = addDuration(startTime, duration);
        return entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    }
    /**
     * Remove all entries from this collection.
     */
    function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */
    function stop() {
        timer_clearInterval(clearOldValuesInterval);
    }
    return { add: add, find: find, closeActive: closeActive, findAll: findAll, reset: reset, stop: stop };
}
//# sourceMappingURL=valueHistory.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js







var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new Observable();
    var expireObservable = new Observable();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = startSessionStore(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = createValueHistory({
        expireDelay: SESSION_CONTEXT_TIMEOUT_DELAY,
    });
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), relativeNow());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function () {
        expireObservable.notify();
        sessionContextHistory.closeActive(relativeNow());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
    trackingConsentState.observable.subscribe(function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
        else {
            sessionStore.expire();
        }
    });
    trackActivity(configuration, function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
    });
    trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    trackResume(configuration, function () { return sessionStore.restartSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
            isReplayForced: !!sessionStore.getSession().forcedReplay,
        };
    }
    return {
        findSession: function (startTime, options) { return sessionContextHistory.find(startTime, options); },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(configuration, expandOrRenewSession) {
    var stop = addEventListeners(configuration, window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = addEventListener(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = timer_setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        timer_clearInterval(visibilityCheckInterval);
    });
}
function trackResume(configuration, cb) {
    var stop = addEventListener(configuration, window, "resume" /* DOM_EVENT.RESUME */, cb, { capture: true }).stop;
    stopCallbacks.push(stop);
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var logsSessionManager_LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration, trackingConsentState) {
    var sessionManager = startSessionManager(configuration, logsSessionManager_LOGS_SESSION_KEY, function (rawTrackingType) { return computeSessionState(configuration, rawTrackingType); }, trackingConsentState);
    return {
        findTrackedSession: function (startTime, options) {
            if (options === void 0) { options = { returnInactive: false }; }
            var session = sessionManager.findSession(startTime, options);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
        expireObservable: sessionManager.expireObservable,
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
        expireObservable: new Observable(),
    };
}
function computeTrackingType(configuration) {
    if (!performDraw(configuration.sessionSampleRate)) {
        return "0" /* LoggerTrackingType.NOT_TRACKED */;
    }
    return "1" /* LoggerTrackingType.TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */ || trackingType === "1" /* LoggerTrackingType.TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                timer_setTimeout(function () {
                    eventCount = 0;
                }, ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: ErrorSource.AGENT,
                        startClocks: clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/contexts/rumInternalContext.js

var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if (willSyntheticsInjectRum()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            addTelemetryDebug('Logs sent before RUM is injected by the synthetics worker', {
                testId: getSyntheticsTestId(),
                resultId: getSyntheticsResultId(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=rumInternalContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/assembly.js



function startLogsAssembly(sessionManager, configuration, lifeCycle, getCommonContext, reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = createEventRateLimiter(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c;
        var rawLogsEvent = _a.rawLogsEvent, _d = _a.messageContext, messageContext = _d === void 0 ? undefined : _d, _e = _a.savedCommonContext, savedCommonContext = _e === void 0 ? undefined : _e, domainContext = _a.domainContext;
        var startTime = getRelativeTime(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session &&
            (!configuration.sendLogsAfterSessionExpiration ||
                !sessionManager.findTrackedSession(startTime, { returnInactive: true }))) {
            return;
        }
        var commonContext = savedCommonContext || getCommonContext();
        var log = combine({
            service: configuration.service,
            session_id: session ? session.id : undefined,
            // Insert user first to allow overrides from global context
            usr: !isEmptyObject(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, messageContext);
        if (((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log, domainContext)) === false ||
            (log.origin !== ErrorSource.AGENT &&
                ((_c = logRateLimiters[log.status]) !== null && _c !== void 0 ? _c : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */, log);
    });
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js









var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return mergeObservables.apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    return new Observable(function (observable) {
        var originalConsoleApi = globalConsole[api];
        globalConsole[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            globalConsole[api] = originalConsoleApi;
        };
    });
}
function buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    var causes;
    if (api === ConsoleApiName.error) {
        var firstErrorParam = find(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
        fingerprint = tryToGetFingerprint(firstErrorParam);
        causes = firstErrorParam ? flattenErrorCauses(firstErrorParam, 'console') : undefined;
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
        causes: causes,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return sanitize(param);
    }
    if (param instanceof Error) {
        return formatErrorMessage(computeStackTrace(param));
    }
    return jsonStringify(sanitize(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var consoleCollection_a;


var LogStatusForApi = (consoleCollection_a = {},
    consoleCollection_a[ConsoleApiName.log] = StatusType.info,
    consoleCollection_a[ConsoleApiName.debug] = StatusType.debug,
    consoleCollection_a[ConsoleApiName.info] = StatusType.info,
    consoleCollection_a[ConsoleApiName.warn] = StatusType.warn,
    consoleCollection_a[ConsoleApiName.error] = StatusType.error,
    consoleCollection_a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = initConsoleObservable(configuration.forwardConsoleLogs).subscribe(function (log) {
        var collectedData = {
            rawLogsEvent: {
                date: timeStampNow(),
                message: log.message,
                origin: ErrorSource.CONSOLE,
                error: log.api === ConsoleApiName.error
                    ? {
                        stack: log.stack,
                        fingerprint: log.fingerprint,
                        causes: log.causes,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
            domainContext: {
                handlingStack: log.handlingStack,
            },
        };
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, collectedData);
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[RawReportType.cspViolation] = StatusType.error,
    reportCollection_a[RawReportType.intervention] = StatusType.error,
    reportCollection_a[RawReportType.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = initReportObservable(configuration, configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat(getFileFromStackTraceString(report.stack));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: timeStampNow(),
                message: message,
                origin: ErrorSource.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
function createXhrObservable(configuration) {
    return new Observable(function (observable) {
        var stopInstrumentingStart = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr).stop;
        var stopInstrumentingSend = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
            sendXhr(call, configuration, observable);
        }, { computeHandlingStack: true }).stop;
        var stopInstrumentingAbort = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: normalizeUrl(String(url)),
    });
}
function sendXhr(_a, configuration, observable) {
    var xhr = _a.target, handlingStack = _a.handlingStack;
    var context = xhrContexts.get(xhr);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startClocks = clocksNow();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethod(xhr, 'onreadystatechange', function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            // Try to report the XHR as soon as possible, because the XHR may be mutated by the
            // application during a future event. For example, Angular is calling .abort() on
            // completed requests during an onreadystatechange event, so the status becomes '0'
            // before the request is collected.
            onEnd();
        }
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
        completeContext.status = xhr.status;
        observable.notify(shallowClone(completeContext));
    };
    var unsubscribeLoadEndListener = addEventListener(configuration, xhr, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr(_a) {
    var xhr = _a.target;
    var context = xhrContexts.get(xhr);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then(monitor(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), monitor(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        functionUtils_noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils_noop };
    }
    var xhrSubscription = initXhrObservable(configuration).subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* RequestType.XHR */, context);
        }
    });
    var fetchSubscription = initFetchObservable().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* RequestType.FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || isServerError(request.status))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            var domainContext = {
                isAborted: request.isAborted,
                handlingStack: request.handlingStack,
            };
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method, // Cast resource method because of case mismatch cf issue RUMF-1152
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: ErrorSource.NETWORK,
                },
                domainContext: domainContext,
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText(toStackTraceString(computeStackTrace(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = tryToClone(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then(monitor(function (text) { return callback(truncateResponseText(text, configuration)); }), monitor(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* RequestType.XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    readBytesFromStream(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js





function trackRuntimeError(errorObservable) {
    var handleRuntimeError = function (stackTrace, originalError) {
        var rawError = computeRawError({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: clocksNow(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: ErrorSource.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
function instrumentOnError(callback) {
    return instrumentMethod(window, 'onerror', function (_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if (errorObj instanceof Error) {
            stackTrace = computeStackTrace(errorObj);
        }
        else {
            stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
        }
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function instrumentUnhandledRejection(callback) {
    return instrumentMethod(window, 'onunhandledrejection', function (_a) {
        var e = _a.parameters[0];
        var reason = e.reason || 'Empty reason';
        var stack = computeStackTrace(reason);
        callback(stack, reason);
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils_noop };
    }
    var rawErrorObservable = new Observable();
    var stopRuntimeErrorTracking = trackRuntimeError(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    stack: rawError.stack,
                    causes: rawError.causes,
                },
                origin: ErrorSource.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
// eslint-disable-next-line no-restricted-syntax
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js

var LifeCycle = (AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/logger/loggerCollection.js
var loggerCollection_a;



function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, handlingStack, savedCommonContext, savedDate) {
        var messageContext = combine(logger.getContext(), logsMessage.context);
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            displayInConsole(logsMessage, messageContext);
        }
        if (isAuthorized(logsMessage.status, HandlerType.http, logger)) {
            var rawLogEventData = {
                rawLogsEvent: {
                    date: savedDate || timeStampNow(),
                    message: logsMessage.message,
                    status: logsMessage.status,
                    origin: ErrorSource.LOGGER,
                },
                messageContext: messageContext,
                savedCommonContext: savedCommonContext,
            };
            if (handlingStack) {
                rawLogEventData.domainContext = { handlingStack: handlingStack };
            }
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, rawLogEventData);
        }
    }
    return {
        handleLog: handleLog,
    };
}
var loggerToConsoleApiName = (loggerCollection_a = {},
    loggerCollection_a[StatusType.ok] = ConsoleApiName.debug,
    loggerCollection_a[StatusType.debug] = ConsoleApiName.debug,
    loggerCollection_a[StatusType.info] = ConsoleApiName.info,
    loggerCollection_a[StatusType.notice] = ConsoleApiName.info,
    loggerCollection_a[StatusType.warn] = ConsoleApiName.warn,
    loggerCollection_a[StatusType.error] = ConsoleApiName.error,
    loggerCollection_a[StatusType.critical] = ConsoleApiName.error,
    loggerCollection_a[StatusType.alert] = ConsoleApiName.error,
    loggerCollection_a[StatusType.emerg] = ConsoleApiName.error,
    loggerCollection_a);
function displayInConsole(_a, messageContext) {
    var status = _a.status, message = _a.message;
    originalConsoleMethods[loggerToConsoleApiName[status]].call(globalConsole, message, messageContext);
}
//# sourceMappingURL=loggerCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/batch.js





function createBatch(_a) {
    var encoder = _a.encoder, request = _a.request, flushController = _a.flushController, messageBytesLimit = _a.messageBytesLimit;
    var upsertBuffer = {};
    var flushSubscription = flushController.flushObservable.subscribe(function (event) { return flush(event); });
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        }
        else {
            encoder.write(encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
                flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        var removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        var messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        var serializedMessage = jsonStringify(message);
        var estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= messageBytesLimit) {
            display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(messageBytesLimit, "KB. ").concat(MORE_DETAILS, " ").concat(DOCS_TROUBLESHOOTING, "/#technical-limitations"));
            return;
        }
        if (hasMessageFor(key)) {
            remove(key);
        }
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        var upsertMessages = objectValues(upsertBuffer).join('\n');
        upsertBuffer = {};
        var isPageExit = isPageExitReason(event.reason);
        var send = isPageExit ? request.sendOnExit : request.send;
        if (isPageExit &&
            // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
            // if the encoder is async we need to send two requests in some cases (one for encoded data
            // and the other for non-encoded data). But if it's not async, we don't have to worry about
            // it and always send a single request.
            encoder.isAsync) {
            var encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) {
                send(formatPayloadFromEncoder(encoderResult));
            }
            // Send messages that are not yet encoded at this point
            var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
            if (pendingMessages) {
                send({
                    data: pendingMessages,
                    bytesCount: computeBytesCount(pendingMessages),
                });
            }
        }
        else {
            if (upsertMessages) {
                encoder.write(encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            }
            encoder.finish(function (encoderResult) {
                send(formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController: flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe,
    };
}
function formatPayloadFromEncoder(encoderResult) {
    var data;
    if (typeof encoderResult.output === 'string') {
        data = encoderResult.output;
    }
    else {
        data = new Blob([encoderResult.output], {
            // This will set the 'Content-Type: text/plain' header. Reasoning:
            // * The intake rejects the request if there is no content type.
            // * The browser will issue CORS preflight requests if we set it to 'application/json', which
            // could induce higher intake load (and maybe has other impacts).
            // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
            // new lines.
            type: 'text/plain',
        });
    }
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
    };
}
//# sourceMappingURL=batch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var MAX_ONGOING_BYTES_COUNT = 80 * ONE_KIBI_BYTE;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * ONE_MEBI_BYTE;
var MAX_BACKOFF_TIME = ONE_MINUTE;
var INITIAL_BACKOFF_TIME = ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    timer_setTimeout(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / ONE_MEBI_BYTE, "MiB"),
            source: ErrorSource.AGENT,
            startClocks: clocksNow(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            isServerError(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addTelemetryError(e);
    }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then(monitor(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), monitor(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    if (data instanceof Blob) {
        // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
        // automatically, so the intake request ends up being rejected with an HTTP status 415
        // Defining the header manually fixes this issue.
        request.setRequestHeader('Content-Type', data.type);
    }
    addEventListener(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new Observable(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = timer_setTimeout(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        timer_clearTimeout(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */
        notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */
        notifyAfterAddMessage: function (messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) { messageBytesCountDiff = 0; }
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js



function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable, batchFactoryImp) {
    if (batchFactoryImp === void 0) { batchFactoryImp = createBatch; }
    var primaryBatch = createBatchFromConfig(configuration, primary);
    var replicaBatch = replica && createBatchFromConfig(configuration, replica);
    function createBatchFromConfig(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return batchFactoryImp({
            encoder: encoder,
            request: createHttpRequest(configuration, endpoint, configuration.batchBytesLimit, reportError),
            flushController: createFlushController({
                messagesLimit: configuration.batchMessagesLimit,
                bytesLimit: configuration.batchBytesLimit,
                durationLimit: configuration.flushTimeout,
                pageExitObservable: pageExitObservable,
                sessionExpireObservable: sessionExpireObservable,
            }),
            messageBytesLimit: configuration.messageBytesLimit,
        });
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            if (replicaBatch) {
                replicaBatch.stop();
            }
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/encoder.js

function createIdentityEncoder() {
    var output = '';
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty() {
            return !output;
        },
        write: function (data, callback) {
            var additionalEncodedBytesCount = computeBytesCount(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) {
                callback(additionalEncodedBytesCount);
            }
        },
        finish: function (callback) {
            callback(this.finishSync());
        },
        finishSync: function () {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: '',
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function (data) {
            return data.length;
        },
    };
}
//# sourceMappingURL=encoder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session) {
    var batch = startBatchWithReplica(configuration, {
        endpoint: configuration.logsEndpointBuilder,
        encoder: createIdentityEncoder(),
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
        encoder: createIdentityEncoder(),
    }, reportError, pageExitObservable, session.expireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = getEventBridge();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/contexts/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/reportError.js


function startReportError(lifeCycle) {
    return function (error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: ErrorSource.AGENT,
                status: StatusType.error,
            },
        });
        addTelemetryDebug('Error reported to customer', { 'error.message': error.message });
    };
}
//# sourceMappingURL=reportError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/domain/logsTelemetry.js



function startLogsTelemetry(initConfiguration, configuration, reportError, pageExitObservable, session) {
    var telemetry = startTelemetry("browser-logs-sdk" /* TelemetryService.LOGS */, configuration);
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    var cleanupTasks = [];
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
        cleanupTasks.push(function () { return telemetrySubscription_1.unsubscribe(); });
    }
    else {
        var telemetryBatch_1 = startBatchWithReplica(configuration, {
            endpoint: configuration.rumEndpointBuilder,
            encoder: createIdentityEncoder(),
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
            encoder: createIdentityEncoder(),
        }, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function () { return telemetryBatch_1.stop(); });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function (event) {
            return telemetryBatch_1.add(event, isTelemetryReplicationAllowed(configuration));
        });
        cleanupTasks.push(function () { return telemetrySubscription_2.unsubscribe(); });
    }
    drainPreStartTelemetry();
    addTelemetryConfiguration(serializeLogsConfiguration(initConfiguration));
    return {
        telemetry: telemetry,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=logsTelemetry.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, getCommonContext, 
// `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var lifeCycle = new LifeCycle();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (log) { return sendToExtension('logs', log); });
    var reportError = startReportError(lifeCycle);
    var pageExitObservable = createPageExitObservable(configuration);
    var session = configuration.sessionStoreStrategyType && !canUseEventBridge() && !willSyntheticsInjectRum()
        ? startLogsSessionManager(configuration, trackingConsentState)
        : startLogsSessionManagerStub(configuration);
    var stopLogsTelemetry = startLogsTelemetry(initConfiguration, configuration, reportError, pageExitObservable, session).stop;
    cleanupTasks.push(function () { return stopLogsTelemetry(); });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    startLogsAssembly(session, configuration, lifeCycle, getCommonContext, reportError);
    if (!canUseEventBridge()) {
        var stopLogsBatch_1 = startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session).stop;
        cleanupTasks.push(function () { return stopLogsBatch_1(); });
    }
    else {
        startLogsBridge(lifeCycle);
    }
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-logs/esm/entries/main.js





var datadogLogs = makeLogsPublicApi(startLogs);
defineGlobal(getGlobalObject(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/display.js
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var display_ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var display_globalConsole = console;
var display_originalConsoleMethods = {};
Object.keys(display_ConsoleApiName).forEach(function (name) {
    display_originalConsoleMethods[name] = display_globalConsole[name];
});
var display_PREFIX = 'Datadog Browser SDK:';
var display_display = {
    debug: display_originalConsoleMethods.debug.bind(display_globalConsole, display_PREFIX),
    log: display_originalConsoleMethods.log.bind(display_globalConsole, display_PREFIX),
    info: display_originalConsoleMethods.info.bind(display_globalConsole, display_PREFIX),
    warn: display_originalConsoleMethods.warn.bind(display_globalConsole, display_PREFIX),
    error: display_originalConsoleMethods.error.bind(display_globalConsole, display_PREFIX),
};
var display_DOCS_ORIGIN = 'https://docs.datadoghq.com';
var display_DOCS_TROUBLESHOOTING = "".concat(display_DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting");
var display_MORE_DETAILS = 'More details:';
//# sourceMappingURL=display.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js

function catchUserErrors_catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display_display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var monitor_onMonitorErrorCollected;
var monitor_debugMode = false;
function monitor_startMonitorErrorCollection(newOnMonitorErrorCollected) {
    monitor_onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function monitor_setDebugMode(newDebugMode) {
    monitor_debugMode = newDebugMode;
}
function monitor_resetMonitor() {
    monitor_onMonitorErrorCollected = undefined;
    monitor_debugMode = false;
}
function monitor_monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = monitor_onMonitorErrorCollected ? monitor_monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor_monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return monitor_callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function monitor_callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        monitor_displayIfDebugEnabled(e);
        if (monitor_onMonitorErrorCollected) {
            try {
                monitor_onMonitorErrorCollected(e);
            }
            catch (e) {
                monitor_displayIfDebugEnabled(e);
            }
        }
    }
}
function monitor_displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (monitor_debugMode) {
        display_display.error.apply(display_display, monitor_spreadArray(['[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
function utils_polyfills_includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function utils_polyfills_arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function polyfills_find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function polyfills_findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function polyfills_forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function polyfills_objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function polyfills_objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function polyfills_startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function polyfills_endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function utils_polyfills_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/boot/init.js




function init_makePublicApi(stub) {
    var publicApi = utils_polyfills_assign({
        version: "5.23.3",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return monitor_setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function init_defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
        display_display.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
    }
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors_catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject_getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils_ONE_KIBI_BYTE = 1024;
var byteUtils_ONE_MEBI_BYTE = 1024 * byteUtils_ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var byteUtils_HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function byteUtils_computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!byteUtils_HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function byteUtils_concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue_getZoneJsOriginalValue(target, name) {
    var browserWindow = getGlobalObject_getGlobalObject();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/timer.js



function tools_timer_setTimeout(callback, delay) {
    return getZoneJsOriginalValue_getZoneJsOriginalValue(getGlobalObject_getGlobalObject(), 'setTimeout')(monitor_monitor(callback), delay);
}
function tools_timer_clearTimeout(timeoutId) {
    getZoneJsOriginalValue_getZoneJsOriginalValue(getGlobalObject_getGlobalObject(), 'clearTimeout')(timeoutId);
}
function tools_timer_setInterval(callback, delay) {
    return getZoneJsOriginalValue_getZoneJsOriginalValue(getGlobalObject_getGlobalObject(), 'setInterval')(monitor_monitor(callback), delay);
}
function tools_timer_clearInterval(timeoutId) {
    getZoneJsOriginalValue_getZoneJsOriginalValue(getGlobalObject_getGlobalObject(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js

// use lodash API
function functionUtils_throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = tools_timer_setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            tools_timer_clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function utils_functionUtils_noop() { }
//# sourceMappingURL=functionUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify_jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = jsonStringify_detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = jsonStringify_detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = jsonStringify_detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = jsonStringify_detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function jsonStringify_detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return utils_functionUtils_noop;
}
//# sourceMappingURL=jsonStringify.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js

function objectUtils_shallowClone(object) {
    return utils_polyfills_assign({}, object);
}
function objectUtils_objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function objectUtils_isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function objectUtils_mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/context/customerDataTracker.js





// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var customerDataTracker_CUSTOMER_DATA_BYTES_LIMIT = 3 * byteUtils_ONE_KIBI_BYTE;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var customerDataTracker_CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * byteUtils_ONE_KIBI_BYTE;
var customerDataTracker_BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function customerDataTracker_createCustomerDataTrackerManager(compressionStatus) {
    if (compressionStatus === void 0) { compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */; }
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) { initialBytesCount = 0; }
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
            return;
        }
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */
            ? customerDataTracker_CUSTOMER_DATA_BYTES_LIMIT
            : customerDataTracker_CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function (tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            customerDataTracker_displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */
        createDetachedTracker: function () {
            var tracker = customerDataTracker_createCustomerDataTracker(function () { return checkCustomerDataLimit(tracker.getBytesCount()); });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */
        getOrCreateTracker: function (type) {
            if (!customerDataTrackers.has(type)) {
                customerDataTrackers.set(type, customerDataTracker_createCustomerDataTracker(checkCustomerDataLimit));
            }
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function (newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function () { return compressionStatus; },
        stop: function () {
            customerDataTrackers.forEach(function (tracker) { return tracker.stop(); });
            customerDataTrackers.clear();
        },
    };
}
function customerDataTracker_createCustomerDataTracker(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = functionUtils_throttle(function (context) {
        bytesCountCache = byteUtils_computeBytesCount(jsonStringify_jsonStringify(context));
        checkCustomerDataLimit();
    }, customerDataTracker_BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function () {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function (context) {
            if (objectUtils_isEmptyObject(context)) {
                resetBytesCount();
            }
            else {
                computeBytesCountThrottled(context);
            }
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function () { return bytesCountCache; },
        stop: function () {
            cancelComputeBytesCount();
        },
    };
}
function customerDataTracker_displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    display_display.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / byteUtils_ONE_KIBI_BYTE, "KiB threshold. ").concat(display_MORE_DETAILS, " ").concat(display_DOCS_TROUBLESHOOTING, "/#customer-data-exceeds-the-recommended-threshold-warning"));
}
//# sourceMappingURL=customerDataTracker.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function typeUtils_getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/mergeInto.js

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto_mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = mergeInto_createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto_mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = typeUtils_getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto_mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function mergeInto_deepClone(value) {
    return mergeInto_mergeInto(undefined, value);
}
function mergeInto_combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto_mergeInto(destination, source);
    }
    return destination;
}
function mergeInto_createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var sanitize_SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * byteUtils_ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var sanitize_JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var sanitize_KEY_DECORATION_LENGTH = 3;
function sanitize_sanitize(source, maxCharacterCount) {
    if (maxCharacterCount === void 0) { maxCharacterCount = sanitize_SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = jsonStringify_detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = jsonStringify_detachToJsonMethod(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitize_sanitizeProcessor(source, sanitize_JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var serializedSanitizedData = JSON.stringify(sanitizedData);
    var accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        sanitize_warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitize_sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    sanitize_warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitize_sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + sanitize_KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        sanitize_warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitize_sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = sanitize_tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitize_sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitize_sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitize_sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitize_sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function sanitize_tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function sanitize_warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    display_display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/observable.js
// eslint-disable-next-line no-restricted-syntax
var observable_Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        this.observers.push(f);
        if (this.observers.length === 1 && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        }
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function observable_mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return new observable_Observable(function (globalObservable) {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
}
//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/context/contextManager.js




function contextManager_createContextManager(customerDataTracker) {
    var context = {};
    var changeObservable = new observable_Observable();
    var contextManager = {
        getContext: function () { return mergeInto_deepClone(context); },
        setContext: function (newContext) {
            if (typeUtils_getType(newContext) === 'object') {
                context = sanitize_sanitize(newContext);
                customerDataTracker.updateCustomerData(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = sanitize_sanitize(property);
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/trackingConsent.js

var trackingConsent_TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
function trackingConsent_createTrackingConsentState(currentConsent) {
    var observable = new observable_Observable();
    return {
        tryToInit: function (trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        update: function (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function () {
            return currentConsent === trackingConsent_TrackingConsent.GRANTED;
        },
        observable: observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

// eslint-disable-next-line no-restricted-syntax
var experimentalFeatures_ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
    ExperimentalFeature["TOLERANT_RESOURCE_TIMINGS"] = "tolerant_resource_timings";
    ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
    ExperimentalFeature["UPDATE_VIEW_NAME"] = "update_view_name";
})(experimentalFeatures_ExperimentalFeature || (experimentalFeatures_ExperimentalFeature = {}));
var experimentalFeatures_enabledExperimentalFeatures = new Set();
function experimentalFeatures_initFeatureFlags(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) {
        experimentalFeatures_addExperimentalFeatures(enableExperimentalFeatures.filter(function (flag) {
            return objectUtils_objectHasValue(experimentalFeatures_ExperimentalFeature, flag);
        }));
    }
}
function experimentalFeatures_addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        experimentalFeatures_enabledExperimentalFeatures.add(flag);
    });
}
function experimentalFeatures_isExperimentalFeatureEnabled(featureName) {
    return experimentalFeatures_enabledExperimentalFeatures.has(featureName);
}
function experimentalFeatures_resetExperimentalFeatures() {
    experimentalFeatures_enabledExperimentalFeatures.clear();
}
function experimentalFeatures_getExperimentalFeatures() {
    return experimentalFeatures_enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.js
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */

var computeStackTrace_UNKNOWN_FUNCTION = '?';
function computeStackTrace_computeStackTrace(ex) {
    var stack = [];
    var stackProperty = computeStackTrace_tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && polyfills_startsWith(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = computeStackTrace_parseChromeLine(line) || computeStackTrace_parseChromeAnonymousLine(line) || computeStackTrace_parseWinLine(line) || computeStackTrace_parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = computeStackTrace_UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: computeStackTrace_tryToGetString(ex, 'message'),
        name: computeStackTrace_tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var computeStackTrace_fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var computeStackTrace_filePosition = '(?::(\\d+))';
var computeStackTrace_CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(computeStackTrace_fileUrl).concat(computeStackTrace_filePosition, "?").concat(computeStackTrace_filePosition, "?\\)?\\s*$"), 'i');
var computeStackTrace_CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(computeStackTrace_filePosition).concat(computeStackTrace_filePosition, "\\)"));
function computeStackTrace_parseChromeLine(line) {
    var parts = computeStackTrace_CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = computeStackTrace_CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || computeStackTrace_UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var computeStackTrace_CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(computeStackTrace_fileUrl).concat(computeStackTrace_filePosition, "?").concat(computeStackTrace_filePosition, "??\\s*$"), 'i');
function computeStackTrace_parseChromeAnonymousLine(line) {
    var parts = computeStackTrace_CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: computeStackTrace_UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var computeStackTrace_WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function computeStackTrace_parseWinLine(line) {
    var parts = computeStackTrace_WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || computeStackTrace_UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var computeStackTrace_GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var computeStackTrace_GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function computeStackTrace_parseGeckoLine(line) {
    var parts = computeStackTrace_GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = computeStackTrace_GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || computeStackTrace_UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function computeStackTrace_tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function computeStackTrace_computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
    var stack = [{ url: url, column: column, line: line }];
    var _a = computeStackTrace_tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack,
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var computeStackTrace_ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function computeStackTrace_tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = computeStackTrace_ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
//# sourceMappingURL=computeStackTrace.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.js



/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function handlingStack_createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            utils_functionUtils_noop();
        }
    }
    monitor_callMonitored(function () {
        var stackTrace = computeStackTrace_computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = handlingStack_toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function handlingStack_toStackTraceString(stack) {
    var result = handlingStack_formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function handlingStack_formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
//# sourceMappingURL=handlingStack.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/error/error.js




var error_NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function error_computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = error_computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = error_hasUsableStack(isErrorInstance, stackTrace)
        ? handlingStack_toStackTraceString(stackTrace)
        : error_NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? error_flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace ? stackTrace.name : undefined;
    var fingerprint = error_tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function error_computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat(jsonStringify_jsonStringify(sanitize_sanitize(originalError)))
            : 'Empty message';
}
function error_hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function error_tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function error_getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function error_flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = computeStackTrace_computeStackTrace(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && handlingStack_toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites_INTAKE_SITE_STAGING = 'datad0g.com';
var intakeSites_INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var intakeSites_INTAKE_SITE_US1 = 'datadoghq.com';
var intakeSites_INTAKE_SITE_EU1 = 'datadoghq.eu';
var intakeSites_INTAKE_SITE_US1_FED = 'ddog-gov.com';
var intakeSites_PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';
//# sourceMappingURL=intakeSites.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function numberUtils_performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function utils_numberUtils_round(num, decimals) {
    return +num.toFixed(decimals);
}
function numberUtils_isPercentage(value) {
    return utils_numberUtils_isNumber(value) && value >= 0 && value <= 100;
}
function utils_numberUtils_isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js

var timeUtils_ONE_SECOND = 1000;
var timeUtils_ONE_MINUTE = 60 * timeUtils_ONE_SECOND;
var timeUtils_ONE_HOUR = 60 * timeUtils_ONE_MINUTE;
var timeUtils_ONE_DAY = 24 * timeUtils_ONE_HOUR;
var timeUtils_ONE_YEAR = 365 * timeUtils_ONE_DAY;
function timeUtils_relativeToClocks(relative) {
    return { relative: relative, timeStamp: timeUtils_getCorrectedTimeStamp(relative) };
}
function timeUtils_timeStampToClocks(timeStamp) {
    return { relative: timeUtils_getRelativeTime(timeStamp), timeStamp: timeStamp };
}
function timeUtils_getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (timeUtils_dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > timeUtils_getNavigationStart()) {
        return Math.round(timeUtils_addDuration(correctedOrigin, relativeTime));
    }
    return timeUtils_getTimeStamp(relativeTime);
}
function timeUtils_currentDrift() {
    return Math.round(timeUtils_dateNow() - timeUtils_addDuration(timeUtils_getNavigationStart(), performance.now()));
}
function timeUtils_toServerDuration(duration) {
    if (!utils_numberUtils_isNumber(duration)) {
        return duration;
    }
    return utils_numberUtils_round(duration * 1e6, 0);
}
function timeUtils_dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeUtils_timeStampNow() {
    return timeUtils_dateNow();
}
function timeUtils_relativeNow() {
    return performance.now();
}
function timeUtils_clocksNow() {
    return { relative: timeUtils_relativeNow(), timeStamp: timeUtils_timeStampNow() };
}
function timeUtils_clocksOrigin() {
    return { relative: 0, timeStamp: timeUtils_getNavigationStart() };
}
function timeUtils_elapsed(start, end) {
    return (end - start);
}
function timeUtils_addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function timeUtils_getRelativeTime(timestamp) {
    return (timestamp - timeUtils_getNavigationStart());
}
function timeUtils_getTimeStamp(relativeTime) {
    return Math.round(timeUtils_addDuration(timeUtils_getNavigationStart(), relativeTime));
}
function timeUtils_looksLikeRelativeTime(time) {
    return time < timeUtils_ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var timeUtils_navigationStart;
function timeUtils_getNavigationStart() {
    if (timeUtils_navigationStart === undefined) {
        timeUtils_navigationStart = performance.timing.navigationStart;
    }
    return timeUtils_navigationStart;
}
function timeUtils_resetNavigationStart() {
    timeUtils_navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
function sendToExtension_sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
function connectivity_getConnectivity() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js

function arrayUtils_removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return arrayFrom(set);
}
function arrayUtils_removeItem(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) {
        array.splice(index, 1);
    }
}
//# sourceMappingURL=arrayUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js

var boundedBuffer_BUFFER_LIMIT = 500;
function tools_boundedBuffer_createBoundedBuffer() {
    var buffer = [];
    var add = function (callback) {
        var length = buffer.push(callback);
        if (length > boundedBuffer_BUFFER_LIMIT) {
            buffer.splice(0, 1);
        }
    };
    var remove = function (callback) {
        arrayUtils_removeItem(buffer, callback);
    };
    var drain = function (arg) {
        buffer.forEach(function (callback) { return callback(arg); });
        buffer.length = 0;
    };
    return {
        add: add,
        remove: remove,
        drain: drain,
    };
}
//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var rawTelemetryEvent_types_TelemetryType = {
    log: 'log',
    configuration: 'configuration',
    usage: 'usage',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js

















var telemetry_ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var telemetry_TELEMETRY_EXCLUDED_SITES = [intakeSites_INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var telemetry_preStartTelemetryBuffer = tools_boundedBuffer_createBoundedBuffer();
var telemetry_onRawTelemetryEventCollected = function (event) {
    telemetry_preStartTelemetryBuffer.add(function () { return telemetry_onRawTelemetryEventCollected(event); });
};
function telemetry_startTelemetry(telemetryService, configuration) {
    var _a;
    var contextProvider;
    var observable = new observable_Observable();
    var alreadySentEvents = new Set();
    var telemetryEnabled = !utils_polyfills_includes(telemetry_TELEMETRY_EXCLUDED_SITES, configuration.site) && numberUtils_performDraw(configuration.telemetrySampleRate);
    var telemetryEnabledPerType = (_a = {},
        _a[rawTelemetryEvent_types_TelemetryType.log] = telemetryEnabled,
        _a[rawTelemetryEvent_types_TelemetryType.configuration] = telemetryEnabled && numberUtils_performDraw(configuration.telemetryConfigurationSampleRate),
        _a[rawTelemetryEvent_types_TelemetryType.usage] = telemetryEnabled && numberUtils_performDraw(configuration.telemetryUsageSampleRate),
        _a);
    var runtimeEnvInfo = telemetry_getRuntimeEnvInfo();
    telemetry_onRawTelemetryEventCollected = function (rawEvent) {
        var stringifiedEvent = jsonStringify_jsonStringify(rawEvent);
        if (telemetryEnabledPerType[rawEvent.type] &&
            alreadySentEvents.size < configuration.maxTelemetryEventsPerPage &&
            !alreadySentEvents.has(stringifiedEvent)) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            sendToExtension_sendToExtension('telemetry', event_1);
            alreadySentEvents.add(stringifiedEvent);
        }
    };
    monitor_startMonitorErrorCollection(telemetry_addTelemetryError);
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return mergeInto_combine({
            type: 'telemetry',
            date: timeUtils_timeStampNow(),
            service: telemetryService,
            version: "5.23.3",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: mergeInto_combine(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: connectivity_getConnectivity(),
            }),
            experimental_features: utils_polyfills_arrayFrom(experimentalFeatures_getExperimentalFeatures()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryEnabled,
    };
}
function telemetry_getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function telemetry_startFakeTelemetry() {
    var events = [];
    telemetry_onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
// need to be called after telemetry context is provided and observers are registered
function telemetry_drainPreStartTelemetry() {
    telemetry_preStartTelemetryBuffer.drain();
}
function telemetry_resetTelemetry() {
    telemetry_preStartTelemetryBuffer = createBoundedBuffer();
    telemetry_onRawTelemetryEventCollected = function (event) {
        telemetry_preStartTelemetryBuffer.add(function () { return telemetry_onRawTelemetryEventCollected(event); });
    };
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function telemetry_isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites_INTAKE_SITE_STAGING;
}
function telemetry_addTelemetryDebug(message, context) {
    monitor_displayIfDebugEnabled(display_ConsoleApiName.debug, message, context);
    telemetry_onRawTelemetryEventCollected(utils_polyfills_assign({
        type: rawTelemetryEvent_types_TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function telemetry_addTelemetryError(e, context) {
    telemetry_onRawTelemetryEventCollected(utils_polyfills_assign({
        type: rawTelemetryEvent_types_TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, telemetry_formatError(e), context));
}
function telemetry_addTelemetryConfiguration(configuration) {
    telemetry_onRawTelemetryEventCollected({
        type: rawTelemetryEvent_types_TelemetryType.configuration,
        configuration: configuration,
    });
}
function telemetry_addTelemetryUsage(usage) {
    telemetry_onRawTelemetryEventCollected({
        type: rawTelemetryEvent_types_TelemetryType.usage,
        usage: usage,
    });
}
function telemetry_formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace_computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: handlingStack_toStackTraceString(telemetry_scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error_NO_ERROR_STACK_PRESENT_MESSAGE,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify_jsonStringify(e)),
    };
}
function telemetry_scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || telemetry_ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return polyfills_startsWith(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/addEventListener.js


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener_addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListener_addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListener_addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = monitor_monitor(function (event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
            return;
        }
        if (once) {
            stop();
        }
        listener(event);
    });
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = getZoneJsOriginalValue_getZoneJsOriginalValue(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = getZoneJsOriginalValue_getZoneJsOriginalValue(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js


var storeContextManager_CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storeContextManager_storageListeners = [];
function storeContextManager_storeContextManager(configuration, contextManager, productKey, customerDataType) {
    var storageKey = storeContextManager_buildStorageKey(productKey, customerDataType);
    storeContextManager_storageListeners.push(addEventListener_addEventListener(configuration, window, "storage" /* DOM_EVENT.STORAGE */, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext(mergeInto_combine(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function storeContextManager_buildStorageKey(productKey, customerDataType) {
    return "".concat(storeContextManager_CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function storeContextManager_removeStorageListeners() {
    storeContextManager_storageListeners.map(function (listener) { return listener.stop(); });
}
//# sourceMappingURL=storeContextManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/encoder.js

function encoder_createIdentityEncoder() {
    var output = '';
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty() {
            return !output;
        },
        write: function (data, callback) {
            var additionalEncodedBytesCount = byteUtils_computeBytesCount(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) {
                callback(additionalEncodedBytesCount);
            }
        },
        finish: function (callback) {
            callback(this.finishSync());
        },
        finishSync: function () {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: '',
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function (data) {
            return data.length;
        },
    };
}
//# sourceMappingURL=encoder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/user/user.js



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function user_sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = utils_polyfills_assign({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function user_checkUser(newUser) {
    var isValid = typeUtils_getType(newUser) === 'object';
    if (!isValid) {
        display_display.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js

function displayAlreadyInitializedError_displayAlreadyInitializedError(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) {
        display_display.error("".concat(sdkName, " is already initialized."));
    }
}
//# sourceMappingURL=displayAlreadyInitializedError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function commonContext_buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/eventBridge.js


function eventBridge_getEventBridge() {
    var eventBridgeGlobal = eventBridge_getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getCapabilities: function () {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
        },
        getPrivacyLevel: function () {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event, viewId) {
            var view = viewId ? { id: viewId } : undefined;
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event, view: view }));
        },
    };
}
function eventBridge_bridgeSupports(capability) {
    var bridge = eventBridge_getEventBridge();
    return !!bridge && utils_polyfills_includes(bridge.getCapabilities(), capability);
}
function eventBridge_canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = getGlobalObject_getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = eventBridge_getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || polyfills_endsWith(currentHost, ".".concat(allowedHost)); }));
}
function eventBridge_getEventBridgeGlobal() {
    return getGlobalObject_getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js





/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod_instrumentMethod(targetPrototype, method, onPreCall, _a) {
    var _b = _a === void 0 ? {} : _a, computeHandlingStack = _b.computeHandlingStack;
    var original = targetPrototype[method];
    if (typeof original !== 'function') {
        if (polyfills_startsWith(method, 'on')) {
            original = utils_functionUtils_noop;
        }
        else {
            return { stop: utils_functionUtils_noop };
        }
    }
    var stopped = false;
    var instrumentation = function () {
        if (stopped) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
            return original.apply(this, arguments);
        }
        var parameters = utils_polyfills_arrayFrom(arguments);
        var postCallCallback;
        monitor_callMonitored(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function (callback) {
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? handlingStack_createHandlingStack() : undefined,
            },
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var result = original.apply(this, parameters);
        if (postCallCallback) {
            monitor_callMonitored(postCallCallback, null, [result]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: function () {
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) {
                targetPrototype[method] = original;
            }
        },
    };
}
function instrumentMethod_instrumentSetter(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: utils_functionUtils_noop };
    }
    var stoppedInstrumentation = utils_functionUtils_noop;
    var instrumentation = function (target, value) {
        // put hooked setter into event loop to avoid of set latency
        tools_timer_setTimeout(function () {
            if (instrumentation !== stoppedInstrumentation) {
                after(target, value);
            }
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(targetPrototype, property, originalDescriptor);
            }
            instrumentation = stoppedInstrumentation;
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js

function urlPolyfill_normalizeUrl(url) {
    return urlPolyfill_buildUrl(url, location.href).href;
}
function urlPolyfill_isValidUrl(url) {
    try {
        return !!urlPolyfill_buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function urlPolyfill_getPathName(url) {
    var pathname = urlPolyfill_buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function urlPolyfill_buildUrl(url, base) {
    var supportedURL = urlPolyfill_getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify_jsonStringify({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var urlPolyfill_originalURL = URL;
var urlPolyfill_isURLSupported;
function urlPolyfill_getSupportedUrl() {
    if (urlPolyfill_isURLSupported === undefined) {
        try {
            var url = new urlPolyfill_originalURL('http://test/path');
            urlPolyfill_isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            urlPolyfill_isURLSupported = false;
        }
    }
    return urlPolyfill_isURLSupported ? urlPolyfill_originalURL : undefined;
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/fetchObservable.js






var fetchObservable_fetchObservable;
function fetchObservable_initFetchObservable() {
    if (!fetchObservable_fetchObservable) {
        fetchObservable_fetchObservable = fetchObservable_createFetchObservable();
    }
    return fetchObservable_fetchObservable;
}
function fetchObservable_resetFetchObservable() {
    fetchObservable_fetchObservable = undefined;
}
function fetchObservable_createFetchObservable() {
    return new observable_Observable(function (observable) {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod_instrumentMethod(window, 'fetch', function (call) { return fetchObservable_beforeSend(call, observable); }, {
            computeHandlingStack: true,
        }).stop;
        return stop;
    });
}
function fetchObservable_beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall, handlingStack = _a.handlingStack;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) {
        methodFromParams = input.method;
    }
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    var url = input instanceof Request ? input.url : urlPolyfill_normalizeUrl(String(input));
    var startClocks = timeUtils_clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
        handlingStack: handlingStack,
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function (responsePromise) { return fetchObservable_afterSend(observable, responsePromise, context); });
}
function fetchObservable_afterSend(observable, responsePromise, startContext) {
    var context = startContext;
    function reportFetch(partialContext) {
        context.state = 'resolve';
        utils_polyfills_assign(context, partialContext);
        observable.notify(context);
    }
    responsePromise.then(monitor_monitor(function (response) {
        reportFetch({
            response: response,
            responseType: response.type,
            status: response.status,
            isAborted: false,
        });
    }), monitor_monitor(function (error) {
        var _a, _b;
        reportFetch({
            status: 0,
            isAborted: ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || (error instanceof DOMException && error.code === DOMException.ABORT_ERR),
            error: error,
        });
    }));
}
//# sourceMappingURL=fetchObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function stringUtils_generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, stringUtils_generateUUID);
}
var stringUtils_COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function stringUtils_findCommaSeparatedValue(rawString, name) {
    stringUtils_COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = stringUtils_COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) {
                return match[2];
            }
        }
        else {
            break;
        }
    }
}
function stringUtils_findCommaSeparatedValues(rawString) {
    var result = new Map();
    stringUtils_COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = stringUtils_COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            result.set(match[1], match[2]);
        }
        else {
            break;
        }
    }
    return result;
}
function stringUtils_safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/cookie.js



function cookie_setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    var partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function cookie_getCookie(name) {
    return stringUtils_findCommaSeparatedValue(document.cookie, name);
}
var cookie_initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function cookie_getInitCookie(name) {
    if (!cookie_initCookieParsed) {
        cookie_initCookieParsed = stringUtils_findCommaSeparatedValues(document.cookie);
    }
    return cookie_initCookieParsed.get(name);
}
function cookie_resetInitCookies() {
    cookie_initCookieParsed = undefined;
}
function cookie_deleteCookie(name, options) {
    cookie_setCookie(name, '', 0, options);
}
function cookie_areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(stringUtils_generateUUID());
        var testCookieValue = 'test';
        cookie_setCookie(testCookieName, testCookieValue, timeUtils_ONE_MINUTE, options);
        var isCookieCorrectlySet = cookie_getCookie(testCookieName) === testCookieValue;
        cookie_deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display_display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var cookie_getCurrentSiteCache;
function cookie_getCurrentSite() {
    if (cookie_getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(stringUtils_generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !cookie_getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            cookie_setCookie(testCookieName, testCookieValue, timeUtils_ONE_SECOND, { domain: candidateDomain });
        }
        cookie_deleteCookie(testCookieName, { domain: candidateDomain });
        cookie_getCurrentSiteCache = candidateDomain;
    }
    return cookie_getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js

var syntheticsWorkerValues_SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var syntheticsWorkerValues_SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var syntheticsWorkerValues_SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function syntheticsWorkerValues_willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || cookie_getInitCookie(syntheticsWorkerValues_SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function syntheticsWorkerValues_getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || cookie_getInitCookie(syntheticsWorkerValues_SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function syntheticsWorkerValues_getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || cookie_getInitCookie(syntheticsWorkerValues_SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
function browserDetection_isIE() {
    return browserDetection_detectBrowserCached() === 0 /* Browser.IE */;
}
function browserDetection_isChromium() {
    return browserDetection_detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function browserDetection_isSafari() {
    return browserDetection_detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserDetection_browserCache;
function browserDetection_detectBrowserCached() {
    return browserDetection_browserCache !== null && browserDetection_browserCache !== void 0 ? browserDetection_browserCache : (browserDetection_browserCache = browserDetection_detectBrowser());
}
// Exported only for tests
function browserDetection_detectBrowser(browserWindow) {
    var _a;
    if (browserWindow === void 0) { browserWindow = window; }
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
        return 1 /* Browser.CHROMIUM */;
    }
    if (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 ||
        (/safari/i.test(userAgent) && !/chrome|android/i.test(userAgent))) {
        return 2 /* Browser.SAFARI */;
    }
    if (browserWindow.document.documentMode) {
        return 0 /* Browser.IE */;
    }
    return 3 /* Browser.OTHER */;
}
//# sourceMappingURL=browserDetection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var sessionStoreStrategy_SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js

var sessionConstants_SESSION_TIME_OUT_DELAY = 4 * timeUtils_ONE_HOUR;
var sessionConstants_SESSION_EXPIRATION_DELAY = 15 * timeUtils_ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var sessionState_SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var sessionState_SESSION_ENTRY_SEPARATOR = '&';
var sessionState_EXPIRED = '1';
function sessionState_getExpiredSessionState() {
    return {
        isExpired: sessionState_EXPIRED,
    };
}
function sessionState_isSessionInNotStartedState(session) {
    return objectUtils_isEmptyObject(session);
}
function sessionState_isSessionStarted(session) {
    return !sessionState_isSessionInNotStartedState(session);
}
function sessionState_isSessionInExpiredState(session) {
    return session.isExpired !== undefined || !sessionState_isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function sessionState_isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return ((sessionState.created === undefined || timeUtils_dateNow() - Number(sessionState.created) < sessionConstants_SESSION_TIME_OUT_DELAY) &&
        (sessionState.expire === undefined || timeUtils_dateNow() < Number(sessionState.expire)));
}
function sessionState_expandSessionState(session) {
    session.expire = String(timeUtils_dateNow() + sessionConstants_SESSION_EXPIRATION_DELAY);
}
function sessionState_toSessionString(session) {
    return polyfills_objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(sessionState_SESSION_ENTRY_SEPARATOR);
}
function sessionState_toSessionState(sessionString) {
    var session = {};
    if (sessionState_isValidSessionString(sessionString)) {
        sessionString.split(sessionState_SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = sessionState_SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function sessionState_isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(sessionState_SESSION_ENTRY_SEPARATOR) !== -1 || sessionState_SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var oldCookiesMigration_OLD_SESSION_COOKIE_NAME = '_dd';
var oldCookiesMigration_OLD_RUM_COOKIE_NAME = '_dd_r';
var oldCookiesMigration_OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var oldCookiesMigration_RUM_SESSION_KEY = 'rum';
var oldCookiesMigration_LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function oldCookiesMigration_tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = cookie_getInitCookie(sessionStoreStrategy_SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = cookie_getInitCookie(oldCookiesMigration_OLD_SESSION_COOKIE_NAME);
        var oldRumType = cookie_getInitCookie(oldCookiesMigration_OLD_RUM_COOKIE_NAME);
        var oldLogsType = cookie_getInitCookie(oldCookiesMigration_OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[oldCookiesMigration_LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[oldCookiesMigration_RUM_SESSION_KEY] = oldRumType;
        }
        if (sessionState_isSessionStarted(session)) {
            sessionState_expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js






function sessionInCookie_selectCookieStrategy(initConfiguration) {
    var cookieOptions = sessionInCookie_buildCookieOptions(initConfiguration);
    return cookie_areCookiesAuthorized(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function sessionInCookie_initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: browserDetection_isChromium(),
        persistSession: sessionInCookie_persistSessionCookie(cookieOptions),
        retrieveSession: sessionInCookie_retrieveSessionCookie,
        expireSession: function () { return sessionInCookie_expireSessionCookie(cookieOptions); },
    };
    oldCookiesMigration_tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function sessionInCookie_persistSessionCookie(options) {
    return function (session) {
        cookie_setCookie(sessionStoreStrategy_SESSION_STORE_KEY, sessionState_toSessionString(session), sessionConstants_SESSION_EXPIRATION_DELAY, options);
    };
}
function sessionInCookie_expireSessionCookie(options) {
    cookie_setCookie(sessionStoreStrategy_SESSION_STORE_KEY, sessionState_toSessionString(sessionState_getExpiredSessionState()), sessionConstants_SESSION_TIME_OUT_DELAY, options);
}
function sessionInCookie_retrieveSessionCookie() {
    var sessionString = cookie_getCookie(sessionStoreStrategy_SESSION_STORE_KEY);
    return sessionState_toSessionState(sessionString);
}
function sessionInCookie_buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure =
        !!initConfiguration.useSecureSessionCookie ||
            !!initConfiguration.usePartitionedCrossSiteSessionCookie ||
            !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite =
        !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = cookie_getCurrentSite();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var sessionInLocalStorage_LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function sessionInLocalStorage_selectLocalStorageStrategy() {
    try {
        var id = stringUtils_generateUUID();
        var testKey = "".concat(sessionInLocalStorage_LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function sessionInLocalStorage_initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: sessionInLocalStorage_persistInLocalStorage,
        retrieveSession: sessionInLocalStorage_retrieveSessionFromLocalStorage,
        expireSession: sessionInLocalStorage_expireSessionFromLocalStorage,
    };
}
function sessionInLocalStorage_persistInLocalStorage(sessionState) {
    localStorage.setItem(sessionStoreStrategy_SESSION_STORE_KEY, sessionState_toSessionString(sessionState));
}
function sessionInLocalStorage_retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(sessionStoreStrategy_SESSION_STORE_KEY);
    return sessionState_toSessionState(sessionString);
}
function sessionInLocalStorage_expireSessionFromLocalStorage() {
    sessionInLocalStorage_persistInLocalStorage(sessionState_getExpiredSessionState());
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js




var sessionStoreOperations_LOCK_RETRY_DELAY = 10;
var sessionStoreOperations_LOCK_MAX_TRIES = 100;
var sessionStoreOperations_bufferedOperations = [];
var sessionStoreOperations_ongoingOperations;
function sessionStoreOperations_processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, persistSession = sessionStoreStrategy.persistSession, expireSession = sessionStoreStrategy.expireSession;
    var persistWithLock = function (session) { return persistSession(utils_polyfills_assign({}, session, { lock: currentLock })); };
    var retrieveStore = function () {
        var session = sessionStoreStrategy.retrieveSession();
        var lock = session.lock;
        if (session.lock) {
            delete session.lock;
        }
        return {
            session: session,
            lock: lock,
        };
    };
    if (!sessionStoreOperations_ongoingOperations) {
        sessionStoreOperations_ongoingOperations = operations;
    }
    if (operations !== sessionStoreOperations_ongoingOperations) {
        sessionStoreOperations_bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= sessionStoreOperations_LOCK_MAX_TRIES) {
        sessionStoreOperations_next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            sessionStoreOperations_retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = stringUtils_generateUUID();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            sessionStoreOperations_retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            sessionStoreOperations_retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (sessionState_isSessionInExpiredState(processedSession)) {
            expireSession();
        }
        else {
            sessionState_expandSessionState(processedSession);
            isLockEnabled ? persistWithLock(processedSession) : persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && sessionState_isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                sessionStoreOperations_retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
    sessionStoreOperations_next(sessionStoreStrategy);
}
function sessionStoreOperations_retryLater(operations, sessionStore, currentNumberOfRetries) {
    tools_timer_setTimeout(function () {
        sessionStoreOperations_processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, sessionStoreOperations_LOCK_RETRY_DELAY);
}
function sessionStoreOperations_next(sessionStore) {
    sessionStoreOperations_ongoingOperations = undefined;
    var nextOperations = sessionStoreOperations_bufferedOperations.shift();
    if (nextOperations) {
        sessionStoreOperations_processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js










/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var sessionStore_STORAGE_POLL_DELAY = timeUtils_ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function sessionStore_selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = sessionInCookie_selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = sessionInLocalStorage_selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function sessionStore_startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new observable_Observable();
    var expireObservable = new observable_Observable();
    var sessionStateUpdateObservable = new observable_Observable();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? sessionInCookie_initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : sessionInLocalStorage_initLocalStorageStrategy();
    var expireSession = sessionStoreStrategy.expireSession;
    var watchSessionTimeoutId = tools_timer_setInterval(watchSession, sessionStore_STORAGE_POLL_DELAY);
    var sessionCache;
    startSession();
    var _a = functionUtils_throttle(function () {
        sessionStoreOperations_processSessionStoreOperations({
            process: function (sessionState) {
                if (sessionState_isSessionInNotStartedState(sessionState)) {
                    return;
                }
                var synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (sessionState_isSessionStarted(sessionState) && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }, sessionStore_STORAGE_POLL_DELAY), throttledExpandOrRenewSession = _a.throttled, cancelExpandOrRenewSession = _a.cancel;
    function expandSession() {
        sessionStoreOperations_processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        sessionStoreOperations_processSessionStoreOperations({
            process: function (sessionState) { return (sessionState_isSessionInExpiredState(sessionState) ? sessionState_getExpiredSessionState() : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (sessionState_isSessionInExpiredState(sessionState)) {
            sessionState = sessionState_getExpiredSessionState();
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionStateUpdateObservable.notify({ previousState: sessionCache, newState: sessionState });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        sessionStoreOperations_processSessionStoreOperations({
            process: function (sessionState) {
                if (sessionState_isSessionInNotStartedState(sessionState)) {
                    return sessionState_getExpiredSessionState();
                }
            },
            after: function (sessionState) {
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if (sessionState_isSessionInNotStartedState(sessionState)) {
            return false;
        }
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (isTracked && !sessionState.id) {
            sessionState.id = stringUtils_generateUUID();
            sessionState.created = String(timeUtils_dateNow());
        }
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = sessionState_getExpiredSessionState();
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        sessionStoreOperations_processSessionStoreOperations({
            process: function (sessionState) { return utils_polyfills_assign({}, sessionState, partialSessionState); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStateUpdateObservable,
        restartSession: startSession,
        expire: function () {
            cancelExpandOrRenewSession();
            expireSession();
            synchronizeSession(sessionState_getExpiredSessionState());
        },
        stop: function () {
            tools_timer_clearInterval(watchSessionTimeoutId);
        },
        updateSessionState: updateSessionState,
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js




function endpointBuilder_createEndpointBuilder(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = endpointBuilder_createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function (api, payload) {
            var parameters = endpointBuilder_buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        trackType: trackType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function endpointBuilder_createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        var normalizedProxyUrl_1 = urlPolyfill_normalizeUrl(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    if (typeof proxy === 'function') {
        return function (parameters) { return proxy({ path: path, parameters: parameters }); };
    }
    var host = endpointBuilder_buildEndpointHost(trackType, initConfiguration);
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function endpointBuilder_buildEndpointHost(trackType, initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites_INTAKE_SITE_US1 : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (trackType === 'logs' && initConfiguration.usePciIntake && site === intakeSites_INTAKE_SITE_US1) {
        return intakeSites_PCI_INTAKE_HOST_US1;
    }
    if (internalAnalyticsSubdomain && site === intakeSites_INTAKE_SITE_US1) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites_INTAKE_SITE_US1);
    }
    if (site === intakeSites_INTAKE_SITE_FED_STAGING) {
        return "http-intake.logs.".concat(site);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function endpointBuilder_buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("5.23.3"), "api:".concat(api)].concat(configurationTags);
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.23.3")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat(stringUtils_generateUUID()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (trackType === 'rum') {
        parameters.push("batch_time=".concat(timeUtils_timeStampNow()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var tags_TAG_SIZE_LIMIT = 200;
function tags_buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(tags_buildTag('env', env));
    }
    if (service) {
        tags.push(tags_buildTag('service', service));
    }
    if (version) {
        tags.push(tags_buildTag('version', version));
    }
    if (datacenter) {
        tags.push(tags_buildTag('datacenter', datacenter));
    }
    return tags;
}
var tags_FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function tags_buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = tags_TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || tags_FORBIDDEN_CHARACTERS.test(rawValue)) {
        display_display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. ").concat(display_MORE_DETAILS, " ").concat(display_DOCS_ORIGIN, "/getting_started/tagging/#defining-tags"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function transportConfiguration_computeTransportConfiguration(initConfiguration) {
    var site = initConfiguration.site || intakeSites_INTAKE_SITE_US1;
    var tags = tags_buildTags(initConfiguration);
    var endpointBuilders = transportConfiguration_computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = transportConfiguration_computeIntakeUrlPrefixes(endpointBuilders, site);
    var replicaConfiguration = transportConfiguration_computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return utils_polyfills_assign({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: site,
    }, endpointBuilders);
}
function transportConfiguration_computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: endpointBuilder_createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: endpointBuilder_createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: endpointBuilder_createEndpointBuilder(initConfiguration, 'replay', tags),
    };
}
function transportConfiguration_computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = utils_polyfills_assign({}, initConfiguration, {
        site: intakeSites_INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: endpointBuilder_createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: endpointBuilder_createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, polyfills_objectValues(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return utils_polyfills_assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
function transportConfiguration_computeIntakeUrlPrefixes(endpointBuilders, site) {
    var intakeUrlPrefixes = polyfills_objectValues(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    if (site === intakeSites_INTAKE_SITE_US1) {
        intakeUrlPrefixes.push("https://".concat(intakeSites_PCI_INTAKE_HOST_US1, "/"));
    }
    return intakeUrlPrefixes;
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js










var configuration_DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
var configuration_TraceContextInjection = {
    ALL: 'all',
    SAMPLED: 'sampled',
};
function configuration_isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== 'string') {
        display_display.error("".concat(tagName, " must be defined as a string"));
        return false;
    }
    return true;
}
function configuration_isDatadogSite(site) {
    if (site && typeof site === 'string' && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        display_display.error("Site should be a valid Datadog site. ".concat(display_MORE_DETAILS, " ").concat(display_DOCS_ORIGIN, "/getting_started/site/."));
        return false;
    }
    return true;
}
function configuration_isSampleRate(sampleRate, name) {
    if (sampleRate !== undefined && !numberUtils_isPercentage(sampleRate)) {
        display_display.error("".concat(name, " Sample Rate should be a number between 0 and 100"));
        return false;
    }
    return true;
}
function configuration_validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display_display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (!configuration_isDatadogSite(initConfiguration.site) ||
        !configuration_isSampleRate(initConfiguration.sessionSampleRate, 'Session') ||
        !configuration_isSampleRate(initConfiguration.telemetrySampleRate, 'Telemetry') ||
        !configuration_isSampleRate(initConfiguration.telemetryConfigurationSampleRate, 'Telemetry Configuration') ||
        !configuration_isSampleRate(initConfiguration.telemetryUsageSampleRate, 'Telemetry Usage') ||
        !configuration_isString(initConfiguration.version, 'Version') ||
        !configuration_isString(initConfiguration.env, 'Env') ||
        !configuration_isString(initConfiguration.service, 'Service')) {
        return;
    }
    if (initConfiguration.trackingConsent !== undefined &&
        !objectUtils_objectHasValue(trackingConsent_TrackingConsent, initConfiguration.trackingConsent)) {
        display_display.error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return utils_polyfills_assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors_catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: sessionStore_selectSessionStoreStrategyType(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: initConfiguration.service || undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : trackingConsent_TrackingConsent.GRANTED,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * byteUtils_ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * timeUtils_ONE_SECOND),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * byteUtils_ONE_KIBI_BYTE,
    }, transportConfiguration_computeTransportConfiguration(initConfiguration));
}
function configuration_serializeConfiguration(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
    };
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/matchOption.js



function isMatchOption(item) {
    var itemType = typeUtils_getType(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? polyfills_startsWith(value, item) : item === value;
            }
        }
        catch (e) {
            display_display.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return (typeUtils_getType(expectedItem) === 'object' &&
        isMatchOption(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = objectUtils_shallowClone(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(polyfills_objectEntries(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = polyfills_find(configuration.allowedTracingUrls, function (tracingOption) {
        return matchList([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceSampled = !utils_numberUtils_isNumber(configuration.traceSampleRate) || numberUtils_performDraw(configuration.traceSampleRate);
    if (!context.traceSampled && configuration.traceContextInjection !== configuration_TraceContextInjection.ALL) {
        return;
    }
    context.traceId = createTraceIdentifier();
    context.spanId = createTraceIdentifier();
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                utils_polyfills_assign(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                utils_polyfills_assign(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                utils_polyfills_assign(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                utils_polyfills_assign(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
function createTraceIdentifier() {
    var buffer = new Uint8Array(8);
    getCrypto().getRandomValues(buffer);
    buffer[0] = buffer[0] & 0x7f; // force 63-bit
    function readInt32(offset) {
        return buffer[offset] * 16777216 + (buffer[offset + 1] << 16) + (buffer[offset + 2] << 8) + buffer[offset + 3];
    }
    function toString(radix) {
        var high = readInt32(0);
        var low = readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    }
    /**
     * Format used everywhere except the trace intake
     */
    function toDecimalString() {
        return toString(10);
    }
    /**
     * Format used by OTel headers
     */
    function toPaddedHexadecimalString() {
        var traceId = toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    }
    return {
        toDecimalString: toDecimalString,
        toPaddedHexadecimalString: toPaddedHexadecimalString,
    };
}
/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/configuration/configuration.js


var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        display_display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (!configuration_isSampleRate(initConfiguration.sessionReplaySampleRate, 'Session Replay') ||
        !configuration_isSampleRate(initConfiguration.traceSampleRate, 'Trace')) {
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display_display.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = configuration_validateAndBuildConfiguration(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    return utils_polyfills_assign({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version || undefined,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
        startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
        traceSampleRate: initConfiguration.traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!initConfiguration.trackUserInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!initConfiguration.trackResources,
        trackLongTasks: !!initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: objectUtils_objectHasValue(configuration_DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_DefaultPrivacyLevel.MASK,
        enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
        customerDataTelemetrySampleRate: 1,
        traceContextInjection: objectUtils_objectHasValue(configuration_TraceContextInjection, initConfiguration.traceContextInjection)
            ? initConfiguration.traceContextInjection
            : configuration_TraceContextInjection.ALL,
        plugins: initConfiguration.betaPlugins || [],
    }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls === undefined) {
        return [];
    }
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
        display_display.error('Allowed Tracing URLs should be an array');
        return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
        display_display.error('Service needs to be configured when tracing is enabled');
        return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    var tracingOptions = [];
    initConfiguration.allowedTracingUrls.forEach(function (option) {
        if (isMatchOption(option)) {
            tracingOptions.push({ match: option, propagatorTypes: DEFAULT_PROPAGATOR_TYPES });
        }
        else if (isTracingOption(option)) {
            tracingOptions.push(option);
        }
        else {
            display_display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
        }
    });
    return tracingOptions;
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
            else if (typeUtils_getType(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    return utils_polyfills_arrayFrom(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a;
    var baseSerializedConfiguration = configuration_serializeConfiguration(configuration);
    return utils_polyfills_assign({
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        plugins: (_a = configuration.betaPlugins) === null || _a === void 0 ? void 0 : _a.map(function (plugin) { var _a; return utils_polyfills_assign({ name: plugin.name }, (_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin)); }),
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/vital/vitalCollection.js

function startVitalCollection(lifeCycle, pageStateHistory) {
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital, true));
        }
    }
    return {
        addDurationVital: addDurationVital,
        startDurationVital: function (startVital) {
            return createVitalInstance(function (vital) {
                addDurationVital(vital);
            }, startVital);
        },
    };
}
function createVitalInstance(stopCallback, vitalStart) {
    var startClocks = timeUtils_clocksNow();
    var stopClocks;
    return {
        stop: function (vitalStop) {
            if (stopClocks) {
                return;
            }
            stopClocks = timeUtils_clocksNow();
            stopCallback(buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks));
        },
    };
}
function buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks) {
    var _a;
    if (vitalStop === void 0) { vitalStop = {}; }
    return {
        name: vitalStart.name,
        type: "duration" /* VitalType.DURATION */,
        startClocks: startClocks,
        duration: timeUtils_elapsed(startClocks.timeStamp, stopClocks.timeStamp),
        context: mergeInto_combine(vitalStart.context, vitalStop.context),
        details: (_a = vitalStop.details) !== null && _a !== void 0 ? _a : vitalStart.details,
    };
}
function processVital(vital, valueComputedBySdk) {
    var rawRumEvent = {
        date: vital.startClocks.timeStamp,
        vital: {
            id: stringUtils_generateUUID(),
            type: vital.type,
            name: vital.name,
            duration: timeUtils_toServerDuration(vital.duration),
            details: vital.details,
        },
        type: "vital" /* RumEventType.VITAL */,
    };
    if (valueComputedBySdk) {
        rawRumEvent._dd = {
            vital: {
                computed_value: true,
            },
        };
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: vital.startClocks.relative,
        customerContext: vital.context,
        domainContext: {},
    };
}
//# sourceMappingURL=vitalCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/configuration/remoteConfiguration.js

var REMOTE_CONFIGURATION_URL = 'https://d3uc069fcn7uxw.cloudfront.net/configuration';
function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
    fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
        callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
    });
}
function applyRemoteConfiguration(initConfiguration, remoteInitConfiguration) {
    return utils_polyfills_assign({}, initConfiguration, remoteInitConfiguration);
}
function fetchRemoteConfiguration(configuration, callback) {
    var xhr = new XMLHttpRequest();
    addEventListener_addEventListener(configuration, xhr, 'load', function () {
        if (xhr.status === 200) {
            callback(JSON.parse(xhr.responseText));
        }
        else {
            displayRemoteConfigurationFetchingError();
        }
    });
    addEventListener_addEventListener(configuration, xhr, 'error', function () {
        displayRemoteConfigurationFetchingError();
    });
    xhr.open('GET', "".concat(REMOTE_CONFIGURATION_URL, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json"));
    xhr.send();
}
function displayRemoteConfigurationFetchingError() {
    display_display.error('Error fetching the remote configuration.');
}
//# sourceMappingURL=remoteConfiguration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/plugins.js
function callPluginsMethod(plugins, methodName, parameter) {
    if (!plugins) {
        return;
    }
    for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
        var plugin = plugins_1[_i];
        var method = plugin[methodName];
        if (method) {
            method(parameter);
        }
    }
}
//# sourceMappingURL=plugins.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/boot/preStartRum.js





function preStartRum_createPreStartStrategy(_a, getCommonContext, trackingConsentState, doStartRum) {
    var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum, startDeflateWorker = _a.startDeflateWorker;
    var bufferApiCalls = tools_boundedBuffer_createBoundedBuffer();
    var firstStartViewCall;
    var deflateWorker;
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
            return;
        }
        trackingConsentStateSubscription.unsubscribe();
        var initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) {
                return;
            }
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        var startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    function doInit(initConfiguration) {
        var eventBridgeAvailable = eventBridge_canUseEventBridge();
        if (eventBridgeAvailable) {
            initConfiguration = preStartRum_overrideInitConfigurationForBridge(initConfiguration);
        }
        // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
        cachedInitConfiguration = initConfiguration;
        telemetry_addTelemetryConfiguration(serializeRumConfiguration(initConfiguration));
        if (cachedConfiguration) {
            displayAlreadyInitializedError_displayAlreadyInitializedError('DD_RUM', initConfiguration);
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            display_display.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', 
            // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            utils_functionUtils_noop);
            if (!deflateWorker) {
                // `startDeflateWorker` should have logged an error message explaining the issue
                return;
            }
        }
        cachedConfiguration = configuration;
        // Instrumuent fetch to track network requests
        // This is needed in case the consent is not granted and some cutsomer
        // library (Apollo Client) is storing uninstrumented fetch to be used later
        // The subscrption is needed so that the instrumentation process is completed
        fetchObservable_initFetchObservable().subscribe(utils_functionUtils_noop);
        trackingConsentState.tryToInit(configuration.trackingConsent);
        tryStartRum();
    }
    var addDurationVital = function (vital) {
        bufferApiCalls.add(function (startRumResult) { return startRumResult.addDurationVital(vital); });
    };
    return {
        init: function (initConfiguration, publicApi) {
            if (!initConfiguration) {
                display_display.error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            experimentalFeatures_initFeatureFlags(initConfiguration.enableExperimentalFeatures);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && syntheticsWorkerValues_willSyntheticsInjectRum()) {
                return;
            }
            callPluginsMethod(initConfiguration.betaPlugins, 'onInit', { initConfiguration: initConfiguration, publicApi: publicApi });
            if (initConfiguration.remoteConfigurationId &&
                experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.REMOTE_CONFIGURATION)) {
                fetchAndApplyRemoteConfiguration(initConfiguration, doInit);
            }
            else {
                doInit(initConfiguration);
            }
        },
        get initConfiguration() {
            return cachedInitConfiguration;
        },
        getInternalContext: utils_functionUtils_noop,
        stopSession: utils_functionUtils_noop,
        addTiming: function (name, time) {
            if (time === void 0) { time = timeUtils_timeStampNow(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addTiming(name, time); });
        },
        startView: function (options, startClocks) {
            if (startClocks === void 0) { startClocks = timeUtils_clocksNow(); }
            var callback = function (startRumResult) {
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = { options: options, callback: callback };
                tryStartRum();
            }
        },
        updateViewName: function (name) {
            bufferApiCalls.add(function (startRumResult) { return startRumResult.updateViewName(name); });
        },
        addAction: function (action, commonContext) {
            if (commonContext === void 0) { commonContext = getCommonContext(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addAction(action, commonContext); });
        },
        addError: function (providedError, commonContext) {
            if (commonContext === void 0) { commonContext = getCommonContext(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addError(providedError, commonContext); });
        },
        addFeatureFlagEvaluation: function (key, value) {
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addFeatureFlagEvaluation(key, value); });
        },
        startDurationVital: function (vitalStart) {
            return createVitalInstance(function (vital) { return addDurationVital(vital); }, vitalStart);
        },
        addDurationVital: addDurationVital,
    };
}
function preStartRum_overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return utils_polyfills_assign({}, initConfiguration, {
        applicationId: '00000000-aaaa-0000-aaaa-000000000000',
        clientToken: 'empty',
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = eventBridge_getEventBridge()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel(),
    });
}
//# sourceMappingURL=preStartRum.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, options) {
    if (options === void 0) { options = {}; }
    var customerDataTrackerManager = customerDataTracker_createCustomerDataTrackerManager(0 /* CustomerDataCompressionStatus.Unknown */);
    var globalContextManager = contextManager_createContextManager(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
    var userContextManager = contextManager_createContextManager(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
    var trackingConsentState = trackingConsent_createTrackingConsentState();
    function getCommonContext() {
        return commonContext_buildCommonContext(globalContextManager, userContextManager, recorderApi);
    }
    var strategy = preStartRum_createPreStartStrategy(options, getCommonContext, trackingConsentState, function (configuration, deflateWorker, initialViewOptions) {
        if (experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.CUSTOM_VITALS)) {
            /**
             * Start a custom duration vital
             * stored in @vital.custom.<name>
             *
             * @param name name of the custom vital
             * @param options.context custom context attached to the vital
             * @param options.details  Details of the vital.
             */
            ;
            rumPublicApi.startDurationVital = monitor_monitor(function (name, options) {
                telemetry_addTelemetryUsage({ feature: 'start-duration-vital' });
                return strategy.startDurationVital({
                    name: sanitize_sanitize(name),
                    context: sanitize_sanitize(options && options.context),
                    details: sanitize_sanitize(options && options.details),
                });
            });
            rumPublicApi.addDurationVital = monitor_monitor(function (name, options) {
                telemetry_addTelemetryUsage({ feature: 'add-duration-vital' });
                strategy.addDurationVital({
                    name: sanitize_sanitize(name),
                    type: "duration" /* VitalType.DURATION */,
                    startClocks: timeUtils_timeStampToClocks(options.startTime),
                    duration: options.duration,
                    context: sanitize_sanitize(options && options.context),
                    details: sanitize_sanitize(options && options.details),
                });
            });
            rumPublicApi.stopDurationVital = utils_functionUtils_noop;
        }
        if (experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.UPDATE_VIEW_NAME)) {
            /**
             * Update View Name.
             *
             * Enable to manually change the name of the current view.
             * @param name name of the view
             * See [Override default RUM view names](https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/#override-default-rum-view-names) for further information.
             */
            ;
            rumPublicApi.updateViewName = monitor_monitor(function (name) {
                strategy.updateViewName(name);
            });
        }
        if (configuration.storeContextsAcrossPages) {
            storeContextManager_storeContextManager(configuration, globalContextManager, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            storeContextManager_storeContextManager(configuration, userContextManager, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
        }
        customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */ : 2 /* CustomerDataCompressionStatus.Disabled */);
        var startRumResult = startRumImpl(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder
            ? function (streamId) { return options.createDeflateEncoder(configuration, deflateWorker, streamId); }
            : encoder_createIdentityEncoder, trackingConsentState);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
        strategy = rumPublicApi_createPostStartStrategy(strategy, startRumResult);
        return startRumResult;
    });
    var startView = monitor_monitor(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        strategy.startView(sanitizedOptions);
        telemetry_addTelemetryUsage({ feature: 'start-view' });
    });
    var rumPublicApi = init_makePublicApi({
        init: monitor_monitor(function (initConfiguration) { return strategy.init(initConfiguration, rumPublicApi); }),
        setTrackingConsent: monitor_monitor(function (trackingConsent) {
            trackingConsentState.update(trackingConsent);
            telemetry_addTelemetryUsage({ feature: 'set-tracking-consent', tracking_consent: trackingConsent });
        }),
        setGlobalContext: monitor_monitor(function (context) {
            globalContextManager.setContext(context);
            telemetry_addTelemetryUsage({ feature: 'set-global-context' });
        }),
        getGlobalContext: monitor_monitor(function () { return globalContextManager.getContext(); }),
        setGlobalContextProperty: monitor_monitor(function (key, value) {
            globalContextManager.setContextProperty(key, value);
            telemetry_addTelemetryUsage({ feature: 'set-global-context' });
        }),
        removeGlobalContextProperty: monitor_monitor(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: monitor_monitor(function () { return globalContextManager.clearContext(); }),
        getInternalContext: monitor_monitor(function (startTime) { return strategy.getInternalContext(startTime); }),
        getInitConfiguration: monitor_monitor(function () { return mergeInto_deepClone(strategy.initConfiguration); }),
        addAction: function (name, context) {
            var handlingStack = handlingStack_createHandlingStack();
            monitor_callMonitored(function () {
                strategy.addAction({
                    name: sanitize_sanitize(name),
                    context: sanitize_sanitize(context),
                    startClocks: timeUtils_clocksNow(),
                    type: "custom" /* ActionType.CUSTOM */,
                    handlingStack: handlingStack,
                });
                telemetry_addTelemetryUsage({ feature: 'add-action' });
            });
        },
        addError: function (error, context) {
            var handlingStack = handlingStack_createHandlingStack();
            monitor_callMonitored(function () {
                strategy.addError({
                    error: error, // Do not sanitize error here, it is needed unserialized by computeRawError()
                    handlingStack: handlingStack,
                    context: sanitize_sanitize(context),
                    startClocks: timeUtils_clocksNow(),
                });
                telemetry_addTelemetryUsage({ feature: 'add-error' });
            });
        },
        addTiming: monitor_monitor(function (name, time) {
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming(sanitize_sanitize(name), time);
        }),
        setUser: monitor_monitor(function (newUser) {
            if (user_checkUser(newUser)) {
                userContextManager.setContext(user_sanitizeUser(newUser));
            }
            telemetry_addTelemetryUsage({ feature: 'set-user' });
        }),
        getUser: monitor_monitor(function () { return userContextManager.getContext(); }),
        setUserProperty: monitor_monitor(function (key, property) {
            var _a;
            var sanitizedProperty = user_sanitizeUser((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
            telemetry_addTelemetryUsage({ feature: 'set-user' });
        }),
        removeUserProperty: monitor_monitor(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: monitor_monitor(function () { return userContextManager.clearContext(); }),
        startView: startView,
        stopSession: monitor_monitor(function () {
            strategy.stopSession();
            telemetry_addTelemetryUsage({ feature: 'stop-session' });
        }),
        addFeatureFlagEvaluation: monitor_monitor(function (key, value) {
            strategy.addFeatureFlagEvaluation(sanitize_sanitize(key), sanitize_sanitize(value));
            telemetry_addTelemetryUsage({ feature: 'add-feature-flag-evaluation' });
        }),
        getSessionReplayLink: monitor_monitor(function () { return recorderApi.getSessionReplayLink(); }),
        startSessionReplayRecording: monitor_monitor(function (options) {
            recorderApi.start(options);
            telemetry_addTelemetryUsage({ feature: 'start-session-replay-recording', force: options && options.force });
        }),
        stopSessionReplayRecording: monitor_monitor(function () { return recorderApi.stop(); }),
    });
    return rumPublicApi;
}
function rumPublicApi_createPostStartStrategy(preStartStrategy, startRumResult) {
    return utils_polyfills_assign({
        init: function (initConfiguration) {
            displayAlreadyInitializedError_displayAlreadyInitializedError('DD_RUM', initConfiguration);
        },
        initConfiguration: preStartStrategy.initConfiguration,
    }, startRumResult);
}
//# sourceMappingURL=rumPublicApi.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js



var pageExitObservable_PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function pageExitObservable_createPageExitObservable(configuration) {
    return new observable_Observable(function (observable) {
        var stopListeners = addEventListener_addEventListeners(configuration, window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */], function (event) {
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: pageExitObservable_PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: pageExitObservable_PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = addEventListener_addEventListener(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
            observable.notify({ reason: pageExitObservable_PageExitReason.UNLOADING });
        }).stop;
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function pageExitObservable_isPageExitReason(reason) {
    return utils_polyfills_includes(polyfills_objectValues(pageExitObservable_PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    return new observable_Observable(function (observable) {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(monitor_monitor(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = getZoneJsOriginalValue_getZoneJsOriginalValue(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(utils_functionUtils_noop);
            var originalInstance = getZoneJsOriginalValue_getZoneJsOriginalValue(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return utils_polyfills_includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return utils_polyfills_includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!urlPolyfill_isValidUrl(url)) {
        telemetry_addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = urlPolyfill_getPathName(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return timeUtils_toServerDuration(timeUtils_elapsed(startTime, responseEnd));
    }
    return timeUtils_toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
    if (!isValidEntry(entry)) {
        return undefined;
    }
    var startTime = entry.startTime, fetchStart = entry.fetchStart, redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd, domainLookupStart = entry.domainLookupStart, domainLookupEnd = entry.domainLookupEnd, connectStart = entry.connectStart, secureConnectionStart = entry.secureConnectionStart, connectEnd = entry.connectEnd, requestStart = entry.requestStart, responseStart = entry.responseStart, responseEnd = entry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (fetchStart < connectEnd) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (fetchStart < domainLookupEnd) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    // Make sure a redirection occurred
    if (startTime < redirectEnd) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function isValidEntry(entry) {
    if (experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.TOLERANT_RESOURCE_TIMINGS)) {
        return true;
    }
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    var areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    var areRedirectionTimingsInOrder = hasRedirection(entry)
        ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart)
        : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
    if (origin <= start && start <= end) {
        return {
            duration: timeUtils_toServerDuration(timeUtils_elapsed(start, end)),
            start: timeUtils_toServerDuration(timeUtils_elapsed(origin, start)),
        };
    }
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        var encodedBodySize = entry.encodedBodySize, decodedBodySize = entry.decodedBodySize, transferSize = entry.transferSize;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize,
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined,
    };
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
var DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 24000;
function isLongDataUrl(url) {
    if (url.length <= MAX_ATTRIBUTE_VALUE_CHAR_LENGTH) {
        return false;
    }
    else if (url.substring(0, 5) === 'data:') {
        // Avoid String.match RangeError: Maximum call stack size exceeded
        url = url.substring(0, MAX_ATTRIBUTE_VALUE_CHAR_LENGTH);
        return true;
    }
    return false;
}
function sanitizeDataUrl(url) {
    return "".concat(url.match(DATA_URL_REGEX)[0], "[...]");
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/performanceObservable.js


// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function createPerformanceObservable(configuration, options) {
    return new observable_Observable(function (observable) {
        if (!window.PerformanceObserver) {
            return;
        }
        var handlePerformanceEntries = function (entries) {
            var rumPerformanceEntries = filterRumPerformanceEntries(configuration, entries);
            if (rumPerformanceEntries.length > 0) {
                observable.notify(rumPerformanceEntries);
            }
        };
        var timeoutId;
        var isObserverInitializing = true;
        var observer = new PerformanceObserver(monitor_monitor(function (entries) {
            // In Safari the performance observer callback is synchronous.
            // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
            if (isObserverInitializing) {
                timeoutId = tools_timer_setTimeout(function () { return handlePerformanceEntries(entries.getEntries()); });
            }
            else {
                handlePerformanceEntries(entries.getEntries());
            }
        }));
        try {
            observer.observe(options);
        }
        catch (_a) {
            // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
            // TODO: remove this fallback in the next major version
            var fallbackSupportedEntryTypes = [
                RumPerformanceEntryType.RESOURCE,
                RumPerformanceEntryType.NAVIGATION,
                RumPerformanceEntryType.LONG_TASK,
                RumPerformanceEntryType.PAINT,
            ];
            if (utils_polyfills_includes(fallbackSupportedEntryTypes, options.type)) {
                if (options.buffered) {
                    timeoutId = tools_timer_setTimeout(function () { return handlePerformanceEntries(performance.getEntriesByType(options.type)); });
                }
                try {
                    observer.observe({ entryTypes: [options.type] });
                }
                catch (_b) {
                    // Old versions of Safari are throwing "entryTypes contained only unsupported types"
                    // errors when observing only unsupported entry types.
                    //
                    // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
                    // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
                    // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
                    // even if they do support the entry type.
                    return;
                }
            }
        }
        isObserverInitializing = false;
        manageResourceTimingBufferFull(configuration);
        return function () {
            observer.disconnect();
            tools_timer_clearTimeout(timeoutId);
        };
    });
}
var resourceTimingBufferFullListener;
function manageResourceTimingBufferFull(configuration) {
    if (!resourceTimingBufferFullListener && supportPerformanceObject() && 'addEventListener' in performance) {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
        resourceTimingBufferFullListener = addEventListener_addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
            performance.clearResourceTimings();
        });
    }
    return function () {
        resourceTimingBufferFullListener === null || resourceTimingBufferFullListener === void 0 ? void 0 : resourceTimingBufferFullListener.stop();
    };
}
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function filterRumPerformanceEntries(configuration, entries) {
    return entries.filter(function (entry) { return !isForbiddenResource(configuration, entry); });
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === RumPerformanceEntryType.RESOURCE && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js


function performanceCollection_supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function startPerformanceCollection(lifeCycle, configuration) {
    var cleanupTasks = [];
    if (performanceCollection_supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        tools_timer_setTimeout(function () { return handleRumPerformanceEntries(lifeCycle, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = monitor_monitor(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, entries.getEntries());
        });
        var mainEntries = [RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
        var experimentalEntries = [
            RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
            RumPerformanceEntryType.FIRST_INPUT,
            RumPerformanceEntryType.LAYOUT_SHIFT,
            RumPerformanceEntryType.EVENT,
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40,
                });
                cleanupTasks.push(function () { return observer.disconnect(); });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
        try {
            mainObserver_1.observe({ entryTypes: mainEntries });
            cleanupTasks.push(function () { return mainObserver_1.disconnect(); });
        }
        catch (_a) {
            // Old versions of Safari are throwing "entryTypes contained only unsupported types"
            // errors when observing only unsupported entry types.
            //
            // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
            // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
            // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
            // even if they do support the entry type.
        }
        if (performanceCollection_supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            var removePerformanceListener = addEventListener_addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            }).stop;
            cleanupTasks.push(removePerformanceListener);
        }
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
        var stopFirstInputTiming = retrieveFirstInputTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, [timing]);
        }).stop;
        cleanupTasks.push(stopFirstInputTiming);
    }
    return {
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = timeUtils_dateNow();
    var timingSent = false;
    var removeEventListeners = addEventListener_addEventListeners(configuration, window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: RumPerformanceEntryType.FIRST_INPUT,
            processingStart: timeUtils_relativeNow(),
            processingEnd: timeUtils_relativeNow(),
            startTime: evt.timeStamp,
            duration: 0, // arbitrary value to avoid nullable duration and simplify INP logic
            name: '',
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    return { stop: removeEventListeners };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        addEventListener_addEventListeners(configuration, window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < timeUtils_dateNow() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function handleRumPerformanceEntries(lifeCycle, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return objectUtils_objectHasValue(RumPerformanceEntryType, entry.entryType);
    });
    if (rumPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumPerformanceEntries);
    }
}
//# sourceMappingURL=performanceCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types_ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js



function createEventRateLimiter_createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                tools_timer_setTimeout(function () {
                    eventCount = 0;
                }, timeUtils_ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: error_types_ErrorSource.AGENT,
                        startClocks: timeUtils_clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = syntheticsWorkerValues_getSyntheticsTestId();
    var resultId = syntheticsWorkerValues_getSyntheticsResultId();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: syntheticsWorkerValues_willSyntheticsInjectRum(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = mergeInto_deepClone(object);
    var result = modifier(clone);
    polyfills_objectEntries(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = typeUtils_getType(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, sanitize_sanitize(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return typeUtils_getType(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/assembly.js



var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
    service: 'string',
    version: 'string',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = utils_polyfills_assign({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = utils_polyfills_assign({
            'resource.url': 'string',
        }, experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL)
            ? {
                'resource.graphql': 'object',
            }
            : {}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = utils_polyfills_assign({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = utils_polyfills_assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["vital" /* RumEventType.VITAL */] = utils_polyfills_assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = createEventRateLimiter_createEventRateLimiter("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = createEventRateLimiter_createEventRateLimiter("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b["vital" /* RumEventType.VITAL */] = createEventRateLimiter_createEventRateLimiter("vital" /* RumEventType.VITAL */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = getSyntheticsContext();
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: timeUtils_currentDrift(),
                    configuration: {
                        session_sample_rate: utils_numberUtils_round(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: utils_numberUtils_round(configuration.sessionReplaySampleRate, 3),
                    },
                    browser_sdk_version: eventBridge_canUseEventBridge() ? "5.23.3" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: timeUtils_timeStampNow(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext
                        ? "synthetics" /* SessionType.SYNTHETICS */
                        : ciVisibilityContext.get()
                            ? "ci_test" /* SessionType.CI_TEST */
                            : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciVisibilityContext.get(),
                display: displayContext.get(),
                connectivity: connectivity_getConnectivity(),
            };
            var serverRumEvent = mergeInto_combine(rumContext, rawRumEvent);
            serverRumEvent.context = mergeInto_combine(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (serverRumEvent.type === 'view') {
                ;
                serverRumEvent.session.sampled_for_replay =
                    session.sessionReplay === 1 /* SessionReplayState.SAMPLED */;
            }
            if (!objectUtils_isEmptyObject(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (objectUtils_isEmptyObject(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            display_display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function internalContext_startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
// eslint-disable-next-line no-restricted-syntax
var abstractLifeCycle_AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

var lifeCycle_LifeCycle = (abstractLifeCycle_AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/valueHistory.js



var valueHistory_END_OF_TIMES = Infinity;
var valueHistory_CLEAR_OLD_VALUES_INTERVAL = timeUtils_ONE_MINUTE;
function valueHistory_createValueHistory(_a) {
    var expireDelay = _a.expireDelay, maxEntries = _a.maxEntries;
    var entries = [];
    var clearOldValuesInterval = tools_timer_setInterval(function () { return clearOldValues(); }, valueHistory_CLEAR_OLD_VALUES_INTERVAL);
    function clearOldValues() {
        var oldTimeThreshold = timeUtils_relativeNow() - expireDelay;
        while (entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold) {
            entries.pop();
        }
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    function add(value, startTime) {
        var entry = {
            value: value,
            startTime: startTime,
            endTime: valueHistory_END_OF_TIMES,
            remove: function () {
                arrayUtils_removeItem(entries, entry);
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (maxEntries && entries.length >= maxEntries) {
            entries.pop();
        }
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */
    function find(startTime, options) {
        if (startTime === void 0) { startTime = valueHistory_END_OF_TIMES; }
        if (options === void 0) { options = { returnInactive: false }; }
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.startTime <= startTime) {
                if (options.returnInactive || startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    function closeActive(endTime) {
        var latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === valueHistory_END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    function findAll(startTime, duration) {
        if (startTime === void 0) { startTime = valueHistory_END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = timeUtils_addDuration(startTime, duration);
        return entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    }
    /**
     * Remove all entries from this collection.
     */
    function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */
    function stop() {
        tools_timer_clearInterval(clearOldValuesInterval);
    }
    return { add: add, find: find, closeActive: closeActive, findAll: findAll, reset: reset, stop: stop };
}
//# sourceMappingURL=valueHistory.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants_SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = valueHistory_createValueHistory({ expireDelay: VIEW_CONTEXT_TIME_OUT_DELAY });
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (viewUpdate) {
        var currentView = viewContextHistory.find(viewUpdate.startClocks.relative);
        if (currentView && viewUpdate.name) {
            currentView.name = viewUpdate.name;
        }
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






var xhrObservable_xhrObservable;
var xhrObservable_xhrContexts = new WeakMap();
function xhrObservable_initXhrObservable(configuration) {
    if (!xhrObservable_xhrObservable) {
        xhrObservable_xhrObservable = xhrObservable_createXhrObservable(configuration);
    }
    return xhrObservable_xhrObservable;
}
function xhrObservable_createXhrObservable(configuration) {
    return new observable_Observable(function (observable) {
        var stopInstrumentingStart = instrumentMethod_instrumentMethod(XMLHttpRequest.prototype, 'open', xhrObservable_openXhr).stop;
        var stopInstrumentingSend = instrumentMethod_instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
            xhrObservable_sendXhr(call, configuration, observable);
        }, { computeHandlingStack: true }).stop;
        var stopInstrumentingAbort = instrumentMethod_instrumentMethod(XMLHttpRequest.prototype, 'abort', xhrObservable_abortXhr).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function xhrObservable_openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    xhrObservable_xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: urlPolyfill_normalizeUrl(String(url)),
    });
}
function xhrObservable_sendXhr(_a, configuration, observable) {
    var xhr = _a.target, handlingStack = _a.handlingStack;
    var context = xhrObservable_xhrContexts.get(xhr);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startClocks = timeUtils_clocksNow();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethod_instrumentMethod(xhr, 'onreadystatechange', function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            // Try to report the XHR as soon as possible, because the XHR may be mutated by the
            // application during a future event. For example, Angular is calling .abort() on
            // completed requests during an onreadystatechange event, so the status becomes '0'
            // before the request is collected.
            onEnd();
        }
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = timeUtils_elapsed(startContext.startClocks.timeStamp, timeUtils_timeStampNow());
        completeContext.status = xhr.status;
        observable.notify(objectUtils_shallowClone(completeContext));
    };
    var unsubscribeLoadEndListener = addEventListener_addEventListener(configuration, xhr, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function xhrObservable_abortXhr(_a) {
    var xhr = _a.target;
    var context = xhrObservable_xhrContexts.get(xhr);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
function responseUtils_isServerError(status) {
    return status >= 500;
}
function responseUtils_tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream_readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then(monitor_monitor(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), monitor_monitor(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        utils_functionUtils_noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = xhrObservable_initXhrObservable(configuration).subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = fetchObservable_initFetchObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                        isAborted: context.isAborted,
                        handlingStack: context.handlingStack,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && responseUtils_tryToClone(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback(timeUtils_elapsed(context.startClocks.timeStamp, timeUtils_timeStampNow()));
    }
    else {
        readBytesFromStream_readBytesFromStream(clonedResponse.body, function () {
            callback(timeUtils_elapsed(context.startClocks.timeStamp, timeUtils_timeStampNow()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/discardNegativeDuration.js

function discardNegativeDuration(duration) {
    return utils_numberUtils_isNumber(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=discardNegativeDuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? utils_functionUtils_noop : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        var _a;
        if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js


// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = tools_timer_setTimeout(monitor_monitor(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? tools_timer_setTimeout(monitor_monitor(function () { return complete({ hadActivity: true, end: timeUtils_timeStampNow() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        tools_timer_clearTimeout(validationTimeoutId);
        tools_timer_clearTimeout(pageActivityEndTimeoutId);
        var lastChangeTime = timeUtils_timeStampNow();
        if (!isBusy) {
            pageActivityEndTimeoutId = tools_timer_setTimeout(monitor_monitor(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        tools_timer_clearTimeout(validationTimeoutId);
        tools_timer_clearTimeout(pageActivityEndTimeoutId);
        tools_timer_clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    return new observable_Observable(function (observable) {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), createPerformanceObservable(configuration, { type: RumPerformanceEntryType.RESOURCE }).subscribe(function (entries) {
            if (entries.some(function (entry) { return !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return instrumentMethod_instrumentMethod(window, 'open', callback);
}
//# sourceMappingURL=waitPageActivityEnd.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/polyfills.js
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
/**
 * Return the parentElement of an node
 *
 * In cases where parentElement is not supported, such as in IE11 for SVG nodes, we fallback to parentNode
 */
function getParentElement(node) {
    if (node.parentElement) {
        return node.parentElement;
    }
    while (node.parentNode) {
        if (node.parentNode.nodeType === Node.ELEMENT_NODE) {
            return node.parentNode;
        }
        node = node.parentNode;
    }
    return null;
}
/**
 * Return the classList of an element or an array of classes if classList is not supported
 *
 * In cases where classList is not supported, such as in IE11 for SVG and MathML elements,
 * we fallback to using element.getAttribute('class').
 * We opt for element.getAttribute('class') over element.className because className returns an SVGAnimatedString for SVG elements.
 */
function getClassList(element) {
    if (element.classList) {
        return element.classList;
    }
    var classes = (element.getAttribute('class') || '').trim();
    return classes ? classes.split(/\s+/) : [];
}
// ie11 supports WeakMap but not WeakSet
var PLACEHOLDER = 1;
// eslint-disable-next-line no-restricted-syntax
var polyfills_WeakSet = /** @class */ (function () {
    function WeakSet(initialValues) {
        var _this = this;
        this.map = new WeakMap();
        if (initialValues) {
            initialValues.forEach(function (value) { return _this.map.set(value, PLACEHOLDER); });
        }
    }
    WeakSet.prototype.add = function (value) {
        this.map.set(value, PLACEHOLDER);
        return this;
    };
    WeakSet.prototype.delete = function (value) {
        return this.map.delete(value);
    };
    WeakSet.prototype.has = function (value) {
        return this.map.has(value);
    };
    return WeakSet;
}());

//# sourceMappingURL=polyfills.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
    var child = node.firstChild;
    while (child) {
        callback(child);
        child = child.nextSibling;
    }
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/privacy.js



var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_DefaultPrivacyLevel.ALLOW,
    MASK: configuration_DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: configuration_DefaultPrivacyLevel.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) {
        return cache.get(node);
    }
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode
        ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache)
        : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    var nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) {
        cache.set(node, nodePrivacyLevel);
    }
    return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.HIDDEN))) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK))) {
        return NodePrivacyLevel.MASK;
    }
    if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.ALLOW))) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
function getPrivacySelector(privacyLevel) {
    return "[".concat(PRIVACY_ATTR_NAME, "=\"").concat(privacyLevel, "\"], .").concat(PRIVACY_CLASS_PREFIX).concat(privacyLevel);
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.js



/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
var ACTION_NAME_PLACEHOLDER = 'Masked Element';
function getActionNameFromElement(element, _a, nodePrivacyLevel) {
    var enablePrivacyForActionName = _a.enablePrivacyForActionName, userProgrammaticAttribute = _a.actionNameAttribute;
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    var defaultActionName = getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute));
    if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
        return defaultActionName || ACTION_NAME_PLACEHOLDER;
    }
    return (defaultActionName ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies, enablePrivacyForActionName) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies, enablePrivacyForActionName) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = getParentElement(element);
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute, privacy) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                polyfills_find(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute, privacy);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute, privacyEnabledActionName) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute, privacyEnabledActionName) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute, privacyEnabledActionName) {
        return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies, privacyEnabledActionName) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute, privacyEnabledActionName);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = getParentElement(element);
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(stringUtils_safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        if (privacyEnabledActionName) {
            // remove the text of elements with privacy override
            removeTextFromElements("".concat(getPrivacySelector(NodePrivacyLevel.HIDDEN), ", ").concat(getPrivacySelector(NodePrivacyLevel.MASK)));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !browserDetection_isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    if (!isConnected(targetElement)) {
        // We cannot compute a selector for a detached element, as we don't have access to all of its
        // parents, and we cannot determine if it's unique in the document.
        return;
    }
    var targetElementSelector;
    var currentElement = targetElement;
    while (currentElement && currentElement.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(currentElement, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(currentElement, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(currentElement), targetElementSelector);
        currentElement = getParentElement(currentElement);
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat(cssEscape(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    var classList = getClassList(element);
    for (var i = 0; i < classList.length; i += 1) {
        var className = classList[i];
        if (isGeneratedValue(className)) {
            continue;
        }
        return "".concat(cssEscape(element.tagName), ".").concat(cssEscape(className));
    }
}
function getTagNameSelector(element) {
    return cssEscape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat(cssEscape(element.tagName), "[").concat(attributeName, "=\"").concat(cssEscape(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = getParentElement(element).firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat(cssEscape(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        if (predicate(element, elementSelector, childSelector)) {
            return combineSelector(elementSelector, childSelector);
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, elementSelector, childSelector) {
    return element.ownerDocument.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
 *
 * @param {Element} currentElement - the element being considered while iterating over the target
 * element ancestors.
 *
 * @param {string} currentElementSelector - a selector that matches the current element. That
 * selector is not a composed selector (i.e. it might be a single tag name, class name...).
 *
 * @param {string|undefined} childSelector - child selector is a selector that targets a descendant
 * of the current element. When undefined, the current element is the target element.
 *
 * # Scope selector usage
 *
 * When composed together, the final selector will be joined with `>` operators to make sure we
 * target direct descendants at each level. In this function, we'll use `querySelector` to check if
 * a selector matches descendants of the current element. But by default, the query selector match
 * elements at any level. Example:
 *
 * ```html
 * <main>
 *   <div>
 *     <span></span>
 *   </div>
 *   <marquee>
 *     <div>
 *       <span></span>
 *     </div>
 *   </marquee>
 * </main>
 * ```
 *
 * `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
 * selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
 * operator (`MAIN > DIV > SPAN`).
 *
 * To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
 * sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT CHILD_SELECTOR" returns a single element), regardless of whether the selector is
 * a direct descendant of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 *
 * [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
 *
 * # Performance considerations
 *
 * We compute selectors in performance-critical operations (ex: during a click), so we need to make
 * sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
 * check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
 *
 * Because we are iterating the DOM upward and we use that function at every level, we know the
 * child selector is already unique among the current element children, so we don't need to check
 * for the current element subtree.
 *
 * Instead, we can focus on the current element siblings. If we find a single element matching the
 * selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
 * (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
 */
function isSelectorUniqueAmongSiblings(currentElement, currentElementSelector, childSelector) {
    var isSiblingMatching;
    if (childSelector === undefined) {
        // If the child selector is undefined (meaning `currentElement` is the target element, not one
        // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
        // as `querySelector` only returns a descendant of the element.
        isSiblingMatching = function (sibling) { return elementMatches(sibling, currentElementSelector); };
    }
    else {
        var scopedSelector_1 = supportScopeSelector()
            ? combineSelector("".concat(currentElementSelector, ":scope"), childSelector)
            : combineSelector(currentElementSelector, childSelector);
        isSiblingMatching = function (sibling) { return sibling.querySelector(scopedSelector_1) !== null; };
    }
    var parent = getParentElement(currentElement);
    var sibling = parent.firstElementChild;
    while (sibling) {
        if (sibling !== currentElement && isSiblingMatching(sibling)) {
            return false;
        }
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
/**
 * Polyfill-utility for the `isConnected` property not supported in IE11
 */
function isConnected(element) {
    if ('isConnected' in
        // cast is to make sure `element` is not inferred as `never` after the check
        element) {
        return element.isConnected;
    }
    return element.ownerDocument.documentElement.contains(element);
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = timeUtils_ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        tools_timer_clearTimeout(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = tools_timer_setTimeout(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        tools_timer_clearTimeout(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.js

function listenActionEvents(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
        scroll: false,
    };
    var clickContext;
    var listeners = [
        addEventListener_addEventListener(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        addEventListener_addEventListener(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        addEventListener_addEventListener(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, function () {
            userActivity.scroll = true;
        }, { capture: true, passive: true }),
        addEventListener_addEventListener(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        addEventListener_addEventListener(configuration, window, "input" /* DOM_EVENT.INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.js


var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection || click.getUserActivity().scroll; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            timeUtils_ONE_SECOND) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) {
        return false;
    }
    return !elementMatches(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.js









// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * timeUtils_ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * timeUtils_ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = valueHistory_createValueHistory({ expireDelay: ACTION_CONTEXT_TIME_OUT_DELAY });
    var stopObservable = new observable_Observable();
    var currentClickChain;
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents(configuration, {
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) { return history.findAll(startTime); },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
    var nodePrivacyLevel = configuration.enablePrivacyForActionName
        ? getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel)
        : NodePrivacyLevel.ALLOW;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return undefined;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, configuration.actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: getActionNameFromElement(event.target, configuration, nodePrivacyLevel),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = stringUtils_generateUUID();
    var startClocks = timeUtils_clocksNow();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? utils_polyfills_includes(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new observable_Observable();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close(timeUtils_getRelativeTime(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = utils_polyfills_assign({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && timeUtils_elapsed(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop(timeUtils_timeStampNow());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.js



function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: utils_functionUtils_noop };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, utils_polyfills_assign({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: discardNegativeDuration(timeUtils_toServerDuration(action.duration)),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = mergeInto_combine({
        action: {
            id: stringUtils_generateUUID(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, action.startClocks.relative) },
    }, autoActionProperties);
    var domainContext = isAutoAction(action) ? { events: action.events } : {};
    if (!isAutoAction(action) && action.handlingStack) {
        domainContext.handlingStack = action.handlingStack;
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: domainContext,
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js





function trackRuntimeError_trackRuntimeError(errorObservable) {
    var handleRuntimeError = function (stackTrace, originalError) {
        var rawError = error_computeRawError({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: timeUtils_clocksNow(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: error_types_ErrorSource.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = trackRuntimeError_instrumentOnError(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = trackRuntimeError_instrumentUnhandledRejection(handleRuntimeError).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
function trackRuntimeError_instrumentOnError(callback) {
    return instrumentMethod_instrumentMethod(window, 'onerror', function (_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if (errorObj instanceof Error) {
            stackTrace = computeStackTrace_computeStackTrace(errorObj);
        }
        else {
            stackTrace = computeStackTrace_computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
        }
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function trackRuntimeError_instrumentUnhandledRejection(callback) {
    return instrumentMethod_instrumentMethod(window, 'onunhandledrejection', function (_a) {
        var e = _a.parameters[0];
        var reason = e.reason || 'Empty reason';
        var stack = computeStackTrace_computeStackTrace(reason);
        callback(stack, reason);
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js









var consoleObservable_consoleObservablesByApi = {};
function consoleObservable_initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservable_consoleObservablesByApi[api]) {
            consoleObservable_consoleObservablesByApi[api] = consoleObservable_createConsoleObservable(api);
        }
        return consoleObservable_consoleObservablesByApi[api];
    });
    return observable_mergeObservables.apply(void 0, consoleObservables);
}
function consoleObservable_resetConsoleObservable() {
    consoleObservable_consoleObservablesByApi = {};
}
function consoleObservable_createConsoleObservable(api) {
    return new observable_Observable(function (observable) {
        var originalConsoleApi = display_globalConsole[api];
        display_globalConsole[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = handlingStack_createHandlingStack();
            monitor_callMonitored(function () {
                observable.notify(consoleObservable_buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            display_globalConsole[api] = originalConsoleApi;
        };
    });
}
function consoleObservable_buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function (param) { return consoleObservable_formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    var causes;
    if (api === display_ConsoleApiName.error) {
        var firstErrorParam = polyfills_find(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? handlingStack_toStackTraceString(computeStackTrace_computeStackTrace(firstErrorParam)) : undefined;
        fingerprint = error_tryToGetFingerprint(firstErrorParam);
        causes = firstErrorParam ? error_flattenErrorCauses(firstErrorParam, 'console') : undefined;
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
        causes: causes,
    };
}
function consoleObservable_formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return sanitize_sanitize(param);
    }
    if (param instanceof Error) {
        return handlingStack_formatErrorMessage(computeStackTrace_computeStackTrace(param));
    }
    return jsonStringify_jsonStringify(sanitize_sanitize(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = consoleObservable_initConsoleObservable([display_ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: timeUtils_clocksNow(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: error_types_ErrorSource.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js






var reportObservable_RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function reportObservable_initReportObservable(configuration, apis) {
    var observables = [];
    if (utils_polyfills_includes(apis, reportObservable_RawReportType.cspViolation)) {
        observables.push(reportObservable_createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== reportObservable_RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(reportObservable_createReportObservable(reportTypes));
    }
    return observable_mergeObservables.apply(void 0, observables);
}
function reportObservable_createReportObservable(reportTypes) {
    return new observable_Observable(function (observable) {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor_monitor(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(reportObservable_buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
}
function reportObservable_createCspViolationReportObservable(configuration) {
    return new observable_Observable(function (observable) {
        var stop = addEventListener_addEventListener(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(reportObservable_buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function reportObservable_buildRawReportFromReport(report) {
    var type = report.type, body = report.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalReport: report,
        stack: reportObservable_buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function reportObservable_buildRawReportFromCspViolation(event) {
    var type = reportObservable_RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: reportObservable_RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: reportObservable_buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat(stringUtils_safeTruncate(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
        originalReport: event,
    };
}
function reportObservable_buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? handlingStack_toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.js

function trackReportError(configuration, errorObservable) {
    var subscription = reportObservable_initReportObservable(configuration, [
        reportObservable_RawReportType.cspViolation,
        reportObservable_RawReportType.intervention,
    ]).subscribe(function (reportError) {
        var rawError = {
            startClocks: timeUtils_clocksNow(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: error_types_ErrorSource.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
            originalError: reportError.originalReport,
        };
        if (reportError.originalReport.type === 'securitypolicyviolation') {
            rawError.csp = {
                disposition: reportError.originalReport.disposition,
            };
        }
        return errorObservable.notify(rawError);
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.js



function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new observable_Observable();
    trackConsoleError(errorObservable);
    trackRuntimeError_trackRuntimeError(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, utils_polyfills_assign({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? computeStackTrace_computeStackTrace(error) : undefined;
            var rawError = error_computeRawError({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types_ErrorSource.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: stringUtils_generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
            csp: error.csp,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !objectUtils_isEmptyObject(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    var domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack,
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: domainContext,
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.js


function startLongTaskCollection(lifeCycle, configuration) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            if (!configuration.trackLongTasks) {
                break;
            }
            var startClocks = timeUtils_relativeToClocks(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: stringUtils_generateUUID(),
                    duration: timeUtils_toServerDuration(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/resource/matchRequestTiming.js



var alreadyMatchedEntries = new polyfills_WeakSet();
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - filter out timing that were already matched to a request
 * - then, if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .filter(function (entry) { return !alreadyMatchedEntries.has(entry); })
        .filter(function (entry) { return isValidEntry(entry); })
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        alreadyMatchedEntries.add(candidates[0]);
        return candidates[0].toJSON();
    }
    return;
}
function endTime(timing) {
    return timeUtils_addDuration(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= timeUtils_addDuration(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js

function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
        addEventListener_addEventListener(configuration, window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * timeUtils_ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= timeUtils_dateNow() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(stringUtils_findCommaSeparatedValue(comment, 'trace-id'), stringUtils_findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/performanceUtils.js

function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (utils_numberUtils_isNumber(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : timeUtils_getRelativeTime(timingElement);
        }
    }
    return result;
}
//# sourceMappingURL=performanceUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/resource/retrieveInitialDocumentResourceTiming.js





function retrieveInitialDocumentResourceTiming(configuration, callback) {
    runOnReadyState(configuration, 'interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
            toJSON: function () { return utils_polyfills_assign({}, timing, { toJSON: undefined }); },
        };
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) &&
            performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
            timing = utils_polyfills_assign(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = utils_polyfills_assign(relativePerformanceTiming, {
                decodedBodySize: 0,
                encodedBodySize: 0,
                transferSize: 0,
                renderBlockingStatus: 'non-blocking',
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
//# sourceMappingURL=retrieveInitialDocumentResourceTiming.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.js






function startResourceCollection(lifeCycle, configuration, pageStateHistory, retrieveInitialDocumentResourceTimingImpl) {
    if (retrieveInitialDocumentResourceTimingImpl === void 0) { retrieveInitialDocumentResourceTimingImpl = retrieveInitialDocumentResourceTiming; }
    lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        var rawEvent = processRequest(request, configuration, pageStateHistory);
        if (rawEvent) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
    });
    var performanceResourceSubscription = createPerformanceObservable(configuration, {
        type: RumPerformanceEntryType.RESOURCE,
        buffered: true,
    }).subscribe(function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (!isRequestKind(entry)) {
                var rawEvent = processResourceEntry(entry, configuration);
                if (rawEvent) {
                    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
                }
            }
        }
    });
    retrieveInitialDocumentResourceTimingImpl(configuration, function (timing) {
        var rawEvent = processResourceEntry(timing, configuration);
        if (rawEvent) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
    });
    return {
        stop: function () {
            performanceResourceSubscription.unsubscribe();
        },
    };
}
function processRequest(request, configuration, pageStateHistory) {
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? timeUtils_relativeToClocks(matchingTiming.startTime) : request.startClocks;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    if (!configuration.trackResources && !tracingInfo) {
        return;
    }
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var resourceEvent = mergeInto_combine({
        date: startClocks.timeStamp,
        resource: {
            id: stringUtils_generateUUID(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: isLongDataUrl(request.url) ? sanitizeDataUrl(request.url) : request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !configuration.trackResources,
        },
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming,
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
            isAborted: request.isAborted,
            handlingStack: request.handlingStack,
        },
    };
}
function processResourceEntry(entry, configuration) {
    var startClocks = timeUtils_relativeToClocks(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) {
        return;
    }
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var resourceEvent = mergeInto_combine({
        date: startClocks.timeStamp,
        resource: {
            id: stringUtils_generateUUID(),
            type: type,
            url: entry.name,
            status_code: discardZeroStatus(entry.responseStatus),
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !configuration.trackResources,
        },
    }, tracingInfo, entryMetrics);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: entry,
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    var renderBlockingStatus = timing.renderBlockingStatus;
    return {
        resource: utils_polyfills_assign({
            duration: computePerformanceResourceDuration(timing),
            render_blocking_status: renderBlockingStatus,
        }, computeSize(timing), computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            span_id: createTraceIdentifier().toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return utils_numberUtils_isNumber(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, startClocks.relative, duration)
        ? timeUtils_toServerDuration(duration)
        : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.js

function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.js


// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * timeUtils_ONE_MINUTE;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = polyfills_find(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.PAINT &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < FCP_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstContentfulPaint.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstInput.js




/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = polyfills_find(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = timeUtils_elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
                firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstInput.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.js



function trackNavigationTimings(configuration, callback) {
    var processEntry = function (entry) {
        if (!isIncompleteNavigation(entry)) {
            callback(processNavigationEntry(entry));
        }
    };
    var stop = utils_functionUtils_noop;
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        ;
        (stop = createPerformanceObservable(configuration, {
            type: RumPerformanceEntryType.NAVIGATION,
            buffered: true,
        }).subscribe(function (entries) { return polyfills_forEach(entries, processEntry); }).unsubscribe);
    }
    else {
        retrieveNavigationTiming(configuration, processEntry);
    }
    return { stop: stop };
}
function processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: entry.responseStart >= 0 && entry.responseStart <= timeUtils_relativeNow() ? entry.responseStart : undefined,
    };
}
function isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function retrieveNavigationTiming(configuration, callback) {
    runOnReadyState(configuration, 'complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        tools_timer_setTimeout(function () { return callback(computeRelativePerformanceTiming()); });
    });
}
//# sourceMappingURL=trackNavigationTimings.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.js



// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * timeUtils_ONE_MINUTE;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = addEventListener_addEventListeners(configuration, eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var biggestLcpSize = 0;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = polyfills_findLast(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < LCP_MAXIMUM_DELAY &&
                // Ensure to get the LCP entry with the biggest size, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
                entry.size > biggestLcpSize;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if (lcpEntry.element) {
                lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
            });
            biggestLcpSize = lcpEntry.size;
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
//# sourceMappingURL=trackLargestContentfulPaint.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.js

function trackFirstHidden(configuration, eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') {
        timeStamp = 0;
    }
    else {
        timeStamp = Infinity;
        (stopListeners = addEventListener_addEventListeners(configuration, eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, { capture: true }).stop);
    }
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop: function () {
            stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
        },
    };
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.js





function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = trackNavigationTimings(configuration, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = trackFirstHidden(configuration);
    var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.js




/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, viewStart, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: utils_functionUtils_noop,
        };
    }
    var maxClsValue = 0;
    // WeakRef is not supported in IE11 and Safari mobile, but so is the layout shift API, so this code won't be executed in these browsers
    var maxClsTarget;
    var maxClsStartTime;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
                var _a = window.update(entry), cumulatedValue = _a.cumulatedValue, isMaxValue = _a.isMaxValue;
                if (isMaxValue) {
                    var target = getTargetFromSource(entry.sources);
                    maxClsTarget = target ? new WeakRef(target) : undefined;
                    maxClsStartTime = timeUtils_elapsed(viewStart, entry.startTime);
                }
                if (cumulatedValue > maxClsValue) {
                    maxClsValue = cumulatedValue;
                    var target = maxClsTarget === null || maxClsTarget === void 0 ? void 0 : maxClsTarget.deref();
                    callback({
                        value: utils_numberUtils_round(maxClsValue, 4),
                        targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
                        time: maxClsStartTime,
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function getTargetFromSource(sources) {
    var _a;
    if (!sources) {
        return;
    }
    return (_a = polyfills_find(sources, function (source) { return !!source.node && isElementNode(source.node); })) === null || _a === void 0 ? void 0 : _a.node;
}
var MAX_WINDOW_DURATION = 5 * timeUtils_ONE_SECOND;
var MAX_UPDATE_GAP = timeUtils_ONE_SECOND;
function slidingSessionWindow() {
    var cumulatedValue = 0;
    var startTime;
    var endTime;
    var maxValue = 0;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= MAX_UPDATE_GAP ||
                entry.startTime - startTime >= MAX_WINDOW_DURATION;
            var isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            }
            else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) {
                    maxValue = entry.value;
                }
            }
            return {
                cumulatedValue: cumulatedValue,
                isMaxValue: isMaxValue,
            };
        },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.js
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */

var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver(monitor_monitor(function (entries) {
        entries.getEntries().forEach(function (e) {
            var entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
    return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};
//# sourceMappingURL=interactionCountPolyfill.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.js





// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = (1 * timeUtils_ONE_MINUTE);
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!isInteractionToNextPaintSupported()) {
        return {
            getInteractionToNextPaint: function () { return undefined; },
            setViewEnd: utils_functionUtils_noop,
            stop: utils_functionUtils_noop,
        };
    }
    var _a = trackViewInteractionCount(viewLoadingType), getViewInteractionCount = _a.getViewInteractionCount, stopViewInteractionCount = _a.stopViewInteractionCount;
    var viewEnd = Infinity;
    var longestInteractions = trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var interactionToNextPaintStartTime;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if ((entry.entryType === RumPerformanceEntryType.EVENT ||
                entry.entryType === RumPerformanceEntryType.FIRST_INPUT) &&
                entry.interactionId &&
                // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
                entry.startTime >= viewStart &&
                entry.startTime <= viewEnd) {
                longestInteractions.process(entry);
            }
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
            interactionToNextPaint = newInteraction.duration;
            interactionToNextPaintStartTime = timeUtils_elapsed(viewStart, newInteraction.startTime);
            if (newInteraction.target && isElementNode(newInteraction.target)) {
                interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
            }
            else {
                interactionToNextPaintTargetSelector = undefined;
            }
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function () {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
                    targetSelector: interactionToNextPaintTargetSelector,
                    time: interactionToNextPaintStartTime,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        setViewEnd: function (viewEndTime) {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: stop,
    };
}
function trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function (a, b) { return b.duration - a.duration; }).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process: function (entry) {
            var interactionIndex = longestInteractions.findIndex(function (interaction) { return entry.interactionId === interaction.interactionId; });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction: function () {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    initInteractionCountPolyfill();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
    var state = { stopped: false };
    function computeViewInteractionCount() {
        return getInteractionCount() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: function () {
            if (state.stopped) {
                return state.interactionCount;
            }
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: function () {
            state = { stopped: true, interactionCount: computeViewInteractionCount() };
        },
    };
}
function isInteractionToNextPaintSupported() {
    return (supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
//# sourceMappingURL=trackInteractionToNextPaint.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.js


function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(timeUtils_elapsed(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
//# sourceMappingURL=trackLoadingTime.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
function createViewportObservable(configuration) {
    return new observable_Observable(function (observable) {
        var updateDimension = functionUtils_throttle(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return addEventListener_addEventListener(configuration, window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true })
            .stop;
    });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.js



/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = timeUtils_ONE_SECOND;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) { scrollValues = createScrollValuesObservable(configuration); }
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function (_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = timeUtils_relativeNow();
            maxScrollHeightTime = timeUtils_elapsed(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight: maxScrollHeight,
                maxScrollHeightTime: maxScrollHeightTime,
            });
        }
    });
    return {
        stop: function () { return subscription.unsubscribe(); },
    };
}
function computeScrollValues() {
    var scrollTop = getScrollY();
    var height = getViewportDimension().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
function createScrollValuesObservable(configuration, throttleDuration) {
    if (throttleDuration === void 0) { throttleDuration = THROTTLE_SCROLL_DURATION; }
    return new observable_Observable(function (observable) {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = functionUtils_throttle(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver(monitor_monitor(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = addEventListener_addEventListener(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, throttledNotify_1.throttled, {
                passive: true,
            });
            return function () {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
}
//# sourceMappingURL=trackScrollMetrics.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.js




function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, viewStart.relative, function (cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint, setViewEnd = _b.setViewEnd;
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: function () {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * timeUtils_ONE_MINUTE;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * timeUtils_ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, timeUtils_clocksOrigin(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function () {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === pageExitObservable_PageExitReason.UNLOADING) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = timeUtils_timeStampNow(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        updateViewName: function (name) {
            currentView.updateViewName(name);
        },
        stop: function () {
            if (locationChangeSubscription) {
                locationChangeSubscription.unsubscribe();
            }
            currentView.end();
            activeViews.forEach(function (view) { return view.stop(); });
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = timeUtils_clocksNow(); }
    // Setup initial values
    var id = stringUtils_generateUUID();
    var stopObservable = new observable_Observable();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = objectUtils_shallowClone(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service || undefined;
        version = viewOptions.version || undefined;
    }
    var viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    };
    lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
    lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
    // Update the view every time the measures are changing
    var _a = functionUtils_throttle(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, setViewEnd = _b.setViewEnd, stopCommonViewMetricsTracking = _b.stop, stopINPTracking = _b.stopINPTracking, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate)
        : { stop: utils_functionUtils_noop, initialViewMetrics: {} }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = tools_timer_setInterval(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? timeUtils_timeStampNow() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: timeUtils_elapsed(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        });
    }
    return {
        get name() {
            return name;
        },
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function (options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : timeUtils_clocksNow();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, { endClocks: endClocks });
            tools_timer_clearInterval(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            tools_timer_setTimeout(function () {
                _this.stop();
            }, KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop: function () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = timeUtils_looksLikeRelativeTime(time) ? time : timeUtils_elapsed(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        updateViewName: function (updatedName) {
            if (!experimentalFeatures_isExperimentalFeatureEnabled(experimentalFeatures_ExperimentalFeature.UPDATE_VIEW_NAME)) {
                return;
            }
            name = updatedName;
            triggerViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display_display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.js



function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStates,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
            },
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_time: timeUtils_toServerDuration((_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.time),
            cumulative_layout_shift_target_selector: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.targetSelector,
            first_byte: timeUtils_toServerDuration((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.firstByte),
            dom_complete: timeUtils_toServerDuration((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domComplete),
            dom_content_loaded: timeUtils_toServerDuration((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domContentLoaded),
            dom_interactive: timeUtils_toServerDuration((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: timeUtils_toServerDuration(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: timeUtils_toServerDuration((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.delay),
            first_input_time: timeUtils_toServerDuration((_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.time),
            first_input_target_selector: (_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.targetSelector,
            interaction_to_next_paint: timeUtils_toServerDuration((_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.value),
            interaction_to_next_paint_time: timeUtils_toServerDuration((_m = view.commonViewMetrics.interactionToNextPaint) === null || _m === void 0 ? void 0 : _m.time),
            interaction_to_next_paint_target_selector: (_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: timeUtils_toServerDuration((_p = view.initialViewMetrics.largestContentfulPaint) === null || _p === void 0 ? void 0 : _p.value),
            largest_contentful_paint_target_selector: (_q = view.initialViewMetrics.largestContentfulPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
            load_event: timeUtils_toServerDuration((_r = view.initialViewMetrics.navigationTimings) === null || _r === void 0 ? void 0 : _r.loadEvent),
            loading_time: discardNegativeDuration(timeUtils_toServerDuration(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: timeUtils_toServerDuration(view.duration),
        },
        feature_flags: featureFlagContext && !objectUtils_isEmptyObject(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: timeUtils_toServerDuration(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!objectUtils_isEmptyObject(view.customTimings)) {
        viewEvent.view.custom_timings = objectUtils_mapValues(view.customTimings, timeUtils_toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
//# sourceMappingURL=viewCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js







var sessionManager_VISIBILITY_CHECK_DELAY = timeUtils_ONE_MINUTE;
var sessionManager_SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants_SESSION_TIME_OUT_DELAY;
var sessionManager_stopCallbacks = [];
function sessionManager_startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new observable_Observable();
    var expireObservable = new observable_Observable();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = sessionStore_startSessionStore(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    sessionManager_stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = valueHistory_createValueHistory({
        expireDelay: sessionManager_SESSION_CONTEXT_TIMEOUT_DELAY,
    });
    sessionManager_stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), timeUtils_relativeNow());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function () {
        expireObservable.notify();
        sessionContextHistory.closeActive(timeUtils_relativeNow());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), timeUtils_clocksOrigin().relative);
    trackingConsentState.observable.subscribe(function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
        else {
            sessionStore.expire();
        }
    });
    sessionManager_trackActivity(configuration, function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
    });
    sessionManager_trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    sessionManager_trackResume(configuration, function () { return sessionStore.restartSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
            isReplayForced: !!sessionStore.getSession().forcedReplay,
        };
    }
    return {
        findSession: function (startTime, options) { return sessionContextHistory.find(startTime, options); },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState,
    };
}
function sessionManager_stopSessionManager() {
    sessionManager_stopCallbacks.forEach(function (e) { return e(); });
    sessionManager_stopCallbacks = [];
}
function sessionManager_trackActivity(configuration, expandOrRenewSession) {
    var stop = addEventListener_addEventListeners(configuration, window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    sessionManager_stopCallbacks.push(stop);
}
function sessionManager_trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = addEventListener_addEventListener(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    sessionManager_stopCallbacks.push(stop);
    var visibilityCheckInterval = tools_timer_setInterval(expandSessionWhenVisible, sessionManager_VISIBILITY_CHECK_DELAY);
    sessionManager_stopCallbacks.push(function () {
        tools_timer_clearInterval(visibilityCheckInterval);
    });
}
function sessionManager_trackResume(configuration, cb) {
    var stop = addEventListener_addEventListener(configuration, window, "resume" /* DOM_EVENT.RESUME */, cb, { capture: true }).stop;
    sessionManager_stopCallbacks.push(stop);
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var rumSessionManager_RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
    var sessionManager = sessionManager_startSessionManager(configuration, rumSessionManager_RUM_SESSION_KEY, function (rawTrackingType) { return rumSessionManager_computeSessionState(configuration, rawTrackingType); }, trackingConsentState);
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    sessionManager.sessionStateUpdateObservable.subscribe(function (_a) {
        var previousState = _a.previousState, newState = _a.newState;
        if (!previousState.forcedReplay && newState.forcedReplay) {
            var sessionEntity = sessionManager.findSession();
            if (sessionEntity) {
                sessionEntity.isReplayForced = true;
            }
        }
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                    ? 1 /* SessionReplayState.SAMPLED */
                    : session.isReplayForced
                        ? 2 /* SessionReplayState.FORCED */
                        : 0 /* SessionReplayState.OFF */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
        setForcedReplay: function () { return sessionManager.updateSessionState({ forcedReplay: '1' }); },
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplay: eventBridge_bridgeSupports("records" /* BridgeCapability.RECORDS */) ? 1 /* SessionReplayState.SAMPLED */ : 0 /* SessionReplayState.OFF */,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: utils_functionUtils_noop,
        expireObservable: new observable_Observable(),
        setForcedReplay: utils_functionUtils_noop,
    };
}
function rumSessionManager_computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!numberUtils_performDraw(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!numberUtils_performDraw(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/batch.js





function batch_createBatch(_a) {
    var encoder = _a.encoder, request = _a.request, flushController = _a.flushController, messageBytesLimit = _a.messageBytesLimit;
    var upsertBuffer = {};
    var flushSubscription = flushController.flushObservable.subscribe(function (event) { return flush(event); });
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        }
        else {
            encoder.write(encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
                flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        var removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        var messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        var serializedMessage = jsonStringify_jsonStringify(message);
        var estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= messageBytesLimit) {
            display_display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(messageBytesLimit, "KB. ").concat(display_MORE_DETAILS, " ").concat(display_DOCS_TROUBLESHOOTING, "/#technical-limitations"));
            return;
        }
        if (hasMessageFor(key)) {
            remove(key);
        }
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        var upsertMessages = polyfills_objectValues(upsertBuffer).join('\n');
        upsertBuffer = {};
        var isPageExit = pageExitObservable_isPageExitReason(event.reason);
        var send = isPageExit ? request.sendOnExit : request.send;
        if (isPageExit &&
            // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
            // if the encoder is async we need to send two requests in some cases (one for encoded data
            // and the other for non-encoded data). But if it's not async, we don't have to worry about
            // it and always send a single request.
            encoder.isAsync) {
            var encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) {
                send(batch_formatPayloadFromEncoder(encoderResult));
            }
            // Send messages that are not yet encoded at this point
            var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
            if (pendingMessages) {
                send({
                    data: pendingMessages,
                    bytesCount: byteUtils_computeBytesCount(pendingMessages),
                });
            }
        }
        else {
            if (upsertMessages) {
                encoder.write(encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            }
            encoder.finish(function (encoderResult) {
                send(batch_formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController: flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe,
    };
}
function batch_formatPayloadFromEncoder(encoderResult) {
    var data;
    if (typeof encoderResult.output === 'string') {
        data = encoderResult.output;
    }
    else {
        data = new Blob([encoderResult.output], {
            // This will set the 'Content-Type: text/plain' header. Reasoning:
            // * The intake rejects the request if there is no content type.
            // * The browser will issue CORS preflight requests if we set it to 'application/json', which
            // could induce higher intake load (and maybe has other impacts).
            // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
            // new lines.
            type: 'text/plain',
        });
    }
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
    };
}
//# sourceMappingURL=batch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var sendWithRetryStrategy_MAX_ONGOING_BYTES_COUNT = 80 * byteUtils_ONE_KIBI_BYTE;
var sendWithRetryStrategy_MAX_ONGOING_REQUESTS = 32;
var sendWithRetryStrategy_MAX_QUEUE_BYTES_COUNT = 3 * byteUtils_ONE_MEBI_BYTE;
var sendWithRetryStrategy_MAX_BACKOFF_TIME = timeUtils_ONE_MINUTE;
var sendWithRetryStrategy_INITIAL_BACKOFF_TIME = timeUtils_ONE_SECOND;
function sendWithRetryStrategy_sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        sendWithRetryStrategy_send(payload, state, sendStrategy, {
            onSuccess: function () { return sendWithRetryStrategy_retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                sendWithRetryStrategy_scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function sendWithRetryStrategy_scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    tools_timer_setTimeout(function () {
        var payload = state.queuedPayloads.first();
        sendWithRetryStrategy_send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = sendWithRetryStrategy_INITIAL_BACKOFF_TIME;
                sendWithRetryStrategy_retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(sendWithRetryStrategy_MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                sendWithRetryStrategy_scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function sendWithRetryStrategy_send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!sendWithRetryStrategy_shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function sendWithRetryStrategy_retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(sendWithRetryStrategy_MAX_QUEUE_BYTES_COUNT / byteUtils_ONE_MEBI_BYTE, "MiB"),
            source: error_types_ErrorSource.AGENT,
            startClocks: timeUtils_clocksNow(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = sendWithRetryStrategy_newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy_sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
    }
}
function sendWithRetryStrategy_shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            responseUtils_isServerError(response.status)));
}
function sendWithRetryStrategy_newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: sendWithRetryStrategy_INITIAL_BACKOFF_TIME,
        bandwidthMonitor: sendWithRetryStrategy_newBandwidthMonitor(),
        queuedPayloads: sendWithRetryStrategy_newPayloadQueue(),
        queueFullReported: false,
    };
}
function sendWithRetryStrategy_newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= sendWithRetryStrategy_MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function sendWithRetryStrategy_newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= sendWithRetryStrategy_MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < sendWithRetryStrategy_MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function httpRequest_createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = sendWithRetryStrategy_newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return httpRequest_fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy_sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            httpRequest_sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
function httpRequest_sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            httpRequest_reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    httpRequest_sendXHR(configuration, xhrUrl, payload.data);
}
var httpRequest_hasReportedBeaconError = false;
function httpRequest_reportBeaconError(e) {
    if (!httpRequest_hasReportedBeaconError) {
        httpRequest_hasReportedBeaconError = true;
        telemetry_addTelemetryError(e);
    }
}
function httpRequest_fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = httpRequest_isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then(monitor_monitor(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), monitor_monitor(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            httpRequest_sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        httpRequest_sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
function httpRequest_isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function httpRequest_sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    if (data instanceof Blob) {
        // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
        // automatically, so the intake request ends up being rejected with an HTTP status 415
        // Defining the header manually fixes this issue.
        request.setRequestHeader('Content-Type', data.type);
    }
    addEventListener_addEventListener(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function flushController_createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new observable_Observable(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = tools_timer_setTimeout(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        tools_timer_clearTimeout(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */
        notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */
        notifyAfterAddMessage: function (messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) { messageBytesCountDiff = 0; }
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js



function startBatchWithReplica_startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable, batchFactoryImp) {
    if (batchFactoryImp === void 0) { batchFactoryImp = batch_createBatch; }
    var primaryBatch = createBatchFromConfig(configuration, primary);
    var replicaBatch = replica && createBatchFromConfig(configuration, replica);
    function createBatchFromConfig(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return batchFactoryImp({
            encoder: encoder,
            request: httpRequest_createHttpRequest(configuration, endpoint, configuration.batchBytesLimit, reportError),
            flushController: flushController_createFlushController({
                messagesLimit: configuration.batchMessagesLimit,
                bytesLimit: configuration.batchBytesLimit,
                durationLimit: configuration.flushTimeout,
                pageExitObservable: pageExitObservable,
                sessionExpireObservable: sessionExpireObservable,
            }),
            messageBytesLimit: configuration.messageBytesLimit,
        });
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            if (replicaBatch) {
                replicaBatch.stop();
            }
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
    var replica = configuration.replica;
    var batch = startBatchWithReplica_startBatchWithReplica(configuration, {
        endpoint: configuration.rumEndpointBuilder,
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */),
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function (message) { return mergeInto_combine(message, { application: { id: replica.applicationId } }); },
        encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */),
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, telemetry_isTelemetryReplicationAllowed(configuration)); });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = eventBridge_getEventBridge();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = sessionConstants_SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = valueHistory_createValueHistory({ expireDelay: URL_CONTEXT_TIME_OUT_DELAY });
    var previousViewUrl;
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = timeUtils_relativeNow();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(configuration, location) {
    var currentLocation = objectUtils_shallowClone(location);
    return new observable_Observable(function (observable) {
        var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = trackHash(configuration, onLocationChange).stop;
        function onLocationChange() {
            if (currentLocation.href === location.href) {
                return;
            }
            var newLocation = objectUtils_shallowClone(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation,
            });
            currentLocation = newLocation;
        }
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = instrumentMethod_instrumentMethod(history, 'pushState', function (_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var stopInstrumentingReplaceState = instrumentMethod_instrumentMethod(history, 'replaceState', function (_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var removeListener = addEventListener_addEventListener(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return addEventListener_addEventListener(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants_SESSION_TIME_OUT_DELAY;
var featureFlagContext_BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, customerDataTracker) {
    var featureFlagContexts = valueHistory_createValueHistory({
        expireDelay: FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY,
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        customerDataTracker.resetCustomerData();
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                customerDataTracker.updateCustomerData(currentContext);
            }
        },
        stop: function () { return customerDataTracker.stop(); },
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * timeUtils_ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && numberUtils_performDraw(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */).getBytesCount());
        updateMeasure(currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */).getBytesCount());
        updateMeasure(currentBatchMeasures.featureFlagBytes, utils_polyfills_includes(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type)
            ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */).getBytesCount()
            : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    tools_timer_setInterval(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    telemetry_addTelemetryDebug('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants_SESSION_TIME_OUT_DELAY;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateEntryHistory = valueHistory_createValueHistory({
        expireDelay: PAGE_STATE_CONTEXT_TIME_OUT_DELAY,
        maxEntries: MAX_PAGE_STATE_ENTRIES,
    });
    var currentPageState;
    addPageState(getPageState(), timeUtils_relativeNow());
    var stopEventListeners = addEventListener_addEventListeners(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], function (event) {
        addPageState(computePageState(event), event.timeStamp);
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = timeUtils_relativeNow(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    var pageStateHistory = {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = timeUtils_elapsed(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: timeUtils_toServerDuration(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        wasInPageStateAt: function (state, startTime) {
            return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
        },
        wasInPageStateDuringPeriod: function (state, startTime, duration) {
            return pageStateEntryHistory.findAll(startTime, duration).some(function (pageState) { return pageState.state === state; });
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateEntryHistory.stop();
        },
    };
    return pageStateHistory;
}
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js

function startDisplayContext(configuration) {
    var viewport = getViewportDimension();
    var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function () { return ({ viewport: viewport }); },
        stop: unsubscribeViewport,
    };
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/browser/cookieObservable.js

function createCookieObservable(configuration, cookieName) {
    var detectCookieChangeStrategy = window.cookieStore
        ? listenToCookieStoreChange(configuration)
        : watchCookieFallback;
    return new observable_Observable(function (observable) {
        return detectCookieChangeStrategy(cookieName, function (event) { return observable.notify(event); });
    });
}
function listenToCookieStoreChange(configuration) {
    return function (cookieName, callback) {
        var listener = addEventListener_addEventListener(configuration, window.cookieStore, "change" /* DOM_EVENT.CHANGE */, function (event) {
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            var changeEvent = polyfills_find(event.changed, function (event) { return event.name === cookieName; }) ||
                polyfills_find(event.deleted, function (event) { return event.name === cookieName; });
            if (changeEvent) {
                callback(changeEvent.value);
            }
        });
        return listener.stop;
    };
}
var WATCH_COOKIE_INTERVAL_DELAY = timeUtils_ONE_SECOND;
function watchCookieFallback(cookieName, callback) {
    var previousCookieValue = stringUtils_findCommaSeparatedValue(document.cookie, cookieName);
    var watchCookieIntervalId = tools_timer_setInterval(function () {
        var cookieValue = stringUtils_findCommaSeparatedValue(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) {
            callback(cookieValue);
        }
    }, WATCH_COOKIE_INTERVAL_DELAY);
    return function () {
        tools_timer_clearInterval(watchCookieIntervalId);
    };
}
//# sourceMappingURL=cookieObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciVisibilityContext.js


var CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
function startCiVisibilityContext(configuration, cookieObservable) {
    var _a;
    if (cookieObservable === void 0) { cookieObservable = createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME); }
    var testExecutionId = cookie_getInitCookie(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
    var cookieObservableSubscription = cookieObservable.subscribe(function (value) {
        testExecutionId = value;
    });
    return {
        get: function () {
            if (typeof testExecutionId === 'string') {
                return {
                    test_execution_id: testExecutionId,
                };
            }
        },
        stop: function () { return cookieObservableSubscription.unsubscribe(); },
    };
}
//# sourceMappingURL=ciVisibilityContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/boot/startRum.js
























function startRum(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder, 
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var cleanupTasks = [];
    var lifeCycle = new lifeCycle_LifeCycle();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return sendToExtension_sendToExtension('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        telemetry_addTelemetryDebug('Error reported to customer', { 'error.message': error.message });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */));
    var pageExitObservable = pageExitObservable_createPageExitObservable(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    cleanupTasks.push(function () { return pageExitSubscription.unsubscribe(); });
    var session = !eventBridge_canUseEventBridge()
        ? startRumSessionManager(configuration, lifeCycle, trackingConsentState)
        : startRumSessionManagerStub();
    if (!eventBridge_canUseEventBridge()) {
        var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(function () { return batch_1.stop(); });
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(configuration, location);
    var pageStateHistory = startPageStateHistory(configuration);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError), viewContexts = _a.viewContexts, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    telemetry_drainPreStartTelemetry();
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, updateViewName = _b.updateViewName, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var stopResourceCollection = startResourceCollection(lifeCycle, configuration, pageStateHistory).stop;
    cleanupTasks.push(stopResourceCollection);
    startLongTaskCollection(lifeCycle, configuration);
    var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    var stopPerformanceCollection = startPerformanceCollection(lifeCycle, configuration).stop;
    cleanupTasks.push(stopPerformanceCollection);
    var vitalCollection = startVitalCollection(lifeCycle, pageStateHistory);
    var internalContext = internalContext_startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        updateViewName: updateViewName,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startRumTelemetry(configuration) {
    var telemetry = telemetry_startTelemetry("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if (eventBridge_canUseEventBridge()) {
        var bridge_1 = eventBridge_getEventBridge();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = startDisplayContext(configuration);
    var ciVisibilityContext = startCiVisibilityContext(configuration);
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            ciVisibilityContext.stop();
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case intakeSites_INTAKE_SITE_US1:
        case intakeSites_INTAKE_SITE_EU1:
            return 'app';
        case intakeSites_INTAKE_SITE_STAGING:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/node_modules/@datadog/browser-rum-core/esm/index.js














//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js


var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return urlPolyfill_buildUrl(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function censoredImageForSize(width, height) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js



function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            var image = element;
            if (image.naturalWidth > 0) {
                return censoredImageForSize(image.naturalWidth, image.naturalHeight);
            }
            var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (width > 0 || height > 0) {
                return censoredImageForSize(width, height);
            }
            // if we can't get the image size, fallback to the censored image
            return CENSORED_IMG_MARK;
        }
        // mask source URLs
        if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
            return CENSORED_IMG_MARK;
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && polyfills_startsWith(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
        // mask iframe srcdoc
        if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (isLongDataUrl(attributeValue)) {
        return sanitizeDataUrl(attributeValue);
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js




function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, browserDetection_isSafari() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js






function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    forEachChildNodes(node, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = serializeAttributes(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (hasChildNodes(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = utils_polyfills_assign({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: utils_polyfills_assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: timeUtils_timeStampNow(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMove.js






var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function trackMove(configuration, moveCb) {
    var _a = functionUtils_throttle(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            moveCb(assembleIncrementalSnapshot(isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove, { positions: [position] }));
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListener_addEventListeners(configuration, document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
    return {
        stop: function () {
            removeListener();
            cancelThrottle();
        },
    };
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            telemetry_addTelemetryDebug('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=trackMove.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMouseInteraction.js
var trackMouseInteraction_a;







var eventTypeToMouseInteraction = (trackMouseInteraction_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    trackMouseInteraction_a["pointerup" /* DOM_EVENT.POINTER_UP */] = MouseInteractionType.MouseUp,
    trackMouseInteraction_a["mousedown" /* DOM_EVENT.MOUSE_DOWN */] = MouseInteractionType.MouseDown,
    trackMouseInteraction_a["click" /* DOM_EVENT.CLICK */] = MouseInteractionType.Click,
    trackMouseInteraction_a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */] = MouseInteractionType.ContextMenu,
    trackMouseInteraction_a["dblclick" /* DOM_EVENT.DBL_CLICK */] = MouseInteractionType.DblClick,
    trackMouseInteraction_a["focus" /* DOM_EVENT.FOCUS */] = MouseInteractionType.Focus,
    trackMouseInteraction_a["blur" /* DOM_EVENT.BLUR */] = MouseInteractionType.Blur,
    trackMouseInteraction_a["touchstart" /* DOM_EVENT.TOUCH_START */] = MouseInteractionType.TouchStart,
    trackMouseInteraction_a["touchend" /* DOM_EVENT.TOUCH_END */] = MouseInteractionType.TouchEnd,
    trackMouseInteraction_a);
function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = utils_polyfills_assign({ id: recordIds.getIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        mouseInteractionCb(record);
    };
    return addEventListener_addEventListeners(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    });
}
//# sourceMappingURL=trackMouseInteraction.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackScroll.js






var SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scrollCb, elementsScrollPositions, target) {
    if (target === void 0) { target = document; }
    var _a = functionUtils_throttle(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb(assembleIncrementalSnapshot(IncrementalSource.Scroll, {
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        }));
    }, SCROLL_OBSERVER_THRESHOLD), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListener_addEventListener(configuration, target, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, {
        capture: true,
        passive: true,
    }).stop;
    return {
        stop: function () {
            removeListener();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=trackScroll.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackViewportResize.js





var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function trackViewportResize(configuration, viewportResizeCb) {
    var viewportResizeSubscription = initViewportObservable(configuration).subscribe(function (data) {
        viewportResizeCb(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, data));
    });
    return {
        stop: function () {
            viewportResizeSubscription.unsubscribe();
        },
    };
}
function trackVisualViewportResize(configuration, visualViewportResizeCb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return { stop: utils_functionUtils_noop };
    }
    var _a = functionUtils_throttle(function () {
        visualViewportResizeCb({
            data: getVisualViewport(visualViewport),
            type: RecordType.VisualViewport,
            timestamp: timeUtils_timeStampNow(),
        });
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListener_addEventListeners(configuration, visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return {
        stop: function () {
            removeListener();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=trackViewportResize.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMediaInteraction.js






function trackMediaInteraction(configuration, mediaInteractionCb) {
    return addEventListener_addEventListeners(configuration, document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, {
            id: getSerializedNodeId(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? MediaInteractionType.Play : MediaInteractionType.Pause,
        }));
    }, {
        capture: true,
        passive: true,
    });
}
//# sourceMappingURL=trackMediaInteraction.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackStyleSheet.js




function trackStyleSheet(styleSheetCb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        instrumentMethod_instrumentMethod(CSSStyleSheet.prototype, 'insertRule', function (_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet, function (id) {
                return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                    id: id,
                    adds: [{ rule: rule, index: index }],
                }));
            });
        }),
        instrumentMethod_instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', function (_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet, function (id) {
                return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                    id: id,
                    removes: [{ index: index }],
                }));
            });
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push(instrumentMethod_instrumentMethod(cls.prototype, 'insertRule', function (_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
                var path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index || 0);
                    styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                        id: id,
                        adds: [{ rule: rule, index: path }],
                    }));
                }
            });
        }), instrumentMethod_instrumentMethod(cls.prototype, 'deleteRule', function (_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
                var path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index);
                    styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
                        id: id,
                        removes: [{ index: path }],
                    }));
                }
            });
        }));
    }
    return {
        stop: function () {
            instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        },
    };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=trackStyleSheet.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackFocus.js


function trackFocus(configuration, focusCb) {
    return addEventListener_addEventListeners(configuration, window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], function () {
        focusCb({
            data: { has_focus: document.hasFocus() },
            type: RecordType.Focus,
            timestamp: timeUtils_timeStampNow(),
        });
    });
}
//# sourceMappingURL=trackFocus.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackFrustration.js

function trackFrustration(lifeCycle, frustrationCb, recordIds) {
    var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            data.domainContext.events &&
            data.domainContext.events.length) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    });
    return {
        stop: function () {
            frustrationSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackFrustration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackViewEnd.js


function trackViewEnd(lifeCycle, viewEndCb) {
    var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function () {
        viewEndCb({
            timestamp: timeUtils_timeStampNow(),
            type: RecordType.ViewEnd,
        });
    });
    return {
        stop: function () {
            viewEndSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackViewEnd.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackInput.js






function trackInput(configuration, inputCb, target) {
    if (target === void 0) { target = document; }
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = addEventListener_addEventListeners(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? ["change" /* DOM_EVENT.CHANGE */] : ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */], function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            instrumentMethod_instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange),
            instrumentMethod_instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange),
            instrumentMethod_instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange),
            instrumentMethod_instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange),
            instrumentMethod_instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = utils_functionUtils_noop;
    }
    return {
        stop: function () {
            stopPropertySetterInstrumentation();
            stopEventListeners();
        },
    };
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            polyfills_forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(cssEscape(name), "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            inputCb(assembleIncrementalSnapshot(IncrementalSource.Input, utils_polyfills_assign({
                id: getSerializedNodeId(target),
            }, inputState)));
        }
    }
}
//# sourceMappingURL=trackInput.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
/**
 * Minimum duration to wait before processing mutations. This is used to batch mutations together
 * and be able to deduplicate them to save processing time and bandwidth.
 * 16ms is the duration of a frame at 60fps that ensure fluid UI.
 */
var MUTATION_PROCESS_MIN_DELAY = 16;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = utils_functionUtils_noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    var _a = functionUtils_throttle(flush, MUTATION_PROCESS_MIN_DELAY, {
        leading: false,
    }), throttledFlush = _a.throttled, cancelThrottle = _a.cancel;
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(throttledFlush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
            cancelThrottle();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback(monitor_monitor(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(monitor_monitor(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/trackMutation.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function trackMutation(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: utils_functionUtils_noop, flush: utils_functionUtils_noop };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver(monitor_monitor(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    var nodePrivacyLevelCache = new Map();
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return mutation.target.isConnected &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !==
                NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController, nodePrivacyLevelCache), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback(assembleIncrementalSnapshot(IncrementalSource.Mutation, { adds: adds, removes: removes, texts: texts, attributes: attributes }));
}
function processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes && handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    forEachChildNodes(removedNode, function (childNode) { return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback); });
}
//# sourceMappingURL=trackMutation.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/trackers/index.js











//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

var initShadowRootsController = function (configuration, callback, elementsScrollPositions) {
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            if (controllerByShadowRoot.has(shadowRoot)) {
                return;
            }
            var mutationTracker = trackMutation(callback, configuration, shadowRootsController, shadowRoot);
            // The change event does not bubble up across the shadow root, we have to listen on the shadow root
            var inputTracker = trackInput(configuration, callback, shadowRoot);
            // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
            var scrollTracker = trackScroll(configuration, callback, elementsScrollPositions, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: function () { return mutationTracker.flush(); },
                stop: function () {
                    mutationTracker.stop();
                    inputTracker.stop();
                    scrollTracker.stop();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/startFullSnapshots.js





function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = timeUtils_timeStampNow(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        var records = [
            {
                data: {
                    height: height,
                    href: window.location.href,
                    width: width,
                },
                type: RecordType.Meta,
                timestamp: timestamp,
            },
            {
                data: {
                    has_focus: document.hasFocus(),
                },
                type: RecordType.Focus,
                timestamp: timestamp,
            },
            {
                data: {
                    node: serializeDocument(document, configuration, serializationContext),
                    initialOffset: {
                        left: getScrollX(),
                        top: getScrollY(),
                    },
                },
                type: RecordType.FullSnapshot,
                timestamp: timestamp,
            },
        ];
        if (window.visualViewport) {
            records.push({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
        return records;
    };
    fullSnapshotCallback(takeFullSnapshot());
    var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        flushMutations();
        fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
            shadowRootsController: shadowRootsController,
            status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
        }));
    }).unsubscribe;
    return {
        stop: unsubscribe,
    };
}
//# sourceMappingURL=startFullSnapshots.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/recordIds.js
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/record.js







function record(options) {
    var emit = options.emit, configuration = options.configuration, lifeCycle = options.lifeCycle;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var emitAndComputeStats = function (record) {
        emit(record);
        sendToExtension_sendToExtension('record', { record: record });
        var view = options.viewContexts.findView();
        addRecord(view.id);
    };
    var elementsScrollPositions = createElementsScrollPositions();
    var shadowRootsController = initShadowRootsController(configuration, emitAndComputeStats, elementsScrollPositions);
    var stopFullSnapshots = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function (records) { return records.forEach(function (record) { return emitAndComputeStats(record); }); }).stop;
    function flushMutations() {
        shadowRootsController.flush();
        mutationTracker.flush();
    }
    var recordIds = initRecordIds();
    var mutationTracker = trackMutation(emitAndComputeStats, configuration, shadowRootsController, document);
    var trackers = [
        mutationTracker,
        trackMove(configuration, emitAndComputeStats),
        trackMouseInteraction(configuration, emitAndComputeStats, recordIds),
        trackScroll(configuration, emitAndComputeStats, elementsScrollPositions, document),
        trackViewportResize(configuration, emitAndComputeStats),
        trackInput(configuration, emitAndComputeStats),
        trackMediaInteraction(configuration, emitAndComputeStats),
        trackStyleSheet(emitAndComputeStats),
        trackFocus(configuration, emitAndComputeStats),
        trackVisualViewportResize(configuration, emitAndComputeStats),
        trackFrustration(lifeCycle, emitAndComputeStats, recordIds),
        trackViewEnd(lifeCycle, function (viewEndRecord) {
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        }),
    ];
    return {
        stop: function () {
            shadowRootsController.stop();
            trackers.forEach(function (tracker) { return tracker.stop(); });
            stopFullSnapshots();
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = utils_polyfills_assign({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



function createSegment(_a) {
    var context = _a.context, creationReason = _a.creationReason, encoder = _a.encoder;
    var encodedBytesCount = 0;
    var viewId = context.view.id;
    var metadata = utils_polyfills_assign({
        start: Infinity,
        end: -Infinity,
        creation_reason: creationReason,
        records_count: 0,
        has_full_snapshot: false,
        index_in_view: getSegmentsCount(viewId),
        source: 'browser',
    }, context);
    addSegment(viewId);
    function addRecord(record, callback) {
        metadata.start = Math.min(metadata.start, record.timestamp);
        metadata.end = Math.max(metadata.end, record.timestamp);
        metadata.records_count += 1;
        metadata.has_full_snapshot || (metadata.has_full_snapshot = record.type === RecordType.FullSnapshot);
        var prefix = encoder.isEmpty ? '{"records":[' : ',';
        encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
            encodedBytesCount += additionalEncodedBytesCount;
            callback(encodedBytesCount);
        });
    }
    function flush(callback) {
        if (encoder.isEmpty) {
            throw new Error('Empty segment flushed');
        }
        encoder.write("],".concat(JSON.stringify(metadata).slice(1), "\n"));
        encoder.finish(function (encoderResult) {
            addWroteData(metadata.view.id, encoderResult.rawBytesCount);
            callback(metadata, encoderResult);
        });
    }
    return { addRecord: addRecord, flush: flush };
}
//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * timeUtils_ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts); }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(function (metadata, encoderResult) {
                var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
                if (pageExitObservable_isPageExitReason(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            tools_timer_clearTimeout(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: function (record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                var context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: createSegment({ encoder: encoder, context: context, creationReason: state.nextSegmentCreationReason }),
                    expirationTimeoutId: tools_timer_setTimeout(function () {
                        flushSegment('segment_duration_limit');
                    }, SEGMENT_DURATION_LIMIT),
                };
            }
            state.segment.addRecord(record, function (encodedBytesCount) {
                if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/startRecordBridge.js

function startRecordBridge(viewContexts) {
    var bridge = eventBridge_getEventBridge();
    return {
        addRecord: function (record) {
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            var view = viewContexts.findView();
            bridge.send('record', record, view.id);
        },
    };
}
//# sourceMappingURL=startRecordBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var cleanupTasks = [];
    var reportError = function (error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        telemetry_addTelemetryDebug('Error reported to customer', { 'error.message': error.message });
    };
    var replayRequest = httpRequest ||
        httpRequest_createHttpRequest(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var addRecord;
    if (!eventBridge_canUseEventBridge()) {
        var segmentCollection = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder);
        addRecord = segmentCollection.addRecord;
        cleanupTasks.push(segmentCollection.stop);
    }
    else {
        ;
        (addRecord = startRecordBridge(viewContexts).addRecord);
    }
    var stopRecording = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
    }).stop;
    cleanupTasks.push(stopRecording);
    return {
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return getSessionReplayUrl(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (session.sessionReplay === 0 /* SessionReplayState.OFF */) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.js

function createDeflateEncoder(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = addEventListener_addEventListener(configuration, worker, 'message', function (_a) {
        var workerResponse = _a.data;
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
            return;
        }
        rawBytesCount += workerResponse.additionalBytesCount;
        compressedData.push(workerResponse.result);
        compressedDataTrailer = workerResponse.trailer;
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
            if (nextPendingAction.writeCallback) {
                nextPendingAction.writeCallback(workerResponse.result.byteLength);
            }
            else if (nextPendingAction.finishCallback) {
                nextPendingAction.finishCallback();
            }
        }
        else {
            removeMessageListener();
            telemetry_addTelemetryDebug('Worker responses received out of order.');
        }
    }).stop;
    function consumeResult() {
        var output = compressedData.length === 0 ? new Uint8Array(0) : byteUtils_concatBuffers(compressedData.concat(compressedDataTrailer));
        var result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate',
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (nextWriteActionId > 0) {
            worker.postMessage({
                action: 'reset',
                streamId: streamId,
            });
            nextWriteActionId = 0;
        }
    }
    return {
        isAsync: true,
        get isEmpty() {
            return nextWriteActionId === 0;
        },
        write: function (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data,
            });
            nextWriteActionId += 1;
        },
        finish: function (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) {
                callback(consumeResult());
            }
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach(function (pendingWriteAction) {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () { return callback(consumeResult()); };
            }
        },
        finishSync: function () {
            sendResetIfNeeded();
            var pendingData = pendingWriteActions
                .map(function (pendingWriteAction) {
                // Make sure we do not call any write or finish callback
                delete pendingWriteAction.writeCallback;
                delete pendingWriteAction.finishCallback;
                return pendingWriteAction.data;
            })
                .join('');
            return utils_polyfills_assign(consumeResult(), {
                pendingData: pendingData,
            });
        },
        estimateEncodedBytesCount: function (data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop: function () {
            removeMessageListener();
        },
    };
}
//# sourceMappingURL=deflateEncoder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.js

var INITIALIZATION_TIME_OUT_DELAY = 10 * timeUtils_ONE_SECOND;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.23.3\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
function getDeflateWorkerStatus() {
    return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = addEventListener_addEventListener(configuration, worker, 'error', function (error) {
            onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = addEventListener_addEventListener(configuration, worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        }).stop;
        worker.postMessage({ action: 'init' });
        tools_timer_setTimeout(function () { return onTimeout(source); }, INITIALIZATION_TIME_OUT_DELAY);
        var stop_1 = function () {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker: worker, stop: stop_1, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display_display.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version: version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        display_display.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            var baseMessage = void 0;
            if (configuration.workerUrl) {
                baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            }
            else {
                baseMessage = 'Please make sure CSP is correctly configured.';
            }
            display_display.error("".concat(baseMessage, " See documentation at ").concat(display_DOCS_ORIGIN, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        }
        else {
            telemetry_addTelemetryError(error);
        }
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        telemetry_addTelemetryError(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
function isMessageCspRelated(message) {
    return (utils_polyfills_includes(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        utils_polyfills_includes(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/deflate/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/boot/recorderApi.js





function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
    if ((eventBridge_canUseEventBridge() && !eventBridge_bridgeSupports("records" /* BridgeCapability.RECORDS */)) || !isBrowserSupported()) {
        return {
            start: utils_functionUtils_noop,
            stop: utils_functionUtils_noop,
            getReplayStats: function () { return undefined; },
            onRumStart: utils_functionUtils_noop,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 1 /* RecorderStatus.IntentToStart */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    var getSessionReplayLinkStrategy = utils_functionUtils_noop;
    return {
        start: function (options) { return startStrategy(options); },
        stop: function () { return stopStrategy(); },
        getSessionReplayLink: function () { return getSessionReplayLinkStrategy(); },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
            if (configuration.startSessionReplayRecordingManually) {
                state = { status: 0 /* RecorderStatus.Stopped */ };
            }
            lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            // Stop the recorder on page unload to avoid sending records after the page is ended.
            lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
                if (pageExitEvent.reason === pageExitObservable_PageExitReason.UNLOADING) {
                    stopStrategy();
                }
            });
            lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            var cachedDeflateEncoder;
            function getOrCreateDeflateEncoder() {
                if (!cachedDeflateEncoder) {
                    if (!worker) {
                        worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
                            stopStrategy();
                        }, createDeflateWorkerImpl);
                    }
                    if (worker) {
                        cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
                    }
                }
                return cachedDeflateEncoder;
            }
            startStrategy = function (options) {
                var session = sessionManager.findTrackedSession();
                if (!session || (session.sessionReplay === 0 /* SessionReplayState.OFF */ && (!options || !options.force))) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                runOnReadyState(configuration, 'interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    var deflateEncoder = getOrCreateDeflateEncoder();
                    if (!deflateEncoder) {
                        state = {
                            status: 0 /* RecorderStatus.Stopped */,
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */,
                        stopRecording: stopRecording,
                    };
                });
                if (options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */) {
                    sessionManager.setForcedReplay();
                }
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            getSessionReplayLinkStrategy = function () {
                return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
        },
        getReplayStats: function (viewId) {
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
        },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts






var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, { startDeflateWorker: startDeflateWorker, createDeflateEncoder: createDeflateEncoder });
init_defineGlobal(getGlobalObject_getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/utils/report.ts
/**
 * report 각 함수내 catch 구문에서 아무 처리 하지않는 것은
 * datadogLog 모듈 이슈에 대한 트래킹을 하지 않겠다는 것을 의미합니다
 * @author Elie
 */ 






// 봇, 크롤러, headless 브라우저 탐지를 위한 정규식 (성능 최적화를 위해 함수 외부로 이동)
var BOT_PATTERN_AGENT_REGEX = new RegExp("(googlebot/|Googlebot-Mobile|Googlebot-Image|Mediapartners-Google|bingbot|slurp|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon|httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam_gnam_spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|ChatGPT-User|Claude-Web|GPTBot|TikTokBot|LinkedInBot|HeadlessChrome|PhantomJS|SlimerJS|HtmlUnit|Selenium|WebDriver|Chrome-Lighthouse|Puppeteer|Playwright|java/)", "i");
var getConditionalLogSampleRate = function() {
    if (BOT_PATTERN_AGENT_REGEX.test(navigator.userAgent)) {
        return 0;
    }
    return 100;
};
var getConditionalRumSampleRate = function() {
    if (BOT_PATTERN_AGENT_REGEX.test(navigator.userAgent)) {
        return 0;
    }
    var excludeUrlRegex = new RegExp("(/content/magazine.*|/content/qna.*)", "i");
    if (excludeUrlRegex.test(window.location.pathname)) {
        return 0;
    }
    if (window.location.search.indexOf("buzzvil") >= 0) {
        return 5;
    }
    return 100;
};
var getAllowedTracingUrls = function() {
    if (env/* IS_LOCAL */.Kc) {
        return undefined;
    }
    return env/* IS_PROD_ZONE */.UM ? [
        "https://bff.doctornow.co.kr",
        "https://api.doctornow.co.kr"
    ] : [
        "https://bff.dev.doctornow.co.kr",
        "https://api.dev.doctornow.co.kr"
    ];
};
var getVersion = function() {
    if (env/* IS_LOCAL */.Kc) {
        return "local";
    }
    return env/* IS_PROD_ZONE */.UM ? "dd-".concat("20251126-1429-f02ecf5fee") : "dd-dev-".concat("20251126-1429-f02ecf5fee");
};
var initDatadogMonitoring = function() {
    try {
        var conditionalLogSampleRate = getConditionalLogSampleRate();
        var conditionalRumSampleRate = getConditionalRumSampleRate();
        datadogLogs.init({
            clientToken: "pub6ae158c35a813b91603f22d326fc6e7e",
            service: "doctornow-user-web",
            // 고민포인트) getEnv()로 처리하는 것은 어떨까?
            env: env/* IS_PROD_ZONE */.UM ? "production" : "development",
            version: getVersion(),
            forwardErrorsToLogs: env/* IS_PROD_ZONE */.UM,
            sessionSampleRate: conditionalLogSampleRate,
            silentMultipleInit: true,
            beforeSend: function(event, context) {
                var ref;
                if (event.error) {
                    var error = event.error;
                    var _message;
                    var message = (_message = error.message) !== null && _message !== void 0 ? _message : "";
                    var regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
                    if (regex.test(message)) return false;
                }
                /*
          https://github.com/DataDog/browser-sdk/issues/362#issuecomment-1758572518
          - status_code가 0인 경우는 네트워크 문제 및 연결 끊김 등으로 인한 에러로 판단하여 무시
        */ if (event.error && ((ref = event.http) === null || ref === void 0 ? void 0 : ref.status_code) === 0) {
                    return false;
                }
                return !("isAborted" in context && context.isAborted);
            }
        });
        var allowedTracingUrls = getAllowedTracingUrls();
        datadogRum.init({
            applicationId: "4d6d9edd-bec7-40c1-8811-33d44009cd1b",
            clientToken: "pub97ed1e2ca8c7c834e9276da481afd54d",
            site: "datadoghq.com",
            service: "doctornow-user-web",
            env: env/* IS_PROD_ZONE */.UM ? "production" : "development",
            version: getVersion(),
            // 고민포인트) PR버전/ 빌드버전 등으로 자동 generate 되는 건 어떨까? (어떤 배포 영향인지 알수 있을듯)
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: conditionalRumSampleRate,
            // sessionReplaySampleRate: 100을 하더라도  startSessionReplayRecording를 호출해야만 녹화가 시작됨
            sessionReplaySampleRate: 0,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: "mask-user-input",
            allowedTracingUrls: allowedTracingUrls,
            beforeSend: function(event, context) {
                if (event.error) {
                    var error = event.error;
                    // filter out error that might be caused by link validation/ pre-fetch rendering from email clicks
                    // https://github.com/DataDog/browser-sdk/issues/2715
                    var regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
                    if (regex.test(error.message)) return false;
                }
                if (event.type === "resource" && event.resource.type === "fetch") {
                    var ref, ref1;
                    if (event.context && "response" in context && ((ref = context.response) === null || ref === void 0 ? void 0 : ref.headers)) {
                        event.context.responseHeaders = Object.fromEntries(context.response.headers);
                    }
                    if (event.context && "requestInit" in context && ((ref1 = context.requestInit) === null || ref1 === void 0 ? void 0 : ref1.body)) {
                        event.context.responseBody = context.requestInit.body;
                    }
                }
                return true;
            }
        });
    } catch (_error) {}
};
var setUserWithDatadogRum = function(user) {
    datadogRum.setUser({
        id: user.userId,
        email: user.email,
        name: user.name,
        age: user.birth
    });
};
var resetUserWithDatadogRum = function() {
    datadogRum.clearUser();
};
var getMessageContext = function(messageContext) {
    if ("message" in messageContext) {
        var message = messageContext.message, rest = (0,_object_without_properties/* default */.Z)(messageContext, [
            "message"
        ]);
        return JSON.parse(JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            reportMessage: message
        })));
    }
    return JSON.parse(JSON.stringify(messageContext));
};
var infoReport = function(message, messageContext, error) {
    try {
        if (env/* IS_LOCAL */.Kc) {
            console.log("report > reportInfo", message, messageContext, error);
        } else {
            datadogLogs.logger.info(message, getMessageContext(messageContext), error);
        }
    } catch (_error) {}
};
var errorReport = function(message, messageContext, error) {
    try {
        if (env/* IS_LOCAL */.Kc) {
            console.log("report > reportError", message, messageContext, error);
        } else {
            datadogLogs.logger.error(message, getMessageContext(messageContext), error);
        }
    } catch (_error) {}
};
var warningReport = function(message, messageContext, error) {
    try {
        if (env/* IS_LOCAL */.Kc) {
            console.log("report > reportWarning", message, messageContext, error);
        } else {
            datadogLogs.logger.warn(message, getMessageContext(messageContext), error);
        }
    } catch (_error) {}
};
var debugReport = function(message, messageContext, error) {
    try {
        if (env/* IS_LOCAL */.Kc) {
            console.log("report > reportDebug", message, messageContext, error);
        } else {
            datadogLogs.logger.debug(message, getMessageContext(messageContext), error);
        }
    } catch (_error) {}
};
var addActionForRum = function(actionName, context) {
    try {
        if (env/* IS_LOCAL */.Kc) {
            console.log("tracking > addAction", actionName, context);
        } else {
            if ((0,RNPlugins/* isWebView */.vp)()) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.ADD_ACTION_FOR_RUM */.nn.ADD_ACTION_FOR_RUM, {
                    actionName: actionName,
                    params: context
                });
            } else {
                datadogRum.addAction(actionName, context);
            }
        }
    } catch (_error) {}
};


/***/ }),

/***/ 53612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ setTokenExpiration; },
/* harmony export */   "N": function() { return /* binding */ checkTokenExpiration; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

var setTokenExpiration = function(token) {
    return token + "//" + dayjs__WEBPACK_IMPORTED_MODULE_0___default()().unix();
};
var checkTokenExpiration = function(expiration) {
    var diffDay = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(parseInt(expiration, 10) * 1000), "hour");
    return diffDay <= 24;
};


/***/ }),

/***/ 74735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OB": function() { return /* binding */ deleteQueryString; },
/* harmony export */   "aM": function() { return /* binding */ updateSearchParams; },
/* harmony export */   "hA": function() { return /* binding */ getUrlPathWithoutQueryString; },
/* harmony export */   "jl": function() { return /* binding */ stringifyToArray; },
/* harmony export */   "oO": function() { return /* binding */ parseQueryStringToArray; },
/* harmony export */   "sC": function() { return /* binding */ addQueryString; }
/* harmony export */ });
/* unused harmony export stringifyArrayToQueryString */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);




var searchParamsToObject = function(searchParams) {
    return Object.fromEntries(searchParams);
};
var replaceQueue = [];
var isProcessingQueue = false;
var processQueue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var replaceFn;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isProcessingQueue) return [
                        2
                    ];
                    isProcessingQueue = true;
                    _state.label = 1;
                case 1:
                    if (!(replaceQueue.length > 0)) return [
                        3,
                        4
                    ];
                    replaceFn = replaceQueue.shift();
                    if (!replaceFn) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        replaceFn()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    isProcessingQueue = false;
                    return [
                        2
                    ];
            }
        });
    });
    return function processQueue() {
        return _ref.apply(this, arguments);
    };
}();
var _updateSearchParams = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(params) {
        var searchParams, parsedSearchParams;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!( true && window.location && "URLSearchParams" in window)) return [
                        3,
                        2
                    ];
                    searchParams = new URLSearchParams(window.location.search);
                    params.forEach(function(param) {
                        var key = param.key, value = param.value;
                        if (value && value.toString()) {
                            searchParams.set(key, value.toString());
                        } else {
                            searchParams.delete(key);
                        }
                    });
                    parsedSearchParams = searchParamsToObject(searchParams);
                    return [
                        4,
                        next_router__WEBPACK_IMPORTED_MODULE_0___default().replace({
                            pathname: "",
                            query: parsedSearchParams
                        }, undefined, {
                            shallow: true
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function _updateSearchParams(params) {
        return _ref.apply(this, arguments);
    };
}();
var updateSearchParams = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            replaceQueue.push(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _updateSearchParams(params)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            processQueue();
            return [
                2
            ];
        });
    });
    return function updateSearchParams(params) {
        return _ref.apply(this, arguments);
    };
}();
var deleteQueryString = function(querystringKey) {
    if ( true && window.location) {
        delete (next_router__WEBPACK_IMPORTED_MODULE_0___default().query)[querystringKey];
        next_router__WEBPACK_IMPORTED_MODULE_0___default().replace({
            pathname: "",
            query: (next_router__WEBPACK_IMPORTED_MODULE_0___default().query)
        }, undefined, {
            shallow: true
        });
    }
};
var stringifyArrayToQueryString = function(queryArray) {
    return queryArray.map(Number).join(",");
};
var stringifyToArray = function(queryArray) {
    return queryArray.join(",");
};
var parseQueryStringToArray = function(queryString) {
    return queryString ? queryString.split(",") : [];
};
var addQueryString = function(queries) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "?";
    if (!queries) {
        return "";
    }
    var queryList = Object.entries(queries).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (value) {
            acc.push("".concat(key, "=").concat(value.toString()));
        }
        return acc;
    }, []);
    if (queryList.length === 0) {
        return "";
    }
    return "".concat(prefix).concat(queryList.join("&"));
};
var getUrlPathWithoutQueryString = function(urlPath) {
    return urlPath.split("?")[0];
};


/***/ }),

/***/ 64002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ preventInputEnter; },
/* harmony export */   "G5": function() { return /* binding */ validateNonSpecialPattern; },
/* harmony export */   "G6": function() { return /* binding */ checkInputOnlyNumber; },
/* harmony export */   "SO": function() { return /* binding */ pressEnterNextFocus; },
/* harmony export */   "Zr": function() { return /* binding */ validateSsnCheck; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var getIsNation = function(ssn2) {
    var secondFirstPlace = ssn2.substring(0, 1);
    switch(secondFirstPlace){
        case "5":
        case "6":
        case "7":
        case "8":
            return true;
        default:
            return false;
    }
};
var validateSsnCheck = function(_ssn1, _ssn2, isSsnChanged) {
    var ssn1 = _ssn1, ssn2 = _ssn2, ssn = ssn1 + "" + ssn2, arrSsn = [], compare = [
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        2,
        3,
        4,
        5
    ];
    var sum = 0;
    if (ssn.length !== 13) return false;
    if (isSsnChanged) {
        return true;
    }
    var secondFirstPlace = ssn2.substring(0, 1);
    if (ssn1 >= "201001" && [
        "3",
        "4"
    ].includes(secondFirstPlace)) {
        return true;
    }
    for(var i = 0; i < 13; i++){
        arrSsn[i] = Number(ssn.substring(i, i + 1));
    }
    for(var i1 = 0; i1 < 12; i1++){
        sum = sum + arrSsn[i1] * compare[i1];
    }
    var isNation = getIsNation(ssn2);
    if (isNation) {
        sum = (13 - sum % 11) % 10;
    } else {
        sum = (11 - sum % 11) % 10;
    }
    if (sum !== arrSsn[12]) return false;
    return true;
};
var preventInputEnter = function(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        return true;
    }
    return false;
};
var pressEnterNextFocus = function(event, nextElement) {
    var isPrevented = preventInputEnter(event);
    if (!nextElement || !isPrevented) {
        return;
    }
    nextElement.focus();
};
var checkInputOnlyNumber = function(event) {
    var notNumberRegex = /[^0-9]/g;
    var hasNotNumberChar = event.target.value.match(notNumberRegex);
    if (!hasNotNumberChar) {
        return;
    }
    event.target.value = event.target.value.replace(notNumberRegex, "");
};
var validateNonSpecialPattern = function(input) {
    var ALLOWED_PATTERN = /^[a-zA-Z0-9가-힣\s]*$/gi;
    return ALLOWED_PATTERN.test(input);
};


/***/ }),

/***/ 65253:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 90162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(19178)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(29918);
var _addLocale = __webpack_require__(94400);
var _routerContext = __webpack_require__(33220);
var _appRouterContext = __webpack_require__(64069);
var _useIntersection = __webpack_require__(22030);
var _getDomainLocale = __webpack_require__(65253);
var _addBasePath = __webpack_require__(73952);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 22030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(49071);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( true ? __webpack_require__(2784) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 57087:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68522:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 84988:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20533:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 56422:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98612:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90162)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 89430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.z8 = __webpack_unused_export__ = exports.$l = void 0;
var recoil_1 = __webpack_require__(53476);
var nexus = {};
function RecoilNexus() {
    nexus.get = (0, recoil_1.useRecoilCallback)(function (_a) {
        var snapshot = _a.snapshot;
        return function (atom) {
            return snapshot.getLoadable(atom).contents;
        };
    }, []);
    nexus.getPromise = (0, recoil_1.useRecoilCallback)(function (_a) {
        var snapshot = _a.snapshot;
        return function (atom) {
            return snapshot.getPromise(atom);
        };
    }, []);
    nexus.set = (0, recoil_1.useRecoilCallback)(function (_a) {
        var snapshot = _a.snapshot, gotoSnapshot = _a.gotoSnapshot;
        return function (atom, valOrUpdater) {
            var newSnapshot = snapshot.map(function (mutable) {
                mutable.set(atom, valOrUpdater);
            });
            gotoSnapshot(newSnapshot);
        };
    }, []);
    nexus.reset = (0, recoil_1.useRecoilCallback)(function (_a) {
        var reset = _a.reset;
        return reset;
    }, []);
    return null;
}
exports.ZP = RecoilNexus;
function getRecoil(atom) {
    return nexus.get(atom);
}
exports.$l = getRecoil;
function getRecoilPromise(atom) {
    return nexus.getPromise(atom);
}
__webpack_unused_export__ = getRecoilPromise;
function setRecoil(atom, valOrUpdater) {
    nexus.set(atom, valOrUpdater);
}
exports.z8 = setRecoil;
function resetRecoil(atom) {
    nexus.reset(atom);
}
__webpack_unused_export__ = resetRecoil;
//# sourceMappingURL=RecoilNexus.js.map

/***/ }),

/***/ 53476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultValue": function() { return /* binding */ Recoil_index_1; },
/* harmony export */   "RecoilEnv": function() { return /* binding */ Recoil_index_4; },
/* harmony export */   "RecoilLoadable": function() { return /* binding */ Recoil_index_3; },
/* harmony export */   "RecoilRoot": function() { return /* binding */ Recoil_index_5; },
/* harmony export */   "atom": function() { return /* binding */ Recoil_index_8; },
/* harmony export */   "atomFamily": function() { return /* binding */ Recoil_index_10; },
/* harmony export */   "constSelector": function() { return /* binding */ Recoil_index_12; },
/* harmony export */   "errorSelector": function() { return /* binding */ Recoil_index_13; },
/* harmony export */   "isRecoilValue": function() { return /* binding */ Recoil_index_2; },
/* harmony export */   "noWait": function() { return /* binding */ Recoil_index_15; },
/* harmony export */   "readOnlySelector": function() { return /* binding */ Recoil_index_14; },
/* harmony export */   "retentionZone": function() { return /* binding */ Recoil_index_38; },
/* harmony export */   "selector": function() { return /* binding */ Recoil_index_9; },
/* harmony export */   "selectorFamily": function() { return /* binding */ Recoil_index_11; },
/* harmony export */   "snapshot_UNSTABLE": function() { return /* binding */ Recoil_index_36; },
/* harmony export */   "useGetRecoilValueInfo_UNSTABLE": function() { return /* binding */ Recoil_index_26; },
/* harmony export */   "useGotoRecoilSnapshot": function() { return /* binding */ Recoil_index_33; },
/* harmony export */   "useRecoilBridgeAcrossReactRoots_UNSTABLE": function() { return /* binding */ Recoil_index_7; },
/* harmony export */   "useRecoilCallback": function() { return /* binding */ Recoil_index_31; },
/* harmony export */   "useRecoilRefresher_UNSTABLE": function() { return /* binding */ Recoil_index_27; },
/* harmony export */   "useRecoilSnapshot": function() { return /* binding */ Recoil_index_34; },
/* harmony export */   "useRecoilState": function() { return /* binding */ Recoil_index_22; },
/* harmony export */   "useRecoilStateLoadable": function() { return /* binding */ Recoil_index_23; },
/* harmony export */   "useRecoilState_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_30; },
/* harmony export */   "useRecoilStoreID": function() { return /* binding */ Recoil_index_6; },
/* harmony export */   "useRecoilTransactionObserver_UNSTABLE": function() { return /* binding */ Recoil_index_35; },
/* harmony export */   "useRecoilTransaction_UNSTABLE": function() { return /* binding */ Recoil_index_32; },
/* harmony export */   "useRecoilValue": function() { return /* binding */ Recoil_index_20; },
/* harmony export */   "useRecoilValueLoadable": function() { return /* binding */ Recoil_index_21; },
/* harmony export */   "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_28; },
/* harmony export */   "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_29; },
/* harmony export */   "useResetRecoilState": function() { return /* binding */ Recoil_index_25; },
/* harmony export */   "useRetain": function() { return /* binding */ Recoil_index_37; },
/* harmony export */   "useSetRecoilState": function() { return /* binding */ Recoil_index_24; },
/* harmony export */   "waitForAll": function() { return /* binding */ Recoil_index_18; },
/* harmony export */   "waitForAllSettled": function() { return /* binding */ Recoil_index_19; },
/* harmony export */   "waitForAny": function() { return /* binding */ Recoil_index_17; },
/* harmony export */   "waitForNone": function() { return /* binding */ Recoil_index_16; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
/* provided dependency */ var process = __webpack_require__(34406);



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function err(message) {
  const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
  // err.stack property is accessed.

  if (error.stack === undefined) {
    // IE sets the stack only if error is thrown
    try {
      throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty

  }

  return error;
}

var err_1 = err;

// @oss-only


var Recoil_err = err_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

var Recoil_isPromise = isPromise;

function nullthrows(x, message) {
  if (x != null) {
    return x;
  }

  throw Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}

var Recoil_nullthrows = nullthrows;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class BaseLoadable {
  getValue() {
    throw Recoil_err('BaseLoadable');
  }

  toPromise() {
    throw Recoil_err('BaseLoadable');
  }

  valueMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  valueOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }

  promiseMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  promiseOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }

  errorMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  errorOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }

  is(other) {
    // $FlowFixMe[prop-missing]
    return other.state === this.state && other.contents === this.contents;
  }

  map(_map) {
    throw Recoil_err('BaseLoadable');
  }

}

class ValueLoadable extends BaseLoadable {
  constructor(value) {
    super();

    _defineProperty(this, "state", 'hasValue');

    _defineProperty(this, "contents", void 0);

    this.contents = value;
  }

  getValue() {
    return this.contents;
  }

  toPromise() {
    return Promise.resolve(this.contents);
  }

  valueMaybe() {
    return this.contents;
  }

  valueOrThrow() {
    return this.contents;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? // If we "suspended", then try again.
      // errors and subsequent retries will be handled in 'loading' case
      // $FlowFixMe[prop-missing]
      loadableWithPromise(e.next(() => this.map(map))) : loadableWithError(e);
    }
  }

}

class ErrorLoadable extends BaseLoadable {
  constructor(error) {
    super();

    _defineProperty(this, "state", 'hasError');

    _defineProperty(this, "contents", void 0);

    this.contents = error;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return Promise.reject(this.contents);
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return this.contents;
  }

  errorOrThrow() {
    return this.contents;
  }

  map(_map) {
    // $FlowIssue[incompatible-return]
    return this;
  }

}

class LoadingLoadable extends BaseLoadable {
  constructor(promise) {
    super();

    _defineProperty(this, "state", 'loading');

    _defineProperty(this, "contents", void 0);

    this.contents = promise;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return this.contents;
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return this.contents;
  }

  promiseOrThrow() {
    return this.contents;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    return loadableWithPromise(this.contents.then(value => {
      const next = map(value);

      if (isLoadable(next)) {
        const nextLoadable = next;

        switch (nextLoadable.state) {
          case 'hasValue':
            return nextLoadable.contents;

          case 'hasError':
            throw nextLoadable.contents;

          case 'loading':
            return nextLoadable.contents;
        }
      } // $FlowIssue[incompatible-return]


      return next;
    }) // $FlowFixMe[incompatible-call]
    .catch(e => {
      if (Recoil_isPromise(e)) {
        // we were "suspended," try again
        return e.then(() => this.map(map).contents);
      }

      throw e;
    }));
  }

}

function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}

function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}

function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}

function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {})));
}

function loadableAllArray(inputs) {
  return inputs.every(i => i.state === 'hasValue') ? loadableWithValue(inputs.map(i => i.contents)) : inputs.some(i => i.state === 'hasError') ? loadableWithError(Recoil_nullthrows(inputs.find(i => i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : loadableWithPromise(Promise.all(inputs.map(i => i.contents)));
}

function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(key => inputs[key]);
  const normalizedInputs = unwrapedInputs.map(x => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? // $FlowIssue[incompatible-return]
  output : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  // $FlowIssue[incompatible-call]
  output.map(outputs => Object.getOwnPropertyNames(inputs).reduce( // $FlowFixMe[invalid-computed-prop]
  (out, key, idx) => ({ ...out,
    [key]: outputs[idx]
  }), {}));
}

function isLoadable(x) {
  return x instanceof BaseLoadable;
}

const LoadableStaticInterface = {
  of: value => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: error => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};

var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;

var Recoil_Loadable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});

const env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: new Set(['recoil_hamt_2020', 'recoil_sync_external_store', 'recoil_suppress_rerender_in_callback', 'recoil_memory_managament_2020'])
};

function readProcessEnvBooleanFlag(name, set) {
  var _process$env$name, _process$env$name$toL;

  const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  const allowedValues = ['true', 'false'];

  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }

  set(sanitizedValue === 'true');
}

function readProcessEnvStringArrayFlag(name, set) {
  var _process$env$name2;

  const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */


function applyProcessEnvFlagOverrides() {
  var _process;

  // note: this check is needed in addition to the check below, runtime error will occur without it!
  // eslint-disable-next-line fb-www/typeof-undefined
  if (typeof process === 'undefined') {
    return;
  }

  if (((_process = process) === null || process === void 0 ? void 0 : process.env) == null) {
    return;
  }

  readProcessEnvBooleanFlag('RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED', value => {
    env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
  });
  readProcessEnvStringArrayFlag('RECOIL_GKS_ENABLED', value => {
    value.forEach(gk => {
      env.RECOIL_GKS_ENABLED.add(gk);
    });
  });
}

applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;

function Recoil_gkx_OSS(gk) {
  return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}

Recoil_gkx_OSS.setPass = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};

Recoil_gkx_OSS.setFail = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};

Recoil_gkx_OSS.clear = () => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};

var Recoil_gkx = Recoil_gkx_OSS; // @oss-only

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (false) {}

  return null;
}

var recoverableViolation_1 = recoverableViolation;

// @oss-only


var Recoil_recoverableViolation = recoverableViolation_1;

var _createMutableSource, _useMutableSource, _useSyncExternalStore;







const createMutableSource = // flowlint-next-line unclear-type:off
(_createMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_createMutableSource;
const useMutableSource = // flowlint-next-line unclear-type:off
(_useMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86

const useSyncExternalStore = // flowlint-next-line unclear-type:off
(_useSyncExternalStore = react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : // flowlint-next-line unclear-type:off
react__WEBPACK_IMPORTED_MODULE_0__.unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.

function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;

  // $FlowFixMe[incompatible-use]
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } =
  /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
  react__WEBPACK_IMPORTED_MODULE_0__.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;

  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
  }

  return isUseSyncExternalStoreSupported;
}

/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */
function reactMode() {
  // NOTE: This mode is currently broken with some Suspense cases
  // see Recoil_selector-test.js
  if (Recoil_gkx('recoil_transition_support')) {
    return {
      mode: 'TRANSITION_SUPPORT',
      early: true,
      concurrent: true
    };
  }

  if (Recoil_gkx('recoil_sync_external_store') && useSyncExternalStore != null) {
    return {
      mode: 'SYNC_EXTERNAL_STORE',
      early: true,
      concurrent: false
    };
  }

  if (Recoil_gkx('recoil_mutable_source') && useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
      mode: 'MUTABLE_SOURCE',
      early: true,
      concurrent: true
    } : {
      mode: 'MUTABLE_SOURCE',
      early: false,
      concurrent: false
    };
  }

  return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
    mode: 'LEGACY',
    early: true,
    concurrent: false
  } : {
    mode: 'LEGACY',
    early: false,
    concurrent: false
  };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:


function isFastRefreshEnabled() {
  // @fb-only: const {isAcceptingUpdate} = require('__debug');
  // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
  return false; // @oss-only
}

var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);

    this.key = newKey;
  }

  toJSON() {
    return {
      key: this.key
    };
  }

}

class RecoilState extends AbstractRecoilValue {}

class RecoilValueReadOnly extends AbstractRecoilValue {}

function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}

var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};

var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;

var Recoil_RecoilValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}

var sprintf_1 = (/* unused pure expression or super */ null && (sprintf));

function expectationViolation(format, ...args) {
  if (false) {}
}

var expectationViolation_1 = expectationViolation;

// @oss-only


var Recoil_expectationViolation = expectationViolation_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */

function mapIterable(iterable, callback) {
  // Use generator to create iterable/iterator
  return function* () {
    let index = 0;

    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}

var Recoil_mapIterable = mapIterable;

const {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;















class DefaultValue {}

const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off

const recoilValues = new Map();
/* eslint-disable no-redeclare */

function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, key => Recoil_nullthrows(recoilValues.get(key)));
}

function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;

    if (false) {} else {
      // @fb-only: recoverableViolation(message, 'recoil');
      console.warn(message); // @oss-only
    }
  }
}

function registerNode(node) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node.key);
  }

  nodes.set(node.key, node);
  const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
  recoilValues.set(node.key, recoilValue);
  return recoilValue;
}
/* eslint-enable no-redeclare */


class NodeMissingError extends Error {} // flowlint-next-line unclear-type:off


function getNode(key) {
  const node = nodes.get(key);

  if (node == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }

  return node;
} // flowlint-next-line unclear-type:off


function getNodeMaybe(key) {
  return nodes.get(key);
}

const configDeletionHandlers = new Map();

function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const node = nodes.get(key);

  if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
    var _getConfigDeletionHan;

    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}

function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  if (fn === undefined) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}

function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}

var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function enqueueExecution(s, f) {
  f();
}

var Recoil_Queue = {
  enqueueExecution
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hamt_1 = createCommonjsModule(function (module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/


var hamt = {}; // export

/* Configuration
 ******************************************************************************/

var SIZE = 5;
var BUCKET_SIZE = Math.pow(2, SIZE);
var MASK = BUCKET_SIZE - 1;
var MAX_INDEX_NODE = BUCKET_SIZE / 2;
var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
/*
 ******************************************************************************/

var nothing = {};

var constant = function constant(x) {
  return function () {
    return x;
  };
};
/**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/


var hash = hamt.hash = function (str) {
  var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
  if (type === 'number') return str;
  if (type !== 'string') str += '';
  var hash = 0;

  for (var i = 0, len = str.length; i < len; ++i) {
    var c = str.charCodeAt(i);
    hash = (hash << 5) - hash + c | 0;
  }

  return hash;
};
/* Bit Ops
 ******************************************************************************/

/**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/


var popcount = function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
};

var hashFragment = function hashFragment(shift, h) {
  return h >>> shift & MASK;
};

var toBitmap = function toBitmap(x) {
  return 1 << x;
};

var fromBitmap = function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
};
/* Array Ops
 ******************************************************************************/

/**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/


var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
  var out = arr;

  if (!mutate) {
    var len = arr.length;
    out = new Array(len);

    for (var i = 0; i < len; ++i) {
      out[i] = arr[i];
    }
  }

  out[at] = v;
  return out;
};
/**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/


var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
  var newLen = arr.length - 1;
  var i = 0;
  var g = 0;
  var out = arr;

  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);

    while (i < at) {
      out[g++] = arr[i++];
    }
  }

  ++i;

  while (i <= newLen) {
    out[g++] = arr[i++];
  }

  if (mutate) {
    out.length = newLen;
  }

  return out;
};
/**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/


var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
  var len = arr.length;

  if (mutate) {
    var _i = len;

    while (_i >= at) {
      arr[_i--] = arr[_i];
    }

    arr[at] = v;
    return arr;
  }

  var i = 0,
      g = 0;
  var out = new Array(len + 1);

  while (i < at) {
    out[g++] = arr[i++];
  }

  out[at] = v;

  while (i < len) {
    out[++g] = arr[i++];
  }

  return out;
};
/* Node Structures
 ******************************************************************************/


var LEAF = 1;
var COLLISION = 2;
var INDEX = 3;
var ARRAY = 4;
/**
    Empty node.
*/

var empty = {
  __hamt_isEmpty: true
};

var isEmptyNode = function isEmptyNode(x) {
  return x === empty || x && x.__hamt_isEmpty;
};
/**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/


var Leaf = function Leaf(edit, hash, key, value) {
  return {
    type: LEAF,
    edit: edit,
    hash: hash,
    key: key,
    value: value,
    _modify: Leaf__modify
  };
};
/**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/


var Collision = function Collision(edit, hash, children) {
  return {
    type: COLLISION,
    edit: edit,
    hash: hash,
    children: children,
    _modify: Collision__modify
  };
};
/**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/


var IndexedNode = function IndexedNode(edit, mask, children) {
  return {
    type: INDEX,
    edit: edit,
    mask: mask,
    children: children,
    _modify: IndexedNode__modify
  };
};
/**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/


var ArrayNode = function ArrayNode(edit, size, children) {
  return {
    type: ARRAY,
    edit: edit,
    size: size,
    children: children,
    _modify: ArrayNode__modify
  };
};
/**
    Is `node` a leaf node?
*/


var isLeaf = function isLeaf(node) {
  return node === empty || node.type === LEAF || node.type === COLLISION;
};
/* Internal node operations.
 ******************************************************************************/

/**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/


var expand = function expand(edit, frag, child, bitmap, subNodes) {
  var arr = [];
  var bit = bitmap;
  var count = 0;

  for (var i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }

  arr[frag] = child;
  return ArrayNode(edit, count + 1, arr);
};
/**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/


var pack = function pack(edit, count, removed, elements) {
  var children = new Array(count - 1);
  var g = 0;
  var bitmap = 0;

  for (var i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      var elem = elements[i];

      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }

  return IndexedNode(edit, bitmap, children);
};
/**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/


var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return Collision(edit, h1, [n2, n1]);
  var subH1 = hashFragment(shift, h1);
  var subH2 = hashFragment(shift, h2);
  return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
};
/**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/


var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
  var len = list.length;

  for (var i = 0; i < len; ++i) {
    var child = list[i];

    if (keyEq(k, child.key)) {
      var value = child.value;

      var _newValue = f(value);

      if (_newValue === value) return list;

      if (_newValue === nothing) {
        --size.value;
        return arraySpliceOut(mutate, i, list);
      }

      return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
    }
  }

  var newValue = f();
  if (newValue === nothing) return list;
  ++size.value;
  return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
};

var canEditNode = function canEditNode(edit, node) {
  return edit === node.edit;
};
/* Editing
 ******************************************************************************/


var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
  if (keyEq(k, this.key)) {
    var _v = f(this.value);

    if (_v === this.value) return this;else if (_v === nothing) {
      --size.value;
      return empty;
    }

    if (canEditNode(edit, this)) {
      this.value = _v;
      return this;
    }

    return Leaf(edit, h, k, _v);
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
  if (h === this.hash) {
    var canEdit = canEditNode(edit, this);
    var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
    if (list === this.children) return this;
    return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
  var mask = this.mask;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var bit = toBitmap(frag);
  var indx = fromBitmap(mask, bit);
  var exists = mask & bit;
  var current = exists ? children[indx] : empty;

  var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (current === child) return this;
  var canEdit = canEditNode(edit, this);
  var bitmap = mask;
  var newChildren = void 0;

  if (exists && isEmptyNode(child)) {
    // remove
    bitmap &= ~bit;
    if (!bitmap) return empty;
    if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse

    newChildren = arraySpliceOut(canEdit, indx, children);
  } else if (!exists && !isEmptyNode(child)) {
    // add
    if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
    bitmap |= bit;
    newChildren = arraySpliceIn(canEdit, indx, child, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, indx, child, children);
  }

  if (canEdit) {
    this.mask = bitmap;
    this.children = newChildren;
    return this;
  }

  return IndexedNode(edit, bitmap, newChildren);
};

var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
  var count = this.size;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var child = children[frag];

  var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (child === newChild) return this;
  var canEdit = canEditNode(edit, this);
  var newChildren = void 0;

  if (isEmptyNode(child) && !isEmptyNode(newChild)) {
    // add
    ++count;
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
    // remove
    --count;
    if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
    newChildren = arrayUpdate(canEdit, frag, empty, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  }

  if (canEdit) {
    this.size = count;
    this.children = newChildren;
    return this;
  }

  return ArrayNode(edit, count, newChildren);
};

empty._modify = function (edit, keyEq, shift, f, h, k, size) {
  var v = f();
  if (v === nothing) return empty;
  ++size.value;
  return Leaf(edit, h, k, v);
};
/*
 ******************************************************************************/


function Map(editable, edit, config, root, size) {
  this._editable = editable;
  this._edit = edit;
  this._config = config;
  this._root = root;
  this._size = size;
}

Map.prototype.setTree = function (newRoot, newSize) {
  if (this._editable) {
    this._root = newRoot;
    this._size = newSize;
    return this;
  }

  return newRoot === this._root ? this : new Map(this._editable, this._edit, this._config, newRoot, newSize);
};
/* Queries
 ******************************************************************************/

/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/


var tryGetHash = hamt.tryGetHash = function (alt, hash, key, map) {
  var node = map._root;
  var shift = 0;
  var keyEq = map._config.keyEq;

  while (true) {
    switch (node.type) {
      case LEAF:
        {
          return keyEq(key, node.key) ? node.value : alt;
        }

      case COLLISION:
        {
          if (hash === node.hash) {
            var children = node.children;

            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key)) return child.value;
            }
          }

          return alt;
        }

      case INDEX:
        {
          var frag = hashFragment(shift, hash);
          var bit = toBitmap(frag);

          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }

          return alt;
        }

      case ARRAY:
        {
          node = node.children[hashFragment(shift, hash)];

          if (node) {
            shift += SIZE;
            break;
          }

          return alt;
        }

      default:
        return alt;
    }
  }
};

Map.prototype.tryGetHash = function (alt, hash, key) {
  return tryGetHash(alt, hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/


var tryGet = hamt.tryGet = function (alt, key, map) {
  return tryGetHash(alt, map._config.hash(key), key, map);
};

Map.prototype.tryGet = function (alt, key) {
  return tryGet(alt, key, this);
};
/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/


var getHash = hamt.getHash = function (hash, key, map) {
  return tryGetHash(undefined, hash, key, map);
};

Map.prototype.getHash = function (hash, key) {
  return getHash(hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/


var get = hamt.get = function (key, map) {
  return tryGetHash(undefined, map._config.hash(key), key, map);
};

Map.prototype.get = function (key, alt) {
  return tryGet(alt, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/


var hasHash = hamt.has = function (hash, key, map) {
  return tryGetHash(nothing, hash, key, map) !== nothing;
};

Map.prototype.hasHash = function (hash, key) {
  return hasHash(hash, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/


var has = hamt.has = function (key, map) {
  return hasHash(map._config.hash(key), key, map);
};

Map.prototype.has = function (key) {
  return has(key, this);
};

var defKeyCompare = function defKeyCompare(x, y) {
  return x === y;
};
/**
    Create an empty map.

    @param config Configuration.
*/


hamt.make = function (config) {
  return new Map(0, 0, {
    keyEq: config && config.keyEq || defKeyCompare,
    hash: config && config.hash || hash
  }, empty, 0);
};
/**
    Empty map.
*/


hamt.empty = hamt.make();
/**
    Does `map` contain any elements?
*/

var isEmpty = hamt.isEmpty = function (map) {
  return map && !!isEmptyNode(map._root);
};

Map.prototype.isEmpty = function () {
  return isEmpty(this);
};
/* Updates
 ******************************************************************************/

/**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/


var modifyHash = hamt.modifyHash = function (f, hash, key, map) {
  var size = {
    value: map._size
  };

  var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);

  return map.setTree(newRoot, size.value);
};

Map.prototype.modifyHash = function (hash, key, f) {
  return modifyHash(f, hash, key, this);
};
/**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/


var modify = hamt.modify = function (f, key, map) {
  return modifyHash(f, map._config.hash(key), key, map);
};

Map.prototype.modify = function (key, f) {
  return modify(f, key, this);
};
/**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/


var setHash = hamt.setHash = function (hash, key, value, map) {
  return modifyHash(constant(value), hash, key, map);
};

Map.prototype.setHash = function (hash, key, value) {
  return setHash(hash, key, value, this);
};
/**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/


var set = hamt.set = function (key, value, map) {
  return setHash(map._config.hash(key), key, value, map);
};

Map.prototype.set = function (key, value) {
  return set(key, value, this);
};
/**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/


var del = constant(nothing);

var removeHash = hamt.removeHash = function (hash, key, map) {
  return modifyHash(del, hash, key, map);
};

Map.prototype.removeHash = Map.prototype.deleteHash = function (hash, key) {
  return removeHash(hash, key, this);
};
/**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/


var remove = hamt.remove = function (key, map) {
  return removeHash(map._config.hash(key), key, map);
};

Map.prototype.remove = Map.prototype.delete = function (key) {
  return remove(key, this);
};
/* Mutation
 ******************************************************************************/

/**
    Mark `map` as mutable.
 */


var beginMutation = hamt.beginMutation = function (map) {
  return new Map(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
};

Map.prototype.beginMutation = function () {
  return beginMutation(this);
};
/**
    Mark `map` as immutable.
 */


var endMutation = hamt.endMutation = function (map) {
  map._editable = map._editable && map._editable - 1;
  return map;
};

Map.prototype.endMutation = function () {
  return endMutation(this);
};
/**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/


var mutate = hamt.mutate = function (f, map) {
  var transient = beginMutation(map);
  f(transient);
  return endMutation(transient);
};

Map.prototype.mutate = function (f) {
  return mutate(f, this);
};
/* Traversal
 ******************************************************************************/

/**
    Apply a continuation.
*/


var appk = function appk(k) {
  return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
};
/**
    Recursively visit all values stored in an array of nodes lazily.
*/


var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
  while (i < len) {
    var child = children[i++];
    if (child && !isEmptyNode(child)) return lazyVisit(child, f, [len, children, i, f, k]);
  }

  return appk(k);
};
/**
    Recursively visit all values stored in `node` lazily.
*/


var lazyVisit = function lazyVisit(node, f, k) {
  switch (node.type) {
    case LEAF:
      return {
        value: f(node),
        rest: k
      };

    case COLLISION:
    case ARRAY:
    case INDEX:
      var children = node.children;
      return lazyVisitChildren(children.length, children, 0, f, k);

    default:
      return appk(k);
  }
};

var DONE = {
  done: true
};
/**
    Javascript iterator over a map.
*/

function MapIterator(v) {
  this.v = v;
}

MapIterator.prototype.next = function () {
  if (!this.v) return DONE;
  var v0 = this.v;
  this.v = appk(v0.rest);
  return v0;
};

MapIterator.prototype[Symbol.iterator] = function () {
  return this;
};
/**
    Lazily visit each value in map with function `f`.
*/


var visit = function visit(map, f) {
  return new MapIterator(lazyVisit(map._root, f));
};
/**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/


var buildPairs = function buildPairs(x) {
  return [x.key, x.value];
};

var entries = hamt.entries = function (map) {
  return visit(map, buildPairs);
};

Map.prototype.entries = Map.prototype[Symbol.iterator] = function () {
  return entries(this);
};
/**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/


var buildKeys = function buildKeys(x) {
  return x.key;
};

var keys = hamt.keys = function (map) {
  return visit(map, buildKeys);
};

Map.prototype.keys = function () {
  return keys(this);
};
/**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/


var buildValues = function buildValues(x) {
  return x.value;
};

var values = hamt.values = Map.prototype.values = function (map) {
  return visit(map, buildValues);
};

Map.prototype.values = function () {
  return values(this);
};
/* Fold
 ******************************************************************************/

/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/


var fold = hamt.fold = function (f, z, m) {
  var root = m._root;
  if (root.type === LEAF) return f(z, root.value, root.key);
  var toVisit = [root.children];
  var children = void 0;

  while (children = toVisit.pop()) {
    for (var i = 0, len = children.length; i < len;) {
      var child = children[i++];

      if (child && child.type) {
        if (child.type === LEAF) z = f(z, child.value, child.key);else toVisit.push(child.children);
      }
    }
  }

  return z;
};

Map.prototype.fold = function (f, z) {
  return fold(f, z, this);
};
/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/


var forEach = hamt.forEach = function (f, map) {
  return fold(function (_, value, key) {
    return f(value, key, map);
  }, null, map);
};

Map.prototype.forEach = function (f) {
  return forEach(f, this);
};
/* Aggregate
 ******************************************************************************/

/**
    Get the number of entries in `map`.
*/


var count = hamt.count = function (map) {
  return map._size;
};

Map.prototype.count = function () {
  return count(this);
};

Object.defineProperty(Map.prototype, 'size', {
  get: Map.prototype.count
});
/* Export
 ******************************************************************************/

if ( module.exports) {
  module.exports = hamt;
} else {
  undefined.hamt = hamt;
}
});

class BuiltInMap {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);

    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }

  keys() {
    return this._map.keys();
  }

  entries() {
    return this._map.entries();
  }

  get(k) {
    return this._map.get(k);
  }

  has(k) {
    return this._map.has(k);
  }

  set(k, v) {
    this._map.set(k, v);

    return this;
  }

  delete(k) {
    this._map.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._map);
  }

}

class HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());

    if (existing instanceof HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();

      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }

  keys() {
    return this._hamt.keys();
  }

  entries() {
    return this._hamt.entries();
  }

  get(k) {
    return this._hamt.get(k);
  }

  has(k) {
    return this._hamt.has(k);
  }

  set(k, v) {
    this._hamt.set(k, v);

    return this;
  }

  delete(k) {
    this._hamt.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._hamt);
  }

}

function persistentMap(existing) {
  if (Recoil_gkx('recoil_hamt_2020')) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}

var Recoil_PersistentMap = {
  persistentMap
};

var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;

var Recoil_PersistentMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */

function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = new Set();

  FIRST: for (const value of set) {
    for (const otherSet of setsWithValuesToRemove) {
      if (otherSet.has(value)) {
        continue FIRST;
      }
    }

    ret.add(value);
  }

  return ret;
}

var Recoil_differenceSets = differenceSets;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */

function mapMap(map, callback) {
  const result = new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}

var Recoil_mapMap = mapMap;

function makeGraph() {
  return {
    nodeDeps: new Map(),
    nodeToNodeSubscriptions: new Map()
  };
}

function cloneGraph(graph) {
  return {
    nodeDeps: Recoil_mapMap(graph.nodeDeps, s => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, s => new Set(s))
  };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.


function mergeDepsIntoGraph(key, newDeps, graph, // If olderGraph is given then we will not overwrite changes made to the given
// graph compared with olderGraph:
olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph;
  const oldDeps = nodeDeps.get(key);

  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  } // Update nodeDeps:


  nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:

  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);

  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, new Set());
    }

    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  } // Remove removed deps from nodeToNodeSubscriptions:


  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);

    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }

      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);

      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}

function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;

  const storeState = store.getState();

  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
  } // Merge the dependencies discovered into the store's dependency map
  // for the version that was read:


  const graph = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
  // into later versions if they don't already have their own:

  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph);
  }

  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;

    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;

    if (nextVersion !== undefined) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph);
    }
  }
}

var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let nextTreeStateVersion = 0;

const getNextTreeStateVersion = () => nextTreeStateVersion++;

let nextStoreID = 0;

const getNextStoreID = () => nextStoreID++;

let nextComponentID = 0;

const getNextComponentID = () => nextComponentID++;

var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};

const {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;

const {
  graph
} = Recoil_Graph;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;

function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}

function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: new Set(),
    knownSelectors: new Set(),
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(currentTree.version, graph()),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    nodeCleanupFunctions: new Map()
  };
}

var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class RetentionZone {}

function retentionZone() {
  return new RetentionZone();
}

var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */

function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}

function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}

function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}

function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}

function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}

function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach(k => next.delete(k));
  return next;
}

var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */

function* filterIterable(iterable, predicate) {
  // Use generator to create iterable/iterator
  let index = 0;

  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}

var Recoil_filterIterable = filterIterable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */
// $FlowIssue[unclear-type]

function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }

      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: target => {

      return Object.keys(target);
    }
  }); // $FlowIssue[incompatible-return]

  return proxy;
}

var Recoil_lazyProxy = lazyProxy;

const {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;

const {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;







 // flowlint-next-line unclear-type:off


const emptySet = Object.freeze(new Set());

class ReadOnlyRecoilValueError extends Error {}

function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return () => undefined;
  }

  const {
    nodesRetainedByZone
  } = store.getState().retention;

  function addToZone(zone) {
    let set = nodesRetainedByZone.get(zone);

    if (!set) {
      nodesRetainedByZone.set(zone, set = new Set());
    }

    set.add(nodeKey);
  }

  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }

  return () => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const {
      retention
    } = store.getState();

    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);

      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }

    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}

function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();

  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }

  const node = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
  const nodeCleanup = node.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}

function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}

function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;

  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.


function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, 'get');
  return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change


function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.


function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;

  const node = getNodeMaybe$1(key);
  node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
  return { ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)


function setNodeValue(store, state, key, newValue) {
  const node = getNode$1(key);

  if (node.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }

  const set = node.set; // so flow doesn't lose the above refinement.

  initializeNodeIfNewToStore(store, state, key, 'set');
  return set(store, state, newValue);
}

function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === 'selector' ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;

      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;

      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([key])), nodeKey => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
} // Find all of the recursively dependent nodes


function getDownstreamNodes(store, state, keys) {
  const visitedNodes = new Set();
  const visitingNodes = Array.from(keys);
  const graph = store.getGraph(state.version);

  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;

    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;

    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }

  return visitedNodes;
}

var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let _invalidateMemoizedSnapshot = null;

function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}

function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;

  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}

var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};

const {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;

const {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;

const {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;

const {
  DefaultValue: DefaultValue$1
} = Recoil_Node;

const {
  reactMode: reactMode$1
} = Recoil_ReactMode;

const {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;

const {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;







function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;

  // Reading from an older tree can cause bugs because the dependencies that we
  // discover during the read are lost.
  const storeState = store.getState();

  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to read from a discarded tree');
  }

  const loadable = getNodeLoadable$1(store, treeState, key);

  if (loadable.state === 'loading') {
    loadable.contents.catch(() => {
      /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */
      return;
    });
  }

  return loadable;
}

function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === 'hasValue' && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}

function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === 'function') {
    // Updater form: pass in the current value. Throw if the current value
    // is unavailable (namely when updating an async selector that's
    // pending or errored):
    const current = getNodeLoadable$1(store, state, key);

    if (current.state === 'loading') {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === 'hasError') {
      throw current.contents;
    } // T itself may be a function, so our refinement is not sufficient:


    return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
  } else {
    return valueOrUpdater;
  }
}

function applyAction(store, state, action) {
  if (action.type === 'set') {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);

    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === 'setLoadable') {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === 'markModified') {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === 'setUnvalidated') {
    var _node$invalidate;

    // Write value directly to state bypassing the Node interface as the node
    // definitions may not have been loaded yet when processing the initial snapshot.
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node = getNodeMaybe$2(key);
    node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}

function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === 'hasValue' && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }

  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}

function applyActionsToStore(store, actions) {
  store.replaceState(state => {
    const newState = copyTreeState(state);

    for (const action of actions) {
      applyAction(store, newState, action);
    }

    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}

function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);

    if (!actions) {
      actionsByStore.set(store, actions = []);
    }

    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}

const batchStack = [];

function batchStart() {
  const actionsByStore = new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }

    const popped = batchStack.pop();

    if (popped !== actionsByStore) {
      Recoil_recoverableViolation('Incorrect order of batch popping');
    }
  };
}

function copyTreeState(state) {
  return { ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}

function invalidateDownstreams(store, state) {
  // Inform any nodes that were changed or downstream of changes so that they
  // can clear out any caches as needed due to the update:
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);

  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;

    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}

function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: 'set',
    recoilValue,
    valueOrUpdater
  });
}

function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }

  queueOrPerformStateUpdate(store, {
    type: 'setLoadable',
    recoilValue,
    loadable: loadable
  });
}

function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: 'markModified',
    recoilValue
  });
}

function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: 'setUnvalidated',
    recoilValue,
    unvalidatedValue
  });
}

function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();

  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, new Map());
  }

  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>', callback]); // Handle the case that, during the same tick that we are subscribing, an atom
  // has been updated by some effect handler. Otherwise we will miss the update.

  const mode = reactMode$1();

  if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
    const nextTree = store.getState().nextTree;

    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }

  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);

      if (subs === undefined || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }

      subs.delete(subID);

      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}

function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;

  const {
    currentTree
  } = store.getState();
  const node = getNode$2(recoilValue.key);
  (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, currentTree);
}

var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */

function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();

  while (!current.done) {
    const entry = current.value;

    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }

    current = iterator.next();
  }

  return false;
}

var Recoil_someSet = someSet;

const {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;

const {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;







 // Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.


const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();

function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;

  if (storeState.nextTree) {
    Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
    return; // leak memory rather than erase something that's about to be used.
  }

  const nodes = new Set();

  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes.add(n);
      }
    } else {
      nodes.add(r);
    }
  }

  const releasableNodes = findReleasableNodes(store, nodes);

  for (const node of releasableNodes) {
    releaseNode(store, treeState, node);
  }
}

function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph = store.getGraph(treeState.version);
  const releasableNodes = new Set(); // mutated to collect answer

  const nonReleasableNodes = new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;

  function findReleasableNodesInner(searchFromNodes) {
    const releasableNodesFoundThisIteration = new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, // don't descend into these
    nonReleasableNodes // don't descend into these
    ); // Find which of the downstream nodes are releasable and which are not:

    for (const node of downstreams) {
      var _storeState$retention;

      // Not releasable if configured to be retained forever:
      if (getNode$3(node).retainedBy === 'recoilRoot') {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained directly by a component:


      if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained by a zone:


      if (zonesThatCouldRetainNode(node).some(z => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if it has a non-releasable child (which will already be in
      // nonReleasableNodes because we are going in topological order):


      const nodeChildren = graph.nodeToNodeSubscriptions.get(node);

      if (nodeChildren && Recoil_someSet(nodeChildren, child => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node);
        continue;
      }

      releasableNodes.add(node);
      releasableNodesFoundThisIteration.add(node);
    } // If we found any releasable nodes, we need to walk UP from those nodes to
    // find whether their parents can now be released as well:


    const parents = new Set();

    for (const node of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;

        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }

    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
} // Children before parents


function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, // Mutable set is destroyed in place
doNotDescendInto1, doNotDescendInto2) {
  const graph = store.getGraph(treeState.version);
  const answer = [];
  const visited = new Set();

  while (nodes.size > 0) {
    visit(Recoil_nullthrows(nodes.values().next().value));
  }

  return answer;

  function visit(node) {
    if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
      nodes.delete(node);
      return;
    }

    if (visited.has(node)) {
      return;
    }

    const children = graph.nodeToNodeSubscriptions.get(node);

    if (children) {
      for (const child of children) {
        visit(child);
      }
    }

    visited.add(node);
    nodes.delete(node);
    answer.push(node);
  }
}

function releaseNode(store, treeState, node) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // Atom effects, in-closure caches, etc.:


  cleanUpNode$1(store, node); // Delete from store state:

  const storeState = store.getState();
  storeState.knownAtoms.delete(node);
  storeState.knownSelectors.delete(node);
  storeState.nodeTransactionSubscriptions.delete(node);
  storeState.retention.referenceCounts.delete(node);
  const zones = zonesThatCouldRetainNode(node);

  for (const zone of zones) {
    var _storeState$retention2;

    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node);
  } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
  // already happens when the last component that was retaining the node unmounts,
  // and this could happen either before or after that.
  // Delete from TreeState and dep graph:


  treeState.atomValues.delete(node);
  treeState.dirtyAtoms.delete(node);
  treeState.nonvalidatedAtoms.delete(node);
  const graph = storeState.graphsByVersion.get(treeState.version);

  if (graph) {
    const deps = graph.nodeDeps.get(node);

    if (deps !== undefined) {
      graph.nodeDeps.delete(node);

      for (const dep of deps) {
        var _graph$nodeToNodeSubs;

        (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node);
      }
    } // No need to delete sub's deps as there should be no subs at this point.
    // But an invariant would require deleting nodes in topological order.


    graph.nodeToNodeSubscriptions.delete(node);
  } // Node config (for family members only as their configs can be recreated, and
  // only if they are not retained within any other Stores):


  deleteNodeConfigIfPossible$1(node);
}

function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;

  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}

function zonesThatCouldRetainNode(node) {
  const retainedBy = getNode$3(node).retainedBy;

  if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy; // it's an array of zones
  }
}

function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();

  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, new Set([retainable]));
  }
}

function updateRetainCount(store, retainable, delta) {
  var _map$get;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;

  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}

function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}

function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}

function retainedByOptionWithDefault(r) {
  // The default will change from 'recoilRoot' to 'components' in the future.
  return r === undefined ? 'recoilRoot' : r;
}

var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  unstable_batchedUpdates
} = react_dom__WEBPACK_IMPORTED_MODULE_1__;

var ReactBatchedUpdates = {
  unstable_batchedUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
// @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates; // @oss-only


var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;

const {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off


/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */
let batcher = unstable_batchedUpdates$2 || (batchFn => batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */


const setBatcher = newBatcher => {
  batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */


const getBatcher = () => batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */


const batchUpdates = callback => {
  batcher(() => {
    let batchEnd = () => undefined;

    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};

var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */

function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}

var Recoil_concatIterables = concatIterables;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/* eslint-disable fb-www/typeof-undefined */

const isSSR = // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */

const isWindow = value => !isSSR && ( // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
value === window || value instanceof Window);

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined

var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */

function memoizeWithArgsHash(fn, hashFunction) {
  let cache;
  return (...args) => {
    if (!cache) {
      cache = {};
    }

    const key = hashFunction(...args);

    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }

    return cache[key];
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  return (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  const invalidate = () => {
    lastKey = null;
  };

  return [memoizedFn, invalidate];
}

var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};

const {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;

const {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;

const {
  graph: graph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;

const {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;

const {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;

const {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;



const {
  isSSR: isSSR$1
} = Recoil_Environment;









const {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;



 // Opaque at this surface because it's part of the public API from here.


const retainWarning = (/* unused pure expression or super */ null && (`
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`)); // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.

class Snapshot {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_refCount", 1);

    _defineProperty(this, "getLoadable", recoilValue => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });

    _defineProperty(this, "getPromise", recoilValue => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });

    _defineProperty(this, "getNodes_UNSTABLE", opt => {
      this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors

      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }

        const state = this._store.getState().currentTree;

        return recoilValuesForKeys$2(state.dirtyAtoms);
      }

      const knownAtoms = this._store.getState().knownAtoms;

      const knownSelectors = this._store.getState().knownSelectors;

      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });

    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });

    _defineProperty(this, "map", mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here

      return mutableSnapshot;
    });

    _defineProperty(this, "asyncMap", async mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain(); // Retain new snapshot during async mapper

      await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
      // after the next tick, the same as a new synchronous snapshot.

      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });

    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: replacer => {
        // no batching, so nextTree is never active
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: version => {
        const graphs = storeState.graphsByVersion;

        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }

        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {}
      }),
      addTransactionMetadata: () => {
        throw Recoil_err('Cannot subscribe to Snapshots');
      }
    }; // Initialize any nodes that are live in the parent store (primarily so that
    // this snapshot gets counted towards the node's live stores count).
    // TODO Optimize this when cloning snapshots for callbacks

    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, 'get');
      updateRetainCount$1(this._store, nodeKey, 1);
    }

    this.autoRelease_INTERNAL();
  }

  retain() {
    if (this._refCount <= 0) {
      if (false) {} else {
        Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
      }
    }

    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;

        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */


  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(() => this._release(), 10);
    }
  }

  _release() {
    this._refCount--;

    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach(cleanup => cleanup());

      this._store.getState().nodeCleanupFunctions.clear();

      if (!Recoil_gkx('recoil_memory_managament_2020')) {
        return;
      } // Temporarily nerfing this to allow us to find broken call sites without
      // actually breaking anybody yet.
      // for (const k of this._store.getState().knownAtoms) {
      //   updateRetainCountToZero(this._store, k);
      // }

    } else if (this._refCount < 0) {
      if (false) {}
    }
  }

  isRetained() {
    return this._refCount > 0;
  }

  checkRefCount_INTERNAL() {
    if (Recoil_gkx('recoil_memory_managament_2020') && this._refCount <= 0) {
      if (false) {} // What we will ship later:
      // throw err(retainWarning);

    }
  }

  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }

  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }

  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  } // We want to allow the methods to be destructured and used as accessors

  /* eslint-disable fb-www/extra-arrow-initializer */

  /* eslint-enable fb-www/extra-arrow-initializer */


}

function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: { ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {}]))
  };
} // Factory to build a fresh snapshot


function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state


const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1( // $FlowFixMe[missing-local-annot]
(store, version) => {
  var _storeState$nextTree;

  const storeState = store.getState();
  const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
  return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version) => {
  var _store$getState$nextT, _store$getState$previ;

  return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies

setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);

function cloneSnapshot(store, version = 'latest') {
  const snapshot = memoizedCloneSnapshot(store, version);

  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }

  return snapshot;
}

class MutableSnapshot extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());

    _defineProperty(this, "_batch", void 0);

    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
      // read the written value after calling `set`. I would like to remove this
      // behavior and only batch in `Snapshot.map`, but this would be a breaking
      // change potentially.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });

    _defineProperty(this, "reset", recoilState => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });

    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", values => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });

    this._batch = batch;
  }

}

var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};

var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;

var Recoil_Snapshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function unionSets(...sets) {
  const result = new Set();

  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_unionSets = unionSets;

const {
  useRef
} = react__WEBPACK_IMPORTED_MODULE_0__;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */


function useRefInitOnce(initialValue) {
  // $FlowExpectedError[incompatible-call]
  const ref = useRef(initialValue);

  if (ref.current === initialValue && typeof initialValue === 'function') {
    // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
  }

  return ref;
}

var Recoil_useRefInitOnce = useRefInitOnce;

// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');


const {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;

const {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;

const {
  graph: graph$2
} = Recoil_Graph;

const {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;

const {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;

const {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;

const {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;

const {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;



const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef: useRef$1,
  useState
} = react__WEBPACK_IMPORTED_MODULE_0__;















function notInAContext() {
  throw Recoil_err('This component must be used inside a <RecoilRoot> component.');
}

const defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;

function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
  }

  const storeState = store.getState();

  if (storeState.nextTree === null) {
    if (Recoil_gkx('recoil_memory_managament_2020') && Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) {
      // If this is a cascading update (that is, rendering due to one state change
      // invokes a second state change), we won't have cleaned up retainables yet
      // because this normally happens after notifying components. Do it before
      // proceeding with the cascading update so that it remains predictable:
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }

    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = { ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}

const AppContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  current: defaultStore
});

const useStoreRef = () => useContext(AppContext); // $FlowExpectedError[incompatible-call]


const MutableSourceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);

  if (mutableSource == null) {
    Recoil_expectationViolation('Attempted to use a Recoil hook outside of a <RecoilRoot>. ' + '<RecoilRoot> must be an ancestor of any component that uses ' + 'Recoil hooks.');
  }

  return mutableSource;
}

function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);

  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);

    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}

function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:

  const dirtyAtoms = treeState.dirtyAtoms;

  if (dirtyAtoms.size) {
    // Execute Node-specific subscribers before global subscribers
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }

    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }

    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      // Notifying components is needed to wake from suspense, even when using
      // early rendering.
      notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
      // We need to wake up components not just when some asynchronous selector
      // resolved, but also when changing synchronous values because this may cause
      // a selector to change from asynchronous to synchronous, in which case there
      // would be no follow-up asynchronous resolution to wake us up.
      // TODO OPTIMIZATION Only wake up related downstream components

      storeState.suspendedComponentResolvers.forEach(cb => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  } // Special behavior ONLY invoked by useInterface.
  // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.


  storeState.queuedComponentCallbacks_DEPRECATED.forEach(cb => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}

function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;

  try {
    const {
      nextTree
    } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
    // because something above RecoilRoot re-rendered:

    if (nextTree == null) {
      return;
    } // nextTree is now committed -- note that copying and reset occurs when
    // a transaction begins, in startNextTreeIfNeeded:


    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);

    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
    }

    storeState.previousTree = null;

    if (Recoil_gkx('recoil_memory_managament_2020')) {
      // Only release retainables if there were no writes during the end of the
      // batch.  This avoids releasing something we might be about to use.
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */


function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState([]); // $FlowFixMe[incompatible-call]

  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(() => setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
    // notifyBatcherOfChange will still be called. An error gets thrown whenever
    // setState is called after a component is already unmounted, so this sets
    // notifyBatcherOfChange to be a no-op.

    return () => {
      setNotifyBatcherOfChange(() => {});
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    // enqueueExecution runs this function immediately; it is only used to
    // manipulate the order of useEffects during tests, since React seems to
    // call useEffect in an unpredictable order sometimes.
    Recoil_Queue.enqueueExecution('Batcher', () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}

if (false) {} // When removing this deprecated function, remove stateBySettingRecoilValue
// which will no longer be needed.


function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();

      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }

      initial.currentTree = { ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: atomValues => {
      // FIXME replace this with a mutative loop
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.


function initialStoreState(initializeState) {
  // Initialize a snapshot and get its store
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release

  snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
  // they will re-initialize if used during rendering.  This allows atom effect
  // initialization to take precedence over initializeState and be compatible
  // with StrictMode semantics.

  storeState.nodeCleanupFunctions.forEach(cleanup => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}

let nextID = 0;

function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  // prettier-ignore
  // @fb-only: useEffect(() => {
  // @fb-only: if (gkx('recoil_usage_logging')) {
  // @fb-only: try {
  // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
  // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
  // @fb-only: path: URI.getRequestURI().getPath(),
  // @fb-only: }));
  // @fb-only: } catch {
  // @fb-only: recoverableViolation(
  // @fb-only: 'Error when logging Recoil Usage event',
  // @fb-only: 'recoil',
  // @fb-only: );
  // @fb-only: }
  // @fb-only: }
  // @fb-only: }, []);
  let storeStateRef; // eslint-disable-line prefer-const

  const getGraph = version => {
    const graphs = storeStateRef.current.graphsByVersion;

    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }

    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };

  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      // Global transaction subscriptions
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      // Node-specific transaction subscriptions:
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();

      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, new Map());
      }

      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);

          if (subs) {
            subs.delete(id);

            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };

  const addTransactionMetadata = metadata => {
    startNextTreeIfNeeded(storeRef.current);

    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };

  const replaceState = replacer => {
    startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:

    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;

    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }

    if (replaced === nextTree) {
      return;
    }

    if (false) {} // Save changes to nextTree and schedule a React update:


    storeStateRef.current.nextTree = replaced;

    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }

    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };

  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback(x => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });

  if (storeProp != null) {
    storeRef.current = storeProp;
  }

  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]); // Cleanup when the <RecoilRoot> is unmounted

  useEffect(() => {
    // React is free to call effect cleanup handlers and effects at will, the
    // deps array is only an optimization.  For example, React strict mode
    // will execute each effect twice for testing.  Therefore, we need symmetry
    // to re-initialize all known atoms after they were cleaned up.
    const store = storeRef.current;

    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, 'get');
    }

    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
    value: storeRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Batcher, {
    setNotifyBatcherOfChange: setNotifyBatcherOfChange
  }), children));
}

function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();

  if (override === false && ancestorStoreRef.current !== defaultStore) {
    // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}

function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}

var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

var Recoil_shallowArrayEqual = shallowArrayEqual;

const {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    // $FlowFixMe[incompatible-type]
    ref.current = value;
  });
  return ref.current;
}

var Recoil_usePrevious = usePrevious;

const {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;

const {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;

const {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;

const {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$2
} = Recoil_Environment;





 // I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.


// flowlint-line unclear-type:off
function useRetain(toRetain) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // eslint-disable-next-line fb-www/react-hooks


  return useRetain_ACTUAL(toRetain);
}

function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map(a => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const store = storeRef.current;

    if (timeoutID.current && !isSSR$2) {
      // Already performed a temporary retain on render, simply cancel the release
      // of that temporary retain.
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }

    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }; // eslint-disable-next-line fb-www/react-hooks-deps
  }, [storeRef, ...retainables]); // We want to retain if the component suspends. This is terrible but the Suspense
  // API affords us no better option. If we suspend and never commit after some
  // seconds, then release. The 'actual' retain/release in the effect above
  // cancels this.

  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);

  if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;

    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }

    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }

    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }

    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;

      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}

var Recoil_useRetain = useRetain;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */
// const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');

function useComponentName() {
  // const nameRef = useRef();
  // if (__DEV__) {
  //   if (gkx('recoil_infer_component_names')) {
  //     if (nameRef.current === undefined) {
  //       // There is no blessed way to determine the calling React component from
  //       // within a hook. This hack uses the fact that hooks must start with 'use'
  //       // and that hooks are either called by React Components or other hooks. It
  //       // follows therefore, that to find the calling component, you simply need
  //       // to look down the stack and find the first function which doesn't start
  //       // with 'use'. We are only enabling this in dev for now, since once the
  //       // codebase is minified, the naming assumptions no longer hold true.
  //       // eslint-disable-next-line fb-www/no-new-error
  //       const frames = stackTraceParser(new Error().stack);
  //       for (const {methodName} of frames) {
  //         // I observed cases where the frame was of the form 'Object.useXXX'
  //         // hence why I'm searching for hooks following a word boundary
  //         if (!methodName.match(/\buse[^\b]+$/)) {
  //           return (nameRef.current = methodName);
  //         }
  //       }
  //       nameRef.current = null;
  //     }
  //     return nameRef.current ?? '<unable to determine component name>';
  //   }
  // }
  // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
  return '<component name not available>'; // @oss-only
}

var Recoil_useComponentName = useComponentName;

const {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;

const {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;

const {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;

const {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;



const {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;



const {
  isSSR: isSSR$3
} = Recoil_Environment;













function handleLoadable(loadable, recoilValue, storeRef) {
  // We can't just throw the promise we are waiting on to Suspense.  If the
  // upstream dependencies change it may produce a state in which the component
  // can render, but it would still be suspended on a Promise that may never resolve.
  if (loadable.state === 'hasValue') {
    return loadable.contents;
  } else if (loadable.state === 'loading') {
    const promise = new Promise(resolve => {
      const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
      suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
      // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)

      if (isSSR$3 && Recoil_isPromise(loadable.contents)) {
        loadable.contents.finally(() => {
          suspendedComponentResolvers.delete(resolve);
        });
      }
    }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
    // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;

    throw promise;
  } else if (loadable.state === 'hasError') {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}

function validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}

/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(new Set());
  recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render

  const previousSubscriptions = useRef$4(new Set());
  const subscriptions = useRef$4(new Map());
  const unsubscribeFrom = useCallback$1(key => {
    const sub = subscriptions.current.get(key);

    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []); // Effect to add/remove subscriptions as nodes are used

  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(key => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }

      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      subscriptions.current.set(key, sub);
      /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */
      // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.

      const state = store.getState();

      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(key => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  }); // Effect to unsubscribe from all when unmounting

  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice

    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(key => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    // eslint-disable-next-line no-shadow
    function useSetRecoilState(recoilState) {
      if (false) {}

      return newValueOrUpdater => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    } // eslint-disable-next-line no-shadow


    function useResetRecoilState(recoilState) {
      if (false) {}

      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    } // eslint-disable-next-line no-shadow


    function useRecoilValueLoadable(recoilValue) {
      var _storeState$nextTree;

      if (false) {}

      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      } // TODO Restore optimization to memoize lookup


      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    } // eslint-disable-next-line no-shadow


    function useRecoilValue(recoilValue) {
      if (false) {}

      const loadable = useRecoilValueLoadable(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    } // eslint-disable-next-line no-shadow


    function useRecoilState(recoilState) {
      if (false) {}

      return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
    } // eslint-disable-next-line no-shadow


    function useRecoilStateLoadable(recoilState) {
      if (false) {}

      return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: useRecoilState,
      getRecoilStateLoadable: useRecoilStateLoadable,
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: useResetRecoilState
    };
  }, [recoilValuesUsed, storeRef]);
}

const recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};

function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]); // Memoize the state to avoid unnecessary rerenders

  const memoizePreviousSnapshot = useCallback$1(getState => {
    let prevState;
    return () => {
      var _prevState, _prevState2;

      const nextState = getState();

      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }

      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1(notify => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, // getSnapshot()
  getMemoizedSnapshot // getServerSnapshot() for SSR support
  ).loadable;
}

function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (false) {}

    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return notify();
      } // Only re-render if the value has changed.
      // This will evaluate the atom/selector now as well as when the
      // component renders, but that may help with prefetching.


      const newLoadable = getLoadable();

      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      } // If the component is suspended then the effect setting prevLoadableRef
      // will not run.  So, set the previous value here when its subscription
      // is fired to wake it up.  We can't just rely on this, though, because
      // this only executes when an atom/selector is dirty and the atom/selector
      // passed to the hook can dynamically change.


      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();

  if (source == null) {
    throw Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
  }

  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}

function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName(); // Accessors to get the current state

  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]); // Memoize state snapshots

  const updateState = useCallback$1(prevState => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]); // Subscribe to Recoil state changes

  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, _state => {
      setState(updateState);
    }, componentName); // Update state in case we are using a different key

    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]); // Get the current state

  const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
  // This is important in case the old key would cause the component to suspend.
  // We don't have to set the new state here since the subscribing effect above
  // will do that.

  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}

function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, _state => {
      var _prevLoadableRef$curr;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }, componentName);
    /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */

    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        // $FlowFixMe[incompatible-type]
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }

    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/


function useRecoilValueLoadable(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */


function useRecoilValue(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/


function useSetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(newValueOrUpdater => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/


function useResetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/


function useRecoilState(recoilState) {
  if (false) {}

  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/


function useRecoilStateLoadable(recoilState) {
  if (false) {}

  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}

function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */


function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}

function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}

function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (false) {}

  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}

var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */

function filterMap(map, callback) {
  const result = new Map();

  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }

  return result;
}

var Recoil_filterMap = filterMap;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */

function filterSet(set, callback) {
  const result = new Set();

  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_filterSet = filterSet;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function mergeMaps(...maps) {
  const result = new Map();

  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;

    while (!(nextKey = iterator.next()).done) {
      // $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
}

var Recoil_mergeMaps = mergeMaps;

const {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;

const {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;

const {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;

const {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$4
} = Recoil_Environment;















function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node = getNode$4(k);
    const persistence = node.persistence_UNSTABLE;
    return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
  }), v => v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
  // all have persistence on or they wouldn't be there in the first place.

  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}

/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2(store => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;

    if (!previousTree) {
      Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
      previousTree = store.getState().currentTree; // attempt to trundle on
    }

    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, node => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;

      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    }); // Filter on existance in atomValues so that externally-visible rules
    // are also applied to modified atoms (specifically exclude selectors):

    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, k => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: { ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}

function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2(store => {
    const snapshot = cloneSnapshot$1(store, 'latest');
    const previousSnapshot = cloneSnapshot$1(store, 'previous');
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
} // Return a snapshot of the current state and subscribe to all state changes


function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2(store => setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted

  useEffect$4(() => {
    const release = snapshot.retain(); // Release the retain from the rendering call

    if (timeoutID.current && !isSSR$4) {
      var _releaseRef$current;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }

    return () => {
      // Defer the release.  If "Fast Refresh"" is used then the component may
      // re-render with the same state.  The previous cleanup will then run and
      // then the new effect will run. We don't want the snapshot to be released
      // by that cleanup before the new effect has a chance to retain it again.
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(release, 10);
    };
  }, [snapshot]); // Retain snapshot until above effect is run.
  // Release after a threshold in case component is suspended.

  if (previousSnapshot !== snapshot && !isSSR$4) {
    // Release the previous snapshot
    if (timeoutID.current) {
      var _releaseRef$current2;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }

    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;

      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }

  return snapshot;
}

function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;

  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = new Set();

    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;

        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }

    keysToUpdate.forEach(key => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState(state => ({ ...state,
      stateID: snapshot.getID()
    }));
  });
}

function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2(snapshot => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}

var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};

const {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;

const {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;

function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4(); // $FlowFixMe[incompatible-return]

  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}

var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;

const {
  reactMode: reactMode$4
} = Recoil_ReactMode;

const {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;



const {
  useMemo: useMemo$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilBridgeAcrossReactRoots() {
  // The test fails when using useMutableSource(), but only if act() is used
  // for the nested root.  So, this may only be a testing environment issue.
  if (reactMode$4().mode === 'MUTABLE_SOURCE') {
    // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
  }

  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    // eslint-disable-next-line no-shadow
    function RecoilBridge({
      children
    }) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }

    return RecoilBridge;
  }, [store]);
}

var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;

const {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;

const {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;

const {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;



function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === 'atom';
}

class TransactionInterfaceImpl {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_treeState", void 0);

    _defineProperty(this, "_changes", void 0);

    _defineProperty(this, "get", recoilValue => {
      if (this._changes.has(recoilValue.key)) {
        // $FlowIssue[incompatible-return]
        return this._changes.get(recoilValue.key);
      }

      if (!isAtom(recoilValue)) {
        throw Recoil_err('Reading selectors within atomicUpdate is not supported');
      }

      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);

      if (loadable.state === 'hasValue') {
        return loadable.contents;
      } else if (loadable.state === 'hasError') {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });

    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err('Setting selectors within atomicUpdate is not supported');
      }

      if (typeof valueOrUpdater === 'function') {
        const current = this.get(recoilState);

        this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off

      } else {
        // Initialize atom and run effects if not initialized yet
        initializeNode$3(this._store, recoilState.key, 'set');

        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });

    _defineProperty(this, "reset", recoilState => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });

    this._store = store;
    this._treeState = treeState;
    this._changes = new Map();
  } // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer


  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }

    const newState = copyTreeState$1(this._treeState);

    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }

    invalidateDownstreams$1(this._store, newState);
    return newState;
  }

}

function atomicUpdater(store) {
  return fn => {
    store.replaceState(treeState => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}

var Recoil_AtomicUpdates = {
  atomicUpdater
};

var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;

var Recoil_AtomicUpdates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var invariant_1 = invariant;

// @oss-only


var Recoil_invariant = invariant_1;

const {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;

const {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;

const {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;

const {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;

const {
  useCallback: useCallback$3
} = react__WEBPACK_IMPORTED_MODULE_0__;









class Sentinel {}

const SENTINEL = new Sentinel();

function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = 'useRecoilCallback() expects a function that returns a function: ' + 'it accepts a function of the type (RecoilInterface) => (Args) => ReturnType ' + 'and returns a callback function (Args) => ReturnType, where RecoilInterface is ' + 'an object {snapshot, set, ...} and Args and ReturnType are the argument and return ' + 'types of the callback you want to create.  Please see the docs ' + 'at recoiljs.org for details.';

    if (typeof fn !== 'function') {
      throw Recoil_err(errMsg);
    } // Clone the snapshot lazily to avoid overhead if the callback does not use it.
    // Note that this means the snapshot may represent later state from when
    // the callback was called if it first accesses the snapshot asynchronously.


    const callbackInterface = Recoil_lazyProxy({ ...(extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}),
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (node, newValue) => setRecoilValue$3(store, node, newValue),
      // $FlowFixMe[missing-local-annot]
      reset: node => setRecoilValue$3(store, node, DEFAULT_VALUE$5),
      // $FlowFixMe[missing-local-annot]
      refresh: node => refreshRecoilValue$1(store, node),
      gotoSnapshot: snapshot => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: transaction => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);

    if (typeof callback !== 'function') {
      throw Recoil_err(errMsg);
    }

    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ?  false ? 0 : Recoil_invariant(false) : void 0;

  if (Recoil_isPromise(ret)) {
    ret = ret.finally(() => {
      var _releaseSnapshot;

      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;

    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }

  return ret;
}

function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3( // $FlowIssue[incompatible-call]
  (...args) => {
    return recoilCallback(storeRef.current, fn, args);
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};

const {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;

const {
  useCallback: useCallback$4
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}

var Recoil_useRecoilRefresher = useRecoilRefresher;

const {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;

const {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;

const {
  useMemo: useMemo$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(() => (...args) => {
    const atomicUpdate = atomicUpdater$2(storeRef.current);
    atomicUpdate(transactionInterface => {
      fn(transactionInterface)(...args);
    });
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilTransaction = useRecoilTransaction;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class WrappedValue {
  constructor(value) {
    _defineProperty(this, "value", void 0);

    this.value = value;
  }

}

var Recoil_Wrapper = {
  WrappedValue
};

var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;

var Recoil_Wrapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});

const {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;



class ChangedPathError extends Error {}

class TreeCache {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_numLeafs", void 0);

    _defineProperty(this, "_root", void 0);

    _defineProperty(this, "_onHit", void 0);

    _defineProperty(this, "_onSet", void 0);

    _defineProperty(this, "_mapNodeValue", void 0);

    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {};
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {};
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : val => val;
  }

  size() {
    return this._numLeafs;
  } // $FlowIssue[unclear-type]


  root() {
    return this._root;
  }

  get(getNodeValue, handlers) {
    var _this$getLeafNode;

    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }

  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return undefined;
    } // Iterate down the tree based on the current node values until we hit a leaf
    // $FlowIssue[unclear-type]


    let node = this._root;

    while (node) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node);

      if (node.type === 'leaf') {
        this._onHit(node);

        return node;
      }

      const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));

      node = node.branches.get(nodeValue);
    }

    return undefined;
  }

  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;

      // First, setup the branch nodes for the route:
      // Iterate down the tree to find or add branch nodes following the route
      let node;
      let branchKey;

      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;

        // If the previous root was a leaf, while we not have a get(), it means
        // the selector has inconsistent values or implementation changed.
        const root = this._root;

        if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') {
          throw this.invalidCacheError();
        } // node now refers to the next node down in the tree


        const parent = node; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = (_node = node) !== null && _node !== void 0 ? _node : {
          type: 'branch',
          nodeKey,
          parent,
          branches: new Map(),
          branchKey
        }; // If we found an existing node, confirm it has a consistent value

        if (node.type !== 'branch' || node.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        } // Add the branch node to the tree


        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.

        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
      } // Second, setup the leaf node:
      // If there is an existing leaf for this route confirm it is consistent


      const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;

      if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      } // Create a new or replacement leaf.


      const leafNode = {
        type: 'leaf',
        value,
        parent: node,
        branchKey
      }; // Install the leaf and call handlers

      (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;

      this._onSet(leafNode);

      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };

    try {
      addLeaf();
    } catch (error) {
      // If the cache was stale or observed inconsistent values, such as with
      // Fast Refresh, then clear it and rebuild with the new values.
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  } // Returns true if leaf was actually deleted from the tree


  delete(leaf) {
    const root = this.root();

    if (!root) {
      return false;
    }

    if (leaf === root) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    } // Iterate up from the leaf deleteing it from it's parent's branches.


    let node = leaf.parent;
    let branchKey = leaf.branchKey;

    while (node) {
      var _node4;

      node.branches.delete(branchKey); // Stop iterating if we hit the root.

      if (node === root) {
        if (node.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }

        return true;
      } // Stop iterating if there are other branches since we don't need to
      // remove any more nodes.


      if (node.branches.size > 0) {
        break;
      } // Iterate up to our parent


      branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node = node.parent;
    } // Confirm that the leaf we are deleting is actually attached to our tree


    for (; node !== root; node = node.parent) {
      if (node == null) {
        return false;
      }
    }

    this._numLeafs--;
    return true;
  }

  clear() {
    this._numLeafs = 0;
    this._root = null;
  }

  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? 'Possible Fast Refresh module reload detected.  ' + 'This may also be caused by an selector returning inconsistent values. ' + 'Resetting cache.' : 'Invalid cache values.  This happens when selectors do not return ' + 'consistent values for the same input dependency values.  That may also ' + 'be caused when using Fast Refresh to change a selector implementation.  ' + 'Resetting cache.';
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
    throw new ChangedPathError();
  }

}

var Recoil_TreeCache = {
  TreeCache
};

var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;

var Recoil_TreeCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});

class LRUCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_maxSize", void 0);

    _defineProperty(this, "_size", void 0);

    _defineProperty(this, "_head", void 0);

    _defineProperty(this, "_tail", void 0);

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  head() {
    return this._head;
  }

  tail() {
    return this._tail;
  }

  size() {
    return this._size;
  }

  maxSize() {
    return this._maxSize;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    const mappedKey = this._keyMapper(key);

    const node = this._map.get(mappedKey);

    if (!node) {
      return undefined;
    }

    this.set(key, node.value);
    return node.value;
  }

  set(key, val) {
    const mappedKey = this._keyMapper(key);

    const existingNode = this._map.get(mappedKey);

    if (existingNode) {
      this.delete(key);
    }

    const head = this.head();
    const node = {
      key,
      right: head,
      left: null,
      value: val
    };

    if (head) {
      head.left = node;
    } else {
      this._tail = node;
    }

    this._map.set(mappedKey, node);

    this._head = node;
    this._size++;

    this._maybeDeleteLRU();
  }

  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }

  deleteLru() {
    const tail = this.tail();

    if (tail) {
      this.delete(tail.key);
    }
  }

  delete(key) {
    const mappedKey = this._keyMapper(key);

    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }

    const node = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node.right;
    const left = node.left;

    if (right) {
      right.left = node.left;
    }

    if (left) {
      left.right = node.right;
    }

    if (node === this.head()) {
      this._head = right;
    }

    if (node === this.tail()) {
      this._tail = left;
    }

    this._map.delete(mappedKey);

    this._size--;
  }

  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
  }

}

var Recoil_LRUCache = {
  LRUCache
};

var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;

var Recoil_LRUCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});

const {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;

const {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;

function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = v => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: node => {
      lruCache.set(node, true);
    },
    onSet: node => {
      const lruNode = lruCache.tail();
      lruCache.set(node, true);

      if (lruNode && cache.size() > maxSize) {
        // $FlowFixMe[incompatible-call]
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}

var Recoil_treeCacheLRU = treeCacheLRU;

const TIME_WARNING_THRESHOLD_MS = 15;

function stringify(x, opt, key) {
  // A optimization to avoid the more expensive JSON.stringify() for simple strings
  // This may lose protection for u2028 and u2029, though.
  if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) {
    return `"${x}"`;
  } // Handle primitive types


  switch (typeof x) {
    case 'undefined':
      return '';
    // JSON.stringify(undefined) returns undefined, but we always want to return a string

    case 'boolean':
      return x ? 'true' : 'false';

    case 'number':
    case 'symbol':
      // case 'bigint': // BigInt is not supported in www
      return String(x);

    case 'string':
      // Add surrounding quotes and escape internal quotes
      return JSON.stringify(x);

    case 'function':
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err('Attempt to serialize function in a Recoil cache key');
      }

      return `__FUNCTION(${x.name})__`;
  }

  if (x === null) {
    return 'null';
  } // Fallback case for unknown types


  if (typeof x !== 'object') {
    var _JSON$stringify;

    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
  } // Deal with all promises as equivalent for now.


  if (Recoil_isPromise(x)) {
    return '__PROMISE__';
  } // Arrays handle recursive stringification


  if (Array.isArray(x)) {
    // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  } // If an object defines a toJSON() method, then use that to override the
  // serialization.  This matches the behavior of JSON.stringify().
  // Pass the key for compatibility.
  // Immutable.js collections define this method to allow us to serialize them.


  if (typeof x.toJSON === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
  } // For built-in Maps, sort the keys in a stable order instead of the
  // default insertion order.  Support non-string keys.


  if (x instanceof Map) {
    const obj = {};

    for (const [k, v] of x) {
      // Stringify will escape any nested quotes
      obj[typeof k === 'string' ? k : stringify(k, opt)] = v;
    }

    return stringify(obj, opt, key);
  } // For built-in Sets, sort the keys in a stable order instead of the
  // default insertion order.


  if (x instanceof Set) {
    return stringify( // $FlowFixMe[missing-local-annot]
    Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
  } // Anything else that is iterable serialize as an Array.


  if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
  } // For all other Objects, sort the keys in a stable order.


  return `{${Object.keys(x).filter(k => x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
  .map(k => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples


function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (false) {}

  return stringify(x, opt);
}

var Recoil_stableStringify = stableStringify;

const {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;









const defaultPolicy = {
  equality: 'reference',
  eviction: 'keep-all',
  maxSize: Infinity
};

function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}

function getValueMapper(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case 'keep-all':
      return new TreeCache$2({
        name,
        mapNodeValue
      });

    case 'lru':
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });

    case 'most-recent':
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if (typeof window === 'undefined') {
    return false;
  }

  const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var Recoil_isNode = (/* unused pure expression or super */ null && (isNode));

const {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;





function shouldNotBeFrozen(value) {
  // Primitives and functions:
  if (value === null || typeof value !== 'object') {
    return true;
  } // React elements:


  switch (typeof value.$$typeof) {
    case 'symbol':
      return true;

    case 'number':
      return true;
  } // Immutable structures:


  if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) {
    return true;
  } // DOM nodes:


  if (Recoil_isNode(value)) {
    return true;
  }

  if (Recoil_isPromise(value)) {
    return true;
  }

  if (value instanceof Error) {
    return true;
  }

  if (ArrayBuffer.isView(value)) {
    return true;
  } // Some environments, just as Jest, don't work with the instanceof check


  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }

  return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)


function deepFreezeValue(value) {
  if (typeof value !== 'object' || shouldNotBeFrozen(value)) {
    return;
  }

  Object.freeze(value); // Make all properties read-only

  for (const key in value) {
    // $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key]; // Prevent infinite recurssion for circular references.

      if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }

  Object.seal(value); // This also makes existing properties non-configurable.
}

var Recoil_deepFreezeValue = (/* unused pure expression or super */ null && (deepFreezeValue));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */
function startPerfBlock(_id) {
  return () => null;
}

var Recoil_PerformanceTimings = {
  startPerfBlock
};

const {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;



const {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;

const {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;

const {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;

const {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;



















const {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;



class Canceled {}

const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */

const dependencyStack = []; // for detecting circular dependencies.

const waitingStores = new Map();

const getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
/* eslint-disable no-redeclare */


function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : undefined; // flow

  if (false) {} // This is every discovered dependency across all executions


  const discoveredDependencyNodeKeys = new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: 'reference',
    eviction: 'keep-all'
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = new Map();
  let liveStoresCount = 0;

  function selectorIsLive() {
    return !Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
  }

  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }

  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
  }

  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }

  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }

    notifyWaitingStores(executionID, true);
  }
  /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */


  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }

  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);

    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }

      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }

  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);

    if (stores == null) {
      waitingStores.set(executionID, stores = new Set());
    }

    stores.add(store);
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */


  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then(value => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch(errorOrPromise => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }

      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */


  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then(resolvedDep => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      } // Check if we are handling a pending Recoil dependency or if the user
      // threw their own Promise to "suspend" a selector evaluation.  We need
      // to check that the loadingDepPromise actually matches the promise that
      // we caught in case the selector happened to catch the promise we threw
      // for a pending Recoil dependency from `getRecoilValue()` and threw
      // their own promise instead.


      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */
        store.getState().knownSelectors.forEach(nodeKey => {
          state.atomValues.delete(nodeKey);
        });
      }
      /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */


      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);

      if (cachedLoadable && cachedLoadable.state !== 'loading') {
        /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }

        if (cachedLoadable.state === 'hasValue') {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */


      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);

        if (executionInfo != null) {
          /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */
          return executionInfo.loadingLoadable.contents;
        }
      } // Retry the selector evaluation now that the dependency has resolved


      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);

      if (loadable.state !== 'loading') {
        resolveAsync(store, state, executionID, loadable, depValues);
      }

      if (loadable.state === 'hasError') {
        throw loadable.contents;
      }

      return loadable.contents;
    }).catch(error => {
      // The selector was released since the request began; ignore the response.
      if (error instanceof Canceled) {
        throw CANCELED;
      }

      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }

  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;

    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;

      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }

    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }

  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here

    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;

    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };

    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */

    const depValues = new Map();

    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
      // knows if it has to restart evaluation if one of them is updated before
      // the asynchronous selector completely resolves.

      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }

      switch (depLoadable.state) {
        case 'hasValue':
          return depLoadable.contents;

        case 'hasError':
          throw depLoadable.contents;

        case 'loading':
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }

      throw Recoil_err('Invalid Loadable state');
    }

    const getCallback = fn => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
        }

        !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;
        return recoilCallback$1(store, fn, args, {
          node: recoilValue
        } // flowlint-line unclear-type:off
        );
      };
    };

    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;

      if (isLoadable$1(result)) {
        if (result.state === 'hasError') {
          resultIsError = true;
        }

        result = result.contents;
      }

      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }

      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;

      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }

    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }

    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }

  function getLoadableFromCacheAndUpdateDeps(store, state) {
    // First, look up in the state cache
    // If it's here, then the deps in the store should already be valid.
    let cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    } // Second, look up in the selector cache and update the deps in the store


    const depsAfterCacheLookup = new Set();

    try {
      cachedLoadable = cache.get(nodeKey => {
        !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: node => {
          if (node.type === 'branch' && node.nodeKey !== key) {
            depsAfterCacheLookup.add(node.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }

    if (cachedLoadable) {
      var _getExecutionInfo;

      // Cache the results in the state to allow for cheaper lookup than
      // iterating the tree cache of dependencies.
      state.atomValues.set(key, cachedLoadable);
      /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */

      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }

    return cachedLoadable;
  }
  /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */


  function getSelectorLoadableAndUpdateDeps(store, state) {
    // First, see if our current state is cached
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);

    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    } // Second, check if there is already an ongoing execution based on the current state


    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);

    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;

      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      } // FIXME: check after the fact to see if we made the right choice by waiting


      return inProgressExecutionInfo.loadingLoadable;
    } // Third, start a new evaluation of the selector


    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */

    if (loadable.state === 'loading') {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }

    return loadable;
  }
  /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */


  function getInProgressExecutionInfo(store, state) {
    // Sort the pending executions so that our current store is checked first.
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);

    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }

      return false;
    }

    for (const execInfo of pendingExecutions) {
      if ( // If this execution was already checked to be valid with this version
      // of state, then let's use it!
      execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
      !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }

    return undefined;
  }

  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */


  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: new Map([[state.version, true]])
    });
  }

  function updateExecutionInfoDepValues(store, executionID, depValues) {
    // We only need to bother updating the deps for the latest execution because
    // that's all getInProgressExecutionInfo() will be looking for.
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);

      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }

  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }

  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;

    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */


  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }

  function setCache(state, loadable, depValues) {
    if (false) {}

    state.atomValues.set(key, loadable);

    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }

  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(' \u2192 ')}`;
      return loadableWithError$1(Recoil_err(message));
    }

    dependencyStack.push(key);

    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }

  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    }

    return cache.get(nodeKey => {
      var _peekNodeLoadable;

      !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }

  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }

  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }

  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;

    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;

      const node = getNode$6(nodeKey);
      (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, treeState);
    }

    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }

  if (set != null) {
    /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = new Map();

      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err('Recoil: Async selector sets are not currently supported.');
        }

        const loadable = getNodeLoadable$2(store, state, depKey);

        if (loadable.state === 'hasValue') {
          return loadable.contents;
        } else if (loadable.state === 'loading') {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }

      function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
      ) {
        if (syncSelectorSetFinished) {
          const msg = 'Recoil: Async selector sets are not currently supported.';
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }

        const setValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
        // flowlint-next-line unclear-type:off
        valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }

      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }

      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue); // set should be a void method, but if the user makes it `async`, then it
      // will return a Promise, which we don't currently support.

      if (ret !== undefined) {
        throw Recoil_isPromise(ret) ? Recoil_err('Recoil: Async selector sets are not currently supported.') : Recoil_err('Recoil: selector set should be a void function.');
      }

      syncSelectorSetFinished = true;
      return writes;
    };

    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
/* eslint-enable no-redeclare */
// $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]


selector.value = value => new WrappedValue$1(value);

var Recoil_selector = selector;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;

const {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;

const {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;















const unwrap = x => x instanceof WrappedValue$2 ? x.value : x;

function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;

  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then(value => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch(error => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }

  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : // $FlowFixMe[incompatible-call]
  loadableWithValue$3(unwrap(options.default));
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
  // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>

  const cleanupEffectsByStore = new Map();

  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (false) {}

    return valueOrPromise;
  }

  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then(value => {
      var _store$getState$nextT, _state$atomValues$get;

      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;

      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node, value);
      }

      return value;
    }).catch(error => {
      var _store$getState$nextT2, _state$atomValues$get2;

      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;

      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
      }

      throw error;
    });
    return wrappedPromise;
  }

  function initAtom(store, initState, trigger) {
    var _options$effects;

    liveStoresCount++;

    const cleanupAtom = () => {
      var _cleanupEffectsByStor;

      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach(cleanup => cleanup());
      cleanupEffectsByStore.delete(store);
    };

    store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve

    if (defaultLoadable.state === 'loading') {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;

        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;

        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node);
        }
      };

      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    } ///////////////////
    // Run Atom Effects
    ///////////////////


    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;

    if (effects != null) {
      // This state is scoped by Store, since this is in the initAtom() closure
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;

      function getLoadable(recoilValue) {
        // Normally we can just get the current value of another atom.
        // But for our own value we need to check if there is a pending
        // initialized value or get the fallback default value.
        if (isDuringInit && recoilValue.key === key) {
          // Cast T to S
          const retValue = initValue; // flowlint-line unclear-type:off

          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
          : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then(v => v instanceof DefaultValue$2 ? // Cast T to S
          defaultLoadable.toPromise() // flowlint-line unclear-type:off
          : v)) : // $FlowFixMe[incompatible-call]
          loadableWithValue$3(retValue);
        }

        return getRecoilValueAsLoadable$4(store, recoilValue);
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function getInfo_UNSTABLE(recoilValue) {
        var _store$getState$nextT4;

        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? { ...info,
          isSet: true,
          loadable: getLoadable(recoilValue)
        } : info;
      }

      const setSelf = effect => valueOrUpdater => {
        if (isDuringInit) {
          const currentLoadable = getLoadable(node);
          const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict T from being a function without losing support for opaque types
          valueOrUpdater(currentValue) // flowlint-line unclear-type:off
          : valueOrUpdater;

          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then(value => {
              // Avoid calling onSet() when setSelf() initializes with a Promise
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err('Setting atoms to async values is not implemented.');
          }

          if (typeof valueOrUpdater !== 'function') {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }

          setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? currentValue => {
            const newValue = unwrap( // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue) // flowlint-line unclear-type:off
            ); // $FlowFixMe[incompatible-type]

            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };

      const resetSelf = effect => () => setSelf(effect)(DEFAULT_VALUE$7);

      const onSet = effect => handler => {
        var _cleanupEffectsByStor2;

        const {
          release
        } = store.subscribeToTransactions(currentStore => {
          var _currentTree$atomValu;

          // eslint-disable-next-line prefer-const
          let {
            currentTree,
            previousTree
          } = currentStore.getState();

          if (!previousTree) {
            Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
            previousTree = currentTree; // attempt to trundle on
          }

          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;

          if (newLoadable.state === 'hasValue') {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;

            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
            // Ignore atom value changes that were set via setSelf() in the same effect.
            // We will still properly call the handler if there was a subsequent
            // set from something other than an atom effect which was batched
            // with the `setSelf()` call.  However, we may incorrectly ignore
            // the handler if the subsequent batched call happens to set the
            // atom to the exact same value as the `setSelf()`.   But, in that
            // case, it was kind of a noop, so the semantics are debatable..

            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []), release]);
      };

      for (const effect of effects) {
        try {
          const cleanup = effect({
            node,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise,
            getLoadable,
            getInfo_UNSTABLE
          });

          if (cleanup != null) {
            var _cleanupEffectsByStor3;

            cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []), cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }

      isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
      // since we are the ones initializing on first use.

      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;

        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
        // This could happen if the atom was first initialized in an action that
        // also updated some other atom's state.

        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }

    return cleanupAtom;
  }

  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;

    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }

  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      // Atom value is stored in state:
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      // Atom value is stored but needs validation before use.
      // We might have already validated it and have a cached validated value:
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }

      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }

      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }

  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = undefined;
  }

  function setAtom(_store, state, newValue) {
    // Bail out if we're being set to the existing value, or if we're being
    // reset but have no stored value (validated or unvalidated) to reset from:
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));

      if (existing.state === 'hasValue' && newValue === existing.contents) {
        return new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return new Map();
    }

    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use

    return new Map().set(key, loadableWithValue$3(newValue));
  }

  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
  }

  const node = registerNode$2({
    key,
    nodeType: 'atom',
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : undefined,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node;
} // prettier-ignore


function atom(options) {
  if (false) {}

  const { // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
  options.default : new Promise(() => {});

  if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
  // for now, since scoped atoms don't support async defaults
  // @fb-only: || (isPromise(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  // @fb-only: || (isLoadable(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  ) {
    return atomWithFallback({ ...restOptions,
      default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,

    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    // @fb-only: && !isPromise(optionsDefault)
    // @fb-only: && !isLoadable(optionsDefault)
    // @fb-only: ) {
    // @fb-only: return scopedAtom<T>({
    // @fb-only: ...restOptions,
    // @fb-only: default: unwrap<T>(optionsDefault),
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    // @fb-only: });
  } else {
    return baseAtom({ ...restOptions,
      default: optionsDefault
    });
  }
}

function atomWithFallback(options) {
  const base = atom({ ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : { ...options.persistence_UNSTABLE,
      validator: storedValue => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off

  }); // $FlowFixMe[incompatible-call]

  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: 'most-recent'
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
} // $FlowFixMe[missing-local-annot]


atom.value = value => new WrappedValue$2(value);

var Recoil_atom = atom;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class MapCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._map = new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  size() {
    return this._map.size;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    return this._map.get(this._keyMapper(key));
  }

  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }

  delete(key) {
    this._map.delete(this._keyMapper(key));
  }

  clear() {
    this._map.clear();
  }

}

var Recoil_MapCache = {
  MapCache
};

var Recoil_MapCache_1 = Recoil_MapCache.MapCache;

var Recoil_MapCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});

const {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;

const {
  MapCache: MapCache$1
} = Recoil_MapCache$1;







const defaultPolicy$1 = {
  equality: 'reference',
  eviction: 'none',
  maxSize: Infinity
};

function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}

function getValueMapper$1(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case 'keep-all':
      return new MapCache$1({
        mapKey
      });

    case 'lru':
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });

    case 'most-recent':
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_cacheFromPolicy = cacheFromPolicy;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';


const {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;





// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }

/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  }); // Simple atomFamily implementation to cache individual atoms based
  // on the parameter value equality.

  return params => {
    var _stableStringify, _options$effects;

    const cachedAtom = atomCache.get(params);

    if (cachedAtom != null) {
      return cachedAtom;
    }

    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default : new Promise(() => {});
    const newAtom = Recoil_atom({ ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
      default: typeof optionsDefault === 'function' ? // The default was parameterized
      // Flow doesn't know that T isn't a function, so we need to case to any
      // $FlowIssue[incompatible-use]
      optionsDefault(params) : // Default may be a static value, promise, or RecoilValue
      optionsDefault,
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),

    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}

var Recoil_atomFamily = atomFamily;

const {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;





 // Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify


// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */

// Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  });
  return params => {
    var _stableStringify;

    // Throw an error with selector key so that it is clear which
    // selector is causing an error
    let cachedSelector;

    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }

    if (cachedSelector != null) {
      return cachedSelector;
    }

    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${nextIndex++}`; // Append index in case values serialize to the same key string

    const myGet = callbacks => options.get(params)(callbacks);

    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;

    if (options.set != null) {
      const set = options.set;

      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);

      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }

    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
/* eslint-enable no-redeclare */


var Recoil_selectorFamily = selectorFamily;

// flowlint-next-line unclear-type:off


const constantSelector = Recoil_selectorFamily({
  key: '__constant',
  get: constant => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.

function constSelector(constant) {
  return constantSelector(constant);
}

var Recoil_constSelector = constSelector;

// flowlint-next-line unclear-type:off


const throwingSelector = Recoil_selectorFamily({
  key: '__error',
  get: message => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always throws an error
// with the provided message.

function errorSelector(message) {
  return throwingSelector(message);
}

var Recoil_errorSelector = errorSelector;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */

function readOnlySelector(atom) {
  // flowlint-next-line unclear-type: off
  return atom;
}

var Recoil_readOnlySelector = readOnlySelector;

const {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;





 /////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.


function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(undefined);
  const exceptions = Array(deps.length).fill(undefined);

  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      // exceptions can either be Promises of pending results or real errors
      exceptions[i] = e;
    }
  }

  return [results, exceptions];
}

function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(key => dependencies[key]);
}

function wrapResults(dependencies,
/* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */
results) {
  return Array.isArray(dependencies) ? results : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({ ...out,
    [key]: results[idx]
  }), {});
}

function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}

function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) =>
  /**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */
  result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.


const waitForNone = Recoil_selectorFamily({
  key: '__waitForNone',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.

    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.

const waitForAny = Recoil_selectorFamily({
  key: '__waitForAny',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status

    if (exceptions.some(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Otherwise, return a promise that will resolve when the next result is
    // available, whichever one happens to be next.  But, if all pending
    // dependencies end up with errors, then reject the promise.


    return new Promise(resolve => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then(result => {
            results[i] = result;
            exceptions[i] = undefined;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch(error => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.

const waitForAll = Recoil_selectorFamily({
  key: '__waitForAll',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => exp == null)) {
      return wrapResults(dependencies, results);
    } // If we have any errors, throw the first error


    const error = exceptions.find(isError);

    if (error != null) {
      throw error;
    } // Otherwise, return a promise that will resolve when all results are available


    return Promise.all(exceptions).then(exceptionResults => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
  key: '__waitForAllSettled',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Wait for all results to settle


    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then(result => {
      results[i] = result;
      exceptions[i] = undefined;
    }).catch(error => {
      results[i] = undefined;
      exceptions[i] = error;
    }) : null)) // Then wrap them as loadables
    .then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
  key: '__noWait',
  get: dependency => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};

const {
  RecoilLoadable
} = Recoil_Loadable$1;

const {
  DefaultValue: DefaultValue$3
} = Recoil_Node;

const {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;

const {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;

const {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;

const {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;

const {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;





const {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;





















const {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;



var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

/* harmony default export */ __webpack_exports__["default"] = (Recoil_index);



/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 1458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(2784);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1458);
} else {}


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ }),

/***/ 15761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class FocusManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();


//# sourceMappingURL=focusManager.mjs.map


/***/ }),

/***/ 9499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject('Missing queryFn'));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    const nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    const previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}


//# sourceMappingURL=infiniteQueryBehavior.mjs.map


/***/ }),

/***/ 30819:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ defaultLogger; }
/* harmony export */ });
const defaultLogger = console;


//# sourceMappingURL=logger.mjs.map


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _logger_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30819);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30081);
/* harmony import */ var _removable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89643);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72379);





// CLASS
class Mutation extends _removable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.options = { ...config.defaultOptions,
      ...config.options
    };
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || _logger_mjs__WEBPACK_IMPORTED_MODULE_1__/* .defaultLogger */ ._;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.updateCacheTime(this.options.cacheTime);
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onError, _this$options4, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, error, this.state.variables, this.state.context, this));

        if (false) {}

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .canFetch */ .Kw)(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__/* .notifyManager.batch */ .V.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}


//# sourceMappingURL=mutation.mjs.map


/***/ }),

/***/ 30081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();


//# sourceMappingURL=notifyManager.mjs.map


/***/ }),

/***/ 96474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class OnlineManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();


//# sourceMappingURL=onlineManager.mjs.map


/***/ }),

/***/ 52924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ QueryObserver; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30081);
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15761);
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72379);






class QueryObserver extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = [];
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (false) {}

    if (!(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqualObjects */ .VS)(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    return this.createResult(query, options);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk || this.currentResult.isStale || !(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isValidTimeout */ .PN)(this.options.staleTime)) {
      return;
    }

    const time = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .timeUntilStale */ .Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk || this.options.enabled === false || !(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isValidTimeout */ .PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || _focusManager_mjs__WEBPACK_IMPORTED_MODULE_2__/* .focusManager.isFocused */ .j.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_3__/* .canFetch */ .Kw)(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .replaceData */ .oE)(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (false) {}

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (false) {}

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .replaceData */ .oE)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqualObjects */ .VS)(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;

      if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_3__/* .isCancelledError */ .DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}


//# sourceMappingURL=queryObserver.mjs.map


/***/ }),

/***/ 89643:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}


//# sourceMappingURL=removable.mjs.map


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15761);
/* harmony import */ var _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96474);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32161);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !_focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== 'always' && !_onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        if (isResolved || !shouldPause()) {
          return continueResolve(value);
        }
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      continueFn == null ? void 0 : continueFn();
    },
    cancelRetry,
    continueRetry
  };
}


//# sourceMappingURL=retryer.mjs.map


/***/ }),

/***/ 33989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
class Subscribable {
  constructor() {
    this.listeners = [];
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    this.listeners.push(listener);
    this.onSubscribe();
    return () => {
      this.listeners = this.listeners.filter(x => x !== listener);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.length > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}


//# sourceMappingURL=subscribable.mjs.map


/***/ }),

/***/ 32161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, isError, isPlainArray, isPlainObject, isQueryKey, parseMutationFilterArgs, partialDeepEqual, replaceAt, replaceEqualDeep */
// TYPES
// UTILS
const isServer = typeof document === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
  return array1.filter(x => array2.indexOf(x) === -1);
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return { ...arg3,
        mutationKey: arg1,
        mutationFn: arg2
      };
    }

    return { ...arg2,
      mutationKey: arg1
    };
  }

  if (typeof arg1 === 'function') {
    return { ...arg2,
      mutationFn: arg1
    };
  }

  return { ...arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    mutationKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 85945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


const defaultContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = react__WEBPACK_IMPORTED_MODULE_0__.useContext(getQueryClientContext(context, react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (false) {}

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: client
  }, children));
};


//# sourceMappingURL=QueryClientProvider.mjs.map


/***/ }),

/***/ 91784:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useQueryErrorResetBoundary; }
/* harmony export */ });
/* unused harmony export QueryErrorResetBoundary */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryErrorResetBoundaryContext); // COMPONENT

const QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};


//# sourceMappingURL=QueryErrorResetBoundary.mjs.map


/***/ }),

/***/ 36661:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useBaseQuery; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs
var QueryErrorResetBoundary = __webpack_require__(91784);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/isRestoring.mjs


const IsRestoringContext = /*#__PURE__*/react.createContext(false);
const useIsRestoring = () => react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;


//# sourceMappingURL=isRestoring.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/errorBoundaryUtils.mjs



const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,utils/* shouldThrowError */.L)(useErrorBoundary, [result.error, query]);
};


//# sourceMappingURL=errorBoundaryUtils.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/suspense.mjs
const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});


//# sourceMappingURL=suspense.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs









function useBaseQuery(options, Observer) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = (0,QueryErrorResetBoundary/* useQueryErrorResetBoundary */._)();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => isRestoring ? () => undefined : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  react.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


//# sourceMappingURL=useBaseQuery.mjs.map


/***/ }),

/***/ 59403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(52924);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    const {
      isFetching,
      isRefetching
    } = result;
    const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
    const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 3 modules
var useBaseQuery = __webpack_require__(36661);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 36492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52924);
/* harmony import */ var _useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36661);



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__/* .parseQueryArgs */ ._v)(arg1, arg2, arg3);
  return (0,_useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useBaseQuery */ .r)(parsedOptions, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .QueryObserver */ .z);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43100);


// Temporary workaround due to an issue with react-native uSES - https://github.com/TanStack/query/pull/3601
const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 24798:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 18770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 90581:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 27805:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 6729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(34067);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 34067:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 21218:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(501);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 42838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 93520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 26297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 501:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 62202:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ Oe; },
  "Am": function() { return /* binding */ dist_c; }
});

// UNUSED EXPORTS: CheckmarkIcon, ErrorIcon, LoaderIcon, ToastBar, ToastIcon, default, resolveValue, useToaster, useToasterStore

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/goober/dist/goober.modern.js
let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,r=e=>{let r=t(e),l=r.data;return r.data="",l},l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";")}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return"go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d)}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e)})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e}return e+l+(null==n?"":n)},"");function u(e){let r=this||{},l=e.call?e(r.p):e;return i(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let d,f,g,b=u.bind({g:1}),h=u.bind({k:1});function m(e,t,r,l){o.p=t,d=e,f=r,g=l}function j(e,t){let r=this||{};return function(){let l=arguments;function a(n,o){let c=Object.assign({},n),s=c.className||a.className;r.p=Object.assign({theme:f&&f()},c),r.o=/ *go\d+/.test(s),c.className=u.apply(r,l)+(s?" "+s:""),t&&(c.ref=o);let i=e;return e[0]&&(i=c.as||e,delete c.as),g&&i[0]&&g(c),d(i,c)}return t?t(a):a}}

;// CONCATENATED MODULE: ../../node_modules/react-hot-toast/dist/index.mjs
"use client";
var W=e=>typeof e=="function",dist_f=(e,t)=>W(e)?e(t):e;var F=(()=>{let e=0;return()=>(++e).toString()})(),A=(()=>{let e;return()=>{if(e===void 0&&typeof window<"u"){let t=matchMedia("(prefers-reduced-motion: reduce)");e=!t||t.matches}return e}})();var Y=20;var U=(e,t)=>{switch(t.type){case 0:return{...e,toasts:[t.toast,...e.toasts].slice(0,Y)};case 1:return{...e,toasts:e.toasts.map(o=>o.id===t.toast.id?{...o,...t.toast}:o)};case 2:let{toast:r}=t;return U(e,{type:e.toasts.find(o=>o.id===r.id)?1:0,toast:r});case 3:let{toastId:s}=t;return{...e,toasts:e.toasts.map(o=>o.id===s||s===void 0?{...o,dismissed:!0,visible:!1}:o)};case 4:return t.toastId===void 0?{...e,toasts:[]}:{...e,toasts:e.toasts.filter(o=>o.id!==t.toastId)};case 5:return{...e,pausedAt:t.time};case 6:let a=t.time-(e.pausedAt||0);return{...e,pausedAt:void 0,toasts:e.toasts.map(o=>({...o,pauseDuration:o.pauseDuration+a}))}}},P=[],y={toasts:[],pausedAt:void 0},dist_u=e=>{y=U(y,e),P.forEach(t=>{t(y)})},q={blank:4e3,error:4e3,success:2e3,loading:1/0,custom:4e3},D=(e={})=>{let[t,r]=(0,react.useState)(y),s=(0,react.useRef)(y);(0,react.useEffect)(()=>(s.current!==y&&r(y),P.push(r),()=>{let o=P.indexOf(r);o>-1&&P.splice(o,1)}),[]);let a=t.toasts.map(o=>{var n,i,p;return{...e,...e[o.type],...o,removeDelay:o.removeDelay||((n=e[o.type])==null?void 0:n.removeDelay)||(e==null?void 0:e.removeDelay),duration:o.duration||((i=e[o.type])==null?void 0:i.duration)||(e==null?void 0:e.duration)||q[o.type],style:{...e.style,...(p=e[o.type])==null?void 0:p.style,...o.style}}});return{...t,toasts:a}};var J=(e,t="blank",r)=>({createdAt:Date.now(),visible:!0,dismissed:!1,type:t,ariaProps:{role:"status","aria-live":"polite"},message:e,pauseDuration:0,...r,id:(r==null?void 0:r.id)||F()}),x=e=>(t,r)=>{let s=J(t,e,r);return dist_u({type:2,toast:s}),s.id},dist_c=(e,t)=>x("blank")(e,t);dist_c.error=x("error");dist_c.success=x("success");dist_c.loading=x("loading");dist_c.custom=x("custom");dist_c.dismiss=e=>{dist_u({type:3,toastId:e})};dist_c.remove=e=>dist_u({type:4,toastId:e});dist_c.promise=(e,t,r)=>{let s=dist_c.loading(t.loading,{...r,...r==null?void 0:r.loading});return typeof e=="function"&&(e=e()),e.then(a=>{let o=t.success?dist_f(t.success,a):void 0;return o?dist_c.success(o,{id:s,...r,...r==null?void 0:r.success}):dist_c.dismiss(s),a}).catch(a=>{let o=t.error?dist_f(t.error,a):void 0;o?dist_c.error(o,{id:s,...r,...r==null?void 0:r.error}):dist_c.dismiss(s)}),e};var K=(e,t)=>{dist_u({type:1,toast:{id:e,height:t}})},X=()=>{dist_u({type:5,time:Date.now()})},dist_b=new Map,Z=1e3,ee=(e,t=Z)=>{if(dist_b.has(e))return;let r=setTimeout(()=>{dist_b.delete(e),dist_u({type:4,toastId:e})},t);dist_b.set(e,r)},O=e=>{let{toasts:t,pausedAt:r}=D(e);(0,react.useEffect)(()=>{if(r)return;let o=Date.now(),n=t.map(i=>{if(i.duration===1/0)return;let p=(i.duration||0)+i.pauseDuration-(o-i.createdAt);if(p<0){i.visible&&dist_c.dismiss(i.id);return}return setTimeout(()=>dist_c.dismiss(i.id),p)});return()=>{n.forEach(i=>i&&clearTimeout(i))}},[t,r]);let s=(0,react.useCallback)(()=>{r&&dist_u({type:6,time:Date.now()})},[r]),a=(0,react.useCallback)((o,n)=>{let{reverseOrder:i=!1,gutter:p=8,defaultPosition:d}=n||{},h=t.filter(m=>(m.position||d)===(o.position||d)&&m.height),v=h.findIndex(m=>m.id===o.id),S=h.filter((m,E)=>E<v&&m.visible).length;return h.filter(m=>m.visible).slice(...i?[S+1]:[0,S]).reduce((m,E)=>m+(E.height||0)+p,0)},[t]);return (0,react.useEffect)(()=>{t.forEach(o=>{if(o.dismissed)ee(o.id,o.removeDelay);else{let n=dist_b.get(o.id);n&&(clearTimeout(n),dist_b.delete(o.id))}})},[t]),{toasts:t,handlers:{updateHeight:K,startPause:X,endPause:s,calculateOffset:a}}};var oe=h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,re=h`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,se=h`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,k=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e=>e.secondary||"#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;var ne=h`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,V=j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e=>e.secondary||"#e0e0e0"};
  border-right-color: ${e=>e.primary||"#616161"};
  animation: ${ne} 1s linear infinite;
`;var pe=h`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,de=h`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,_=j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e=>e.primary||"#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${de} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e=>e.secondary||"#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;var ue=j("div")`
  position: absolute;
`,le=j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,fe=h`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,Te=j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${fe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,M=({toast:e})=>{let{icon:t,type:r,iconTheme:s}=e;return t!==void 0?typeof t=="string"?react.createElement(Te,null,t):t:r==="blank"?null:react.createElement(le,null,react.createElement(V,{...s}),r!=="loading"&&react.createElement(ue,null,r==="error"?react.createElement(k,{...s}):react.createElement(_,{...s})))};var ye=e=>`
0% {transform: translate3d(0,${e*-200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`,ge=e=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e*-150}%,-1px) scale(.6); opacity:0;}
`,he="0%{opacity:0;} 100%{opacity:1;}",xe="0%{opacity:1;} 100%{opacity:0;}",be=j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,Se=j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,Ae=(e,t)=>{let s=e.includes("top")?1:-1,[a,o]=A()?[he,xe]:[ye(s),ge(s)];return{animation:t?`${h(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards`:`${h(o)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`}},C=react.memo(({toast:e,position:t,style:r,children:s})=>{let a=e.height?Ae(e.position||t||"top-center",e.visible):{opacity:0},o=react.createElement(M,{toast:e}),n=react.createElement(Se,{...e.ariaProps},dist_f(e.message,e));return react.createElement(be,{className:e.className,style:{...a,...r,...e.style}},typeof s=="function"?s({icon:o,message:n}):react.createElement(react.Fragment,null,o,n))});m(react.createElement);var ve=({id:e,className:t,style:r,onHeightUpdate:s,children:a})=>{let o=react.useCallback(n=>{if(n){let i=()=>{let p=n.getBoundingClientRect().height;s(e,p)};i(),new MutationObserver(i).observe(n,{subtree:!0,childList:!0,characterData:!0})}},[e,s]);return react.createElement("div",{ref:o,className:t,style:r},a)},Ee=(e,t)=>{let r=e.includes("top"),s=r?{top:0}:{bottom:0},a=e.includes("center")?{justifyContent:"center"}:e.includes("right")?{justifyContent:"flex-end"}:{};return{left:0,right:0,display:"flex",position:"absolute",transition:A()?void 0:"all 230ms cubic-bezier(.21,1.02,.73,1)",transform:`translateY(${t*(r?1:-1)}px)`,...s,...a}},De=u`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,R=16,Oe=({reverseOrder:e,position:t="top-center",toastOptions:r,gutter:s,children:a,containerStyle:o,containerClassName:n})=>{let{toasts:i,handlers:p}=O(r);return react.createElement("div",{id:"_rht_toaster",style:{position:"fixed",zIndex:9999,top:R,left:R,right:R,bottom:R,pointerEvents:"none",...o},className:n,onMouseEnter:p.startPause,onMouseLeave:p.endPause},i.map(d=>{let h=d.position||t,v=p.calculateOffset(d,{reverseOrder:e,gutter:s,defaultPosition:t}),S=Ee(h,v);return react.createElement(ve,{id:d.id,key:d.id,onHeightUpdate:p.updateHeight,className:d.visible?De:"",style:S},d.type==="custom"?dist_f(d.message,d):a?a(d):react.createElement(C,{toast:d,position:h}))}))};var Vt=(/* unused pure expression or super */ null && (dist_c));
//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);